{
  "level": "mt02f",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:mt02f",
    "objects": "AREAS.E3:mt02f.e3",
    "mesh": "TREES.E3:mt02f.e3"
  },
  "spawn_point": {
    "position": [
      -1658.2436965791949,
      -3473.0488289056257,
      24.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      -1658.2436965791949,
      -3373.0488289056257,
      24.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -3963.99951171875,
      -5244.791015625,
      0.0
    ],
    "bbox_max": [
      -660.0,
      -2789.423828125,
      1574.9000244140625
    ],
    "vertex_count": 3753,
    "vertices": [
      [
        -660.0,
        -2993.1591796875,
        1302.5999755859375
      ],
      [
        -660.0,
        -3153.4228515625,
        1141.43310546875
      ],
      [
        -660.0,
        -3181.474609375,
        1094.8697509765625
      ],
      [
        -660.0,
        -3189.680419921875,
        1104.97119140625
      ],
      [
        -660.0,
        -3153.4228515625,
        1141.43310546875
      ],
      [
        -660.0,
        -3181.474609375,
        1094.86962890625
      ],
      [
        -660.0,
        -3350.221435546875,
        1302.5999755859375
      ],
      [
        -1223.9951171875,
        -3650.0,
        0.0
      ],
      [
        -917.23828125,
        -3650.0,
        0.0
      ],
      [
        -1145.534912109375,
        -3506.523681640625,
        267.0
      ],
      [
        -1145.534912109375,
        -3506.523681640625,
        267.0
      ],
      [
        -1182.7503662109375,
        -3440.52197265625,
        267.0
      ],
      [
        -1182.7503662109375,
        -3440.52197265625,
        267.0
      ],
      [
        -1198.09375,
        -3408.409912109375,
        267.0
      ],
      [
        -1198.09375,
        -3408.409912109375,
        267.0
      ],
      [
        -1207.7008056640625,
        -3394.232421875,
        267.0
      ],
      [
        -1207.7008056640625,
        -3394.232421875,
        267.0
      ],
      [
        -1208.414794921875,
        -3395.00634765625,
        267.0
      ],
      [
        -1188.102294921875,
        -3479.90869140625,
        69.50926208496094
      ],
      [
        -1200.9185791015625,
        -3466.518310546875,
        120.43780517578125
      ],
      [
        -1188.102294921875,
        -3479.90869140625,
        69.50926208496094
      ],
      [
        -1224.45458984375,
        -3411.963134765625,
        267.0
      ],
      [
        -1224.1302490234375,
        -3411.97802734375,
        267.0
      ],
      [
        -1224.50634765625,
        -3412.418212890625,
        267.0
      ],
      [
        -1224.45458984375,
        -3411.963134765625,
        267.0
      ],
      [
        -1224.07470703125,
        -3411.980712890625,
        267.0
      ],
      [
        -1224.07470703125,
        -3411.980712890625,
        267.0
      ],
      [
        -1224.51025390625,
        -3412.45263671875,
        267.0
      ],
      [
        -1220.430419921875,
        -3442.769775390625,
        267.0
      ],
      [
        -1224.5528564453125,
        -3412.828125,
        267.0
      ],
      [
        -1214.2481689453125,
        -3448.7548828125,
        252.16676330566406
      ],
      [
        -1224.5528564453125,
        -3412.828125,
        267.0
      ],
      [
        -977.0939331054688,
        -3650.0,
        267.0
      ],
      [
        -1007.23779296875,
        -3650.0,
        6.0961198806762695
      ],
      [
        -1007.23779296875,
        -3650.0,
        6.09613037109375
      ],
      [
        -1007.8887329101562,
        -3650.0,
        2.6302847862243652
      ],
      [
        -1188.968017578125,
        -3525.123779296875,
        267.0
      ],
      [
        -1201.617919921875,
        -3515.152099609375,
        267.0
      ],
      [
        -1188.968017578125,
        -3525.123779296875,
        267.0
      ],
      [
        -1201.617919921875,
        -3515.152099609375,
        267.0
      ],
      [
        -1203.474609375,
        -3510.526123046875,
        267.0
      ],
      [
        -1203.686767578125,
        -3509.99755859375,
        267.0
      ],
      [
        -1197.494384765625,
        -3512.52685546875,
        230.0940399169922
      ],
      [
        -1204.3563232421875,
        -3508.329345703125,
        267.0
      ],
      [
        -1197.494384765625,
        -3512.52685546875,
        230.0940399169922
      ],
      [
        -1196.880615234375,
        -3513.037353515625,
        228.58932495117188
      ],
      [
        -1215.0838623046875,
        -3481.6015625,
        267.0
      ],
      [
        -1215.0838623046875,
        -3481.6015625,
        267.0
      ],
      [
        -1008.3827514648438,
        -3650.0,
        0.0
      ],
      [
        -1344.8778076171875,
        -3096.834228515625,
        577.0269775390625
      ],
      [
        -1334.0955810546875,
        -3092.033935546875,
        711.556884765625
      ],
      [
        -1333.9539794921875,
        -3091.970703125,
        712.7704467773438
      ],
      [
        -1333.5472412109375,
        -3091.78955078125,
        718.399658203125
      ],
      [
        -1334.0955810546875,
        -3092.033935546875,
        711.556884765625
      ],
      [
        -1333.9539794921875,
        -3091.970703125,
        712.7704467773438
      ],
      [
        -1352.1126708984375,
        -3100.0556640625,
        613.0665893554688
      ],
      [
        -1344.8778076171875,
        -3096.834228515625,
        577.0269165039062
      ],
      [
        -1365.9962158203125,
        -3106.23681640625,
        638.2857666015625
      ],
      [
        -1352.1126708984375,
        -3100.0556640625,
        613.0665893554688
      ],
      [
        -1367.46875,
        -3106.892333984375,
        662.6285400390625
      ],
      [
        -1365.9962158203125,
        -3106.23681640625,
        638.2857666015625
      ],
      [
        -1367.46875,
        -3106.892333984375,
        662.6285400390625
      ],
      [
        -1367.668701171875,
        -3106.9814453125,
        690.6090087890625
      ],
      [
        -1350.734130859375,
        -3098.3779296875,
        724.0
      ],
      [
        -1367.9073486328125,
        -3107.087646484375,
        724.0
      ],
      [
        -1334.3448486328125,
        -3089.99560546875,
        724.0
      ],
      [
        -1350.734130859375,
        -3098.3779296875,
        724.0
      ],
      [
        -1334.3448486328125,
        -3089.99560546875,
        724.0
      ],
      [
        -1334.30712890625,
        -3090.04638671875,
        724.0
      ],
      [
        -1333.1427001953125,
        -3091.609375,
        724.0
      ],
      [
        -1330.6363525390625,
        -3087.7412109375,
        780.0
      ],
      [
        -1367.9959716796875,
        -3107.127197265625,
        736.406982421875
      ],
      [
        -1372.2017822265625,
        -3108.999755859375,
        780.0
      ],
      [
        -1367.9959716796875,
        -3107.127197265625,
        736.406982421875
      ],
      [
        -1348.809814453125,
        -3059.905029296875,
        780.0
      ],
      [
        -1348.8089599609375,
        -3059.90673828125,
        780.0
      ],
      [
        -1348.809814453125,
        -3059.905029296875,
        780.0
      ],
      [
        -1330.6363525390625,
        -3087.7412109375,
        780.0
      ],
      [
        -1329.0966796875,
        -3089.80810546875,
        780.0
      ],
      [
        -1215.00341796875,
        -3039.0107421875,
        1295.0087890625
      ],
      [
        -1325.112548828125,
        -3088.034423828125,
        833.904541015625
      ],
      [
        -1368.22216796875,
        -3050.077880859375,
        788.1644287109375
      ],
      [
        -1357.9627685546875,
        -3042.148681640625,
        839.0567016601562
      ],
      [
        -1339.215087890625,
        -3092.12890625,
        780.0
      ],
      [
        -1368.22216796875,
        -3050.077880859375,
        788.1644287109375
      ],
      [
        -1357.8485107421875,
        -3064.591064453125,
        786.4833374023438
      ],
      [
        -1356.784423828125,
        -3066.077880859375,
        786.3157348632812
      ],
      [
        -1357.8485107421875,
        -3064.591064453125,
        786.4833374023438
      ],
      [
        -1325.327392578125,
        -3088.130126953125,
        832.169189453125
      ],
      [
        -1325.2467041015625,
        -3088.09423828125,
        833.34326171875
      ],
      [
        -1325.327392578125,
        -3088.130126953125,
        832.169189453125
      ],
      [
        -1206.3187255859375,
        -3035.14404296875,
        1278.9141845703125
      ],
      [
        -1197.2042236328125,
        -3031.0859375,
        1302.5999755859375
      ],
      [
        -1212.1756591796875,
        -3037.751708984375,
        1292.563720703125
      ],
      [
        -1215.00341796875,
        -3039.0107421875,
        1295.0089111328125
      ],
      [
        -1356.511474609375,
        -3102.013916015625,
        964.08837890625
      ],
      [
        -1377.009033203125,
        -3111.14013671875,
        832.7509765625
      ],
      [
        -1356.511474609375,
        -3102.013916015625,
        1302.5999755859375
      ],
      [
        -1356.511474609375,
        -3102.013916015625,
        964.08837890625
      ],
      [
        -1595.0,
        -3174.36669921875,
        1302.5999755859375
      ],
      [
        -1518.1849365234375,
        -3165.98095703125,
        1302.5999755859375
      ],
      [
        -1542.645263671875,
        -3184.885986328125,
        1260.7716064453125
      ],
      [
        -1595.0,
        -3208.19580078125,
        1215.4404296875
      ],
      [
        -1465.0,
        -3124.875244140625,
        850.0
      ],
      [
        -1465.0,
        -3124.875244140625,
        919.0
      ],
      [
        -1465.0,
        -3124.875244140625,
        850.0
      ],
      [
        -1359.010009765625,
        -3062.966064453125,
        786.6715698242188
      ],
      [
        -1465.0,
        -3150.316162109375,
        850.0
      ],
      [
        -1437.23388671875,
        -3128.416015625,
        849.9962158203125
      ],
      [
        -1440.436767578125,
        -3139.3798828125,
        849.997802734375
      ],
      [
        -1465.0,
        -3150.316162109375,
        850.0
      ],
      [
        -1465.0,
        -3150.316162109375,
        872.0855712890625
      ],
      [
        -1465.0,
        -3124.875244140625,
        864.7116088867188
      ],
      [
        -1465.0,
        -3150.316162109375,
        872.1614990234375
      ],
      [
        -1465.0,
        -3124.875244140625,
        864.7237548828125
      ],
      [
        -1465.0,
        -3150.316162109375,
        919.0
      ],
      [
        -1501.1502685546875,
        -3166.4111328125,
        1296.699951171875
      ],
      [
        -1465.99853515625,
        -3150.7607421875,
        1302.5999755859375
      ],
      [
        -1497.2191162109375,
        -3164.660888671875,
        1300.1038818359375
      ],
      [
        -1501.1502685546875,
        -3166.4111328125,
        1296.7000732421875
      ],
      [
        -1498.0899658203125,
        -3165.048583984375,
        1299.30517578125
      ],
      [
        -1497.9481201171875,
        -3164.9853515625,
        1299.4727783203125
      ],
      [
        -1498.0899658203125,
        -3165.048583984375,
        1299.30517578125
      ],
      [
        -1497.427978515625,
        -3164.75390625,
        1300.087158203125
      ],
      [
        -1497.427978515625,
        -3164.75390625,
        1300.087158203125
      ],
      [
        -1377.009033203125,
        -3111.14013671875,
        832.7509765625
      ],
      [
        -1373.194091796875,
        -3109.441650390625,
        790.2850341796875
      ],
      [
        -1373.194091796875,
        -3109.441650390625,
        790.2850341796875
      ],
      [
        -1325.112548828125,
        -3088.034423828125,
        833.904541015625
      ],
      [
        -1325.222900390625,
        -3088.083740234375,
        833.690185546875
      ],
      [
        -1325.222900390625,
        -3088.083740234375,
        833.690185546875
      ],
      [
        -660.0,
        -3173.34326171875,
        1108.3670654296875
      ],
      [
        -760.7306518554688,
        -3392.85400390625,
        1302.5999755859375
      ],
      [
        -1201.8896484375,
        -3085.17333984375,
        1227.2801513671875
      ],
      [
        -1203.83984375,
        -3034.040283203125,
        1285.35595703125
      ],
      [
        -1028.9876708984375,
        -3036.857666015625,
        1046.6942138671875
      ],
      [
        -928.214111328125,
        -3044.112548828125,
        860.7633056640625
      ],
      [
        -980.8582153320312,
        -3031.946044921875,
        987.1676635742188
      ],
      [
        -943.7490844726562,
        -3038.23095703125,
        930.3491821289062
      ],
      [
        -888.1669311523438,
        -3039.878173828125,
        848.0270385742188
      ],
      [
        -904.9636840820312,
        -3040.228759765625,
        865.61328125
      ],
      [
        -888.1669311523438,
        -3039.878173828125,
        848.0270385742188
      ],
      [
        -887.85498046875,
        -3040.50244140625,
        842.2794799804688
      ],
      [
        -888.2889404296875,
        -3042.43408203125,
        826.215576171875
      ],
      [
        -887.85498046875,
        -3040.50244140625,
        842.2794799804688
      ],
      [
        -888.2889404296875,
        -3042.43408203125,
        826.2155151367188
      ],
      [
        -893.6441650390625,
        -3043.8076171875,
        820.9852905273438
      ],
      [
        -905.6473999023438,
        -3046.740478515625,
        810.50927734375
      ],
      [
        -893.6441650390625,
        -3043.8076171875,
        820.9852905273438
      ],
      [
        -1245.9278564453125,
        -3054.45947265625,
        1161.543701171875
      ],
      [
        -1247.3983154296875,
        -3053.433837890625,
        1159.3487548828125
      ],
      [
        -1239.3367919921875,
        -3049.8447265625,
        1193.1077880859375
      ],
      [
        -1028.9876708984375,
        -3036.857666015625,
        1046.6942138671875
      ],
      [
        -983.6710205078125,
        -3038.446533203125,
        983.9086303710938
      ],
      [
        -919.8648681640625,
        -3044.44287109375,
        863.2477416992188
      ],
      [
        -931.7190551757812,
        -3040.268310546875,
        911.9297485351562
      ],
      [
        -887.9857788085938,
        -3042.16064453125,
        848.25830078125
      ],
      [
        -905.338623046875,
        -3042.242431640625,
        866.3751220703125
      ],
      [
        -888.1599731445312,
        -3044.7236328125,
        826.4489135742188
      ],
      [
        -887.7083740234375,
        -3042.719970703125,
        843.1556396484375
      ],
      [
        -905.6189575195312,
        -3048.768310546875,
        810.6764526367188
      ],
      [
        -893.1364135742188,
        -3045.919921875,
        821.5848999023438
      ],
      [
        -888.1599731445312,
        -3044.7236328125,
        826.4488525390625
      ],
      [
        -893.1364135742188,
        -3045.919921875,
        821.5848999023438
      ],
      [
        -887.9857788085938,
        -3042.16064453125,
        848.25830078125
      ],
      [
        -887.7083740234375,
        -3042.719970703125,
        843.1556396484375
      ],
      [
        -972.0384521484375,
        -3161.110107421875,
        835.21826171875
      ],
      [
        -1201.8896484375,
        -3085.17333984375,
        1227.280029296875
      ],
      [
        -972.0384521484375,
        -3161.110107421875,
        835.21826171875
      ],
      [
        -920.2626953125,
        -3110.41650390625,
        820.424072265625
      ],
      [
        -908.2269287109375,
        -3044.2470703125,
        875.9605102539062
      ],
      [
        -896.2774047851562,
        -3046.270751953125,
        857.6646118164062
      ],
      [
        -887.820556640625,
        -3044.2421875,
        848.46923828125
      ],
      [
        -903.8449096679688,
        -3044.545166015625,
        869.7327880859375
      ],
      [
        -908.2269287109375,
        -3044.2470703125,
        875.9605102539062
      ],
      [
        -903.8449096679688,
        -3044.545166015625,
        869.7327880859375
      ],
      [
        -903.625732421875,
        -3045.0263671875,
        868.9155883789062
      ],
      [
        -887.9212036132812,
        -3048.962890625,
        826.8809204101562
      ],
      [
        -887.4212646484375,
        -3047.0634765625,
        844.8717041015625
      ],
      [
        -887.409912109375,
        -3047.772705078125,
        844.087158203125
      ],
      [
        -905.6151733398438,
        -3049.037353515625,
        810.6986083984375
      ],
      [
        -892.3948364257812,
        -3049.0048828125,
        822.4605712890625
      ],
      [
        -887.9212036132812,
        -3048.962890625,
        826.880859375
      ],
      [
        -892.3948364257812,
        -3049.0048828125,
        822.4606323242188
      ],
      [
        -887.820556640625,
        -3044.2421875,
        848.46923828125
      ],
      [
        -887.4212646484375,
        -3047.0634765625,
        844.8717041015625
      ],
      [
        -895.73779296875,
        -3078.880126953125,
        821.5756225585938
      ],
      [
        -888.5581665039062,
        -3064.965087890625,
        826.9910888671875
      ],
      [
        -896.908447265625,
        -3085.3623046875,
        816.1240234375
      ],
      [
        -895.73779296875,
        -3078.880126953125,
        821.5756225585938
      ],
      [
        -896.908447265625,
        -3085.3623046875,
        816.1240234375
      ],
      [
        -901.77685546875,
        -3090.585205078125,
        817.0203857421875
      ],
      [
        -920.2626953125,
        -3110.41650390625,
        820.424072265625
      ],
      [
        -887.1802978515625,
        -3062.1181640625,
        828.2215576171875
      ],
      [
        -887.1802978515625,
        -3062.118408203125,
        828.2215576171875
      ],
      [
        -888.5581665039062,
        -3064.965087890625,
        826.9911499023438
      ],
      [
        -902.391357421875,
        -3047.7373046875,
        864.3125
      ],
      [
        -902.391357421875,
        -3047.7373046875,
        864.3125
      ],
      [
        -887.7254638671875,
        -3045.440185546875,
        848.5906372070312
      ],
      [
        -892.3446044921875,
        -3045.327392578125,
        853.3883666992188
      ],
      [
        -887.7254638671875,
        -3045.440185546875,
        848.5906372070312
      ],
      [
        -887.6215209960938,
        -3045.648681640625,
        846.6757202148438
      ],
      [
        -1004.0083618164062,
        -3037.7333984375,
        1012.0857543945312
      ],
      [
        -671.1574096679688,
        -2973.337646484375,
        1302.5999755859375
      ],
      [
        -873.3448486328125,
        -3069.9794921875,
        844.1968994140625
      ],
      [
        -877.2920532226562,
        -3077.17919921875,
        829.90478515625
      ],
      [
        -873.3448486328125,
        -3069.9794921875,
        844.1968994140625
      ],
      [
        -875.58642578125,
        -3087.461181640625,
        822.6122436523438
      ],
      [
        -877.2920532226562,
        -3077.17919921875,
        829.90478515625
      ],
      [
        -875.58642578125,
        -3087.461181640625,
        822.6122436523438
      ],
      [
        -859.8419189453125,
        -3104.3193359375,
        833.787109375
      ],
      [
        -886.62353515625,
        -3072.003662109375,
        829.2289428710938
      ],
      [
        -900.0586547851562,
        -3047.177734375,
        861.776123046875
      ],
      [
        -892.2487182617188,
        -3072.117919921875,
        824.2073364257812
      ],
      [
        -886.8619995117188,
        -3072.02099609375,
        828.9940185546875
      ],
      [
        -886.62353515625,
        -3072.003662109375,
        829.2289428710938
      ],
      [
        -886.8619995117188,
        -3072.02099609375,
        828.9940185546875
      ],
      [
        -893.2199096679688,
        -3074.000244140625,
        823.4747924804688
      ],
      [
        -1203.474365234375,
        -3510.526611328125,
        267.0
      ],
      [
        -1240.6727294921875,
        -3522.888916015625,
        567.5443725585938
      ],
      [
        -1206.89111328125,
        -3508.74365234375,
        286.2550048828125
      ],
      [
        -1240.95556640625,
        -3523.00732421875,
        569.8958740234375
      ],
      [
        -1240.85107421875,
        -3522.959716796875,
        568.309814453125
      ],
      [
        -1240.795654296875,
        -3522.9375,
        568.0107421875
      ],
      [
        -1240.6727294921875,
        -3522.888916015625,
        567.5443725585938
      ],
      [
        -1240.85107421875,
        -3522.959716796875,
        568.309814453125
      ],
      [
        -1240.795654296875,
        -3522.9375,
        568.0107421875
      ],
      [
        -1245.0706787109375,
        -3524.878662109375,
        632.373291015625
      ],
      [
        -1246.8746337890625,
        -3525.7001953125,
        660.0
      ],
      [
        -1245.0706787109375,
        -3524.878662109375,
        632.373291015625
      ],
      [
        -1148.46826171875,
        -3487.271484375,
        369.31988525390625
      ],
      [
        -1139.98095703125,
        -3485.4150390625,
        621.925537109375
      ],
      [
        -1135.727294921875,
        -3493.7353515625,
        641.6961059570312
      ],
      [
        -1143.2293701171875,
        -3508.486328125,
        267.0
      ],
      [
        -1135.727294921875,
        -3493.7353515625,
        641.6961059570312
      ],
      [
        -1139.98095703125,
        -3485.4150390625,
        621.925537109375
      ],
      [
        -1137.28759765625,
        -3484.58642578125,
        656.460205078125
      ],
      [
        -1134.301025390625,
        -3493.292236328125,
        660.0
      ],
      [
        -1134.0615234375,
        -3494.06884765625,
        660.0
      ],
      [
        -1134.301025390625,
        -3493.292236328125,
        660.0
      ],
      [
        -1137.28759765625,
        -3484.58642578125,
        656.460205078125
      ],
      [
        -1136.84423828125,
        -3484.438720703125,
        660.0
      ],
      [
        -1155.2579345703125,
        -3489.280029296875,
        267.0
      ],
      [
        -1152.176513671875,
        -3488.46923828125,
        332.6519775390625
      ],
      [
        -1152.176513671875,
        -3488.46923828125,
        332.6519775390625
      ],
      [
        -1148.46826171875,
        -3487.271240234375,
        369.31988525390625
      ],
      [
        -949.8262939453125,
        -3650.0,
        660.0
      ],
      [
        -976.505615234375,
        -3650.0,
        275.85992431640625
      ],
      [
        -977.0939331054688,
        -3650.0,
        267.0
      ],
      [
        -976.505615234375,
        -3650.0,
        275.8599548339844
      ],
      [
        -1131.06005859375,
        -3503.157958984375,
        660.0
      ],
      [
        -1131.06005859375,
        -3503.157958984375,
        660.0
      ],
      [
        -1131.7891845703125,
        -3501.4384765625,
        660.0
      ],
      [
        -1131.7891845703125,
        -3501.4384765625,
        660.0
      ],
      [
        -1204.57861328125,
        -3507.775390625,
        267.0
      ],
      [
        -894.7830810546875,
        -3650.0,
        1288.113037109375
      ],
      [
        -949.8262939453125,
        -3650.0,
        660.0
      ],
      [
        -804.115478515625,
        -3362.595947265625,
        1217.9327392578125
      ],
      [
        -1132.9666748046875,
        -3486.419677734375,
        684.1099243164062
      ],
      [
        -1133.350341796875,
        -3483.275146484375,
        687.8972778320312
      ],
      [
        -1114.8499755859375,
        -3477.9765625,
        999.96044921875
      ],
      [
        -1097.50732421875,
        -3476.419189453125,
        1217.9898681640625
      ],
      [
        -1097.50732421875,
        -3476.419189453125,
        1217.9898681640625
      ],
      [
        -1108.127197265625,
        -3475.992919921875,
        1102.3118896484375
      ],
      [
        -894.7830810546875,
        -3650.0,
        1288.1129150390625
      ],
      [
        -893.34814453125,
        -3650.0,
        1302.5999755859375
      ],
      [
        -1136.681396484375,
        -3485.005615234375,
        660.0
      ],
      [
        -1133.350341796875,
        -3483.275146484375,
        687.8972778320312
      ],
      [
        -1132.9666748046875,
        -3486.419677734375,
        684.1099243164062
      ],
      [
        -1109.4647216796875,
        -3476.43408203125,
        1090.7999267578125
      ],
      [
        -1131.9222412109375,
        -3494.98193359375,
        673.7976684570312
      ],
      [
        -1108.1988525390625,
        -3476.015625,
        1101.51708984375
      ],
      [
        -1108.1988525390625,
        -3476.015625,
        1101.51708984375
      ],
      [
        -1109.4647216796875,
        -3476.43408203125,
        1090.7999267578125
      ],
      [
        -1133.9759521484375,
        -3494.23974609375,
        660.38525390625
      ],
      [
        -1131.9222412109375,
        -3494.98193359375,
        673.7976684570312
      ],
      [
        -1134.008544921875,
        -3494.24072265625,
        660.0
      ],
      [
        -1133.9759521484375,
        -3494.23974609375,
        660.38525390625
      ],
      [
        -1131.270263671875,
        -3502.662109375,
        660.0
      ],
      [
        -1258.1507568359375,
        -3530.838623046875,
        833.2398071289062
      ],
      [
        -1258.0595703125,
        -3530.794189453125,
        831.288330078125
      ],
      [
        -1174.5750732421875,
        -3625.21484375,
        1302.5999755859375
      ],
      [
        -1269.7213134765625,
        -3536.47802734375,
        1080.845947265625
      ],
      [
        -1258.1507568359375,
        -3530.838623046875,
        833.2398681640625
      ],
      [
        -1258.0595703125,
        -3530.794189453125,
        831.288330078125
      ],
      [
        -865.1904296875,
        -3320.0,
        1098.7425537109375
      ],
      [
        -1027.87646484375,
        -3320.0,
        1018.707763671875
      ],
      [
        -1085.4853515625,
        -3320.0,
        869.3729248046875
      ],
      [
        -1027.87646484375,
        -3320.0,
        1018.707763671875
      ],
      [
        -1085.4853515625,
        -3320.0,
        869.3729248046875
      ],
      [
        -1105.0,
        -3320.0,
        872.9010620117188
      ],
      [
        -1105.0,
        -3304.406494140625,
        872.9010620117188
      ],
      [
        -1105.0,
        -3304.406494140625,
        872.9010620117188
      ],
      [
        -1105.0,
        -3293.0009765625,
        871.3569946289062
      ],
      [
        -1067.857177734375,
        -3254.84521484375,
        862.6844482421875
      ],
      [
        -1067.857177734375,
        -3254.84521484375,
        862.6844482421875
      ],
      [
        -1105.0,
        -3293.0009765625,
        871.3569946289062
      ],
      [
        -1105.0,
        -3291.5771484375,
        872.9010620117188
      ],
      [
        -1074.35498046875,
        -3258.607177734375,
        867.3606567382812
      ],
      [
        -1105.0,
        -3276.348876953125,
        889.4143676757812
      ],
      [
        -1105.0,
        -3152.747802734375,
        1023.4471435546875
      ],
      [
        -1105.0,
        -3338.26953125,
        872.9010620117188
      ],
      [
        -1105.0,
        -3434.97412109375,
        1159.3406982421875
      ],
      [
        -1105.0,
        -3434.97412109375,
        1159.3406982421875
      ],
      [
        -1105.0,
        -3475.00244140625,
        1136.998046875
      ],
      [
        -1105.0,
        -3338.26953125,
        872.9010620117188
      ],
      [
        -1175.486083984375,
        -3320.0,
        640.3673095703125
      ],
      [
        -1163.886474609375,
        -3320.0,
        715.0223388671875
      ],
      [
        -1293.4595947265625,
        -3183.870361328125,
        533.1759643554688
      ],
      [
        -1293.4595947265625,
        -3183.870361328125,
        533.1759643554688
      ],
      [
        -1324.6180419921875,
        -3140.56103515625,
        540.0997314453125
      ],
      [
        -1324.6180419921875,
        -3140.56103515625,
        540.0997314453125
      ],
      [
        -1341.4378662109375,
        -3116.576416015625,
        546.7371826171875
      ],
      [
        -1347.9879150390625,
        -3098.218994140625,
        592.5193481445312
      ],
      [
        -1352.2415771484375,
        -3100.78173828125,
        552.8644409179688
      ],
      [
        -1352.24169921875,
        -3100.78173828125,
        552.8644409179688
      ],
      [
        -1341.437744140625,
        -3116.5771484375,
        546.7369384765625
      ],
      [
        -1163.886474609375,
        -3320.0,
        715.0223388671875
      ],
      [
        -1333.1427001953125,
        -3091.609375,
        724.0
      ],
      [
        -1175.145263671875,
        -3303.725341796875,
        724.0
      ],
      [
        -1163.808349609375,
        -3320.0,
        715.8345947265625
      ],
      [
        -1276.442626953125,
        -3320.0,
        466.3150939941406
      ],
      [
        -1282.109375,
        -3320.0,
        465.73052978515625
      ],
      [
        -1284.31787109375,
        -3320.0,
        472.17510986328125
      ],
      [
        -1282.109375,
        -3320.0,
        465.73052978515625
      ],
      [
        -1284.31787109375,
        -3320.0,
        472.17510986328125
      ],
      [
        -1286.2840576171875,
        -3320.0,
        480.18701171875
      ],
      [
        -1328.328857421875,
        -3320.0,
        538.2327880859375
      ],
      [
        -1331.0455322265625,
        -3320.0,
        561.276123046875
      ],
      [
        -1324.7630615234375,
        -3320.0,
        508.04010009765625
      ],
      [
        -1287.4573974609375,
        -3320.0,
        484.96807861328125
      ],
      [
        -1287.4573974609375,
        -3320.0,
        484.96807861328125
      ],
      [
        -1235.3033447265625,
        -3318.94921875,
        472.8974304199219
      ],
      [
        -1235.176513671875,
        -3320.0,
        470.5718994140625
      ],
      [
        -1234.159423828125,
        -3317.593505859375,
        473.12396240234375
      ],
      [
        -1233.32861328125,
        -3320.0,
        466.6517028808594
      ],
      [
        -1235.176513671875,
        -3320.0,
        470.5718994140625
      ],
      [
        -1235.3033447265625,
        -3318.94921875,
        472.8974304199219
      ],
      [
        -1233.32861328125,
        -3320.0,
        466.6517028808594
      ],
      [
        -1234.159423828125,
        -3317.593505859375,
        473.12396240234375
      ],
      [
        -1233.1290283203125,
        -3319.2275390625,
        472.5026550292969
      ],
      [
        -1232.81396484375,
        -3320.0,
        470.81585693359375
      ],
      [
        -1232.641845703125,
        -3320.0,
        472.2089538574219
      ],
      [
        -1337.023193359375,
        -3320.0,
        611.8834228515625
      ],
      [
        -1386.6923828125,
        -3174.371337890625,
        724.0
      ],
      [
        -1400.39306640625,
        -3123.563720703125,
        724.0
      ],
      [
        -1336.9337158203125,
        -3320.0,
        610.9191284179688
      ],
      [
        -1356.4564208984375,
        -3320.0,
        700.5
      ],
      [
        -1353.3177490234375,
        -3290.0556640625,
        700.5
      ],
      [
        -1345.2430419921875,
        -3320.0,
        700.5
      ],
      [
        -1336.874267578125,
        -3320.0,
        610.715576171875
      ],
      [
        -1336.9337158203125,
        -3320.0,
        610.9191284179688
      ],
      [
        -1336.874267578125,
        -3320.0,
        610.715576171875
      ],
      [
        -1388.2457275390625,
        -3117.4443359375,
        630.4634399414062
      ],
      [
        -1400.39306640625,
        -3123.563720703125,
        724.0
      ],
      [
        -1398.0760498046875,
        -3122.388671875,
        724.0
      ],
      [
        -1388.2457275390625,
        -3117.4443359375,
        630.4634399414062
      ],
      [
        -1233.1290283203125,
        -3319.2275390625,
        472.5026550292969
      ],
      [
        -1231.2933349609375,
        -3320.0,
        483.1204528808594
      ],
      [
        -1231.2933349609375,
        -3320.0,
        483.1204528808594
      ],
      [
        -1226.1395263671875,
        -3320.0,
        487.038330078125
      ],
      [
        -1210.5164794921875,
        -3320.0,
        498.9146728515625
      ],
      [
        -1210.5164794921875,
        -3320.0,
        498.9146728515625
      ],
      [
        -1210.31494140625,
        -3320.0,
        501.2149658203125
      ],
      [
        -1191.8505859375,
        -3320.0,
        542.9447021484375
      ],
      [
        -1175.486083984375,
        -3320.0,
        640.3673095703125
      ],
      [
        -1367.9073486328125,
        -3107.087646484375,
        724.0
      ],
      [
        -1209.5694580078125,
        -3320.0,
        509.7249450683594
      ],
      [
        -1191.8505859375,
        -3320.0,
        542.9447021484375
      ],
      [
        -1209.5694580078125,
        -3320.0,
        509.7249450683594
      ],
      [
        -1323.274658203125,
        -3320.0,
        700.5
      ],
      [
        -1163.808349609375,
        -3320.0,
        715.8345947265625
      ],
      [
        -1175.145263671875,
        -3303.725341796875,
        724.0
      ],
      [
        -1163.061767578125,
        -3320.0,
        724.0
      ],
      [
        -1291.38037109375,
        -3374.414306640625,
        504.20489501953125
      ],
      [
        -1312.7127685546875,
        -3320.0,
        500.58746337890625
      ],
      [
        -1291.38037109375,
        -3374.4140625,
        504.20477294921875
      ],
      [
        -1322.521484375,
        -3419.20751953125,
        633.7772216796875
      ],
      [
        -1332.4990234375,
        -3380.387939453125,
        672.1159057617188
      ],
      [
        -1339.1156005859375,
        -3404.196533203125,
        700.5
      ],
      [
        -1345.1156005859375,
        -3320.0,
        700.5
      ],
      [
        -1339.8861083984375,
        -3351.646728515625,
        700.5
      ],
      [
        -1336.3896484375,
        -3320.0,
        606.6046752929688
      ],
      [
        -1332.4990234375,
        -3380.387939453125,
        672.1159057617188
      ],
      [
        -1340.3204345703125,
        -3321.824462890625,
        700.4888916015625
      ],
      [
        -1340.7564697265625,
        -3320.0,
        700.5
      ],
      [
        -1340.43701171875,
        -3320.796142578125,
        700.5
      ],
      [
        -1340.32373046875,
        -3321.79931640625,
        700.5
      ],
      [
        -1340.334716796875,
        -3321.051025390625,
        700.5
      ],
      [
        -1267.69873046875,
        -3510.23681640625,
        724.0
      ],
      [
        -1292.409912109375,
        -3484.34423828125,
        724.0
      ],
      [
        -1240.95556640625,
        -3523.00732421875,
        569.8958740234375
      ],
      [
        -1325.396728515625,
        -3452.548583984375,
        724.0
      ],
      [
        -1292.409912109375,
        -3484.34423828125,
        724.0
      ],
      [
        -1325.396728515625,
        -3452.548583984375,
        724.0
      ],
      [
        -1325.9498291015625,
        -3449.201171875,
        724.0
      ],
      [
        -1329.06494140625,
        -3430.349365234375,
        724.0
      ],
      [
        -1340.5382080078125,
        -3328.757080078125,
        724.0
      ],
      [
        -1340.450439453125,
        -3321.840087890625,
        703.5836181640625
      ],
      [
        -1331.1131591796875,
        -3403.35546875,
        700.5
      ],
      [
        -1340.32373046875,
        -3321.79931640625,
        700.5
      ],
      [
        -1329.06494140625,
        -3430.349365234375,
        724.0
      ],
      [
        -1317.072509765625,
        -3379.008544921875,
        700.5
      ],
      [
        -1145.9208984375,
        -3422.269775390625,
        724.0
      ],
      [
        -1137.0072021484375,
        -3453.29931640625,
        724.0
      ],
      [
        -1131.2100830078125,
        -3482.662109375,
        724.0
      ],
      [
        -1137.0072021484375,
        -3453.29931640625,
        724.0
      ],
      [
        -1160.6263427734375,
        -3329.75439453125,
        724.0
      ],
      [
        -1153.3792724609375,
        -3396.30615234375,
        724.0
      ],
      [
        -1153.3792724609375,
        -3396.30615234375,
        724.0
      ],
      [
        -1198.849853515625,
        -3320.0,
        529.822265625
      ],
      [
        -1160.6263427734375,
        -3329.75439453125,
        724.0
      ],
      [
        -1161.8470458984375,
        -3321.635986328125,
        724.0
      ],
      [
        -1161.8470458984375,
        -3321.635986328125,
        724.0
      ],
      [
        -1214.751220703125,
        -3320.0,
        495.69549560546875
      ],
      [
        -1196.9259033203125,
        -3408.011474609375,
        278.63519287109375
      ],
      [
        -1232.81396484375,
        -3320.0,
        470.8164367675781
      ],
      [
        -1195.760498046875,
        -3413.293212890625,
        267.0
      ],
      [
        -1196.9259033203125,
        -3408.011474609375,
        278.63519287109375
      ],
      [
        -1289.0367431640625,
        -3320.0,
        485.9448547363281
      ],
      [
        -1298.8712158203125,
        -3355.306884765625,
        502.9345703125
      ],
      [
        -1340.35009765625,
        -3320.0,
        700.5
      ],
      [
        -1340.334716796875,
        -3321.051025390625,
        700.5
      ],
      [
        -1251.379638671875,
        -3527.336181640625,
        724.0
      ],
      [
        -1251.379638671875,
        -3527.336181640625,
        724.0
      ],
      [
        -1251.0538330078125,
        -3527.603515625,
        724.0
      ],
      [
        -1341.3077392578125,
        -3321.943359375,
        724.0
      ],
      [
        -1314.535400390625,
        -3083.3251953125,
        878.1983032226562
      ],
      [
        -1152.3179931640625,
        -3322.175537109375,
        823.8455810546875
      ],
      [
        -1325.2467041015625,
        -3088.09423828125,
        833.34326171875
      ],
      [
        -1105.0,
        -3286.692138671875,
        878.1983032226562
      ],
      [
        -1146.5478515625,
        -3314.0,
        861.2327880859375
      ],
      [
        -1126.0,
        -3314.0,
        876.88232421875
      ],
      [
        -1126.9766845703125,
        -3314.0,
        878.1983032226562
      ],
      [
        -1141.1407470703125,
        -3314.0,
        878.1983032226562
      ],
      [
        -1126.0,
        -3322.0,
        868.2073974609375
      ],
      [
        -1140.92724609375,
        -3322.0,
        860.0
      ],
      [
        -1135.127197265625,
        -3322.0,
        878.1983032226562
      ],
      [
        -1133.4146728515625,
        -3322.0,
        878.1983032226562
      ],
      [
        -1146.0,
        -3315.25146484375,
        860.0
      ],
      [
        -1146.5478515625,
        -3314.0,
        861.2327880859375
      ],
      [
        -1116.1199951171875,
        -3348.679931640625,
        874.9114990234375
      ],
      [
        -1126.0,
        -3322.0,
        876.6976928710938
      ],
      [
        -1133.2291259765625,
        -3322.0,
        877.9482421875
      ],
      [
        -1132.57568359375,
        -3322.0,
        877.8865356445312
      ],
      [
        -1133.2774658203125,
        -3322.0,
        878.013427734375
      ],
      [
        -1116.1199951171875,
        -3348.679931640625,
        874.9114990234375
      ],
      [
        -1105.0,
        -3340.057861328125,
        878.1983032226562
      ],
      [
        -1114.98486328125,
        -3348.796142578125,
        878.1983032226562
      ],
      [
        -1126.0,
        -3322.0,
        878.1983032226562
      ],
      [
        -1126.0,
        -3314.0,
        878.1983032226562
      ],
      [
        -1155.2801513671875,
        -3350.784423828125,
        747.0780029296875
      ],
      [
        -1152.3179931640625,
        -3322.175537109375,
        823.8455810546875
      ],
      [
        -1155.2801513671875,
        -3350.784423828125,
        747.0780029296875
      ],
      [
        -1157.6080322265625,
        -3357.472412109375,
        724.0
      ],
      [
        -1117.74365234375,
        -3350.199951171875,
        875.2050170898438
      ],
      [
        -1146.5098876953125,
        -3322.0,
        861.1472778320312
      ],
      [
        -1135.1934814453125,
        -3322.0,
        877.9904174804688
      ],
      [
        -1148.692138671875,
        -3314.0,
        866.057373046875
      ],
      [
        -1141.6876220703125,
        -3314.0,
        876.482421875
      ],
      [
        -1148.6920166015625,
        -3314.0,
        866.0571899414062
      ],
      [
        -1146.5098876953125,
        -3322.0,
        861.1472778320312
      ],
      [
        -1117.74365234375,
        -3350.199951171875,
        875.2050170898438
      ],
      [
        -1116.0537109375,
        -3349.731689453125,
        878.1983032226562
      ],
      [
        -1144.8021240234375,
        -3392.001220703125,
        792.308837890625
      ],
      [
        -1132.2735595703125,
        -3477.275390625,
        724.0
      ],
      [
        -1142.80419921875,
        -3405.77978515625,
        781.2319946289062
      ],
      [
        -1144.518310546875,
        -3396.521240234375,
        788.1217651367188
      ],
      [
        -1142.80419921875,
        -3405.77978515625,
        781.2319946289062
      ],
      [
        -1147.5853271484375,
        -3416.4755859375,
        724.0
      ],
      [
        -1144.8021240234375,
        -3392.001220703125,
        792.308837890625
      ],
      [
        -1144.884765625,
        -3394.542236328125,
        789.594482421875
      ],
      [
        -1144.884765625,
        -3394.542236328125,
        789.594482421875
      ],
      [
        -1373.2103271484375,
        -3109.770263671875,
        740.1548461914062
      ],
      [
        -1381.2618408203125,
        -3113.86083984375,
        724.0
      ],
      [
        -1369.150146484375,
        -3107.64111328125,
        748.3692626953125
      ],
      [
        -1373.2105712890625,
        -3109.770263671875,
        740.1549072265625
      ],
      [
        -1465.0,
        -3155.0,
        878.1983032226562
      ],
      [
        -1465.0,
        -3150.316162109375,
        878.1983032226562
      ],
      [
        -1465.0,
        -3155.0,
        878.1983032226562
      ],
      [
        -1465.0,
        -3200.816162109375,
        878.1983032226562
      ],
      [
        -1445.0,
        -3155.0,
        878.1983032226562
      ],
      [
        -1445.0,
        -3200.81640625,
        878.1983032226562
      ],
      [
        -1370.0,
        -3410.0,
        878.1983032226562
      ],
      [
        -1370.0,
        -3368.0,
        878.1983032226562
      ],
      [
        -1405.0,
        -3368.0,
        878.1983032226562
      ],
      [
        -1405.0,
        -3410.0,
        878.1983032226562
      ],
      [
        -1405.0,
        -3368.0,
        878.1983032226562
      ],
      [
        -1370.0,
        -3368.0,
        878.1983032226562
      ],
      [
        -1445.0,
        -3141.41162109375,
        849.9982299804688
      ],
      [
        -1356.0,
        -3323.0,
        878.1983032226562
      ],
      [
        -1356.0,
        -3315.0,
        878.1983032226562
      ],
      [
        -1356.0,
        -3374.0,
        878.1983032226562
      ],
      [
        -1356.0,
        -3366.0,
        878.1983032226562
      ],
      [
        -1347.2169189453125,
        -3374.0,
        860.0
      ],
      [
        -1356.0,
        -3374.0,
        878.1983032226562
      ],
      [
        -1349.2327880859375,
        -3374.0,
        878.1983032226562
      ],
      [
        -1356.0,
        -3366.0,
        878.1983032226562
      ],
      [
        -1347.956298828125,
        -3366.0,
        860.0
      ],
      [
        -1349.97216796875,
        -3366.0,
        878.1983032226562
      ],
      [
        -1351.93017578125,
        -3323.0,
        860.0
      ],
      [
        -1356.0,
        -3323.0,
        878.1983032226562
      ],
      [
        -1353.9461669921875,
        -3323.0,
        878.1983032226562
      ],
      [
        -1356.0,
        -3315.0,
        878.1983032226562
      ],
      [
        -1352.669677734375,
        -3315.0,
        860.0
      ],
      [
        -1354.6854248046875,
        -3315.0,
        878.1983032226562
      ],
      [
        -1324.8431396484375,
        -3453.082275390625,
        724.0
      ],
      [
        -1333.894287109375,
        -3456.440673828125,
        878.1983032226562
      ],
      [
        -1347.87158203125,
        -3374.0,
        865.9097900390625
      ],
      [
        -1348.5267333984375,
        -3374.0,
        878.1983032226562
      ],
      [
        -1349.9464111328125,
        -3366.0,
        878.1983032226562
      ],
      [
        -1349.922607421875,
        -3366.0,
        877.7510986328125
      ],
      [
        -1333.894287109375,
        -3456.440673828125,
        878.1983032226562
      ],
      [
        -1295.989013671875,
        -3496.095458984375,
        878.1983032226562
      ],
      [
        -1291.3072509765625,
        -3500.863525390625,
        878.1983032226562
      ],
      [
        -1295.989013671875,
        -3496.095458984375,
        878.1983032226562
      ],
      [
        -1286.1649169921875,
        -3499.702880859375,
        798.7045288085938
      ],
      [
        -1351.4095458984375,
        -3315.0,
        860.0
      ],
      [
        -1352.67431640625,
        -3315.0,
        878.1983032226562
      ],
      [
        -1348.7904052734375,
        -3323.0,
        860.0
      ],
      [
        -1350.0330810546875,
        -3323.0,
        878.1983032226562
      ],
      [
        -1349.2763671875,
        -3323.0,
        867.3114624023438
      ],
      [
        -1286.1649169921875,
        -3499.702880859375,
        798.7045288085938
      ],
      [
        -1284.1705322265625,
        -3495.604736328125,
        750.54541015625
      ],
      [
        -1284.1705322265625,
        -3495.604736328125,
        750.54541015625
      ],
      [
        -1282.6756591796875,
        -3494.5439453125,
        724.0
      ],
      [
        -1334.7640380859375,
        -3366.0,
        862.7809448242188
      ],
      [
        -1335.83544921875,
        -3366.0,
        878.1983032226562
      ],
      [
        -1334.9947509765625,
        -3374.0,
        878.1983032226562
      ],
      [
        -1332.70556640625,
        -3374.0,
        871.167236328125
      ],
      [
        -1332.47998046875,
        -3374.0,
        867.9201049804688
      ],
      [
        -1332.70556640625,
        -3374.0,
        871.167236328125
      ],
      [
        -1334.9947509765625,
        -3374.0,
        878.1983032226562
      ],
      [
        -1334.9947509765625,
        -3368.54638671875,
        878.1983032226562
      ],
      [
        -1348.7681884765625,
        -3323.0,
        860.0
      ],
      [
        -1399.47509765625,
        -3123.09814453125,
        724.0
      ],
      [
        -1284.007568359375,
        -3495.489013671875,
        747.6507568359375
      ],
      [
        -1280.76708984375,
        -3496.543701171875,
        724.0
      ],
      [
        -1411.0396728515625,
        -3128.560791015625,
        878.1983032226562
      ],
      [
        -1352.54150390625,
        -3315.0,
        878.1983032226562
      ],
      [
        -1352.54150390625,
        -3315.0,
        876.2875366210938
      ],
      [
        -1134.4197998046875,
        -3417.484375,
        878.1983032226562
      ],
      [
        -1122.068603515625,
        -3480.0439453125,
        878.1983032226562
      ],
      [
        -1137.91455078125,
        -3366.0,
        860.0
      ],
      [
        -1126.0,
        -3366.0,
        876.6976928710938
      ],
      [
        -1134.2296142578125,
        -3366.0,
        878.185546875
      ],
      [
        -1126.0,
        -3374.0,
        876.6976928710938
      ],
      [
        -1135.96923828125,
        -3374.0,
        860.0
      ],
      [
        -1132.3531494140625,
        -3374.0,
        877.8463134765625
      ],
      [
        -1126.0,
        -3366.0,
        878.1983032226562
      ],
      [
        -1134.22705078125,
        -3366.0,
        878.1983032226562
      ],
      [
        -1126.0,
        -3374.0,
        878.1983032226562
      ],
      [
        -1132.2818603515625,
        -3374.0,
        878.1983032226562
      ],
      [
        -1147.7950439453125,
        -3322.0,
        864.0387573242188
      ],
      [
        -1144.9259033203125,
        -3322.0,
        878.1983032226562
      ],
      [
        -1149.131103515625,
        -3314.0,
        867.0450439453125
      ],
      [
        -1146.87109375,
        -3314.0,
        878.1983032226562
      ],
      [
        -1149.1309814453125,
        -3314.0,
        867.044921875
      ],
      [
        -1147.7950439453125,
        -3322.0,
        864.0387573242188
      ],
      [
        -1144.807861328125,
        -3392.177001953125,
        792.1210327148438
      ],
      [
        -1134.4197998046875,
        -3417.484375,
        878.1983032226562
      ],
      [
        -1136.4671630859375,
        -3374.0,
        860.0
      ],
      [
        -1134.3193359375,
        -3374.0,
        878.1983032226562
      ],
      [
        -1134.4036865234375,
        -3366.0,
        877.32666015625
      ],
      [
        -1134.30078125,
        -3366.0,
        878.1983032226562
      ],
      [
        -1145.7242431640625,
        -3366.0,
        860.0
      ],
      [
        -1144.5843505859375,
        -3366.0,
        878.1983032226562
      ],
      [
        -1144.144775390625,
        -3374.0,
        860.0
      ],
      [
        -1143.0048828125,
        -3374.0,
        878.1983032226562
      ],
      [
        -1147.0052490234375,
        -3322.0,
        878.1983032226562
      ],
      [
        -1147.0052490234375,
        -3322.0,
        878.1983032226562
      ],
      [
        -1147.0052490234375,
        -3314.0,
        878.1983032226562
      ],
      [
        -1147.0052490234375,
        -3314.0,
        878.1983032226562
      ],
      [
        -1287.7933349609375,
        -3504.442138671875,
        878.1983032226562
      ],
      [
        -1374.5,
        -3110.425537109375,
        737.5672607421875
      ],
      [
        -1261.143310546875,
        -3531.583984375,
        878.1983032226562
      ],
      [
        -1392.043212890625,
        -3119.3125,
        878.1983032226562
      ],
      [
        -1369.9161376953125,
        -3107.982177734375,
        878.1983032226562
      ],
      [
        -1411.0396728515625,
        -3128.560791015625,
        878.1983032226562
      ],
      [
        -1392.043212890625,
        -3119.3125,
        878.1983032226562
      ],
      [
        -1261.143310546875,
        -3531.583984375,
        878.1983032226562
      ],
      [
        -1260.6123046875,
        -3531.997802734375,
        878.1983032226562
      ],
      [
        -1334.9947509765625,
        -3315.0,
        878.1983032226562
      ],
      [
        -1334.9947509765625,
        -3323.0,
        878.1983032226562
      ],
      [
        -1334.9947509765625,
        -3323.0,
        878.1983032226562
      ],
      [
        -1334.9947509765625,
        -3315.0,
        878.1983032226562
      ],
      [
        -1147.0052490234375,
        -3374.0,
        878.1983032226562
      ],
      [
        -1147.0052490234375,
        -3366.0,
        878.1983032226562
      ],
      [
        -1334.9947509765625,
        -3366.0,
        878.1983032226562
      ],
      [
        -1147.0052490234375,
        -3366.0,
        878.1983032226562
      ],
      [
        -1147.0052490234375,
        -3374.0,
        878.1983032226562
      ],
      [
        -1334.9947509765625,
        -3366.0,
        878.1983032226562
      ],
      [
        -1462.1907958984375,
        -3446.39501953125,
        1302.5999755859375
      ],
      [
        -1520.6458740234375,
        -3432.515380859375,
        1302.5999755859375
      ],
      [
        -1462.1907958984375,
        -3446.39501953125,
        1302.5999755859375
      ],
      [
        -1595.0,
        -3426.5,
        892.0
      ],
      [
        -1455.337646484375,
        -3426.5,
        892.0
      ],
      [
        -1460.414794921875,
        -3426.5,
        915.0
      ],
      [
        -1595.0,
        -3426.5,
        915.0
      ],
      [
        -1595.0,
        -3411.5,
        892.0
      ],
      [
        -1518.510986328125,
        -3411.5,
        892.0
      ],
      [
        -1455.337646484375,
        -3426.5,
        892.0
      ],
      [
        -1595.0,
        -3426.5,
        892.0
      ],
      [
        -1595.0,
        -3426.5,
        915.0
      ],
      [
        -1460.414794921875,
        -3426.5,
        915.0
      ],
      [
        -1523.588134765625,
        -3411.5,
        915.0
      ],
      [
        -1595.0,
        -3411.5,
        915.0
      ],
      [
        -1595.0,
        -3419.54296875,
        1040.4466552734375
      ],
      [
        -1595.0,
        -3405.03955078125,
        1115.2313232421875
      ],
      [
        -1595.0,
        -3419.54296875,
        1040.4466552734375
      ],
      [
        -1595.0,
        -3398.44921875,
        989.5020751953125
      ],
      [
        -1595.0,
        -3411.5,
        915.0
      ],
      [
        -1523.588134765625,
        -3411.5,
        915.0
      ],
      [
        -1518.510986328125,
        -3411.5,
        892.0
      ],
      [
        -1595.0,
        -3411.5,
        892.0
      ],
      [
        -1334.2330322265625,
        -3454.531982421875,
        878.1983032226562
      ],
      [
        -1542.2252197265625,
        -3389.01025390625,
        1192.60498046875
      ],
      [
        -1520.6458740234375,
        -3432.515380859375,
        1302.5999755859375
      ],
      [
        -1534.71923828125,
        -3409.7333984375,
        1302.5999755859375
      ],
      [
        -1542.2252197265625,
        -3389.01025390625,
        1192.60498046875
      ],
      [
        -1576.020751953125,
        -3379.77587890625,
        1243.6004638671875
      ],
      [
        -1595.0,
        -3388.281494140625,
        1201.640625
      ],
      [
        -1595.0,
        -3388.281494140625,
        1201.640625
      ],
      [
        -1576.020751953125,
        -3379.77587890625,
        1243.6004638671875
      ],
      [
        -1595.0,
        -3375.162109375,
        1275.9561767578125
      ],
      [
        -1595.0,
        -3394.36962890625,
        979.6495971679688
      ],
      [
        -1595.0,
        -3368.02783203125,
        912.5338745117188
      ],
      [
        -1542.261474609375,
        -3366.172119140625,
        900.3103637695312
      ],
      [
        -1595.0,
        -3394.36962890625,
        979.6495971679688
      ],
      [
        -1514.9678955078125,
        -3411.5,
        915.0
      ],
      [
        -1513.8604736328125,
        -3411.5,
        892.0
      ],
      [
        -1514.9678955078125,
        -3411.5,
        915.0
      ],
      [
        -1513.486083984375,
        -3413.898681640625,
        915.0
      ],
      [
        -1513.8604736328125,
        -3411.5,
        892.0
      ],
      [
        -1513.0611572265625,
        -3412.7939453125,
        892.0
      ],
      [
        -1542.261474609375,
        -3366.172119140625,
        900.3103637695312
      ],
      [
        -1595.0,
        -3368.02783203125,
        912.5338745117188
      ],
      [
        -1595.0,
        -3362.948486328125,
        912.6388549804688
      ],
      [
        -1544.27880859375,
        -3362.948486328125,
        900.8460083007812
      ],
      [
        -1483.8258056640625,
        -3376.197021484375,
        917.5480346679688
      ],
      [
        -1498.367919921875,
        -3364.627685546875,
        890.1369018554688
      ],
      [
        -1483.8258056640625,
        -3376.197021484375,
        917.5480346679688
      ],
      [
        -1413.2100830078125,
        -3411.5,
        915.0
      ],
      [
        -1406.20703125,
        -3411.5,
        892.0
      ],
      [
        -1405.0,
        -3410.0,
        878.289794921875
      ],
      [
        -1405.0,
        -3409.98583984375,
        878.1983032226562
      ],
      [
        -1335.944091796875,
        -3444.89208984375,
        878.1983032226562
      ],
      [
        -1380.0,
        -3424.746826171875,
        892.0
      ],
      [
        -1394.5,
        -3417.417724609375,
        892.0
      ],
      [
        -1406.20703125,
        -3411.5,
        892.0
      ],
      [
        -1394.5,
        -3417.417724609375,
        892.0
      ],
      [
        -1394.5,
        -3420.95751953125,
        915.0
      ],
      [
        -1383.534912109375,
        -3426.5,
        915.0
      ],
      [
        -1394.5,
        -3420.95751953125,
        915.0
      ],
      [
        -1413.2100830078125,
        -3411.5,
        915.0
      ],
      [
        -1380.0,
        -3426.5,
        903.3905639648438
      ],
      [
        -1383.534912109375,
        -3426.5,
        915.0
      ],
      [
        -1380.0,
        -3424.746826171875,
        892.0
      ],
      [
        -1380.0,
        -3426.5,
        903.3905639648438
      ],
      [
        -1498.367919921875,
        -3364.627685546875,
        890.1369018554688
      ],
      [
        -1501.9541015625,
        -3362.948486328125,
        891.00537109375
      ],
      [
        -1131.1561279296875,
        -3362.948486328125,
        878.1983032226562
      ],
      [
        -1105.0,
        -3362.948486328125,
        946.0004272460938
      ],
      [
        -1110.0399169921875,
        -3476.598876953125,
        1081.0982666015625
      ],
      [
        -1130.6844482421875,
        -3436.404296875,
        878.1983032226562
      ],
      [
        -1130.744140625,
        -3374.0,
        912.0
      ],
      [
        -1133.8756103515625,
        -3374.0,
        878.1983032226562
      ],
      [
        -1130.78955078125,
        -3374.0,
        911.88232421875
      ],
      [
        -1134.1732177734375,
        -3366.0,
        879.4154052734375
      ],
      [
        -1134.2847900390625,
        -3366.0,
        878.1983032226562
      ],
      [
        -1126.0,
        -3366.0,
        900.6022338867188
      ],
      [
        -1130.744140625,
        -3374.0,
        912.0
      ],
      [
        -1126.0,
        -3369.84814453125,
        912.0
      ],
      [
        -1131.1878662109375,
        -3366.0,
        912.0
      ],
      [
        -1130.77880859375,
        -3374.0,
        912.0
      ],
      [
        -1131.1878662109375,
        -3366.0,
        912.0
      ],
      [
        -1130.77880859375,
        -3374.0,
        912.0
      ],
      [
        -1132.336181640625,
        -3374.0,
        895.0014038085938
      ],
      [
        -1134.3192138671875,
        -3374.0,
        878.1983032226562
      ],
      [
        -1134.30078125,
        -3366.0,
        878.1983032226562
      ],
      [
        -1134.2293701171875,
        -3366.0,
        878.8035888671875
      ],
      [
        -1342.1177978515625,
        -3410.108642578125,
        878.1983032226562
      ],
      [
        -1385.8082275390625,
        -3411.5,
        915.0
      ],
      [
        -1381.0540771484375,
        -3411.5,
        911.310791015625
      ],
      [
        -1370.0,
        -3407.306640625,
        894.0
      ],
      [
        -1373.0,
        -3406.188720703125,
        894.0
      ],
      [
        -1405.0,
        -3394.263671875,
        894.0
      ],
      [
        -1401.5,
        -3395.568115234375,
        894.0
      ],
      [
        -1375.0,
        -3405.443359375,
        894.0
      ],
      [
        -1399.5,
        -3396.313232421875,
        894.0
      ],
      [
        -1405.0,
        -3394.263671875,
        894.0
      ],
      [
        -1405.0,
        -3386.67529296875,
        878.1983032226562
      ],
      [
        -1370.0,
        -3407.306640625,
        894.0
      ],
      [
        -1370.0,
        -3399.71826171875,
        878.1983032226562
      ],
      [
        -1401.5,
        -3395.568115234375,
        894.0
      ],
      [
        -1401.5,
        -3405.65283203125,
        915.0
      ],
      [
        -1399.5,
        -3406.397705078125,
        915.0
      ],
      [
        -1399.5,
        -3396.313232421875,
        894.0
      ],
      [
        -1401.5,
        -3405.65283203125,
        915.0
      ],
      [
        -1399.5,
        -3407.23828125,
        916.75
      ],
      [
        -1399.5,
        -3410.0,
        916.75
      ],
      [
        -1375.0,
        -3410.0,
        903.4888916015625
      ],
      [
        -1381.4814453125,
        -3410.0,
        908.5185546875
      ],
      [
        -1381.4814453125,
        -3410.0,
        908.5185546875
      ],
      [
        -1389.833740234375,
        -3410.0,
        915.0
      ],
      [
        -1375.0,
        -3405.443359375,
        894.0
      ],
      [
        -1375.0,
        -3410.0,
        903.4888916015625
      ],
      [
        -1373.0,
        -3410.0,
        901.9366455078125
      ],
      [
        -1373.0,
        -3406.188720703125,
        894.0
      ],
      [
        -1396.5,
        -3397.72509765625,
        894.6126098632812
      ],
      [
        -1396.5,
        -3398.5,
        896.2261352539062
      ],
      [
        -1396.5,
        -3397.72509765625,
        894.6126098632812
      ],
      [
        -1396.5,
        -3397.43115234375,
        894.0
      ],
      [
        -1396.5,
        -3402.713623046875,
        905.0
      ],
      [
        -1396.5,
        -3403.673828125,
        907.0
      ],
      [
        -1396.5,
        -3403.673828125,
        907.0
      ],
      [
        -1399.5,
        -3403.516357421875,
        909.0
      ],
      [
        -1397.5,
        -3408.823974609375,
        918.5
      ],
      [
        -1396.5,
        -3410.0,
        918.5
      ],
      [
        -1397.5,
        -3408.823974609375,
        918.5
      ],
      [
        -1396.5,
        -3409.196533203125,
        918.5
      ],
      [
        -1399.5,
        -3396.5,
        894.3890991210938
      ],
      [
        -1398.99853515625,
        -3396.5,
        894.0
      ],
      [
        -1394.3443603515625,
        -3410.0,
        918.5
      ],
      [
        -1380.0,
        -3411.5,
        910.49267578125
      ],
      [
        -1380.0,
        -3413.66455078125,
        915.0
      ],
      [
        -1380.0,
        -3413.66455078125,
        915.0
      ],
      [
        -1385.8082275390625,
        -3411.5,
        915.0
      ],
      [
        -1477.99609375,
        -3362.948486328125,
        885.43505859375
      ],
      [
        -1405.0,
        -3368.0,
        884.397216796875
      ],
      [
        -1370.0,
        -3368.0,
        882.0145263671875
      ],
      [
        -1370.0,
        -3379.22998046875,
        894.0
      ],
      [
        -1370.0,
        -3368.0,
        882.0145263671875
      ],
      [
        -1370.0,
        -3379.22998046875,
        894.0
      ],
      [
        -1373.0,
        -3379.03857421875,
        894.0
      ],
      [
        -1405.0,
        -3376.997314453125,
        894.0
      ],
      [
        -1401.5,
        -3377.220947265625,
        894.0
      ],
      [
        -1375.0,
        -3378.9111328125,
        894.0
      ],
      [
        -1399.5,
        -3377.348388671875,
        894.0
      ],
      [
        -1405.0,
        -3368.0,
        884.3972778320312
      ],
      [
        -1405.0,
        -3376.997314453125,
        894.0
      ],
      [
        -1373.0,
        -3398.71484375,
        915.0
      ],
      [
        -1373.0,
        -3379.03857421875,
        894.0
      ],
      [
        -1375.0,
        -3378.9111328125,
        894.0
      ],
      [
        -1375.0,
        -3398.587646484375,
        915.0
      ],
      [
        -1373.0,
        -3398.71484375,
        915.0
      ],
      [
        -1375.0,
        -3410.0,
        916.75
      ],
      [
        -1375.0,
        -3400.22705078125,
        916.75
      ],
      [
        -1401.5,
        -3377.220947265625,
        894.0
      ],
      [
        -1401.5,
        -3396.897216796875,
        915.0
      ],
      [
        -1399.5,
        -3397.024658203125,
        915.0
      ],
      [
        -1399.5,
        -3377.348388671875,
        894.0
      ],
      [
        -1401.5,
        -3396.897216796875,
        915.0
      ],
      [
        -1399.5,
        -3398.66455078125,
        916.75
      ],
      [
        -1399.5,
        -3407.23828125,
        916.75
      ],
      [
        -1397.5,
        -3400.431640625,
        918.5
      ],
      [
        -1377.0,
        -3401.739501953125,
        918.5
      ],
      [
        -1376.0,
        -3388.685302734375,
        904.5
      ],
      [
        -1379.0,
        -3398.332275390625,
        915.0
      ],
      [
        -1377.0,
        -3401.739501953125,
        918.5
      ],
      [
        -1397.5,
        -3400.431884765625,
        918.5
      ],
      [
        -1348.5267333984375,
        -3374.0,
        878.1983032226562
      ],
      [
        -1356.0,
        -3374.0,
        887.4649658203125
      ],
      [
        -1348.995361328125,
        -3374.0,
        886.9881591796875
      ],
      [
        -1356.0,
        -3374.0,
        887.4649658203125
      ],
      [
        -1356.0,
        -3368.0,
        878.1983032226562
      ],
      [
        -1356.0,
        -3368.0,
        881.0613403320312
      ],
      [
        -1356.0,
        -3366.0,
        878.9268188476562
      ],
      [
        -1349.946533203125,
        -3366.0,
        878.1983032226562
      ],
      [
        -1349.96337890625,
        -3366.0,
        878.515869140625
      ],
      [
        -1356.0,
        -3366.0,
        878.9268188476562
      ],
      [
        -1337.6041259765625,
        -3374.0,
        886.2127685546875
      ],
      [
        -1337.6041259765625,
        -3374.0,
        886.2127685546875
      ],
      [
        -1334.9947509765625,
        -3366.6572265625,
        878.1983032226562
      ],
      [
        -1345.2978515625,
        -3366.0,
        878.1983032226562
      ],
      [
        -1474.6434326171875,
        -3362.948486328125,
        884.6555786132812
      ],
      [
        -1357.415283203125,
        -3362.948486328125,
        878.5943603515625
      ],
      [
        -1350.0,
        -3362.948486328125,
        878.1983032226562
      ],
      [
        -1357.415283203125,
        -3362.948486328125,
        878.5943603515625
      ],
      [
        -1554.104736328125,
        -3378.35205078125,
        1302.5999755859375
      ],
      [
        -1595.0,
        -3370.693603515625,
        1301.2681884765625
      ],
      [
        -1595.0,
        -3370.693603515625,
        1301.2681884765625
      ],
      [
        -1595.0,
        -3368.889404296875,
        1301.6318359375
      ],
      [
        -1562.951171875,
        -3362.948486328125,
        1288.699462890625
      ],
      [
        -1594.4798583984375,
        -3362.948486328125,
        1302.5999755859375
      ],
      [
        -1595.0,
        -3364.086181640625,
        1302.5999755859375
      ],
      [
        -1346.0,
        -3368.0,
        912.0
      ],
      [
        -1335.471923828125,
        -3368.0,
        879.6638793945312
      ],
      [
        -1340.1395263671875,
        -3374.0,
        894.0
      ],
      [
        -1356.0,
        -3374.0,
        894.0
      ],
      [
        -1356.0,
        -3374.0,
        894.0
      ],
      [
        -1356.0,
        -3368.0,
        881.0613403320312
      ],
      [
        -1356.0,
        -3368.0,
        894.0
      ],
      [
        -1375.0,
        -3374.5,
        913.8333129882812
      ],
      [
        -1375.0,
        -3374.5,
        894.0
      ],
      [
        -1375.0,
        -3374.5,
        915.0
      ],
      [
        -1375.0,
        -3374.5,
        913.8333129882812
      ],
      [
        -1375.0,
        -3374.5,
        915.0
      ],
      [
        -1375.0,
        -3374.5,
        916.75
      ],
      [
        -1399.5,
        -3374.5,
        916.75
      ],
      [
        -1399.5,
        -3398.66455078125,
        916.75
      ],
      [
        -1399.5,
        -3374.5,
        912.8461303710938
      ],
      [
        -1399.5,
        -3374.5,
        894.0
      ],
      [
        -1399.5,
        -3374.5,
        915.0
      ],
      [
        -1399.5,
        -3374.5,
        912.8461303710938
      ],
      [
        -1399.5,
        -3374.5,
        915.0
      ],
      [
        -1399.5,
        -3374.5,
        916.75
      ],
      [
        -1356.0,
        -3368.0,
        912.0
      ],
      [
        -1356.0,
        -3368.0,
        912.0
      ],
      [
        -1346.0,
        -3368.0,
        912.0
      ],
      [
        -1555.170654296875,
        -3373.374755859375,
        1302.5999755859375
      ],
      [
        -1556.3189697265625,
        -3366.0,
        1302.5999755859375
      ],
      [
        -1556.447998046875,
        -3366.0,
        1301.4490966796875
      ],
      [
        -1556.447998046875,
        -3366.0,
        1301.4490966796875
      ],
      [
        -1558.5130615234375,
        -3366.0,
        1287.1690673828125
      ],
      [
        -1560.65283203125,
        -3366.0,
        1287.071044921875
      ],
      [
        -1560.994873046875,
        -3366.0,
        1287.221923828125
      ],
      [
        -1558.5130615234375,
        -3366.0,
        1287.1690673828125
      ],
      [
        -1560.65283203125,
        -3366.0,
        1287.071044921875
      ],
      [
        -1555.170654296875,
        -3373.374755859375,
        1302.5999755859375
      ],
      [
        -1554.104736328125,
        -3378.35205078125,
        1302.5999755859375
      ],
      [
        -1556.3770751953125,
        -3365.626953125,
        1302.5999755859375
      ],
      [
        -1557.062744140625,
        -3362.948486328125,
        1302.5999755859375
      ],
      [
        -1559.0848388671875,
        -3362.948486328125,
        1288.6171875
      ],
      [
        -1559.0848388671875,
        -3362.948486328125,
        1288.6171875
      ],
      [
        -1562.4183349609375,
        -3362.948486328125,
        1288.4644775390625
      ],
      [
        -1562.4183349609375,
        -3362.948486328125,
        1288.4644775390625
      ],
      [
        -1556.3770751953125,
        -3365.626953125,
        1302.5999755859375
      ],
      [
        -1474.6434326171875,
        -3362.948486328125,
        884.6555786132812
      ],
      [
        -1465.0,
        -3150.316162109375,
        918.0631713867188
      ],
      [
        -1356.0,
        -3323.0,
        878.485595703125
      ],
      [
        -1356.0,
        -3315.0,
        898.5742797851562
      ],
      [
        -1356.0,
        -3316.654541015625,
        895.3707275390625
      ],
      [
        -1356.0,
        -3315.0,
        898.5742797851562
      ],
      [
        -1352.5413818359375,
        -3315.0,
        878.1983032226562
      ],
      [
        -1352.5413818359375,
        -3315.0,
        895.8692626953125
      ],
      [
        -1350.031494140625,
        -3323.0,
        878.1983032226562
      ],
      [
        -1356.0,
        -3323.0,
        878.485595703125
      ],
      [
        -1350.0911865234375,
        -3323.0,
        878.4635009765625
      ],
      [
        -1350.031494140625,
        -3323.0,
        878.4168090820312
      ],
      [
        -1595.0,
        -3252.21533203125,
        1102.025146484375
      ],
      [
        -1595.0,
        -3325.190185546875,
        911.740966796875
      ],
      [
        -1595.0,
        -3252.21533203125,
        1102.025146484375
      ],
      [
        -1595.0,
        -3351.9326171875,
        912.8665771484375
      ],
      [
        -1595.0,
        -3325.190185546875,
        911.740966796875
      ],
      [
        -1595.0,
        -3351.9326171875,
        912.8665771484375
      ],
      [
        -1406.996826171875,
        -3344.551025390625,
        881.2424926757812
      ],
      [
        -1406.996826171875,
        -3344.551025390625,
        881.2424926757812
      ],
      [
        -1455.6510009765625,
        -3362.948486328125,
        883.673583984375
      ],
      [
        -1356.0,
        -3323.0,
        878.5187377929688
      ],
      [
        -1355.3331298828125,
        -3323.0,
        878.4830932617188
      ],
      [
        -1356.0,
        -3323.0,
        878.5187377929688
      ],
      [
        -1356.0,
        -3322.987548828125,
        878.5187377929688
      ],
      [
        -1356.0,
        -3323.0,
        883.0848388671875
      ],
      [
        -1356.0,
        -3323.0,
        883.0848388671875
      ],
      [
        -1184.539306640625,
        -3256.2646484375,
        878.1983032226562
      ],
      [
        -1203.061767578125,
        -3084.35595703125,
        1225.5303955078125
      ],
      [
        -1336.7191162109375,
        -3315.0,
        883.4945678710938
      ],
      [
        -1336.7191162109375,
        -3315.0,
        883.4945678710938
      ],
      [
        -1334.9947509765625,
        -3317.038818359375,
        878.1983032226562
      ],
      [
        -1349.7520751953125,
        -3323.0,
        878.1983032226562
      ],
      [
        -1136.8853759765625,
        -3314.0,
        891.5501708984375
      ],
      [
        -1141.1407470703125,
        -3314.0,
        878.1983032226562
      ],
      [
        -1126.9766845703125,
        -3314.0,
        878.1983032226562
      ],
      [
        -1133.4146728515625,
        -3322.0,
        878.1983032226562
      ],
      [
        -1135.127197265625,
        -3322.0,
        878.1983032226562
      ],
      [
        -1134.6126708984375,
        -3322.0,
        879.8126220703125
      ],
      [
        -1114.98486328125,
        -3348.796142578125,
        878.1983032226562
      ],
      [
        -1105.0,
        -3349.81982421875,
        907.113037109375
      ],
      [
        -1130.3677978515625,
        -3314.0,
        912.0
      ],
      [
        -1126.0,
        -3322.0,
        906.8359375
      ],
      [
        -1130.3677978515625,
        -3314.0,
        912.0
      ],
      [
        -1126.0,
        -3319.810546875,
        912.0
      ],
      [
        -1346.20458984375,
        -3323.0,
        878.1983032226562
      ],
      [
        -1350.003173828125,
        -3323.0,
        878.3947143554688
      ],
      [
        -1580.328125,
        -3331.9921875,
        1302.5999755859375
      ],
      [
        -1564.6063232421875,
        -3333.48291015625,
        1302.5999755859375
      ],
      [
        -1580.328125,
        -3331.9921875,
        1302.5999755859375
      ],
      [
        -1564.6063232421875,
        -3333.48291015625,
        1302.5999755859375
      ],
      [
        -1650.8538818359375,
        -3434.6806640625,
        1302.5999755859375
      ],
      [
        -1634.891845703125,
        -3372.7666015625,
        1302.5999755859375
      ],
      [
        -1597.9923095703125,
        -3370.631591796875,
        1302.5999755859375
      ],
      [
        -1634.891845703125,
        -3372.7666015625,
        1302.5999755859375
      ],
      [
        -1610.0,
        -3441.5,
        928.729736328125
      ],
      [
        -1624.5,
        -3441.5,
        930.1790161132812
      ],
      [
        -1610.0,
        -3441.5,
        1302.5999755859375
      ],
      [
        -1624.5,
        -3441.5,
        1302.5999755859375
      ],
      [
        -1610.0,
        -3427.677978515625,
        1000.0
      ],
      [
        -1610.0,
        -3441.5,
        928.729736328125
      ],
      [
        -1610.0,
        -3426.5,
        1302.5999755859375
      ],
      [
        -1610.0,
        -3441.5,
        1302.5999755859375
      ],
      [
        -1610.0,
        -3427.677978515625,
        1000.0
      ],
      [
        -1610.0,
        -3426.5,
        1006.07421875
      ],
      [
        -1624.5,
        -3441.5,
        930.1790161132812
      ],
      [
        -1624.5,
        -3427.959228515625,
        1000.0
      ],
      [
        -1624.5,
        -3441.5,
        1302.5999755859375
      ],
      [
        -1624.5,
        -3426.5,
        1302.5999755859375
      ],
      [
        -1624.5,
        -3426.5,
        1007.524658203125
      ],
      [
        -1624.5,
        -3427.959228515625,
        1000.0
      ],
      [
        -1624.5,
        -3426.5,
        1302.5999755859375
      ],
      [
        -1610.0,
        -3426.5,
        1302.5999755859375
      ],
      [
        -1610.0,
        -3426.5,
        1006.07421875
      ],
      [
        -1624.5,
        -3426.5,
        1007.524658203125
      ],
      [
        -1624.5,
        -3441.5,
        909.8519897460938
      ],
      [
        -1624.5,
        -3440.591064453125,
        915.0
      ],
      [
        -1624.5,
        -3426.5,
        994.8194580078125
      ],
      [
        -1624.5,
        -3440.591064453125,
        915.0
      ],
      [
        -1624.5,
        -3419.54296875,
        1043.3966064453125
      ],
      [
        -1624.5,
        -3418.408203125,
        1040.656005859375
      ],
      [
        -1610.0,
        -3439.752197265625,
        915.0
      ],
      [
        -1610.0,
        -3441.5,
        905.0992431640625
      ],
      [
        -1610.0,
        -3426.5,
        990.0665283203125
      ],
      [
        -1610.0,
        -3439.752197265625,
        915.0
      ],
      [
        -1610.0,
        -3419.54296875,
        1041.9466552734375
      ],
      [
        -1610.0,
        -3417.99951171875,
        1038.2188720703125
      ],
      [
        -1595.0,
        -3417.57666015625,
        1035.6976318359375
      ],
      [
        -1610.0,
        -3441.5,
        905.0992431640625
      ],
      [
        -1624.5,
        -3441.5,
        909.8519897460938
      ],
      [
        -1624.5,
        -3426.5,
        994.8194580078125
      ],
      [
        -1610.0,
        -3426.5,
        990.0665283203125
      ],
      [
        -1660.675537109375,
        -3373.532470703125,
        935.89306640625
      ],
      [
        -1660.675537109375,
        -3373.532470703125,
        935.89306640625
      ],
      [
        -1660.4217529296875,
        -3370.329833984375,
        927.6970825195312
      ],
      [
        -1595.0,
        -3366.591796875,
        912.5635375976562
      ],
      [
        -1660.4217529296875,
        -3370.329833984375,
        927.6970825195312
      ],
      [
        -1660.3753662109375,
        -3370.148193359375,
        927.6900634765625
      ],
      [
        -1659.8751220703125,
        -3368.18701171875,
        927.6143188476562
      ],
      [
        -1638.9671630859375,
        -3362.948486328125,
        922.8613891601562
      ],
      [
        -1595.0,
        -3362.948486328125,
        912.6388549804688
      ],
      [
        -1658.5599365234375,
        -3362.948486328125,
        927.1087036132812
      ],
      [
        -1638.9671630859375,
        -3362.948486328125,
        922.8613891601562
      ],
      [
        -1659.8751220703125,
        -3368.18701171875,
        927.6143188476562
      ],
      [
        -1597.9923095703125,
        -3370.631591796875,
        1302.5999755859375
      ],
      [
        -1760.0,
        -3455.78955078125,
        1064.9735107421875
      ],
      [
        -1650.8538818359375,
        -3434.6806640625,
        1302.5999755859375
      ],
      [
        -1739.9085693359375,
        -3467.27099609375,
        1302.5999755859375
      ],
      [
        -1760.0,
        -3471.65673828125,
        1265.1668701171875
      ],
      [
        -1760.0,
        -3471.65673828125,
        1265.1668701171875
      ],
      [
        -1739.9085693359375,
        -3467.27099609375,
        1302.5999755859375
      ],
      [
        -1760.0,
        -3491.47998046875,
        1302.5999755859375
      ],
      [
        -1760.0,
        -3412.328125,
        1019.3680419921875
      ],
      [
        -1760.0,
        -3383.83349609375,
        951.1689453125
      ],
      [
        -1760.0,
        -3455.78955078125,
        1064.9735107421875
      ],
      [
        -1760.0,
        -3412.328125,
        1019.3680419921875
      ],
      [
        -1660.37548828125,
        -3370.148193359375,
        927.6900634765625
      ],
      [
        -1660.1552734375,
        -3369.285400390625,
        927.65673828125
      ],
      [
        -1671.2335205078125,
        -3362.948486328125,
        929.8560791015625
      ],
      [
        -1760.0,
        -3383.83349609375,
        951.1689453125
      ],
      [
        -1760.0,
        -3362.948486328125,
        950.2378540039062
      ],
      [
        -1671.2335205078125,
        -3362.948486328125,
        929.8560791015625
      ],
      [
        -1760.0,
        -3340.234130859375,
        948.6456909179688
      ],
      [
        -1760.0,
        -3244.978515625,
        1192.2745361328125
      ],
      [
        -1595.0,
        -3326.055419921875,
        911.7774047851562
      ],
      [
        -1760.0,
        -3203.987060546875,
        1302.5999755859375
      ],
      [
        -1760.0,
        -3244.978515625,
        1192.2745361328125
      ],
      [
        -1760.0,
        -3357.116455078125,
        949.9778442382812
      ],
      [
        -1760.0,
        -3340.234130859375,
        948.6456909179688
      ],
      [
        -1760.0,
        -3357.116455078125,
        949.9778442382812
      ],
      [
        -823.8580932617188,
        -3924.0,
        660.0
      ],
      [
        -832.831787109375,
        -3924.0,
        536.4684448242188
      ],
      [
        -854.8887939453125,
        -3924.0,
        267.0
      ],
      [
        -832.831787109375,
        -3924.0,
        536.4684448242188
      ],
      [
        -835.9223022460938,
        -3730.0,
        925.9322509765625
      ],
      [
        -859.2266845703125,
        -3730.0,
        660.0
      ],
      [
        -835.9223022460938,
        -3730.0,
        925.9322509765625
      ],
      [
        -798.61328125,
        -3730.0,
        1302.5999755859375
      ],
      [
        -703.2801513671875,
        -3802.730224609375,
        1529.0736083984375
      ],
      [
        -728.6499633789062,
        -3800.96044921875,
        1302.5999755859375
      ],
      [
        -702.8775634765625,
        -3802.547119140625,
        1534.9000244140625
      ],
      [
        -703.2801513671875,
        -3802.730224609375,
        1529.0736083984375
      ],
      [
        -1100.0,
        -2963.177978515625,
        1363.51953125
      ],
      [
        -1100.0,
        -2955.145751953125,
        1371.78515625
      ],
      [
        -1100.0,
        -2963.177978515625,
        1363.51953125
      ],
      [
        -1100.0,
        -3017.20947265625,
        1302.5999755859375
      ],
      [
        -1100.0,
        -2856.87744140625,
        1472.906982421875
      ],
      [
        -1100.0,
        -2789.423828125,
        1534.9000244140625
      ],
      [
        -1100.0,
        -2856.87744140625,
        1472.906982421875
      ],
      [
        -664.7411499023438,
        -2911.618408203125,
        1340.847412109375
      ],
      [
        -1552.1339111328125,
        -3027.011962890625,
        1501.2713623046875
      ],
      [
        -1583.84765625,
        -3013.635498046875,
        1534.9000244140625
      ],
      [
        -1509.300537109375,
        -3106.068359375,
        1384.676025390625
      ],
      [
        -1552.1339111328125,
        -3027.011962890625,
        1501.2713623046875
      ],
      [
        -1509.300537109375,
        -3106.068359375,
        1384.676025390625
      ],
      [
        -1760.0,
        -3203.987060546875,
        1302.5999755859375
      ],
      [
        -1760.0,
        -3105.5673828125,
        1459.6031494140625
      ],
      [
        -1760.0,
        -3059.423095703125,
        1534.9000244140625
      ],
      [
        -1760.0,
        -3105.5673828125,
        1459.6031494140625
      ],
      [
        -1203.6212158203125,
        -2901.427490234375,
        1449.8204345703125
      ],
      [
        -1203.6212158203125,
        -2901.427490234375,
        1449.8204345703125
      ],
      [
        -1167.873291015625,
        -2811.119384765625,
        1534.9000244140625
      ],
      [
        -1760.0,
        -3630.6875,
        1574.9000244140625
      ],
      [
        -1760.0,
        -3542.7783203125,
        1393.7564697265625
      ],
      [
        -1642.5057373046875,
        -3443.77099609375,
        1455.83544921875
      ],
      [
        -1727.3770751953125,
        -3462.68505859375,
        1302.5999755859375
      ],
      [
        -1149.1082763671875,
        -3646.800048828125,
        1310.0009765625
      ],
      [
        -1544.5638427734375,
        -3476.309326171875,
        1552.2672119140625
      ],
      [
        -1545.34130859375,
        -3478.544677734375,
        1557.0006103515625
      ],
      [
        -1544.5638427734375,
        -3476.309326171875,
        1552.2672119140625
      ],
      [
        -1612.5,
        -3450.0,
        1476.5452880859375
      ],
      [
        -1583.53759765625,
        -3450.0,
        1484.06494140625
      ],
      [
        -1571.8751220703125,
        -3450.0,
        1485.0
      ],
      [
        -1559.0,
        -3449.582763671875,
        1485.0
      ],
      [
        -1559.0,
        -3441.5,
        1465.0074462890625
      ],
      [
        -1559.0,
        -3441.5,
        1459.0
      ],
      [
        -1612.5,
        -3442.05322265625,
        1459.0
      ],
      [
        -1612.5,
        -3450.0,
        1476.5447998046875
      ],
      [
        -1571.8751220703125,
        -3450.0,
        1485.0
      ],
      [
        -1559.0,
        -3449.582763671875,
        1485.0
      ],
      [
        -1601.564453125,
        -3452.543701171875,
        1485.0
      ],
      [
        -1607.0,
        -3453.182861328125,
        1485.0
      ],
      [
        -1601.564453125,
        -3452.543701171875,
        1485.0
      ],
      [
        -1599.0999755859375,
        -3479.5,
        1484.6571044921875
      ],
      [
        -1599.5999755859375,
        -3479.5,
        1484.6571044921875
      ],
      [
        -1590.4000244140625,
        -3479.5,
        1484.6571044921875
      ],
      [
        -1589.9000244140625,
        -3479.5,
        1484.6571044921875
      ],
      [
        -1601.0,
        -3459.271484375,
        1500.0
      ],
      [
        -1602.0289306640625,
        -3458.227294921875,
        1497.4276123046875
      ],
      [
        -1607.0,
        -3453.182861328125,
        1485.0
      ],
      [
        -1602.0291748046875,
        -3458.227294921875,
        1497.42724609375
      ],
      [
        -1596.2305908203125,
        -3458.710693359375,
        1500.0
      ],
      [
        -1601.0,
        -3459.271728515625,
        1500.0
      ],
      [
        -1596.2305908203125,
        -3458.710693359375,
        1500.0
      ],
      [
        -1580.0,
        -3542.5,
        1493.800048828125
      ],
      [
        -1580.0,
        -3535.0,
        1493.800048828125
      ],
      [
        -1582.767822265625,
        -3525.5,
        1500.0
      ],
      [
        -1582.767822265625,
        -3526.0,
        1500.0
      ],
      [
        -1582.5445556640625,
        -3525.5,
        1499.5
      ],
      [
        -1582.767822265625,
        -3525.5,
        1500.0
      ],
      [
        -1582.5445556640625,
        -3526.0,
        1499.5
      ],
      [
        -1582.5445556640625,
        -3525.5,
        1499.5
      ],
      [
        -1577.6470947265625,
        -3535.0,
        1488.5294189453125
      ],
      [
        -1577.6470947265625,
        -3542.5,
        1488.5294189453125
      ],
      [
        -1580.0,
        -3535.0,
        1493.800048828125
      ],
      [
        -1577.6470947265625,
        -3535.0,
        1488.5294189453125
      ],
      [
        -1577.6470947265625,
        -3542.5,
        1488.5294189453125
      ],
      [
        -1580.0,
        -3542.5,
        1493.800048828125
      ],
      [
        -1607.2320556640625,
        -3526.0,
        1500.0
      ],
      [
        -1607.2320556640625,
        -3525.5,
        1500.0
      ],
      [
        -1607.2320556640625,
        -3525.5,
        1500.0
      ],
      [
        -1607.45556640625,
        -3525.5,
        1499.5
      ],
      [
        -1607.45556640625,
        -3525.5,
        1499.5
      ],
      [
        -1607.45556640625,
        -3526.0,
        1499.5
      ],
      [
        -1586.0,
        -3529.9716796875,
        1494.4000244140625
      ],
      [
        -1585.0,
        -3535.0,
        1494.4000244140625
      ],
      [
        -1586.0,
        -3529.9716796875,
        1494.4000244140625
      ],
      [
        -1586.0,
        -3529.9716796875,
        1494.4000244140625
      ],
      [
        -1590.0,
        -3529.9716796875,
        1494.4000244140625
      ],
      [
        -1590.0,
        -3529.9716796875,
        1494.4000244140625
      ],
      [
        -1590.0,
        -3535.0,
        1494.4000244140625
      ],
      [
        -1586.0,
        -3529.9716796875,
        1489.5999755859375
      ],
      [
        -1586.0,
        -3529.9716796875,
        1482.5999755859375
      ],
      [
        -1586.0,
        -3529.9716796875,
        1489.5999755859375
      ],
      [
        -1590.0,
        -3529.9716796875,
        1489.5999755859375
      ],
      [
        -1590.0,
        -3529.9716796875,
        1482.5999755859375
      ],
      [
        -1590.0,
        -3529.9716796875,
        1489.5999755859375
      ],
      [
        -1590.5,
        -3521.79736328125,
        1486.5999755859375
      ],
      [
        -1590.4700927734375,
        -3521.75244140625,
        1486.030517578125
      ],
      [
        -1590.4700927734375,
        -3521.75244140625,
        1486.8248291015625
      ],
      [
        -1590.5,
        -3521.79736328125,
        1486.5999755859375
      ],
      [
        -1591.1820068359375,
        -3522.818115234375,
        1485.91650390625
      ],
      [
        -1589.0499267578125,
        -3521.708740234375,
        1482.5999755859375
      ],
      [
        -1589.0,
        -3521.360107421875,
        1489.199951171875
      ],
      [
        -1589.5,
        -3521.694091796875,
        1483.300048828125
      ],
      [
        -1588.65673828125,
        -3521.130615234375,
        1483.13134765625
      ],
      [
        -1588.6566162109375,
        -3521.130615234375,
        1489.1754150390625
      ],
      [
        -1589.0,
        -3521.360107421875,
        1489.199951171875
      ],
      [
        -1587.5999755859375,
        -3521.420654296875,
        1489.0999755859375
      ],
      [
        -1586.7431640625,
        -3521.25,
        1483.38671875
      ],
      [
        -1586.7427978515625,
        -3521.25,
        1488.7882080078125
      ],
      [
        -1587.5999755859375,
        -3521.420654296875,
        1489.0999755859375
      ],
      [
        -1585.4388427734375,
        -3522.4033203125,
        1485.13427734375
      ],
      [
        -1584.8179931640625,
        -3522.818115234375,
        1485.9881591796875
      ],
      [
        -1585.4388427734375,
        -3522.4033203125,
        1485.13427734375
      ],
      [
        -1587.2816162109375,
        -3521.642822265625,
        1482.5999755859375
      ],
      [
        -1586.5,
        -3521.694091796875,
        1488.699951171875
      ],
      [
        -1586.5,
        -3521.694091796875,
        1488.699951171875
      ],
      [
        -1587.068115234375,
        -3521.314697265625,
        1488.906494140625
      ],
      [
        -1600.0,
        -3481.5419921875,
        1483.5999755859375
      ],
      [
        -1589.5,
        -3481.5419921875,
        1483.5999755859375
      ],
      [
        -1600.0,
        -3480.083251953125,
        1484.5999755859375
      ],
      [
        -1589.5,
        -3480.083251953125,
        1484.5999755859375
      ],
      [
        -1599.0999755859375,
        -3480.08349609375,
        1484.5999755859375
      ],
      [
        -1599.0999755859375,
        -3479.583251953125,
        1484.5999755859375
      ],
      [
        -1599.5999755859375,
        -3479.583251953125,
        1484.5999755859375
      ],
      [
        -1599.5999755859375,
        -3480.08349609375,
        1484.5999755859375
      ],
      [
        -1590.4000244140625,
        -3479.583251953125,
        1484.5999755859375
      ],
      [
        -1590.4000244140625,
        -3480.08349609375,
        1484.5999755859375
      ],
      [
        -1589.9000244140625,
        -3480.08349609375,
        1484.5999755859375
      ],
      [
        -1589.9000244140625,
        -3479.583251953125,
        1484.5999755859375
      ],
      [
        -1599.0999755859375,
        -3481.541748046875,
        1483.5999755859375
      ],
      [
        -1599.0999755859375,
        -3481.041748046875,
        1483.5999755859375
      ],
      [
        -1599.5999755859375,
        -3481.041748046875,
        1483.5999755859375
      ],
      [
        -1599.5999755859375,
        -3481.541748046875,
        1483.5999755859375
      ],
      [
        -1599.5999755859375,
        -3481.0,
        1483.5999755859375
      ],
      [
        -1599.0999755859375,
        -3481.0,
        1483.5999755859375
      ],
      [
        -1599.0999755859375,
        -3481.0,
        1483.9715576171875
      ],
      [
        -1599.5999755859375,
        -3481.0,
        1483.9715576171875
      ],
      [
        -1600.0,
        -3481.0,
        1483.9715576171875
      ],
      [
        -1589.5,
        -3481.0,
        1483.9715576171875
      ],
      [
        -1590.4000244140625,
        -3481.041748046875,
        1483.5999755859375
      ],
      [
        -1590.4000244140625,
        -3481.0,
        1483.6285400390625
      ],
      [
        -1590.4000244140625,
        -3481.0,
        1483.971435546875
      ],
      [
        -1590.4000244140625,
        -3481.541748046875,
        1483.5999755859375
      ],
      [
        -1589.9000244140625,
        -3481.541748046875,
        1483.5999755859375
      ],
      [
        -1589.9000244140625,
        -3481.0,
        1483.971435546875
      ],
      [
        -1589.9000244140625,
        -3481.0,
        1483.6285400390625
      ],
      [
        -1589.9000244140625,
        -3481.041748046875,
        1483.5999755859375
      ],
      [
        -1599.5999755859375,
        -3482.5,
        1482.5999755859375
      ],
      [
        -1599.0999755859375,
        -3482.5,
        1482.5999755859375
      ],
      [
        -1599.0999755859375,
        -3482.5,
        1482.94287109375
      ],
      [
        -1599.5999755859375,
        -3482.5,
        1482.94287109375
      ],
      [
        -1600.0,
        -3482.5,
        1482.94287109375
      ],
      [
        -1589.5,
        -3482.5,
        1482.94287109375
      ],
      [
        -1590.4000244140625,
        -3482.5,
        1482.94287109375
      ],
      [
        -1589.9000244140625,
        -3482.5,
        1482.94287109375
      ],
      [
        -1606.6990966796875,
        -3463.709716796875,
        1516.119384765625
      ],
      [
        -1599.9825439453125,
        -3465.617431640625,
        1521.376708984375
      ],
      [
        -1599.9825439453125,
        -3465.617431640625,
        1521.376708984375
      ],
      [
        -1545.34130859375,
        -3478.544677734375,
        1557.0006103515625
      ],
      [
        -1547.08447265625,
        -3480.6474609375,
        1562.79541015625
      ],
      [
        -1607.0,
        -3452.4169921875,
        1485.0
      ],
      [
        -1612.5,
        -3450.0,
        1478.339111328125
      ],
      [
        -1612.5,
        -3447.601806640625,
        1471.25048828125
      ],
      [
        -1612.5,
        -3447.427734375,
        1471.25048828125
      ],
      [
        -1612.5,
        -3450.0,
        1478.3394775390625
      ],
      [
        -1609.6644287109375,
        -3450.0,
        1478.3394775390625
      ],
      [
        -1610.1365966796875,
        -3450.0,
        1477.158935546875
      ],
      [
        -1607.0,
        -3452.4169921875,
        1485.0
      ],
      [
        -1601.8800048828125,
        -3452.4169921875,
        1485.0
      ],
      [
        -1600.48681640625,
        -3452.4169921875,
        1485.0
      ],
      [
        -1601.8800048828125,
        -3452.4169921875,
        1485.0
      ],
      [
        -1605.5894775390625,
        -3450.0,
        1478.3394775390625
      ],
      [
        -1612.5,
        -3446.725341796875,
        1469.315185546875
      ],
      [
        -1612.5,
        -3450.0,
        1481.7430419921875
      ],
      [
        -1612.5,
        -3441.5,
        1459.0
      ],
      [
        -1612.5,
        -3441.5,
        1460.718017578125
      ],
      [
        -1612.5,
        -3450.0,
        1481.7430419921875
      ],
      [
        -1605.2076416015625,
        -3451.080322265625,
        1485.0
      ],
      [
        -1607.0,
        -3451.138427734375,
        1485.0
      ],
      [
        -1605.2076416015625,
        -3451.080322265625,
        1485.0
      ],
      [
        -1605.0526123046875,
        -3456.615234375,
        1498.7030029296875
      ],
      [
        -1606.6990966796875,
        -3463.709716796875,
        1516.119384765625
      ],
      [
        -1604.3778076171875,
        -3453.70361328125,
        1491.5555419921875
      ],
      [
        -1607.0,
        -3451.138427734375,
        1485.0
      ],
      [
        -1604.13623046875,
        -3453.93994140625,
        1492.159423828125
      ],
      [
        -1604.13623046875,
        -3453.93994140625,
        1492.159423828125
      ],
      [
        -1605.0526123046875,
        -3456.615234375,
        1498.7030029296875
      ],
      [
        -1624.5,
        -3435.847412109375,
        1439.0
      ],
      [
        -1624.5,
        -3437.151611328125,
        1449.0
      ],
      [
        -1624.5,
        -3436.51513671875,
        1447.4259033203125
      ],
      [
        -1624.5,
        -3428.793212890625,
        1350.0
      ],
      [
        -1624.5,
        -3435.847412109375,
        1439.0
      ],
      [
        -1624.5,
        -3428.793212890625,
        1350.0
      ],
      [
        -1624.5,
        -3426.5,
        1321.0653076171875
      ],
      [
        -1610.0,
        -3436.681640625,
        1449.0
      ],
      [
        -1610.0,
        -3432.638916015625,
        1439.0
      ],
      [
        -1610.0,
        -3426.5,
        1388.013671875
      ],
      [
        -1610.0,
        -3430.029541015625,
        1432.5452880859375
      ],
      [
        -1610.0,
        -3432.638916015625,
        1439.0
      ],
      [
        -1550.0,
        -3439.0,
        1459.5447998046875
      ],
      [
        -1556.7967529296875,
        -3439.0,
        1459.0
      ],
      [
        -1550.0,
        -3439.0,
        1459.5447998046875
      ],
      [
        -1549.7508544921875,
        -3438.771728515625,
        1459.0
      ],
      [
        -1559.0,
        -3439.0712890625,
        1459.0
      ],
      [
        -1610.0,
        -3426.5,
        1388.01220703125
      ],
      [
        -1618.233154296875,
        -3426.5,
        1350.0
      ],
      [
        -1624.5,
        -3426.5,
        1321.0653076171875
      ],
      [
        -1618.233154296875,
        -3426.5,
        1350.0
      ],
      [
        -1624.5,
        -3437.151611328125,
        1449.0
      ],
      [
        -1610.0,
        -3436.681640625,
        1449.0
      ],
      [
        -1612.5,
        -3440.805419921875,
        1459.0
      ],
      [
        -1631.7432861328125,
        -3446.90087890625,
        1486.6585693359375
      ],
      [
        -1630.755126953125,
        -3445.17919921875,
        1485.3487548828125
      ],
      [
        -1612.5,
        -3439.0,
        1478.286865234375
      ],
      [
        -1612.5,
        -3449.0400390625,
        1485.0
      ],
      [
        -1608.5008544921875,
        -3450.0,
        1485.0
      ],
      [
        -1596.30126953125,
        -3450.0,
        1483.041748046875
      ],
      [
        -1559.0,
        -3439.0,
        1469.6993408203125
      ],
      [
        -1559.0,
        -3445.02587890625,
        1473.7283935546875
      ],
      [
        -1610.0,
        -3431.333740234375,
        1449.0
      ],
      [
        -1610.0,
        -3430.541259765625,
        1439.0
      ],
      [
        -1610.0,
        -3430.541015625,
        1439.0
      ],
      [
        -1608.5008544921875,
        -3450.0,
        1485.0
      ],
      [
        -1610.0,
        -3450.0,
        1485.0
      ],
      [
        -1610.0,
        -3449.64013671875,
        1485.0
      ],
      [
        -1612.5,
        -3436.7626953125,
        1449.0
      ],
      [
        -1610.0,
        -3431.333740234375,
        1449.0
      ],
      [
        -1612.5,
        -3432.24853515625,
        1449.0
      ],
      [
        -1612.5,
        -3449.0400390625,
        1485.0
      ],
      [
        -1559.0,
        -3439.0,
        1469.6993408203125
      ],
      [
        -1550.0,
        -3439.0,
        1468.2545166015625
      ],
      [
        -1550.0,
        -3439.0,
        1468.2545166015625
      ],
      [
        -1545.71533203125,
        -3435.072265625,
        1464.9405517578125
      ],
      [
        -1545.445556640625,
        -3434.824951171875,
        1459.0
      ],
      [
        -1604.143310546875,
        -3451.0458984375,
        1485.0
      ],
      [
        -1606.7406005859375,
        -3451.39208984375,
        1485.6484375
      ],
      [
        -1620.0,
        -3439.0,
        1479.4906005859375
      ],
      [
        -1612.5,
        -3439.0,
        1478.2867431640625
      ],
      [
        -1620.0,
        -3439.0,
        1479.4906005859375
      ],
      [
        -1622.506103515625,
        -3436.702880859375,
        1459.0
      ],
      [
        -1621.2755126953125,
        -3437.830810546875,
        1478.91357421875
      ],
      [
        -1622.1014404296875,
        -3437.073974609375,
        1449.0
      ],
      [
        -1623.1239013671875,
        -3436.13623046875,
        1449.0
      ],
      [
        -1624.5,
        -3436.639892578125,
        1449.0
      ],
      [
        -1624.5,
        -3436.639892578125,
        1449.0
      ],
      [
        -1621.04296875,
        -3438.0439453125,
        1482.6754150390625
      ],
      [
        -1627.84814453125,
        -3441.50439453125,
        1484.3602294921875
      ],
      [
        -1626.8880615234375,
        -3440.290771484375,
        1484.0338134765625
      ],
      [
        -1545.8719482421875,
        -3435.216064453125,
        1468.3966064453125
      ],
      [
        -1627.84814453125,
        -3441.50439453125,
        1484.3602294921875
      ],
      [
        -1630.5223388671875,
        -3444.884765625,
        1485.26953125
      ],
      [
        -1630.755126953125,
        -3445.17919921875,
        1485.3487548828125
      ],
      [
        -1630.5223388671875,
        -3444.884765625,
        1485.26953125
      ],
      [
        -1620.0,
        -3439.0,
        1482.5989990234375
      ],
      [
        -1612.5,
        -3439.0,
        1481.2088623046875
      ],
      [
        -1559.0,
        -3439.0,
        1471.2928466796875
      ],
      [
        -1550.0,
        -3439.0,
        1469.6246337890625
      ],
      [
        -1550.0,
        -3439.0,
        1469.6246337890625
      ],
      [
        -1545.8721923828125,
        -3435.216064453125,
        1468.396484375
      ],
      [
        -1620.0,
        -3439.0,
        1482.5989990234375
      ],
      [
        -1621.0430908203125,
        -3438.0439453125,
        1482.6754150390625
      ],
      [
        -1612.5,
        -3439.0,
        1481.2088623046875
      ],
      [
        -1612.5,
        -3444.34912109375,
        1481.863525390625
      ],
      [
        -1559.0,
        -3439.0,
        1471.2928466796875
      ],
      [
        -1559.0,
        -3441.917236328125,
        1471.6497802734375
      ],
      [
        -1550.725830078125,
        -3485.0400390625,
        1574.9000244140625
      ],
      [
        -1631.5953369140625,
        -3448.461181640625,
        1490.208740234375
      ],
      [
        -1606.95751953125,
        -3450.529296875,
        1485.106201171875
      ],
      [
        -1604.3778076171875,
        -3453.70361328125,
        1491.555419921875
      ],
      [
        -1603.75927734375,
        -3451.033447265625,
        1485.0
      ],
      [
        -1605.2906494140625,
        -3450.7705078125,
        1485.0
      ],
      [
        -1580.8638916015625,
        -3450.0,
        1484.2794189453125
      ],
      [
        -1604.011474609375,
        -3450.0,
        1484.2794189453125
      ],
      [
        -1559.0,
        -3444.5732421875,
        1473.4256591796875
      ],
      [
        -1559.0,
        -3446.298583984375,
        1476.8763427734375
      ],
      [
        -1618.372314453125,
        -3439.0,
        1500.6595458984375
      ],
      [
        -1620.0,
        -3439.0,
        1496.973388671875
      ],
      [
        -1552.0589599609375,
        -3439.0,
        1500.424560546875
      ],
      [
        -1550.0,
        -3439.0,
        1497.6932373046875
      ],
      [
        -1617.0968017578125,
        -3439.0,
        1503.54833984375
      ],
      [
        -1618.372314453125,
        -3439.0,
        1500.6595458984375
      ],
      [
        -1552.0589599609375,
        -3439.0,
        1500.424560546875
      ],
      [
        -1554.625244140625,
        -3439.0,
        1503.8291015625
      ],
      [
        -1617.0968017578125,
        -3439.0,
        1503.54833984375
      ],
      [
        -1616.455810546875,
        -3439.0,
        1505.0
      ],
      [
        -1555.5079345703125,
        -3439.0,
        1505.0
      ],
      [
        -1554.625244140625,
        -3439.0,
        1503.8291015625
      ],
      [
        -1555.5079345703125,
        -3439.0,
        1505.0
      ],
      [
        -1616.455810546875,
        -3439.0,
        1505.0
      ],
      [
        -1614.5399169921875,
        -3437.538818359375,
        1506.3282470703125
      ],
      [
        -1586.596435546875,
        -3428.0,
        1515.0
      ],
      [
        -1586.5509033203125,
        -3428.0,
        1515.0
      ],
      [
        -1569.154052734375,
        -3431.94287109375,
        1511.4156494140625
      ],
      [
        -1586.5509033203125,
        -3428.0,
        1515.0
      ],
      [
        -1586.596435546875,
        -3428.0,
        1515.0
      ],
      [
        -1586.5784912109375,
        -3427.993408203125,
        1515.0
      ],
      [
        -1586.5,
        -3426.439697265625,
        1485.0
      ],
      [
        -1602.5,
        -3431.4423828125,
        1485.0
      ],
      [
        -1587.912841796875,
        -3426.104248046875,
        1485.0
      ],
      [
        -1546.6260986328125,
        -3435.9072265625,
        1485.0
      ],
      [
        -1620.8994140625,
        -3438.175537109375,
        1485.0
      ],
      [
        -1600.551025390625,
        -3431.5,
        1494.7261962890625
      ],
      [
        -1602.5,
        -3431.5,
        1485.7269287109375
      ],
      [
        -1600.0587158203125,
        -3431.5,
        1497.0
      ],
      [
        -1600.551025390625,
        -3431.5,
        1494.7261962890625
      ],
      [
        -1546.6260986328125,
        -3435.9072265625,
        1485.0
      ],
      [
        -1550.0,
        -3439.0,
        1497.6932373046875
      ],
      [
        -1546.78759765625,
        -3436.055419921875,
        1488.55517578125
      ],
      [
        -1620.0,
        -3439.0,
        1496.973388671875
      ],
      [
        -1620.8994140625,
        -3438.175537109375,
        1485.0
      ],
      [
        -1620.214599609375,
        -3438.80322265625,
        1496.0819091796875
      ],
      [
        -1585.0,
        -3427.51806640625,
        1498.785888671875
      ],
      [
        -1585.0,
        -3426.874267578125,
        1486.5
      ],
      [
        -1585.0,
        -3427.529296875,
        1499.0
      ],
      [
        -1585.0,
        -3427.51806640625,
        1498.785888671875
      ],
      [
        -1585.0,
        -3427.529296875,
        1499.0
      ],
      [
        -1585.0,
        -3427.8125,
        1504.4000244140625
      ],
      [
        -1585.0,
        -3427.8125,
        1504.4000244140625
      ],
      [
        -1585.0,
        -3428.0,
        1507.9754638671875
      ],
      [
        -1600.0587158203125,
        -3431.5,
        1497.0
      ],
      [
        -1586.5,
        -3427.068603515625,
        1497.0
      ],
      [
        -1587.3790283203125,
        -3426.85986328125,
        1497.0
      ],
      [
        -1586.5,
        -3427.031005859375,
        1496.2850341796875
      ],
      [
        -1586.5,
        -3426.47119140625,
        1485.603515625
      ],
      [
        -1586.5,
        -3426.47119140625,
        1485.603515625
      ],
      [
        -1586.5,
        -3426.439697265625,
        1485.0
      ],
      [
        -1586.5,
        -3427.068603515625,
        1497.0
      ],
      [
        -1586.5,
        -3427.031005859375,
        1496.2850341796875
      ],
      [
        -1602.5,
        -3431.5,
        1485.7269287109375
      ],
      [
        -1602.5,
        -3431.4423828125,
        1485.0
      ],
      [
        -1584.2105712890625,
        -3428.0,
        1504.4000244140625
      ],
      [
        -1583.01806640625,
        -3428.0,
        1499.0
      ],
      [
        -1585.0,
        -3428.0,
        1507.9754638671875
      ],
      [
        -1584.2105712890625,
        -3428.0,
        1504.4000244140625
      ],
      [
        -1583.01806640625,
        -3428.0,
        1499.0
      ],
      [
        -1580.2593994140625,
        -3428.0,
        1486.5
      ],
      [
        -1580.2593994140625,
        -3428.0,
        1486.5
      ],
      [
        -1585.0,
        -3426.874267578125,
        1486.5
      ],
      [
        -1631.7432861328125,
        -3446.90087890625,
        1486.6585693359375
      ],
      [
        -1631.5953369140625,
        -3448.461181640625,
        1490.208740234375
      ],
      [
        -1534.7191162109375,
        -3409.7333984375,
        1302.5999755859375
      ],
      [
        -1568.787109375,
        -3428.0,
        1504.4000244140625
      ],
      [
        -1564.7166748046875,
        -3428.0,
        1499.0
      ],
      [
        -1576.024169921875,
        -3428.0,
        1514.0
      ],
      [
        -1568.787109375,
        -3428.0,
        1504.4000244140625
      ],
      [
        -1564.7166748046875,
        -3428.0,
        1499.0
      ],
      [
        -1555.2939453125,
        -3428.0,
        1486.5
      ],
      [
        -1545.5377197265625,
        -3434.90966796875,
        1485.0
      ],
      [
        -1545.5377197265625,
        -3434.90966796875,
        1485.0
      ],
      [
        -1542.9244384765625,
        -3432.51416015625,
        1477.566162109375
      ],
      [
        -1540.9151611328125,
        -3430.672119140625,
        1459.0
      ],
      [
        -1576.7779541015625,
        -3428.0,
        1515.0
      ],
      [
        -1541.8011474609375,
        -3431.484375,
        1467.1854248046875
      ],
      [
        -1555.2939453125,
        -3428.0,
        1486.5
      ],
      [
        -1585.0,
        -3425.156982421875,
        1486.5
      ],
      [
        -1570.6143798828125,
        -3419.892333984375,
        1486.5
      ],
      [
        -1556.5234375,
        -3427.01513671875,
        1486.5
      ],
      [
        -1586.5,
        -3425.587158203125,
        1485.0
      ],
      [
        -1586.5,
        -3426.51806640625,
        1486.5
      ],
      [
        -1586.5,
        -3425.642822265625,
        1485.702880859375
      ],
      [
        -1586.5,
        -3425.7060546875,
        1486.5
      ],
      [
        -1586.5,
        -3425.642822265625,
        1485.702880859375
      ],
      [
        -1586.5,
        -3425.587158203125,
        1485.0
      ],
      [
        -1570.442138671875,
        -3428.0,
        1506.594970703125
      ],
      [
        -1569.0,
        -3423.059326171875,
        1496.5
      ],
      [
        -1569.0,
        -3423.059326171875,
        1496.5
      ],
      [
        -1562.8321533203125,
        -3428.0,
        1496.5
      ],
      [
        -1585.0,
        -3426.080078125,
        1498.146728515625
      ],
      [
        -1585.0,
        -3425.15673828125,
        1486.5
      ],
      [
        -1585.0,
        -3426.147705078125,
        1499.0
      ],
      [
        -1585.0,
        -3426.080078125,
        1498.146728515625
      ],
      [
        -1585.0,
        -3426.147705078125,
        1499.0
      ],
      [
        -1585.0,
        -3426.57568359375,
        1504.4000244140625
      ],
      [
        -1585.0,
        -3426.57568359375,
        1504.4000244140625
      ],
      [
        -1585.0,
        -3427.33642578125,
        1514.0
      ],
      [
        -1586.5,
        -3426.474365234375,
        1496.1959228515625
      ],
      [
        -1586.5,
        -3426.5380859375,
        1497.0
      ],
      [
        -1586.5,
        -3426.474365234375,
        1496.1959228515625
      ],
      [
        -1585.0,
        -3428.0,
        1515.0
      ],
      [
        -1586.5,
        -3428.0,
        1515.0
      ],
      [
        -1586.5,
        -3427.964599609375,
        1515.0
      ],
      [
        -1585.0,
        -3427.415771484375,
        1515.0
      ],
      [
        -1586.5,
        -3426.5380859375,
        1497.0
      ],
      [
        -1576.024169921875,
        -3428.0,
        1514.0
      ],
      [
        -1579.4073486328125,
        -3425.289794921875,
        1514.0
      ],
      [
        -1585.0,
        -3427.33642578125,
        1514.0
      ],
      [
        -1576.7779541015625,
        -3428.0,
        1515.0
      ],
      [
        -1579.8568115234375,
        -3425.53369140625,
        1515.0
      ],
      [
        -1642.5057373046875,
        -3443.77099609375,
        1455.83544921875
      ],
      [
        -1637.2723388671875,
        -3382.0,
        1302.5999755859375
      ],
      [
        -1634.29931640625,
        -3382.0,
        1345.208984375
      ],
      [
        -1634.7877197265625,
        -3386.785888671875,
        1355.8927001953125
      ],
      [
        -1624.5,
        -3420.6640625,
        1449.0
      ],
      [
        -1624.5,
        -3415.81103515625,
        1439.0
      ],
      [
        -1624.5,
        -3426.5,
        1461.025390625
      ],
      [
        -1624.5,
        -3420.6640625,
        1449.0
      ],
      [
        -1624.5,
        -3434.875244140625,
        1459.0
      ],
      [
        -1629.142333984375,
        -3430.61962890625,
        1459.0
      ],
      [
        -1624.5,
        -3434.875244140625,
        1478.2823486328125
      ],
      [
        -1624.5,
        -3439.372802734375,
        1483.4788818359375
      ],
      [
        -1624.5,
        -3437.27197265625,
        1483.2216796875
      ],
      [
        -1613.913818359375,
        -3426.5,
        1485.0
      ],
      [
        -1620.5372314453125,
        -3426.5,
        1470.0
      ],
      [
        -1610.0,
        -3426.5,
        1493.86376953125
      ],
      [
        -1613.913818359375,
        -3426.5,
        1485.0
      ],
      [
        -1620.5372314453125,
        -3426.5,
        1470.0
      ],
      [
        -1624.5,
        -3426.5,
        1461.025390625
      ],
      [
        -1598.238525390625,
        -3410.0,
        1486.5
      ],
      [
        -1590.1846923828125,
        -3410.0,
        1486.5
      ],
      [
        -1593.4718017578125,
        -3410.0,
        1497.2955322265625
      ],
      [
        -1579.3758544921875,
        -3410.0,
        1451.0
      ],
      [
        -1585.2955322265625,
        -3410.0,
        1470.4422607421875
      ],
      [
        -1608.1402587890625,
        -3410.0,
        1464.07568359375
      ],
      [
        -1612.0,
        -3410.0,
        1455.3343505859375
      ],
      [
        -1608.1402587890625,
        -3410.0,
        1464.07568359375
      ],
      [
        -1585.2955322265625,
        -3410.0,
        1470.4422607421875
      ],
      [
        -1588.2056884765625,
        -3410.0,
        1480.0
      ],
      [
        -1601.1087646484375,
        -3410.0,
        1480.0
      ],
      [
        -1610.0,
        -3414.9189453125,
        1470.0
      ],
      [
        -1610.0,
        -3422.198486328125,
        1485.0
      ],
      [
        -1610.0,
        -3422.198486328125,
        1485.0
      ],
      [
        -1610.0,
        -3426.5,
        1493.86376953125
      ],
      [
        -1610.0,
        -3411.5,
        1462.9552001953125
      ],
      [
        -1610.0,
        -3414.9189453125,
        1470.0
      ],
      [
        -1600.6669921875,
        -3426.5,
        1515.0
      ],
      [
        -1591.38525390625,
        -3416.298583984375,
        1515.0
      ],
      [
        -1582.4974365234375,
        -3426.5,
        1515.0
      ],
      [
        -1588.994384765625,
        -3426.5,
        1485.0
      ],
      [
        -1602.5,
        -3426.5,
        1485.0
      ],
      [
        -1602.5,
        -3413.95556640625,
        1485.0
      ],
      [
        -1600.7208251953125,
        -3412.0,
        1485.0
      ],
      [
        -1602.5,
        -3426.5,
        1497.0
      ],
      [
        -1602.5,
        -3419.779052734375,
        1497.0
      ],
      [
        -1602.5,
        -3413.95556640625,
        1485.0
      ],
      [
        -1602.5,
        -3426.5,
        1485.0
      ],
      [
        -1586.5,
        -3412.0,
        1487.3935546875
      ],
      [
        -1600.7208251953125,
        -3412.0,
        1485.0
      ],
      [
        -1595.422119140625,
        -3412.0,
        1497.0
      ],
      [
        -1589.4248046875,
        -3412.0,
        1497.0
      ],
      [
        -1589.4248046875,
        -3412.0,
        1497.0
      ],
      [
        -1595.422119140625,
        -3412.0,
        1497.0
      ],
      [
        -1602.5,
        -3419.779052734375,
        1497.0
      ],
      [
        -1602.5,
        -3426.5,
        1497.0
      ],
      [
        -1586.5,
        -3426.5,
        1497.0
      ],
      [
        -1586.5,
        -3413.478271484375,
        1497.0
      ],
      [
        -1585.0,
        -3423.5,
        1497.0
      ],
      [
        -1585.0,
        -3425.9892578125,
        1497.0
      ],
      [
        -1585.0,
        -3414.54443359375,
        1499.0
      ],
      [
        -1585.0,
        -3414.23681640625,
        1497.0
      ],
      [
        -1585.0,
        -3423.5,
        1497.0
      ],
      [
        -1585.0,
        -3414.54443359375,
        1499.0
      ],
      [
        -1585.0,
        -3426.5,
        1503.445068359375
      ],
      [
        -1585.0,
        -3426.5,
        1504.4000244140625
      ],
      [
        -1585.0,
        -3415.37548828125,
        1504.4000244140625
      ],
      [
        -1585.0,
        -3415.37548828125,
        1504.4000244140625
      ],
      [
        -1585.0,
        -3426.5,
        1504.4000244140625
      ],
      [
        -1585.0,
        -3426.5,
        1514.0
      ],
      [
        -1585.0,
        -3420.809814453125,
        1514.0
      ],
      [
        -1585.0,
        -3415.499755859375,
        1505.2064208984375
      ],
      [
        -1585.0,
        -3420.809814453125,
        1514.0
      ],
      [
        -1585.0,
        -3426.5,
        1514.0
      ],
      [
        -1582.71435546875,
        -3426.5,
        1514.0
      ],
      [
        -1586.5,
        -3412.0,
        1487.3931884765625
      ],
      [
        -1586.5,
        -3413.226806640625,
        1495.3641357421875
      ],
      [
        -1586.5,
        -3413.226806640625,
        1495.3641357421875
      ],
      [
        -1586.5,
        -3413.478515625,
        1497.0
      ],
      [
        -1586.5,
        -3426.5,
        1497.0
      ],
      [
        -1586.5,
        -3426.5,
        1496.5194091796875
      ],
      [
        -1585.0,
        -3412.62060546875,
        1486.5
      ],
      [
        -1585.0,
        -3412.620849609375,
        1486.5
      ],
      [
        -1585.0,
        -3413.5,
        1492.212158203125
      ],
      [
        -1585.0,
        -3413.92919921875,
        1495.0
      ],
      [
        -1585.0,
        -3413.5,
        1492.212158203125
      ],
      [
        -1585.848876953125,
        -3413.5,
        1495.0
      ],
      [
        -1585.0,
        -3413.92919921875,
        1495.0
      ],
      [
        -1585.848876953125,
        -3413.5,
        1495.0
      ],
      [
        -1588.282470703125,
        -3412.0,
        1493.247314453125
      ],
      [
        -1586.5,
        -3413.478515625,
        1497.0
      ],
      [
        -1624.5,
        -3415.81103515625,
        1439.0
      ],
      [
        -1620.5775146484375,
        -3411.5,
        1439.0
      ],
      [
        -1616.1619873046875,
        -3411.5,
        1449.0
      ],
      [
        -1615.27880859375,
        -3411.5,
        1451.0
      ],
      [
        -1616.1619873046875,
        -3411.5,
        1449.0
      ],
      [
        -1620.5775146484375,
        -3411.5,
        1439.0
      ],
      [
        -1612.0,
        -3411.5,
        1458.4256591796875
      ],
      [
        -1610.0,
        -3411.5,
        1462.9552001953125
      ],
      [
        -1612.0,
        -3410.0,
        1455.3343505859375
      ],
      [
        -1612.0,
        -3411.5,
        1458.4256591796875
      ],
      [
        -1615.27880859375,
        -3411.5,
        1451.0
      ],
      [
        -1613.913818359375,
        -3410.0,
        1451.0
      ],
      [
        -1579.3758544921875,
        -3410.0,
        1451.0
      ],
      [
        -1613.913818359375,
        -3410.0,
        1451.0
      ],
      [
        -1603.033447265625,
        -3398.04150390625,
        1451.0
      ],
      [
        -1601.1087646484375,
        -3410.0,
        1480.0
      ],
      [
        -1588.2056884765625,
        -3410.0,
        1480.0
      ],
      [
        -1597.3349609375,
        -3405.16845703125,
        1478.5908203125
      ],
      [
        -1595.701416015625,
        -3407.21142578125,
        1486.5
      ],
      [
        -1590.1846923828125,
        -3410.0,
        1486.5
      ],
      [
        -1598.238525390625,
        -3410.0,
        1486.5
      ],
      [
        -1589.4583740234375,
        -3408.289306640625,
        1473.0
      ],
      [
        -1589.669921875,
        -3407.5,
        1468.5660400390625
      ],
      [
        -1595.28466796875,
        -3405.34423828125,
        1473.0
      ],
      [
        -1589.4583740234375,
        -3408.289306640625,
        1473.0
      ],
      [
        -1595.28466796875,
        -3405.34423828125,
        1473.0
      ],
      [
        -1594.0,
        -3405.0,
        1466.5419921875
      ],
      [
        -1591.4017333984375,
        -3405.76806640625,
        1463.0
      ],
      [
        -1590.93505859375,
        -3406.23486328125,
        1464.5
      ],
      [
        -1591.4017333984375,
        -3405.76806640625,
        1463.0
      ],
      [
        -1591.5,
        -3405.669921875,
        1462.6842041015625
      ],
      [
        -1590.934814453125,
        -3406.235107421875,
        1464.5
      ],
      [
        -1589.669921875,
        -3407.5,
        1468.565185546875
      ],
      [
        -1591.7047119140625,
        -3405.614990234375,
        1463.0
      ],
      [
        -1592.6767578125,
        -3405.3544921875,
        1464.5
      ],
      [
        -1591.7047119140625,
        -3405.614990234375,
        1463.0
      ],
      [
        -1591.5,
        -3405.669921875,
        1462.6842041015625
      ],
      [
        -1594.0,
        -3405.0,
        1466.5419921875
      ],
      [
        -1592.6767578125,
        -3405.3544921875,
        1464.5
      ],
      [
        -1610.0,
        -3408.0,
        1455.7432861328125
      ],
      [
        -1610.0,
        -3410.0,
        1459.8638916015625
      ],
      [
        -1612.0,
        -3408.0,
        1451.2137451171875
      ],
      [
        -1610.0,
        -3408.0,
        1455.7432861328125
      ],
      [
        -1612.0,
        -3410.0,
        1455.3343505859375
      ],
      [
        -1612.0,
        -3408.0,
        1451.2137451171875
      ],
      [
        -1590.944580078125,
        -3408.0,
        1476.0
      ],
      [
        -1601.055419921875,
        -3408.0,
        1476.0
      ],
      [
        -1600.39306640625,
        -3408.0,
        1477.5
      ],
      [
        -1591.4013671875,
        -3408.0,
        1477.5
      ],
      [
        -1593.9117431640625,
        -3406.5,
        1476.0
      ],
      [
        -1599.6905517578125,
        -3406.5,
        1476.0
      ],
      [
        -1601.055419921875,
        -3408.0,
        1476.0
      ],
      [
        -1590.944580078125,
        -3408.0,
        1476.0
      ],
      [
        -1594.368896484375,
        -3406.5,
        1477.5
      ],
      [
        -1599.0281982421875,
        -3406.5,
        1477.5
      ],
      [
        -1599.6905517578125,
        -3406.5,
        1476.0
      ],
      [
        -1593.9117431640625,
        -3406.5,
        1476.0
      ],
      [
        -1586.5263671875,
        -3408.232421875,
        1463.0
      ],
      [
        -1586.580810546875,
        -3408.435791015625,
        1464.5
      ],
      [
        -1586.8895263671875,
        -3409.587890625,
        1473.0
      ],
      [
        -1586.580810546875,
        -3408.435791015625,
        1464.5
      ],
      [
        -1586.5263671875,
        -3408.232421875,
        1463.0
      ],
      [
        -1586.330078125,
        -3407.5,
        1457.596435546875
      ],
      [
        -1586.013671875,
        -3407.18359375,
        1454.5
      ],
      [
        -1580.4415283203125,
        -3410.0,
        1454.5
      ],
      [
        -1586.330078125,
        -3407.5,
        1457.5953369140625
      ],
      [
        -1586.013671875,
        -3407.18359375,
        1454.5
      ],
      [
        -1586.0740966796875,
        -3410.0,
        1473.0
      ],
      [
        -1586.8895263671875,
        -3409.587890625,
        1473.0
      ],
      [
        -1584.0,
        -3407.66259765625,
        1451.0
      ],
      [
        -1584.0,
        -3408.201171875,
        1454.5
      ],
      [
        -1580.0,
        -3410.0,
        1453.050537109375
      ],
      [
        -1580.0,
        -3409.684326171875,
        1451.0
      ],
      [
        -1610.0,
        -3434.07666015625,
        1509.4757080078125
      ],
      [
        -1602.03173828125,
        -3428.0,
        1515.0
      ],
      [
        -1610.0,
        -3435.989013671875,
        1507.7371826171875
      ],
      [
        -1602.03173828125,
        -3428.0,
        1515.0
      ],
      [
        -1622.8826904296875,
        -3436.357666015625,
        1485.0
      ],
      [
        -1622.8826904296875,
        -3436.357666015625,
        1485.0
      ],
      [
        -1624.5,
        -3434.875,
        1449.0
      ],
      [
        -1623.1239013671875,
        -3436.13623046875,
        1449.0
      ],
      [
        -1623.4007568359375,
        -3435.882568359375,
        1482.847900390625
      ],
      [
        -1634.787841796875,
        -3386.786865234375,
        1355.8946533203125
      ],
      [
        -1634.29931640625,
        -3382.0,
        1345.2088623046875
      ],
      [
        -1634.2630615234375,
        -3382.0,
        1347.219482421875
      ],
      [
        -1760.0,
        -3526.5615234375,
        1368.846435546875
      ],
      [
        -1760.0,
        -3542.7783203125,
        1393.7564697265625
      ],
      [
        -1760.0,
        -3526.5615234375,
        1368.846435546875
      ],
      [
        -1626.8880615234375,
        -3440.290771484375,
        1484.0338134765625
      ],
      [
        -1619.2523193359375,
        -3439.0,
        1503.006103515625
      ],
      [
        -1620.0,
        -3439.0,
        1499.5546875
      ],
      [
        -1618.9356689453125,
        -3439.0,
        1504.4677734375
      ],
      [
        -1619.2523193359375,
        -3439.0,
        1503.006103515625
      ],
      [
        -1618.9356689453125,
        -3439.0,
        1504.4677734375
      ],
      [
        -1618.8203125,
        -3439.0,
        1505.0
      ],
      [
        -1618.8203125,
        -3439.0,
        1505.0
      ],
      [
        -1614.5399169921875,
        -3437.538818359375,
        1506.3282470703125
      ],
      [
        -1620.0,
        -3439.0,
        1499.5546875
      ],
      [
        -1620.214599609375,
        -3438.80322265625,
        1496.0819091796875
      ],
      [
        -1633.61083984375,
        -3382.0,
        1383.44189453125
      ],
      [
        -1629.2471923828125,
        -3430.5234375,
        1485.0
      ],
      [
        -1624.6888427734375,
        -3434.701904296875,
        1503.262451171875
      ],
      [
        -1624.184326171875,
        -3435.164306640625,
        1505.0
      ],
      [
        -1632.0,
        -3428.0,
        1473.971435546875
      ],
      [
        -1629.2471923828125,
        -3430.5234375,
        1485.0
      ],
      [
        -1627.1573486328125,
        -3410.0,
        1451.0
      ],
      [
        -1622.5,
        -3410.0,
        1461.5970458984375
      ],
      [
        -1611.55517578125,
        -3410.0,
        1486.5
      ],
      [
        -1593.99072265625,
        -3410.0,
        1499.0
      ],
      [
        -1606.0616455078125,
        -3410.0,
        1499.0
      ],
      [
        -1595.634765625,
        -3410.0,
        1504.4000244140625
      ],
      [
        -1603.6883544921875,
        -3410.0,
        1504.4000244140625
      ],
      [
        -1606.0615234375,
        -3410.0,
        1499.0
      ],
      [
        -1593.99072265625,
        -3410.0,
        1499.0
      ],
      [
        -1598.5582275390625,
        -3410.0,
        1514.0
      ],
      [
        -1599.46923828125,
        -3410.0,
        1514.0
      ],
      [
        -1603.6883544921875,
        -3410.0,
        1504.4000244140625
      ],
      [
        -1595.634765625,
        -3410.0,
        1504.4000244140625
      ],
      [
        -1614.4119873046875,
        -3410.0,
        1480.0
      ],
      [
        -1621.8834228515625,
        -3410.0,
        1463.0
      ],
      [
        -1613.868408203125,
        -3428.0,
        1515.0
      ],
      [
        -1612.8729248046875,
        -3426.680419921875,
        1515.0
      ],
      [
        -1599.1168212890625,
        -3410.105224609375,
        1515.0
      ],
      [
        -1624.5,
        -3424.80322265625,
        1485.0
      ],
      [
        -1624.5,
        -3416.85986328125,
        1470.0
      ],
      [
        -1624.5,
        -3426.5,
        1488.2039794921875
      ],
      [
        -1624.5,
        -3424.80322265625,
        1485.0
      ],
      [
        -1624.5,
        -3416.860107421875,
        1470.0
      ],
      [
        -1624.5,
        -3411.5,
        1459.8790283203125
      ],
      [
        -1632.0,
        -3428.0,
        1473.971435546875
      ],
      [
        -1632.0,
        -3420.07177734375,
        1459.0
      ],
      [
        -1619.095947265625,
        -3426.5,
        1500.5
      ],
      [
        -1624.5,
        -3426.5,
        1488.2039794921875
      ],
      [
        -1620.0,
        -3433.10595703125,
        1510.3582763671875
      ],
      [
        -1613.8685302734375,
        -3428.0,
        1515.0
      ],
      [
        -1624.184326171875,
        -3435.164306640625,
        1505.0
      ],
      [
        -1620.0,
        -3433.10595703125,
        1510.358154296875
      ],
      [
        -1610.0,
        -3411.5,
        1492.8717041015625
      ],
      [
        -1610.0,
        -3415.5400390625,
        1500.5
      ],
      [
        -1612.8001708984375,
        -3411.5,
        1486.5
      ],
      [
        -1613.45947265625,
        -3411.5,
        1485.0
      ],
      [
        -1612.0,
        -3411.5,
        1488.320556640625
      ],
      [
        -1610.0,
        -3411.5,
        1492.87158203125
      ],
      [
        -1622.74755859375,
        -3411.5,
        1463.8663330078125
      ],
      [
        -1620.0517578125,
        -3411.5,
        1470.0
      ],
      [
        -1624.5,
        -3411.5,
        1459.87890625
      ],
      [
        -1622.74755859375,
        -3411.5,
        1463.8663330078125
      ],
      [
        -1620.0517578125,
        -3411.5,
        1470.0
      ],
      [
        -1613.45947265625,
        -3411.5,
        1485.0
      ],
      [
        -1622.5,
        -3410.742919921875,
        1463.0
      ],
      [
        -1622.5,
        -3410.0,
        1461.59716796875
      ],
      [
        -1621.8834228515625,
        -3410.0,
        1463.0
      ],
      [
        -1622.5,
        -3410.742919921875,
        1463.0
      ],
      [
        -1612.0,
        -3410.535888671875,
        1486.5
      ],
      [
        -1612.0,
        -3411.5,
        1488.320556640625
      ],
      [
        -1612.0,
        -3410.535888671875,
        1486.5
      ],
      [
        -1612.8001708984375,
        -3411.5,
        1486.5
      ],
      [
        -1610.0,
        -3415.5400390625,
        1500.5
      ],
      [
        -1619.095947265625,
        -3426.5,
        1500.5
      ],
      [
        -1627.1572265625,
        -3410.0,
        1451.0
      ],
      [
        -1619.0,
        -3400.171142578125,
        1451.0
      ],
      [
        -1619.0,
        -3400.1708984375,
        1451.0
      ],
      [
        -1613.0362548828125,
        -3392.9853515625,
        1451.0
      ],
      [
        -1614.4119873046875,
        -3410.0,
        1480.0
      ],
      [
        -1607.31494140625,
        -3399.88671875,
        1477.05029296875
      ],
      [
        -1605.2396240234375,
        -3402.39013671875,
        1486.5
      ],
      [
        -1611.5552978515625,
        -3410.0,
        1486.5
      ],
      [
        -1610.0,
        -3408.1259765625,
        1486.5
      ],
      [
        -1610.0,
        -3410.0,
        1490.0390625
      ],
      [
        -1599.4691162109375,
        -3410.0,
        1514.0
      ],
      [
        -1598.5582275390625,
        -3410.0,
        1514.0
      ],
      [
        -1599.199951171875,
        -3409.67578125,
        1514.0
      ],
      [
        -1613.2652587890625,
        -3406.5,
        1476.0
      ],
      [
        -1614.5101318359375,
        -3408.0,
        1476.0
      ],
      [
        -1600.836181640625,
        -3403.0,
        1476.0
      ],
      [
        -1610.3604736328125,
        -3403.0,
        1476.0
      ],
      [
        -1611.60546875,
        -3404.5,
        1476.0
      ],
      [
        -1597.86865234375,
        -3404.5,
        1476.0
      ],
      [
        -1612.6060791015625,
        -3406.5,
        1477.5
      ],
      [
        -1613.2652587890625,
        -3406.5,
        1476.0
      ],
      [
        -1614.5101318359375,
        -3408.0,
        1476.0
      ],
      [
        -1613.850830078125,
        -3408.0,
        1477.5
      ],
      [
        -1597.86865234375,
        -3404.5,
        1476.0
      ],
      [
        -1611.60546875,
        -3404.5,
        1476.0
      ],
      [
        -1610.9461669921875,
        -3404.5,
        1477.5
      ],
      [
        -1598.325439453125,
        -3404.5,
        1477.5
      ],
      [
        -1601.2933349609375,
        -3403.0,
        1477.5
      ],
      [
        -1609.701171875,
        -3403.0,
        1477.5
      ],
      [
        -1610.3604736328125,
        -3403.0,
        1476.0
      ],
      [
        -1600.836181640625,
        -3403.0,
        1476.0
      ],
      [
        -1622.5,
        -3408.0,
        1457.8203125
      ],
      [
        -1622.5,
        -3410.0,
        1461.59716796875
      ],
      [
        -1624.5,
        -3408.0,
        1453.2696533203125
      ],
      [
        -1622.5,
        -3408.0,
        1457.8203125
      ],
      [
        -1624.5,
        -3410.0,
        1457.0465087890625
      ],
      [
        -1624.5,
        -3408.0,
        1453.2696533203125
      ],
      [
        -1629.669921875,
        -3430.135986328125,
        1483.306640625
      ],
      [
        -1633.3604736328125,
        -3382.0,
        1397.349365234375
      ],
      [
        -1633.395751953125,
        -3383.44384765625,
        1406.7977294921875
      ],
      [
        -1599.897216796875,
        -3409.47998046875,
        1515.0
      ],
      [
        -1629.9910888671875,
        -3429.841552734375,
        1485.0
      ],
      [
        -1632.0,
        -3428.0,
        1478.0806884765625
      ],
      [
        -1629.9910888671875,
        -3429.841552734375,
        1485.0
      ],
      [
        -1632.0,
        -3428.0,
        1478.0806884765625
      ],
      [
        -1632.0,
        -3415.578125,
        1459.0
      ],
      [
        -1624.6090087890625,
        -3410.0,
        1465.481201171875
      ],
      [
        -1631.0,
        -3410.0,
        1452.468017578125
      ],
      [
        -1608.1473388671875,
        -3410.0,
        1499.0
      ],
      [
        -1612.0,
        -3410.0,
        1491.155517578125
      ],
      [
        -1605.4954833984375,
        -3410.0,
        1504.4000244140625
      ],
      [
        -1608.1474609375,
        -3410.0,
        1499.0
      ],
      [
        -1600.7806396484375,
        -3410.0,
        1514.0
      ],
      [
        -1605.4954833984375,
        -3410.0,
        1504.4000244140625
      ],
      [
        -1617.4786376953125,
        -3410.0,
        1480.0
      ],
      [
        -1624.6090087890625,
        -3410.0,
        1465.481201171875
      ],
      [
        -1624.5,
        -3422.5625,
        1485.0
      ],
      [
        -1624.5,
        -3412.79736328125,
        1470.0
      ],
      [
        -1624.5,
        -3426.5,
        1491.048095703125
      ],
      [
        -1624.5,
        -3422.5625,
        1485.0
      ],
      [
        -1624.5,
        -3412.79736328125,
        1470.0
      ],
      [
        -1624.5,
        -3411.5,
        1468.0072021484375
      ],
      [
        -1615.4180908203125,
        -3411.5,
        1486.5
      ],
      [
        -1616.154541015625,
        -3411.5,
        1485.0
      ],
      [
        -1612.0,
        -3411.5,
        1493.4595947265625
      ],
      [
        -1610.0,
        -3411.5,
        1497.531982421875
      ],
      [
        -1624.1400146484375,
        -3411.5,
        1468.7401123046875
      ],
      [
        -1623.521240234375,
        -3411.5,
        1470.0
      ],
      [
        -1624.5,
        -3411.5,
        1468.0072021484375
      ],
      [
        -1624.1400146484375,
        -3411.5,
        1468.7401123046875
      ],
      [
        -1623.521240234375,
        -3411.5,
        1470.0
      ],
      [
        -1616.154541015625,
        -3411.5,
        1485.0
      ],
      [
        -1612.0,
        -3410.0,
        1491.155517578125
      ],
      [
        -1612.0,
        -3411.5,
        1493.459716796875
      ],
      [
        -1615.4180908203125,
        -3411.5,
        1486.5
      ],
      [
        -1614.286376953125,
        -3410.0,
        1486.5
      ],
      [
        -1610.0,
        -3413.43212890625,
        1500.5
      ],
      [
        -1619.8580322265625,
        -3426.5,
        1500.5
      ],
      [
        -1619.8580322265625,
        -3426.5,
        1500.5
      ],
      [
        -1624.5,
        -3426.5,
        1491.048095703125
      ],
      [
        -1610.0,
        -3411.5,
        1497.531982421875
      ],
      [
        -1610.0,
        -3413.43212890625,
        1500.5
      ],
      [
        -1631.0,
        -3409.04443359375,
        1451.0
      ],
      [
        -1619.0,
        -3393.13720703125,
        1451.0
      ],
      [
        -1619.0,
        -3393.137451171875,
        1451.0
      ],
      [
        -1617.2706298828125,
        -3390.844970703125,
        1451.0
      ],
      [
        -1617.4786376953125,
        -3410.0,
        1480.0
      ],
      [
        -1610.324462890625,
        -3398.2939453125,
        1476.585693359375
      ],
      [
        -1607.6329345703125,
        -3401.180419921875,
        1486.5
      ],
      [
        -1614.286376953125,
        -3410.0,
        1486.5
      ],
      [
        -1610.0,
        -3408.0,
        1492.15576171875
      ],
      [
        -1610.0,
        -3410.0,
        1495.227783203125
      ],
      [
        -1612.0,
        -3408.0,
        1488.08349609375
      ],
      [
        -1610.0,
        -3408.0,
        1492.15576171875
      ],
      [
        -1612.0,
        -3410.0,
        1491.155517578125
      ],
      [
        -1612.0,
        -3408.0,
        1488.08349609375
      ],
      [
        -1599.7744140625,
        -3409.0,
        1511.5
      ],
      [
        -1601.2540283203125,
        -3409.0,
        1511.5
      ],
      [
        -1601.008544921875,
        -3409.0,
        1512.0
      ],
      [
        -1599.9266357421875,
        -3409.0,
        1512.0
      ],
      [
        -1601.2540283203125,
        -3409.0,
        1511.5
      ],
      [
        -1599.7744140625,
        -3409.0,
        1511.5
      ],
      [
        -1600.8455810546875,
        -3408.45849609375,
        1511.5
      ],
      [
        -1600.78076171875,
        -3410.0,
        1514.0
      ],
      [
        -1600.167236328125,
        -3409.186767578125,
        1514.0
      ],
      [
        -1624.5,
        -3408.0,
        1462.630859375
      ],
      [
        -1623.5821533203125,
        -3408.0,
        1464.5
      ],
      [
        -1617.9344482421875,
        -3408.0,
        1476.0
      ],
      [
        -1617.1976318359375,
        -3408.0,
        1477.5
      ],
      [
        -1624.5,
        -3409.216796875,
        1464.5
      ],
      [
        -1624.5,
        -3410.0,
        1465.7030029296875
      ],
      [
        -1624.5,
        -3408.0,
        1462.630859375
      ],
      [
        -1624.5,
        -3409.216796875,
        1464.5
      ],
      [
        -1623.5821533203125,
        -3408.0,
        1464.5
      ],
      [
        -1623.3719482421875,
        -3410.0,
        1468.0
      ],
      [
        -1619.0,
        -3408.855712890625,
        1475.1444091796875
      ],
      [
        -1619.0,
        -3409.0,
        1475.3662109375
      ],
      [
        -1619.0,
        -3408.76171875,
        1475.0
      ],
      [
        -1619.0,
        -3408.855712890625,
        1475.1444091796875
      ],
      [
        -1619.1798095703125,
        -3409.0,
        1475.0
      ],
      [
        -1619.0,
        -3408.76171875,
        1475.0
      ],
      [
        -1631.0,
        -3410.0,
        1452.468017578125
      ],
      [
        -1631.0,
        -3409.04443359375,
        1451.0
      ],
      [
        -1614.162353515625,
        -3403.0,
        1476.0
      ],
      [
        -1615.2940673828125,
        -3404.5,
        1476.0
      ],
      [
        -1616.802734375,
        -3406.5,
        1476.0
      ],
      [
        -1617.9344482421875,
        -3408.0,
        1476.0
      ],
      [
        -1615.2940673828125,
        -3404.5,
        1476.0
      ],
      [
        -1614.557373046875,
        -3404.5,
        1477.5
      ],
      [
        -1613.4256591796875,
        -3403.0,
        1477.5
      ],
      [
        -1614.162353515625,
        -3403.0,
        1476.0
      ],
      [
        -1616.0660400390625,
        -3406.5,
        1477.5
      ],
      [
        -1616.802734375,
        -3406.5,
        1476.0
      ],
      [
        -1611.9105224609375,
        -3398.886962890625,
        1474.267333984375
      ],
      [
        -1611.225830078125,
        -3398.0244140625,
        1474.3365478515625
      ],
      [
        -1613.0,
        -3400.03515625,
        1473.8125
      ],
      [
        -1611.9105224609375,
        -3398.886962890625,
        1474.267333984375
      ],
      [
        -1609.343994140625,
        -3398.283935546875,
        1473.2999267578125
      ],
      [
        -1610.9779052734375,
        -3397.593017578125,
        1474.178466796875
      ],
      [
        -1611.2528076171875,
        -3398.0087890625,
        1474.2574462890625
      ],
      [
        -1611.225830078125,
        -3398.0244140625,
        1474.3365478515625
      ],
      [
        -1610.9580078125,
        -3397.614990234375,
        1474.2525634765625
      ],
      [
        -1609.343994140625,
        -3398.283935546875,
        1473.2999267578125
      ],
      [
        -1611.2528076171875,
        -3398.0087890625,
        1474.2574462890625
      ],
      [
        -1611.926025390625,
        -3398.860107421875,
        1474.1944580078125
      ],
      [
        -1613.8148193359375,
        -3400.78173828125,
        1473.2999267578125
      ],
      [
        -1613.0,
        -3400.01220703125,
        1473.777099609375
      ],
      [
        -1613.0,
        -3400.03515625,
        1473.8125
      ],
      [
        -1613.8148193359375,
        -3400.78173828125,
        1473.2999267578125
      ],
      [
        -1611.926025390625,
        -3398.860107421875,
        1474.1944580078125
      ],
      [
        -1613.0,
        -3400.01220703125,
        1473.777099609375
      ],
      [
        -1630.4658203125,
        -3429.40625,
        1483.3648681640625
      ],
      [
        -1633.395751953125,
        -3383.444091796875,
        1406.7977294921875
      ],
      [
        -1633.3604736328125,
        -3382.0,
        1397.3492431640625
      ],
      [
        -1633.291748046875,
        -3382.0,
        1404.79150390625
      ],
      [
        -1627.598388671875,
        -3394.5,
        1508.66796875
      ],
      [
        -1620.0,
        -3399.3154296875,
        1515.0
      ],
      [
        -1620.0,
        -3399.3154296875,
        1515.0
      ],
      [
        -1599.90771484375,
        -3409.4716796875,
        1515.0
      ],
      [
        -1627.617431640625,
        -3390.847900390625,
        1485.0
      ],
      [
        -1629.91650390625,
        -3392.763671875,
        1505.0
      ],
      [
        -1627.617431640625,
        -3390.847900390625,
        1485.0
      ],
      [
        -1624.62841796875,
        -3388.35693359375,
        1459.0
      ],
      [
        -1632.0,
        -3431.817138671875,
        1483.9442138671875
      ],
      [
        -1631.0,
        -3393.666748046875,
        1505.0
      ],
      [
        -1631.0,
        -3394.5,
        1505.8333740234375
      ],
      [
        -1626.5528564453125,
        -3391.61669921875,
        1486.5
      ],
      [
        -1621.9658203125,
        -3388.471435546875,
        1451.0
      ],
      [
        -1619.0,
        -3389.970703125,
        1451.0
      ],
      [
        -1619.0,
        -3389.970703125,
        1451.0
      ],
      [
        -1621.9658203125,
        -3388.471435546875,
        1451.0
      ],
      [
        -1624.4947509765625,
        -3390.5791015625,
        1473.0
      ],
      [
        -1624.9998779296875,
        -3391.0,
        1467.199951171875
      ],
      [
        -1624.9998779296875,
        -3391.0,
        1472.199951171875
      ],
      [
        -1624.9998779296875,
        -3391.0,
        1461.199951171875
      ],
      [
        -1624.9998779296875,
        -3391.0,
        1466.199951171875
      ],
      [
        -1624.33056640625,
        -3388.845947265625,
        1461.199951171875
      ],
      [
        -1624.9998779296875,
        -3391.0,
        1461.199951171875
      ],
      [
        -1623.1383056640625,
        -3389.44873046875,
        1461.199951171875
      ],
      [
        -1624.9835205078125,
        -3389.439697265625,
        1467.199951171875
      ],
      [
        -1624.9998779296875,
        -3391.0,
        1467.199951171875
      ],
      [
        -1623.828369140625,
        -3390.023681640625,
        1467.199951171875
      ],
      [
        -1624.9998779296875,
        -3391.0,
        1472.199951171875
      ],
      [
        -1625.52734375,
        -3389.93408203125,
        1472.199951171875
      ],
      [
        -1624.40283203125,
        -3390.50244140625,
        1472.199951171875
      ],
      [
        -1624.9998779296875,
        -3391.0,
        1466.199951171875
      ],
      [
        -1624.8746337890625,
        -3389.340576171875,
        1466.199951171875
      ],
      [
        -1623.7132568359375,
        -3389.927734375,
        1466.199951171875
      ],
      [
        -1621.5714111328125,
        -3402.0,
        1478.5
      ],
      [
        -1627.5714111328125,
        -3402.0,
        1475.0
      ],
      [
        -1627.5714111328125,
        -3402.0,
        1475.0
      ],
      [
        -1627.5714111328125,
        -3409.0,
        1475.0
      ],
      [
        -1624.4947509765625,
        -3390.5791015625,
        1473.0
      ],
      [
        -1619.0,
        -3393.702392578125,
        1475.24658203125
      ],
      [
        -1625.85693359375,
        -3402.0,
        1476.0001220703125
      ],
      [
        -1619.0,
        -3402.0,
        1477.6666259765625
      ],
      [
        -1619.0,
        -3402.64501953125,
        1477.8548583984375
      ],
      [
        -1619.0,
        -3402.0,
        1477.6666259765625
      ],
      [
        -1619.0,
        -3404.857177734375,
        1478.5
      ],
      [
        -1619.0,
        -3402.64501953125,
        1477.8548583984375
      ],
      [
        -1619.0,
        -3393.702392578125,
        1475.24658203125
      ],
      [
        -1613.5999755859375,
        -3397.60009765625,
        1476.3834228515625
      ],
      [
        -1612.4000244140625,
        -3397.60009765625,
        1476.3834228515625
      ],
      [
        -1613.5999755859375,
        -3396.560302734375,
        1476.080078125
      ],
      [
        -1613.5999755859375,
        -3396.640380859375,
        1476.5999755859375
      ],
      [
        -1613.5999755859375,
        -3397.60009765625,
        1476.3834228515625
      ],
      [
        -1612.4000244140625,
        -3397.60009765625,
        1476.3834228515625
      ],
      [
        -1612.4000244140625,
        -3397.2470703125,
        1476.5999755859375
      ],
      [
        -1612.4000244140625,
        -3397.195556640625,
        1476.265380859375
      ],
      [
        -1620.069580078125,
        -3391.0,
        1461.199951171875
      ],
      [
        -1621.5919189453125,
        -3391.0,
        1466.199951171875
      ],
      [
        -1621.896728515625,
        -3391.0,
        1467.199951171875
      ],
      [
        -1623.4185791015625,
        -3391.0,
        1472.199951171875
      ],
      [
        -1620.069580078125,
        -3391.0,
        1461.199951171875
      ],
      [
        -1621.5919189453125,
        -3391.0,
        1466.199951171875
      ],
      [
        -1621.896728515625,
        -3391.0,
        1467.199951171875
      ],
      [
        -1623.4185791015625,
        -3391.0,
        1472.199951171875
      ],
      [
        -1611.20751953125,
        -3397.51123046875,
        1474.39990234375
      ],
      [
        -1614.488525390625,
        -3395.852783203125,
        1474.39990234375
      ],
      [
        -1616.2547607421875,
        -3394.790771484375,
        1473.2999267578125
      ],
      [
        -1614.478271484375,
        -3395.842529296875,
        1474.2999267578125
      ],
      [
        -1614.488525390625,
        -3395.852783203125,
        1474.39990234375
      ],
      [
        -1616.2547607421875,
        -3394.790771484375,
        1473.2999267578125
      ],
      [
        -1611.203857421875,
        -3397.49755859375,
        1474.2999267578125
      ],
      [
        -1611.2076416015625,
        -3397.511474609375,
        1474.39990234375
      ],
      [
        -1614.478271484375,
        -3395.842529296875,
        1474.2999267578125
      ],
      [
        -1611.203857421875,
        -3397.49755859375,
        1474.2999267578125
      ],
      [
        -1612.4000244140625,
        -3396.908447265625,
        1474.4000244140625
      ],
      [
        -1613.5999755859375,
        -3396.39990234375,
        1475.0369873046875
      ],
      [
        -1613.5999755859375,
        -3396.39990234375,
        1475.0369873046875
      ],
      [
        -1613.4061279296875,
        -3396.39990234375,
        1474.4000244140625
      ],
      [
        -1620.0,
        -3399.161376953125,
        1514.0
      ],
      [
        -1620.0,
        -3399.161376953125,
        1514.0
      ],
      [
        -1626.4400634765625,
        -3395.0,
        1508.1119384765625
      ],
      [
        -1629.91650390625,
        -3392.763671875,
        1505.0
      ],
      [
        -1627.598388671875,
        -3394.5,
        1508.66796875
      ],
      [
        -1604.7205810546875,
        -3406.5,
        1511.5
      ],
      [
        -1604.873046875,
        -3406.5,
        1512.0
      ],
      [
        -1604.7205810546875,
        -3406.5,
        1511.5
      ],
      [
        -1628.57470703125,
        -3393.349609375,
        1504.4000244140625
      ],
      [
        -1627.9647216796875,
        -3392.826904296875,
        1499.0
      ],
      [
        -1627.9647216796875,
        -3392.826904296875,
        1499.0
      ],
      [
        -1626.5528564453125,
        -3391.61669921875,
        1486.5
      ],
      [
        -1628.57470703125,
        -3393.349609375,
        1504.4000244140625
      ],
      [
        -1626.4400634765625,
        -3395.0,
        1508.1119384765625
      ],
      [
        -1626.8314208984375,
        -3390.19287109375,
        1478.163330078125
      ],
      [
        -1631.5889892578125,
        -3387.90625,
        1478.931396484375
      ],
      [
        -1631.5889892578125,
        -3387.90625,
        1478.931396484375
      ],
      [
        -1632.0,
        -3387.708740234375,
        1478.997802734375
      ],
      [
        -1632.6556396484375,
        -3387.3935546875,
        1479.1036376953125
      ],
      [
        -1633.0465087890625,
        -3387.205810546875,
        1479.166748046875
      ],
      [
        -1632.9208984375,
        -3382.0,
        1444.9290771484375
      ],
      [
        -1633.0465087890625,
        -3387.205810546875,
        1479.166748046875
      ],
      [
        -1552.311279296875,
        -3382.0,
        1312.15576171875
      ],
      [
        -1551.8511962890625,
        -3382.0,
        1302.5999755859375
      ],
      [
        -1580.9638671875,
        -3386.0,
        1451.0
      ],
      [
        -1632.943115234375,
        -3382.923095703125,
        1451.0
      ],
      [
        -1632.8648681640625,
        -3382.0,
        1451.0
      ],
      [
        -1576.516357421875,
        -3411.0,
        1486.5
      ],
      [
        -1577.764404296875,
        -3410.0,
        1486.5
      ],
      [
        -1576.5162353515625,
        -3411.0,
        1486.5
      ],
      [
        -1607.724853515625,
        -3386.0,
        1486.5
      ],
      [
        -1577.764404296875,
        -3410.0,
        1486.5
      ],
      [
        -1580.964111328125,
        -3386.0,
        1451.0
      ],
      [
        -1597.5478515625,
        -3386.0,
        1473.0
      ],
      [
        -1617.9705810546875,
        -3384.5,
        1486.5
      ],
      [
        -1617.1070556640625,
        -3384.5,
        1486.5
      ],
      [
        -1620.0,
        -3384.5,
        1486.5
      ],
      [
        -1617.9705810546875,
        -3384.5,
        1486.5
      ],
      [
        -1608.466064453125,
        -3384.5,
        1485.0
      ],
      [
        -1609.5968017578125,
        -3384.5,
        1486.5
      ],
      [
        -1617.1070556640625,
        -3384.5,
        1486.5
      ],
      [
        -1608.466064453125,
        -3384.5,
        1485.0
      ],
      [
        -1588.8671875,
        -3384.5,
        1459.0
      ],
      [
        -1621.800048828125,
        -3386.0,
        1485.0
      ],
      [
        -1620.0,
        -3384.5,
        1486.5
      ],
      [
        -1621.7999267578125,
        -3386.0,
        1486.5
      ],
      [
        -1621.800048828125,
        -3386.0,
        1485.0
      ],
      [
        -1621.800048828125,
        -3386.0,
        1459.0
      ],
      [
        -1632.818603515625,
        -3384.5,
        1478.9722900390625
      ],
      [
        -1632.9449462890625,
        -3386.0,
        1479.080078125
      ],
      [
        -1633.0174560546875,
        -3386.0,
        1471.236328125
      ],
      [
        -1632.981201171875,
        -3384.5,
        1461.37109375
      ],
      [
        -1621.800048828125,
        -3386.0,
        1476.9808349609375
      ],
      [
        -1631.47021484375,
        -3386.0,
        1478.80224609375
      ],
      [
        -1631.376708984375,
        -3384.5,
        1478.70068359375
      ],
      [
        -1631.376708984375,
        -3384.5,
        1478.70068359375
      ],
      [
        -1631.47021484375,
        -3386.0,
        1478.80224609375
      ],
      [
        -1632.9449462890625,
        -3386.0,
        1479.080078125
      ],
      [
        -1632.818603515625,
        -3384.5,
        1478.9722900390625
      ],
      [
        -1632.6080322265625,
        -3382.0,
        1478.7926025390625
      ],
      [
        -1620.2760009765625,
        -3382.0,
        1476.4697265625
      ],
      [
        -1631.220947265625,
        -3382.0,
        1478.5313720703125
      ],
      [
        -1631.220947265625,
        -3382.0,
        1478.5313720703125
      ],
      [
        -1632.6080322265625,
        -3382.0,
        1478.7926025390625
      ],
      [
        -1599.140380859375,
        -3384.5,
        1472.6285400390625
      ],
      [
        -1620.2760009765625,
        -3382.0,
        1476.4697265625
      ],
      [
        -1602.655029296875,
        -3382.0,
        1473.1505126953125
      ],
      [
        -1569.0687255859375,
        -3410.0,
        1474.9644775390625
      ],
      [
        -1569.0687255859375,
        -3410.0,
        1474.9644775390625
      ],
      [
        -1572.8642578125,
        -3410.0,
        1480.0
      ],
      [
        -1538.9801025390625,
        -3428.8984375,
        1466.3460693359375
      ],
      [
        -1538.9801025390625,
        -3428.8984375,
        1466.345947265625
      ],
      [
        -1538.0,
        -3428.0,
        1463.5579833984375
      ],
      [
        -1541.801025390625,
        -3431.484130859375,
        1467.185302734375
      ],
      [
        -1538.0,
        -3428.0,
        1463.5579833984375
      ],
      [
        -1538.0,
        -3425.24755859375,
        1459.0
      ],
      [
        -1597.5478515625,
        -3386.0,
        1473.0
      ],
      [
        -1572.8642578125,
        -3410.0,
        1480.0
      ],
      [
        -1627.7899169921875,
        -3390.99169921875,
        1486.5
      ],
      [
        -1626.365478515625,
        -3389.804443359375,
        1474.109619140625
      ],
      [
        -1621.800048828125,
        -3386.0,
        1473.0
      ],
      [
        -1599.5999755859375,
        -3396.39990234375,
        1476.0333251953125
      ],
      [
        -1599.5999755859375,
        -3397.60009765625,
        1476.3834228515625
      ],
      [
        -1599.5999755859375,
        -3396.39990234375,
        1476.0333251953125
      ],
      [
        -1598.4000244140625,
        -3396.39990234375,
        1476.0333251953125
      ],
      [
        -1598.4000244140625,
        -3397.60009765625,
        1476.3834228515625
      ],
      [
        -1598.4000244140625,
        -3396.39990234375,
        1476.0333251953125
      ],
      [
        -1599.5999755859375,
        -3397.60009765625,
        1476.3834228515625
      ],
      [
        -1598.4000244140625,
        -3397.60009765625,
        1476.3834228515625
      ],
      [
        -1613.5999755859375,
        -3396.39990234375,
        1476.0333251953125
      ],
      [
        -1612.4000244140625,
        -3396.39990234375,
        1476.0333251953125
      ],
      [
        -1612.4000244140625,
        -3396.39990234375,
        1476.0333251953125
      ],
      [
        -1612.4000244140625,
        -3397.195556640625,
        1476.265380859375
      ],
      [
        -1613.5999755859375,
        -3396.39990234375,
        1476.0333251953125
      ],
      [
        -1613.5999755859375,
        -3396.560302734375,
        1476.080078125
      ],
      [
        -1633.024169921875,
        -3386.280517578125,
        1473.081787109375
      ],
      [
        -1633.0010986328125,
        -3386.0,
        1473.0
      ],
      [
        -1579.718017578125,
        -3403.0,
        1477.5
      ],
      [
        -1578.58740234375,
        -3403.0,
        1476.0
      ],
      [
        -1578.58740234375,
        -3403.0,
        1476.0
      ],
      [
        -1576.71533203125,
        -3404.5,
        1476.0
      ],
      [
        -1574.2183837890625,
        -3406.5,
        1476.0
      ],
      [
        -1572.345947265625,
        -3408.0,
        1476.0
      ],
      [
        -1576.71533203125,
        -3404.5,
        1476.0
      ],
      [
        -1577.845947265625,
        -3404.5,
        1477.5
      ],
      [
        -1575.3489990234375,
        -3406.5,
        1477.5
      ],
      [
        -1574.2183837890625,
        -3406.5,
        1476.0
      ],
      [
        -1572.345947265625,
        -3408.0,
        1476.0
      ],
      [
        -1573.4765625,
        -3408.0,
        1477.5
      ],
      [
        -1565.669921875,
        -3407.5,
        1466.3154296875
      ],
      [
        -1565.0,
        -3410.0,
        1469.5672607421875
      ],
      [
        -1570.0,
        -3405.0,
        1467.9195556640625
      ],
      [
        -1567.5,
        -3405.669921875,
        1465.71240234375
      ],
      [
        -1572.5,
        -3405.669921875,
        1472.345458984375
      ],
      [
        -1570.0,
        -3405.0,
        1467.9195556640625
      ],
      [
        -1567.5,
        -3405.669921875,
        1465.71240234375
      ],
      [
        -1565.669921875,
        -3407.5,
        1466.3154296875
      ],
      [
        -1572.719482421875,
        -3405.889404296875,
        1473.0
      ],
      [
        -1572.5,
        -3405.669921875,
        1472.345458984375
      ],
      [
        -1567.5875244140625,
        -3410.0,
        1473.0
      ],
      [
        -1572.719482421875,
        -3405.889404296875,
        1473.0
      ],
      [
        -1559.4117431640625,
        -3405.37841796875,
        1454.5
      ],
      [
        -1553.6419677734375,
        -3410.0,
        1454.5
      ],
      [
        -1562.4786376953125,
        -3408.054443359375,
        1463.0
      ],
      [
        -1562.678466796875,
        -3408.800048828125,
        1464.5
      ],
      [
        -1562.4786376953125,
        -3408.054443359375,
        1463.0
      ],
      [
        -1562.330078125,
        -3407.5,
        1461.8843994140625
      ],
      [
        -1563.0,
        -3410.0,
        1466.9139404296875
      ],
      [
        -1562.678466796875,
        -3408.800048828125,
        1464.5
      ],
      [
        -1562.330078125,
        -3407.5,
        1461.8843994140625
      ],
      [
        -1560.5,
        -3405.669921875,
        1456.426513671875
      ],
      [
        -1560.5,
        -3405.669921875,
        1456.426513671875
      ],
      [
        -1559.4117431640625,
        -3405.37841796875,
        1454.5
      ],
      [
        -1558.01123046875,
        -3406.5,
        1454.5
      ],
      [
        -1556.0,
        -3406.5,
        1451.83203125
      ],
      [
        -1556.0,
        -3408.111083984375,
        1454.5
      ],
      [
        -1556.0,
        -3406.5,
        1451.83203125
      ],
      [
        -1590.4200439453125,
        -3387.0,
        1465.199951171875
      ],
      [
        -1590.0,
        -3387.33642578125,
        1465.199951171875
      ],
      [
        -1623.2532958984375,
        -3389.54443359375,
        1462.199951171875
      ],
      [
        -1623.59814453125,
        -3389.831787109375,
        1465.199951171875
      ],
      [
        -1619.0,
        -3386.0,
        1465.199951171875
      ],
      [
        -1619.0,
        -3386.0,
        1462.199951171875
      ],
      [
        -1625.3411865234375,
        -3388.950927734375,
        1465.199951171875
      ],
      [
        -1624.996337890625,
        -3388.66357421875,
        1462.199951171875
      ],
      [
        -1621.800048828125,
        -3386.0,
        1462.199951171875
      ],
      [
        -1621.800048828125,
        -3386.0,
        1465.199951171875
      ],
      [
        -1619.0,
        -3386.0,
        1465.199951171875
      ],
      [
        -1619.0,
        -3386.0,
        1462.199951171875
      ],
      [
        -1590.0,
        -3386.0,
        1462.199951171875
      ],
      [
        -1590.0,
        -3386.0,
        1462.9866943359375
      ],
      [
        -1590.0,
        -3387.0,
        1464.642822265625
      ],
      [
        -1620.3740234375,
        -3391.0,
        1462.199951171875
      ],
      [
        -1621.2874755859375,
        -3391.0,
        1465.199951171875
      ],
      [
        -1619.0,
        -3391.0,
        1465.199951171875
      ],
      [
        -1619.0,
        -3391.0,
        1462.199951171875
      ],
      [
        -1590.0,
        -3391.0,
        1462.199951171875
      ],
      [
        -1590.0,
        -3391.0,
        1465.199951171875
      ],
      [
        -1585.4266357421875,
        -3391.0,
        1465.199951171875
      ],
      [
        -1583.1650390625,
        -3391.0,
        1462.199951171875
      ],
      [
        -1619.0,
        -3391.0,
        1462.199951171875
      ],
      [
        -1619.0,
        -3391.0,
        1465.199951171875
      ],
      [
        -1590.0,
        -3391.0,
        1465.199951171875
      ],
      [
        -1590.0,
        -3391.0,
        1462.199951171875
      ],
      [
        -1623.1383056640625,
        -3389.44873046875,
        1461.199951171875
      ],
      [
        -1576.255615234375,
        -3390.39990234375,
        1452.0400390625
      ],
      [
        -1582.2923583984375,
        -3387.39990234375,
        1455.0799560546875
      ],
      [
        -1576.0,
        -3390.39990234375,
        1451.7010498046875
      ],
      [
        -1576.255615234375,
        -3390.39990234375,
        1452.0400390625
      ],
      [
        -1588.5,
        -3386.0,
        1456.49853515625
      ],
      [
        -1576.0,
        -3389.9765625,
        1451.0
      ],
      [
        -1576.0,
        -3390.39990234375,
        1451.7010498046875
      ],
      [
        -1588.653076171875,
        -3386.0,
        1461.199951171875
      ],
      [
        -1582.4112548828125,
        -3391.0,
        1461.199951171875
      ],
      [
        -1582.4112548828125,
        -3391.0,
        1461.199951171875
      ],
      [
        -1582.52734375,
        -3390.39990234375,
        1460.3599853515625
      ],
      [
        -1583.160400390625,
        -3390.39990234375,
        1461.199951171875
      ],
      [
        -1588.5,
        -3386.0,
        1460.9971923828125
      ],
      [
        -1588.5,
        -3386.122314453125,
        1461.199951171875
      ],
      [
        -1583.8299560546875,
        -3387.39990234375,
        1457.1199951171875
      ],
      [
        -1582.527099609375,
        -3390.39990234375,
        1460.3599853515625
      ],
      [
        -1582.2923583984375,
        -3387.39990234375,
        1455.0799560546875
      ],
      [
        -1583.8299560546875,
        -3387.39990234375,
        1457.1199951171875
      ],
      [
        -1592.681640625,
        -3387.0,
        1468.199951171875
      ],
      [
        -1590.0,
        -3389.14794921875,
        1468.199951171875
      ],
      [
        -1591.197998046875,
        -3390.0,
        1471.199951171875
      ],
      [
        -1590.0,
        -3390.0,
        1469.6109619140625
      ],
      [
        -1591.197998046875,
        -3390.0,
        1471.199951171875
      ],
      [
        -1594.94287109375,
        -3387.0,
        1471.199951171875
      ],
      [
        -1619.0,
        -3386.0,
        1471.199951171875
      ],
      [
        -1619.0,
        -3386.0,
        1468.199951171875
      ],
      [
        -1623.800048828125,
        -3390.0,
        1468.199951171875
      ],
      [
        -1623.7999267578125,
        -3390.0,
        1471.199951171875
      ],
      [
        -1626.031005859375,
        -3389.525634765625,
        1471.199951171875
      ],
      [
        -1625.68603515625,
        -3389.23828125,
        1468.199951171875
      ],
      [
        -1621.800048828125,
        -3386.0,
        1468.199951171875
      ],
      [
        -1621.800048828125,
        -3386.0,
        1471.199951171875
      ],
      [
        -1619.0,
        -3386.0,
        1471.199951171875
      ],
      [
        -1619.0,
        -3386.0,
        1468.199951171875
      ],
      [
        -1623.7998046875,
        -3390.0,
        1473.0
      ],
      [
        -1619.0,
        -3390.0,
        1474.166748046875
      ],
      [
        -1619.0,
        -3390.0,
        1472.199951171875
      ],
      [
        -1625.39697265625,
        -3390.0,
        1472.199951171875
      ],
      [
        -1619.0,
        -3390.0,
        1472.199951171875
      ],
      [
        -1619.0,
        -3386.0,
        1472.199951171875
      ],
      [
        -1623.7998046875,
        -3390.0,
        1472.199951171875
      ],
      [
        -1623.7998046875,
        -3390.0,
        1473.0
      ],
      [
        -1622.2010498046875,
        -3391.0,
        1468.199951171875
      ],
      [
        -1619.0,
        -3391.0,
        1468.199951171875
      ],
      [
        -1590.0,
        -3391.0,
        1468.199951171875
      ],
      [
        -1590.0,
        -3391.0,
        1471.26708984375
      ],
      [
        -1587.6878662109375,
        -3391.0,
        1468.199951171875
      ],
      [
        -1619.0,
        -3391.0,
        1468.199951171875
      ],
      [
        -1623.9429931640625,
        -3390.119140625,
        1468.199951171875
      ],
      [
        -1624.40283203125,
        -3390.50244140625,
        1472.199951171875
      ],
      [
        -1623.7998046875,
        -3390.0,
        1472.199951171875
      ],
      [
        -1590.0,
        -3390.0,
        1469.6109619140625
      ],
      [
        -1590.0,
        -3391.0,
        1471.26708984375
      ],
      [
        -1590.0,
        -3391.0,
        1468.199951171875
      ],
      [
        -1583.2020263671875,
        -3398.337646484375,
        1474.39990234375
      ],
      [
        -1586.1287841796875,
        -3395.9931640625,
        1474.39990234375
      ],
      [
        -1581.2626953125,
        -3399.226806640625,
        1473.2999267578125
      ],
      [
        -1583.1683349609375,
        -3398.303955078125,
        1474.2999267578125
      ],
      [
        -1583.2020263671875,
        -3398.337646484375,
        1474.39990234375
      ],
      [
        -1581.2626953125,
        -3399.226806640625,
        1473.2999267578125
      ],
      [
        -1587.330322265625,
        -3394.3662109375,
        1473.2999267578125
      ],
      [
        -1586.09521484375,
        -3395.95947265625,
        1474.2999267578125
      ],
      [
        -1586.1287841796875,
        -3395.9931640625,
        1474.39990234375
      ],
      [
        -1587.330322265625,
        -3394.3662109375,
        1473.2999267578125
      ],
      [
        -1586.09521484375,
        -3395.95947265625,
        1474.2999267578125
      ],
      [
        -1583.1683349609375,
        -3398.303955078125,
        1474.2999267578125
      ],
      [
        -1584.12255859375,
        -3397.60009765625,
        1474.4000244140625
      ],
      [
        -1585.199951171875,
        -3397.60009765625,
        1475.8292236328125
      ],
      [
        -1585.199951171875,
        -3396.737060546875,
        1474.4000244140625
      ],
      [
        -1585.199951171875,
        -3397.60009765625,
        1475.8292236328125
      ],
      [
        -1623.8280029296875,
        -3390.0234375,
        1467.199951171875
      ],
      [
        -1619.0,
        -3386.0,
        1467.199951171875
      ],
      [
        -1623.7132568359375,
        -3389.927734375,
        1466.199951171875
      ],
      [
        -1586.180419921875,
        -3391.0,
        1466.199951171875
      ],
      [
        -1590.0,
        -3387.9404296875,
        1466.199951171875
      ],
      [
        -1586.180419921875,
        -3391.0,
        1466.199951171875
      ],
      [
        -1590.0,
        -3387.33642578125,
        1465.199951171875
      ],
      [
        -1590.0,
        -3387.9404296875,
        1466.199951171875
      ],
      [
        -1590.0,
        -3388.544189453125,
        1467.199951171875
      ],
      [
        -1586.93408203125,
        -3391.0,
        1467.199951171875
      ],
      [
        -1586.93408203125,
        -3391.0,
        1467.199951171875
      ],
      [
        -1590.0,
        -3388.544189453125,
        1467.199951171875
      ],
      [
        -1590.0,
        -3389.14794921875,
        1468.199951171875
      ],
      [
        -1618.597412109375,
        -3394.5,
        1515.0
      ],
      [
        -1598.4942626953125,
        -3410.0,
        1514.0
      ],
      [
        -1617.219482421875,
        -3395.0,
        1514.0
      ],
      [
        -1621.199951171875,
        -3394.5,
        1514.0
      ],
      [
        -1621.199951171875,
        -3398.554931640625,
        1514.0
      ],
      [
        -1618.597412109375,
        -3394.5,
        1515.0
      ],
      [
        -1620.0,
        -3393.5,
        1514.0
      ],
      [
        -1619.0919189453125,
        -3393.5,
        1514.0
      ],
      [
        -1620.0,
        -3393.5,
        1514.0
      ],
      [
        -1621.199951171875,
        -3394.5,
        1514.0
      ],
      [
        -1620.0,
        -3384.5,
        1500.3006591796875
      ],
      [
        -1621.736328125,
        -3385.947021484375,
        1505.0
      ],
      [
        -1612.593017578125,
        -3384.5,
        1490.4747314453125
      ],
      [
        -1611.7073974609375,
        -3384.5,
        1489.2998046875
      ],
      [
        -1620.0,
        -3384.5,
        1500.3006591796875
      ],
      [
        -1612.593017578125,
        -3384.5,
        1490.4747314453125
      ],
      [
        -1611.7073974609375,
        -3384.5,
        1489.2998046875
      ],
      [
        -1583.2293701171875,
        -3410.0,
        1493.75
      ],
      [
        -1582.0,
        -3410.0,
        1492.119140625
      ],
      [
        -1585.0,
        -3410.0,
        1496.09912109375
      ],
      [
        -1583.2293701171875,
        -3410.0,
        1493.75
      ],
      [
        -1585.0,
        -3410.0,
        1496.0987548828125
      ],
      [
        -1587.18701171875,
        -3410.0,
        1499.0
      ],
      [
        -1591.2574462890625,
        -3410.0,
        1504.4000244140625
      ],
      [
        -1587.18701171875,
        -3410.0,
        1499.0
      ],
      [
        -1598.4942626953125,
        -3410.0,
        1514.0
      ],
      [
        -1591.2574462890625,
        -3410.0,
        1504.4000244140625
      ],
      [
        -1585.0,
        -3410.0,
        1496.0987548828125
      ],
      [
        -1585.0,
        -3411.03662109375,
        1497.8154296875
      ],
      [
        -1585.0,
        -3411.751953125,
        1499.0
      ],
      [
        -1585.0,
        -3411.03662109375,
        1497.8154296875
      ],
      [
        -1585.0,
        -3411.751953125,
        1499.0
      ],
      [
        -1585.0,
        -3415.0126953125,
        1504.4000244140625
      ],
      [
        -1585.0,
        -3415.0126953125,
        1504.4000244140625
      ],
      [
        -1581.992431640625,
        -3411.0,
        1493.7645263671875
      ],
      [
        -1585.0,
        -3411.0,
        1497.754150390625
      ],
      [
        -1582.0,
        -3410.98486328125,
        1493.75
      ],
      [
        -1582.0,
        -3410.0,
        1492.119140625
      ],
      [
        -1582.0,
        -3410.985107421875,
        1493.75
      ],
      [
        -1581.992431640625,
        -3411.0,
        1493.7645263671875
      ],
      [
        -1617.1473388671875,
        -3386.0,
        1499.0
      ],
      [
        -1616.8363037109375,
        -3386.0,
        1498.58740234375
      ],
      [
        -1611.5855712890625,
        -3386.0,
        1491.621826171875
      ],
      [
        -1610.60888671875,
        -3386.0,
        1490.3260498046875
      ],
      [
        -1617.1473388671875,
        -3386.0,
        1499.0
      ],
      [
        -1620.0,
        -3386.0,
        1502.784423828125
      ],
      [
        -1616.8363037109375,
        -3386.0,
        1498.58740234375
      ],
      [
        -1611.5855712890625,
        -3386.0,
        1491.621826171875
      ],
      [
        -1607.7247314453125,
        -3386.0,
        1486.5
      ],
      [
        -1610.60888671875,
        -3386.0,
        1490.3260498046875
      ],
      [
        -1610.5,
        -3391.9287109375,
        1500.0
      ],
      [
        -1610.5,
        -3386.0,
        1490.1817626953125
      ],
      [
        -1613.0,
        -3386.0,
        1493.498291015625
      ],
      [
        -1613.0,
        -3389.926025390625,
        1500.0
      ],
      [
        -1613.0,
        -3389.926025390625,
        1500.0
      ],
      [
        -1612.5,
        -3390.9306640625,
        1501.0
      ],
      [
        -1611.0,
        -3392.132080078125,
        1501.0
      ],
      [
        -1612.5,
        -3390.9306640625,
        1501.0
      ],
      [
        -1610.5,
        -3391.9287109375,
        1500.0
      ],
      [
        -1611.0,
        -3392.132080078125,
        1501.0
      ],
      [
        -1598.986328125,
        -3393.0,
        1486.5
      ],
      [
        -1599.7401123046875,
        -3393.0,
        1487.5
      ],
      [
        -1602.2369384765625,
        -3391.0,
        1487.5
      ],
      [
        -1599.7401123046875,
        -3393.0,
        1487.5
      ],
      [
        -1602.2369384765625,
        -3391.0,
        1487.5
      ],
      [
        -1608.4783935546875,
        -3386.0,
        1487.5
      ],
      [
        -1600.9786376953125,
        -3406.5,
        1511.5
      ],
      [
        -1597.8580322265625,
        -3409.0,
        1511.5
      ],
      [
        -1601.3555908203125,
        -3406.5,
        1512.0
      ],
      [
        -1600.9786376953125,
        -3406.5,
        1511.5
      ],
      [
        -1597.8580322265625,
        -3409.0,
        1511.5
      ],
      [
        -1598.23486328125,
        -3409.0,
        1512.0
      ],
      [
        -1617.5,
        -3386.3212890625,
        1500.0
      ],
      [
        -1617.5,
        -3386.0,
        1499.468017578125
      ],
      [
        -1620.0,
        -3388.7412109375,
        1507.323974609375
      ],
      [
        -1620.0,
        -3393.5,
        1512.4000244140625
      ],
      [
        -1619.5,
        -3394.5,
        1513.4666748046875
      ],
      [
        -1618.0001220703125,
        -3394.5,
        1513.4666748046875
      ],
      [
        -1617.704345703125,
        -3393.90869140625,
        1512.8359375
      ],
      [
        -1620.0,
        -3391.66357421875,
        1512.1636962890625
      ],
      [
        -1617.5,
        -3386.3212890625,
        1500.0
      ],
      [
        -1618.0,
        -3386.524658203125,
        1501.0
      ],
      [
        -1618.0306396484375,
        -3386.5,
        1501.0
      ],
      [
        -1618.0,
        -3386.524658203125,
        1501.0
      ],
      [
        -1617.9010009765625,
        -3386.0,
        1500.0
      ],
      [
        -1618.0306396484375,
        -3386.5,
        1501.0
      ],
      [
        -1620.0,
        -3394.5,
        1513.4666748046875
      ],
      [
        -1617.5,
        -3394.5,
        1513.4666748046875
      ],
      [
        -1617.5,
        -3394.36865234375,
        1513.3265380859375
      ],
      [
        -1617.441650390625,
        -3394.5,
        1513.4666748046875
      ],
      [
        -1610.965576171875,
        -3398.5,
        1511.5
      ],
      [
        -1611.342529296875,
        -3398.5,
        1512.0
      ],
      [
        -1614.0867919921875,
        -3396.0,
        1511.5
      ],
      [
        -1610.965576171875,
        -3398.5,
        1511.5
      ],
      [
        -1614.4637451171875,
        -3396.0,
        1512.0
      ],
      [
        -1614.0867919921875,
        -3396.0,
        1511.5
      ],
      [
        -1617.219482421875,
        -3395.0,
        1514.0
      ],
      [
        -1620.5882568359375,
        -3386.504150390625,
        1504.4000244140625
      ],
      [
        -1620.0,
        -3386.0,
        1502.784423828125
      ],
      [
        -1621.736328125,
        -3385.947021484375,
        1505.0
      ],
      [
        -1621.3648681640625,
        -3387.169921875,
        1506.5325927734375
      ],
      [
        -1628.83544921875,
        -3393.573486328125,
        1506.7105712890625
      ],
      [
        -1620.0,
        -3391.66357421875,
        1512.1636962890625
      ],
      [
        -1620.5882568359375,
        -3386.504150390625,
        1504.4000244140625
      ],
      [
        -1620.0,
        -3388.7412109375,
        1507.323974609375
      ],
      [
        -1621.199951171875,
        -3396.028564453125,
        1514.0
      ],
      [
        -1624.7601318359375,
        -3396.298828125,
        1511.033203125
      ],
      [
        -1623.5426025390625,
        -3384.5,
        1505.0
      ],
      [
        -1627.311767578125,
        -3384.5,
        1510.0
      ],
      [
        -1543.1268310546875,
        -3383.273681640625,
        1396.290771484375
      ],
      [
        -1544.6763916015625,
        -3382.0,
        1384.2362060546875
      ],
      [
        -1552.311279296875,
        -3382.0,
        1312.15576171875
      ],
      [
        -1544.6763916015625,
        -3382.0,
        1384.2362060546875
      ],
      [
        -1543.1268310546875,
        -3383.273681640625,
        1396.290771484375
      ],
      [
        -1543.5052490234375,
        -3382.0,
        1394.68359375
      ],
      [
        -1163.4052734375,
        -3646.800048828125,
        1551.6312255859375
      ],
      [
        -1547.08447265625,
        -3480.6474609375,
        1562.79541015625
      ],
      [
        -1563.135986328125,
        -3428.0,
        1515.0
      ],
      [
        -1599.8870849609375,
        -3394.5,
        1515.0
      ],
      [
        -1555.0,
        -3421.94091796875,
        1486.5
      ],
      [
        -1567.0029296875,
        -3411.0,
        1486.5
      ],
      [
        -1594.428955078125,
        -3386.0,
        1486.5
      ],
      [
        -1568.0997314453125,
        -3410.0,
        1486.5
      ],
      [
        -1549.6859130859375,
        -3410.0,
        1451.0
      ],
      [
        -1551.0,
        -3408.80224609375,
        1451.0
      ],
      [
        -1551.0,
        -3408.8017578125,
        1451.0
      ],
      [
        -1576.0146484375,
        -3386.0,
        1451.0
      ],
      [
        -1595.296630859375,
        -3384.5,
        1485.0
      ],
      [
        -1596.07470703125,
        -3384.5,
        1486.5
      ],
      [
        -1609.5968017578125,
        -3384.5,
        1486.5
      ],
      [
        -1595.296630859375,
        -3384.5,
        1485.0
      ],
      [
        -1581.8101806640625,
        -3384.5,
        1459.0
      ],
      [
        -1587.4263916015625,
        -3386.0,
        1473.0
      ],
      [
        -1564.728271484375,
        -3410.0,
        1480.0
      ],
      [
        -1585.199951171875,
        -3396.39990234375,
        1476.0333251953125
      ],
      [
        -1584.0,
        -3396.39990234375,
        1476.0333251953125
      ],
      [
        -1584.0,
        -3397.60009765625,
        1476.3834228515625
      ],
      [
        -1584.0,
        -3396.39990234375,
        1476.0333251953125
      ],
      [
        -1585.199951171875,
        -3396.39990234375,
        1476.0333251953125
      ],
      [
        -1585.199951171875,
        -3397.60009765625,
        1476.38330078125
      ],
      [
        -1585.199951171875,
        -3397.60009765625,
        1476.38330078125
      ],
      [
        -1584.0,
        -3397.60009765625,
        1476.3834228515625
      ],
      [
        -1549.685546875,
        -3410.0,
        1451.0
      ],
      [
        -1551.0,
        -3410.0,
        1453.5340576171875
      ],
      [
        -1551.0,
        -3410.0,
        1453.5340576171875
      ],
      [
        -1562.994384765625,
        -3410.0,
        1476.6573486328125
      ],
      [
        -1562.994384765625,
        -3410.0,
        1476.6573486328125
      ],
      [
        -1564.728271484375,
        -3410.0,
        1480.0
      ],
      [
        -1542.77392578125,
        -3432.376220703125,
        1485.0
      ],
      [
        -1546.0650634765625,
        -3435.39306640625,
        1486.5
      ],
      [
        -1543.161865234375,
        -3432.73193359375,
        1486.5
      ],
      [
        -1542.77392578125,
        -3432.376220703125,
        1485.0
      ],
      [
        -1538.0,
        -3428.0,
        1466.5406494140625
      ],
      [
        -1538.0,
        -3428.0,
        1466.5406494140625
      ],
      [
        -1538.0,
        -3424.4345703125,
        1459.0
      ],
      [
        -1538.0,
        -3427.755859375,
        1466.0245361328125
      ],
      [
        -1537.86376953125,
        -3427.875,
        1466.013916015625
      ],
      [
        -1576.014892578125,
        -3386.0,
        1451.0
      ],
      [
        -1587.4263916015625,
        -3386.0,
        1473.0
      ],
      [
        -1578.9329833984375,
        -3391.0,
        1467.199951171875
      ],
      [
        -1581.5264892578125,
        -3391.0,
        1472.199951171875
      ],
      [
        -1575.82080078125,
        -3391.0,
        1461.199951171875
      ],
      [
        -1578.4139404296875,
        -3391.0,
        1466.199951171875
      ],
      [
        -1581.3057861328125,
        -3386.0,
        1461.199951171875
      ],
      [
        -1575.82080078125,
        -3391.0,
        1461.199951171875
      ],
      [
        -1578.4139404296875,
        -3391.0,
        1466.199951171875
      ],
      [
        -1583.89892578125,
        -3386.0,
        1466.199951171875
      ],
      [
        -1584.4178466796875,
        -3386.0,
        1467.199951171875
      ],
      [
        -1578.9329833984375,
        -3391.0,
        1467.199951171875
      ],
      [
        -1581.5264892578125,
        -3391.0,
        1472.199951171875
      ],
      [
        -1587.011474609375,
        -3386.0,
        1472.199951171875
      ],
      [
        -1577.65380859375,
        -3387.39990234375,
        1457.1199951171875
      ],
      [
        -1576.0433349609375,
        -3390.39990234375,
        1460.3599853515625
      ],
      [
        -1576.0433349609375,
        -3390.39990234375,
        1460.3599853515625
      ],
      [
        -1576.4791259765625,
        -3390.39990234375,
        1461.199951171875
      ],
      [
        -1576.0,
        -3387.76708984375,
        1454.7078857421875
      ],
      [
        -1576.5958251953125,
        -3387.39990234375,
        1455.0799560546875
      ],
      [
        -1576.0,
        -3386.013671875,
        1451.0
      ],
      [
        -1576.0,
        -3387.76708984375,
        1454.7078857421875
      ],
      [
        -1576.5958251953125,
        -3387.39990234375,
        1455.0799560546875
      ],
      [
        -1577.65380859375,
        -3387.39990234375,
        1457.1199951171875
      ],
      [
        -1571.1109619140625,
        -3403.0,
        1477.5
      ],
      [
        -1570.332763671875,
        -3403.0,
        1476.0
      ],
      [
        -1570.332763671875,
        -3403.0,
        1476.0
      ],
      [
        -1568.68701171875,
        -3404.5,
        1476.0
      ],
      [
        -1566.4931640625,
        -3406.5,
        1476.0
      ],
      [
        -1564.84765625,
        -3408.0,
        1476.0
      ],
      [
        -1568.68701171875,
        -3404.5,
        1476.0
      ],
      [
        -1569.4652099609375,
        -3404.5,
        1477.5
      ],
      [
        -1567.27099609375,
        -3406.5,
        1477.5
      ],
      [
        -1566.4931640625,
        -3406.5,
        1476.0
      ],
      [
        -1564.84765625,
        -3408.0,
        1476.0
      ],
      [
        -1565.6258544921875,
        -3408.0,
        1477.5
      ],
      [
        -1560.5,
        -3405.669921875,
        1462.690673828125
      ],
      [
        -1558.0,
        -3405.0,
        1456.45458984375
      ],
      [
        -1562.62646484375,
        -3408.60595703125,
        1473.0
      ],
      [
        -1562.330078125,
        -3407.5,
        1470.0892333984375
      ],
      [
        -1560.5765380859375,
        -3405.746337890625,
        1463.0
      ],
      [
        -1560.9476318359375,
        -3406.117431640625,
        1464.5
      ],
      [
        -1560.5765380859375,
        -3405.746337890625,
        1463.0
      ],
      [
        -1560.5,
        -3405.669921875,
        1462.690673828125
      ],
      [
        -1562.330078125,
        -3407.5,
        1470.0892333984375
      ],
      [
        -1560.9476318359375,
        -3406.117431640625,
        1464.5
      ],
      [
        -1553.484375,
        -3408.192138671875,
        1454.5
      ],
      [
        -1556.5643310546875,
        -3405.384765625,
        1454.5
      ],
      [
        -1553.484375,
        -3408.192138671875,
        1454.5
      ],
      [
        -1553.0,
        -3410.0,
        1457.3892822265625
      ],
      [
        -1558.0,
        -3405.0,
        1456.45458984375
      ],
      [
        -1556.5643310546875,
        -3405.384765625,
        1454.5
      ],
      [
        -1561.09716796875,
        -3410.0,
        1473.0
      ],
      [
        -1562.62646484375,
        -3408.60595703125,
        1473.0
      ],
      [
        -1573.63427734375,
        -3398.8095703125,
        1473.5023193359375
      ],
      [
        -1572.2724609375,
        -3400.06982421875,
        1473.541748046875
      ],
      [
        -1571.3870849609375,
        -3400.76220703125,
        1473.2999267578125
      ],
      [
        -1572.26904296875,
        -3400.064208984375,
        1473.52294921875
      ],
      [
        -1572.2724609375,
        -3400.06982421875,
        1473.541748046875
      ],
      [
        -1571.3870849609375,
        -3400.76220703125,
        1473.2999267578125
      ],
      [
        -1574.172119140625,
        -3398.2236328125,
        1473.2999267578125
      ],
      [
        -1573.6292724609375,
        -3398.806640625,
        1473.4866943359375
      ],
      [
        -1573.63427734375,
        -3398.8095703125,
        1473.5023193359375
      ],
      [
        -1574.172119140625,
        -3398.2236328125,
        1473.2999267578125
      ],
      [
        -1572.26904296875,
        -3400.064208984375,
        1473.52294921875
      ],
      [
        -1573.6292724609375,
        -3398.806640625,
        1473.4866943359375
      ],
      [
        -1587.76806640625,
        -3384.5,
        1470.4864501953125
      ],
      [
        -1590.7275390625,
        -3382.0,
        1470.90380859375
      ],
      [
        -1562.6173095703125,
        -3428.0,
        1514.0
      ],
      [
        -1582.3641357421875,
        -3410.0,
        1514.0
      ],
      [
        -1582.3641357421875,
        -3410.0,
        1514.0
      ],
      [
        -1598.8197021484375,
        -3395.0,
        1514.0
      ],
      [
        -1600.4654541015625,
        -3393.5,
        1514.0
      ],
      [
        -1599.8870849609375,
        -3394.5,
        1515.0
      ],
      [
        -1619.0919189453125,
        -3393.5,
        1514.0
      ],
      [
        -1574.6510009765625,
        -3429.10009765625,
        1514.0
      ],
      [
        -1563.135986328125,
        -3428.0,
        1515.0
      ],
      [
        -1561.4105224609375,
        -3429.10009765625,
        1514.0
      ],
      [
        -1550.0,
        -3436.374755859375,
        1507.38671875
      ],
      [
        -1605.6710205078125,
        -3384.5,
        1505.0
      ],
      [
        -1596.685302734375,
        -3396.0,
        1512.0
      ],
      [
        -1596.42578125,
        -3396.0,
        1511.5
      ],
      [
        -1547.94677734375,
        -3437.117919921875,
        1505.0
      ],
      [
        -1593.683349609375,
        -3398.5,
        1511.5
      ],
      [
        -1593.94287109375,
        -3398.5,
        1512.0
      ],
      [
        -1596.42578125,
        -3396.0,
        1511.5
      ],
      [
        -1593.683349609375,
        -3398.5,
        1511.5
      ],
      [
        -1569.59130859375,
        -3410.0,
        1489.375
      ],
      [
        -1571.860595703125,
        -3410.0,
        1493.75
      ],
      [
        -1568.0997314453125,
        -3410.0,
        1486.5
      ],
      [
        -1569.59130859375,
        -3410.0,
        1489.375
      ],
      [
        -1582.3641357421875,
        -3410.0,
        1514.0
      ],
      [
        -1580.5,
        -3410.0,
        1510.406005859375
      ],
      [
        -1574.5,
        -3410.0,
        1498.8387451171875
      ],
      [
        -1571.860595703125,
        -3410.0,
        1493.75
      ],
      [
        -1557.6378173828125,
        -3428.0,
        1504.4000244140625
      ],
      [
        -1555.0,
        -3428.0,
        1499.3145751953125
      ],
      [
        -1562.6173095703125,
        -3428.0,
        1514.0
      ],
      [
        -1557.6378173828125,
        -3428.0,
        1504.4000244140625
      ],
      [
        -1571.5,
        -3419.9033203125,
        1514.0
      ],
      [
        -1569.0,
        -3413.907958984375,
        1496.5
      ],
      [
        -1555.0,
        -3428.0,
        1499.3145751953125
      ],
      [
        -1555.0,
        -3427.851318359375,
        1499.0
      ],
      [
        -1555.0,
        -3427.851318359375,
        1499.0
      ],
      [
        -1555.0,
        -3421.94091796875,
        1486.5
      ],
      [
        -1561.0,
        -3421.2001953125,
        1496.5
      ],
      [
        -1559.3890380859375,
        -3428.0,
        1507.7763671875
      ],
      [
        -1561.0,
        -3421.2001953125,
        1496.5
      ],
      [
        -1569.0,
        -3413.907958984375,
        1496.5
      ],
      [
        -1567.0029296875,
        -3411.0,
        1486.5
      ],
      [
        -1567.571533203125,
        -3411.0,
        1486.5
      ],
      [
        -1567.78759765625,
        -3411.0,
        1488.0125732421875
      ],
      [
        -1580.5,
        -3410.0,
        1510.406005859375
      ],
      [
        -1580.5,
        -3411.0,
        1512.5205078125
      ],
      [
        -1581.2674560546875,
        -3411.0,
        1514.0
      ],
      [
        -1580.5,
        -3411.0,
        1512.5205078125
      ],
      [
        -1568.4942626953125,
        -3411.0,
        1489.375
      ],
      [
        -1570.763427734375,
        -3411.0,
        1493.75
      ],
      [
        -1568.4942626953125,
        -3411.0,
        1489.375
      ],
      [
        -1570.7637939453125,
        -3411.0,
        1493.75
      ],
      [
        -1574.5,
        -3411.0,
        1500.9532470703125
      ],
      [
        -1574.5,
        -3411.0,
        1500.9532470703125
      ],
      [
        -1574.5,
        -3410.0,
        1498.8387451171875
      ],
      [
        -1602.55859375,
        -3384.5,
        1499.0
      ],
      [
        -1604.4454345703125,
        -3384.5,
        1502.6373291015625
      ],
      [
        -1598.927734375,
        -3384.5,
        1492.0
      ],
      [
        -1605.6710205078125,
        -3384.5,
        1505.0
      ],
      [
        -1604.4454345703125,
        -3384.5,
        1502.6373291015625
      ],
      [
        -1598.8197021484375,
        -3395.0,
        1514.0
      ],
      [
        -1603.7137451171875,
        -3386.0,
        1504.4000244140625
      ],
      [
        -1620.0,
        -3384.5,
        1502.7996826171875
      ],
      [
        -1621.375,
        -3385.645751953125,
        1504.02197265625
      ],
      [
        -1603.7137451171875,
        -3386.0,
        1504.4000244140625
      ],
      [
        -1600.912841796875,
        -3386.0,
        1499.0
      ],
      [
        -1594.428955078125,
        -3386.0,
        1486.5
      ],
      [
        -1597.281982421875,
        -3386.0,
        1492.0
      ],
      [
        -1597.281982421875,
        -3386.0,
        1492.0
      ],
      [
        -1598.927734375,
        -3384.5,
        1492.0
      ],
      [
        -1597.8602294921875,
        -3385.0,
        1491.0
      ],
      [
        -1598.37890625,
        -3385.0,
        1492.0
      ],
      [
        -1609.5,
        -3385.0,
        1492.0
      ],
      [
        -1609.5,
        -3385.0,
        1492.0
      ],
      [
        -1598.37890625,
        -3385.0,
        1492.0
      ],
      [
        -1597.8602294921875,
        -3385.0,
        1491.0
      ],
      [
        -1602.52880859375,
        -3385.0,
        1500.0
      ],
      [
        -1602.52880859375,
        -3385.0,
        1500.0
      ],
      [
        -1602.55859375,
        -3384.5,
        1499.0
      ],
      [
        -1606.5,
        -3385.0,
        1499.0
      ],
      [
        -1602.010009765625,
        -3385.0,
        1499.0
      ],
      [
        -1608.5,
        -3385.0,
        1497.5
      ],
      [
        -1608.5,
        -3385.0,
        1493.5
      ],
      [
        -1608.5,
        -3385.0,
        1493.5
      ],
      [
        -1606.5,
        -3385.0,
        1492.0
      ],
      [
        -1608.5,
        -3385.0,
        1497.5
      ],
      [
        -1606.5,
        -3385.0,
        1499.0
      ],
      [
        -1600.912841796875,
        -3386.0,
        1499.0
      ],
      [
        -1589.4622802734375,
        -3391.0,
        1487.5
      ],
      [
        -1587.2679443359375,
        -3393.0,
        1487.5
      ],
      [
        -1589.4622802734375,
        -3391.0,
        1487.5
      ],
      [
        -1594.947509765625,
        -3386.0,
        1487.5
      ],
      [
        -1586.7491455078125,
        -3393.0,
        1486.5
      ],
      [
        -1587.2679443359375,
        -3393.0,
        1487.5
      ],
      [
        -1594.0203857421875,
        -3388.5,
        1491.0
      ],
      [
        -1595.92529296875,
        -3387.0,
        1491.5
      ],
      [
        -1593.76123046875,
        -3388.5,
        1490.5
      ],
      [
        -1594.0203857421875,
        -3388.5,
        1491.0
      ],
      [
        -1593.850341796875,
        -3387.0,
        1487.5
      ],
      [
        -1595.92529296875,
        -3387.0,
        1491.5
      ],
      [
        -1595.92529296875,
        -3387.0,
        1491.5
      ],
      [
        -1597.0224609375,
        -3386.0,
        1491.5
      ],
      [
        -1595.4066162109375,
        -3387.0,
        1490.5
      ],
      [
        -1593.76123046875,
        -3388.5,
        1490.5
      ],
      [
        -1595.4727783203125,
        -3392.11865234375,
        1501.4530029296875
      ],
      [
        -1595.5,
        -3392.098388671875,
        1501.4627685546875
      ],
      [
        -1595.5,
        -3392.058837890625,
        1501.3792724609375
      ],
      [
        -1595.4727783203125,
        -3392.11865234375,
        1501.4530029296875
      ],
      [
        -1601.0,
        -3387.6845703125,
        1502.7305908203125
      ],
      [
        -1601.0,
        -3387.139892578125,
        1501.5787353515625
      ],
      [
        -1605.5,
        -3387.314208984375,
        1501.4000244140625
      ],
      [
        -1605.5,
        -3388.0947265625,
        1500.5999755859375
      ],
      [
        -1602.5999755859375,
        -3388.0947265625,
        1500.5999755859375
      ],
      [
        -1602.5999755859375,
        -3387.314208984375,
        1501.4000244140625
      ],
      [
        -1603.4000244140625,
        -3388.094970703125,
        1500.5999755859375
      ],
      [
        -1603.4000244140625,
        -3387.314453125,
        1501.4000244140625
      ],
      [
        -1601.0,
        -3388.0947265625,
        1500.5999755859375
      ],
      [
        -1601.0,
        -3387.314208984375,
        1501.4000244140625
      ],
      [
        -1601.345458984375,
        -3386.927734375,
        1501.796142578125
      ],
      [
        -1601.0,
        -3387.6845703125,
        1502.7305908203125
      ],
      [
        -1601.345458984375,
        -3386.927734375,
        1501.796142578125
      ],
      [
        -1601.0,
        -3387.139892578125,
        1501.5787353515625
      ],
      [
        -1595.5,
        -3392.098388671875,
        1501.4627685546875
      ],
      [
        -1595.5,
        -3392.058837890625,
        1501.3792724609375
      ],
      [
        -1605.6710205078125,
        -3384.5,
        1505.0
      ],
      [
        -1608.2640380859375,
        -3384.5,
        1510.0
      ],
      [
        -1551.0,
        -3386.0,
        1463.3240966796875
      ],
      [
        -1585.748046875,
        -3386.0,
        1469.764404296875
      ],
      [
        -1548.199951171875,
        -3386.0,
        1462.80517578125
      ],
      [
        -1550.0,
        -3384.5,
        1462.9552001953125
      ],
      [
        -1548.199951171875,
        -3386.0,
        1459.0
      ],
      [
        -1538.0,
        -3394.5,
        1461.954833984375
      ],
      [
        -1538.0,
        -3427.755859375,
        1466.0245361328125
      ],
      [
        -1539.0,
        -3410.0,
        1464.0369873046875
      ],
      [
        -1551.0,
        -3410.0,
        1466.2611083984375
      ],
      [
        -1551.0,
        -3410.0,
        1466.2611083984375
      ],
      [
        -1558.303955078125,
        -3410.0,
        1467.6148681640625
      ],
      [
        -1539.0,
        -3396.0,
        1462.32373046875
      ],
      [
        -1539.0,
        -3410.0,
        1464.0369873046875
      ],
      [
        -1538.0,
        -3394.5,
        1461.954833984375
      ],
      [
        -1539.0,
        -3393.666748046875,
        1462.0382080078125
      ],
      [
        -1539.0,
        -3393.666748046875,
        1459.0
      ],
      [
        -1539.0,
        -3396.0,
        1462.32373046875
      ],
      [
        -1551.0,
        -3386.0,
        1463.3240966796875
      ],
      [
        -1545.000244140625,
        -3391.0,
        1461.199951171875
      ],
      [
        -1545.000244140625,
        -3391.0,
        1461.199951171875
      ],
      [
        -1545.000244140625,
        -3391.0,
        1462.823974609375
      ],
      [
        -1543.5,
        -3391.0,
        1462.5458984375
      ],
      [
        -1547.0,
        -3404.5,
        1464.8466796875
      ],
      [
        -1539.0,
        -3404.5,
        1463.3638916015625
      ],
      [
        -1558.479736328125,
        -3390.0,
        1465.199951171875
      ],
      [
        -1551.0,
        -3390.0,
        1463.8135986328125
      ],
      [
        -1574.6656494140625,
        -3390.0,
        1468.199951171875
      ],
      [
        -1575.0,
        -3390.0,
        1468.261962890625
      ],
      [
        -1558.47998046875,
        -3390.0,
        1465.199951171875
      ],
      [
        -1560.460693359375,
        -3387.0,
        1465.199951171875
      ],
      [
        -1575.0,
        -3386.0,
        1465.199951171875
      ],
      [
        -1575.0,
        -3386.0,
        1462.199951171875
      ],
      [
        -1551.0,
        -3386.0,
        1462.199951171875
      ],
      [
        -1551.0,
        -3386.0,
        1463.3240966796875
      ],
      [
        -1551.0,
        -3387.0,
        1463.446533203125
      ],
      [
        -1580.0299072265625,
        -3390.0,
        1467.199951171875
      ],
      [
        -1575.0,
        -3390.0,
        1467.199951171875
      ],
      [
        -1575.0,
        -3390.0,
        1467.199951171875
      ],
      [
        -1575.0,
        -3389.49365234375,
        1468.199951171875
      ],
      [
        -1575.0,
        -3386.65234375,
        1467.852294921875
      ],
      [
        -1575.0,
        -3386.65234375,
        1467.8521728515625
      ],
      [
        -1575.0,
        -3386.0,
        1467.7724609375
      ],
      [
        -1575.0,
        -3389.4931640625,
        1468.199951171875
      ],
      [
        -1574.6654052734375,
        -3390.0,
        1468.199951171875
      ],
      [
        -1579.510986328125,
        -3390.0,
        1466.199951171875
      ],
      [
        -1575.0,
        -3390.0,
        1466.199951171875
      ],
      [
        -1575.0,
        -3390.0,
        1466.199951171875
      ],
      [
        -1547.0,
        -3397.0,
        1463.9288330078125
      ],
      [
        -1547.0,
        -3397.0,
        1462.199951171875
      ],
      [
        -1539.0,
        -3397.0,
        1462.199951171875
      ],
      [
        -1539.0,
        -3397.0,
        1462.446044921875
      ],
      [
        -1547.0,
        -3397.0,
        1462.199951171875
      ],
      [
        -1547.0,
        -3397.0,
        1463.9288330078125
      ],
      [
        -1547.0,
        -3404.5,
        1464.8466796875
      ],
      [
        -1547.0,
        -3404.5,
        1462.199951171875
      ],
      [
        -1551.0,
        -3391.0,
        1462.199951171875
      ],
      [
        -1551.0,
        -3391.0,
        1463.93603515625
      ],
      [
        -1545.000244140625,
        -3391.0,
        1462.199951171875
      ],
      [
        -1580.0308837890625,
        -3391.0,
        1469.316650390625
      ],
      [
        -1575.0,
        -3391.0,
        1468.38427734375
      ],
      [
        -1576.3394775390625,
        -3391.0,
        1462.199951171875
      ],
      [
        -1575.0,
        -3391.0,
        1462.199951171875
      ],
      [
        -1575.0,
        -3391.0,
        1468.38427734375
      ],
      [
        -1575.0,
        -3390.0,
        1468.261962890625
      ],
      [
        -1575.0,
        -3391.0,
        1462.199951171875
      ],
      [
        -1551.0,
        -3391.0,
        1463.93603515625
      ],
      [
        -1551.0,
        -3391.0,
        1462.199951171875
      ],
      [
        -1551.0,
        -3390.0,
        1463.8135986328125
      ],
      [
        -1555.5,
        -3405.669921875,
        1466.5653076171875
      ],
      [
        -1553.669921875,
        -3407.5,
        1466.4500732421875
      ],
      [
        -1558.0,
        -3405.0,
        1466.9466552734375
      ],
      [
        -1555.5,
        -3405.669921875,
        1466.5653076171875
      ],
      [
        -1553.669921875,
        -3407.5,
        1466.4500732421875
      ],
      [
        -1553.0,
        -3410.0,
        1466.6318359375
      ],
      [
        -1560.5,
        -3405.669921875,
        1467.4920654296875
      ],
      [
        -1558.0,
        -3405.0,
        1466.9466552734375
      ],
      [
        -1561.7855224609375,
        -3406.955322265625,
        1467.8875732421875
      ],
      [
        -1560.5,
        -3405.669921875,
        1467.4920654296875
      ],
      [
        -1547.524658203125,
        -3386.562744140625,
        1505.0
      ],
      [
        -1548.1597900390625,
        -3394.5,
        1513.4664306640625
      ],
      [
        -1550.0,
        -3384.5,
        1502.7996826171875
      ],
      [
        -1547.524658203125,
        -3386.562744140625,
        1505.0
      ],
      [
        -1550.0,
        -3395.937744140625,
        1515.0
      ],
      [
        -1548.1597900390625,
        -3394.5,
        1513.4664306640625
      ],
      [
        -1548.800048828125,
        -3428.0,
        1514.0
      ],
      [
        -1548.800048828125,
        -3395.000244140625,
        1514.0
      ],
      [
        -1550.0,
        -3429.10009765625,
        1514.0
      ],
      [
        -1561.4105224609375,
        -3429.10009765625,
        1514.0
      ],
      [
        -1538.0,
        -3427.142822265625,
        1485.0
      ],
      [
        -1538.0,
        -3428.0,
        1485.25
      ],
      [
        -1538.0,
        -3427.142822265625,
        1485.0
      ],
      [
        -1538.0,
        -3394.5,
        1475.4791259765625
      ],
      [
        -1550.0,
        -3384.5,
        1486.5
      ],
      [
        -1538.0,
        -3394.5,
        1486.5
      ],
      [
        -1538.0,
        -3394.5,
        1475.4791259765625
      ],
      [
        -1550.0,
        -3384.5,
        1472.5625
      ],
      [
        -1551.0,
        -3402.0,
        1477.6666259765625
      ],
      [
        -1539.0,
        -3402.0,
        1477.6666259765625
      ],
      [
        -1538.0,
        -3428.0,
        1486.5
      ],
      [
        -1538.0,
        -3428.0,
        1485.25
      ],
      [
        -1542.6751708984375,
        -3432.28564453125,
        1486.5
      ],
      [
        -1551.0,
        -3402.0,
        1477.6666259765625
      ],
      [
        -1551.0,
        -3402.645263671875,
        1477.854736328125
      ],
      [
        -1551.0,
        -3402.645263671875,
        1477.854736328125
      ],
      [
        -1551.0,
        -3404.857177734375,
        1478.5
      ],
      [
        -1569.800048828125,
        -3397.60009765625,
        1476.3834228515625
      ],
      [
        -1569.800048828125,
        -3396.39990234375,
        1476.0333251953125
      ],
      [
        -1571.0,
        -3396.39990234375,
        1476.0333251953125
      ],
      [
        -1569.800048828125,
        -3396.39990234375,
        1476.0333251953125
      ],
      [
        -1571.0,
        -3396.39990234375,
        1476.0333251953125
      ],
      [
        -1571.0,
        -3397.60009765625,
        1476.3834228515625
      ],
      [
        -1571.0,
        -3397.60009765625,
        1476.3834228515625
      ],
      [
        -1569.800048828125,
        -3397.60009765625,
        1476.3834228515625
      ],
      [
        -1557.199951171875,
        -3396.39990234375,
        1476.0333251953125
      ],
      [
        -1556.0,
        -3396.39990234375,
        1476.0333251953125
      ],
      [
        -1557.199951171875,
        -3396.39990234375,
        1476.0333251953125
      ],
      [
        -1557.199951171875,
        -3397.60009765625,
        1476.3834228515625
      ],
      [
        -1556.0,
        -3397.60009765625,
        1476.3834228515625
      ],
      [
        -1556.0,
        -3396.39990234375,
        1476.0333251953125
      ],
      [
        -1557.199951171875,
        -3397.60009765625,
        1476.3834228515625
      ],
      [
        -1556.0,
        -3397.60009765625,
        1476.3834228515625
      ],
      [
        -1555.0,
        -3411.0,
        1504.4000244140625
      ],
      [
        -1555.0,
        -3411.0,
        1499.0
      ],
      [
        -1555.0,
        -3411.0,
        1514.0
      ],
      [
        -1555.0,
        -3411.0,
        1504.4000244140625
      ],
      [
        -1555.0,
        -3411.0,
        1499.0
      ],
      [
        -1555.0,
        -3411.0,
        1486.5
      ],
      [
        -1543.197998046875,
        -3432.764892578125,
        1486.6397705078125
      ],
      [
        -1558.5,
        -3428.0,
        1514.0
      ],
      [
        -1559.38916015625,
        -3428.0,
        1507.7763671875
      ],
      [
        -1558.7225341796875,
        -3430.813720703125,
        1512.442138671875
      ],
      [
        -1558.4998779296875,
        -3429.10009765625,
        1514.0
      ],
      [
        -1555.0,
        -3433.18701171875,
        1510.28466796875
      ],
      [
        -1555.0,
        -3429.10009765625,
        1514.0
      ],
      [
        -1577.5,
        -3385.0,
        1499.0
      ],
      [
        -1602.0101318359375,
        -3385.0,
        1499.0
      ],
      [
        -1577.5,
        -3385.0,
        1499.0
      ],
      [
        -1602.0101318359375,
        -3385.0,
        1499.0
      ],
      [
        -1550.0,
        -3384.5,
        1499.0
      ],
      [
        -1549.4000244140625,
        -3385.0,
        1499.0
      ],
      [
        -1549.4000244140625,
        -3385.0,
        1503.3330078125
      ],
      [
        -1548.199951171875,
        -3386.0,
        1499.0
      ],
      [
        -1548.199951171875,
        -3386.0,
        1504.3997802734375
      ],
      [
        -1580.5,
        -3385.0,
        1492.0
      ],
      [
        -1598.379150390625,
        -3385.0,
        1492.0
      ],
      [
        -1560.0,
        -3385.0,
        1488.0
      ],
      [
        -1570.0,
        -3385.0,
        1488.0
      ],
      [
        -1550.0,
        -3384.5,
        1488.0
      ],
      [
        -1549.4000244140625,
        -3385.0,
        1486.5
      ],
      [
        -1549.4000244140625,
        -3385.0,
        1488.0
      ],
      [
        -1560.0,
        -3385.0,
        1488.0
      ],
      [
        -1560.54541015625,
        -3384.5,
        1492.0
      ],
      [
        -1560.54541015625,
        -3385.0,
        1492.0
      ],
      [
        -1550.0,
        -3384.5,
        1492.0
      ],
      [
        -1549.4000244140625,
        -3385.0,
        1492.0
      ],
      [
        -1569.45458984375,
        -3384.5,
        1492.0
      ],
      [
        -1570.0,
        -3385.0,
        1488.0
      ],
      [
        -1569.45458984375,
        -3385.0,
        1492.0
      ],
      [
        -1568.5,
        -3385.0,
        1499.0
      ],
      [
        -1578.5,
        -3385.0,
        1493.5
      ],
      [
        -1578.5,
        -3385.0,
        1497.5
      ],
      [
        -1578.5,
        -3385.0,
        1493.5
      ],
      [
        -1580.5,
        -3385.0,
        1492.0
      ],
      [
        -1578.5,
        -3385.0,
        1497.5
      ],
      [
        -1580.5,
        -3385.0,
        1499.0
      ],
      [
        -1561.5,
        -3385.0,
        1499.0
      ],
      [
        -1549.4000244140625,
        -3385.0,
        1499.0
      ],
      [
        -1548.199951171875,
        -3386.0,
        1486.5
      ],
      [
        -1560.54541015625,
        -3385.0,
        1492.0
      ],
      [
        -1560.54541015625,
        -3386.0,
        1492.0
      ],
      [
        -1569.45458984375,
        -3386.0,
        1492.0
      ],
      [
        -1569.45458984375,
        -3385.0,
        1492.0
      ],
      [
        -1570.0,
        -3387.333251953125,
        1487.5
      ],
      [
        -1560.0,
        -3387.333251953125,
        1487.5
      ],
      [
        -1570.0,
        -3386.0,
        1487.5
      ],
      [
        -1570.0,
        -3387.333251953125,
        1487.5
      ],
      [
        -1560.0,
        -3387.333251953125,
        1487.5
      ],
      [
        -1560.0,
        -3386.0,
        1487.5
      ],
      [
        -1576.5,
        -3387.3330078125,
        1487.5
      ],
      [
        -1576.5,
        -3389.99951171875,
        1486.5
      ],
      [
        -1595.406494140625,
        -3387.0,
        1490.5
      ],
      [
        -1580.5,
        -3387.0,
        1490.5
      ],
      [
        -1580.5,
        -3387.0,
        1490.5
      ],
      [
        -1580.5,
        -3386.0,
        1490.5
      ],
      [
        -1570.0,
        -3387.0,
        1487.625
      ],
      [
        -1560.0,
        -3387.0,
        1487.625
      ],
      [
        -1570.0,
        -3387.0,
        1487.625
      ],
      [
        -1570.0,
        -3387.0,
        1487.5
      ],
      [
        -1560.0,
        -3387.0,
        1487.625
      ],
      [
        -1560.0,
        -3387.0,
        1487.5
      ],
      [
        -1580.5,
        -3387.0,
        1487.6248779296875
      ],
      [
        -1580.5,
        -3386.0,
        1487.9998779296875
      ],
      [
        -1595.5,
        -3387.314208984375,
        1501.4000244140625
      ],
      [
        -1595.5,
        -3388.0947265625,
        1500.5999755859375
      ],
      [
        -1592.5999755859375,
        -3388.0947265625,
        1500.5999755859375
      ],
      [
        -1592.5999755859375,
        -3387.314208984375,
        1501.4000244140625
      ],
      [
        -1593.4000244140625,
        -3388.094970703125,
        1500.5999755859375
      ],
      [
        -1593.4000244140625,
        -3387.314453125,
        1501.4000244140625
      ],
      [
        -1591.0,
        -3388.0947265625,
        1500.5999755859375
      ],
      [
        -1591.0,
        -3387.314208984375,
        1501.4000244140625
      ],
      [
        -1580.5,
        -3388.0947265625,
        1500.5999755859375
      ],
      [
        -1580.5,
        -3387.314208984375,
        1501.4000244140625
      ],
      [
        -1582.800048828125,
        -3387.314208984375,
        1501.4000244140625
      ],
      [
        -1582.800048828125,
        -3388.0947265625,
        1500.5999755859375
      ],
      [
        -1582.0,
        -3387.314453125,
        1501.4000244140625
      ],
      [
        -1582.0,
        -3388.094970703125,
        1500.5999755859375
      ],
      [
        -1582.800048828125,
        -3389.916015625,
        1498.73291015625
      ],
      [
        -1585.0,
        -3387.314208984375,
        1501.4000244140625
      ],
      [
        -1548.199951171875,
        -3386.0,
        1473.0
      ],
      [
        -1548.199951171875,
        -3386.0,
        1462.80517578125
      ],
      [
        -1543.158935546875,
        -3384.5,
        1462.083740234375
      ],
      [
        -1543.08154296875,
        -3386.0,
        1462.1531982421875
      ],
      [
        -1548.2000732421875,
        -3386.0,
        1463.1171875
      ],
      [
        -1543.08154296875,
        -3386.0,
        1462.1531982421875
      ],
      [
        -1543.158935546875,
        -3384.5,
        1462.083740234375
      ],
      [
        -1538.0,
        -3384.5,
        1461.1119384765625
      ],
      [
        -1538.0,
        -3386.0,
        1461.1959228515625
      ],
      [
        -1538.0,
        -3394.5,
        1472.3194580078125
      ],
      [
        -1548.199951171875,
        -3386.0,
        1472.3194580078125
      ],
      [
        -1540.0281982421875,
        -3402.0,
        1475.0
      ],
      [
        -1538.0,
        -3428.0,
        1482.09033203125
      ],
      [
        -1542.633056640625,
        -3432.2470703125,
        1484.4552001953125
      ],
      [
        -1540.0281982421875,
        -3402.0,
        1475.0
      ],
      [
        -1539.0,
        -3402.85693359375,
        1475.0
      ],
      [
        -1542.4287109375,
        -3402.0,
        1475.0
      ],
      [
        -1542.4287109375,
        -3409.0,
        1475.0
      ],
      [
        -1542.4287109375,
        -3402.0,
        1475.0
      ],
      [
        -1544.14306640625,
        -3402.0,
        1476.0001220703125
      ],
      [
        -1551.0,
        -3386.0,
        1468.199951171875
      ],
      [
        -1551.0,
        -3386.0,
        1471.199951171875
      ],
      [
        -1546.199951171875,
        -3390.0,
        1471.199951171875
      ],
      [
        -1546.199951171875,
        -3390.0,
        1468.199951171875
      ],
      [
        -1575.0,
        -3386.0,
        1471.199951171875
      ],
      [
        -1575.0,
        -3386.0,
        1468.199951171875
      ],
      [
        -1551.0,
        -3386.0,
        1468.199951171875
      ],
      [
        -1551.0,
        -3386.0,
        1471.199951171875
      ],
      [
        -1551.0,
        -3390.0,
        1467.199951171875
      ],
      [
        -1551.0,
        -3390.0,
        1466.199951171875
      ],
      [
        -1551.0,
        -3390.0,
        1467.199951171875
      ],
      [
        -1544.699951171875,
        -3390.0,
        1467.199951171875
      ],
      [
        -1551.0,
        -3386.0,
        1467.199951171875
      ],
      [
        -1546.199951171875,
        -3390.0,
        1467.199951171875
      ],
      [
        -1546.199951171875,
        -3390.0,
        1462.9239501953125
      ],
      [
        -1544.699951171875,
        -3390.0,
        1466.199951171875
      ],
      [
        -1546.1998291015625,
        -3390.0,
        1466.199951171875
      ],
      [
        -1551.0,
        -3390.0,
        1466.199951171875
      ],
      [
        -1551.0,
        -3391.0,
        1471.199951171875
      ],
      [
        -1543.5,
        -3391.0,
        1471.199951171875
      ],
      [
        -1581.0078125,
        -3391.0,
        1471.199951171875
      ],
      [
        -1575.0,
        -3391.0,
        1471.199951171875
      ],
      [
        -1551.0,
        -3391.0,
        1471.199951171875
      ],
      [
        -1545.0,
        -3391.0,
        1462.823974609375
      ],
      [
        -1546.199951171875,
        -3390.0,
        1466.199951171875
      ],
      [
        -1545.0,
        -3391.0,
        1466.199951171875
      ],
      [
        -1546.199951171875,
        -3390.0,
        1467.199951171875
      ],
      [
        -1545.0,
        -3391.0,
        1471.199951171875
      ],
      [
        -1545.0,
        -3391.0,
        1467.199951171875
      ],
      [
        -1575.0,
        -3391.0,
        1471.199951171875
      ],
      [
        -1539.0,
        -3396.0,
        1471.199951171875
      ],
      [
        -1551.0,
        -3404.5,
        1477.5
      ],
      [
        -1551.0,
        -3403.0,
        1477.958251953125
      ],
      [
        -1551.0,
        -3404.5,
        1478.395751953125
      ],
      [
        -1551.0,
        -3403.0,
        1475.0
      ],
      [
        -1551.0,
        -3404.5,
        1475.0
      ],
      [
        -1542.4287109375,
        -3404.5,
        1475.0
      ],
      [
        -1542.4287109375,
        -3403.0,
        1475.0
      ],
      [
        -1551.0,
        -3404.5,
        1475.0
      ],
      [
        -1551.0,
        -3403.0,
        1475.0
      ],
      [
        -1551.0,
        -3404.5,
        1476.0
      ],
      [
        -1545.000244140625,
        -3391.0,
        1472.199951171875
      ],
      [
        -1545.000244140625,
        -3391.0,
        1472.199951171875
      ],
      [
        -1545.000244140625,
        -3391.0,
        1471.199951171875
      ],
      [
        -1551.0,
        -3406.5,
        1477.5
      ],
      [
        -1551.0,
        -3406.5,
        1478.5
      ],
      [
        -1551.0,
        -3408.0,
        1478.5
      ],
      [
        -1551.0,
        -3409.0,
        1476.0
      ],
      [
        -1538.0,
        -3390.236328125,
        1461.43310546875
      ],
      [
        -1536.0374755859375,
        -3384.5,
        1460.7421875
      ],
      [
        -1563.4156494140625,
        -3384.5,
        1531.309814453125
      ],
      [
        -1554.9222412109375,
        -3384.5,
        1526.001220703125
      ],
      [
        -1554.9222412109375,
        -3384.5,
        1526.001220703125
      ],
      [
        -1554.422119140625,
        -3384.5,
        1526.8013916015625
      ],
      [
        -1562.91552734375,
        -3384.5,
        1532.1099853515625
      ],
      [
        -1563.4156494140625,
        -3384.5,
        1531.309814453125
      ],
      [
        -1543.2879638671875,
        -3382.0,
        1461.968017578125
      ],
      [
        -1549.883056640625,
        -3382.0,
        1463.210205078125
      ],
      [
        -1543.2879638671875,
        -3382.0,
        1461.968017578125
      ],
      [
        -1536.5770263671875,
        -3382.0,
        1460.703857421875
      ],
      [
        -1552.932861328125,
        -3382.0,
        1463.78466796875
      ],
      [
        -1549.883056640625,
        -3382.0,
        1463.210205078125
      ],
      [
        -1552.932861328125,
        -3382.0,
        1463.78466796875
      ],
      [
        -1573.5,
        -3382.0,
        1488.0
      ],
      [
        -1557.0,
        -3382.0,
        1488.0
      ],
      [
        -1573.5,
        -3382.0,
        1486.5
      ],
      [
        -1557.0,
        -3382.0,
        1486.5
      ],
      [
        -1573.5,
        -3382.0,
        1486.5
      ],
      [
        -1573.5,
        -3382.0,
        1488.0
      ],
      [
        -1557.0,
        -3382.0,
        1488.0
      ],
      [
        -1557.0,
        -3382.0,
        1486.5
      ],
      [
        -1563.3309326171875,
        -3382.0,
        1531.2568359375
      ],
      [
        -1554.83740234375,
        -3382.0,
        1525.9482421875
      ],
      [
        -1554.83740234375,
        -3382.0,
        1525.9482421875
      ],
      [
        -1554.3372802734375,
        -3382.0,
        1526.7484130859375
      ],
      [
        -1562.830810546875,
        -3382.0,
        1532.0570068359375
      ],
      [
        -1563.3309326171875,
        -3382.0,
        1531.2568359375
      ],
      [
        -1536.1141357421875,
        -3382.0,
        1460.61669921875
      ],
      [
        -1536.1141357421875,
        -3382.0,
        1460.61669921875
      ],
      [
        -1573.1328125,
        -3287.9814453125,
        1324.192626953125
      ],
      [
        -1625.0,
        -3331.0,
        1493.5
      ],
      [
        -1549.5,
        -3331.0,
        1493.5
      ],
      [
        -1549.0,
        -3331.0,
        1488.0
      ],
      [
        -1549.5,
        -3331.0,
        1493.5
      ],
      [
        -1625.0,
        -3331.0,
        1493.5
      ],
      [
        -1625.5,
        -3331.0,
        1488.0
      ],
      [
        -1625.0,
        -3377.0,
        1493.5
      ],
      [
        -1549.5,
        -3377.0,
        1493.5
      ],
      [
        -1549.0,
        -3377.0,
        1488.0
      ],
      [
        -1549.5,
        -3377.0,
        1493.5
      ],
      [
        -1625.0,
        -3377.0,
        1493.5
      ],
      [
        -1625.5,
        -3377.0,
        1488.0
      ],
      [
        -1554.891845703125,
        -3334.891845703125,
        1496.0
      ],
      [
        -1552.108154296875,
        -3334.891845703125,
        1496.0
      ],
      [
        -1554.891845703125,
        -3332.108154296875,
        1496.0
      ],
      [
        -1554.891845703125,
        -3334.891845703125,
        1496.0
      ],
      [
        -1554.891845703125,
        -3332.108154296875,
        1496.0
      ],
      [
        -1552.108154296875,
        -3332.108154296875,
        1496.0
      ],
      [
        -1552.108154296875,
        -3334.891845703125,
        1496.0
      ],
      [
        -1552.108154296875,
        -3332.108154296875,
        1496.0
      ],
      [
        -1554.891845703125,
        -3372.608154296875,
        1496.0
      ],
      [
        -1554.891845703125,
        -3375.391845703125,
        1496.0
      ],
      [
        -1554.891845703125,
        -3375.391845703125,
        1496.0
      ],
      [
        -1552.108154296875,
        -3375.391845703125,
        1496.0
      ],
      [
        -1552.108154296875,
        -3375.391845703125,
        1496.0
      ],
      [
        -1552.108154296875,
        -3372.608154296875,
        1496.0
      ],
      [
        -1554.891845703125,
        -3372.608154296875,
        1496.0
      ],
      [
        -1552.108154296875,
        -3372.608154296875,
        1496.0
      ],
      [
        -1573.1328125,
        -3287.9814453125,
        1324.192626953125
      ],
      [
        -1622.0,
        -3375.0,
        1476.4024658203125
      ],
      [
        -1625.0,
        -3375.0,
        1476.967529296875
      ],
      [
        -1599.0,
        -3375.0,
        1472.070068359375
      ],
      [
        -1602.0,
        -3375.0,
        1472.6351318359375
      ],
      [
        -1573.0,
        -3375.0,
        1467.172607421875
      ],
      [
        -1576.0,
        -3375.0,
        1467.7376708984375
      ],
      [
        -1549.0,
        -3375.0,
        1462.65185546875
      ],
      [
        -1552.0,
        -3375.0,
        1463.2169189453125
      ],
      [
        -1625.0,
        -3375.0,
        1476.967529296875
      ],
      [
        -1625.0,
        -3378.0,
        1477.135498046875
      ],
      [
        -1622.0,
        -3378.0,
        1476.5704345703125
      ],
      [
        -1625.0,
        -3378.0,
        1477.135498046875
      ],
      [
        -1599.0,
        -3378.0,
        1472.238037109375
      ],
      [
        -1602.0,
        -3378.0,
        1472.8031005859375
      ],
      [
        -1573.0,
        -3378.0,
        1467.340576171875
      ],
      [
        -1576.0,
        -3378.0,
        1467.9056396484375
      ],
      [
        -1549.0,
        -3378.0,
        1462.81982421875
      ],
      [
        -1552.0,
        -3378.0,
        1463.3848876953125
      ],
      [
        -1622.0,
        -3378.0,
        1476.5704345703125
      ],
      [
        -1622.0,
        -3375.0,
        1476.4024658203125
      ],
      [
        -1602.0,
        -3375.0,
        1472.6351318359375
      ],
      [
        -1602.0,
        -3378.0,
        1472.8031005859375
      ],
      [
        -1599.0,
        -3378.0,
        1472.238037109375
      ],
      [
        -1599.0,
        -3375.0,
        1472.070068359375
      ],
      [
        -1576.0,
        -3375.0,
        1467.7376708984375
      ],
      [
        -1576.0,
        -3378.0,
        1467.9056396484375
      ],
      [
        -1573.0,
        -3378.0,
        1467.340576171875
      ],
      [
        -1573.0,
        -3375.0,
        1467.172607421875
      ],
      [
        -1552.0,
        -3375.0,
        1463.2169189453125
      ],
      [
        -1552.0,
        -3378.0,
        1463.3848876953125
      ],
      [
        -1549.0,
        -3378.0,
        1462.81982421875
      ],
      [
        -1549.0,
        -3375.0,
        1462.65185546875
      ],
      [
        -1625.0,
        -3330.0,
        1474.4476318359375
      ],
      [
        -1625.0,
        -3333.0,
        1474.61572265625
      ],
      [
        -1622.0,
        -3333.0,
        1474.050537109375
      ],
      [
        -1625.0,
        -3333.0,
        1474.61572265625
      ],
      [
        -1599.0,
        -3333.0,
        1469.71826171875
      ],
      [
        -1602.0,
        -3333.0,
        1470.2833251953125
      ],
      [
        -1549.0,
        -3333.0,
        1460.300048828125
      ],
      [
        -1552.0,
        -3333.0,
        1460.8651123046875
      ],
      [
        -1573.0,
        -3333.0,
        1464.8206787109375
      ],
      [
        -1576.0,
        -3333.0,
        1465.3858642578125
      ],
      [
        -1622.0,
        -3330.0,
        1473.882568359375
      ],
      [
        -1625.0,
        -3330.0,
        1474.4476318359375
      ],
      [
        -1599.0,
        -3330.0,
        1469.55029296875
      ],
      [
        -1602.0,
        -3330.0,
        1470.1153564453125
      ],
      [
        -1549.0,
        -3330.0,
        1460.132080078125
      ],
      [
        -1552.0,
        -3330.0,
        1460.6971435546875
      ],
      [
        -1573.0,
        -3330.0,
        1464.6527099609375
      ],
      [
        -1576.0,
        -3330.0,
        1465.2178955078125
      ],
      [
        -1622.0,
        -3333.0,
        1474.050537109375
      ],
      [
        -1622.0,
        -3330.0,
        1473.882568359375
      ],
      [
        -1602.0,
        -3330.0,
        1470.1153564453125
      ],
      [
        -1602.0,
        -3333.0,
        1470.2833251953125
      ],
      [
        -1599.0,
        -3333.0,
        1469.71826171875
      ],
      [
        -1599.0,
        -3330.0,
        1469.5501708984375
      ],
      [
        -1576.0,
        -3330.0,
        1465.2178955078125
      ],
      [
        -1576.0,
        -3333.0,
        1465.3858642578125
      ],
      [
        -1573.0,
        -3333.0,
        1464.8206787109375
      ],
      [
        -1573.0,
        -3330.0,
        1464.6527099609375
      ],
      [
        -1552.0,
        -3330.0,
        1460.6971435546875
      ],
      [
        -1552.0,
        -3333.0,
        1460.8651123046875
      ],
      [
        -1549.0,
        -3333.0,
        1460.300048828125
      ],
      [
        -1549.0,
        -3330.0,
        1460.132080078125
      ],
      [
        -1632.84228515625,
        -3372.64794921875,
        1302.5999755859375
      ],
      [
        -1549.0,
        -3374.5,
        1482.0
      ],
      [
        -1549.0,
        -3378.5,
        1482.0
      ],
      [
        -1549.0,
        -3333.5,
        1482.0
      ],
      [
        -1549.0,
        -3329.5,
        1482.0
      ],
      [
        -1549.0,
        -3333.5,
        1485.0
      ],
      [
        -1549.0,
        -3333.5,
        1482.0
      ],
      [
        -1549.0,
        -3329.5,
        1482.0
      ],
      [
        -1549.0,
        -3329.5,
        1485.0
      ],
      [
        -1549.0,
        -3378.5,
        1485.0
      ],
      [
        -1549.0,
        -3378.5,
        1482.0
      ],
      [
        -1549.0,
        -3374.5,
        1482.0
      ],
      [
        -1549.0,
        -3374.5,
        1485.0
      ],
      [
        -1636.6453857421875,
        -3382.0,
        1311.585205078125
      ],
      [
        -1552.4217529296875,
        -3381.076416015625,
        1302.5999755859375
      ],
      [
        -1551.9346923828125,
        -3382.0,
        1304.333251953125
      ],
      [
        -1620.161865234375,
        -3361.461181640625,
        1515.075927734375
      ],
      [
        -1609.718017578125,
        -3354.1357421875,
        1507.27587890625
      ],
      [
        -1631.96044921875,
        -3365.522705078125,
        1530.160888671875
      ],
      [
        -1620.1619873046875,
        -3361.461181640625,
        1515.075927734375
      ],
      [
        -1633.6953125,
        -3364.03515625,
        1529.26708984375
      ],
      [
        -1622.4443359375,
        -3359.504638671875,
        1513.9002685546875
      ],
      [
        -1620.040771484375,
        -3361.099365234375,
        1515.3974609375
      ],
      [
        -1631.776611328125,
        -3365.1328125,
        1530.4117431640625
      ],
      [
        -1622.2056884765625,
        -3359.33203125,
        1513.7177734375
      ],
      [
        -1622.4443359375,
        -3359.504638671875,
        1513.9002685546875
      ],
      [
        -1620.64208984375,
        -3360.04541015625,
        1513.9337158203125
      ],
      [
        -1622.2999267578125,
        -3359.162841796875,
        1514.23388671875
      ],
      [
        -1633.490478515625,
        -3363.66357421875,
        1529.52880859375
      ],
      [
        -1621.56201171875,
        -3358.8662109375,
        1513.2254638671875
      ],
      [
        -1612.1478271484375,
        -3352.05322265625,
        1506.024658203125
      ],
      [
        -1610.4500732421875,
        -3350.78955078125,
        1504.7919921875
      ],
      [
        -1612.1478271484375,
        -3352.05322265625,
        1506.024658203125
      ],
      [
        -1609.718017578125,
        -3354.1357421875,
        1507.27587890625
      ],
      [
        -1608.0,
        -3352.8896484375,
        1506.053955078125
      ],
      [
        -1608.0,
        -3352.8896484375,
        1506.053955078125
      ],
      [
        -1607.2806396484375,
        -3352.33642578125,
        1505.589111328125
      ],
      [
        -1609.736572265625,
        -3350.2314453125,
        1504.32421875
      ],
      [
        -1610.4500732421875,
        -3350.78955078125,
        1504.7919921875
      ],
      [
        -1606.263427734375,
        -3351.464599609375,
        1505.065185546875
      ],
      [
        -1605.5501708984375,
        -3350.78955078125,
        1504.7919921875
      ],
      [
        -1609.7003173828125,
        -3353.8466796875,
        1507.674560546875
      ],
      [
        -1620.040771484375,
        -3361.099365234375,
        1515.3974609375
      ],
      [
        -1606.7713623046875,
        -3351.915771484375,
        1505.3033447265625
      ],
      [
        -1606.263427734375,
        -3351.464599609375,
        1505.065185546875
      ],
      [
        -1609.2286376953125,
        -3349.809326171875,
        1504.0377197265625
      ],
      [
        -1609.736572265625,
        -3350.2314453125,
        1504.32421875
      ],
      [
        -1607.2806396484375,
        -3352.33642578125,
        1505.589111328125
      ],
      [
        -1606.7713623046875,
        -3351.915771484375,
        1505.3033447265625
      ],
      [
        -1608.614013671875,
        -3349.60546875,
        1503.8843994140625
      ],
      [
        -1608.974365234375,
        -3349.584716796875,
        1503.919189453125
      ],
      [
        -1609.2286376953125,
        -3349.809326171875,
        1504.0377197265625
      ],
      [
        -1608.0,
        -3349.735595703125,
        1503.90576171875
      ],
      [
        -1608.614013671875,
        -3349.60546875,
        1503.8843994140625
      ],
      [
        -1606.395751953125,
        -3350.876220703125,
        1504.6478271484375
      ],
      [
        -1606.74365234375,
        -3350.455078125,
        1504.338134765625
      ],
      [
        -1606.74365234375,
        -3350.455078125,
        1504.338134765625
      ],
      [
        -1607.1112060546875,
        -3350.14990234375,
        1504.1307373046875
      ],
      [
        -1607.51904296875,
        -3349.91650390625,
        1503.990478515625
      ],
      [
        -1608.0,
        -3349.735595703125,
        1503.90576171875
      ],
      [
        -1607.1112060546875,
        -3350.14990234375,
        1504.1307373046875
      ],
      [
        -1607.51904296875,
        -3349.91650390625,
        1503.990478515625
      ],
      [
        -1622.2999267578125,
        -3359.162841796875,
        1514.23388671875
      ],
      [
        -1612.105712890625,
        -3351.78564453125,
        1506.4365234375
      ],
      [
        -1608.0,
        -3349.501220703125,
        1503.8216552734375
      ],
      [
        -1608.601806640625,
        -3349.25,
        1503.75634765625
      ],
      [
        -1608.71923828125,
        -3349.359375,
        1503.8004150390625
      ],
      [
        -1607.4796142578125,
        -3349.824462890625,
        1503.958984375
      ],
      [
        -1608.0,
        -3349.501220703125,
        1503.8216552734375
      ],
      [
        -1607.4796142578125,
        -3349.824462890625,
        1503.958984375
      ],
      [
        -1608.71923828125,
        -3349.359375,
        1503.8004150390625
      ],
      [
        -1606.2811279296875,
        -3349.982177734375,
        1504.75341796875
      ],
      [
        -1605.5748291015625,
        -3350.53466796875,
        1505.21630859375
      ],
      [
        -1607.28076171875,
        -3349.359619140625,
        1503.8004150390625
      ],
      [
        -1608.0,
        -3348.689697265625,
        1503.5302734375
      ],
      [
        -1605.5501708984375,
        -3350.78955078125,
        1504.7919921875
      ],
      [
        -1606.263671875,
        -3350.2314453125,
        1504.3243408203125
      ],
      [
        -1608.0,
        -3348.689697265625,
        1503.5302734375
      ],
      [
        -1606.771484375,
        -3349.8095703125,
        1504.0377197265625
      ],
      [
        -1607.28076171875,
        -3349.359619140625,
        1503.8004150390625
      ],
      [
        -1606.263671875,
        -3350.2314453125,
        1504.3243408203125
      ],
      [
        -1606.771484375,
        -3349.8095703125,
        1504.0377197265625
      ],
      [
        -1612.105712890625,
        -3351.78564453125,
        1506.4365234375
      ],
      [
        -1610.42529296875,
        -3350.53466796875,
        1505.2164306640625
      ],
      [
        -1608.0,
        -3352.61328125,
        1506.4652099609375
      ],
      [
        -1609.7003173828125,
        -3353.8466796875,
        1507.674560546875
      ],
      [
        -1610.42529296875,
        -3350.53466796875,
        1505.2164306640625
      ],
      [
        -1609.718994140625,
        -3349.982177734375,
        1504.75341796875
      ],
      [
        -1608.7120361328125,
        -3349.119140625,
        1504.2347412109375
      ],
      [
        -1608.0,
        -3348.4560546875,
        1503.96728515625
      ],
      [
        -1605.5748291015625,
        -3350.53466796875,
        1505.21630859375
      ],
      [
        -1606.28125,
        -3351.202880859375,
        1505.4866943359375
      ],
      [
        -1608.0,
        -3348.4560546875,
        1503.96728515625
      ],
      [
        -1607.2880859375,
        -3349.119384765625,
        1504.2347412109375
      ],
      [
        -1607.2880859375,
        -3352.06591796875,
        1506.0052490234375
      ],
      [
        -1608.0,
        -3352.61328125,
        1506.4652099609375
      ],
      [
        -1609.718994140625,
        -3349.982177734375,
        1504.75341796875
      ],
      [
        -1609.2161865234375,
        -3349.564453125,
        1504.4697265625
      ],
      [
        -1609.2161865234375,
        -3349.564453125,
        1504.4697265625
      ],
      [
        -1608.7120361328125,
        -3349.119140625,
        1504.2347412109375
      ],
      [
        -1606.783935546875,
        -3349.564697265625,
        1504.4697265625
      ],
      [
        -1606.2811279296875,
        -3349.982177734375,
        1504.75341796875
      ],
      [
        -1606.783935546875,
        -3351.6494140625,
        1505.722412109375
      ],
      [
        -1607.2880859375,
        -3352.06591796875,
        1506.0052490234375
      ],
      [
        -1606.28125,
        -3351.202880859375,
        1505.4866943359375
      ],
      [
        -1606.783935546875,
        -3351.6494140625,
        1505.722412109375
      ],
      [
        -1607.2880859375,
        -3349.119384765625,
        1504.2347412109375
      ],
      [
        -1606.783935546875,
        -3349.564697265625,
        1504.4697265625
      ],
      [
        -1614.199951171875,
        -3353.6025390625,
        1507.474609375
      ],
      [
        -1614.199951171875,
        -3353.53857421875,
        1507.5943603515625
      ],
      [
        -1614.199951171875,
        -3354.705322265625,
        1505.4095458984375
      ],
      [
        -1611.7750244140625,
        -3356.955810546875,
        1506.7618408203125
      ],
      [
        -1605.474853515625,
        -3351.5556640625,
        1503.51708984375
      ],
      [
        -1608.0,
        -3349.391357421875,
        1502.216552734375
      ],
      [
        -1614.199951171875,
        -3353.9541015625,
        1506.81591796875
      ],
      [
        -1614.199951171875,
        -3354.27392578125,
        1506.2171630859375
      ],
      [
        -1614.199951171875,
        -3353.9541015625,
        1506.81591796875
      ],
      [
        -1614.199951171875,
        -3354.705322265625,
        1505.4095458984375
      ],
      [
        -1614.199951171875,
        -3354.27392578125,
        1506.2171630859375
      ],
      [
        -1611.9013671875,
        -3355.667236328125,
        1508.9063720703125
      ],
      [
        -1611.852783203125,
        -3356.162353515625,
        1508.082275390625
      ],
      [
        -1611.8529052734375,
        -3356.162353515625,
        1508.0821533203125
      ],
      [
        -1611.8187255859375,
        -3356.510009765625,
        1507.5035400390625
      ],
      [
        -1611.7750244140625,
        -3356.955810546875,
        1506.7618408203125
      ],
      [
        -1611.8187255859375,
        -3356.510009765625,
        1507.5035400390625
      ],
      [
        -1608.4747314453125,
        -3354.126953125,
        1505.0621337890625
      ],
      [
        -1608.22216796875,
        -3356.7021484375,
        1500.7763671875
      ],
      [
        -1612.0,
        -3355.178466796875,
        1499.86083984375
      ],
      [
        -1612.0,
        -3356.1220703125,
        1498.0943603515625
      ],
      [
        -1612.0,
        -3352.819580078125,
        1504.276611328125
      ],
      [
        -1612.0,
        -3355.178466796875,
        1499.86083984375
      ],
      [
        -1606.6214599609375,
        -3356.44677734375,
        1498.2894287109375
      ],
      [
        -1605.121337890625,
        -3355.160888671875,
        1497.516845703125
      ],
      [
        -1606.121337890625,
        -3354.3037109375,
        1497.0018310546875
      ],
      [
        -1609.878662109375,
        -3354.3037109375,
        1497.0018310546875
      ],
      [
        -1612.0,
        -3356.1220703125,
        1498.0943603515625
      ],
      [
        -1608.22216796875,
        -3356.7021484375,
        1500.7763671875
      ],
      [
        -1606.6214599609375,
        -3356.44677734375,
        1498.2894287109375
      ],
      [
        -1608.2777099609375,
        -3351.98779296875,
        1497.943603515625
      ],
      [
        -1607.722900390625,
        -3351.98779296875,
        1497.943603515625
      ],
      [
        -1607.9749755859375,
        -3349.41259765625,
        1502.2294921875
      ],
      [
        -1608.0250244140625,
        -3349.41259765625,
        1502.2294921875
      ],
      [
        -1607.722900390625,
        -3351.98779296875,
        1497.943603515625
      ],
      [
        -1608.2777099609375,
        -3351.98779296875,
        1497.943603515625
      ],
      [
        -1609.878662109375,
        -3354.3037109375,
        1497.0018310546875
      ],
      [
        -1606.121337890625,
        -3354.3037109375,
        1497.0018310546875
      ],
      [
        -1612.2022705078125,
        -3355.60009765625,
        1499.5
      ],
      [
        -1612.0,
        -3355.60009765625,
        1499.0712890625
      ],
      [
        -1612.0,
        -3355.37109375,
        1499.5
      ],
      [
        -1612.2021484375,
        -3355.60009765625,
        1499.5
      ],
      [
        -1613.2020263671875,
        -3365.902099609375,
        1496.0
      ],
      [
        -1613.6324462890625,
        -3365.076171875,
        1498.0
      ],
      [
        -1611.905029296875,
        -3364.341552734375,
        1496.0
      ],
      [
        -1612.9840087890625,
        -3364.2958984375,
        1498.0
      ],
      [
        -1613.6324462890625,
        -3365.076171875,
        1498.0
      ],
      [
        -1612.9840087890625,
        -3364.2958984375,
        1498.0
      ],
      [
        -1611.375244140625,
        -3346.498291015625,
        1500.478271484375
      ],
      [
        -1631.9603271484375,
        -3321.473388671875,
        1503.693359375
      ],
      [
        -1620.1617431640625,
        -3336.699462890625,
        1500.1973876953125
      ],
      [
        -1624.517578125,
        -3355.07373046875,
        1510.9464111328125
      ],
      [
        -1621.5618896484375,
        -3358.865966796875,
        1513.225341796875
      ],
      [
        -1626.1187744140625,
        -3353.4560546875,
        1510.2657470703125
      ],
      [
        -1624.517578125,
        -3355.07373046875,
        1510.9464111328125
      ],
      [
        -1625.879150390625,
        -3349.208984375,
        1507.422607421875
      ],
      [
        -1626.693359375,
        -3347.180908203125,
        1506.495361328125
      ],
      [
        -1625.87939453125,
        -3349.208984375,
        1507.422607421875
      ],
      [
        -1624.517822265625,
        -3343.343994140625,
        1503.898681640625
      ],
      [
        -1624.4217529296875,
        -3341.192626953125,
        1502.897216796875
      ],
      [
        -1624.517822265625,
        -3343.343994140625,
        1503.898681640625
      ],
      [
        -1620.6422119140625,
        -3338.372314453125,
        1500.911376953125
      ],
      [
        -1619.919189453125,
        -3336.939453125,
        1500.2625732421875
      ],
      [
        -1620.1617431640625,
        -3336.699462890625,
        1500.1973876953125
      ],
      [
        -1620.6422119140625,
        -3338.372314453125,
        1500.911376953125
      ],
      [
        -1631.9603271484375,
        -3321.473388671875,
        1503.693359375
      ],
      [
        -1631.875732421875,
        -3321.45556640625,
        1503.90625
      ],
      [
        -1620.0406494140625,
        -3336.585205078125,
        1500.6678466796875
      ],
      [
        -1631.7767333984375,
        -3321.434814453125,
        1504.1553955078125
      ],
      [
        -1619.2666015625,
        -3337.584716796875,
        1500.43798828125
      ],
      [
        -1631.7767333984375,
        -3321.434814453125,
        1504.1553955078125
      ],
      [
        -1619.678955078125,
        -3339.337646484375,
        1501.1751708984375
      ],
      [
        -1620.9373779296875,
        -3338.7509765625,
        1501.1387939453125
      ],
      [
        -1624.6212158203125,
        -3354.627197265625,
        1510.6781005859375
      ],
      [
        -1623.258544921875,
        -3354.766357421875,
        1510.4454345703125
      ],
      [
        -1609.7177734375,
        -3347.02587890625,
        1503.003662109375
      ],
      [
        -1612.473388671875,
        -3344.30126953125,
        1502.2633056640625
      ],
      [
        -1619.678955078125,
        -3339.337646484375,
        1501.1751708984375
      ],
      [
        -1623.258544921875,
        -3354.766357421875,
        1510.4454345703125
      ],
      [
        -1615.0791015625,
        -3354.174560546875,
        1508.2667236328125
      ],
      [
        -1609.7177734375,
        -3347.02587890625,
        1503.003662109375
      ],
      [
        -1614.199951171875,
        -3353.5810546875,
        1507.5146484375
      ],
      [
        -1611.4954833984375,
        -3345.26806640625,
        1502.52587890625
      ],
      [
        -1611.4886474609375,
        -3345.337890625,
        1502.409423828125
      ],
      [
        -1614.199951171875,
        -3352.963623046875,
        1506.8338623046875
      ],
      [
        -1614.199951171875,
        -3353.722412109375,
        1507.2498779296875
      ],
      [
        -1614.199951171875,
        -3352.963623046875,
        1506.8338623046875
      ],
      [
        -1614.199951171875,
        -3345.227783203125,
        1502.5927734375
      ],
      [
        -1614.199951171875,
        -3345.227783203125,
        1502.5927734375
      ],
      [
        -1613.927978515625,
        -3345.255615234375,
        1502.54638671875
      ],
      [
        -1613.927978515625,
        -3345.255615234375,
        1502.54638671875
      ],
      [
        -1611.4720458984375,
        -3345.50732421875,
        1502.127685546875
      ],
      [
        -1611.4586181640625,
        -3345.64501953125,
        1501.898681640625
      ],
      [
        -1611.4586181640625,
        -3345.64501953125,
        1501.898681640625
      ],
      [
        -1611.4241943359375,
        -3345.9970703125,
        1501.3123779296875
      ],
      [
        -1611.4241943359375,
        -3345.9970703125,
        1501.3123779296875
      ],
      [
        -1611.375244140625,
        -3346.498291015625,
        1500.478271484375
      ],
      [
        -1620.0406494140625,
        -3336.585205078125,
        1500.6678466796875
      ],
      [
        -1609.700439453125,
        -3346.80908203125,
        1503.446044921875
      ],
      [
        -1609.700439453125,
        -3346.80908203125,
        1503.446044921875
      ],
      [
        -1615.029296875,
        -3344.753173828125,
        1496.0
      ],
      [
        -1614.0667724609375,
        -3344.774658203125,
        1498.0
      ],
      [
        -1613.678466796875,
        -3346.282470703125,
        1496.0
      ],
      [
        -1613.3914794921875,
        -3345.539306640625,
        1498.0
      ],
      [
        -1614.0667724609375,
        -3344.774658203125,
        1498.0
      ],
      [
        -1613.3914794921875,
        -3345.539306640625,
        1498.0
      ],
      [
        -1614.8421630859375,
        -3363.36767578125,
        1515.93017578125
      ],
      [
        -1619.2664794921875,
        -3360.8330078125,
        1514.4072265625
      ],
      [
        -1614.8421630859375,
        -3363.36767578125,
        1515.93017578125
      ],
      [
        -1613.1055908203125,
        -3364.61083984375,
        1516.9683837890625
      ],
      [
        -1619.268798828125,
        -3371.882080078125,
        1533.9820556640625
      ],
      [
        -1608.0,
        -3364.534423828125,
        1516.631103515625
      ],
      [
        -1608.0,
        -3364.534423828125,
        1516.631103515625
      ],
      [
        -1605.7835693359375,
        -3365.103515625,
        1517.264404296875
      ],
      [
        -1606.45556640625,
        -3356.5478515625,
        1499.2738037109375
      ],
      [
        -1606.979248046875,
        -3356.50390625,
        1498.845458984375
      ],
      [
        -1607.47216796875,
        -3356.58251953125,
        1499.6112060546875
      ],
      [
        -1601.1578369140625,
        -3363.36767578125,
        1515.93017578125
      ],
      [
        -1601.1578369140625,
        -3363.36767578125,
        1515.93017578125
      ],
      [
        -1598.79833984375,
        -3363.156494140625,
        1516.0946044921875
      ],
      [
        -1605.0206298828125,
        -3356.7021484375,
        1500.7763671875
      ],
      [
        -1604.6185302734375,
        -3356.7021484375,
        1500.7763671875
      ],
      [
        -1607.65869140625,
        -3356.6123046875,
        1499.9010009765625
      ],
      [
        -1604.400390625,
        -3356.65966796875,
        1500.84716796875
      ],
      [
        -1604.6185302734375,
        -3356.7021484375,
        1500.7763671875
      ],
      [
        -1605.0206298828125,
        -3356.7021484375,
        1500.7763671875
      ],
      [
        -1582.3048095703125,
        -3364.035400390625,
        1529.2672119140625
      ],
      [
        -1593.5556640625,
        -3359.504638671875,
        1513.9002685546875
      ],
      [
        -1595.3572998046875,
        -3360.0458984375,
        1513.9342041015625
      ],
      [
        -1595.3572998046875,
        -3360.0458984375,
        1513.9342041015625
      ],
      [
        -1593.5556640625,
        -3359.504638671875,
        1513.9002685546875
      ],
      [
        -1593.7945556640625,
        -3359.331787109375,
        1513.717529296875
      ],
      [
        -1582.3990478515625,
        -3363.8642578125,
        1529.3875732421875
      ],
      [
        -1582.3048095703125,
        -3364.035400390625,
        1529.2672119140625
      ],
      [
        -1603.5,
        -3356.185546875,
        1501.63623046875
      ],
      [
        -1603.5,
        -3356.3388671875,
        1501.3812255859375
      ],
      [
        -1604.6611328125,
        -3356.677490234375,
        1500.8173828125
      ],
      [
        -1606.147216796875,
        -3356.7021484375,
        1500.7763671875
      ],
      [
        -1606.147216796875,
        -3356.7021484375,
        1500.7763671875
      ],
      [
        -1606.9127197265625,
        -3356.6376953125,
        1500.1485595703125
      ],
      [
        -1603.5,
        -3356.3388671875,
        1501.381103515625
      ],
      [
        -1603.5,
        -3356.185546875,
        1501.63623046875
      ],
      [
        -1603.5,
        -3355.471923828125,
        1500.3721923828125
      ],
      [
        -1603.5,
        -3355.50048828125,
        1500.318603515625
      ],
      [
        -1593.7001953125,
        -3359.1630859375,
        1514.23388671875
      ],
      [
        -1582.509521484375,
        -3363.66357421875,
        1529.52880859375
      ],
      [
        -1594.4376220703125,
        -3358.866455078125,
        1513.2257080078125
      ],
      [
        -1582.509521484375,
        -3363.66357421875,
        1529.52880859375
      ],
      [
        -1603.5,
        -3356.040283203125,
        1501.8780517578125
      ],
      [
        -1604.999755859375,
        -3356.478271484375,
        1501.1490478515625
      ],
      [
        -1603.5,
        -3356.040283203125,
        1501.8780517578125
      ],
      [
        -1603.5,
        -3355.221923828125,
        1500.8399658203125
      ],
      [
        -1601.199951171875,
        -3355.219970703125,
        1505.71875
      ],
      [
        -1614.31640625,
        -3362.42041015625,
        1515.0421142578125
      ],
      [
        -1614.316650390625,
        -3363.457275390625,
        1515.9840087890625
      ],
      [
        -1595.7979736328125,
        -3360.29833984375,
        1514.0858154296875
      ],
      [
        -1596.31787109375,
        -3359.361572265625,
        1513.207763671875
      ],
      [
        -1596.320556640625,
        -3359.35986328125,
        1513.205810546875
      ],
      [
        -1601.1378173828125,
        -3354.017822265625,
        1508.1009521484375
      ],
      [
        -1603.8526611328125,
        -3352.05322265625,
        1506.0244140625
      ],
      [
        -1614.31640625,
        -3362.42041015625,
        1515.0421142578125
      ],
      [
        -1612.6905517578125,
        -3356.220703125,
        1509.4959716796875
      ],
      [
        -1603.8526611328125,
        -3352.05322265625,
        1506.0244140625
      ],
      [
        -1611.8966064453125,
        -3355.716064453125,
        1508.8251953125
      ],
      [
        -1601.199951171875,
        -3355.4990234375,
        1509.1865234375
      ],
      [
        -1601.199951171875,
        -3353.97265625,
        1508.05322265625
      ],
      [
        -1601.199951171875,
        -3354.036376953125,
        1507.93408203125
      ],
      [
        -1601.199951171875,
        -3355.4990234375,
        1509.1865234375
      ],
      [
        -1601.6517333984375,
        -3355.665771484375,
        1508.9088134765625
      ],
      [
        -1601.199951171875,
        -3355.65673828125,
        1508.924072265625
      ],
      [
        -1601.6517333984375,
        -3355.665771484375,
        1508.9088134765625
      ],
      [
        -1601.199951171875,
        -3355.65673828125,
        1508.924072265625
      ],
      [
        -1601.199951171875,
        -3354.209716796875,
        1507.609619140625
      ],
      [
        -1610.944091796875,
        -3355.855224609375,
        1508.593505859375
      ],
      [
        -1611.881103515625,
        -3355.874267578125,
        1508.561767578125
      ],
      [
        -1610.944091796875,
        -3355.855224609375,
        1508.5933837890625
      ],
      [
        -1601.199951171875,
        -3354.567138671875,
        1506.9404296875
      ],
      [
        -1601.199951171875,
        -3354.5673828125,
        1506.9404296875
      ],
      [
        -1601.199951171875,
        -3354.86962890625,
        1506.374267578125
      ],
      [
        -1601.199951171875,
        -3354.86962890625,
        1506.374267578125
      ],
      [
        -1601.199951171875,
        -3355.219970703125,
        1505.71875
      ],
      [
        -1603.5,
        -3353.248046875,
        1504.5340576171875
      ],
      [
        -1603.89453125,
        -3351.78564453125,
        1506.4364013671875
      ],
      [
        -1593.7001953125,
        -3359.1630859375,
        1514.23388671875
      ],
      [
        -1603.89453125,
        -3351.78564453125,
        1506.4364013671875
      ],
      [
        -1603.5,
        -3356.0615234375,
        1500.3914794921875
      ],
      [
        -1603.5,
        -3355.607421875,
        1500.1185302734375
      ],
      [
        -1603.5,
        -3355.753173828125,
        1499.8455810546875
      ],
      [
        -1603.5,
        -3355.607421875,
        1500.1185302734375
      ],
      [
        -1603.5,
        -3356.0615234375,
        1500.3914794921875
      ],
      [
        -1603.5,
        -3356.484130859375,
        1501.1392822265625
      ],
      [
        -1603.5,
        -3356.484130859375,
        1501.1392822265625
      ],
      [
        -1603.5,
        -3356.605712890625,
        1499.8377685546875
      ],
      [
        -1606.894775390625,
        -3356.490478515625,
        1498.714111328125
      ],
      [
        -1604.3770751953125,
        -3355.798828125,
        1497.900146484375
      ],
      [
        -1606.235107421875,
        -3356.11572265625,
        1498.0904541015625
      ],
      [
        -1603.5,
        -3356.20751953125,
        1498.993896484375
      ],
      [
        -1603.5,
        -3356.605712890625,
        1499.8380126953125
      ],
      [
        -1603.5,
        -3356.46875,
        1498.5045166015625
      ],
      [
        -1603.6209716796875,
        -3356.44677734375,
        1498.2894287109375
      ],
      [
        -1603.6209716796875,
        -3356.44677734375,
        1498.2894287109375
      ],
      [
        -1603.5,
        -3356.46875,
        1498.5045166015625
      ],
      [
        -1554.48681640625,
        -3375.0,
        1525.98095703125
      ],
      [
        -1554.4794921875,
        -3382.0,
        1526.5208740234375
      ],
      [
        -1554.48681640625,
        -3375.0,
        1525.98095703125
      ],
      [
        -1554.5999755859375,
        -3373.0107421875,
        1525.7999267578125
      ],
      [
        -1554.8775634765625,
        -3373.01318359375,
        1525.973388671875
      ],
      [
        -1554.8775634765625,
        -3373.01318359375,
        1525.973388671875
      ],
      [
        -1563.090576171875,
        -3373.08251953125,
        1531.106689453125
      ],
      [
        -1554.4901123046875,
        -3375.0,
        1525.731201171875
      ],
      [
        -1563.090576171875,
        -3373.08251953125,
        1531.106689453125
      ],
      [
        -1562.590087890625,
        -3373.09326171875,
        1531.9066162109375
      ],
      [
        -1554.5999755859375,
        -3373.0107421875,
        1525.7999267578125
      ],
      [
        -1554.48681640625,
        -3332.5,
        1525.98095703125
      ],
      [
        -1554.4764404296875,
        -3322.5078125,
        1526.7518310546875
      ],
      [
        -1554.4764404296875,
        -3322.5078125,
        1526.7518310546875
      ],
      [
        -1554.475341796875,
        -3322.509521484375,
        1526.834716796875
      ],
      [
        -1554.48681640625,
        -3332.5,
        1525.98095703125
      ],
      [
        -1554.48681640625,
        -3373.0,
        1525.98095703125
      ],
      [
        -1554.4764404296875,
        -3363.0078125,
        1526.7518310546875
      ],
      [
        -1554.4764404296875,
        -3363.0078125,
        1526.7518310546875
      ],
      [
        -1554.475341796875,
        -3363.009521484375,
        1526.834716796875
      ],
      [
        -1554.48681640625,
        -3334.5,
        1525.98095703125
      ],
      [
        -1554.4764404296875,
        -3344.4921875,
        1526.7518310546875
      ],
      [
        -1554.4764404296875,
        -3344.4921875,
        1526.7518310546875
      ],
      [
        -1554.475341796875,
        -3344.490478515625,
        1526.834716796875
      ],
      [
        -1554.48681640625,
        -3334.5,
        1525.98095703125
      ],
      [
        -1554.48681640625,
        -3373.0,
        1525.98095703125
      ],
      [
        -1614.8421630859375,
        -3335.050048828125,
        1498.9151611328125
      ],
      [
        -1619.2666015625,
        -3337.58447265625,
        1500.4378662109375
      ],
      [
        -1613.1063232421875,
        -3333.5498046875,
        1498.304931640625
      ],
      [
        -1614.8421630859375,
        -3335.050048828125,
        1498.9151611328125
      ],
      [
        -1619.269775390625,
        -3315.1142578125,
        1499.872314453125
      ],
      [
        -1608.0,
        -3333.883056640625,
        1498.214111328125
      ],
      [
        -1605.7843017578125,
        -3333.056884765625,
        1498.0087890625
      ],
      [
        -1608.0,
        -3333.883056640625,
        1498.214111328125
      ],
      [
        -1605.739501953125,
        -3313.578125,
        1498.9493408203125
      ],
      [
        -1601.15771484375,
        -3335.0498046875,
        1498.9150390625
      ],
      [
        -1598.7989501953125,
        -3335.003662109375,
        1499.178466796875
      ],
      [
        -1601.15771484375,
        -3335.0498046875,
        1498.9150390625
      ],
      [
        -1592.5533447265625,
        -3316.597412109375,
        1500.7635498046875
      ],
      [
        -1595.3575439453125,
        -3338.3720703125,
        1500.9112548828125
      ],
      [
        -1593.2144775390625,
        -3339.09375,
        1501.6361083984375
      ],
      [
        -1595.3575439453125,
        -3338.3720703125,
        1500.9112548828125
      ],
      [
        -1581.71923828125,
        -3323.7119140625,
        1505.0384521484375
      ],
      [
        -1574.88623046875,
        -3333.83837890625,
        1511.123046875
      ],
      [
        -1589.8814697265625,
        -3344.703857421875,
        1505.0069580078125
      ],
      [
        -1591.4818115234375,
        -3343.343994140625,
        1503.898681640625
      ],
      [
        -1589.8814697265625,
        -3344.703857421875,
        1505.0069580078125
      ],
      [
        -1591.4818115234375,
        -3343.343994140625,
        1503.898681640625
      ],
      [
        -1574.88623046875,
        -3333.83837890625,
        1511.123046875
      ],
      [
        -1591.4815673828125,
        -3355.073974609375,
        1510.9466552734375
      ],
      [
        -1594.438232421875,
        -3358.865966796875,
        1513.2252197265625
      ],
      [
        -1591.4815673828125,
        -3355.073974609375,
        1510.9466552734375
      ],
      [
        -1589.881591796875,
        -3353.457275390625,
        1510.2664794921875
      ],
      [
        -1574.88623046875,
        -3353.15771484375,
        1522.731201171875
      ],
      [
        -1590.120849609375,
        -3349.208984375,
        1507.422607421875
      ],
      [
        -1590.120849609375,
        -3349.208984375,
        1507.422607421875
      ],
      [
        -1589.3067626953125,
        -3347.180419921875,
        1506.4949951171875
      ],
      [
        -1573.0943603515625,
        -3341.56005859375,
        1515.7626953125
      ],
      [
        -1559.8956298828125,
        -3344.25830078125,
        1529.1097412109375
      ],
      [
        -1559.3818359375,
        -3344.282470703125,
        1528.78857421875
      ],
      [
        -1555.820556640625,
        -3337.708251953125,
        1526.562744140625
      ],
      [
        -1555.046875,
        -3335.3037109375,
        1526.0792236328125
      ],
      [
        -1559.3818359375,
        -3344.282470703125,
        1528.78857421875
      ],
      [
        -1559.8956298828125,
        -3344.25830078125,
        1529.1097412109375
      ],
      [
        -1559.146728515625,
        -3344.270263671875,
        1529.75439453125
      ],
      [
        -1558.63232421875,
        -3344.29443359375,
        1529.432861328125
      ],
      [
        -1554.5296630859375,
        -3332.5,
        1525.2376708984375
      ],
      [
        -1554.5999755859375,
        -3333.91455078125,
        1525.7999267578125
      ],
      [
        -1554.4964599609375,
        -3332.5,
        1525.26171875
      ],
      [
        -1554.4874267578125,
        -3332.5,
        1525.9329833984375
      ],
      [
        -1554.541015625,
        -3332.5,
        1525.8941650390625
      ],
      [
        -1554.5296630859375,
        -3332.5,
        1525.2376708984375
      ],
      [
        -1554.541015625,
        -3332.5,
        1525.8941650390625
      ],
      [
        -1554.6036376953125,
        -3332.39208984375,
        1525.80224609375
      ],
      [
        -1554.5999755859375,
        -3333.91455078125,
        1525.7999267578125
      ],
      [
        -1554.638916015625,
        -3332.501953125,
        1525.8243408203125
      ],
      [
        -1555.2711181640625,
        -3334.46826171875,
        1526.2193603515625
      ],
      [
        -1554.7855224609375,
        -3334.4912109375,
        1525.9158935546875
      ],
      [
        -1554.7855224609375,
        -3334.4912109375,
        1525.9158935546875
      ],
      [
        -1555.2711181640625,
        -3334.46826171875,
        1526.2193603515625
      ],
      [
        -1556.2593994140625,
        -3337.54296875,
        1526.8370361328125
      ],
      [
        -1554.638916015625,
        -3332.501953125,
        1525.8243408203125
      ],
      [
        -1554.6036376953125,
        -3332.39208984375,
        1525.80224609375
      ],
      [
        -1600.714111328125,
        -3335.303955078125,
        1499.0677490234375
      ],
      [
        -1601.6812744140625,
        -3336.2734375,
        1499.332763671875
      ],
      [
        -1591.483154296875,
        -3349.3486328125,
        1507.1903076171875
      ],
      [
        -1590.2244873046875,
        -3348.76220703125,
        1507.1541748046875
      ],
      [
        -1601.199951171875,
        -3349.213134765625,
        1504.791748046875
      ],
      [
        -1604.058349609375,
        -3345.298583984375,
        1502.47509765625
      ],
      [
        -1601.199951171875,
        -3345.240234375,
        1502.572021484375
      ],
      [
        -1601.199951171875,
        -3346.54150390625,
        1503.0391845703125
      ],
      [
        -1601.199951171875,
        -3347.7412109375,
        1503.826171875
      ],
      [
        -1601.199951171875,
        -3347.7412109375,
        1503.826171875
      ],
      [
        -1601.199951171875,
        -3345.240234375,
        1502.572021484375
      ],
      [
        -1602.0155029296875,
        -3345.2568359375,
        1502.54443359375
      ],
      [
        -1602.0155029296875,
        -3345.2568359375,
        1502.54443359375
      ],
      [
        -1601.199951171875,
        -3354.027587890625,
        1507.9503173828125
      ],
      [
        -1601.199951171875,
        -3347.588623046875,
        1503.4151611328125
      ],
      [
        -1601.199951171875,
        -3347.588623046875,
        1503.4151611328125
      ],
      [
        -1601.199951171875,
        -3349.162109375,
        1503.9801025390625
      ],
      [
        -1601.199951171875,
        -3349.162109375,
        1503.9801025390625
      ],
      [
        -1601.199951171875,
        -3355.0244140625,
        1506.0848388671875
      ],
      [
        -1611.4915771484375,
        -3345.3076171875,
        1502.4598388671875
      ],
      [
        -1611.4776611328125,
        -3345.44970703125,
        1502.2236328125
      ],
      [
        -1610.7862548828125,
        -3345.435546875,
        1502.2470703125
      ],
      [
        -1610.7862548828125,
        -3345.435546875,
        1502.2470703125
      ],
      [
        -1554.634521484375,
        -3335.518798828125,
        1525.821533203125
      ],
      [
        -1554.634521484375,
        -3335.518798828125,
        1525.821533203125
      ],
      [
        -1554.485595703125,
        -3335.674072265625,
        1526.071533203125
      ],
      [
        -1554.4901123046875,
        -3334.5,
        1525.731201171875
      ],
      [
        -1554.5,
        -3334.345703125,
        1525.0
      ],
      [
        -1554.513916015625,
        -3334.5,
        1525.111328125
      ],
      [
        -1554.513916015625,
        -3334.5,
        1525.111328125
      ],
      [
        -1554.498291015625,
        -3334.5,
        1525.12451171875
      ],
      [
        -1556.1658935546875,
        -3344.434326171875,
        1526.778564453125
      ],
      [
        -1554.8863525390625,
        -3342.93994140625,
        1525.978759765625
      ],
      [
        -1554.8863525390625,
        -3342.93994140625,
        1525.978759765625
      ],
      [
        -1554.477783203125,
        -3343.195068359375,
        1526.6517333984375
      ],
      [
        -1556.1658935546875,
        -3344.434326171875,
        1526.778564453125
      ],
      [
        -1555.4239501953125,
        -3344.44580078125,
        1527.4276123046875
      ],
      [
        -1555.4276123046875,
        -3363.03076171875,
        1526.317138671875
      ],
      [
        -1556.98486328125,
        -3373.031005859375,
        1527.29052734375
      ],
      [
        -1554.4754638671875,
        -3363.00927734375,
        1526.825927734375
      ],
      [
        -1555.4276123046875,
        -3363.03076171875,
        1526.317138671875
      ],
      [
        -1612.9140625,
        -3344.109130859375,
        1498.0
      ],
      [
        -1612.828125,
        -3345.214111328125,
        1498.0
      ],
      [
        -1612.8280029296875,
        -3345.214111328125,
        1498.0
      ],
      [
        -1610.9605712890625,
        -3344.320068359375,
        1497.3619384765625
      ],
      [
        -1611.327880859375,
        -3343.034423828125,
        1497.4498291015625
      ],
      [
        -1612.9140625,
        -3344.109130859375,
        1498.0
      ],
      [
        -1610.9605712890625,
        -3344.320068359375,
        1497.3619384765625
      ],
      [
        -1611.327880859375,
        -3343.034423828125,
        1497.4498291015625
      ],
      [
        -2460.0,
        -4027.830078125,
        1052.5999755859375
      ],
      [
        -2460.0,
        -3907.199951171875,
        1052.5999755859375
      ],
      [
        -2460.0,
        -3817.021240234375,
        1052.5999755859375
      ],
      [
        -2460.0,
        -3907.199951171875,
        1052.5999755859375
      ],
      [
        -2460.0,
        -4090.906494140625,
        1052.5999755859375
      ],
      [
        -2460.0,
        -4027.830078125,
        1052.5999755859375
      ],
      [
        -2460.0,
        -3802.99560546875,
        1052.5999755859375
      ],
      [
        -2460.0,
        -3817.021240234375,
        1052.5999755859375
      ],
      [
        -2460.0,
        -3802.99560546875,
        1052.5999755859375
      ],
      [
        -2460.0,
        -3668.113525390625,
        1052.5999755859375
      ],
      [
        -2460.0,
        -3447.450927734375,
        1052.5999755859375
      ],
      [
        -2460.0,
        -3668.113525390625,
        1052.5999755859375
      ],
      [
        -3280.0,
        -4239.7685546875,
        1052.5999755859375
      ],
      [
        -3280.0,
        -4062.429443359375,
        1052.5999755859375
      ],
      [
        -2460.0,
        -4609.7685546875,
        1052.5999755859375
      ],
      [
        -2460.0,
        -4569.7998046875,
        1052.5999755859375
      ],
      [
        -3280.0,
        -3960.0,
        1052.5999755859375
      ],
      [
        -2460.0,
        -4126.15380859375,
        1052.5999755859375
      ],
      [
        -2460.0,
        -4970.0,
        1052.5999755859375
      ],
      [
        -3280.0,
        -4970.0,
        1052.5999755859375
      ],
      [
        -3280.0,
        -4919.7685546875,
        1052.5999755859375
      ],
      [
        -3280.0,
        -4942.9951171875,
        1168.73291015625
      ],
      [
        -2460.0,
        -4969.7685546875,
        1302.5999755859375
      ],
      [
        -2460.0,
        -4919.7685546875,
        1052.5999755859375
      ],
      [
        -3280.0,
        -4981.95361328125,
        1302.5999755859375
      ],
      [
        -3280.0,
        -4970.07861328125,
        1261.796142578125
      ],
      [
        -3280.0,
        -4942.9951171875,
        1168.73291015625
      ],
      [
        -3280.0,
        -4970.07861328125,
        1261.7962646484375
      ],
      [
        -3162.666748046875,
        -4939.7734375,
        1152.623779296875
      ],
      [
        -3175.552978515625,
        -4919.7685546875,
        1052.5999755859375
      ],
      [
        -2460.0,
        -4606.9326171875,
        1052.5999755859375
      ],
      [
        -2460.0,
        -4606.9326171875,
        1084.7506103515625
      ],
      [
        -2670.423583984375,
        -4609.7685546875,
        1101.623779296875
      ],
      [
        -2670.423583984375,
        -4928.619140625,
        1101.623779296875
      ],
      [
        -2799.999755859375,
        -4623.70166015625,
        1101.623779296875
      ],
      [
        -2799.999755859375,
        -4869.7685546875,
        1101.623779296875
      ],
      [
        -2879.999755859375,
        -4850.7685546875,
        1101.623779296875
      ],
      [
        -3029.098876953125,
        -4729.86767578125,
        1101.623779296875
      ],
      [
        -3219.999755859375,
        -4850.7685546875,
        1101.623779296875
      ],
      [
        -3145.921875,
        -4739.90283203125,
        1101.623779296875
      ],
      [
        -3119.999755859375,
        -4701.10791015625,
        1101.623779296875
      ],
      [
        -3119.999755859375,
        -4679.7998046875,
        1101.623779296875
      ],
      [
        -3119.999755859375,
        -4701.10791015625,
        1052.5999755859375
      ],
      [
        -3219.999755859375,
        -4850.7685546875,
        1101.623779296875
      ],
      [
        -3169.237060546875,
        -4929.5732421875,
        1101.623779296875
      ],
      [
        -3119.999755859375,
        -4730.7685546875,
        1101.623779296875
      ],
      [
        -3029.098876953125,
        -4729.86767578125,
        1101.623779296875
      ],
      [
        -3079.999755859375,
        -4679.7998046875,
        1101.623779296875
      ],
      [
        -3070.10009765625,
        -4611.48583984375,
        1101.623779296875
      ],
      [
        -3020.1005859375,
        -4611.11279296875,
        1052.5999755859375
      ],
      [
        -2839.999755859375,
        -4623.70166015625,
        1101.623779296875
      ],
      [
        -2799.999755859375,
        -4623.70166015625,
        1101.623779296875
      ],
      [
        -2670.423583984375,
        -4609.7685546875,
        1101.623779296875
      ],
      [
        -2749.999755859375,
        -4609.7685546875,
        1101.623779296875
      ],
      [
        -3070.18798828125,
        -4306.080078125,
        1101.623779296875
      ],
      [
        -3070.100341796875,
        -4529.7685546875,
        1101.623779296875
      ],
      [
        -3070.068359375,
        -4611.48583984375,
        1101.5926513671875
      ],
      [
        -2664.0,
        -4319.7685546875,
        1101.623779296875
      ],
      [
        -2684.999755859375,
        -4319.7685546875,
        1101.623779296875
      ],
      [
        -2684.999755859375,
        -4319.7685546875,
        1101.623779296875
      ],
      [
        -2869.999755859375,
        -4319.7685546875,
        1101.623779296875
      ],
      [
        -3060.9208984375,
        -4529.7685546875,
        1092.623779296875
      ],
      [
        -3060.9208984375,
        -4611.41748046875,
        1092.623779296875
      ],
      [
        -3070.10009765625,
        -4529.7685546875,
        1092.623779296875
      ],
      [
        -3060.9208984375,
        -4529.7685546875,
        1092.623779296875
      ],
      [
        -2749.999755859375,
        -4559.7685546875,
        1092.623779296875
      ],
      [
        -2839.999755859375,
        -4559.7685546875,
        1092.623779296875
      ],
      [
        -2909.999755859375,
        -4499.7685546875,
        1092.623779296875
      ],
      [
        -2909.999755859375,
        -4441.7685546875,
        1092.623779296875
      ],
      [
        -2884.999755859375,
        -4529.7685546875,
        1092.623779296875
      ],
      [
        -2884.999755859375,
        -4499.7685546875,
        1092.623779296875
      ],
      [
        -2884.999755859375,
        -4499.7685546875,
        1092.623779296875
      ],
      [
        -2909.999755859375,
        -4499.7685546875,
        1092.623779296875
      ],
      [
        -2749.999755859375,
        -4559.7685546875,
        1101.623779296875
      ],
      [
        -2839.999755859375,
        -4559.7685546875,
        1101.623779296875
      ],
      [
        -3060.9208984375,
        -4559.7685546875,
        1092.623779296875
      ],
      [
        -3070.08837890625,
        -4559.7685546875,
        1101.6123046875
      ],
      [
        -2909.999755859375,
        -4499.7685546875,
        1101.623779296875
      ],
      [
        -2909.999755859375,
        -4441.7685546875,
        1101.623779296875
      ],
      [
        -2663.999755859375,
        -4372.7685546875,
        1101.623779296875
      ],
      [
        -2664.0,
        -4319.7685546875,
        1101.623779296875
      ],
      [
        -2884.999755859375,
        -4529.7685546875,
        1101.623779296875
      ],
      [
        -2839.999755859375,
        -4529.7685546875,
        1101.623779296875
      ],
      [
        -2759.999755859375,
        -4509.7685546875,
        1101.623779296875
      ],
      [
        -2759.999755859375,
        -4469.7685546875,
        1101.623779296875
      ],
      [
        -2884.999755859375,
        -4529.7685546875,
        1101.623779296875
      ],
      [
        -2884.999755859375,
        -4499.7685546875,
        1101.623779296875
      ],
      [
        -2884.999755859375,
        -4499.7685546875,
        1101.623779296875
      ],
      [
        -2909.999755859375,
        -4499.7685546875,
        1101.623779296875
      ],
      [
        -2769.999755859375,
        -4469.7685546875,
        1101.623779296875
      ],
      [
        -2759.999755859375,
        -4469.7685546875,
        1101.623779296875
      ],
      [
        -2687.4853515625,
        -4306.30322265625,
        1101.623779296875
      ],
      [
        -2653.469482421875,
        -4247.6279296875,
        1101.623779296875
      ],
      [
        -2653.469482421875,
        -4247.6279296875,
        1052.5999755859375
      ],
      [
        -3117.009033203125,
        -4293.56640625,
        1101.623779296875
      ],
      [
        -3118.603759765625,
        -4295.22607421875,
        1108.4144287109375
      ],
      [
        -3265.45751953125,
        -4918.80078125,
        1141.0877685546875
      ],
      [
        -3232.09814453125,
        -4868.87548828125,
        1232.623779296875
      ],
      [
        -3232.09814453125,
        -4855.9072265625,
        1232.623779296875
      ],
      [
        -3280.0,
        -4850.7685546875,
        1128.623779296875
      ],
      [
        -3232.09814453125,
        -4855.9072265625,
        1232.623779296875
      ],
      [
        -3249.981689453125,
        -4855.9072265625,
        1232.623779296875
      ],
      [
        -3280.0,
        -4853.7041015625,
        1188.0367431640625
      ],
      [
        -3280.0,
        -4853.7041015625,
        1188.0367431640625
      ],
      [
        -3249.981689453125,
        -4855.9072265625,
        1232.623779296875
      ],
      [
        -3274.898193359375,
        -4856.21337890625,
        1232.623779296875
      ],
      [
        -3280.0,
        -4855.59765625,
        1220.8592529296875
      ],
      [
        -3119.999755859375,
        -4701.10791015625,
        1116.07177734375
      ],
      [
        -3119.999755859375,
        -4679.7998046875,
        1116.07177734375
      ],
      [
        -3119.999755859375,
        -4701.10791015625,
        1101.623779296875
      ],
      [
        -3232.09814453125,
        -4911.6953125,
        1232.623779296875
      ],
      [
        -3119.999755859375,
        -4730.7685546875,
        1116.07177734375
      ],
      [
        -3119.999755859375,
        -4730.7685546875,
        1117.547119140625
      ],
      [
        -3119.999755859375,
        -4679.7998046875,
        1117.171875
      ],
      [
        -3128.563232421875,
        -4306.03271484375,
        1152.623779296875
      ],
      [
        -3118.603759765625,
        -4295.22607421875,
        1108.4144287109375
      ],
      [
        -3070.100341796875,
        -4689.537109375,
        1152.623779296875
      ],
      [
        -3070.10009765625,
        -4689.537109375,
        1101.623779296875
      ],
      [
        -3070.03759765625,
        -4689.5986328125,
        1152.623779296875
      ],
      [
        -3070.03759765625,
        -4689.5986328125,
        1101.623779296875
      ],
      [
        -2919.67919921875,
        -4913.2685546875,
        1232.623779296875
      ],
      [
        -2919.67919921875,
        -4891.50537109375,
        1232.623779296875
      ],
      [
        -2919.67919921875,
        -4855.55908203125,
        1232.623779296875
      ],
      [
        -2919.67919921875,
        -4891.50537109375,
        1232.623779296875
      ],
      [
        -2964.228515625,
        -4855.4091796875,
        1232.623779296875
      ],
      [
        -2943.232666015625,
        -4855.4091796875,
        1232.623779296875
      ],
      [
        -2919.67919921875,
        -4855.55908203125,
        1232.623779296875
      ],
      [
        -2943.232666015625,
        -4855.4091796875,
        1232.623779296875
      ],
      [
        -2799.999755859375,
        -4372.7685546875,
        1122.623779296875
      ],
      [
        -2799.999755859375,
        -4319.7685546875,
        1122.623779296875
      ],
      [
        -2799.999755859375,
        -4319.7685546875,
        1122.623779296875
      ],
      [
        -2799.999755859375,
        -4319.7685546875,
        1101.623779296875
      ],
      [
        -2799.999755859375,
        -4559.7685546875,
        1112.623779296875
      ],
      [
        -2799.999755859375,
        -4559.7685546875,
        1101.623779296875
      ],
      [
        -2764.999755859375,
        -4319.7685546875,
        1122.623779296875
      ],
      [
        -2754.499755859375,
        -4319.7685546875,
        1101.623779296875
      ],
      [
        -2759.999755859375,
        -4559.7685546875,
        1112.623779296875
      ],
      [
        -2754.49951171875,
        -4559.7685546875,
        1101.623779296875
      ],
      [
        -2679.17236328125,
        -4609.7685546875,
        1122.623779296875
      ],
      [
        -2749.999755859375,
        -4609.7685546875,
        1122.623779296875
      ],
      [
        -2675.010986328125,
        -4319.7685546875,
        1112.6348876953125
      ],
      [
        -2670.423583984375,
        -4319.7685546875,
        1101.623779296875
      ],
      [
        -2675.01123046875,
        -4372.7685546875,
        1112.6351318359375
      ],
      [
        -2675.010986328125,
        -4319.7685546875,
        1112.6348876953125
      ],
      [
        -2687.4853515625,
        -4306.30322265625,
        1122.623779296875
      ],
      [
        -2683.28466796875,
        -4299.05712890625,
        1122.623779296875
      ],
      [
        -2680.307861328125,
        -4293.92236328125,
        1101.623779296875
      ],
      [
        -2687.4853515625,
        -4306.30322265625,
        1142.5771484375
      ],
      [
        -2685.4052734375,
        -4302.71484375,
        1137.5841064453125
      ],
      [
        -2954.386962890625,
        -4907.5830078125,
        1302.5999755859375
      ],
      [
        -2954.386962890625,
        -4866.78369140625,
        1302.5999755859375
      ],
      [
        -2954.386962890625,
        -4859.7490234375,
        1302.5999755859375
      ],
      [
        -2954.386962890625,
        -4866.78369140625,
        1302.5999755859375
      ],
      [
        -3221.847900390625,
        -4859.59814453125,
        1302.5999755859375
      ],
      [
        -3244.551513671875,
        -4859.876953125,
        1302.5999755859375
      ],
      [
        -3221.847900390625,
        -4859.59814453125,
        1302.5999755859375
      ],
      [
        -3206.59619140625,
        -4859.537109375,
        1302.5999755859375
      ],
      [
        -2954.386962890625,
        -4859.7490234375,
        1302.5999755859375
      ],
      [
        -2978.151611328125,
        -4859.59814453125,
        1302.5999755859375
      ],
      [
        -3185.6435546875,
        -4906.7431640625,
        1302.5999755859375
      ],
      [
        -3185.643798828125,
        -4859.46826171875,
        1302.5999755859375
      ],
      [
        -3189.3193359375,
        -4859.46826171875,
        1302.5999755859375
      ],
      [
        -2978.151611328125,
        -4859.59814453125,
        1302.5999755859375
      ],
      [
        -3010.6865234375,
        -4859.46826171875,
        1302.5999755859375
      ],
      [
        -3185.643798828125,
        -4859.45361328125,
        1302.5999755859375
      ],
      [
        -3185.6435546875,
        -4859.45361328125,
        1302.5999755859375
      ],
      [
        -3014.35595703125,
        -4859.45361328125,
        1302.5999755859375
      ],
      [
        -2687.4853515625,
        -4306.30322265625,
        1152.259033203125
      ],
      [
        -2653.469482421875,
        -4247.6279296875,
        1152.623779296875
      ],
      [
        -2708.07421875,
        -4247.63818359375,
        1101.623779296875
      ],
      [
        -3086.152099609375,
        -3932.528564453125,
        1052.5999755859375
      ],
      [
        -3110.8232421875,
        -3943.19287109375,
        1247.45458984375
      ],
      [
        -3086.49267578125,
        -3903.7587890625,
        1079.9710693359375
      ],
      [
        -3083.144287109375,
        -3903.39501953125,
        1052.5999755859375
      ],
      [
        -3126.218994140625,
        -4239.7685546875,
        1121.623779296875
      ],
      [
        -3280.0,
        -4239.7685546875,
        1121.623779296875
      ],
      [
        -3280.0,
        -4239.7685546875,
        1052.5999755859375
      ],
      [
        -3117.869384765625,
        -4239.7685546875,
        1052.5999755859375
      ],
      [
        -3055.73828125,
        -3344.980712890625,
        1302.5999755859375
      ],
      [
        -2848.796875,
        -3363.318115234375,
        1119.5692138671875
      ],
      [
        -2921.3994140625,
        -3392.010498046875,
        1052.5999755859375
      ],
      [
        -2848.796875,
        -3363.318115234375,
        1119.5692138671875
      ],
      [
        -3083.468505859375,
        -3931.36865234375,
        1154.199951171875
      ],
      [
        -3094.6171875,
        -3936.187744140625,
        1280.1251220703125
      ],
      [
        -3080.901123046875,
        -3903.1513671875,
        1082.623779296875
      ],
      [
        -3080.8984375,
        -3903.151123046875,
        1052.5999755859375
      ],
      [
        -3085.076904296875,
        -3903.60498046875,
        1187.623779296875
      ],
      [
        -3080.901123046875,
        -3903.1513671875,
        1082.623779296875
      ],
      [
        -3080.906005859375,
        -3903.15185546875,
        1139.7886962890625
      ],
      [
        -3077.043212890625,
        -3860.464111328125,
        1072.5999755859375
      ],
      [
        -3077.04150390625,
        -3860.464111328125,
        1052.5999755859375
      ],
      [
        -3078.84326171875,
        -3880.383056640625,
        1072.5999755859375
      ],
      [
        -3077.043212890625,
        -3860.464111328125,
        1072.5999755859375
      ],
      [
        -3111.3173828125,
        -4239.7685546875,
        1121.623779296875
      ],
      [
        -3111.311767578125,
        -4239.7685546875,
        1052.5999755859375
      ],
      [
        -3080.91015625,
        -3903.15234375,
        1187.623779296875
      ],
      [
        -3035.290771484375,
        -3398.328369140625,
        1088.03369140625
      ],
      [
        -3029.97216796875,
        -3339.265625,
        1302.5999755859375
      ],
      [
        -3030.255859375,
        -3342.416259765625,
        1291.154296875
      ],
      [
        -2937.185791015625,
        -3393.852783203125,
        1080.0
      ],
      [
        -2956.8212890625,
        -3397.729736328125,
        1080.0
      ],
      [
        -2937.185791015625,
        -3393.852783203125,
        1080.0
      ],
      [
        -2936.673095703125,
        -3397.090087890625,
        1069.902587890625
      ],
      [
        -3041.499755859375,
        -3898.87109375,
        1082.623779296875
      ],
      [
        -3041.499755859375,
        -3898.87109375,
        1052.5999755859375
      ],
      [
        -3041.499755859375,
        -3898.87109375,
        1187.623779296875
      ],
      [
        -3041.499755859375,
        -3898.87109375,
        1082.623779296875
      ],
      [
        -2539.053466796875,
        -3964.91552734375,
        1087.331787109375
      ],
      [
        -2464.74853515625,
        -3836.215576171875,
        1056.1944580078125
      ],
      [
        -2460.0,
        -3835.69970703125,
        1055.6033935546875
      ],
      [
        -2460.0,
        -3843.5283203125,
        1057.02392578125
      ],
      [
        -2555.334716796875,
        -3989.915283203125,
        1093.57373046875
      ],
      [
        -2466.7197265625,
        -3836.429443359375,
        1056.4398193359375
      ],
      [
        -2460.0,
        -3835.699462890625,
        1055.6033935546875
      ],
      [
        -2460.0,
        -3843.5283203125,
        1057.02392578125
      ],
      [
        -2586.52587890625,
        -3994.139892578125,
        1097.6080322265625
      ],
      [
        -2569.205322265625,
        -4004.139892578125,
        1097.6080322265625
      ],
      [
        -2643.68359375,
        -3961.139892578125,
        1097.6080322265625
      ],
      [
        -2586.52587890625,
        -3994.139892578125,
        1097.6080322265625
      ],
      [
        -2569.205322265625,
        -4004.139892578125,
        1097.6080322265625
      ],
      [
        -2579.205322265625,
        -4021.46044921875,
        1101.7984619140625
      ],
      [
        -2579.205322265625,
        -4021.46044921875,
        1101.79833984375
      ],
      [
        -2576.629638671875,
        -4022.947509765625,
        1101.0238037109375
      ],
      [
        -2576.78759765625,
        -4022.8564453125,
        1101.79833984375
      ],
      [
        -2643.68359375,
        -3961.139892578125,
        1097.6080322265625
      ],
      [
        -2695.376953125,
        -3926.67578125,
        1096.7698974609375
      ],
      [
        -2745.6064453125,
        -3897.67578125,
        1096.7698974609375
      ],
      [
        -2695.376953125,
        -3926.67578125,
        1096.7698974609375
      ],
      [
        -2744.5654296875,
        -3893.881591796875,
        1052.5999755859375
      ],
      [
        -2744.5654296875,
        -3893.881591796875,
        1082.623779296875
      ],
      [
        -2744.5654296875,
        -3893.881591796875,
        1082.623779296875
      ],
      [
        -2745.6064453125,
        -3897.67578125,
        1096.7698974609375
      ],
      [
        -2744.5654296875,
        -3893.881591796875,
        1095.972412109375
      ],
      [
        -2559.205322265625,
        -3986.8193359375,
        1093.41748046875
      ],
      [
        -2569.59765625,
        -3980.8193359375,
        1093.41748046875
      ],
      [
        -2576.52587890625,
        -3976.8193359375,
        1093.4173583984375
      ],
      [
        -2559.205322265625,
        -3986.8193359375,
        1093.41748046875
      ],
      [
        -2603.84619140625,
        -3984.139892578125,
        1097.60791015625
      ],
      [
        -2576.52587890625,
        -3976.8193359375,
        1093.41748046875
      ],
      [
        -2556.375,
        -3991.91748046875,
        1093.10546875
      ],
      [
        -2563.375,
        -4004.0419921875,
        1092.84326171875
      ],
      [
        -2559.205322265625,
        -3986.8193359375,
        1093.4176025390625
      ],
      [
        -2556.375,
        -3991.91748046875,
        1093.10546875
      ],
      [
        -2556.496337890625,
        -3991.698974609375,
        1094.01904296875
      ],
      [
        -2741.23046875,
        -3881.726806640625,
        1052.5999755859375
      ],
      [
        -2741.23046875,
        -3881.726806640625,
        1082.623779296875
      ],
      [
        -2741.23046875,
        -3881.726806640625,
        1082.623779296875
      ],
      [
        -2741.23046875,
        -3881.726806640625,
        1093.41748046875
      ],
      [
        -2737.60302734375,
        -3868.5068359375,
        1090.638671875
      ],
      [
        -2740.67431640625,
        -3866.19091796875,
        1082.623779296875
      ],
      [
        -2740.67431640625,
        -3866.19091796875,
        1052.5999755859375
      ],
      [
        -2740.67431640625,
        -3866.19091796875,
        1090.540283203125
      ],
      [
        -2740.67431640625,
        -3866.19091796875,
        1082.623779296875
      ],
      [
        -2737.60302734375,
        -3868.5068359375,
        1090.638671875
      ],
      [
        -2740.67431640625,
        -3866.19091796875,
        1226.623779296875
      ],
      [
        -2569.205322265625,
        -4004.139892578125,
        1114.038330078125
      ],
      [
        -2584.199951171875,
        -3995.482666015625,
        1187.623779296875
      ],
      [
        -2569.205322265625,
        -4004.139892578125,
        1114.0384521484375
      ],
      [
        -2579.205322265625,
        -4021.46044921875,
        1113.6636962890625
      ],
      [
        -2579.205322265625,
        -4021.46044921875,
        1113.6636962890625
      ],
      [
        -2598.382080078125,
        -3982.67578125,
        1096.769775390625
      ],
      [
        -2598.382080078125,
        -3982.67578125,
        1166.623779296875
      ],
      [
        -2559.205322265625,
        -3986.8193359375,
        1114.4124755859375
      ],
      [
        -2568.214111328125,
        -3981.6181640625,
        1158.623779296875
      ],
      [
        -2559.205322265625,
        -3986.8193359375,
        1114.412353515625
      ],
      [
        -2569.842529296875,
        -3980.677978515625,
        1166.6146240234375
      ],
      [
        -2559.205322265625,
        -3986.8193359375,
        1114.4124755859375
      ],
      [
        -2460.0,
        -3881.518798828125,
        1063.9173583984375
      ],
      [
        -2460.0,
        -3884.990966796875,
        1064.5474853515625
      ],
      [
        -2460.0,
        -3884.8955078125,
        1052.5999755859375
      ],
      [
        -2460.0,
        -3884.990966796875,
        1064.5474853515625
      ],
      [
        -2576.78759765625,
        -4022.8564453125,
        1101.7984619140625
      ],
      [
        -2548.89697265625,
        -4038.958984375,
        1101.0238037109375
      ],
      [
        -2548.894287109375,
        -4038.96044921875,
        1101.79833984375
      ],
      [
        -2530.52734375,
        -4006.816650390625,
        1052.5999755859375
      ],
      [
        -2530.38720703125,
        -4006.814453125,
        1082.623779296875
      ],
      [
        -2530.334228515625,
        -4006.8134765625,
        1094.0208740234375
      ],
      [
        -2530.567626953125,
        -4006.8173828125,
        1094.0460205078125
      ],
      [
        -2530.38720703125,
        -4006.814453125,
        1082.623779296875
      ],
      [
        -2556.375,
        -3991.91748046875,
        1094.0458984375
      ],
      [
        -2563.375,
        -4004.0419921875,
        1096.9793701171875
      ],
      [
        -2556.496337890625,
        -3991.698974609375,
        1094.01904296875
      ],
      [
        -2556.375,
        -3991.91748046875,
        1094.0458984375
      ],
      [
        -2524.737548828125,
        -4006.719482421875,
        1093.41748046875
      ],
      [
        -2516.548095703125,
        -4011.44775390625,
        1082.623779296875
      ],
      [
        -2516.548095703125,
        -4011.44775390625,
        1093.4176025390625
      ],
      [
        -2524.737548828125,
        -4006.719482421875,
        1093.41748046875
      ],
      [
        -2516.548095703125,
        -4011.44775390625,
        1052.5999755859375
      ],
      [
        -2516.548095703125,
        -4011.44775390625,
        1093.41748046875
      ],
      [
        -2524.737548828125,
        -4006.719482421875,
        1093.4176025390625
      ],
      [
        -2534.737548828125,
        -4024.0400390625,
        1097.6080322265625
      ],
      [
        -2526.578857421875,
        -4028.75048828125,
        1082.623779296875
      ],
      [
        -2526.578857421875,
        -4028.75048828125,
        1097.6080322265625
      ],
      [
        -2544.737548828125,
        -4041.3603515625,
        1101.79833984375
      ],
      [
        -2526.578857421875,
        -4028.75048828125,
        1187.623779296875
      ],
      [
        -2516.548095703125,
        -4011.44775390625,
        1158.623779296875
      ],
      [
        -2516.548095703125,
        -4011.44775390625,
        1166.623779296875
      ],
      [
        -2534.64892578125,
        -4006.885986328125,
        1142.623779296875
      ],
      [
        -2557.7763671875,
        -4007.2744140625,
        1194.623779296875
      ],
      [
        -2557.7763671875,
        -4007.2744140625,
        1142.623779296875
      ],
      [
        -2557.7763671875,
        -4007.2744140625,
        1194.623779296875
      ],
      [
        -2460.0,
        -4067.168212890625,
        1082.623779296875
      ],
      [
        -2460.0,
        -4067.168212890625,
        1052.5999755859375
      ],
      [
        -2460.0,
        -4067.168212890625,
        1172.623779296875
      ],
      [
        -2460.0,
        -4067.168212890625,
        1082.623779296875
      ],
      [
        -2460.0,
        -3827.99072265625,
        1054.20458984375
      ],
      [
        -2460.0,
        -3824.790771484375,
        1053.6239013671875
      ],
      [
        -2010.0,
        -3394.35986328125,
        1007.42724609375
      ],
      [
        -2010.0,
        -3336.106689453125,
        1160.166015625
      ],
      [
        -2010.0,
        -3336.106689453125,
        1160.166015625
      ],
      [
        -2010.0,
        -3271.035888671875,
        1302.5999755859375
      ],
      [
        -2010.0,
        -3490.472412109375,
        1109.14892578125
      ],
      [
        -2010.0,
        -3440.84375,
        1011.8688354492188
      ],
      [
        -1888.70703125,
        -3628.2177734375,
        1302.5999755859375
      ],
      [
        -1954.1270751953125,
        -3539.59130859375,
        1205.4261474609375
      ],
      [
        -1945.0,
        -3545.0,
        1214.4193115234375
      ],
      [
        -1991.890380859375,
        -3517.213134765625,
        1168.2171630859375
      ],
      [
        -2010.0,
        -3506.4814453125,
        1140.5296630859375
      ],
      [
        -2010.0,
        -3506.4814453125,
        1114.91552734375
      ],
      [
        -1954.1270751953125,
        -3539.59130859375,
        1205.4261474609375
      ],
      [
        -2010.0,
        -3793.99462890625,
        1052.5999755859375
      ],
      [
        -2010.0,
        -3733.333251953125,
        1052.5999755859375
      ],
      [
        -1945.0,
        -3545.0,
        1214.4193115234375
      ],
      [
        -1928.6549072265625,
        -3559.98291015625,
        1234.0
      ],
      [
        -1928.6549072265625,
        -3559.98291015625,
        1234.0
      ],
      [
        -1936.4140625,
        -3567.037109375,
        1234.0
      ],
      [
        -1945.0341796875,
        -3544.979736328125,
        1233.892822265625
      ],
      [
        -1945.0,
        -3545.0,
        1233.8914794921875
      ],
      [
        -1945.0955810546875,
        -3544.943359375,
        1233.895263671875
      ],
      [
        -1958.655029296875,
        -3536.908203125,
        1219.030029296875
      ],
      [
        -1945.0341796875,
        -3544.979736328125,
        1233.892822265625
      ],
      [
        -1958.655029296875,
        -3536.908203125,
        1219.030029296875
      ],
      [
        -1945.0955810546875,
        -3544.943359375,
        1233.895263671875
      ],
      [
        -1945.068115234375,
        -3545.033935546875,
        1234.0
      ],
      [
        -1982.8216552734375,
        -3533.51318359375,
        1203.4991455078125
      ],
      [
        -1945.0,
        -3545.0,
        1233.8914794921875
      ],
      [
        -1944.74267578125,
        -3545.23583984375,
        1234.0
      ],
      [
        -1945.068115234375,
        -3545.033935546875,
        1234.0
      ],
      [
        -1944.74267578125,
        -3545.23583984375,
        1234.0
      ],
      [
        -1812.5396728515625,
        -3483.12548828125,
        1167.278076171875
      ],
      [
        -1809.959716796875,
        -3551.677978515625,
        1302.5999755859375
      ],
      [
        -1822.9830322265625,
        -3407.556884765625,
        1000.8163452148438
      ],
      [
        -1822.9830322265625,
        -3407.556884765625,
        1000.8163452148438
      ],
      [
        -1826.26513671875,
        -3393.506103515625,
        966.8153686523438
      ],
      [
        -1826.2652587890625,
        -3393.506103515625,
        966.8153686523438
      ],
      [
        -1816.41650390625,
        -3380.125732421875,
        963.95751953125
      ],
      [
        -1760.0,
        -3362.54541015625,
        950.2199096679688
      ],
      [
        -1760.0,
        -3462.17236328125,
        1145.505126953125
      ],
      [
        -1812.5396728515625,
        -3483.12548828125,
        1167.278076171875
      ],
      [
        -1760.0,
        -3491.47998046875,
        1302.5999755859375
      ],
      [
        -1813.3851318359375,
        -3376.00732421875,
        963.0778198242188
      ],
      [
        -1816.41650390625,
        -3380.125732421875,
        963.95751953125
      ],
      [
        -1790.718017578125,
        -3344.77978515625,
        955.6844482421875
      ],
      [
        -1813.3851318359375,
        -3376.00732421875,
        963.0778198242188
      ],
      [
        -2010.0,
        -3440.84375,
        1011.8688354492188
      ],
      [
        -2010.0,
        -3424.79638671875,
        1010.5689086914062
      ],
      [
        -2010.0,
        -3424.79638671875,
        1010.5689086914062
      ],
      [
        -2010.0,
        -3394.35986328125,
        1007.42724609375
      ],
      [
        -2010.0,
        -3506.4814453125,
        1162.74072265625
      ],
      [
        -2010.0,
        -3506.4814453125,
        1162.74072265625
      ],
      [
        -2010.0,
        -3517.407470703125,
        1173.7037353515625
      ],
      [
        -2093.25244140625,
        -3407.82421875,
        1052.5999755859375
      ],
      [
        -2010.0,
        -3383.087646484375,
        1036.9825439453125
      ],
      [
        -2010.0,
        -3396.96630859375,
        1007.6962890625
      ],
      [
        -2095.4931640625,
        -3425.24658203125,
        1027.7513427734375
      ],
      [
        -2095.09765625,
        -3424.814697265625,
        1027.6839599609375
      ],
      [
        -2095.990966796875,
        -3423.116943359375,
        1027.5908203125
      ],
      [
        -2010.0,
        -3441.03564453125,
        1012.2451782226562
      ],
      [
        -2010.0,
        -3444.63427734375,
        1019.2986450195312
      ],
      [
        -2073.61328125,
        -3488.20263671875,
        1031.9949951171875
      ],
      [
        -2010.0,
        -3446.653564453125,
        1023.2570190429688
      ],
      [
        -2067.7431640625,
        -3460.420166015625,
        1029.0318603515625
      ],
      [
        -2010.0,
        -3446.897216796875,
        1023.7344970703125
      ],
      [
        -2080.0,
        -3465.0,
        1030.313232421875
      ],
      [
        -2069.96728515625,
        -3470.9453125,
        1030.1544189453125
      ],
      [
        -2095.0,
        -3425.0,
        1027.694091796875
      ],
      [
        -2095.0,
        -3425.0,
        1027.694091796875
      ],
      [
        -2074.42822265625,
        -3493.7626953125,
        1033.019775390625
      ],
      [
        -2235.4189453125,
        -3584.956787109375,
        1052.5999755859375
      ],
      [
        -2067.52734375,
        -3460.532470703125,
        1029.3314208984375
      ],
      [
        -2010.0,
        -3447.13427734375,
        1024.19921875
      ],
      [
        -2080.0,
        -3465.0,
        1030.595947265625
      ],
      [
        -2069.720458984375,
        -3471.091552734375,
        1030.50341796875
      ],
      [
        -2095.0,
        -3425.0,
        1027.707763671875
      ],
      [
        -2095.0,
        -3425.0,
        1027.707763671875
      ],
      [
        -2074.00537109375,
        -3402.604736328125,
        1052.5999755859375
      ],
      [
        -2010.0,
        -3377.13134765625,
        1052.5999755859375
      ],
      [
        -2074.00537109375,
        -3402.604736328125,
        1052.5999755859375
      ],
      [
        -2093.25244140625,
        -3407.82421875,
        1052.5999755859375
      ],
      [
        -2102.800048828125,
        -3411.51708984375,
        1052.5999755859375
      ],
      [
        -2096.996826171875,
        -3421.205810546875,
        1027.819580078125
      ],
      [
        -2101.585205078125,
        -3413.5810546875,
        1052.5999755859375
      ],
      [
        -2096.940185546875,
        -3421.313232421875,
        1027.478759765625
      ],
      [
        -2096.996826171875,
        -3421.205810546875,
        1027.819580078125
      ],
      [
        -2050.7568359375,
        -3469.260498046875,
        1052.5999755859375
      ],
      [
        -2010.0,
        -3461.623291015625,
        1052.5999755859375
      ],
      [
        -2080.0,
        -3465.0,
        1033.5072021484375
      ],
      [
        -2054.08740234375,
        -3480.35546875,
        1052.5999755859375
      ],
      [
        -2067.511962890625,
        -3472.400146484375,
        1052.5999755859375
      ],
      [
        -2105.0,
        -3430.0,
        1052.5999755859375
      ],
      [
        -2095.0,
        -3425.0,
        1052.5999755859375
      ],
      [
        -2096.146240234375,
        -3422.82177734375,
        1052.5999755859375
      ],
      [
        -2095.0,
        -3425.0,
        1052.5999755859375
      ],
      [
        -2096.146240234375,
        -3422.82177734375,
        1052.5999755859375
      ],
      [
        -2080.0,
        -3465.0,
        1052.5999755859375
      ],
      [
        -3720.0,
        -4765.74462890625,
        1052.5999755859375
      ],
      [
        -3720.0,
        -4653.587890625,
        1052.5999755859375
      ],
      [
        -3720.0,
        -4656.16015625,
        1052.5999755859375
      ],
      [
        -3720.0,
        -4318.77197265625,
        1052.5999755859375
      ],
      [
        -3720.0,
        -3960.0,
        1052.5999755859375
      ],
      [
        -3720.0,
        -4970.0,
        1052.5999755859375
      ],
      [
        -3720.0,
        -4271.61572265625,
        1152.6011962890625
      ],
      [
        -3720.0,
        -4099.7685546875,
        1152.6011962890625
      ],
      [
        -3720.0,
        -4879.7685546875,
        1302.5999755859375
      ],
      [
        -3720.0,
        -4856.95947265625,
        1188.553955078125
      ],
      [
        -3699.999755859375,
        -4719.7685546875,
        1052.5999755859375
      ],
      [
        -3720.0,
        -4784.76953125,
        1158.5577392578125
      ],
      [
        -3720.0,
        -4740.96044921875,
        1158.5577392578125
      ],
      [
        -3720.0,
        -4784.76953125,
        1158.5577392578125
      ],
      [
        -3720.0,
        -4856.95947265625,
        1188.553955078125
      ],
      [
        -3430.738037109375,
        -4186.0302734375,
        1092.4654541015625
      ],
      [
        -3424.76611328125,
        -4192.001953125,
        1052.5999755859375
      ],
      [
        -3720.0,
        -4695.8271484375,
        1158.5577392578125
      ],
      [
        -3720.0,
        -4672.56103515625,
        1052.5999755859375
      ],
      [
        -3720.0,
        -4695.8271484375,
        1158.5577392578125
      ],
      [
        -3376.999755859375,
        -4239.7685546875,
        1090.5311279296875
      ],
      [
        -3280.0,
        -4239.7685546875,
        1061.7740478515625
      ],
      [
        -3450.0,
        -4553.38916015625,
        1112.1729736328125
      ],
      [
        -3451.2861328125,
        -4408.373046875,
        1112.5543212890625
      ],
      [
        -3454.023193359375,
        -4413.39990234375,
        1113.36572265625
      ],
      [
        -3474.777587890625,
        -4404.92822265625,
        1102.3896484375
      ],
      [
        -3450.0,
        -4406.0107421875,
        1112.1729736328125
      ],
      [
        -3450.0,
        -4406.0107421875,
        1112.1729736328125
      ],
      [
        -3430.738037109375,
        -4186.0302734375,
        1106.4625244140625
      ],
      [
        -3376.999755859375,
        -4239.7685546875,
        1090.5311279296875
      ],
      [
        -3430.738037109375,
        -4186.0302734375,
        1107.5933837890625
      ],
      [
        -3417.001953125,
        -4199.76611328125,
        1102.3902587890625
      ],
      [
        -3720.0,
        -4254.21875,
        1152.6011962890625
      ],
      [
        -2460.0,
        -4969.7685546875,
        1302.5999755859375
      ],
      [
        -2460.0,
        -5169.7685546875,
        1534.9000244140625
      ],
      [
        -3280.0,
        -5244.791015625,
        1534.9000244140625
      ],
      [
        -3280.0,
        -5117.62890625,
        1418.4383544921875
      ],
      [
        -3280.0,
        -5041.67822265625,
        1350.2730712890625
      ],
      [
        -3280.0,
        -5117.62890625,
        1418.4383544921875
      ],
      [
        -3280.0,
        -4981.95361328125,
        1302.5999755859375
      ],
      [
        -3280.0,
        -5041.67822265625,
        1350.2730712890625
      ],
      [
        -3016.616455078125,
        -3239.552001953125,
        1476.240234375
      ],
      [
        -3161.864501953125,
        -3346.458740234375,
        1434.564697265625
      ],
      [
        -3035.258056640625,
        -3237.51708984375,
        1487.3131103515625
      ],
      [
        -3035.258056640625,
        -3237.51708984375,
        1487.3131103515625
      ],
      [
        -3016.616455078125,
        -3239.552001953125,
        1476.240234375
      ],
      [
        -3161.864501953125,
        -3346.458740234375,
        1434.564697265625
      ],
      [
        -3106.85986328125,
        -3381.18115234375,
        1327.955322265625
      ],
      [
        -3156.801025390625,
        -3354.920166015625,
        1423.3140869140625
      ],
      [
        -3086.888427734375,
        -3384.146240234375,
        1302.5999755859375
      ],
      [
        -3106.85986328125,
        -3381.18115234375,
        1327.955322265625
      ],
      [
        -3124.666259765625,
        -3408.620849609375,
        1351.9122314453125
      ],
      [
        -3085.00634765625,
        -3437.66064453125,
        1302.5999755859375
      ],
      [
        -3124.666259765625,
        -3408.620849609375,
        1351.9122314453125
      ],
      [
        -3162.6396484375,
        -4861.31201171875,
        1332.522705078125
      ],
      [
        -3171.936767578125,
        -4861.48193359375,
        1344.58447265625
      ],
      [
        -3153.473388671875,
        -4906.16357421875,
        1317.9111328125
      ],
      [
        -3151.940185546875,
        -4861.1162109375,
        1318.640869140625
      ],
      [
        -3185.643798828125,
        -4860.693359375,
        1302.5999755859375
      ],
      [
        -3151.91455078125,
        -4860.365234375,
        1318.653076171875
      ],
      [
        -3162.6396484375,
        -4861.31201171875,
        1332.522705078125
      ],
      [
        -3151.91455078125,
        -4860.365234375,
        1318.653076171875
      ],
      [
        -3147.812255859375,
        -3369.941650390625,
        1403.34130859375
      ],
      [
        -3151.955322265625,
        -4861.56103515625,
        1318.6336669921875
      ],
      [
        -2954.386962890625,
        -4860.4365234375,
        1302.5999755859375
      ],
      [
        -3170.65673828125,
        -4861.45849609375,
        1342.9239501953125
      ],
      [
        -3151.940185546875,
        -4861.1162109375,
        1318.640869140625
      ],
      [
        -2460.0,
        -3271.27490234375,
        1335.750732421875
      ],
      [
        -2460.0,
        -3308.51708984375,
        1302.5999755859375
      ],
      [
        -1760.0,
        -3196.33544921875,
        1314.8060302734375
      ],
      [
        -1823.181640625,
        -3567.609619140625,
        1302.5999755859375
      ],
      [
        -1760.0,
        -3524.104736328125,
        1364.2069091796875
      ],
      [
        -3720.0,
        -4879.7685546875,
        1302.5999755859375
      ],
      [
        -3720.0,
        -5079.7685546875,
        1534.9000244140625
      ],
      [
        -3303.90771484375,
        -5226.4208984375,
        1534.9000244140625
      ],
      [
        -3280.0,
        -5190.60986328125,
        1485.2779541015625
      ],
      [
        -3749.99951171875,
        -4839.2734375,
        1302.5999755859375
      ],
      [
        -3963.99951171875,
        -4828.22119140625,
        1534.9000244140625
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        -0.7832221984863281,
        -0.4408717155456543,
        0.43840065598487854
      ],
      "plane_d": -2407.586669921875,
      "bbox_min": [
        -660.0,
        -3350.221435546875,
        1094.86962890625
      ],
      "bbox_max": [
        -513.5322265625,
        -2993.1591796875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4566386640071869,
        0.6905266642570496,
        0.5609403848648071
      ],
      "plane_d": 1281.354736328125,
      "bbox_min": [
        -660.0,
        -3253.36376953125,
        1094.86962890625
      ],
      "bbox_max": [
        -513.5322265625,
        -3153.4228515625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7552521228790283,
        -0.561424732208252,
        0.3382256329059601
      ],
      "plane_d": -2654.937744140625,
      "bbox_min": [
        -660.0,
        -3253.36376953125,
        1094.86962890625
      ],
      "bbox_max": [
        -513.5322265625,
        -3153.4228515625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4566386640071869,
        0.6905266642570496,
        0.5609403848648071
      ],
      "plane_d": 1281.354736328125,
      "bbox_min": [
        -660.0,
        -3350.221435546875,
        1104.97119140625
      ],
      "bbox_max": [
        -513.5322265625,
        -3189.680419921875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": 0.0,
      "bbox_min": [
        -1236.751220703125,
        -3650.0,
        0.0
      ],
      "bbox_max": [
        -917.23828125,
        -3394.232421875,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6477525234222412,
        -0.7609485387802124,
        0.03706754744052887
      ],
      "plane_d": -3420.204345703125,
      "bbox_min": [
        -1224.5528564453125,
        -3650.0,
        0.0
      ],
      "bbox_max": [
        -977.0939331054688,
        -3394.232421875,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8973290324211121,
        -0.4287506937980652,
        0.1047549843788147
      ],
      "plane_d": -2564.411865234375,
      "bbox_min": [
        -1208.414794921875,
        -3440.52197265625,
        225.0
      ],
      "bbox_max": [
        -1182.7503662109375,
        -3394.232421875,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8235416412353516,
        -0.5580507516860962,
        0.10177668184041977
      ],
      "plane_d": -2915.920166015625,
      "bbox_min": [
        -1208.414794921875,
        -3409.848388671875,
        225.0
      ],
      "bbox_max": [
        -1198.09375,
        -3394.232421875,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6944899559020996,
        -0.6407128572463989,
        0.3273695409297943
      ],
      "plane_d": -1423.39990234375,
      "bbox_min": [
        -1208.414794921875,
        -3409.848388671875,
        225.0
      ],
      "bbox_max": [
        -1202.3095703125,
        -3394.232421875,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1290990114212036,
        -0.8996244668960571,
        0.41714420914649963
      ],
      "plane_d": -3006.223388671875,
      "bbox_min": [
        -1224.5528564453125,
        -3507.97802734375,
        0.0
      ],
      "bbox_max": [
        -1159.1053466796875,
        -3395.00634765625,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04223942756652832,
        -0.9113441109657288,
        0.4094725549221039
      ],
      "plane_d": -3270.52197265625,
      "bbox_min": [
        -1224.50634765625,
        -3412.709228515625,
        265.3875427246094
      ],
      "bbox_max": [
        -1223.98681640625,
        -3411.963134765625,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9405732750892639,
        -0.10687936842441559,
        0.3223331570625305
      ],
      "plane_d": 700.9578857421875,
      "bbox_min": [
        -1224.50634765625,
        -3412.709228515625,
        265.3875427246094
      ],
      "bbox_max": [
        -1223.98681640625,
        -3411.963134765625,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6944899559020996,
        -0.6407128572463989,
        0.3273695409297943
      ],
      "plane_d": -1423.39990234375,
      "bbox_min": [
        -1224.5528564453125,
        -3448.7548828125,
        225.0
      ],
      "bbox_max": [
        -1202.3095703125,
        -3395.00634765625,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04223942756652832,
        -0.9113441109657288,
        0.4094725549221039
      ],
      "plane_d": -3270.52197265625,
      "bbox_min": [
        -1224.51025390625,
        -3412.709228515625,
        265.3875427246094
      ],
      "bbox_max": [
        -1223.98681640625,
        -3411.97802734375,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9405732750892639,
        -0.10687936842441559,
        0.3223331570625305
      ],
      "plane_d": 700.9578857421875,
      "bbox_min": [
        -1224.51025390625,
        -3412.709228515625,
        265.3875427246094
      ],
      "bbox_max": [
        -1223.98681640625,
        -3412.418212890625,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9327303767204285,
        0.12842270731925964,
        0.33692970871925354
      ],
      "plane_d": 1490.5020751953125,
      "bbox_min": [
        -1224.5528564453125,
        -3448.7548828125,
        252.16676330566406
      ],
      "bbox_max": [
        -1214.2481689453125,
        -3412.45263671875,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9405732750892639,
        -0.10687936842441559,
        0.3223331570625305
      ],
      "plane_d": 700.9578857421875,
      "bbox_min": [
        -1224.5528564453125,
        -3412.828125,
        265.3875427246094
      ],
      "bbox_max": [
        -1223.98681640625,
        -3412.45263671875,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6831920742988586,
        -0.7259601950645447,
        0.07893336564302444
      ],
      "plane_d": -3338.5439453125,
      "bbox_min": [
        -1220.430419921875,
        -3650.0,
        0.0
      ],
      "bbox_max": [
        -977.0939331054688,
        -3442.769775390625,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6572308540344238,
        -0.7498543858528137,
        0.07593389600515366
      ],
      "plane_d": -3399.419189453125,
      "bbox_min": [
        -1011.593017578125,
        -3650.0,
        0.0
      ],
      "bbox_max": [
        -977.0939331054688,
        -3646.800048828125,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6998437643051147,
        -0.7020972967147827,
        0.13144628703594208
      ],
      "plane_d": -3268.36572265625,
      "bbox_min": [
        -1011.593017578125,
        -3650.0,
        0.0
      ],
      "bbox_max": [
        -1007.23779296875,
        -3646.800048828125,
        6.09613037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7116605639457703,
        0.7005480527877808,
        0.05264675244688988
      ],
      "plane_d": 3300.78955078125,
      "bbox_min": [
        -1220.430419921875,
        -3650.0,
        0.0
      ],
      "bbox_max": [
        -1007.8887329101562,
        -3442.769775390625,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7090446352958679,
        0.7030144929885864,
        0.055013131350278854
      ],
      "plane_d": 3306.3583984375,
      "bbox_min": [
        -1204.3563232421875,
        -3646.800048828125,
        0.0
      ],
      "bbox_max": [
        -1068.0478515625,
        -3508.329345703125,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7080089449882507,
        0.7036092877388,
        0.06047677621245384
      ],
      "plane_d": 3305.96240234375,
      "bbox_min": [
        -1203.686767578125,
        -3646.800048828125,
        228.19198608398438
      ],
      "bbox_max": [
        -1068.0478515625,
        -3509.99755859375,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9202737212181091,
        0.3693651854991913,
        0.12909552454948425
      ],
      "plane_d": 2369.723876953125,
      "bbox_min": [
        -1203.474609375,
        -3515.152099609375,
        228.19198608398438
      ],
      "bbox_max": [
        -1196.587890625,
        -3510.526123046875,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9202737212181091,
        0.3693651854991913,
        0.12909552454948425
      ],
      "plane_d": 2369.723876953125,
      "bbox_min": [
        -1203.686767578125,
        -3514.12060546875,
        228.19198608398438
      ],
      "bbox_max": [
        -1196.587890625,
        -3509.99755859375,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9202737212181091,
        0.3693651854991913,
        0.12909552454948425
      ],
      "plane_d": 2369.723876953125,
      "bbox_min": [
        -1204.3563232421875,
        -3514.12060546875,
        228.19198608398438
      ],
      "bbox_max": [
        -1196.587890625,
        -3508.329345703125,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9327303767204285,
        0.12842270731925964,
        0.33692970871925354
      ],
      "plane_d": 1490.5020751953125,
      "bbox_min": [
        -1197.494384765625,
        -3514.12060546875,
        228.19198608398438
      ],
      "bbox_max": [
        -1196.587890625,
        -3512.52685546875,
        230.0940399169922
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7149500250816345,
        -0.6106722354888916,
        0.3404790163040161
      ],
      "plane_d": -1299.316162109375,
      "bbox_min": [
        -1220.430419921875,
        -3650.0,
        0.0
      ],
      "bbox_max": [
        -1007.8887329101562,
        -3442.769775390625,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1290990114212036,
        -0.8996244668960571,
        0.41714420914649963
      ],
      "plane_d": -3006.223388671875,
      "bbox_min": [
        -1220.430419921875,
        -3650.0,
        0.0
      ],
      "bbox_max": [
        -1007.8887329101562,
        -3442.769775390625,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9327303767204285,
        0.12842270731925964,
        0.33692970871925354
      ],
      "plane_d": 1490.5020751953125,
      "bbox_min": [
        -1220.430419921875,
        -3650.0,
        0.0
      ],
      "bbox_max": [
        -1007.8887329101562,
        -3442.769775390625,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9202737212181091,
        0.3693651854991913,
        0.12909552454948425
      ],
      "plane_d": 2369.723876953125,
      "bbox_min": [
        -1215.0838623046875,
        -3650.0,
        0.0
      ],
      "bbox_max": [
        -1007.8887329101562,
        -3481.6015625,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6998437643051147,
        -0.7020972967147827,
        0.13144628703594208
      ],
      "plane_d": -3268.36572265625,
      "bbox_min": [
        -1011.593017578125,
        -3650.0,
        0.0
      ],
      "bbox_max": [
        -1007.8887329101562,
        -3646.800048828125,
        2.6302847862243652
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8137342929840088,
        -0.5748793482780457,
        0.08573256433010101
      ],
      "plane_d": -2924.1494140625,
      "bbox_min": [
        -1367.9073486328125,
        -3107.087646484375,
        577.0269165039062
      ],
      "bbox_max": [
        -1333.1427001953125,
        -3089.99560546875,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7995961308479309,
        -0.5955905318260193,
        0.0769285261631012
      ],
      "plane_d": -2963.00537109375,
      "bbox_min": [
        -1335.0894775390625,
        -3092.033935546875,
        711.556884765625
      ],
      "bbox_max": [
        -1333.5472412109375,
        -3090.4482421875,
        718.399658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.796037495136261,
        -0.5924747586250305,
        0.12368514388799667
      ],
      "plane_d": -2981.951171875,
      "bbox_min": [
        -1335.0894775390625,
        -3092.033935546875,
        711.556884765625
      ],
      "bbox_max": [
        -1333.9539794921875,
        -3090.4482421875,
        712.7704467773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44718649983406067,
        -0.8943867683410645,
        0.009831518866121769
      ],
      "plane_d": -2174.02978515625,
      "bbox_min": [
        -1367.9073486328125,
        -3107.087646484375,
        577.0269165039062
      ],
      "bbox_max": [
        -1333.1427001953125,
        -3089.99560546875,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4278530180454254,
        -0.903739333152771,
        0.014034316875040531
      ],
      "plane_d": -2231.740478515625,
      "bbox_min": [
        -1367.668701171875,
        -3106.9814453125,
        613.0665893554688
      ],
      "bbox_max": [
        -1335.0894775390625,
        -3090.4482421875,
        712.7554321289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44900059700012207,
        -0.8935260772705078,
        0.003092230297625065
      ],
      "plane_d": -2164.14404296875,
      "bbox_min": [
        -1367.668701171875,
        -3106.9814453125,
        638.2857666015625
      ],
      "bbox_max": [
        -1335.0894775390625,
        -3090.4482421875,
        712.7554321289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4523264467716217,
        -0.8918522596359253,
        0.0003948037629015744
      ],
      "plane_d": -2152.6083984375,
      "bbox_min": [
        -1367.668701171875,
        -3106.9814453125,
        662.6285400390625
      ],
      "bbox_max": [
        -1335.0894775390625,
        -3090.4482421875,
        712.7554321289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4523264467716217,
        -0.8918522596359253,
        0.0003948037629015744
      ],
      "plane_d": -2152.6083984375,
      "bbox_min": [
        -1367.9073486328125,
        -3107.087646484375,
        690.6090087890625
      ],
      "bbox_max": [
        -1333.1427001953125,
        -3089.99560546875,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7995961308479309,
        -0.5955905318260193,
        0.0769285261631012
      ],
      "plane_d": -2963.00537109375,
      "bbox_min": [
        -1335.0894775390625,
        -3090.4482421875,
        712.7554321289062
      ],
      "bbox_max": [
        -1334.30712890625,
        -3089.99560546875,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45534273982048035,
        -0.890298068523407,
        0.00568737369030714
      ],
      "plane_d": -2147.550537109375,
      "bbox_min": [
        -1372.2017822265625,
        -3108.999755859375,
        724.0
      ],
      "bbox_max": [
        -1329.0966796875,
        -3042.10009765625,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4523264467716217,
        -0.8918522596359253,
        0.0003948037629015744
      ],
      "plane_d": -2152.6083984375,
      "bbox_min": [
        -1367.9959716796875,
        -3107.127197265625,
        724.0
      ],
      "bbox_max": [
        -1348.800048828125,
        -3042.10009765625,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47822824120521545,
        0.24448950588703156,
        0.8435180187225342
      ],
      "plane_d": 735.2036743164062,
      "bbox_min": [
        -1357.9000244140625,
        -3059.90673828125,
        779.9929809570312
      ],
      "bbox_max": [
        -1348.800048828125,
        -3042.10009765625,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4771321713924408,
        0.2466089278459549,
        0.8435217142105103
      ],
      "plane_d": 740.2075805664062,
      "bbox_min": [
        -1348.809814453125,
        -3059.90673828125,
        779.9929809570312
      ],
      "bbox_max": [
        -1348.800048828125,
        -3059.89990234375,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7995961308479309,
        -0.5955905318260193,
        0.0769285261631012
      ],
      "plane_d": -2963.00537109375,
      "bbox_min": [
        -1334.3448486328125,
        -3091.609375,
        724.0
      ],
      "bbox_max": [
        -1329.0966796875,
        -3087.7412109375,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7746099233627319,
        -0.5822634696960449,
        0.2468777596950531
      ],
      "plane_d": -3030.36767578125,
      "bbox_min": [
        -1595.0,
        -3208.19580078125,
        780.0
      ],
      "bbox_max": [
        -1197.2042236328125,
        -3031.0859375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6115233302116394,
        -0.7912264466285706,
        0.0
      ],
      "plane_d": -1576.6024169921875,
      "bbox_min": [
        -1368.22216796875,
        -3092.12890625,
        780.0
      ],
      "bbox_max": [
        -1197.2042236328125,
        -3031.0859375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45534273982048035,
        -0.890298068523407,
        0.00568737369030714
      ],
      "plane_d": -2147.550537109375,
      "bbox_min": [
        -1368.22216796875,
        -3092.12890625,
        780.0
      ],
      "bbox_max": [
        -1197.2042236328125,
        -3031.0859375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47822824120521545,
        0.24448950588703156,
        0.8435180187225342
      ],
      "plane_d": 735.2036743164062,
      "bbox_min": [
        -1368.22216796875,
        -3066.077880859375,
        780.0
      ],
      "bbox_max": [
        -1348.8089599609375,
        -3042.10009765625,
        788.1644287109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4771321713924408,
        0.2466089278459549,
        0.8435217142105103
      ],
      "plane_d": 740.2075805664062,
      "bbox_min": [
        -1357.8485107421875,
        -3066.077880859375,
        780.0
      ],
      "bbox_max": [
        -1348.8089599609375,
        -3059.905029296875,
        786.4833374023438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7995961308479309,
        -0.5955905318260193,
        0.0769285261631012
      ],
      "plane_d": -2963.00537109375,
      "bbox_min": [
        -1330.6363525390625,
        -3089.80810546875,
        780.0
      ],
      "bbox_max": [
        -1197.2042236328125,
        -3031.0859375,
        1302.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6744422316551208,
        -0.542770504951477,
        0.5005276203155518
      ],
      "plane_d": -1478.223388671875,
      "bbox_min": [
        -1216.4732666015625,
        -3039.0107421875,
        1292.563720703125
      ],
      "bbox_max": [
        -1212.1756591796875,
        -3033.836669921875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4557587504386902,
        -0.8900548815727234,
        -0.00928233191370964
      ],
      "plane_d": -2133.771484375,
      "bbox_min": [
        -1595.0,
        -3208.19580078125,
        780.0
      ],
      "bbox_max": [
        -1216.4732666015625,
        -3033.836669921875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43772801756858826,
        -0.8991074562072754,
        0.0
      ],
      "plane_d": -2195.2607421875,
      "bbox_min": [
        -1595.0,
        -3208.19580078125,
        786.3157348632812
      ],
      "bbox_max": [
        -1216.4732666015625,
        -3033.836669921875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6115233302116394,
        -0.7912264466285706,
        0.0
      ],
      "plane_d": -1576.6024169921875,
      "bbox_min": [
        -1595.0,
        -3208.19580078125,
        786.3157348632812
      ],
      "bbox_max": [
        -1356.784423828125,
        -3042.148681640625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1012493446469307,
        -0.9274534583091736,
        0.35997048020362854
      ],
      "plane_d": -3251.482177734375,
      "bbox_min": [
        -1595.0,
        -3208.19580078125,
        850.0
      ],
      "bbox_max": [
        -1446.4000244140625,
        -3110.5,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4433528184890747,
        -0.8963472843170166,
        0.0
      ],
      "plane_d": -2146.82275390625,
      "bbox_min": [
        -1465.0,
        -3124.875244140625,
        850.0
      ],
      "bbox_max": [
        -1446.4000244140625,
        -3110.5,
        919.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1465.0,
      "bbox_min": [
        -1465.0,
        -3124.875244140625,
        850.0
      ],
      "bbox_max": [
        -1446.4000244140625,
        -3110.5,
        919.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -850.0,
      "bbox_min": [
        -1465.0,
        -3124.875244140625,
        850.0
      ],
      "bbox_max": [
        -1446.4000244140625,
        -3110.5,
        850.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47822824120521545,
        0.24448950588703156,
        0.8435180187225342
      ],
      "plane_d": 735.2036743164062,
      "bbox_min": [
        -1465.0,
        -3150.316162109375,
        786.4833374023438
      ],
      "bbox_max": [
        -1357.8485107421875,
        -3062.966064453125,
        872.1614990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -850.0,
      "bbox_min": [
        -1465.0,
        -3150.316162109375,
        849.9962158203125
      ],
      "bbox_max": [
        -1437.23388671875,
        -3110.5,
        872.0855712890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1465.0,
      "bbox_min": [
        -1465.0,
        -3150.316162109375,
        850.0
      ],
      "bbox_max": [
        -1465.0,
        -3124.875244140625,
        872.0855712890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1465.0,
      "bbox_min": [
        -1465.0,
        -3150.316162109375,
        849.9962158203125
      ],
      "bbox_max": [
        -1437.199951171875,
        -3110.5,
        872.1614990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -850.0,
      "bbox_min": [
        -1446.4000244140625,
        -3128.416015625,
        849.9962158203125
      ],
      "bbox_max": [
        -1437.199951171875,
        -3110.5,
        850.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1012493446469307,
        -0.9274534583091736,
        0.35997048020362854
      ],
      "plane_d": -3251.482177734375,
      "bbox_min": [
        -1542.645263671875,
        -3184.885986328125,
        1260.7716064453125
      ],
      "bbox_max": [
        -1465.99853515625,
        -3150.7607421875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11021039634943008,
        -0.9280050992965698,
        0.3558935821056366
      ],
      "plane_d": -3234.49072265625,
      "bbox_min": [
        -1501.1502685546875,
        -3166.4111328125,
        1296.7000732421875
      ],
      "bbox_max": [
        -1497.9481201171875,
        -3163.810791015625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.001288205268792808,
        -0.936079740524292,
        0.3517853915691376
      ],
      "plane_d": -3417.884521484375,
      "bbox_min": [
        -1498.3060302734375,
        -3165.048583984375,
        1299.30517578125
      ],
      "bbox_max": [
        -1497.9481201171875,
        -3163.810791015625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.001288205268792808,
        -0.936079740524292,
        0.3517853915691376
      ],
      "plane_d": -3417.884521484375,
      "bbox_min": [
        -1498.3060302734375,
        -3164.9853515625,
        1299.4727783203125
      ],
      "bbox_max": [
        -1497.2191162109375,
        -3163.810791015625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3377978503704071,
        -0.8362663984298706,
        0.4319157302379608
      ],
      "plane_d": -2702.277587890625,
      "bbox_min": [
        -1498.3060302734375,
        -3164.75390625,
        1300.087158203125
      ],
      "bbox_max": [
        -1497.2191162109375,
        -3163.810791015625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4556112587451935,
        -0.8901628255844116,
        0.005325810518115759
      ],
      "plane_d": -2146.4755859375,
      "bbox_min": [
        -1377.009033203125,
        -3111.14013671875,
        780.0
      ],
      "bbox_max": [
        -1325.112548828125,
        -3085.589599609375,
        833.904541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45534273982048035,
        -0.890298068523407,
        0.00568737369030714
      ],
      "plane_d": -2147.550537109375,
      "bbox_min": [
        -1373.194091796875,
        -3109.441650390625,
        780.0
      ],
      "bbox_max": [
        -1325.112548828125,
        -3085.589599609375,
        833.904541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8007402420043945,
        -0.5945212841033936,
        0.073208749294281
      ],
      "plane_d": -2958.124267578125,
      "bbox_min": [
        -1327.09716796875,
        -3088.09423828125,
        833.34326171875
      ],
      "bbox_max": [
        -1325.222900390625,
        -3085.589599609375,
        833.690185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.024503104388713837,
        0.08246573805809021,
        0.9962926506996155
      ],
      "plane_d": -534.0615234375,
      "bbox_min": [
        -1247.3983154296875,
        -3392.85400390625,
        805.8817749023438
      ],
      "bbox_max": [
        -660.0,
        -2930.939453125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5389724969863892,
        0.6360949873924255,
        0.5521700382232666
      ],
      "plane_d": 1050.81884765625,
      "bbox_min": [
        -1247.3983154296875,
        -3392.85400390625,
        805.8817749023438
      ],
      "bbox_max": [
        -660.0,
        -2930.939453125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4566386640071869,
        0.6905266642570496,
        0.5609403848648071
      ],
      "plane_d": 1281.354736328125,
      "bbox_min": [
        -845.512451171875,
        -3379.62841796875,
        831.763671875
      ],
      "bbox_max": [
        -660.0,
        -3090.42138671875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7552521228790283,
        -0.561424732208252,
        0.3382256329059601
      ],
      "plane_d": -2654.937744140625,
      "bbox_min": [
        -845.512451171875,
        -3181.474609375,
        831.763671875
      ],
      "bbox_max": [
        -660.0,
        -3090.42138671875,
        1108.3670654296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6744422316551208,
        -0.542770504951477,
        0.5005276203155518
      ],
      "plane_d": -1478.223388671875,
      "bbox_min": [
        -1247.3983154296875,
        -3231.95166015625,
        805.8817749023438
      ],
      "bbox_max": [
        -660.0,
        -2930.939453125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9954870343208313,
        -0.08357247710227966,
        -0.044957485049963
      ],
      "plane_d": -1100.083740234375,
      "bbox_min": [
        -906.4345703125,
        -3046.740478515625,
        805.8817749023438
      ],
      "bbox_max": [
        -887.85498046875,
        -2976.87353515625,
        848.0270385742188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9980483651161194,
        -0.052817005664110184,
        0.03331343084573746
      ],
      "plane_d": -1074.771728515625,
      "bbox_min": [
        -906.4345703125,
        -3046.740478515625,
        805.8817749023438
      ],
      "bbox_max": [
        -887.85498046875,
        -2985.04052734375,
        842.2794799804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7026313543319702,
        0.032863739877939224,
        0.7107947468757629
      ],
      "plane_d": -1111.423583984375,
      "bbox_min": [
        -906.4345703125,
        -3046.740478515625,
        805.8817749023438
      ],
      "bbox_max": [
        -888.2889404296875,
        -2985.04052734375,
        826.2155151367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6638638377189636,
        0.052185166627168655,
        0.7460305094718933
      ],
      "plane_d": -1046.896484375,
      "bbox_min": [
        -906.4345703125,
        -3046.740478515625,
        805.8817749023438
      ],
      "bbox_max": [
        -893.6441650390625,
        -2990.6005859375,
        820.9852905273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7746099233627319,
        -0.5822634696960449,
        0.2468777596950531
      ],
      "plane_d": -3030.36767578125,
      "bbox_min": [
        -1247.3983154296875,
        -3054.45947265625,
        1159.3487548828125
      ],
      "bbox_max": [
        -1239.3367919921875,
        -3049.8447265625,
        1193.1077880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.060430631041526794,
        -0.9956679344177246,
        0.07066542655229568
      ],
      "plane_d": -3147.843994140625,
      "bbox_min": [
        -943.7490844726562,
        -3048.768310546875,
        810.50927734375
      ],
      "bbox_max": [
        -887.7083740234375,
        -3038.23095703125,
        930.3491821289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7160930037498474,
        -0.12640127539634705,
        -0.6864644289016724
      ],
      "plane_d": -438.1142578125,
      "bbox_min": [
        -905.6473999023438,
        -3048.768310546875,
        810.50927734375
      ],
      "bbox_max": [
        -887.7083740234375,
        -3039.878173828125,
        866.3751220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9980483651161194,
        -0.052817005664110184,
        0.03331343084573746
      ],
      "plane_d": -1074.771728515625,
      "bbox_min": [
        -905.6473999023438,
        -3048.768310546875,
        810.50927734375
      ],
      "bbox_max": [
        -887.7083740234375,
        -3039.878173828125,
        848.25830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6638638377189636,
        0.052185166627168655,
        0.7460305094718933
      ],
      "plane_d": -1046.896484375,
      "bbox_min": [
        -905.6473999023438,
        -3048.768310546875,
        810.50927734375
      ],
      "bbox_max": [
        -887.7083740234375,
        -3039.878173828125,
        848.25830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7026313543319702,
        0.032863739877939224,
        0.7107947468757629
      ],
      "plane_d": -1111.423583984375,
      "bbox_min": [
        -893.6441650390625,
        -3045.919921875,
        820.9852905273438
      ],
      "bbox_max": [
        -887.7083740234375,
        -3039.878173828125,
        848.25830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9954870343208313,
        -0.08357247710227966,
        -0.044957485049963
      ],
      "plane_d": -1100.083740234375,
      "bbox_min": [
        -888.1669311523438,
        -3042.719970703125,
        842.2794799804688
      ],
      "bbox_max": [
        -887.7083740234375,
        -3039.878173828125,
        848.25830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1376151144504547,
        0.1973152607679367,
        0.9706331491470337
      ],
      "plane_d": -53.18804931640625,
      "bbox_min": [
        -1245.9278564453125,
        -3209.46337890625,
        810.6764526367188
      ],
      "bbox_max": [
        -887.1802978515625,
        -3039.0107421875,
        1295.0087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0647813007235527,
        0.2180229127407074,
        0.9737911820411682
      ],
      "plane_d": -61.163818359375,
      "bbox_min": [
        -972.0384521484375,
        -3161.110107421875,
        810.6764526367188
      ],
      "bbox_max": [
        -887.1802978515625,
        -3040.268310546875,
        911.9297485351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.060430631041526794,
        -0.9956679344177246,
        0.07066542655229568
      ],
      "plane_d": -3147.843994140625,
      "bbox_min": [
        -931.7190551757812,
        -3110.41650390625,
        810.6764526367188
      ],
      "bbox_max": [
        -887.1802978515625,
        -3040.268310546875,
        911.9297485351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09297493100166321,
        -0.989263117313385,
        0.11275718361139297
      ],
      "plane_d": -3025.889892578125,
      "bbox_min": [
        -908.2269287109375,
        -3045.0263671875,
        867.4175415039062
      ],
      "bbox_max": [
        -903.625732421875,
        -3044.2470703125,
        875.9605102539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29665228724479675,
        -0.8555408120155334,
        0.42431989312171936
      ],
      "plane_d": -3241.9052734375,
      "bbox_min": [
        -905.8515625,
        -3045.0263671875,
        867.4175415039062
      ],
      "bbox_max": [
        -903.625732421875,
        -3044.545166015625,
        869.7327880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9980483651161194,
        -0.052817005664110184,
        0.03331343084573746
      ],
      "plane_d": -1074.771728515625,
      "bbox_min": [
        -905.6189575195312,
        -3049.037353515625,
        810.6764526367188
      ],
      "bbox_max": [
        -887.409912109375,
        -3042.16064453125,
        848.46923828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7026313543319702,
        0.032863739877939224,
        0.7107947468757629
      ],
      "plane_d": -1111.423583984375,
      "bbox_min": [
        -893.1364135742188,
        -3049.0048828125,
        821.5848999023438
      ],
      "bbox_max": [
        -887.4212646484375,
        -3042.16064453125,
        848.46923828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9954870343208313,
        -0.08357247710227966,
        -0.044957485049963
      ],
      "plane_d": -1100.083740234375,
      "bbox_min": [
        -887.9857788085938,
        -3047.0634765625,
        843.1556396484375
      ],
      "bbox_max": [
        -887.4212646484375,
        -3042.16064453125,
        848.46923828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6638638377189636,
        0.052185166627168655,
        0.7460305094718933
      ],
      "plane_d": -1046.896484375,
      "bbox_min": [
        -920.2626953125,
        -3110.41650390625,
        810.6986083984375
      ],
      "bbox_max": [
        -887.1802978515625,
        -3044.99755859375,
        868.9155883789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.28822508454322815,
        -0.5853193998336792,
        0.7578439116477966
      ],
      "plane_d": -2682.9287109375,
      "bbox_min": [
        -905.1171875,
        -3090.585205078125,
        813.6261596679688
      ],
      "bbox_max": [
        -895.73779296875,
        -3078.880126953125,
        821.5756225585938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23609928786754608,
        0.3740059733390808,
        0.896870493888855
      ],
      "plane_d": 210.2269287109375,
      "bbox_min": [
        -905.1171875,
        -3090.585205078125,
        813.6261596679688
      ],
      "bbox_max": [
        -896.908447265625,
        -3084.55419921875,
        817.0203857421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23609928786754608,
        0.3740059733390808,
        0.896870493888855
      ],
      "plane_d": 210.2269287109375,
      "bbox_min": [
        -920.2626953125,
        -3110.41650390625,
        813.6261596679688
      ],
      "bbox_max": [
        -887.1802978515625,
        -3044.99755859375,
        868.9155883789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9980483651161194,
        -0.052817005664110184,
        0.03331343084573746
      ],
      "plane_d": -1074.771728515625,
      "bbox_min": [
        -905.8515625,
        -3064.965087890625,
        822.4606323242188
      ],
      "bbox_max": [
        -887.1802978515625,
        -3044.99755859375,
        868.9155883789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7160930037498474,
        -0.12640127539634705,
        -0.6864644289016724
      ],
      "plane_d": -438.1142578125,
      "bbox_min": [
        -905.8515625,
        -3047.7373046875,
        857.6646118164062
      ],
      "bbox_max": [
        -896.2774047851562,
        -3044.99755859375,
        868.9155883789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29665228724479675,
        -0.8555408120155334,
        0.42431989312171936
      ],
      "plane_d": -3241.9052734375,
      "bbox_min": [
        -905.8515625,
        -3047.7373046875,
        864.3125
      ],
      "bbox_max": [
        -902.391357421875,
        -3044.99755859375,
        868.9155883789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09297493100166321,
        -0.989263117313385,
        0.11275718361139297
      ],
      "plane_d": -3025.889892578125,
      "bbox_min": [
        -1203.83984375,
        -3231.95166015625,
        816.1240234375
      ],
      "bbox_max": [
        -660.0,
        -2930.939453125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35227170586586,
        -0.9041997790336609,
        0.2415105253458023
      ],
      "plane_d": -2671.578125,
      "bbox_min": [
        -1026.85400390625,
        -3045.648681640625,
        846.6757202148438
      ],
      "bbox_max": [
        -671.1574096679688,
        -2930.939453125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.060430631041526794,
        -0.9956679344177246,
        0.07066542655229568
      ],
      "plane_d": -3147.843994140625,
      "bbox_min": [
        -1026.85400390625,
        -3045.648681640625,
        846.6757202148438
      ],
      "bbox_max": [
        -887.6215209960938,
        -3006.767333984375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7160930037498474,
        -0.12640127539634705,
        -0.6864644289016724
      ],
      "plane_d": -438.1142578125,
      "bbox_min": [
        -892.3446044921875,
        -3045.648681640625,
        846.6757202148438
      ],
      "bbox_max": [
        -887.6215209960938,
        -3044.2421875,
        853.3883666992188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9954870343208313,
        -0.08357247710227966,
        -0.044957485049963
      ],
      "plane_d": -1100.083740234375,
      "bbox_min": [
        -887.820556640625,
        -3045.648681640625,
        846.6757202148438
      ],
      "bbox_max": [
        -887.6215209960938,
        -3044.2421875,
        848.5906372070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12456259876489639,
        -0.9855428338050842,
        0.11484554409980774
      ],
      "plane_d": -2984.98828125,
      "bbox_min": [
        -1026.85400390625,
        -3038.446533203125,
        983.9086303710938
      ],
      "bbox_max": [
        -983.6710205078125,
        -3006.767333984375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7832221984863281,
        -0.4408717155456543,
        0.43840065598487854
      ],
      "plane_d": -2407.586669921875,
      "bbox_min": [
        -840.498779296875,
        -3030.260986328125,
        942.820068359375
      ],
      "bbox_max": [
        -671.1574096679688,
        -2930.939453125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9639432430267334,
        0.2661080062389374
      ],
      "plane_d": -3171.8916015625,
      "bbox_min": [
        -840.498779296875,
        -3030.260986328125,
        942.820068359375
      ],
      "bbox_max": [
        -695.023193359375,
        -2930.939453125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7832221984863281,
        -0.4408717155456543,
        0.43840065598487854
      ],
      "plane_d": -2407.586669921875,
      "bbox_min": [
        -1203.83984375,
        -3231.95166015625,
        816.1240234375
      ],
      "bbox_max": [
        -660.0,
        -2973.337646484375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3876725137233734,
        -0.8030712008476257,
        0.4525335431098938
      ],
      "plane_d": -3186.01123046875,
      "bbox_min": [
        -877.2920532226562,
        -3104.3193359375,
        822.6122436523438
      ],
      "bbox_max": [
        -840.498779296875,
        -3030.260986328125,
        942.820068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.28822508454322815,
        -0.5853193998336792,
        0.7578439116477966
      ],
      "plane_d": -2682.9287109375,
      "bbox_min": [
        -877.2920532226562,
        -3104.3193359375,
        822.6122436523438
      ],
      "bbox_max": [
        -845.512451171875,
        -3077.17919921875,
        833.787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23609928786754608,
        0.3740059733390808,
        0.896870493888855
      ],
      "plane_d": 210.2269287109375,
      "bbox_min": [
        -875.58642578125,
        -3104.3193359375,
        822.6122436523438
      ],
      "bbox_max": [
        -845.512451171875,
        -3087.461181640625,
        833.787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14039453864097595,
        -0.9834563732147217,
        0.11446819454431534
      ],
      "plane_d": -2961.9658203125,
      "bbox_min": [
        -1203.83984375,
        -3231.95166015625,
        816.1240234375
      ],
      "bbox_max": [
        -840.498779296875,
        -3006.767333984375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23609928786754608,
        0.3740059733390808,
        0.896870493888855
      ],
      "plane_d": 210.2269287109375,
      "bbox_min": [
        -1023.68017578125,
        -3231.95166015625,
        816.1240234375
      ],
      "bbox_max": [
        -840.498779296875,
        -3030.260986328125,
        942.820068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0647813007235527,
        0.2180229127407074,
        0.9737911820411682
      ],
      "plane_d": -61.163818359375,
      "bbox_min": [
        -1023.68017578125,
        -3231.95166015625,
        816.1240234375
      ],
      "bbox_max": [
        -840.498779296875,
        -3030.260986328125,
        942.820068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7160930037498474,
        -0.12640127539634705,
        -0.6864644289016724
      ],
      "plane_d": -438.1142578125,
      "bbox_min": [
        -900.0586547851562,
        -3072.117919921875,
        824.2073364257812
      ],
      "bbox_max": [
        -886.54736328125,
        -3045.327392578125,
        861.776123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9954870343208313,
        -0.08357247710227966,
        -0.044957485049963
      ],
      "plane_d": -1100.083740234375,
      "bbox_min": [
        -892.2487182617188,
        -3072.117919921875,
        824.2073364257812
      ],
      "bbox_max": [
        -886.54736328125,
        -3045.440185546875,
        850.0946655273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6638638377189636,
        0.052185166627168655,
        0.7460305094718933
      ],
      "plane_d": -1046.896484375,
      "bbox_min": [
        -892.2487182617188,
        -3072.117919921875,
        824.2073364257812
      ],
      "bbox_max": [
        -886.62353515625,
        -3062.118408203125,
        829.2289428710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7026313543319702,
        0.032863739877939224,
        0.7107947468757629
      ],
      "plane_d": -1111.423583984375,
      "bbox_min": [
        -888.5581665039062,
        -3072.02099609375,
        826.9911499023438
      ],
      "bbox_max": [
        -886.62353515625,
        -3062.118408203125,
        829.2289428710938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29665228724479675,
        -0.8555408120155334,
        0.42431989312171936
      ],
      "plane_d": -3241.9052734375,
      "bbox_min": [
        -1023.68017578125,
        -3231.95166015625,
        816.1240234375
      ],
      "bbox_max": [
        -840.498779296875,
        -3030.260986328125,
        942.820068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7160930037498474,
        -0.12640127539634705,
        -0.6864644289016724
      ],
      "plane_d": -438.1142578125,
      "bbox_min": [
        -902.391357421875,
        -3060.28271484375,
        850.0946655273438
      ],
      "bbox_max": [
        -886.54736328125,
        -3047.177734375,
        864.3125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1376151144504547,
        0.1973152607679367,
        0.9706331491470337
      ],
      "plane_d": -53.18804931640625,
      "bbox_min": [
        -1023.68017578125,
        -3231.95166015625,
        816.1240234375
      ],
      "bbox_max": [
        -873.3448486328125,
        -3060.28271484375,
        852.3694458007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9980483651161194,
        -0.052817005664110184,
        0.03331343084573746
      ],
      "plane_d": -1074.771728515625,
      "bbox_min": [
        -893.2199096679688,
        -3074.000244140625,
        823.4747924804688
      ],
      "bbox_max": [
        -886.54736328125,
        -3060.28271484375,
        850.0946655273438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6638638377189636,
        0.052185166627168655,
        0.7460305094718933
      ],
      "plane_d": -1046.896484375,
      "bbox_min": [
        -893.2199096679688,
        -3074.000244140625,
        823.4747924804688
      ],
      "bbox_max": [
        -886.54931640625,
        -3072.003662109375,
        829.36328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7026313543319702,
        0.032863739877939224,
        0.7107947468757629
      ],
      "plane_d": -1111.423583984375,
      "bbox_min": [
        -886.8619995117188,
        -3073.32177734375,
        828.9940185546875
      ],
      "bbox_max": [
        -886.54931640625,
        -3072.003662109375,
        829.36328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.28822508454322815,
        -0.5853193998336792,
        0.7578439116477966
      ],
      "plane_d": -2682.9287109375,
      "bbox_min": [
        -896.908447265625,
        -3087.461181640625,
        816.1240234375
      ],
      "bbox_max": [
        -875.58642578125,
        -3073.32177734375,
        829.90478515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6638638377189636,
        0.052185166627168655,
        0.7460305094718933
      ],
      "plane_d": -1046.896484375,
      "bbox_min": [
        -895.73779296875,
        -3078.880126953125,
        821.5756225585938
      ],
      "bbox_max": [
        -886.54931640625,
        -3073.32177734375,
        829.36328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7080089449882507,
        0.7036092877388,
        0.06047677621245384
      ],
      "plane_d": 3305.96240234375,
      "bbox_min": [
        -1246.8746337890625,
        -3650.0,
        267.0
      ],
      "bbox_max": [
        -949.8262939453125,
        -3484.438720703125,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9202737212181091,
        0.3693651854991913,
        0.12909552454948425
      ],
      "plane_d": 2369.723876953125,
      "bbox_min": [
        -1246.8746337890625,
        -3636.550048828125,
        267.0
      ],
      "bbox_max": [
        -1111.803466796875,
        -3508.74365234375,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7217350602149963,
        0.6888043284416199,
        0.06816939264535904
      ],
      "plane_d": 3283.454345703125,
      "bbox_min": [
        -1240.95556640625,
        -3523.1552734375,
        567.5443725585938
      ],
      "bbox_max": [
        -1240.6463623046875,
        -3522.888916015625,
        569.8958740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7327849268913269,
        0.6294608116149902,
        0.25846728682518005
      ],
      "plane_d": 2979.97509765625,
      "bbox_min": [
        -1240.85107421875,
        -3523.1552734375,
        567.5443725585938
      ],
      "bbox_max": [
        -1240.6463623046875,
        -3522.888916015625,
        568.309814453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7646611928939819,
        0.6164575219154358,
        0.18781177699565887
      ],
      "plane_d": 3013.850341796875,
      "bbox_min": [
        -1240.85107421875,
        -3523.1552734375,
        568.0107421875
      ],
      "bbox_max": [
        -1240.6463623046875,
        -3522.9375,
        568.309814453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6330804824829102,
        0.7714124321937561,
        0.06428063660860062
      ],
      "plane_d": 3466.7158203125,
      "bbox_min": [
        -1246.8746337890625,
        -3636.550048828125,
        568.1181640625
      ],
      "bbox_max": [
        -1111.803466796875,
        -3523.00732421875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7217350602149963,
        0.6888043284416199,
        0.06816939264535904
      ],
      "plane_d": 3283.454345703125,
      "bbox_min": [
        -1245.0706787109375,
        -3524.878662109375,
        568.1181640625
      ],
      "bbox_max": [
        -1240.6463623046875,
        -3523.00732421875,
        632.373291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6450628638267517,
        -0.7628151178359985,
        0.04480097442865372
      ],
      "plane_d": -3426.438232421875,
      "bbox_min": [
        -1206.89111328125,
        -3650.0,
        267.0
      ],
      "bbox_max": [
        -949.8262939453125,
        -3484.438720703125,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9528772234916687,
        -0.2737281024456024,
        0.130758598446846
      ],
      "plane_d": -2123.362548828125,
      "bbox_min": [
        -1137.28759765625,
        -3493.292236328125,
        656.460205078125
      ],
      "bbox_max": [
        -1134.301025390625,
        -3484.438720703125,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6477525234222412,
        -0.7609485387802124,
        0.03706754744052887
      ],
      "plane_d": -3420.204345703125,
      "bbox_min": [
        -1155.2579345703125,
        -3508.486328125,
        267.0
      ],
      "bbox_max": [
        -1140.9757080078125,
        -3487.271240234375,
        369.31988525390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8701116442680359,
        -0.4906183183193207,
        0.04689646139740944
      ],
      "plane_d": -2729.62939453125,
      "bbox_min": [
        -1155.2579345703125,
        -3506.523681640625,
        267.0
      ],
      "bbox_max": [
        -1140.9757080078125,
        -3487.271240234375,
        369.31988525390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8973290324211121,
        -0.4287506937980652,
        0.1047549843788147
      ],
      "plane_d": -2564.411865234375,
      "bbox_min": [
        -1152.176513671875,
        -3506.034912109375,
        332.6519775390625
      ],
      "bbox_max": [
        -1140.9757080078125,
        -3487.271240234375,
        369.31988525390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6611984968185425,
        -0.7488041520118713,
        0.045921631157398224
      ],
      "plane_d": -3391.467041015625,
      "bbox_min": [
        -1206.89111328125,
        -3650.0,
        267.0
      ],
      "bbox_max": [
        -949.8262939453125,
        -3493.7353515625,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6585033535957336,
        -0.7513062953948975,
        0.04372837394475937
      ],
      "plane_d": -3397.36328125,
      "bbox_min": [
        -980.744873046875,
        -3650.0,
        267.0
      ],
      "bbox_max": [
        -976.505615234375,
        -3646.800048828125,
        275.8599548339844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9202737212181091,
        0.3693651854991913,
        0.12909552454948425
      ],
      "plane_d": 2369.723876953125,
      "bbox_min": [
        -1206.89111328125,
        -3510.526611328125,
        267.0
      ],
      "bbox_max": [
        -1203.474365234375,
        -3507.775390625,
        286.2550048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9792153239250183,
        -0.19332727789878845,
        0.061334479600191116
      ],
      "plane_d": -1825.3980712890625,
      "bbox_min": [
        -1136.84423828125,
        -3650.0,
        660.0
      ],
      "bbox_max": [
        -893.34814453125,
        -3470.2734375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6438754796981812,
        -0.7624677419662476,
        0.06377595663070679
      ],
      "plane_d": -3441.28662109375,
      "bbox_min": [
        -897.137451171875,
        -3650.0,
        1288.1129150390625
      ],
      "bbox_max": [
        -893.34814453125,
        -3646.800048828125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9528772234916687,
        -0.2737281024456024,
        0.130758598446846
      ],
      "plane_d": -2123.362548828125,
      "bbox_min": [
        -1136.84423828125,
        -3486.419677734375,
        660.0
      ],
      "bbox_max": [
        -1132.9666748046875,
        -3483.275146484375,
        687.8972778320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6443679928779602,
        -0.762627899646759,
        0.0564676970243454
      ],
      "plane_d": -3432.79296875,
      "bbox_min": [
        -1276.5831298828125,
        -3646.800048828125,
        660.0
      ],
      "bbox_max": [
        -897.137451171875,
        -3475.992919921875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9792153239250183,
        -0.19332727789878845,
        0.061334479600191116
      ],
      "plane_d": -1825.3980712890625,
      "bbox_min": [
        -1136.681396484375,
        -3646.800048828125,
        660.0
      ],
      "bbox_max": [
        -897.137451171875,
        -3475.992919921875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6707790493965149,
        -0.7331188917160034,
        0.11221480369567871
      ],
      "plane_d": -3421.490234375,
      "bbox_min": [
        -1109.4647216796875,
        -3646.800048828125,
        1090.7999267578125
      ],
      "bbox_max": [
        -897.137451171875,
        -3475.992919921875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9945406317710876,
        -0.05085870251059532,
        0.09111718833446503
      ],
      "plane_d": -1379.3016357421875,
      "bbox_min": [
        -1109.4647216796875,
        -3483.7431640625,
        1090.7999267578125
      ],
      "bbox_max": [
        -1097.50732421875,
        -3475.992919921875,
        1217.9898681640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9931049346923828,
        0.0022958379704505205,
        0.11720679700374603
      ],
      "plane_d": -1221.6827392578125,
      "bbox_min": [
        -1109.4647216796875,
        -3483.7431640625,
        1090.7999267578125
      ],
      "bbox_max": [
        -1106.3704833984375,
        -3476.015625,
        1117.1605224609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6268800497055054,
        -0.7762154936790466,
        0.06716372817754745
      ],
      "plane_d": -3472.729736328125,
      "bbox_min": [
        -1276.5831298828125,
        -3646.800048828125,
        660.0
      ],
      "bbox_max": [
        -953.4501953125,
        -3483.7431640625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9792153239250183,
        -0.19332727789878845,
        0.061334479600191116
      ],
      "plane_d": -1825.3980712890625,
      "bbox_min": [
        -1134.008544921875,
        -3646.800048828125,
        660.0
      ],
      "bbox_max": [
        -953.4501953125,
        -3483.7431640625,
        1117.1605224609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6285895705223083,
        -0.7772358059883118,
        0.02792278490960598
      ],
      "plane_d": -3452.181396484375,
      "bbox_min": [
        -1131.270263671875,
        -3646.800048828125,
        660.0
      ],
      "bbox_max": [
        -953.4501953125,
        -3502.662109375,
        663.99609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9201366305351257,
        -0.3901376724243164,
        0.03378250449895859
      ],
      "plane_d": -2429.739990234375,
      "bbox_min": [
        -1131.270263671875,
        -3503.157958984375,
        660.0
      ],
      "bbox_max": [
        -1130.929443359375,
        -3502.662109375,
        663.99609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9528772234916687,
        -0.2737281024456024,
        0.130758598446846
      ],
      "plane_d": -2123.362548828125,
      "bbox_min": [
        -1134.008544921875,
        -3503.1201171875,
        660.0
      ],
      "bbox_max": [
        -1130.929443359375,
        -3494.23974609375,
        673.7976684570312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9524388313293457,
        -0.2936769425868988,
        0.08132689446210861
      ],
      "plane_d": -2159.927490234375,
      "bbox_min": [
        -1134.008544921875,
        -3503.1201171875,
        660.0
      ],
      "bbox_max": [
        -1130.929443359375,
        -3494.23974609375,
        663.99609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9201366305351257,
        -0.3901376724243164,
        0.03378250449895859
      ],
      "plane_d": -2429.739990234375,
      "bbox_min": [
        -1131.7891845703125,
        -3503.1201171875,
        660.0
      ],
      "bbox_max": [
        -1130.929443359375,
        -3501.4384765625,
        663.99609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6207442283630371,
        0.782613217830658,
        0.046831756830215454
      ],
      "plane_d": 3505.248779296875,
      "bbox_min": [
        -1276.5831298828125,
        -3646.800048828125,
        660.0
      ],
      "bbox_max": [
        -1111.803466796875,
        -3525.7001953125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6149458289146423,
        0.787019670009613,
        0.04941307380795479
      ],
      "plane_d": 3512.108154296875,
      "bbox_min": [
        -1269.7213134765625,
        -3646.800048828125,
        833.2398681640625
      ],
      "bbox_max": [
        -1127.2415771484375,
        -3530.838623046875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6398068070411682,
        0.7678380608558655,
        0.03273991122841835
      ],
      "plane_d": 3492.43212890625,
      "bbox_min": [
        -1269.7213134765625,
        -3646.800048828125,
        833.2398681640625
      ],
      "bbox_max": [
        -1127.2415771484375,
        -3530.838623046875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6140355467796326,
        0.7874341607093811,
        0.05392313003540039
      ],
      "plane_d": 3507.92138671875,
      "bbox_min": [
        -1267.1397705078125,
        -3646.800048828125,
        833.2398681640625
      ],
      "bbox_max": [
        -1127.2415771484375,
        -3530.838623046875,
        1035.9180908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6398068070411682,
        0.7678380608558655,
        0.03273991122841835
      ],
      "plane_d": 3492.43212890625,
      "bbox_min": [
        -1276.5831298828125,
        -3636.550048828125,
        660.0
      ],
      "bbox_max": [
        -1111.803466796875,
        -3525.7001953125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6330804824829102,
        0.7714124321937561,
        0.06428063660860062
      ],
      "plane_d": 3466.7158203125,
      "bbox_min": [
        -1258.0595703125,
        -3636.550048828125,
        660.0
      ],
      "bbox_max": [
        -1111.803466796875,
        -3525.7001953125,
        831.288330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2074883133172989,
        0.8826481699943542,
        0.42175933718681335
      ],
      "plane_d": 2287.469970703125,
      "bbox_min": [
        -1105.0,
        -3320.0,
        852.3694458007812
      ],
      "bbox_max": [
        -865.1904296875,
        -3152.747802734375,
        1098.7425537109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6382936835289001,
        0.7293487191200256,
        0.2462347000837326
      ],
      "plane_d": 1514.509521484375,
      "bbox_min": [
        -1105.0,
        -3320.0,
        852.3694458007812
      ],
      "bbox_max": [
        -991.43603515625,
        -3231.95166015625,
        1018.707763671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17790910601615906,
        -0.0,
        0.984046995639801
      ],
      "plane_d": -662.3861083984375,
      "bbox_min": [
        -1105.0,
        -3320.0,
        852.3694458007812
      ],
      "bbox_max": [
        -991.43603515625,
        -3231.95166015625,
        889.4143676757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09315899014472961,
        0.1335732340812683,
        0.9866505861282349
      ],
      "plane_d": -316.9273681640625,
      "bbox_min": [
        -1105.0,
        -3304.406494140625,
        852.3694458007812
      ],
      "bbox_max": [
        -991.43603515625,
        -3231.95166015625,
        872.9010620117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6744422316551208,
        -0.542770504951477,
        0.5005276203155518
      ],
      "plane_d": -1478.223388671875,
      "bbox_min": [
        -1105.0,
        -3293.0009765625,
        862.6844482421875
      ],
      "bbox_max": [
        -1067.857177734375,
        -3254.84521484375,
        872.9010620117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6744422316551208,
        -0.542770504951477,
        0.5005276203155518
      ],
      "plane_d": -1478.223388671875,
      "bbox_min": [
        -1105.0,
        -3291.5771484375,
        867.3606567382812
      ],
      "bbox_max": [
        -1074.35498046875,
        -3258.607177734375,
        889.4143676757812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.09315899014472961,
        0.1335732340812683,
        0.9866505861282349
      ],
      "plane_d": -316.9273681640625,
      "bbox_min": [
        -1067.857177734375,
        -3254.84521484375,
        852.3694458007812
      ],
      "bbox_max": [
        -991.43603515625,
        -3209.46337890625,
        862.6844482421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6382936835289001,
        0.7293487191200256,
        0.2462347000837326
      ],
      "plane_d": 1514.509521484375,
      "bbox_min": [
        -1105.0,
        -3475.00244140625,
        869.3729248046875
      ],
      "bbox_max": [
        -1027.87646484375,
        -3320.0,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9945406317710876,
        -0.05085870251059532,
        0.09111718833446503
      ],
      "plane_d": -1379.3016357421875,
      "bbox_min": [
        -1105.0,
        -3475.00244140625,
        1136.998046875
      ],
      "bbox_max": [
        -1090.06982421875,
        -3434.97412109375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17790910601615906,
        -0.0,
        0.984046995639801
      ],
      "plane_d": -662.3861083984375,
      "bbox_min": [
        -1105.0,
        -3338.26953125,
        869.3729248046875
      ],
      "bbox_max": [
        -1085.4853515625,
        -3320.0,
        872.9010620117188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -724.0,
      "bbox_min": [
        -1465.0,
        -3531.997802734375,
        267.0
      ],
      "bbox_max": [
        -1105.0,
        -3083.3251953125,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.796037495136261,
        -0.5924747586250305,
        0.12368514388799667
      ],
      "plane_d": -2981.951171875,
      "bbox_min": [
        -1400.39306640625,
        -3320.0,
        465.73052978515625
      ],
      "bbox_max": [
        -1163.061767578125,
        -3091.609375,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8137342929840088,
        -0.5748793482780457,
        0.08573256433010101
      ],
      "plane_d": -2924.1494140625,
      "bbox_min": [
        -1352.24169921875,
        -3317.8837890625,
        533.1759643554688
      ],
      "bbox_max": [
        -1192.5257568359375,
        -3092.033935546875,
        711.556884765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7564704418182373,
        -0.5494663715362549,
        0.3547379672527313
      ],
      "plane_d": -2917.031494140625,
      "bbox_min": [
        -1352.24169921875,
        -3317.8837890625,
        533.1759643554688
      ],
      "bbox_max": [
        -1192.5257568359375,
        -3096.834228515625,
        592.5193481445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11611118167638779,
        -0.3397166132926941,
        0.933333158493042
      ],
      "plane_d": -1724.796630859375,
      "bbox_min": [
        -1352.24169921875,
        -3140.56103515625,
        540.0997314453125
      ],
      "bbox_max": [
        -1324.6180419921875,
        -3096.834228515625,
        592.5193481445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44718649983406067,
        -0.8943867683410645,
        0.009831518866121769
      ],
      "plane_d": -2174.02978515625,
      "bbox_min": [
        -1352.24169921875,
        -3116.5771484375,
        546.7369384765625
      ],
      "bbox_max": [
        -1341.437744140625,
        -3096.834228515625,
        592.5193481445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.137528657913208,
        -0.27506157755851746,
        0.9515392780303955
      ],
      "plane_d": -1193.0062255859375,
      "bbox_min": [
        -1352.24169921875,
        -3116.5771484375,
        546.7369384765625
      ],
      "bbox_max": [
        -1341.437744140625,
        -3097.97119140625,
        552.8644409179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7995961308479309,
        -0.5955905318260193,
        0.0769285261631012
      ],
      "plane_d": -2963.00537109375,
      "bbox_min": [
        -1400.39306640625,
        -3320.0,
        465.73052978515625
      ],
      "bbox_max": [
        -1163.061767578125,
        -3091.609375,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.573469877243042,
        -0.17084632813930511,
        0.8012139201164246
      ],
      "plane_d": -214.29714965820312,
      "bbox_min": [
        -1384.3837890625,
        -3320.0,
        465.73052978515625
      ],
      "bbox_max": [
        -1276.442626953125,
        -3115.6298828125,
        593.9807739257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04223942756652832,
        -0.9113441109657288,
        0.4094725549221039
      ],
      "plane_d": -3270.52197265625,
      "bbox_min": [
        -1286.90576171875,
        -3320.0,
        465.73052978515625
      ],
      "bbox_max": [
        -1276.442626953125,
        -3312.349365234375,
        482.2633972167969
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9405732750892639,
        -0.10687936842441559,
        0.3223331570625305
      ],
      "plane_d": 700.9578857421875,
      "bbox_min": [
        -1286.90576171875,
        -3320.0,
        465.73052978515625
      ],
      "bbox_max": [
        -1282.109375,
        -3312.349365234375,
        482.2633972167969
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9710849523544312,
        0.01423729583621025,
        0.2383090704679489
      ],
      "plane_d": 1181.926025390625,
      "bbox_min": [
        -1286.90576171875,
        -3320.0,
        472.17510986328125
      ],
      "bbox_max": [
        -1284.31787109375,
        -3312.349365234375,
        482.2633972167969
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9655990600585938,
        0.23379258811473846,
        0.11383970826864243
      ],
      "plane_d": 1997.5523681640625,
      "bbox_min": [
        -1384.3837890625,
        -3320.0,
        480.18701171875
      ],
      "bbox_max": [
        -1286.2840576171875,
        -3115.6298828125,
        593.9807739257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5087251663208008,
        0.25412195920944214,
        0.8225695490837097
      ],
      "plane_d": 1099.726806640625,
      "bbox_min": [
        -1324.896728515625,
        -3320.0,
        480.18701171875
      ],
      "bbox_max": [
        -1286.2840576171875,
        -3312.349365234375,
        508.04010009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9710849523544312,
        0.01423729583621025,
        0.2383090704679489
      ],
      "plane_d": 1181.926025390625,
      "bbox_min": [
        -1287.4573974609375,
        -3320.0,
        480.18701171875
      ],
      "bbox_max": [
        -1286.2840576171875,
        -3312.349365234375,
        484.96807861328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.137528657913208,
        -0.27506157755851746,
        0.9515392780303955
      ],
      "plane_d": -1193.0062255859375,
      "bbox_min": [
        -1400.39306640625,
        -3320.0,
        466.3150939941406
      ],
      "bbox_max": [
        -1163.061767578125,
        -3098.218994140625,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04223942756652832,
        -0.9113441109657288,
        0.4094725549221039
      ],
      "plane_d": -3270.52197265625,
      "bbox_min": [
        -1286.90576171875,
        -3320.0,
        466.3150939941406
      ],
      "bbox_max": [
        -1232.641845703125,
        -3312.349365234375,
        482.2633972167969
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8235416412353516,
        -0.5580507516860962,
        0.10177668184041977
      ],
      "plane_d": -2915.920166015625,
      "bbox_min": [
        -1234.159423828125,
        -3320.0,
        466.6517028808594
      ],
      "bbox_max": [
        -1232.81396484375,
        -3317.593505859375,
        473.12396240234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8235416412353516,
        -0.5580507516860962,
        0.10177668184041977
      ],
      "plane_d": -2915.920166015625,
      "bbox_min": [
        -1233.1290283203125,
        -3320.0,
        470.81585693359375
      ],
      "bbox_max": [
        -1232.641845703125,
        -3319.2275390625,
        472.5026550292969
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -700.5,
      "bbox_min": [
        -1359.5350341796875,
        -3320.0,
        700.5
      ],
      "bbox_max": [
        -1345.2430419921875,
        -3290.0556640625,
        700.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11611118167638779,
        -0.3397166132926941,
        0.933333158493042
      ],
      "plane_d": -1724.796630859375,
      "bbox_min": [
        -1398.0760498046875,
        -3320.0,
        472.2089538574219
      ],
      "bbox_max": [
        -1163.061767578125,
        -3098.218994140625,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04223942756652832,
        -0.9113441109657288,
        0.4094725549221039
      ],
      "plane_d": -3270.52197265625,
      "bbox_min": [
        -1286.90576171875,
        -3320.0,
        472.2089538574219
      ],
      "bbox_max": [
        -1226.1395263671875,
        -3311.770263671875,
        488.7859802246094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6944899559020996,
        -0.6407128572463989,
        0.3273695409297943
      ],
      "plane_d": -1423.39990234375,
      "bbox_min": [
        -1236.1697998046875,
        -3318.94921875,
        472.8974304199219
      ],
      "bbox_max": [
        -1234.159423828125,
        -3311.770263671875,
        488.7859802246094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8235416412353516,
        -0.5580507516860962,
        0.10177668184041977
      ],
      "plane_d": -2915.920166015625,
      "bbox_min": [
        -1236.1697998046875,
        -3320.0,
        472.2089538574219
      ],
      "bbox_max": [
        -1226.1395263671875,
        -3311.770263671875,
        488.7859802246094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4483394920825958,
        -0.6716778874397278,
        0.5897800326347351
      ],
      "plane_d": -3066.94287109375,
      "bbox_min": [
        -1236.1697998046875,
        -3320.0,
        483.1204528808594
      ],
      "bbox_max": [
        -1226.1395263671875,
        -3311.770263671875,
        488.7859802246094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.49946901202201843,
        -0.47514525055885315,
        0.7244084477424622
      ],
      "plane_d": -2545.081298828125,
      "bbox_min": [
        -1398.0760498046875,
        -3320.0,
        487.038330078125
      ],
      "bbox_max": [
        -1163.061767578125,
        -3098.218994140625,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4483394920825958,
        -0.6716778874397278,
        0.5897800326347351
      ],
      "plane_d": -3066.94287109375,
      "bbox_min": [
        -1236.1697998046875,
        -3320.0,
        487.038330078125
      ],
      "bbox_max": [
        -1210.31494140625,
        -3311.770263671875,
        503.0541687011719
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9192844033241272,
        -0.38526779413223267,
        0.08052864670753479
      ],
      "plane_d": -2432.07470703125,
      "bbox_min": [
        -1212.1279296875,
        -3320.0,
        498.9146728515625
      ],
      "bbox_max": [
        -1210.31494140625,
        -3315.28955078125,
        503.0541687011719
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7564704418182373,
        -0.5494663715362549,
        0.3547379672527313
      ],
      "plane_d": -2917.031494140625,
      "bbox_min": [
        -1398.0760498046875,
        -3320.0,
        501.2149658203125
      ],
      "bbox_max": [
        -1163.061767578125,
        -3098.218994140625,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4523264467716217,
        -0.8918522596359253,
        0.0003948037629015744
      ],
      "plane_d": -2152.6083984375,
      "bbox_min": [
        -1398.0760498046875,
        -3320.0,
        501.2149658203125
      ],
      "bbox_max": [
        -1163.061767578125,
        -3098.218994140625,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4278530180454254,
        -0.903739333152771,
        0.014034316875040531
      ],
      "plane_d": -2231.740478515625,
      "bbox_min": [
        -1388.2457275390625,
        -3320.0,
        501.2149658203125
      ],
      "bbox_max": [
        -1163.061767578125,
        -3098.218994140625,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44718649983406067,
        -0.8943867683410645,
        0.009831518866121769
      ],
      "plane_d": -2174.02978515625,
      "bbox_min": [
        -1362.39306640625,
        -3105.857421875,
        552.8644409179688
      ],
      "bbox_max": [
        -1347.9879150390625,
        -3098.218994140625,
        613.0665893554688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8672640323638916,
        0.18403863906860352,
        0.46258267760276794
      ],
      "plane_d": -673.7977294921875,
      "bbox_min": [
        -1353.3177490234375,
        -3320.0,
        501.2149658203125
      ],
      "bbox_max": [
        -1163.061767578125,
        -3287.259765625,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9192844033241272,
        -0.38526779413223267,
        0.08052864670753479
      ],
      "plane_d": -2432.07470703125,
      "bbox_min": [
        -1212.1279296875,
        -3320.0,
        501.2149658203125
      ],
      "bbox_max": [
        -1209.5694580078125,
        -3315.28955078125,
        509.7249450683594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8007402420043945,
        -0.5945212841033936,
        0.073208749294281
      ],
      "plane_d": -2958.124267578125,
      "bbox_min": [
        -1175.145263671875,
        -3320.0,
        715.8345947265625
      ],
      "bbox_max": [
        -1163.061767578125,
        -3303.725341796875,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9710849523544312,
        0.01423729583621025,
        0.2383090704679489
      ],
      "plane_d": 1181.926025390625,
      "bbox_min": [
        -1356.4564208984375,
        -3523.00732421875,
        342.435546875
      ],
      "bbox_max": [
        -1240.795654296875,
        -3320.0,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -700.5,
      "bbox_min": [
        -1356.4564208984375,
        -3405.079345703125,
        606.6046752929688
      ],
      "bbox_max": [
        -1336.3896484375,
        -3320.0,
        700.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9655990600585938,
        0.23379258811473846,
        0.11383970826864243
      ],
      "plane_d": 1997.5523681640625,
      "bbox_min": [
        -1337.023193359375,
        -3321.37109375,
        606.6046752929688
      ],
      "bbox_max": [
        -1336.3896484375,
        -3320.0,
        611.8834228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9616638422012329,
        0.25931838154792786,
        0.08920101076364517
      ],
      "plane_d": 2092.123291015625,
      "bbox_min": [
        -1337.023193359375,
        -3321.37109375,
        610.715576171875
      ],
      "bbox_max": [
        -1336.5555419921875,
        -3320.0,
        611.8834228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9320849776268005,
        0.2389715313911438,
        0.2722319960594177
      ],
      "plane_d": 1873.2095947265625,
      "bbox_min": [
        -1336.9337158203125,
        -3321.37109375,
        610.715576171875
      ],
      "bbox_max": [
        -1336.5555419921875,
        -3320.0,
        610.9191284179688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9927957653999329,
        0.11212077736854553,
        0.042255036532878876
      ],
      "plane_d": 1673.5107421875,
      "bbox_min": [
        -1345.1156005859375,
        -3380.387939453125,
        538.2327880859375
      ],
      "bbox_max": [
        -1328.328857421875,
        -3320.0,
        700.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9655990600585938,
        0.23379258811473846,
        0.11383970826864243
      ],
      "plane_d": 1997.5523681640625,
      "bbox_min": [
        -1340.43701171875,
        -3321.79931640625,
        538.2327880859375
      ],
      "bbox_max": [
        -1328.328857421875,
        -3320.0,
        700.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -700.5,
      "bbox_min": [
        -1340.43701171875,
        -3321.79931640625,
        700.5
      ],
      "bbox_max": [
        -1340.32373046875,
        -3320.796142578125,
        700.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9824994802474976,
        0.16235168278217316,
        0.09130601584911346
      ],
      "plane_d": 1796.623046875,
      "bbox_min": [
        -1325.9498291015625,
        -3452.548583984375,
        640.7750854492188
      ],
      "bbox_max": [
        -1318.2420654296875,
        -3449.04052734375,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7646611928939819,
        0.6164575219154358,
        0.18781177699565887
      ],
      "plane_d": 3013.850341796875,
      "bbox_min": [
        -1340.5382080078125,
        -3522.959716796875,
        528.0936279296875
      ],
      "bbox_max": [
        -1240.795654296875,
        -3321.051025390625,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -700.5,
      "bbox_min": [
        -1340.32373046875,
        -3404.196533203125,
        700.5
      ],
      "bbox_max": [
        -1331.1131591796875,
        -3321.79931640625,
        700.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9824994802474976,
        0.16235168278217316,
        0.09130601584911346
      ],
      "plane_d": 1796.623046875,
      "bbox_min": [
        -1340.334716796875,
        -3449.201171875,
        633.7772216796875
      ],
      "bbox_max": [
        -1314.6949462890625,
        -3321.051025390625,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -700.5,
      "bbox_min": [
        -1340.334716796875,
        -3403.35546875,
        700.5
      ],
      "bbox_max": [
        -1314.6949462890625,
        -3321.051025390625,
        700.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9201366305351257,
        -0.3901376724243164,
        0.03378250449895859
      ],
      "plane_d": -2429.739990234375,
      "bbox_min": [
        -1341.3077392578125,
        -3527.603515625,
        267.0
      ],
      "bbox_max": [
        -1131.2100830078125,
        -3320.0,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9524388313293457,
        -0.2936769425868988,
        0.08132689446210861
      ],
      "plane_d": -2159.927490234375,
      "bbox_min": [
        -1214.751220703125,
        -3485.4150390625,
        426.0061340332031
      ],
      "bbox_max": [
        -1131.2100830078125,
        -3320.0,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9753258228302002,
        -0.14798365533351898,
        0.1638302057981491
      ],
      "plane_d": -1742.69921875,
      "bbox_min": [
        -1198.849853515625,
        -3484.58642578125,
        529.822265625
      ],
      "bbox_max": [
        -1131.2100830078125,
        -3320.0,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9528772234916687,
        -0.2737281024456024,
        0.130758598446846
      ],
      "plane_d": -2123.362548828125,
      "bbox_min": [
        -1166.6292724609375,
        -3484.58642578125,
        621.68359375
      ],
      "bbox_max": [
        -1131.2100830078125,
        -3399.0576171875,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9792153239250183,
        -0.19332727789878845,
        0.061334479600191116
      ],
      "plane_d": -1825.3980712890625,
      "bbox_min": [
        -1137.0072021484375,
        -3483.275146484375,
        687.8972778320312
      ],
      "bbox_max": [
        -1131.2100830078125,
        -3453.29931640625,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9528772234916687,
        -0.2737281024456024,
        0.130758598446846
      ],
      "plane_d": -2123.362548828125,
      "bbox_min": [
        -1166.6292724609375,
        -3422.269775390625,
        621.68359375
      ],
      "bbox_max": [
        -1145.9208984375,
        -3396.30615234375,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8672640323638916,
        0.18403863906860352,
        0.46258267760276794
      ],
      "plane_d": -673.7977294921875,
      "bbox_min": [
        -1198.849853515625,
        -3399.0576171875,
        529.822265625
      ],
      "bbox_max": [
        -1160.6263427734375,
        -3320.0,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.796037495136261,
        -0.5924747586250305,
        0.12368514388799667
      ],
      "plane_d": -2981.951171875,
      "bbox_min": [
        -1175.486083984375,
        -3329.75439453125,
        640.3673095703125
      ],
      "bbox_max": [
        -1160.6263427734375,
        -3320.0,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9845805764198303,
        -0.14805786311626434,
        0.09316641837358475
      ],
      "plane_d": -1703.1788330078125,
      "bbox_min": [
        -1163.886474609375,
        -3329.75439453125,
        715.0223388671875
      ],
      "bbox_max": [
        -1160.6263427734375,
        -3320.0,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8007402420043945,
        -0.5945212841033936,
        0.073208749294281
      ],
      "plane_d": -2958.124267578125,
      "bbox_min": [
        -1163.886474609375,
        -3321.635986328125,
        715.0223388671875
      ],
      "bbox_max": [
        -1161.8470458984375,
        -3320.0,
        724.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8672640323638916,
        0.18403863906860352,
        0.46258267760276794
      ],
      "plane_d": -673.7977294921875,
      "bbox_min": [
        -1209.5694580078125,
        -3399.0576171875,
        509.7249450683594
      ],
      "bbox_max": [
        -1166.6292724609375,
        -3320.0,
        621.68359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4483394920825958,
        -0.6716778874397278,
        0.5897800326347351
      ],
      "plane_d": -3066.94287109375,
      "bbox_min": [
        -1214.751220703125,
        -3402.96435546875,
        426.0061340332031
      ],
      "bbox_max": [
        -1182.1331787109375,
        -3320.0,
        498.9146728515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04223942756652832,
        -0.9113441109657288,
        0.4094725549221039
      ],
      "plane_d": -3270.52197265625,
      "bbox_min": [
        -1341.3077392578125,
        -3527.603515625,
        267.0
      ],
      "bbox_max": [
        -1148.46826171875,
        -3320.0,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6944899559020996,
        -0.6407128572463989,
        0.3273695409297943
      ],
      "plane_d": -1423.39990234375,
      "bbox_min": [
        -1235.176513671875,
        -3413.293212890625,
        267.0
      ],
      "bbox_max": [
        -1195.760498046875,
        -3320.0,
        470.8164367675781
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9405732750892639,
        -0.10687936842441559,
        0.3223331570625305
      ],
      "plane_d": 700.9578857421875,
      "bbox_min": [
        -1341.3077392578125,
        -3527.603515625,
        267.0
      ],
      "bbox_max": [
        -1148.46826171875,
        -3320.0,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5087251663208008,
        0.25412195920944214,
        0.8225695490837097
      ],
      "plane_d": 1099.726806640625,
      "bbox_min": [
        -1312.7127685546875,
        -3355.306884765625,
        485.9448547363281
      ],
      "bbox_max": [
        -1289.0367431640625,
        -3320.0,
        502.9345703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4483394920825958,
        -0.6716778874397278,
        0.5897800326347351
      ],
      "plane_d": -3066.94287109375,
      "bbox_min": [
        -1231.2933349609375,
        -3402.96435546875,
        426.0061340332031
      ],
      "bbox_max": [
        -1182.1331787109375,
        -3320.0,
        495.69549560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9710849523544312,
        0.01423729583621025,
        0.2383090704679489
      ],
      "plane_d": 1181.926025390625,
      "bbox_min": [
        -1341.3077392578125,
        -3527.603515625,
        267.0
      ],
      "bbox_max": [
        -1148.46826171875,
        -3320.0,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8973290324211121,
        -0.4287506937980652,
        0.1047549843788147
      ],
      "plane_d": -2564.411865234375,
      "bbox_min": [
        -1341.3077392578125,
        -3527.603515625,
        267.0
      ],
      "bbox_max": [
        -1148.46826171875,
        -3320.0,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6330804824829102,
        0.7714124321937561,
        0.06428063660860062
      ],
      "plane_d": 3466.7158203125,
      "bbox_min": [
        -1341.3077392578125,
        -3527.603515625,
        632.373291015625
      ],
      "bbox_max": [
        -1245.0706787109375,
        -3320.0,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7746099233627319,
        -0.5822634696960449,
        0.2468777596950531
      ],
      "plane_d": -3030.36767578125,
      "bbox_min": [
        -1465.0,
        -3531.997802734375,
        724.0
      ],
      "bbox_max": [
        -1105.0,
        -3083.3251953125,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8007402420043945,
        -0.5945212841033936,
        0.073208749294281
      ],
      "plane_d": -2958.124267578125,
      "bbox_min": [
        -1333.1427001953125,
        -3357.472412109375,
        724.0
      ],
      "bbox_max": [
        -1105.0,
        -3088.09423828125,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3314.0,
      "bbox_min": [
        -1146.5478515625,
        -3322.0,
        860.0
      ],
      "bbox_max": [
        -1126.0,
        -3314.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3322.0,
      "bbox_min": [
        -1146.5478515625,
        -3322.0,
        860.0
      ],
      "bbox_max": [
        -1126.0,
        -3314.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9138116240501404,
        -0.0,
        -0.40613850951194763
      ],
      "plane_d": -697.9490356445312,
      "bbox_min": [
        -1146.5478515625,
        -3315.25146484375,
        860.0
      ],
      "bbox_max": [
        -1146.0,
        -3314.0,
        861.2327880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.17790910601615906,
        -0.0,
        0.984046995639801
      ],
      "plane_d": -662.3861083984375,
      "bbox_min": [
        -1134.300048828125,
        -3348.796142578125,
        868.2073974609375
      ],
      "bbox_max": [
        -1105.0,
        -3293.0009765625,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3322.0,
      "bbox_min": [
        -1133.2291259765625,
        -3322.0,
        868.2073974609375
      ],
      "bbox_max": [
        -1126.0,
        -3322.0,
        877.9482421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3322.0,
      "bbox_min": [
        -1133.2774658203125,
        -3322.0,
        877.8865356445312
      ],
      "bbox_max": [
        -1132.57568359375,
        -3322.0,
        878.013427734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3322.0,
      "bbox_min": [
        -1133.4146728515625,
        -3322.0,
        876.6976928710938
      ],
      "bbox_max": [
        -1126.0,
        -3314.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3314.0,
      "bbox_min": [
        -1126.9766845703125,
        -3314.0,
        876.88232421875
      ],
      "bbox_max": [
        -1126.0,
        -3314.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9845805764198303,
        -0.14805786311626434,
        0.09316641837358475
      ],
      "plane_d": -1703.1788330078125,
      "bbox_min": [
        -1161.8470458984375,
        -3357.472412109375,
        724.0
      ],
      "bbox_max": [
        -1152.3179931640625,
        -3321.635986328125,
        823.8455810546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9856189489364624,
        -0.10732632130384445,
        0.13052378594875336
      ],
      "plane_d": -1595.8048095703125,
      "bbox_min": [
        -1160.6263427734375,
        -3357.472412109375,
        724.0
      ],
      "bbox_max": [
        -1155.2801513671875,
        -3329.75439453125,
        747.0780029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8007402420043945,
        -0.5945212841033936,
        0.073208749294281
      ],
      "plane_d": -2958.124267578125,
      "bbox_min": [
        -1381.2618408203125,
        -3477.275390625,
        724.0
      ],
      "bbox_max": [
        -1114.98486328125,
        -3088.083740234375,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3322.0,
      "bbox_min": [
        -1148.692138671875,
        -3322.0,
        860.0
      ],
      "bbox_max": [
        -1135.1934814453125,
        -3314.0,
        877.9904174804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3314.0,
      "bbox_min": [
        -1148.692138671875,
        -3322.0,
        860.0
      ],
      "bbox_max": [
        -1141.6876220703125,
        -3314.0,
        876.482421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9138116240501404,
        -0.0,
        -0.40613850951194763
      ],
      "plane_d": -697.9490356445312,
      "bbox_min": [
        -1148.6920166015625,
        -3322.0,
        860.0
      ],
      "bbox_max": [
        -1146.0,
        -3314.0,
        866.0571899414062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6382936835289001,
        0.7293487191200256,
        0.2462347000837326
      ],
      "plane_d": 1514.509521484375,
      "bbox_min": [
        -1117.74365234375,
        -3350.199951171875,
        874.9114990234375
      ],
      "bbox_max": [
        -1114.98486328125,
        -3348.679931640625,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9845805764198303,
        -0.14805786311626434,
        0.09316641837358475
      ],
      "plane_d": -1703.1788330078125,
      "bbox_min": [
        -1381.2618408203125,
        -3477.275390625,
        724.0
      ],
      "bbox_max": [
        -1132.2735595703125,
        -3107.087646484375,
        856.8275146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9792153239250183,
        -0.19332727789878845,
        0.061334479600191116
      ],
      "plane_d": -1825.3980712890625,
      "bbox_min": [
        -1147.5853271484375,
        -3477.275390625,
        724.0
      ],
      "bbox_max": [
        -1132.2735595703125,
        -3396.521240234375,
        788.1217651367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9528772234916687,
        -0.2737281024456024,
        0.130758598446846
      ],
      "plane_d": -2123.362548828125,
      "bbox_min": [
        -1147.5853271484375,
        -3453.29931640625,
        724.0
      ],
      "bbox_max": [
        -1137.0072021484375,
        -3396.521240234375,
        788.1217651367188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9856189489364624,
        -0.10732632130384445,
        0.13052378594875336
      ],
      "plane_d": -1595.8048095703125,
      "bbox_min": [
        -1381.2618408203125,
        -3416.4755859375,
        724.0
      ],
      "bbox_max": [
        -1144.518310546875,
        -3107.087646484375,
        792.308837890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9528772234916687,
        -0.2737281024456024,
        0.130758598446846
      ],
      "plane_d": -2123.362548828125,
      "bbox_min": [
        -1153.3792724609375,
        -3416.4755859375,
        724.0
      ],
      "bbox_max": [
        -1144.518310546875,
        -3394.542236328125,
        789.594482421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4523264467716217,
        -0.8918522596359253,
        0.0003948037629015744
      ],
      "plane_d": -2152.6083984375,
      "bbox_min": [
        -1381.2618408203125,
        -3113.86083984375,
        724.0
      ],
      "bbox_max": [
        -1367.9073486328125,
        -3107.087646484375,
        748.3692626953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45534273982048035,
        -0.890298068523407,
        0.00568737369030714
      ],
      "plane_d": -2147.550537109375,
      "bbox_min": [
        -1373.2105712890625,
        -3109.770263671875,
        736.406982421875
      ],
      "bbox_max": [
        -1367.9959716796875,
        -3107.127197265625,
        748.3692626953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9927957653999329,
        0.11212077736854553,
        0.042255036532878876
      ],
      "plane_d": 1673.5107421875,
      "bbox_min": [
        -1465.0,
        -3453.564697265625,
        724.0
      ],
      "bbox_max": [
        -1324.8431396484375,
        -3139.3798828125,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1465.0,
      "bbox_min": [
        -1465.0,
        -3410.0,
        849.997802734375
      ],
      "bbox_max": [
        -1347.2169189453125,
        -3139.3798828125,
        878.1983032226562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1370.0,
      "bbox_min": [
        -1445.0,
        -3410.0,
        849.997802734375
      ],
      "bbox_max": [
        -1347.2169189453125,
        -3139.3798828125,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1405.0,
      "bbox_min": [
        -1445.0,
        -3410.0,
        849.997802734375
      ],
      "bbox_max": [
        -1370.0,
        -3139.3798828125,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3368.0,
      "bbox_min": [
        -1405.0,
        -3368.0,
        870.0
      ],
      "bbox_max": [
        -1370.0,
        -3368.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -850.0,
      "bbox_min": [
        -1445.0,
        -3155.0,
        849.997802734375
      ],
      "bbox_max": [
        -1440.436767578125,
        -3139.3798828125,
        850.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1356.0,
      "bbox_min": [
        -1356.0,
        -3374.0,
        860.0
      ],
      "bbox_max": [
        -1347.2169189453125,
        -3315.0,
        878.1983032226562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3323.0,
      "bbox_min": [
        -1356.0,
        -3323.0,
        860.0
      ],
      "bbox_max": [
        -1351.93017578125,
        -3315.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3315.0,
      "bbox_min": [
        -1356.0,
        -3315.0,
        860.0
      ],
      "bbox_max": [
        -1352.669677734375,
        -3315.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -850.0,
      "bbox_min": [
        -1465.0,
        -3155.0,
        849.9982299804688
      ],
      "bbox_max": [
        -1445.0,
        -3141.41162109375,
        850.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9824994802474976,
        0.16235168278217316,
        0.09130601584911346
      ],
      "plane_d": 1796.623046875,
      "bbox_min": [
        -1329.06494140625,
        -3453.564697265625,
        724.0
      ],
      "bbox_max": [
        -1324.8431396484375,
        -3430.349365234375,
        748.108642578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6911952495574951,
        0.7170864343643188,
        0.08964577317237854
      ],
      "plane_d": 3326.97998046875,
      "bbox_min": [
        -1327.46923828125,
        -3453.564697265625,
        724.0
      ],
      "bbox_max": [
        -1324.8431396484375,
        -3452.548583984375,
        748.108642578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9832573533058167,
        0.1745198667049408,
        0.052420713007450104
      ],
      "plane_d": 1868.7430419921875,
      "bbox_min": [
        -1354.6854248046875,
        -3500.863525390625,
        724.0
      ],
      "bbox_max": [
        -1282.6756591796875,
        -3315.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7124058604240417,
        0.6995056867599487,
        0.05629853904247284
      ],
      "plane_d": 3319.36767578125,
      "bbox_min": [
        -1354.6854248046875,
        -3500.863525390625,
        724.0
      ],
      "bbox_max": [
        -1282.6756591796875,
        -3315.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3315.0,
      "bbox_min": [
        -1354.6854248046875,
        -3323.0,
        860.0
      ],
      "bbox_max": [
        -1348.7904052734375,
        -3315.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3323.0,
      "bbox_min": [
        -1353.9461669921875,
        -3323.0,
        860.0
      ],
      "bbox_max": [
        -1348.7904052734375,
        -3323.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7217350602149963,
        0.6888043284416199,
        0.06816939264535904
      ],
      "plane_d": 3283.454345703125,
      "bbox_min": [
        -1292.409912109375,
        -3495.604736328125,
        724.0
      ],
      "bbox_max": [
        -1282.6756591796875,
        -3484.34423828125,
        750.54541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3374.0,
      "bbox_min": [
        -1348.5267333984375,
        -3374.0,
        860.0
      ],
      "bbox_max": [
        -1332.47998046875,
        -3368.54638671875,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.950871467590332,
        -0.0,
        0.3095860481262207
      ],
      "plane_d": 997.530517578125,
      "bbox_min": [
        -1334.9947509765625,
        -3374.0,
        871.167236328125
      ],
      "bbox_max": [
        -1332.70556640625,
        -3368.54638671875,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9616638422012329,
        0.25931838154792786,
        0.08920101076364517
      ],
      "plane_d": 2092.123291015625,
      "bbox_min": [
        -1403.4910888671875,
        -3496.543701171875,
        724.0
      ],
      "bbox_max": [
        -1280.76708984375,
        -3123.09814453125,
        761.9190673828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4523264467716217,
        -0.8918522596359253,
        0.0003948037629015744
      ],
      "plane_d": -2152.6083984375,
      "bbox_min": [
        -1403.4910888671875,
        -3496.543701171875,
        724.0
      ],
      "bbox_max": [
        -1280.76708984375,
        -3123.09814453125,
        761.9190673828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7217350602149963,
        0.6888043284416199,
        0.06816939264535904
      ],
      "plane_d": 3283.454345703125,
      "bbox_min": [
        -1284.007568359375,
        -3496.543701171875,
        724.0
      ],
      "bbox_max": [
        -1280.76708984375,
        -3494.5439453125,
        747.6507568359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3315.0,
      "bbox_min": [
        -1352.67431640625,
        -3315.0,
        876.2875366210938
      ],
      "bbox_max": [
        -1352.54150390625,
        -3315.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9533829092979431,
        -0.23182019591331482,
        0.1931847333908081
      ],
      "plane_d": -2031.31396484375,
      "bbox_min": [
        -1150.0,
        -3417.484375,
        792.1210327148438
      ],
      "bbox_max": [
        -1116.0537109375,
        -3314.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9845805764198303,
        -0.14805786311626434,
        0.09316641837358475
      ],
      "plane_d": -1703.1788330078125,
      "bbox_min": [
        -1149.1702880859375,
        -3394.3984375,
        792.1210327148438
      ],
      "bbox_max": [
        -1116.0537109375,
        -3314.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3366.0,
      "bbox_min": [
        -1137.91455078125,
        -3374.0,
        860.0
      ],
      "bbox_max": [
        -1126.0,
        -3366.0,
        878.185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3366.0,
      "bbox_min": [
        -1134.2296142578125,
        -3374.0,
        876.6976928710938
      ],
      "bbox_max": [
        -1126.0,
        -3366.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3374.0,
      "bbox_min": [
        -1132.3531494140625,
        -3374.0,
        876.6976928710938
      ],
      "bbox_max": [
        -1126.0,
        -3374.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3322.0,
      "bbox_min": [
        -1149.131103515625,
        -3322.0,
        861.1472778320312
      ],
      "bbox_max": [
        -1135.127197265625,
        -3314.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3314.0,
      "bbox_min": [
        -1149.131103515625,
        -3322.0,
        861.1472778320312
      ],
      "bbox_max": [
        -1141.1407470703125,
        -3314.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9138116240501404,
        -0.0,
        -0.40613850951194763
      ],
      "plane_d": -697.9490356445312,
      "bbox_min": [
        -1149.1309814453125,
        -3322.0,
        861.1472778320312
      ],
      "bbox_max": [
        -1146.5098876953125,
        -3314.0,
        867.044921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9856189489364624,
        -0.10732632130384445,
        0.13052378594875336
      ],
      "plane_d": -1595.8048095703125,
      "bbox_min": [
        -1144.807861328125,
        -3394.3984375,
        792.1210327148438
      ],
      "bbox_max": [
        -1144.192626953125,
        -3392.001220703125,
        794.9396362304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9931049346923828,
        0.0022958379704505205,
        0.11720679700374603
      ],
      "plane_d": -1221.6827392578125,
      "bbox_min": [
        -1150.0,
        -3417.484375,
        794.9396362304688
      ],
      "bbox_max": [
        -1132.2818603515625,
        -3314.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3366.0,
      "bbox_min": [
        -1134.4036865234375,
        -3366.0,
        877.32666015625
      ],
      "bbox_max": [
        -1134.22705078125,
        -3366.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3366.0,
      "bbox_min": [
        -1150.0,
        -3374.0,
        860.0
      ],
      "bbox_max": [
        -1134.30078125,
        -3314.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3374.0,
      "bbox_min": [
        -1144.144775390625,
        -3374.0,
        860.0
      ],
      "bbox_max": [
        -1134.3193359375,
        -3374.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3322.0,
      "bbox_min": [
        -1150.0,
        -3322.0,
        864.0387573242188
      ],
      "bbox_max": [
        -1144.9259033203125,
        -3314.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3314.0,
      "bbox_min": [
        -1150.0,
        -3322.0,
        864.0387573242188
      ],
      "bbox_max": [
        -1146.87109375,
        -3314.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9138116240501404,
        -0.0,
        -0.40613850951194763
      ],
      "plane_d": -697.9490356445312,
      "bbox_min": [
        -1150.0,
        -3322.0,
        864.0387573242188
      ],
      "bbox_max": [
        -1147.7950439453125,
        -3314.0,
        869.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6330804824829102,
        0.7714124321937561,
        0.06428063660860062
      ],
      "plane_d": 3466.7158203125,
      "bbox_min": [
        -1411.0396728515625,
        -3531.997802734375,
        724.0
      ],
      "bbox_max": [
        -1142.80419921875,
        -3107.64111328125,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6911952495574951,
        0.7170864343643188,
        0.08964577317237854
      ],
      "plane_d": 3326.97998046875,
      "bbox_min": [
        -1291.3072509765625,
        -3530.23779296875,
        750.54541015625
      ],
      "bbox_max": [
        -1258.8291015625,
        -3495.604736328125,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7124058604240417,
        0.6995056867599487,
        0.05629853904247284
      ],
      "plane_d": 3319.36767578125,
      "bbox_min": [
        -1291.3072509765625,
        -3530.23779296875,
        798.7045288085938
      ],
      "bbox_max": [
        -1258.8291015625,
        -3499.702880859375,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4523264467716217,
        -0.8918522596359253,
        0.0003948037629015744
      ],
      "plane_d": -2152.6083984375,
      "bbox_min": [
        -1403.4910888671875,
        -3125.1181640625,
        724.0
      ],
      "bbox_max": [
        -1374.5,
        -3110.425537109375,
        761.9190673828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7124058604240417,
        0.6995056867599487,
        0.05629853904247284
      ],
      "plane_d": 3319.36767578125,
      "bbox_min": [
        -1411.0396728515625,
        -3531.997802734375,
        737.5672607421875
      ],
      "bbox_max": [
        -1142.80419921875,
        -3107.64111328125,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4557587504386902,
        -0.8900548815727234,
        -0.00928233191370964
      ],
      "plane_d": -2133.771484375,
      "bbox_min": [
        -1411.0396728515625,
        -3531.997802734375,
        737.5672607421875
      ],
      "bbox_max": [
        -1142.80419921875,
        -3107.64111328125,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43772801756858826,
        -0.8991074562072754,
        0.0
      ],
      "plane_d": -2195.2607421875,
      "bbox_min": [
        -1411.0396728515625,
        -3128.560791015625,
        832.278564453125
      ],
      "bbox_max": [
        -1392.043212890625,
        -3119.3125,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45534273982048035,
        -0.890298068523407,
        0.00568737369030714
      ],
      "plane_d": -2147.550537109375,
      "bbox_min": [
        -1403.4910888671875,
        -3531.997802734375,
        737.5672607421875
      ],
      "bbox_max": [
        -1142.80419921875,
        -3107.64111328125,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4523264467716217,
        -0.8918522596359253,
        0.0003948037629015744
      ],
      "plane_d": -2152.6083984375,
      "bbox_min": [
        -1403.4910888671875,
        -3125.1181640625,
        737.5672607421875
      ],
      "bbox_max": [
        -1373.2103271484375,
        -3109.770263671875,
        761.9190673828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6140355467796326,
        0.7874341607093811,
        0.05392313003540039
      ],
      "plane_d": 3507.92138671875,
      "bbox_min": [
        -1352.54150390625,
        -3531.997802734375,
        781.2319946289062
      ],
      "bbox_max": [
        -1142.80419921875,
        -3315.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6207442283630371,
        0.782613217830658,
        0.046831756830215454
      ],
      "plane_d": 3505.248779296875,
      "bbox_min": [
        -1258.8291015625,
        -3530.838623046875,
        831.288330078125
      ],
      "bbox_max": [
        -1258.0595703125,
        -3530.23779296875,
        833.2398071289062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3315.0,
      "bbox_min": [
        -1352.54150390625,
        -3405.77978515625,
        781.2319946289062
      ],
      "bbox_max": [
        -1142.80419921875,
        -3315.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3323.0,
      "bbox_min": [
        -1350.0330810546875,
        -3405.77978515625,
        781.2319946289062
      ],
      "bbox_max": [
        -1142.80419921875,
        -3315.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.950871467590332,
        -0.0,
        0.3095860481262207
      ],
      "plane_d": 997.530517578125,
      "bbox_min": [
        -1334.9947509765625,
        -3323.0,
        869.0
      ],
      "bbox_max": [
        -1332.0,
        -3315.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9528772234916687,
        -0.2737281024456024,
        0.130758598446846
      ],
      "plane_d": -2123.362548828125,
      "bbox_min": [
        -1335.83544921875,
        -3405.77978515625,
        781.2319946289062
      ],
      "bbox_max": [
        -1142.80419921875,
        -3366.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9856189489364624,
        -0.10732632130384445,
        0.13052378594875336
      ],
      "plane_d": -1595.8048095703125,
      "bbox_min": [
        -1144.884765625,
        -3394.542236328125,
        789.594482421875
      ],
      "bbox_max": [
        -1144.192626953125,
        -3392.177001953125,
        794.9396362304688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3374.0,
      "bbox_min": [
        -1335.83544921875,
        -3374.0,
        860.0
      ],
      "bbox_max": [
        -1143.0048828125,
        -3366.0,
        878.1983032226562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.950871467590332,
        0.0,
        0.3095860481262207
      ],
      "plane_d": -1362.532470703125,
      "bbox_min": [
        -1150.0,
        -3374.0,
        869.0
      ],
      "bbox_max": [
        -1147.0052490234375,
        -3366.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.950871467590332,
        -0.0,
        0.3095860481262207
      ],
      "plane_d": 997.530517578125,
      "bbox_min": [
        -1334.9947509765625,
        -3374.0,
        869.0
      ],
      "bbox_max": [
        -1332.0,
        -3366.0,
        878.1983032226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2307186871767044,
        0.971686601638794,
        0.05093211308121681
      ],
      "plane_d": 3619.826416015625,
      "bbox_min": [
        -1595.0,
        -3540.2158203125,
        878.1983032226562
      ],
      "bbox_max": [
        -1260.6123046875,
        -3362.948486328125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7247740030288696,
        0.6881459951400757,
        0.034025806933641434
      ],
      "plane_d": 3317.09765625,
      "bbox_min": [
        -1595.0,
        -3540.2158203125,
        878.1983032226562
      ],
      "bbox_max": [
        -1260.6123046875,
        -3398.44921875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3426.5,
      "bbox_min": [
        -1595.0,
        -3426.5,
        892.0
      ],
      "bbox_max": [
        -1455.337646484375,
        -3398.44921875,
        1115.2313232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -892.0,
      "bbox_min": [
        -1595.0,
        -3426.5,
        892.0
      ],
      "bbox_max": [
        -1455.337646484375,
        -3398.44921875,
        1115.2313232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 915.0,
      "bbox_min": [
        -1595.0,
        -3426.5,
        892.0
      ],
      "bbox_max": [
        -1460.414794921875,
        -3398.44921875,
        1115.2313232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01903552934527397,
        0.9815307855606079,
        -0.19035546481609344
      ],
      "plane_d": 3524.079833984375,
      "bbox_min": [
        -1595.0,
        -3419.54296875,
        989.5020751953125
      ],
      "bbox_max": [
        -1515.6566162109375,
        -3398.44921875,
        1115.2313232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.038227956742048264,
        0.9232555031776428,
        0.3822798430919647
      ],
      "plane_d": 2820.343505859375,
      "bbox_min": [
        -1595.0,
        -3419.54296875,
        989.5020751953125
      ],
      "bbox_max": [
        -1515.6566162109375,
        -3398.44921875,
        1040.4466552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3411.5,
      "bbox_min": [
        -1595.0,
        -3411.5,
        892.0
      ],
      "bbox_max": [
        -1518.510986328125,
        -3411.5,
        915.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7219356298446655,
        0.69008469581604,
        0.05091238394379616
      ],
      "plane_d": 3303.51171875,
      "bbox_min": [
        -1338.7542724609375,
        -3535.07177734375,
        878.1983032226562
      ],
      "bbox_max": [
        -1260.6123046875,
        -3454.531982421875,
        997.4153442382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7124058604240417,
        0.6995056867599487,
        0.05629853904247284
      ],
      "plane_d": 3319.36767578125,
      "bbox_min": [
        -1338.7542724609375,
        -3535.07177734375,
        878.1983032226562
      ],
      "bbox_max": [
        -1260.6123046875,
        -3454.531982421875,
        997.4153442382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6140355467796326,
        0.7874341607093811,
        0.05392313003540039
      ],
      "plane_d": 3507.92138671875,
      "bbox_min": [
        -1338.7542724609375,
        -3535.07177734375,
        878.1983032226562
      ],
      "bbox_max": [
        -1260.6123046875,
        -3454.531982421875,
        997.4153442382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9832573533058167,
        0.1745198667049408,
        0.052420713007450104
      ],
      "plane_d": 1868.7430419921875,
      "bbox_min": [
        -1338.7542724609375,
        -3458.6162109375,
        878.1983032226562
      ],
      "bbox_max": [
        -1333.894287109375,
        -3454.531982421875,
        976.6000366210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8500498533248901,
        0.5251100659370422,
        0.04092385247349739
      ],
      "plane_d": 3041.765869140625,
      "bbox_min": [
        -1595.0,
        -3458.6162109375,
        878.1983032226562
      ],
      "bbox_max": [
        -1334.2330322265625,
        -3362.948486328125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.056889183819293976,
        0.9831775426864624,
        -0.17356735467910767
      ],
      "plane_d": 3449.109619140625,
      "bbox_min": [
        -1595.0,
        -3388.281494140625,
        1201.640625
      ],
      "bbox_max": [
        -1576.020751953125,
        -3375.162109375,
        1275.9561767578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.038227956742048264,
        0.9232555031776428,
        0.3822798430919647
      ],
      "plane_d": 2820.343505859375,
      "bbox_min": [
        -1595.0,
        -3419.54296875,
        892.0
      ],
      "bbox_max": [
        -1513.0611572265625,
        -3394.36962890625,
        1032.5123291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3411.5,
      "bbox_min": [
        -1523.588134765625,
        -3413.898681640625,
        892.0
      ],
      "bbox_max": [
        -1513.0611572265625,
        -3411.5,
        915.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 915.0,
      "bbox_min": [
        -1523.588134765625,
        -3413.898681640625,
        892.0
      ],
      "bbox_max": [
        -1513.0611572265625,
        -3411.5,
        915.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -892.0,
      "bbox_min": [
        -1518.510986328125,
        -3412.7939453125,
        892.0
      ],
      "bbox_max": [
        -1513.0611572265625,
        -3411.5,
        892.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22641703486442566,
        -0.020128117874264717,
        0.9738224148750305
      ],
      "plane_d": -595.3028564453125,
      "bbox_min": [
        -1595.0,
        -3368.02783203125,
        900.3103637695312
      ],
      "bbox_max": [
        -1542.261474609375,
        -3362.948486328125,
        912.6388549804688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3184397518634796,
        0.8545204997062683,
        0.4103544354438782
      ],
      "plane_d": 2981.018798828125,
      "bbox_min": [
        -1544.27880859375,
        -3458.6162109375,
        878.1983032226562
      ],
      "bbox_max": [
        -1334.2330322265625,
        -3362.948486328125,
        1032.5123291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1405.0,
      "bbox_min": [
        -1405.0,
        -3410.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1405.0,
        -3409.98583984375,
        878.289794921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9832573533058167,
        0.1745198667049408,
        0.052420713007450104
      ],
      "plane_d": 1868.7430419921875,
      "bbox_min": [
        -1514.9678955078125,
        -3458.6162109375,
        878.1983032226562
      ],
      "bbox_max": [
        -1334.2330322265625,
        -3411.5,
        976.6000366210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -892.0,
      "bbox_min": [
        -1514.9678955078125,
        -3426.5,
        892.0
      ],
      "bbox_max": [
        -1380.0,
        -3411.5,
        915.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 915.0,
      "bbox_min": [
        -1514.9678955078125,
        -3426.5,
        892.0
      ],
      "bbox_max": [
        -1380.0,
        -3411.5,
        915.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3426.5,
      "bbox_min": [
        -1460.414794921875,
        -3426.5,
        892.0
      ],
      "bbox_max": [
        -1380.0,
        -3424.746826171875,
        915.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1380.0,
      "bbox_min": [
        -1380.0,
        -3426.5,
        892.0
      ],
      "bbox_max": [
        -1380.0,
        -3424.746826171875,
        903.3905639648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22641703486442566,
        -0.020128117874264717,
        0.9738224148750305
      ],
      "plane_d": -595.3028564453125,
      "bbox_min": [
        -1544.27880859375,
        -3366.172119140625,
        890.1369018554688
      ],
      "bbox_max": [
        -1498.367919921875,
        -3362.948486328125,
        900.8460083007812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9945406317710876,
        -0.05085870251059532,
        0.09111718833446503
      ],
      "plane_d": -1379.3016357421875,
      "bbox_min": [
        -1595.0,
        -3480.0439453125,
        878.1983032226562
      ],
      "bbox_max": [
        -1105.0,
        -3362.948486328125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3366.0,
      "bbox_min": [
        -1134.2847900390625,
        -3374.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1126.0,
        -3366.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -912.0,
      "bbox_min": [
        -1130.744140625,
        -3374.0,
        912.0
      ],
      "bbox_max": [
        -1126.0,
        -3369.84814453125,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3366.0,
      "bbox_min": [
        -1134.1732177734375,
        -3374.0,
        879.4154052734375
      ],
      "bbox_max": [
        -1126.0,
        -3366.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3374.0,
      "bbox_min": [
        -1130.78955078125,
        -3374.0,
        911.88232421875
      ],
      "bbox_max": [
        -1130.744140625,
        -3374.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3374.0,
      "bbox_min": [
        -1134.3192138671875,
        -3374.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1132.336181640625,
        -3366.0,
        895.0014038085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9832573533058167,
        0.1745198667049408,
        0.052420713007450104
      ],
      "plane_d": 1868.7430419921875,
      "bbox_min": [
        -1501.9541015625,
        -3458.6162109375,
        878.1983032226562
      ],
      "bbox_max": [
        -1335.944091796875,
        -3362.948486328125,
        976.6000366210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05185391753911972,
        0.9296181201934814,
        0.36485806107521057
      ],
      "plane_d": 2880.741455078125,
      "bbox_min": [
        -1501.9541015625,
        -3426.5,
        878.1983032226562
      ],
      "bbox_max": [
        -1370.0,
        -3362.948486328125,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3411.5,
      "bbox_min": [
        -1413.2100830078125,
        -3426.5,
        878.1983032226562
      ],
      "bbox_max": [
        -1370.0,
        -3386.67529296875,
        918.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -894.0,
      "bbox_min": [
        -1405.0,
        -3411.5,
        878.1983032226562
      ],
      "bbox_max": [
        -1370.0,
        -3386.67529296875,
        918.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1405.0,
      "bbox_min": [
        -1405.0,
        -3410.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1370.0,
        -3386.67529296875,
        894.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1370.0,
      "bbox_min": [
        -1370.0,
        -3410.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1370.0,
        -3399.71826171875,
        894.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1399.5,
      "bbox_min": [
        -1401.5,
        -3411.5,
        894.0
      ],
      "bbox_max": [
        -1373.0,
        -3396.313232421875,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6585046052932739,
        0.0,
        0.7525767087936401
      ],
      "plane_d": -1611.501953125,
      "bbox_min": [
        -1401.5,
        -3410.0,
        915.0
      ],
      "bbox_max": [
        -1399.5,
        -3405.65283203125,
        916.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 3409.999755859375,
      "bbox_min": [
        -1399.5,
        -3411.5,
        894.0
      ],
      "bbox_max": [
        -1373.0,
        -3396.5,
        918.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1382.0,
      "bbox_min": [
        -1392.5,
        -3411.5,
        894.0
      ],
      "bbox_max": [
        -1382.0,
        -3410.0,
        908.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1392.5,
      "bbox_min": [
        -1392.5,
        -3411.5,
        894.0
      ],
      "bbox_max": [
        -1382.0,
        -3410.0,
        908.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 908.0,
      "bbox_min": [
        -1392.5,
        -3411.5,
        908.0
      ],
      "bbox_max": [
        -1382.0,
        -3410.0,
        908.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1375.0,
      "bbox_min": [
        -1399.5,
        -3410.0,
        894.0
      ],
      "bbox_max": [
        -1373.0,
        -3396.5,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1373.0,
      "bbox_min": [
        -1373.0,
        -3410.0,
        894.0
      ],
      "bbox_max": [
        -1373.0,
        -3406.188720703125,
        901.9366455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1396.5,
      "bbox_min": [
        -1399.5,
        -3410.0,
        894.0
      ],
      "bbox_max": [
        -1394.3443603515625,
        -3396.5,
        918.5
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3403.0,
      "bbox_min": [
        -1399.5,
        -3410.0,
        894.0
      ],
      "bbox_max": [
        -1396.5,
        -3396.5,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547001957893372,
        -0.0,
        0.8320503234863281
      ],
      "plane_d": 19.96917724609375,
      "bbox_min": [
        -1399.5,
        -3410.0,
        895.0
      ],
      "bbox_max": [
        -1396.5,
        -3403.516357421875,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3408.5,
      "bbox_min": [
        -1399.0,
        -3408.5,
        895.0
      ],
      "bbox_max": [
        -1396.5,
        -3404.0,
        905.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -895.0,
      "bbox_min": [
        -1399.0,
        -3408.5,
        895.0
      ],
      "bbox_max": [
        -1396.5,
        -3404.0,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -918.5,
      "bbox_min": [
        -1397.5,
        -3410.0,
        918.5
      ],
      "bbox_max": [
        -1396.5,
        -3408.823974609375,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -895.0,
      "bbox_min": [
        -1399.5,
        -3403.0,
        894.0
      ],
      "bbox_max": [
        -1396.5,
        -3396.5,
        895.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3396.5,
      "bbox_min": [
        -1399.5,
        -3396.5,
        894.0
      ],
      "bbox_max": [
        -1398.99853515625,
        -3396.5,
        894.3890991210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -918.5,
      "bbox_min": [
        -1396.5,
        -3410.0,
        918.5
      ],
      "bbox_max": [
        -1394.3443603515625,
        -3409.196533203125,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1380.0,
      "bbox_min": [
        -1413.2100830078125,
        -3426.5,
        892.0
      ],
      "bbox_max": [
        -1380.0,
        -3411.5,
        915.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 915.0,
      "bbox_min": [
        -1413.2100830078125,
        -3426.5,
        892.0
      ],
      "bbox_max": [
        -1380.0,
        -3411.5,
        915.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -892.0,
      "bbox_min": [
        -1406.20703125,
        -3426.5,
        892.0
      ],
      "bbox_max": [
        -1380.0,
        -3411.5,
        915.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3426.5,
      "bbox_min": [
        -1383.534912109375,
        -3426.5,
        903.3905639648438
      ],
      "bbox_max": [
        -1380.0,
        -3426.5,
        915.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22641703486442566,
        -0.020128117874264717,
        0.9738224148750305
      ],
      "plane_d": -595.3028564453125,
      "bbox_min": [
        -1501.9541015625,
        -3364.627685546875,
        884.6555786132812
      ],
      "bbox_max": [
        -1474.71875,
        -3362.948486328125,
        891.00537109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.046494390815496445,
        0.7289436459541321,
        0.6829929947853088
      ],
      "plane_d": 1916.369873046875,
      "bbox_min": [
        -1595.0,
        -3458.6162109375,
        878.1983032226562
      ],
      "bbox_max": [
        -1130.77880859375,
        -3362.948486328125,
        1302.5999755859375
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.9832573533058167,
        0.1745198667049408,
        0.052420713007450104
      ],
      "plane_d": 1868.7430419921875,
      "bbox_min": [
        -1405.0,
        -3458.6162109375,
        878.1983032226562
      ],
      "bbox_max": [
        -1334.9947509765625,
        -3365.699951171875,
        976.6000366210938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1370.0,
      "bbox_min": [
        -1405.0,
        -3413.66455078125,
        878.1983032226562
      ],
      "bbox_max": [
        -1348.5267333984375,
        -3368.0,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -894.0,
      "bbox_min": [
        -1405.0,
        -3413.66455078125,
        878.1983032226562
      ],
      "bbox_max": [
        -1370.0,
        -3368.0,
        918.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1405.0,
      "bbox_min": [
        -1405.0,
        -3394.263671875,
        878.1983032226562
      ],
      "bbox_max": [
        -1405.0,
        -3368.0,
        894.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6585046052932739,
        -0.0,
        0.7525767087936401
      ],
      "plane_d": 215.5191650390625,
      "bbox_min": [
        -1375.0,
        -3410.0,
        915.0
      ],
      "bbox_max": [
        -1373.0,
        -3398.71484375,
        916.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6585046052932739,
        0.0,
        0.7525767087936401
      ],
      "plane_d": -1611.501953125,
      "bbox_min": [
        -1401.5,
        -3407.23828125,
        915.0
      ],
      "bbox_max": [
        -1399.5,
        -3396.897216796875,
        916.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -918.5,
      "bbox_min": [
        -1399.5,
        -3413.66455078125,
        894.0
      ],
      "bbox_max": [
        -1375.0,
        -3385.0,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        -0.0
      ],
      "plane_d": 3409.999755859375,
      "bbox_min": [
        -1399.5,
        -3413.66455078125,
        894.0
      ],
      "bbox_max": [
        -1375.0,
        -3385.0,
        918.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3411.5,
      "bbox_min": [
        -1385.8082275390625,
        -3413.66455078125,
        910.49267578125
      ],
      "bbox_max": [
        -1380.0,
        -3411.5,
        915.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 915.0,
      "bbox_min": [
        -1385.8082275390625,
        -3413.66455078125,
        910.49267578125
      ],
      "bbox_max": [
        -1380.0,
        -3411.5,
        915.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1380.0,
      "bbox_min": [
        -1380.0,
        -3413.66455078125,
        910.49267578125
      ],
      "bbox_max": [
        -1380.0,
        -3411.5,
        915.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9615239500999451,
        -0.0,
        -0.2747211158275604
      ],
      "plane_d": -1074.57177734375,
      "bbox_min": [
        -1399.5,
        -3410.0,
        894.0
      ],
      "bbox_max": [
        -1375.0,
        -3385.0,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6585046052932739,
        -0.0,
        0.7525767087936401
      ],
      "plane_d": 215.5191650390625,
      "bbox_min": [
        -1377.0,
        -3410.0,
        916.75
      ],
      "bbox_max": [
        -1375.0,
        -3400.22705078125,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6000000238418579,
        0.0,
        0.800000011920929
      ],
      "plane_d": -1545.2000732421875,
      "bbox_min": [
        -1399.5,
        -3408.823974609375,
        894.0
      ],
      "bbox_max": [
        -1375.0,
        -3385.0,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3385.0,
      "bbox_min": [
        -1379.5999755859375,
        -3385.0,
        894.0
      ],
      "bbox_max": [
        -1375.0,
        -3385.0,
        899.7999877929688
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3396.5,
      "bbox_min": [
        -1399.5,
        -3408.823974609375,
        894.0
      ],
      "bbox_max": [
        -1396.5,
        -3396.5,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1396.5,
      "bbox_min": [
        -1399.5,
        -3408.823974609375,
        894.0
      ],
      "bbox_max": [
        -1396.5,
        -3396.5,
        918.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.6585046052932739,
        0.0,
        0.7525767087936401
      ],
      "plane_d": -1611.501953125,
      "bbox_min": [
        -1399.5,
        -3408.823974609375,
        907.0
      ],
      "bbox_max": [
        -1396.5,
        -3396.5,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547001957893372,
        -0.0,
        0.8320503234863281
      ],
      "plane_d": 19.96917724609375,
      "bbox_min": [
        -1399.5,
        -3403.673828125,
        907.0
      ],
      "bbox_max": [
        -1396.5,
        -3396.5,
        909.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3374.0,
      "bbox_min": [
        -1356.0,
        -3374.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1348.5267333984375,
        -3368.0,
        887.4649658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1356.0,
      "bbox_min": [
        -1356.0,
        -3374.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1356.0,
        -3368.0,
        887.4649658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3366.0,
      "bbox_min": [
        -1356.0,
        -3368.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1349.946533203125,
        -3366.0,
        881.0613403320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1356.0,
      "bbox_min": [
        -1356.0,
        -3368.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1356.0,
        -3366.0,
        881.0613403320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3374.0,
      "bbox_min": [
        -1349.96337890625,
        -3374.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1334.9947509765625,
        -3366.0,
        886.9881591796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.950871467590332,
        -0.0,
        0.3095860481262207
      ],
      "plane_d": 997.530517578125,
      "bbox_min": [
        -1349.96337890625,
        -3374.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1334.9947509765625,
        -3366.0,
        886.2127685546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05333402752876282,
        0.0,
        0.9985767602920532
      ],
      "plane_d": -804.9474487304688,
      "bbox_min": [
        -1357.415283203125,
        -3365.699951171875,
        878.1983032226562
      ],
      "bbox_max": [
        -1350.0,
        -3362.948486328125,
        878.5943603515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8500498533248901,
        0.5251100659370422,
        0.04092385247349739
      ],
      "plane_d": 3041.765869140625,
      "bbox_min": [
        -1595.0,
        -3409.7333984375,
        878.1983032226562
      ],
      "bbox_max": [
        -1130.77880859375,
        -3362.948486328125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.056889183819293976,
        0.9831775426864624,
        -0.17356735467910767
      ],
      "plane_d": 3449.109619140625,
      "bbox_min": [
        -1595.0,
        -3379.77587890625,
        1243.6004638671875
      ],
      "bbox_max": [
        -1557.488037109375,
        -3368.889404296875,
        1301.6318359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39672571420669556,
        0.18136583268642426,
        -0.8998417854309082
      ],
      "plane_d": 1149.486572265625,
      "bbox_min": [
        -1595.0,
        -3371.47021484375,
        1284.5732421875
      ],
      "bbox_max": [
        -1557.488037109375,
        -3368.889404296875,
        1301.6318359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39672571420669556,
        0.18136583268642426,
        -0.8998417854309082
      ],
      "plane_d": 1149.486572265625,
      "bbox_min": [
        -1595.0,
        -3371.47021484375,
        1284.5732421875
      ],
      "bbox_max": [
        -1557.488037109375,
        -3362.948486328125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.950871467590332,
        0.0,
        0.3095860481262207
      ],
      "plane_d": -1362.532470703125,
      "bbox_min": [
        -1562.951171875,
        -3401.739501953125,
        878.1983032226562
      ],
      "bbox_max": [
        -1130.77880859375,
        -3362.948486328125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3366.0,
      "bbox_min": [
        -1147.0052490234375,
        -3374.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1130.77880859375,
        -3366.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3374.0,
      "bbox_min": [
        -1147.0052490234375,
        -3374.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1130.77880859375,
        -3366.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -912.0,
      "bbox_min": [
        -1136.0,
        -3374.0,
        912.0
      ],
      "bbox_max": [
        -1130.77880859375,
        -3366.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3366.0,
      "bbox_min": [
        -1562.951171875,
        -3401.739501953125,
        878.1983032226562
      ],
      "bbox_max": [
        -1334.9947509765625,
        -3362.948486328125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3368.0,
      "bbox_min": [
        -1405.0,
        -3401.739501953125,
        878.1983032226562
      ],
      "bbox_max": [
        -1334.9947509765625,
        -3366.0,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.950871467590332,
        -0.0,
        0.3095860481262207
      ],
      "plane_d": 997.530517578125,
      "bbox_min": [
        -1405.0,
        -3401.739501953125,
        879.6638793945312
      ],
      "bbox_max": [
        -1335.471923828125,
        -3368.0,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -894.0,
      "bbox_min": [
        -1405.0,
        -3401.739501953125,
        881.0613403320312
      ],
      "bbox_max": [
        -1337.6041259765625,
        -3368.0,
        918.5
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1370.0,
      "bbox_min": [
        -1405.0,
        -3379.22998046875,
        881.0613403320312
      ],
      "bbox_max": [
        -1337.6041259765625,
        -3368.0,
        894.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1405.0,
      "bbox_min": [
        -1405.0,
        -3376.997314453125,
        884.3972778320312
      ],
      "bbox_max": [
        -1405.0,
        -3368.0,
        894.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3374.0,
      "bbox_min": [
        -1356.0,
        -3374.0,
        881.0613403320312
      ],
      "bbox_max": [
        -1337.6041259765625,
        -3368.0,
        894.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1356.0,
      "bbox_min": [
        -1356.0,
        -3374.0,
        881.0613403320312
      ],
      "bbox_max": [
        -1356.0,
        -3368.0,
        894.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1373.0,
      "bbox_min": [
        -1401.5,
        -3401.739501953125,
        894.0
      ],
      "bbox_max": [
        -1340.1395263671875,
        -3368.0,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1401.5,
      "bbox_min": [
        -1401.5,
        -3401.739501953125,
        894.0
      ],
      "bbox_max": [
        -1373.0,
        -3374.5,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6585046052932739,
        -0.0,
        0.7525767087936401
      ],
      "plane_d": 215.5191650390625,
      "bbox_min": [
        -1401.5,
        -3401.739501953125,
        894.0
      ],
      "bbox_max": [
        -1373.0,
        -3374.5,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1375.0,
      "bbox_min": [
        -1401.5,
        -3400.431884765625,
        894.0
      ],
      "bbox_max": [
        -1373.0,
        -3374.5,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3374.5,
      "bbox_min": [
        -1375.0,
        -3374.5,
        894.0
      ],
      "bbox_max": [
        -1373.0,
        -3374.5,
        916.75
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1399.5,
      "bbox_min": [
        -1401.5,
        -3400.431884765625,
        894.0
      ],
      "bbox_max": [
        -1375.0,
        -3374.5,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6585046052932739,
        0.0,
        0.7525767087936401
      ],
      "plane_d": -1611.501953125,
      "bbox_min": [
        -1401.5,
        -3398.66455078125,
        894.0
      ],
      "bbox_max": [
        -1399.5,
        -3374.5,
        916.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3374.5,
      "bbox_min": [
        -1401.5,
        -3374.5,
        894.0
      ],
      "bbox_max": [
        -1399.5,
        -3374.5,
        916.75
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.6585046052932739,
        0.0,
        0.7525767087936401
      ],
      "plane_d": -1611.501953125,
      "bbox_min": [
        -1399.5,
        -3400.431884765625,
        894.0
      ],
      "bbox_max": [
        -1375.0,
        -3374.5,
        918.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3374.5,
      "bbox_min": [
        -1399.5,
        -3398.332275390625,
        894.0
      ],
      "bbox_max": [
        -1375.0,
        -3374.5,
        918.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.9615239500999451,
        -0.0,
        -0.2747211158275604
      ],
      "plane_d": -1074.57177734375,
      "bbox_min": [
        -1395.0,
        -3398.332275390625,
        894.0
      ],
      "bbox_max": [
        -1375.0,
        -3374.5,
        915.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3384.0,
      "bbox_min": [
        -1379.0,
        -3384.0,
        904.5
      ],
      "bbox_max": [
        -1375.0,
        -3384.0,
        915.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1385.0,
      "bbox_min": [
        -1395.0,
        -3376.0,
        894.0
      ],
      "bbox_max": [
        -1385.0,
        -3374.5,
        908.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1395.0,
      "bbox_min": [
        -1395.0,
        -3376.0,
        894.0
      ],
      "bbox_max": [
        -1385.0,
        -3374.5,
        908.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 908.0,
      "bbox_min": [
        -1395.0,
        -3376.0,
        908.0
      ],
      "bbox_max": [
        -1385.0,
        -3374.5,
        908.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3374.0,
      "bbox_min": [
        -1356.0,
        -3374.0,
        894.0
      ],
      "bbox_max": [
        -1340.1395263671875,
        -3368.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1356.0,
      "bbox_min": [
        -1356.0,
        -3374.0,
        894.0
      ],
      "bbox_max": [
        -1346.0,
        -3368.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -912.0,
      "bbox_min": [
        -1356.0,
        -3374.0,
        912.0
      ],
      "bbox_max": [
        -1346.0,
        -3368.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.950871467590332,
        -0.0,
        0.3095860481262207
      ],
      "plane_d": 997.530517578125,
      "bbox_min": [
        -1356.0,
        -3368.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1334.9947509765625,
        -3366.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1356.0,
      "bbox_min": [
        -1356.0,
        -3368.0,
        878.9268188476562
      ],
      "bbox_max": [
        -1346.0,
        -3366.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -912.0,
      "bbox_min": [
        -1356.0,
        -3368.0,
        912.0
      ],
      "bbox_max": [
        -1346.0,
        -3366.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.982089102268219,
        0.1529073566198349,
        -0.11009181290864944
      ],
      "plane_d": 2186.53564453125,
      "bbox_min": [
        -1560.994873046875,
        -3378.35205078125,
        1284.5732421875
      ],
      "bbox_max": [
        -1554.104736328125,
        -3366.0,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39672571420669556,
        0.18136583268642426,
        -0.8998417854309082
      ],
      "plane_d": 1149.486572265625,
      "bbox_min": [
        -1560.994873046875,
        -3371.47021484375,
        1284.5732421875
      ],
      "bbox_max": [
        -1557.488037109375,
        -3366.0,
        1287.221923828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0412130132317543,
        0.43465206027030945,
        -0.8996549844741821
      ],
      "plane_d": 2685.27783203125,
      "bbox_min": [
        -1560.65283203125,
        -3371.47021484375,
        1284.5732421875
      ],
      "bbox_max": [
        -1557.488037109375,
        -3366.0,
        1287.1690673828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9726229310035706,
        0.20830567181110382,
        -0.10302186012268066
      ],
      "plane_d": 2349.484130859375,
      "bbox_min": [
        -1557.488037109375,
        -3378.35205078125,
        1284.5732421875
      ],
      "bbox_max": [
        -1554.104736328125,
        -3371.47021484375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9593862891197205,
        0.24561771750450134,
        -0.13874416053295135
      ],
      "plane_d": 2500.552490234375,
      "bbox_min": [
        -1562.951171875,
        -3366.0,
        884.6555786132812
      ],
      "bbox_max": [
        -1474.6434326171875,
        -3362.948486328125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39672571420669556,
        0.18136583268642426,
        -0.8998417854309082
      ],
      "plane_d": 1149.486572265625,
      "bbox_min": [
        -1562.951171875,
        -3366.0,
        1287.071044921875
      ],
      "bbox_max": [
        -1556.3189697265625,
        -3362.948486328125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22641703486442566,
        -0.020128117874264717,
        0.9738224148750305
      ],
      "plane_d": -595.3028564453125,
      "bbox_min": [
        -1477.99609375,
        -3363.79541015625,
        884.6555786132812
      ],
      "bbox_max": [
        -1474.6434326171875,
        -3362.948486328125,
        885.43505859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3377978503704071,
        -0.8362663984298706,
        0.4319157302379608
      ],
      "plane_d": -2702.277587890625,
      "bbox_min": [
        -1595.0,
        -3362.948486328125,
        878.1983032226562
      ],
      "bbox_max": [
        -1105.0,
        -3053.433837890625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9541356563568115,
        0.2993745803833008,
        0.0
      ],
      "plane_d": 2282.934814453125,
      "bbox_min": [
        -1595.0,
        -3362.948486328125,
        878.1983032226562
      ],
      "bbox_max": [
        -1184.539306640625,
        -3053.433837890625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.001288205268792808,
        -0.936079740524292,
        0.3517853915691376
      ],
      "plane_d": -3417.884521484375,
      "bbox_min": [
        -1595.0,
        -3362.948486328125,
        878.1983032226562
      ],
      "bbox_max": [
        -1350.0,
        -3150.316162109375,
        1300.087158203125
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.1961391419172287,
        -0.9805760383605957
      ],
      "plane_d": 282.33038330078125,
      "bbox_min": [
        -1465.0,
        -3323.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1350.031494140625,
        -3150.316162109375,
        945.003173828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1465.0,
      "bbox_min": [
        -1465.0,
        -3155.0,
        918.0631713867188
      ],
      "bbox_max": [
        -1465.0,
        -3150.316162109375,
        919.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        -0.0
      ],
      "plane_d": -1444.9998779296875,
      "bbox_min": [
        -1465.0,
        -3323.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1350.031494140625,
        -3150.316162109375,
        945.003173828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1356.0,
      "bbox_min": [
        -1356.0,
        -3323.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1350.031494140625,
        -3315.0,
        898.5742797851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3323.0,
      "bbox_min": [
        -1356.0,
        -3323.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1350.031494140625,
        -3323.0,
        878.485595703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.136230432370212e-05,
        0.0,
        1.0
      ],
      "plane_d": -929.9793701171875,
      "bbox_min": [
        -1465.0,
        -3303.789306640625,
        930.0027465820312
      ],
      "bbox_max": [
        -1445.0,
        -3285.0,
        930.0106811523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11021039634943008,
        -0.9280050992965698,
        0.3558935821056366
      ],
      "plane_d": -3234.49072265625,
      "bbox_min": [
        -1595.0,
        -3362.948486328125,
        878.1983032226562
      ],
      "bbox_max": [
        -1350.0,
        -3165.048583984375,
        1299.30517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1012493446469307,
        -0.9274534583091736,
        0.35997048020362854
      ],
      "plane_d": -3251.482177734375,
      "bbox_min": [
        -1595.0,
        -3252.21533203125,
        1102.025146484375
      ],
      "bbox_max": [
        -1501.1502685546875,
        -3166.4111328125,
        1296.699951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21167901158332825,
        0.041101183742284775,
        0.9764747023582458
      ],
      "plane_d": -415.9947204589844,
      "bbox_min": [
        -1595.0,
        -3351.9326171875,
        884.6555786132812
      ],
      "bbox_max": [
        -1470.9000244140625,
        -3320.83935546875,
        912.8665771484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3323.0,
      "bbox_min": [
        -1356.0,
        -3323.0,
        878.4830932617188
      ],
      "bbox_max": [
        -1355.3331298828125,
        -3322.987548828125,
        878.5187377929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1356.0,
      "bbox_min": [
        -1356.0,
        -3323.0,
        878.485595703125
      ],
      "bbox_max": [
        -1356.0,
        -3322.987548828125,
        878.5187377929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1356.0,
      "bbox_min": [
        -1356.0,
        -3323.0,
        878.4635009765625
      ],
      "bbox_max": [
        -1350.0911865234375,
        -3316.654541015625,
        895.3707275390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3323.0,
      "bbox_min": [
        -1356.0,
        -3323.0,
        878.4635009765625
      ],
      "bbox_max": [
        -1350.0911865234375,
        -3323.0,
        883.0848388671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43772801756858826,
        -0.8991074562072754,
        0.0
      ],
      "plane_d": -2195.2607421875,
      "bbox_min": [
        -1411.0396728515625,
        -3323.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1184.539306640625,
        -3053.433837890625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4557587504386902,
        -0.8900548815727234,
        -0.00928233191370964
      ],
      "plane_d": -2133.771484375,
      "bbox_min": [
        -1392.043212890625,
        -3119.3125,
        878.1983032226562
      ],
      "bbox_max": [
        -1356.511474609375,
        -3102.013916015625,
        964.08837890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3314.0,
      "bbox_min": [
        -1141.1407470703125,
        -3322.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1126.9766845703125,
        -3314.0,
        891.5501708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3322.0,
      "bbox_min": [
        -1134.6126708984375,
        -3322.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1126.0,
        -3314.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -912.0,
      "bbox_min": [
        -1130.3677978515625,
        -3319.810546875,
        912.0
      ],
      "bbox_max": [
        -1126.0,
        -3314.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05163498595356941,
        -0.004590269178152084,
        0.9986554980278015
      ],
      "plane_d": -822.7598266601562,
      "bbox_min": [
        -1594.4798583984375,
        -3362.948486328125,
        878.1983032226562
      ],
      "bbox_max": [
        -1105.0,
        -3314.0,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39672571420669556,
        0.18136583268642426,
        -0.8998417854309082
      ],
      "plane_d": 1149.486572265625,
      "bbox_min": [
        -1594.4798583984375,
        -3362.948486328125,
        878.1983032226562
      ],
      "bbox_max": [
        -1126.0,
        -3314.0,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9593862891197205,
        0.24561771750450134,
        -0.13874416053295135
      ],
      "plane_d": 2500.552490234375,
      "bbox_min": [
        -1564.6063232421875,
        -3362.948486328125,
        1288.6171875
      ],
      "bbox_max": [
        -1557.062744140625,
        -3333.48291015625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3314.0,
      "bbox_min": [
        -1147.0052490234375,
        -3322.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1126.0,
        -3314.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3322.0,
      "bbox_min": [
        -1147.0052490234375,
        -3322.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1126.0,
        -3314.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -912.0,
      "bbox_min": [
        -1136.0,
        -3322.0,
        912.0
      ],
      "bbox_max": [
        -1126.0,
        -3314.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3323.0,
      "bbox_min": [
        -1356.0,
        -3323.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1334.9947509765625,
        -3315.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.950871467590332,
        -0.0,
        0.3095860481262207
      ],
      "plane_d": 997.530517578125,
      "bbox_min": [
        -1356.0,
        -3323.0,
        878.1983032226562
      ],
      "bbox_max": [
        -1334.9947509765625,
        -3315.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1356.0,
      "bbox_min": [
        -1356.0,
        -3323.0,
        883.0848388671875
      ],
      "bbox_max": [
        -1346.0,
        -3315.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -912.0,
      "bbox_min": [
        -1356.0,
        -3323.0,
        912.0
      ],
      "bbox_max": [
        -1346.0,
        -3315.0,
        912.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9661343693733215,
        0.24907872080802917,
        0.0674104243516922
      ],
      "plane_d": -827.2496337890625,
      "bbox_min": [
        -1760.0,
        -3491.47998046875,
        892.0
      ],
      "bbox_max": [
        -1595.0,
        -3362.948486328125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.056889183819293976,
        0.9831775426864624,
        -0.17356735467910767
      ],
      "plane_d": 3449.109619140625,
      "bbox_min": [
        -1664.755859375,
        -3441.5,
        892.0
      ],
      "bbox_max": [
        -1595.0,
        -3362.948486328125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01903552934527397,
        0.9815307855606079,
        -0.19035546481609344
      ],
      "plane_d": 3524.079833984375,
      "bbox_min": [
        -1664.755859375,
        -3441.5,
        905.0992431640625
      ],
      "bbox_max": [
        -1595.0,
        -3388.281494140625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3441.5,
      "bbox_min": [
        -1624.5,
        -3441.5,
        928.729736328125
      ],
      "bbox_max": [
        -1610.0,
        -3426.5,
        1302.5999755859375
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1610.0,
      "bbox_min": [
        -1624.5,
        -3441.5,
        928.729736328125
      ],
      "bbox_max": [
        -1610.0,
        -3426.5,
        1302.5999755859375
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1624.5,
      "bbox_min": [
        -1624.5,
        -3441.5,
        930.1790161132812
      ],
      "bbox_max": [
        -1610.0,
        -3426.5,
        1302.5999755859375
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3426.5,
      "bbox_min": [
        -1624.5,
        -3426.5,
        1006.07421875
      ],
      "bbox_max": [
        -1610.0,
        -3426.5,
        1302.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1624.5,
      "bbox_min": [
        -1664.755859375,
        -3441.5,
        905.0992431640625
      ],
      "bbox_max": [
        -1595.0,
        -3417.57666015625,
        1047.4222412109375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.038227956742048264,
        0.9232555031776428,
        0.3822798430919647
      ],
      "plane_d": 2820.343505859375,
      "bbox_min": [
        -1664.755859375,
        -3419.54296875,
        1040.656005859375
      ],
      "bbox_max": [
        -1624.5,
        -3418.408203125,
        1047.4222412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1610.0,
      "bbox_min": [
        -1624.5,
        -3441.5,
        905.0992431640625
      ],
      "bbox_max": [
        -1595.0,
        -3417.57666015625,
        1043.3966064453125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.038227956742048264,
        0.9232555031776428,
        0.3822798430919647
      ],
      "plane_d": 2820.343505859375,
      "bbox_min": [
        -1610.0,
        -3419.54296875,
        1035.6976318359375
      ],
      "bbox_max": [
        -1595.0,
        -3417.57666015625,
        1041.9466552734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3441.5,
      "bbox_min": [
        -1624.5,
        -3441.5,
        905.0992431640625
      ],
      "bbox_max": [
        -1610.0,
        -3417.99951171875,
        1043.3966064453125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3426.5,
      "bbox_min": [
        -1624.5,
        -3426.5,
        990.0665283203125
      ],
      "bbox_max": [
        -1610.0,
        -3417.99951171875,
        1043.3966064453125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.038227956742048264,
        0.9232555031776428,
        0.3822798430919647
      ],
      "plane_d": 2820.343505859375,
      "bbox_min": [
        -1624.5,
        -3419.54296875,
        1038.2188720703125
      ],
      "bbox_max": [
        -1610.0,
        -3417.99951171875,
        1043.3966064453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.038227956742048264,
        0.9232555031776428,
        0.3822798430919647
      ],
      "plane_d": 2820.343505859375,
      "bbox_min": [
        -1664.755859375,
        -3441.5,
        892.0
      ],
      "bbox_max": [
        -1595.0,
        -3362.948486328125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1624.5,
      "bbox_min": [
        -1624.5,
        -3441.5,
        892.0
      ],
      "bbox_max": [
        -1595.0,
        -3411.5,
        994.8194580078125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3426.5,
      "bbox_min": [
        -1624.5,
        -3441.5,
        892.0
      ],
      "bbox_max": [
        -1595.0,
        -3411.5,
        994.8194580078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3411.5,
      "bbox_min": [
        -1624.5,
        -3426.5,
        892.0
      ],
      "bbox_max": [
        -1595.0,
        -3411.5,
        915.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 915.0,
      "bbox_min": [
        -1624.5,
        -3426.5,
        892.0
      ],
      "bbox_max": [
        -1595.0,
        -3411.5,
        915.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -892.0,
      "bbox_min": [
        -1624.5,
        -3426.5,
        892.0
      ],
      "bbox_max": [
        -1595.0,
        -3411.5,
        892.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1610.0,
      "bbox_min": [
        -1624.5,
        -3441.5,
        892.0
      ],
      "bbox_max": [
        -1610.0,
        -3426.5,
        990.0665283203125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3441.5,
      "bbox_min": [
        -1624.5,
        -3441.5,
        892.0
      ],
      "bbox_max": [
        -1610.0,
        -3426.5,
        909.8519897460938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -892.0,
      "bbox_min": [
        -1624.5,
        -3441.5,
        892.0
      ],
      "bbox_max": [
        -1610.0,
        -3426.5,
        892.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22641703486442566,
        -0.020128117874264717,
        0.9738224148750305
      ],
      "plane_d": -595.3028564453125,
      "bbox_min": [
        -1660.4217529296875,
        -3370.329833984375,
        912.5338745117188
      ],
      "bbox_max": [
        -1595.0,
        -3366.591796875,
        927.6970825195312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22641703486442566,
        -0.020128117874264717,
        0.9738224148750305
      ],
      "plane_d": -595.3028564453125,
      "bbox_min": [
        -1660.3753662109375,
        -3370.693603515625,
        912.5635375976562
      ],
      "bbox_max": [
        -1595.0,
        -3362.948486328125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21167901158332825,
        0.041101183742284775,
        0.9764747023582458
      ],
      "plane_d": -415.9947204589844,
      "bbox_min": [
        -1659.8751220703125,
        -3368.18701171875,
        922.8613891601562
      ],
      "bbox_max": [
        -1638.9671630859375,
        -3362.948486328125,
        927.6143188476562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.39672571420669556,
        0.18136583268642426,
        -0.8998417854309082
      ],
      "plane_d": 1149.486572265625,
      "bbox_min": [
        -1597.9923095703125,
        -3370.693603515625,
        1301.2681884765625
      ],
      "bbox_max": [
        -1595.0,
        -3364.086181640625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7289522290229797,
        0.6049720644950867,
        0.3203705847263336
      ],
      "plane_d": 411.9771423339844,
      "bbox_min": [
        -1760.0,
        -3491.47998046875,
        1265.1668701171875
      ],
      "bbox_max": [
        -1739.9085693359375,
        -3467.27099609375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.05185391753911972,
        0.9296181201934814,
        0.36485806107521057
      ],
      "plane_d": 2880.741455078125,
      "bbox_min": [
        -1669.7366943359375,
        -3373.532470703125,
        927.6900634765625
      ],
      "bbox_max": [
        -1660.37548828125,
        -3370.148193359375,
        935.89306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22641703486442566,
        -0.020128117874264717,
        0.9738224148750305
      ],
      "plane_d": -595.3028564453125,
      "bbox_min": [
        -1669.7366943359375,
        -3370.65771484375,
        927.6900634765625
      ],
      "bbox_max": [
        -1660.37548828125,
        -3370.148193359375,
        929.8560791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22641703486442566,
        -0.020128117874264717,
        0.9738224148750305
      ],
      "plane_d": -595.3028564453125,
      "bbox_min": [
        -1669.7366943359375,
        -3370.65771484375,
        927.65673828125
      ],
      "bbox_max": [
        -1660.1552734375,
        -3369.285400390625,
        929.8560791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2235765904188156,
        0.04341130331158638,
        0.9737191796302795
      ],
      "plane_d": -385.780029296875,
      "bbox_min": [
        -1760.0,
        -3383.83349609375,
        927.1087036132812
      ],
      "bbox_max": [
        -1658.5599365234375,
        -3362.948486328125,
        951.1689453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21167901158332825,
        0.041101183742284775,
        0.9764747023582458
      ],
      "plane_d": -415.9947204589844,
      "bbox_min": [
        -1671.2335205078125,
        -3370.65771484375,
        927.1087036132812
      ],
      "bbox_max": [
        -1658.5599365234375,
        -3362.948486328125,
        929.8560791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22641703486442566,
        -0.020128117874264717,
        0.9738224148750305
      ],
      "plane_d": -595.3028564453125,
      "bbox_min": [
        -1669.7366943359375,
        -3370.65771484375,
        927.6143188476562
      ],
      "bbox_max": [
        -1659.8751220703125,
        -3368.18701171875,
        929.8560791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21603241562843323,
        -0.9093504548072815,
        0.35554423928260803
      ],
      "plane_d": -2994.511962890625,
      "bbox_min": [
        -1760.0,
        -3362.948486328125,
        911.740966796875
      ],
      "bbox_max": [
        -1595.0,
        -3174.36669921875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1012493446469307,
        -0.9274534583091736,
        0.35997048020362854
      ],
      "plane_d": -3251.482177734375,
      "bbox_min": [
        -1760.0,
        -3362.948486328125,
        911.740966796875
      ],
      "bbox_max": [
        -1595.0,
        -3174.36669921875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11021039634943008,
        -0.9280050992965698,
        0.3558935821056366
      ],
      "plane_d": -3234.49072265625,
      "bbox_min": [
        -1678.0,
        -3328.10009765625,
        911.740966796875
      ],
      "bbox_max": [
        -1595.0,
        -3252.21533203125,
        1102.025146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21167901158332825,
        0.041101183742284775,
        0.9764747023582458
      ],
      "plane_d": -415.9947204589844,
      "bbox_min": [
        -1678.0,
        -3328.10009765625,
        911.740966796875
      ],
      "bbox_max": [
        -1595.0,
        -3325.190185546875,
        929.8560791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24250808358192444,
        -0.909406840801239,
        0.3378889858722687
      ],
      "plane_d": -2927.0478515625,
      "bbox_min": [
        -1760.0,
        -3362.948486328125,
        911.7774047851562
      ],
      "bbox_max": [
        -1595.0,
        -3184.333984375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2235765904188156,
        0.04341130331158638,
        0.9737191796302795
      ],
      "plane_d": -385.780029296875,
      "bbox_min": [
        -1760.0,
        -3362.948486328125,
        911.7774047851562
      ],
      "bbox_max": [
        -1595.0,
        -3326.055419921875,
        950.2378540039062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21186989545822144,
        0.07687602192163467,
        0.9742696285247803
      ],
      "plane_d": -294.561767578125,
      "bbox_min": [
        -1760.0,
        -3357.116455078125,
        929.8560791015625
      ],
      "bbox_max": [
        -1678.0,
        -3328.10009765625,
        949.9778442382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21167901158332825,
        0.041101183742284775,
        0.9764747023582458
      ],
      "plane_d": -415.9947204589844,
      "bbox_min": [
        -1678.0,
        -3362.948486328125,
        911.7774047851562
      ],
      "bbox_max": [
        -1595.0,
        -3326.055419921875,
        929.8560791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": 0.0,
      "bbox_min": [
        -1223.9951171875,
        -4402.3603515625,
        0.0
      ],
      "bbox_max": [
        -751.310546875,
        -3650.0,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6998437643051147,
        -0.7020972967147827,
        0.13144628703594208
      ],
      "plane_d": -3268.36572265625,
      "bbox_min": [
        -1008.3827514648438,
        -3967.783203125,
        0.0
      ],
      "bbox_max": [
        -820.840576171875,
        -3650.0,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6572308540344238,
        -0.7498543858528137,
        0.07593389600515366
      ],
      "plane_d": -3399.419189453125,
      "bbox_min": [
        -1007.23779296875,
        -3967.783203125,
        0.0
      ],
      "bbox_max": [
        -820.840576171875,
        -3650.0,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9488316774368286,
        0.23572899401187897,
        0.2101198136806488
      ],
      "plane_d": 57.75299072265625,
      "bbox_min": [
        -919.74755859375,
        -3967.783203125,
        0.0
      ],
      "bbox_max": [
        -820.840576171875,
        -3786.95263671875,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9344744086265564,
        0.3212260901927948,
        0.1535298079252243
      ],
      "plane_d": 408.4210510253906,
      "bbox_min": [
        -919.74755859375,
        -3947.069091796875,
        0.0
      ],
      "bbox_max": [
        -820.840576171875,
        -3786.95263671875,
        267.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6585033535957336,
        -0.7513062953948975,
        0.04372837394475937
      ],
      "plane_d": -3397.36328125,
      "bbox_min": [
        -977.0939331054688,
        -3924.0,
        267.0
      ],
      "bbox_max": [
        -792.70361328125,
        -3650.0,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6611984968185425,
        -0.7488041520118713,
        0.045921631157398224
      ],
      "plane_d": -3391.467041015625,
      "bbox_min": [
        -976.505615234375,
        -3788.740234375,
        275.85992431640625
      ],
      "bbox_max": [
        -792.70361328125,
        -3650.0,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9720523357391357,
        0.22389337420463562,
        0.07061281055212021
      ],
      "plane_d": 31.119951248168945,
      "bbox_min": [
        -854.8887939453125,
        -3924.0,
        267.0
      ],
      "bbox_max": [
        -792.70361328125,
        -3786.95263671875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9674496054649353,
        0.24035444855690002,
        0.07918946444988251
      ],
      "plane_d": 94.94546508789062,
      "bbox_min": [
        -854.8887939453125,
        -3924.0,
        267.0
      ],
      "bbox_max": [
        -820.840576171875,
        -3786.95263671875,
        536.4684448242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6494391560554504,
        0.7583372592926025,
        0.0561547577381134
      ],
      "plane_d": 2441.852783203125,
      "bbox_min": [
        -1019.15966796875,
        -4127.744140625,
        267.0
      ],
      "bbox_max": [
        -823.8580932617188,
        -3924.0,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6840948462486267,
        0.7246696949005127,
        0.0828745886683464
      ],
      "plane_d": 2260.9384765625,
      "bbox_min": [
        -1019.15966796875,
        -4112.587890625,
        267.0
      ],
      "bbox_max": [
        -823.8580932617188,
        -3924.0,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9674496054649353,
        0.24035444855690002,
        0.07918946444988251
      ],
      "plane_d": 94.94546508789062,
      "bbox_min": [
        -865.766357421875,
        -3986.826171875,
        267.0
      ],
      "bbox_max": [
        -823.8580932617188,
        -3924.0,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9720523357391357,
        0.22389337420463562,
        0.07061281055212021
      ],
      "plane_d": 31.119951248168945,
      "bbox_min": [
        -838.328857421875,
        -3986.826171875,
        536.4684448242188
      ],
      "bbox_max": [
        -823.8580932617188,
        -3924.0,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6607861518859863,
        -0.7483370900154114,
        0.05790644884109497
      ],
      "plane_d": -3397.280517578125,
      "bbox_min": [
        -949.8262939453125,
        -3730.0,
        660.0
      ],
      "bbox_max": [
        -798.61328125,
        -3650.0,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6438754796981812,
        -0.7624677419662476,
        0.06377595663070679
      ],
      "plane_d": -3441.28662109375,
      "bbox_min": [
        -894.7830810546875,
        -3730.0,
        925.9322509765625
      ],
      "bbox_max": [
        -798.61328125,
        -3650.0,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9783579707145691,
        0.18061994016170502,
        0.10095646232366562
      ],
      "plane_d": -157.85714721679688,
      "bbox_min": [
        -1002.8759765625,
        -4162.021484375,
        660.0
      ],
      "bbox_max": [
        -726.752685546875,
        -3730.0,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6452460289001465,
        0.7534409165382385,
        0.12642896175384521
      ],
      "plane_d": 2379.466552734375,
      "bbox_min": [
        -1002.8759765625,
        -4162.021484375,
        660.0
      ],
      "bbox_max": [
        -726.752685546875,
        -3730.0,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.566495954990387,
        0.819241464138031,
        0.08902643620967865
      ],
      "plane_d": 2754.736328125,
      "bbox_min": [
        -1002.8759765625,
        -4162.021484375,
        660.0
      ],
      "bbox_max": [
        -726.752685546875,
        -3730.0,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.967786967754364,
        0.22291091084480286,
        0.11704368144273758
      ],
      "plane_d": 0.13446807861328125,
      "bbox_min": [
        -859.2266845703125,
        -4038.2421875,
        660.0
      ],
      "bbox_max": [
        -726.752685546875,
        -3730.0,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6438754796981812,
        -0.7624677419662476,
        0.06377595663070679
      ],
      "plane_d": -3441.28662109375,
      "bbox_min": [
        -859.2266845703125,
        -3790.68359375,
        660.0
      ],
      "bbox_max": [
        -726.752685546875,
        -3730.0,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6607861518859863,
        -0.7483370900154114,
        0.05790644884109497
      ],
      "plane_d": -3397.280517578125,
      "bbox_min": [
        -859.2266845703125,
        -3788.740234375,
        660.0
      ],
      "bbox_max": [
        -792.70361328125,
        -3730.0,
        925.9322509765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8214666247367859,
        -0.2627931237220764,
        0.5060952305793762
      ],
      "plane_d": -1936.05078125,
      "bbox_min": [
        -1100.0,
        -4169.6982421875,
        1302.5999755859375
      ],
      "bbox_max": [
        -342.082275390625,
        -2670.834716796875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6356639862060547,
        -0.35781198740005493,
        0.6840335130691528
      ],
      "plane_d": -2381.548583984375,
      "bbox_min": [
        -1100.0,
        -4169.6982421875,
        1302.5999755859375
      ],
      "bbox_max": [
        -342.082275390625,
        -2670.834716796875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1656186729669571,
        0.7045361995697021,
        0.6900719404220581
      ],
      "plane_d": 1365.509765625,
      "bbox_min": [
        -1100.0,
        -4169.6982421875,
        1302.5999755859375
      ],
      "bbox_max": [
        -342.082275390625,
        -2670.834716796875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6734017729759216,
        -0.7359853386878967,
        0.06968268007040024
      ],
      "plane_d": -3378.893798828125,
      "bbox_min": [
        -1090.06982421875,
        -4169.6982421875,
        1302.5999755859375
      ],
      "bbox_max": [
        -701.50048828125,
        -3470.2734375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6569232940673828,
        -0.7521604299545288,
        0.05202310532331467
      ],
      "plane_d": -3396.388427734375,
      "bbox_min": [
        -897.137451171875,
        -3802.730224609375,
        1302.5999755859375
      ],
      "bbox_max": [
        -701.50048828125,
        -3646.800048828125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6437557935714722,
        -0.7623260021209717,
        0.06661495566368103
      ],
      "plane_d": -3444.360595703125,
      "bbox_min": [
        -897.137451171875,
        -3802.730224609375,
        1302.5999755859375
      ],
      "bbox_max": [
        -701.50048828125,
        -3646.800048828125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9773173928260803,
        0.18042781949043274,
        0.11089008301496506
      ],
      "plane_d": -170.76866149902344,
      "bbox_min": [
        -728.6499633789062,
        -3802.730224609375,
        1302.5999755859375
      ],
      "bbox_max": [
        -701.50048828125,
        -3790.68359375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.971863329410553,
        0.2277802973985672,
        0.05998194217681885
      ],
      "plane_d": 90.97808837890625,
      "bbox_min": [
        -703.2801513671875,
        -3802.730224609375,
        1529.0736083984375
      ],
      "bbox_max": [
        -701.50048828125,
        -3796.67138671875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.971863329410553,
        0.2277802973985672,
        0.05998194217681885
      ],
      "plane_d": 90.97808837890625,
      "bbox_min": [
        -951.4599609375,
        -4169.6982421875,
        1302.5999755859375
      ],
      "bbox_max": [
        -702.8775634765625,
        -3800.96044921875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9773173928260803,
        0.18042781949043274,
        0.11089008301496506
      ],
      "plane_d": -170.76866149902344,
      "bbox_min": [
        -951.4599609375,
        -4169.6982421875,
        1302.5999755859375
      ],
      "bbox_max": [
        -703.2801513671875,
        -3800.96044921875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.567858099937439,
        0.8212112188339233,
        0.05611976608633995
      ],
      "plane_d": 2804.5029296875,
      "bbox_min": [
        -951.4599609375,
        -4169.6982421875,
        1302.5999755859375
      ],
      "bbox_max": [
        -759.785888671875,
        -4038.2421875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5781539082527161,
        0.8130282759666443,
        0.06872465461492538
      ],
      "plane_d": 2744.22998046875,
      "bbox_min": [
        -951.4599609375,
        -4169.6982421875,
        1302.5999755859375
      ],
      "bbox_max": [
        -759.785888671875,
        -4045.35595703125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24675478041172028,
        -0.633362352848053,
        0.7334604859352112
      ],
      "plane_d": -2606.39794921875,
      "bbox_min": [
        -1100.0,
        -3646.800048828125,
        1302.5999755859375
      ],
      "bbox_max": [
        -342.082275390625,
        -2670.834716796875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1512952446937561,
        -0.7088976502418518,
        0.6888933181762695
      ],
      "plane_d": -2873.484375,
      "bbox_min": [
        -1100.0,
        -3017.20947265625,
        1302.5999755859375
      ],
      "bbox_max": [
        -1026.85400390625,
        -2955.145751953125,
        1371.78515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10619720071554184,
        -0.7439054846763611,
        0.6597930788993835
      ],
      "plane_d": -2987.148193359375,
      "bbox_min": [
        -1100.0,
        -3017.20947265625,
        1302.5999755859375
      ],
      "bbox_max": [
        -1026.85400390625,
        -2963.177978515625,
        1363.51953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3113660216331482,
        -0.6430392861366272,
        0.6996798515319824
      ],
      "plane_d": -2525.14501953125,
      "bbox_min": [
        -1100.0,
        -3646.800048828125,
        1302.5999755859375
      ],
      "bbox_max": [
        -342.082275390625,
        -2670.834716796875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1512952446937561,
        -0.7088976502418518,
        0.6888933181762695
      ],
      "plane_d": -2873.484375,
      "bbox_min": [
        -1100.0,
        -3006.767333984375,
        1302.5999755859375
      ],
      "bbox_max": [
        -1026.85400390625,
        -2856.87744140625,
        1472.906982421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.512399435043335,
        0.7244004011154175,
        0.4611842632293701
      ],
      "plane_d": 1486.495849609375,
      "bbox_min": [
        -873.099365234375,
        -3646.800048828125,
        1302.5999755859375
      ],
      "bbox_max": [
        -342.082275390625,
        -2670.834716796875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3404339551925659,
        0.7671160101890564,
        0.5437257885932922
      ],
      "plane_d": 1612.6265869140625,
      "bbox_min": [
        -704.468994140625,
        -3461.04345703125,
        1302.5999755859375
      ],
      "bbox_max": [
        -342.082275390625,
        -3253.36376953125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4902830421924591,
        0.7414035797119141,
        0.4581957757472992
      ],
      "plane_d": 1563.4337158203125,
      "bbox_min": [
        -704.468994140625,
        -3461.04345703125,
        1302.5999755859375
      ],
      "bbox_max": [
        -513.5322265625,
        -3253.36376953125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09165661036968231,
        -0.6677837371826172,
        0.7386906743049622
      ],
      "plane_d": -2995.730712890625,
      "bbox_min": [
        -855.087646484375,
        -2930.939453125,
        1302.5999755859375
      ],
      "bbox_max": [
        -511.1015625,
        -2670.834716796875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -7.739518537164258e-08,
        -0.6953417062759399,
        0.7186792492866516
      ],
      "plane_d": -2974.156005859375,
      "bbox_min": [
        -832.221435546875,
        -2930.939453125,
        1302.5999755859375
      ],
      "bbox_max": [
        -664.7411499023438,
        -2690.8427734375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4018848240375519,
        -0.6489609479904175,
        0.6460171937942505
      ],
      "plane_d": -3022.886474609375,
      "bbox_min": [
        -709.314697265625,
        -2911.618408203125,
        1340.847412109375
      ],
      "bbox_max": [
        -511.1015625,
        -2690.8427734375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48143571615219116,
        -0.5738243460655212,
        0.6625293493270874
      ],
      "plane_d": -2018.246337890625,
      "bbox_min": [
        -1760.0,
        -3203.987060546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -1167.873291015625,
        -2811.119384765625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20202520489692688,
        -0.8296098113059998,
        0.5205125212669373
      ],
      "plane_d": -2979.09912109375,
      "bbox_min": [
        -1760.0,
        -3203.987060546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -1411.0396728515625,
        -3013.635498046875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08832583576440811,
        -0.8090729713439941,
        0.5810332894325256
      ],
      "plane_d": -3184.2685546875,
      "bbox_min": [
        -1760.0,
        -3203.987060546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -1411.0396728515625,
        -3027.011962890625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.30647212266921997,
        -0.7587150931358337,
        0.5748271346092224
      ],
      "plane_d": -2690.01171875,
      "bbox_min": [
        -1509.300537109375,
        -3163.810791015625,
        1302.5999755859375
      ],
      "bbox_max": [
        -1411.0396728515625,
        -3106.068359375,
        1384.676025390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22038745880126953,
        -0.8264544606208801,
        0.5180755853652954
      ],
      "plane_d": -2934.9130859375,
      "bbox_min": [
        -1760.0,
        -3203.987060546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -1680.74951171875,
        -3037.23291015625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23221024870872498,
        -0.8293224573135376,
        0.5082348585128784
      ],
      "plane_d": -2908.64794921875,
      "bbox_min": [
        -1760.0,
        -3105.5673828125,
        1459.6031494140625
      ],
      "bbox_max": [
        -1680.74951171875,
        -3037.23291015625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10619720071554184,
        -0.7439054846763611,
        0.6597930788993835
      ],
      "plane_d": -2987.148193359375,
      "bbox_min": [
        -1305.776123046875,
        -3033.836669921875,
        1302.5999755859375
      ],
      "bbox_max": [
        -1167.873291015625,
        -2811.119384765625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1512952446937561,
        -0.7088976502418518,
        0.6888933181762695
      ],
      "plane_d": -2873.484375,
      "bbox_min": [
        -1305.776123046875,
        -2901.427490234375,
        1449.8204345703125
      ],
      "bbox_max": [
        -1167.873291015625,
        -2811.119384765625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.41471293568611145,
        -0.6906698942184448,
        0.5924426317214966
      ],
      "plane_d": -2347.342041015625,
      "bbox_min": [
        -1583.84765625,
        -3128.560791015625,
        1302.5999755859375
      ],
      "bbox_max": [
        -1100.0,
        -2789.423828125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.30647212266921997,
        -0.7587150931358337,
        0.5748271346092224
      ],
      "plane_d": -2690.01171875,
      "bbox_min": [
        -1583.84765625,
        -3128.560791015625,
        1302.5999755859375
      ],
      "bbox_max": [
        -1411.0396728515625,
        -3000.38232421875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20202520489692688,
        -0.8296098113059998,
        0.5205125212669373
      ],
      "plane_d": -2979.09912109375,
      "bbox_min": [
        -1583.84765625,
        -3027.011962890625,
        1501.2713623046875
      ],
      "bbox_max": [
        -1529.423828125,
        -3000.38232421875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10619720071554184,
        -0.7439054846763611,
        0.6597930788993835
      ],
      "plane_d": -2987.148193359375,
      "bbox_min": [
        -1216.4732666015625,
        -3033.836669921875,
        1302.5999755859375
      ],
      "bbox_max": [
        -1100.0,
        -2789.423828125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3113660216331482,
        -0.6430392861366272,
        0.6996798515319824
      ],
      "plane_d": -2525.14501953125,
      "bbox_min": [
        -1126.625732421875,
        -2856.87744140625,
        1472.906982421875
      ],
      "bbox_max": [
        -1100.0,
        -2789.423828125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5655401349067688,
        0.7059893012046814,
        0.4263138175010681
      ],
      "plane_d": 2665.9970703125,
      "bbox_min": [
        -1760.0,
        -3646.800048828125,
        1302.5999755859375
      ],
      "bbox_max": [
        -1148.67041015625,
        -3382.0,
        1574.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4469253122806549,
        0.8841609358787537,
        0.13607771694660187
      ],
      "plane_d": 3523.403076171875,
      "bbox_min": [
        -1760.0,
        -3646.800048828125,
        1302.5999755859375
      ],
      "bbox_max": [
        -1148.67041015625,
        -3382.0,
        1574.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34272027015686035,
        0.9365004897117615,
        0.07422665506601334
      ],
      "plane_d": 2554.111572265625,
      "bbox_min": [
        -1727.3770751953125,
        -3646.800048828125,
        1302.5999755859375
      ],
      "bbox_max": [
        -1148.67041015625,
        -3382.0,
        1574.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6396912932395935,
        0.7676994204521179,
        0.037849828600883484
      ],
      "plane_d": 3485.137451171875,
      "bbox_min": [
        -1631.7432861328125,
        -3646.800048828125,
        1302.5999755859375
      ],
      "bbox_max": [
        -1148.67041015625,
        -3426.104248046875,
        1574.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.030036021023988724,
        0.9266842007637024,
        0.3746386170387268
      ],
      "plane_d": 2593.50927734375,
      "bbox_min": [
        -1631.7432861328125,
        -3542.5,
        1302.5999755859375
      ],
      "bbox_max": [
        -1523.64404296875,
        -3426.104248046875,
        1574.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3441.5,
      "bbox_min": [
        -1624.5,
        -3542.5,
        1302.5999755859375
      ],
      "bbox_max": [
        -1544.5638427734375,
        -3426.5,
        1562.79541015625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.10651867091655731,
        0.9057281017303467,
        0.41025659441947937
      ],
      "plane_d": 2347.23828125,
      "bbox_min": [
        -1615.0,
        -3542.5,
        1459.0
      ],
      "bbox_max": [
        -1544.5638427734375,
        -3441.5,
        1562.79541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3450.0,
      "bbox_min": [
        -1615.0,
        -3542.5,
        1459.0
      ],
      "bbox_max": [
        -1559.0,
        -3441.5,
        1505.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1485.0,
      "bbox_min": [
        -1571.8751220703125,
        -3450.0,
        1485.0
      ],
      "bbox_max": [
        -1559.0,
        -3449.582763671875,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1482.5999755859375,
      "bbox_min": [
        -1615.0,
        -3542.5,
        1482.5999755859375
      ],
      "bbox_max": [
        -1572.5,
        -3450.3603515625,
        1505.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3479.5,
      "bbox_min": [
        -1615.0,
        -3542.5,
        1482.5999755859375
      ],
      "bbox_max": [
        -1572.5,
        -3450.3603515625,
        1505.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1485.0,
      "bbox_min": [
        -1607.0,
        -3479.5,
        1484.6571044921875
      ],
      "bbox_max": [
        -1583.0,
        -3450.3603515625,
        1500.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1589.9000244140625,
      "bbox_min": [
        -1589.9000244140625,
        -3479.5,
        1484.6571044921875
      ],
      "bbox_max": [
        -1589.9000244140625,
        -3479.0,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284767508506775,
        0.0,
        -0.371390700340271
      ],
      "plane_d": 2043.577392578125,
      "bbox_min": [
        -1607.0,
        -3479.5,
        1485.0
      ],
      "bbox_max": [
        -1583.0,
        -3450.3603515625,
        1500.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.9284767508506775,
        0.0,
        -0.371390700340271
      ],
      "plane_d": -918.2635498046875,
      "bbox_min": [
        -1607.0,
        -3479.5,
        1485.0
      ],
      "bbox_max": [
        -1583.0,
        -3450.3603515625,
        1500.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1500.0,
      "bbox_min": [
        -1607.0,
        -3479.5,
        1485.0
      ],
      "bbox_max": [
        -1583.0,
        -3457.8603515625,
        1500.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3478.0,
      "bbox_min": [
        -1607.0,
        -3479.5,
        1485.0
      ],
      "bbox_max": [
        -1583.0,
        -3478.0,
        1500.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1495.0,
      "bbox_min": [
        -1600.0,
        -3479.5,
        1485.0
      ],
      "bbox_max": [
        -1589.5,
        -3478.0,
        1495.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1600.0,
      "bbox_min": [
        -1600.0,
        -3479.5,
        1485.0
      ],
      "bbox_max": [
        -1589.5,
        -3478.0,
        1495.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1589.5,
      "bbox_min": [
        -1589.5,
        -3479.5,
        1485.0
      ],
      "bbox_max": [
        -1589.5,
        -3478.0,
        1495.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9131380319595337,
        -0.0,
        -0.4076504707336426
      ],
      "plane_d": -833.809814453125,
      "bbox_min": [
        -1615.0,
        -3542.5,
        1482.5999755859375
      ],
      "bbox_max": [
        -1572.5,
        -3479.5,
        1505.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.23337295651435852,
        0.0,
        -0.9723873138427734
      ],
      "plane_d": 1083.8228759765625,
      "bbox_min": [
        -1582.767822265625,
        -3542.5,
        1487.5
      ],
      "bbox_max": [
        -1572.5,
        -3525.5,
        1500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1500.0,
      "bbox_min": [
        -1582.767822265625,
        -3526.0,
        1499.5
      ],
      "bbox_max": [
        -1582.2000732421875,
        -3525.5,
        1500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3525.5,
      "bbox_min": [
        -1582.767822265625,
        -3526.0,
        1499.5
      ],
      "bbox_max": [
        -1582.2000732421875,
        -3525.5,
        1500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1499.5,
      "bbox_min": [
        -1582.5445556640625,
        -3526.0,
        1499.5
      ],
      "bbox_max": [
        -1582.2000732421875,
        -3525.5,
        1499.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1961161345243454,
        0.0,
        0.9805806875228882
      ],
      "plane_d": -1150.2210693359375,
      "bbox_min": [
        -1580.0,
        -3542.5,
        1487.5
      ],
      "bbox_max": [
        -1572.5,
        -3535.0,
        1493.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3535.0,
      "bbox_min": [
        -1580.0,
        -3542.5,
        1487.5
      ],
      "bbox_max": [
        -1572.5,
        -3535.0,
        1493.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3542.5,
      "bbox_min": [
        -1580.0,
        -3542.5,
        1487.5
      ],
      "bbox_max": [
        -1572.5,
        -3542.5,
        1493.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9131380319595337,
        0.0,
        -0.4076504707336426
      ],
      "plane_d": 2079.1005859375,
      "bbox_min": [
        -1615.0,
        -3542.5,
        1482.5999755859375
      ],
      "bbox_max": [
        -1575.0,
        -3479.5,
        1505.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1500.0,
      "bbox_min": [
        -1607.7999267578125,
        -3526.0,
        1499.5
      ],
      "bbox_max": [
        -1607.2320556640625,
        -3525.5,
        1500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3525.5,
      "bbox_min": [
        -1607.7999267578125,
        -3526.0,
        1499.5
      ],
      "bbox_max": [
        -1607.2320556640625,
        -3525.5,
        1500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1499.5,
      "bbox_min": [
        -1607.7999267578125,
        -3526.0,
        1499.5
      ],
      "bbox_max": [
        -1607.45556640625,
        -3525.5,
        1499.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3526.0,
      "bbox_min": [
        -1615.0,
        -3542.5,
        1482.5999755859375
      ],
      "bbox_max": [
        -1575.0,
        -3479.5,
        1505.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1495.0,
      "bbox_min": [
        -1600.0,
        -3542.5,
        1482.5999755859375
      ],
      "bbox_max": [
        -1577.6470947265625,
        -3526.0,
        1495.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3535.0,
      "bbox_min": [
        -1600.0,
        -3542.5,
        1482.5999755859375
      ],
      "bbox_max": [
        -1577.6470947265625,
        -3526.0,
        1495.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9807887673377991,
        0.19507324695587158,
        -0.0
      ],
      "plane_d": 2249.734375,
      "bbox_min": [
        -1592.5,
        -3535.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1583.5,
        -3526.0,
        1495.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1494.4000244140625,
      "bbox_min": [
        -1592.5,
        -3535.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1583.5,
        -3526.0,
        1495.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807926416397095,
        -0.19505374133586884,
        0.0
      ],
      "plane_d": -2244.0712890625,
      "bbox_min": [
        -1591.1820068359375,
        -3535.0,
        1494.4000244140625
      ],
      "bbox_max": [
        -1584.8179931640625,
        -3529.181884765625,
        1495.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5557108521461487,
        -0.8313754796981812,
        0.00039633322739973664
      ],
      "plane_d": -3818.904541015625,
      "bbox_min": [
        -1591.1820068359375,
        -3535.0,
        1494.4000244140625
      ],
      "bbox_max": [
        -1586.0,
        -3529.181884765625,
        1495.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.1950865387916565,
        -0.9807860851287842,
        0.0
      ],
      "plane_d": -3152.867919921875,
      "bbox_min": [
        -1588.0,
        -3530.5,
        1494.4000244140625
      ],
      "bbox_max": [
        -1586.0,
        -3529.9716796875,
        1495.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1590.0,
      "bbox_min": [
        -1590.0,
        -3535.0,
        1494.4000244140625
      ],
      "bbox_max": [
        -1590.0,
        -3529.9716796875,
        1495.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807926416397095,
        -0.19505374133586884,
        0.0
      ],
      "plane_d": -2244.0712890625,
      "bbox_min": [
        -1592.157470703125,
        -3535.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1583.5,
        -3526.0,
        1494.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807887673377991,
        0.19507324695587158,
        0.0
      ],
      "plane_d": -865.2506713867188,
      "bbox_min": [
        -1586.0,
        -3529.9716796875,
        1482.5999755859375
      ],
      "bbox_max": [
        -1583.5,
        -3526.0,
        1494.4000244140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8314401507377625,
        0.5556144714355469,
        0.0
      ],
      "plane_d": 643.1832275390625,
      "bbox_min": [
        -1586.0,
        -3529.9716796875,
        1482.5999755859375
      ],
      "bbox_max": [
        -1583.842529296875,
        -3527.72216796875,
        1494.4000244140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5555983185768127,
        0.8314509391784668,
        0.0
      ],
      "plane_d": 2053.8193359375,
      "bbox_min": [
        -1586.0,
        -3529.9716796875,
        1482.5999755859375
      ],
      "bbox_max": [
        -1584.8179931640625,
        -3529.181884765625,
        1494.4000244140625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.5555983185768127,
        0.8314509391784668,
        -0.0
      ],
      "plane_d": 3818.399658203125,
      "bbox_min": [
        -1591.1820068359375,
        -3529.9716796875,
        1482.5999755859375
      ],
      "bbox_max": [
        -1590.0,
        -3529.181884765625,
        1494.4000244140625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1490.0,
      "bbox_min": [
        -1590.0,
        -3535.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1585.0,
        -3529.9716796875,
        1490.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.1950865387916565,
        0.9807860851287842,
        -0.0
      ],
      "plane_d": 3772.462646484375,
      "bbox_min": [
        -1590.0,
        -3530.5,
        1482.5999755859375
      ],
      "bbox_max": [
        -1586.0,
        -3529.9716796875,
        1490.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.1950865387916565,
        0.9807860851287842,
        0.0
      ],
      "plane_d": 3152.867919921875,
      "bbox_min": [
        -1590.0,
        -3530.5,
        1482.5999755859375
      ],
      "bbox_max": [
        -1586.0,
        -3529.9716796875,
        1490.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5555983185768127,
        0.8314509391784668,
        -0.0
      ],
      "plane_d": 3818.399658203125,
      "bbox_min": [
        -1590.0,
        -3530.157470703125,
        1482.5999755859375
      ],
      "bbox_max": [
        -1586.0,
        -3529.9716796875,
        1490.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5555983185768127,
        0.8314509391784668,
        0.0
      ],
      "plane_d": 2053.8193359375,
      "bbox_min": [
        -1586.2779541015625,
        -3530.157470703125,
        1482.5999755859375
      ],
      "bbox_max": [
        -1586.0,
        -3529.9716796875,
        1490.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3542.5,
      "bbox_min": [
        -1600.0,
        -3542.5,
        1488.5294189453125
      ],
      "bbox_max": [
        -1577.6470947265625,
        -3535.0,
        1495.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1490.0,
      "bbox_min": [
        -1600.0,
        -3542.5,
        1488.5294189453125
      ],
      "bbox_max": [
        -1577.6470947265625,
        -3535.0,
        1495.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.1961161345243454,
        0.0,
        0.9805806875228882
      ],
      "plane_d": -1150.2210693359375,
      "bbox_min": [
        -1585.0,
        -3542.5,
        1488.5294189453125
      ],
      "bbox_max": [
        -1577.6470947265625,
        -3535.0,
        1490.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.23337295651435852,
        0.0,
        -0.9723873138427734
      ],
      "plane_d": 1083.8228759765625,
      "bbox_min": [
        -1585.0,
        -3542.5,
        1493.800048828125
      ],
      "bbox_max": [
        -1580.0,
        -3535.0,
        1495.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3514.0,
      "bbox_min": [
        -1615.0,
        -3526.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1575.0,
        -3479.5,
        1505.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3518.0,
      "bbox_min": [
        -1615.0,
        -3526.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1575.0,
        -3514.0,
        1505.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9186536073684692,
        0.0,
        -0.39506393671035767
      ],
      "plane_d": -863.1574096679688,
      "bbox_min": [
        -1612.8231201171875,
        -3518.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1577.1768798828125,
        -3514.0,
        1503.3221435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9186536073684692,
        0.0,
        -0.39506393671035767
      ],
      "plane_d": 2067.34765625,
      "bbox_min": [
        -1612.8231201171875,
        -3518.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1586.08837890625,
        -3514.0,
        1503.3221435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1503.3221435546875,
      "bbox_min": [
        -1603.91162109375,
        -3518.0,
        1503.3221435546875
      ],
      "bbox_max": [
        -1586.08837890625,
        -3514.0,
        1503.3221435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1505.0,
      "bbox_min": [
        -1607.800048828125,
        -3526.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1582.199951171875,
        -3518.0,
        1505.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807823300361633,
        0.19510522484779358,
        0.0
      ],
      "plane_d": -874.4451904296875,
      "bbox_min": [
        -1607.800048828125,
        -3526.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1582.199951171875,
        -3521.0,
        1505.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.831501305103302,
        0.5555229783058167,
        0.0
      ],
      "plane_d": 633.446044921875,
      "bbox_min": [
        -1593.0,
        -3526.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1582.199951171875,
        -3521.0,
        1505.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555341243743896,
        0.8314937949180603,
        0.0
      ],
      "plane_d": 3809.13134765625,
      "bbox_min": [
        -1593.0,
        -3526.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1582.199951171875,
        -3521.0,
        1505.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.5554838180541992,
        0.8315272927284241,
        0.0
      ],
      "plane_d": 2044.952880859375,
      "bbox_min": [
        -1593.0,
        -3526.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1582.199951171875,
        -3521.0,
        1505.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1494.9998779296875,
      "bbox_min": [
        -1593.0,
        -3526.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1582.199951171875,
        -3521.0,
        1505.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807823300361633,
        0.19510522484779358,
        -0.0
      ],
      "plane_d": 2240.51953125,
      "bbox_min": [
        -1592.5,
        -3526.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1582.199951171875,
        -3521.0,
        1495.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.831501305103302,
        0.5555229783058167,
        -0.0
      ],
      "plane_d": 3274.294189453125,
      "bbox_min": [
        -1592.5,
        -3526.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1583.380615234375,
        -3521.0,
        1495.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807887673377991,
        -0.19507324695587158,
        0.0
      ],
      "plane_d": -2240.9072265625,
      "bbox_min": [
        -1592.5,
        -3526.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1583.5,
        -3521.0,
        1495.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9807887673377991,
        -0.19507324695587158,
        0.0
      ],
      "plane_d": 874.077880859375,
      "bbox_min": [
        -1592.5,
        -3526.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1583.5,
        -3521.0,
        1495.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8314401507377625,
        -0.5556144714355469,
        0.0
      ],
      "plane_d": -3275.010009765625,
      "bbox_min": [
        -1592.5,
        -3526.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1583.5,
        -3521.0,
        1495.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.1951693594455719,
        0.9807695150375366,
        0.0
      ],
      "plane_d": 3763.21826171875,
      "bbox_min": [
        -1592.5,
        -3526.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1583.5,
        -3521.0,
        1495.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.19503216445446014,
        0.9807968139648438,
        0.0
      ],
      "plane_d": 3143.674560546875,
      "bbox_min": [
        -1592.5,
        -3526.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1583.5,
        -3521.0,
        1495.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1494.4000244140625,
      "bbox_min": [
        -1592.5,
        -3526.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1583.5,
        -3521.0,
        1494.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314401507377625,
        -0.5556144714355469,
        0.0
      ],
      "plane_d": -634.3560791015625,
      "bbox_min": [
        -1592.157470703125,
        -3524.27783203125,
        1482.5999755859375
      ],
      "bbox_max": [
        -1584.8179931640625,
        -3521.0,
        1494.4000244140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.998618483543396,
        -0.0,
        0.05254536494612694
      ],
      "plane_d": 1510.188720703125,
      "bbox_min": [
        -1590.5,
        -3521.79736328125,
        1486.030517578125
      ],
      "bbox_max": [
        -1590.4700927734375,
        -3521.75244140625,
        1486.8248291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.99123215675354,
        0.0,
        -0.13213202357292175
      ],
      "plane_d": 1772.982177734375,
      "bbox_min": [
        -1590.5,
        -3521.79736328125,
        1486.5999755859375
      ],
      "bbox_max": [
        -1590.4700927734375,
        -3521.75244140625,
        1486.8248291015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8411626219749451,
        -0.0,
        0.5407822132110596
      ],
      "plane_d": 534.8856811523438,
      "bbox_min": [
        -1591.1820068359375,
        -3522.818115234375,
        1482.5999755859375
      ],
      "bbox_max": [
        -1584.8179931640625,
        -3521.0,
        1494.4000244140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5556613802909851,
        -0.831408679485321,
        0.0
      ],
      "plane_d": -2044.7431640625,
      "bbox_min": [
        -1591.1820068359375,
        -3522.818115234375,
        1482.5999755859375
      ],
      "bbox_max": [
        -1589.0499267578125,
        -3521.708740234375,
        1485.91650390625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.19518285989761353,
        -0.9807668924331665,
        0.0
      ],
      "plane_d": -3143.81982421875,
      "bbox_min": [
        -1589.7220458984375,
        -3521.842529296875,
        1482.5999755859375
      ],
      "bbox_max": [
        -1589.0499267578125,
        -3521.708740234375,
        1483.6453857421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5555983185768127,
        -0.8314509391784668,
        0.0
      ],
      "plane_d": -2044.992431640625,
      "bbox_min": [
        -1591.1820068359375,
        -3522.818115234375,
        1482.5999755859375
      ],
      "bbox_max": [
        -1584.8179931640625,
        -3521.0,
        1494.4000244140625
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.645942211151123,
        0.0,
        -0.7633862495422363
      ],
      "plane_d": 2163.23681640625,
      "bbox_min": [
        -1590.5,
        -3522.3623046875,
        1483.13134765625
      ],
      "bbox_max": [
        -1588.6566162109375,
        -3521.130615234375,
        1489.199951171875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.19614683091640472,
        0.0,
        0.9805746078491211
      ],
      "plane_d": -1142.7109375,
      "bbox_min": [
        -1589.5,
        -3521.694091796875,
        1483.13134765625
      ],
      "bbox_max": [
        -1588.6566162109375,
        -3521.130615234375,
        1489.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07122974097728729,
        0.0,
        -0.997459888458252
      ],
      "plane_d": 1372.233154296875,
      "bbox_min": [
        -1589.0,
        -3521.360107421875,
        1489.1754150390625
      ],
      "bbox_max": [
        -1588.6566162109375,
        -3521.130615234375,
        1489.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1950865387916565,
        -0.9807860851287842,
        0.0
      ],
      "plane_d": -3144.040771484375,
      "bbox_min": [
        -1589.7220458984375,
        -3522.818115234375,
        1482.5999755859375
      ],
      "bbox_max": [
        -1584.8179931640625,
        -3521.0,
        1494.4000244140625
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.07122974097728729,
        0.0,
        -0.997459888458252
      ],
      "plane_d": 1372.233154296875,
      "bbox_min": [
        -1589.7220458984375,
        -3521.842529296875,
        1483.0
      ],
      "bbox_max": [
        -1586.7427978515625,
        -3521.0,
        1489.199951171875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.29409217834472656,
        0.0,
        0.955777108669281
      ],
      "plane_d": -1884.435791015625,
      "bbox_min": [
        -1589.7220458984375,
        -3521.842529296875,
        1483.0
      ],
      "bbox_max": [
        -1586.7427978515625,
        -3521.0,
        1489.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.645942211151123,
        0.0,
        -0.7633862495422363
      ],
      "plane_d": 2163.23681640625,
      "bbox_min": [
        -1589.7220458984375,
        -3521.842529296875,
        1488.5889892578125
      ],
      "bbox_max": [
        -1586.7427978515625,
        -3521.07958984375,
        1489.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34176817536354065,
        0.0,
        -0.9397842884063721
      ],
      "plane_d": 856.8416137695312,
      "bbox_min": [
        -1587.5999755859375,
        -3521.420654296875,
        1488.7882080078125
      ],
      "bbox_max": [
        -1586.7427978515625,
        -3521.07958984375,
        1489.0999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.80877286195755,
        0.0,
        0.5881211161613464
      ],
      "plane_d": -2155.69873046875,
      "bbox_min": [
        -1588.0,
        -3522.818115234375,
        1482.5999755859375
      ],
      "bbox_max": [
        -1584.8179931640625,
        -3521.25,
        1494.4000244140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5556027889251709,
        -0.8314478397369385,
        0.0
      ],
      "plane_d": -3809.56884765625,
      "bbox_min": [
        -1587.2816162109375,
        -3522.818115234375,
        1482.5999755859375
      ],
      "bbox_max": [
        -1584.8179931640625,
        -3521.642822265625,
        1485.9881591796875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.29409217834472656,
        0.0,
        0.955777108669281
      ],
      "plane_d": -1884.435791015625,
      "bbox_min": [
        -1588.0,
        -3522.818115234375,
        1482.5999755859375
      ],
      "bbox_max": [
        -1584.8179931640625,
        -3521.25,
        1494.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1950865387916565,
        -0.9807860851287842,
        0.0
      ],
      "plane_d": -3763.635498046875,
      "bbox_min": [
        -1588.0,
        -3521.758544921875,
        1482.5999755859375
      ],
      "bbox_max": [
        -1586.699951171875,
        -3521.5,
        1483.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555983185768127,
        -0.8314509391784668,
        0.0
      ],
      "plane_d": -3809.57275390625,
      "bbox_min": [
        -1588.0,
        -3522.818115234375,
        1484.5
      ],
      "bbox_max": [
        -1584.8179931640625,
        -3521.25,
        1494.4000244140625
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.9079519510269165,
        1.942604831128847e-05,
        -0.41907426714897156
      ],
      "plane_d": -816.5216064453125,
      "bbox_min": [
        -1587.068115234375,
        -3522.228759765625,
        1486.199951171875
      ],
      "bbox_max": [
        -1585.699951171875,
        -3521.25,
        1488.906494140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.34176817536354065,
        0.0,
        -0.9397842884063721
      ],
      "plane_d": 856.8416137695312,
      "bbox_min": [
        -1587.068115234375,
        -3521.694091796875,
        1488.699951171875
      ],
      "bbox_max": [
        -1586.5,
        -3521.25,
        1488.906494140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1950865387916565,
        -0.9807860851287842,
        0.0
      ],
      "plane_d": -3763.635498046875,
      "bbox_min": [
        -1588.0,
        -3521.842529296875,
        1488.2188720703125
      ],
      "bbox_max": [
        -1586.2779541015625,
        -3521.314697265625,
        1494.4000244140625
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.07122542709112167,
        0.0,
        -0.9974603056907654
      ],
      "plane_d": 1372.2406005859375,
      "bbox_min": [
        -1588.0,
        -3521.57958984375,
        1489.0999755859375
      ],
      "bbox_max": [
        -1587.5999755859375,
        -3521.420654296875,
        1489.1285400390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9785451292991638,
        -0.2060326635837555,
        0.0
      ],
      "plane_d": 822.17431640625,
      "bbox_min": [
        -1583.3779296875,
        -3526.0,
        1489.0
      ],
      "bbox_max": [
        -1582.199951171875,
        -3524.10009765625,
        1494.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1492.0,
      "bbox_min": [
        -1583.3779296875,
        -3526.0,
        1489.0
      ],
      "bbox_max": [
        -1582.199951171875,
        -3524.10009765625,
        1494.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3524.10009765625,
      "bbox_min": [
        -1583.3779296875,
        -3526.0,
        1492.0
      ],
      "bbox_max": [
        -1582.199951171875,
        -3524.10009765625,
        1494.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1494.0,
      "bbox_min": [
        -1583.3717041015625,
        -3526.0,
        1494.0
      ],
      "bbox_max": [
        -1582.199951171875,
        -3524.10009765625,
        1494.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3524.10009765625,
      "bbox_min": [
        -1583.3779296875,
        -3526.0,
        1489.0
      ],
      "bbox_max": [
        -1582.199951171875,
        -3524.10009765625,
        1491.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1491.0,
      "bbox_min": [
        -1583.3717041015625,
        -3526.0,
        1491.0
      ],
      "bbox_max": [
        -1582.199951171875,
        -3524.10009765625,
        1491.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9785451292991638,
        -0.2060326635837555,
        0.0
      ],
      "plane_d": 822.17431640625,
      "bbox_min": [
        -1583.3779296875,
        -3526.0,
        1483.0
      ],
      "bbox_max": [
        -1582.199951171875,
        -3524.10009765625,
        1488.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1486.0,
      "bbox_min": [
        -1583.3779296875,
        -3526.0,
        1483.0
      ],
      "bbox_max": [
        -1582.199951171875,
        -3524.10009765625,
        1488.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3524.10009765625,
      "bbox_min": [
        -1583.3779296875,
        -3526.0,
        1486.0
      ],
      "bbox_max": [
        -1582.199951171875,
        -3524.10009765625,
        1488.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1488.0,
      "bbox_min": [
        -1583.3717041015625,
        -3526.0,
        1488.0
      ],
      "bbox_max": [
        -1582.199951171875,
        -3524.10009765625,
        1488.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3524.10009765625,
      "bbox_min": [
        -1583.3779296875,
        -3526.0,
        1483.0
      ],
      "bbox_max": [
        -1582.199951171875,
        -3524.10009765625,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1485.0,
      "bbox_min": [
        -1583.3717041015625,
        -3526.0,
        1485.0
      ],
      "bbox_max": [
        -1582.199951171875,
        -3524.10009765625,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1586.5,
      "bbox_min": [
        -1589.5,
        -3526.0,
        1495.0
      ],
      "bbox_max": [
        -1582.5445556640625,
        -3522.5,
        1505.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1497.5,
      "bbox_min": [
        -1589.5,
        -3526.0,
        1495.0
      ],
      "bbox_max": [
        -1586.5,
        -3522.5,
        1505.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9284766912460327,
        0.3713906705379486
      ],
      "plane_d": 2715.330078125,
      "bbox_min": [
        -1589.5,
        -3526.0,
        1495.0
      ],
      "bbox_max": [
        -1586.5,
        -3522.5,
        1497.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1589.4998779296875,
      "bbox_min": [
        -1589.5,
        -3526.0,
        1495.0
      ],
      "bbox_max": [
        -1589.5,
        -3522.5,
        1497.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3524.5,
      "bbox_min": [
        -1589.0,
        -3526.0,
        1497.5
      ],
      "bbox_max": [
        -1587.0,
        -3524.5,
        1505.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1587.0,
      "bbox_min": [
        -1589.0,
        -3526.0,
        1497.5
      ],
      "bbox_max": [
        -1587.0,
        -3524.5,
        1505.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1589.0,
      "bbox_min": [
        -1589.0,
        -3526.0,
        1497.5
      ],
      "bbox_max": [
        -1589.0,
        -3524.5,
        1505.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3525.5,
      "bbox_min": [
        -1585.5,
        -3526.0,
        1495.0
      ],
      "bbox_max": [
        -1582.5445556640625,
        -3525.5,
        1500.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1585.5,
      "bbox_min": [
        -1585.5,
        -3526.0,
        1495.0
      ],
      "bbox_max": [
        -1582.5445556640625,
        -3525.5,
        1500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1499.5,
      "bbox_min": [
        -1585.5,
        -3526.0,
        1495.0
      ],
      "bbox_max": [
        -1582.5445556640625,
        -3525.5,
        1500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1500.0,
      "bbox_min": [
        -1585.300048828125,
        -3526.0,
        1499.4998779296875
      ],
      "bbox_max": [
        -1582.767822265625,
        -3525.5,
        1500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4473009705543518,
        0.0,
        0.8943836092948914
      ],
      "plane_d": -2050.234375,
      "bbox_min": [
        -1585.300048828125,
        -3526.0,
        1499.4998779296875
      ],
      "bbox_max": [
        -1584.300048828125,
        -3525.5,
        1500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1585.0,
      "bbox_min": [
        -1585.5,
        -3526.0,
        1495.0
      ],
      "bbox_max": [
        -1584.300048828125,
        -3525.5,
        1499.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9805852770805359,
        0.0,
        0.1960930973291397
      ],
      "plane_d": -1848.5634765625,
      "bbox_min": [
        -1585.5,
        -3526.0,
        1498.5
      ],
      "bbox_max": [
        -1585.300048828125,
        -3525.5,
        1499.4998779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9899529218673706,
        0.0,
        -0.14139717817306519
      ],
      "plane_d": 1780.9591064453125,
      "bbox_min": [
        -1585.0,
        -3526.0,
        1498.5
      ],
      "bbox_max": [
        -1584.300048828125,
        -3525.5,
        1499.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4472863972187042,
        0.0,
        -0.8943908214569092
      ],
      "plane_d": 2049.77490234375,
      "bbox_min": [
        -1584.9000244140625,
        -3526.0,
        1499.199951171875
      ],
      "bbox_max": [
        -1584.300048828125,
        -3525.5,
        1499.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807823300361633,
        0.19510522484779358,
        0.0
      ],
      "plane_d": 2254.25048828125,
      "bbox_min": [
        -1607.800048828125,
        -3526.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1592.6220703125,
        -3521.0,
        1505.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.831501305103302,
        0.5555229783058167,
        0.0
      ],
      "plane_d": 3285.935302734375,
      "bbox_min": [
        -1607.800048828125,
        -3526.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1597.0,
        -3521.0,
        1505.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19509325921535492,
        0.9807847142219543,
        0.0
      ],
      "plane_d": 3765.88232421875,
      "bbox_min": [
        -1607.800048828125,
        -3526.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1597.0,
        -3521.0,
        1505.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509325921535492,
        0.9807847142219543,
        0.0
      ],
      "plane_d": 3140.8037109375,
      "bbox_min": [
        -1607.800048828125,
        -3526.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1597.0,
        -3521.0,
        1505.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555374622344971,
        0.8314915299415588,
        0.0
      ],
      "plane_d": 3816.906005859375,
      "bbox_min": [
        -1607.800048828125,
        -3526.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1597.0,
        -3521.0,
        1505.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5555374622344971,
        0.8314915299415588,
        0.0
      ],
      "plane_d": 2036.964111328125,
      "bbox_min": [
        -1607.800048828125,
        -3526.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1597.0,
        -3521.0,
        1505.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1495.0,
      "bbox_min": [
        -1607.800048828125,
        -3526.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1597.0,
        -3521.0,
        1505.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9807823300361633,
        0.19510522484779358,
        0.0
      ],
      "plane_d": -888.1761474609375,
      "bbox_min": [
        -1607.800048828125,
        -3526.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1605.5355224609375,
        -3522.46435546875,
        1495.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.831501305103302,
        0.5555229783058167,
        0.0
      ],
      "plane_d": 621.8050537109375,
      "bbox_min": [
        -1606.619384765625,
        -3524.086669921875,
        1482.5999755859375
      ],
      "bbox_max": [
        -1605.5355224609375,
        -3522.46435546875,
        1495.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9785451292991638,
        -0.2060326635837555,
        0.0
      ],
      "plane_d": -2299.384765625,
      "bbox_min": [
        -1607.800048828125,
        -3526.0,
        1483.0
      ],
      "bbox_max": [
        -1606.6220703125,
        -3524.10009765625,
        1494.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1489.0,
      "bbox_min": [
        -1607.800048828125,
        -3526.0,
        1483.0
      ],
      "bbox_max": [
        -1606.6220703125,
        -3524.10009765625,
        1494.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1492.0,
      "bbox_min": [
        -1607.800048828125,
        -3526.0,
        1489.0
      ],
      "bbox_max": [
        -1606.6220703125,
        -3524.10009765625,
        1494.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3524.10009765625,
      "bbox_min": [
        -1607.800048828125,
        -3526.0,
        1492.0
      ],
      "bbox_max": [
        -1606.6220703125,
        -3524.10009765625,
        1494.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1494.0,
      "bbox_min": [
        -1607.800048828125,
        -3526.0,
        1494.0
      ],
      "bbox_max": [
        -1606.6282958984375,
        -3524.10009765625,
        1494.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3524.10009765625,
      "bbox_min": [
        -1607.800048828125,
        -3526.0,
        1489.0
      ],
      "bbox_max": [
        -1606.6220703125,
        -3524.10009765625,
        1491.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1491.0,
      "bbox_min": [
        -1607.800048828125,
        -3526.0,
        1491.0
      ],
      "bbox_max": [
        -1606.6282958984375,
        -3524.10009765625,
        1491.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3524.10009765625,
      "bbox_min": [
        -1607.800048828125,
        -3526.0,
        1483.0
      ],
      "bbox_max": [
        -1606.6220703125,
        -3524.10009765625,
        1488.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1488.0,
      "bbox_min": [
        -1607.800048828125,
        -3526.0,
        1485.0
      ],
      "bbox_max": [
        -1606.6282958984375,
        -3524.10009765625,
        1488.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1485.0,
      "bbox_min": [
        -1607.800048828125,
        -3526.0,
        1485.0
      ],
      "bbox_max": [
        -1606.6282958984375,
        -3524.10009765625,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1603.4998779296875,
      "bbox_min": [
        -1607.45556640625,
        -3526.0,
        1495.0
      ],
      "bbox_max": [
        -1600.5,
        -3522.5,
        1505.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1497.5,
      "bbox_min": [
        -1603.5,
        -3526.0,
        1495.0
      ],
      "bbox_max": [
        -1600.5,
        -3522.5,
        1505.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9284766912460327,
        0.3713906705379486
      ],
      "plane_d": 2715.330078125,
      "bbox_min": [
        -1603.5,
        -3526.0,
        1495.0
      ],
      "bbox_max": [
        -1600.5,
        -3522.5,
        1497.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1600.5,
      "bbox_min": [
        -1600.5,
        -3526.0,
        1495.0
      ],
      "bbox_max": [
        -1600.5,
        -3522.5,
        1497.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3524.5,
      "bbox_min": [
        -1603.0,
        -3526.0,
        1497.5
      ],
      "bbox_max": [
        -1601.0,
        -3524.5,
        1505.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1603.0,
      "bbox_min": [
        -1603.0,
        -3526.0,
        1497.5
      ],
      "bbox_max": [
        -1601.0,
        -3524.5,
        1505.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1601.0,
      "bbox_min": [
        -1601.0,
        -3526.0,
        1497.5
      ],
      "bbox_max": [
        -1601.0,
        -3524.5,
        1505.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3525.5,
      "bbox_min": [
        -1607.45556640625,
        -3526.0,
        1495.0
      ],
      "bbox_max": [
        -1604.5,
        -3525.5,
        1500.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1604.5,
      "bbox_min": [
        -1607.45556640625,
        -3526.0,
        1495.0
      ],
      "bbox_max": [
        -1604.5,
        -3525.5,
        1500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1499.5,
      "bbox_min": [
        -1607.45556640625,
        -3526.0,
        1495.0
      ],
      "bbox_max": [
        -1604.5,
        -3525.5,
        1500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1500.0,
      "bbox_min": [
        -1607.2320556640625,
        -3526.0,
        1499.4998779296875
      ],
      "bbox_max": [
        -1604.699951171875,
        -3525.5,
        1500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4473009705543518,
        -0.0,
        0.8943836092948914
      ],
      "plane_d": -623.3442993164062,
      "bbox_min": [
        -1605.699951171875,
        -3526.0,
        1499.4998779296875
      ],
      "bbox_max": [
        -1604.699951171875,
        -3525.5,
        1500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1605.0,
      "bbox_min": [
        -1605.699951171875,
        -3526.0,
        1495.0
      ],
      "bbox_max": [
        -1604.5,
        -3525.5,
        1499.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9805852770805359,
        -0.0,
        0.1960930973291397
      ],
      "plane_d": 1279.503662109375,
      "bbox_min": [
        -1604.699951171875,
        -3526.0,
        1498.5
      ],
      "bbox_max": [
        -1604.5,
        -3525.5,
        1499.4998779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9899529218673706,
        -0.0,
        -0.14139717817306519
      ],
      "plane_d": -1376.99072265625,
      "bbox_min": [
        -1605.699951171875,
        -3526.0,
        1498.5
      ],
      "bbox_max": [
        -1605.0,
        -3525.5,
        1499.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4472863972187042,
        -0.0,
        -0.8943908214569092
      ],
      "plane_d": 622.9313354492188,
      "bbox_min": [
        -1605.699951171875,
        -3526.0,
        1499.199951171875
      ],
      "bbox_max": [
        -1605.0999755859375,
        -3525.5,
        1499.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9785451292991638,
        -0.2060326635837555,
        0.0
      ],
      "plane_d": -2285.68505859375,
      "bbox_min": [
        -1597.3779296875,
        -3526.0,
        1483.0
      ],
      "bbox_max": [
        -1592.6220703125,
        -3524.10009765625,
        1494.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1489.0,
      "bbox_min": [
        -1593.800048828125,
        -3526.0,
        1483.0
      ],
      "bbox_max": [
        -1592.6220703125,
        -3524.10009765625,
        1494.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1492.0,
      "bbox_min": [
        -1593.800048828125,
        -3526.0,
        1489.0
      ],
      "bbox_max": [
        -1592.6220703125,
        -3524.10009765625,
        1494.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3524.10009765625,
      "bbox_min": [
        -1593.800048828125,
        -3526.0,
        1492.0
      ],
      "bbox_max": [
        -1592.6220703125,
        -3524.10009765625,
        1494.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1494.0,
      "bbox_min": [
        -1593.800048828125,
        -3526.0,
        1494.0
      ],
      "bbox_max": [
        -1592.6220703125,
        -3524.10009765625,
        1494.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3524.10009765625,
      "bbox_min": [
        -1593.800048828125,
        -3526.0,
        1489.0
      ],
      "bbox_max": [
        -1592.6220703125,
        -3524.10009765625,
        1491.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1491.0,
      "bbox_min": [
        -1593.800048828125,
        -3526.0,
        1491.0
      ],
      "bbox_max": [
        -1592.6220703125,
        -3524.10009765625,
        1491.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1486.0,
      "bbox_min": [
        -1593.800048828125,
        -3526.0,
        1483.0
      ],
      "bbox_max": [
        -1592.6220703125,
        -3524.10009765625,
        1488.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3524.10009765625,
      "bbox_min": [
        -1593.800048828125,
        -3526.0,
        1486.0
      ],
      "bbox_max": [
        -1592.6220703125,
        -3524.10009765625,
        1488.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1488.0,
      "bbox_min": [
        -1593.800048828125,
        -3526.0,
        1488.0
      ],
      "bbox_max": [
        -1592.6220703125,
        -3524.10009765625,
        1488.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3524.10009765625,
      "bbox_min": [
        -1593.800048828125,
        -3526.0,
        1483.0
      ],
      "bbox_max": [
        -1592.6220703125,
        -3524.10009765625,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1485.0,
      "bbox_min": [
        -1593.800048828125,
        -3526.0,
        1485.0
      ],
      "bbox_max": [
        -1592.6220703125,
        -3524.10009765625,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1489.0,
      "bbox_min": [
        -1597.3779296875,
        -3526.0,
        1483.0
      ],
      "bbox_max": [
        -1596.199951171875,
        -3524.10009765625,
        1494.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9785451292991638,
        -0.2060326635837555,
        0.0
      ],
      "plane_d": 835.8739013671875,
      "bbox_min": [
        -1597.3779296875,
        -3526.0,
        1489.0
      ],
      "bbox_max": [
        -1596.199951171875,
        -3524.10009765625,
        1494.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1492.0,
      "bbox_min": [
        -1597.3779296875,
        -3526.0,
        1489.0
      ],
      "bbox_max": [
        -1596.199951171875,
        -3524.10009765625,
        1494.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3524.10009765625,
      "bbox_min": [
        -1597.3779296875,
        -3526.0,
        1492.0
      ],
      "bbox_max": [
        -1596.199951171875,
        -3524.10009765625,
        1494.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1494.0,
      "bbox_min": [
        -1597.3779296875,
        -3526.0,
        1494.0
      ],
      "bbox_max": [
        -1596.199951171875,
        -3524.10009765625,
        1494.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3524.10009765625,
      "bbox_min": [
        -1597.3779296875,
        -3526.0,
        1489.0
      ],
      "bbox_max": [
        -1596.199951171875,
        -3524.10009765625,
        1491.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1491.0,
      "bbox_min": [
        -1597.3779296875,
        -3526.0,
        1491.0
      ],
      "bbox_max": [
        -1596.199951171875,
        -3524.10009765625,
        1491.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9785451292991638,
        -0.2060326635837555,
        0.0
      ],
      "plane_d": 835.8739013671875,
      "bbox_min": [
        -1597.3779296875,
        -3526.0,
        1483.0
      ],
      "bbox_max": [
        -1596.199951171875,
        -3524.10009765625,
        1488.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1486.0,
      "bbox_min": [
        -1597.3779296875,
        -3526.0,
        1483.0
      ],
      "bbox_max": [
        -1596.199951171875,
        -3524.10009765625,
        1488.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3524.10009765625,
      "bbox_min": [
        -1597.3779296875,
        -3526.0,
        1486.0
      ],
      "bbox_max": [
        -1596.199951171875,
        -3524.10009765625,
        1488.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1488.0,
      "bbox_min": [
        -1597.3779296875,
        -3526.0,
        1488.0
      ],
      "bbox_max": [
        -1596.199951171875,
        -3524.10009765625,
        1488.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3524.10009765625,
      "bbox_min": [
        -1597.3779296875,
        -3526.0,
        1483.0
      ],
      "bbox_max": [
        -1596.199951171875,
        -3524.10009765625,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1485.0,
      "bbox_min": [
        -1597.3779296875,
        -3526.0,
        1485.0
      ],
      "bbox_max": [
        -1596.199951171875,
        -3524.10009765625,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3490.0,
      "bbox_min": [
        -1615.0,
        -3514.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1575.0,
        -3479.5,
        1505.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3486.0,
      "bbox_min": [
        -1615.0,
        -3490.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1575.0,
        -3479.5,
        1505.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9186536073684692,
        0.0,
        -0.39506393671035767
      ],
      "plane_d": -863.1574096679688,
      "bbox_min": [
        -1612.8231201171875,
        -3490.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1577.1768798828125,
        -3486.0,
        1503.3221435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9186536073684692,
        0.0,
        -0.39506393671035767
      ],
      "plane_d": 2067.34765625,
      "bbox_min": [
        -1612.8231201171875,
        -3490.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1586.08837890625,
        -3486.0,
        1503.3221435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1503.3221435546875,
      "bbox_min": [
        -1603.91162109375,
        -3490.0,
        1503.3221435546875
      ],
      "bbox_max": [
        -1586.08837890625,
        -3486.0,
        1503.3221435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1505.0,
      "bbox_min": [
        -1605.4000244140625,
        -3486.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1584.0,
        -3479.5,
        1505.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1485.0,
      "bbox_min": [
        -1605.4000244140625,
        -3484.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1584.0,
        -3479.5,
        1505.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3484.0,
      "bbox_min": [
        -1605.4000244140625,
        -3484.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1584.0,
        -3479.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1589.0,
      "bbox_min": [
        -1605.4000244140625,
        -3484.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1584.0,
        -3479.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4705919325351715,
        0.8823509216308594
      ],
      "plane_d": -2947.7158203125,
      "bbox_min": [
        -1589.0,
        -3484.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1584.0,
        -3479.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1584.0,
      "bbox_min": [
        -1584.0,
        -3484.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1584.0,
        -3479.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1600.4000244140625,
      "bbox_min": [
        -1605.4000244140625,
        -3484.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1589.5,
        -3479.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4705919325351715,
        0.8823509216308594
      ],
      "plane_d": -2947.7158203125,
      "bbox_min": [
        -1605.4000244140625,
        -3484.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1600.4000244140625,
        -3479.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1605.4000244140625,
      "bbox_min": [
        -1605.4000244140625,
        -3484.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1605.4000244140625,
        -3479.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1600.0,
      "bbox_min": [
        -1600.0,
        -3484.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1589.5,
        -3479.5,
        1485.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1589.5,
      "bbox_min": [
        -1600.0,
        -3484.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1589.5,
        -3479.5,
        1485.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.5655322670936584,
        0.8247262239456177
      ],
      "plane_d": -3192.488037109375,
      "bbox_min": [
        -1600.0,
        -3484.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1589.5,
        -3479.5,
        1485.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1483.5999755859375,
      "bbox_min": [
        -1600.0,
        -3483.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1589.5,
        -3479.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1484.5999755859375,
      "bbox_min": [
        -1600.0,
        -3481.541748046875,
        1483.5999755859375
      ],
      "bbox_max": [
        -1589.5,
        -3479.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1599.0999755859375,
      "bbox_min": [
        -1599.5999755859375,
        -3480.08349609375,
        1484.5999755859375
      ],
      "bbox_max": [
        -1589.9000244140625,
        -3479.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1589.9000244140625,
      "bbox_min": [
        -1589.9000244140625,
        -3480.08349609375,
        1484.5999755859375
      ],
      "bbox_max": [
        -1589.9000244140625,
        -3479.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3481.0,
      "bbox_min": [
        -1599.5999755859375,
        -3481.0,
        1483.5999755859375
      ],
      "bbox_max": [
        -1599.0999755859375,
        -3481.0,
        1483.9715576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3481.0,
      "bbox_min": [
        -1600.0,
        -3481.0,
        1483.5999755859375
      ],
      "bbox_max": [
        -1599.5999755859375,
        -3481.0,
        1483.9715576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1589.9000244140625,
      "bbox_min": [
        -1589.9000244140625,
        -3481.541748046875,
        1483.5999755859375
      ],
      "bbox_max": [
        -1589.9000244140625,
        -3481.0,
        1483.971435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1590.4000244140625,
      "bbox_min": [
        -1590.4000244140625,
        -3481.0,
        1483.6285400390625
      ],
      "bbox_max": [
        -1589.9000244140625,
        -3479.583251953125,
        1484.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1589.9000244140625,
      "bbox_min": [
        -1589.9000244140625,
        -3481.0,
        1483.6285400390625
      ],
      "bbox_max": [
        -1589.9000244140625,
        -3479.583251953125,
        1484.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1599.0999755859375,
      "bbox_min": [
        -1600.0,
        -3483.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1589.5,
        -3481.041748046875,
        1483.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1599.5999755859375,
      "bbox_min": [
        -1600.0,
        -3483.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1599.0999755859375,
        -3481.041748046875,
        1483.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3482.5,
      "bbox_min": [
        -1599.5999755859375,
        -3482.5,
        1482.5999755859375
      ],
      "bbox_max": [
        -1599.0999755859375,
        -3482.5,
        1482.94287109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1589.9000244140625,
      "bbox_min": [
        -1589.9000244140625,
        -3482.5,
        1482.5999755859375
      ],
      "bbox_max": [
        -1589.9000244140625,
        -3481.041748046875,
        1483.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3482.5,
      "bbox_min": [
        -1600.0,
        -3482.5,
        1482.94287109375
      ],
      "bbox_max": [
        -1589.5,
        -3482.5,
        1483.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1483.5999755859375,
      "bbox_min": [
        -1600.0,
        -3482.5,
        1483.5999755859375
      ],
      "bbox_max": [
        -1589.5,
        -3481.0,
        1484.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3482.5,
      "bbox_min": [
        -1600.0,
        -3482.5,
        1483.5999755859375
      ],
      "bbox_max": [
        -1589.5,
        -3481.0,
        1484.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3481.0,
      "bbox_min": [
        -1600.0,
        -3481.0,
        1483.9715576171875
      ],
      "bbox_max": [
        -1589.5,
        -3481.0,
        1484.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1484.5999755859375,
      "bbox_min": [
        -1600.0,
        -3481.0,
        1484.5999755859375
      ],
      "bbox_max": [
        -1589.5,
        -3480.083251953125,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3481.0,
      "bbox_min": [
        -1600.0,
        -3481.0,
        1484.5999755859375
      ],
      "bbox_max": [
        -1589.5,
        -3481.0,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1591.9998779296875,
      "bbox_min": [
        -1602.0,
        -3482.0,
        1497.2000732421875
      ],
      "bbox_max": [
        -1588.0,
        -3479.5,
        1505.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3482.0,
      "bbox_min": [
        -1592.0,
        -3482.0,
        1497.2000732421875
      ],
      "bbox_max": [
        -1588.0,
        -3479.5,
        1505.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1588.0,
      "bbox_min": [
        -1592.0,
        -3482.0,
        1497.2000732421875
      ],
      "bbox_max": [
        -1588.0,
        -3479.5,
        1505.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4327167868614197,
        -0.9015299677848816
      ],
      "plane_d": -155.8673095703125,
      "bbox_min": [
        -1592.0,
        -3482.0,
        1497.2000732421875
      ],
      "bbox_max": [
        -1588.0,
        -3479.5,
        1498.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3482.0,
      "bbox_min": [
        -1602.0,
        -3482.0,
        1497.2000732421875
      ],
      "bbox_max": [
        -1598.0,
        -3479.5,
        1505.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1601.9998779296875,
      "bbox_min": [
        -1602.0,
        -3482.0,
        1497.2000732421875
      ],
      "bbox_max": [
        -1598.0,
        -3479.5,
        1505.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1598.0,
      "bbox_min": [
        -1602.0,
        -3482.0,
        1497.2000732421875
      ],
      "bbox_max": [
        -1598.0,
        -3479.5,
        1505.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4327167868614197,
        -0.9015299677848816
      ],
      "plane_d": -155.8673095703125,
      "bbox_min": [
        -1602.0,
        -3482.0,
        1497.2000732421875
      ],
      "bbox_max": [
        -1598.0,
        -3479.5,
        1498.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3500.0,
      "bbox_min": [
        -1615.0,
        -3514.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1575.0,
        -3490.0,
        1505.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3504.0,
      "bbox_min": [
        -1615.0,
        -3514.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1575.0,
        -3500.0,
        1505.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9186536073684692,
        0.0,
        -0.39506393671035767
      ],
      "plane_d": -863.1574096679688,
      "bbox_min": [
        -1612.8231201171875,
        -3504.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1577.1768798828125,
        -3500.0,
        1503.3221435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9186536073684692,
        0.0,
        -0.39506393671035767
      ],
      "plane_d": 2067.34765625,
      "bbox_min": [
        -1612.8231201171875,
        -3504.0,
        1482.5999755859375
      ],
      "bbox_max": [
        -1586.08837890625,
        -3500.0,
        1503.3221435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1503.3221435546875,
      "bbox_min": [
        -1603.91162109375,
        -3504.0,
        1503.3221435546875
      ],
      "bbox_max": [
        -1586.08837890625,
        -3500.0,
        1503.3221435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1505.0,
      "bbox_min": [
        -1605.0,
        -3514.0,
        1503.0
      ],
      "bbox_max": [
        -1585.0,
        -3504.0,
        1505.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3511.0,
      "bbox_min": [
        -1600.5,
        -3513.0,
        1503.0
      ],
      "bbox_max": [
        -1588.5,
        -3505.0,
        1503.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1503.0,
      "bbox_min": [
        -1600.5,
        -3513.0,
        1503.0
      ],
      "bbox_max": [
        -1588.5,
        -3511.0,
        1503.5
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1503.4998779296875,
      "bbox_min": [
        -1600.5,
        -3513.0,
        1503.0
      ],
      "bbox_max": [
        -1588.5,
        -3511.0,
        1503.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3513.0,
      "bbox_min": [
        -1600.5,
        -3513.0,
        1503.0
      ],
      "bbox_max": [
        -1588.5,
        -3511.0,
        1503.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1600.5,
      "bbox_min": [
        -1600.5,
        -3513.0,
        1503.0
      ],
      "bbox_max": [
        -1588.5,
        -3511.0,
        1503.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1588.5,
      "bbox_min": [
        -1600.5,
        -3513.0,
        1503.0
      ],
      "bbox_max": [
        -1588.5,
        -3511.0,
        1503.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -3615.4375,
      "bbox_min": [
        -1600.5,
        -3513.0,
        1503.0
      ],
      "bbox_max": [
        -1588.5,
        -3511.0,
        1503.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 1351.2811279296875,
      "bbox_min": [
        -1600.5,
        -3513.0,
        1503.0
      ],
      "bbox_max": [
        -1588.5,
        -3511.0,
        1503.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -1360.4736328125,
      "bbox_min": [
        -1589.0,
        -3513.0,
        1503.0
      ],
      "bbox_max": [
        -1588.5,
        -3511.0,
        1503.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": 3606.244873046875,
      "bbox_min": [
        -1589.0,
        -3511.5,
        1503.0
      ],
      "bbox_max": [
        -1588.5,
        -3511.0,
        1503.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1503.0,
      "bbox_min": [
        -1600.5,
        -3507.0,
        1503.0
      ],
      "bbox_max": [
        -1588.5,
        -3505.0,
        1503.5
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3507.0,
      "bbox_min": [
        -1600.5,
        -3507.0,
        1503.0
      ],
      "bbox_max": [
        -1588.5,
        -3505.0,
        1503.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3505.0,
      "bbox_min": [
        -1600.5,
        -3507.0,
        1503.0
      ],
      "bbox_max": [
        -1588.5,
        -3505.0,
        1503.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1600.5,
      "bbox_min": [
        -1600.5,
        -3507.0,
        1503.0
      ],
      "bbox_max": [
        -1588.5,
        -3505.0,
        1503.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1588.5,
      "bbox_min": [
        -1600.5,
        -3507.0,
        1503.0
      ],
      "bbox_max": [
        -1588.5,
        -3505.0,
        1503.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -3611.19482421875,
      "bbox_min": [
        -1600.5,
        -3507.0,
        1503.0
      ],
      "bbox_max": [
        -1588.5,
        -3505.0,
        1503.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 1347.0384521484375,
      "bbox_min": [
        -1600.5,
        -3507.0,
        1503.0
      ],
      "bbox_max": [
        -1588.5,
        -3505.0,
        1503.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -1356.23095703125,
      "bbox_min": [
        -1589.0,
        -3507.0,
        1503.0
      ],
      "bbox_max": [
        -1588.5,
        -3505.0,
        1503.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": 3602.002197265625,
      "bbox_min": [
        -1589.0,
        -3505.5,
        1503.0
      ],
      "bbox_max": [
        -1588.5,
        -3505.0,
        1503.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1505.0,
      "bbox_min": [
        -1605.0,
        -3500.0,
        1503.0
      ],
      "bbox_max": [
        -1585.0,
        -3490.0,
        1505.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3493.0,
      "bbox_min": [
        -1600.5,
        -3499.0,
        1503.0
      ],
      "bbox_max": [
        -1588.5,
        -3491.0,
        1503.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1503.0,
      "bbox_min": [
        -1600.5,
        -3493.0,
        1503.0
      ],
      "bbox_max": [
        -1588.5,
        -3491.0,
        1503.5
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1503.4998779296875,
      "bbox_min": [
        -1600.5,
        -3493.0,
        1503.0
      ],
      "bbox_max": [
        -1588.5,
        -3491.0,
        1503.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3491.0,
      "bbox_min": [
        -1600.5,
        -3493.0,
        1503.0
      ],
      "bbox_max": [
        -1588.5,
        -3491.0,
        1503.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1600.5,
      "bbox_min": [
        -1600.5,
        -3493.0,
        1503.0
      ],
      "bbox_max": [
        -1588.5,
        -3491.0,
        1503.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1588.5,
      "bbox_min": [
        -1600.5,
        -3493.0,
        1503.0
      ],
      "bbox_max": [
        -1588.5,
        -3491.0,
        1503.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -3601.294921875,
      "bbox_min": [
        -1600.5,
        -3493.0,
        1503.0
      ],
      "bbox_max": [
        -1588.5,
        -3491.0,
        1503.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 1337.1390380859375,
      "bbox_min": [
        -1600.5,
        -3493.0,
        1503.0
      ],
      "bbox_max": [
        -1588.5,
        -3491.0,
        1503.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -1346.331298828125,
      "bbox_min": [
        -1589.0,
        -3493.0,
        1503.0
      ],
      "bbox_max": [
        -1588.5,
        -3491.0,
        1503.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": 3592.102783203125,
      "bbox_min": [
        -1589.0,
        -3491.5,
        1503.0
      ],
      "bbox_max": [
        -1588.5,
        -3491.0,
        1503.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1503.0,
      "bbox_min": [
        -1600.5,
        -3499.0,
        1503.0
      ],
      "bbox_max": [
        -1588.5,
        -3497.0,
        1503.5
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3499.0,
      "bbox_min": [
        -1600.5,
        -3499.0,
        1503.0
      ],
      "bbox_max": [
        -1588.5,
        -3497.0,
        1503.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3497.0,
      "bbox_min": [
        -1600.5,
        -3499.0,
        1503.0
      ],
      "bbox_max": [
        -1588.5,
        -3497.0,
        1503.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1600.5,
      "bbox_min": [
        -1600.5,
        -3499.0,
        1503.0
      ],
      "bbox_max": [
        -1588.5,
        -3497.0,
        1503.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1588.5,
      "bbox_min": [
        -1600.5,
        -3499.0,
        1503.0
      ],
      "bbox_max": [
        -1588.5,
        -3497.0,
        1503.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -3605.53759765625,
      "bbox_min": [
        -1600.5,
        -3499.0,
        1503.0
      ],
      "bbox_max": [
        -1588.5,
        -3497.0,
        1503.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 1341.3817138671875,
      "bbox_min": [
        -1600.5,
        -3499.0,
        1503.0
      ],
      "bbox_max": [
        -1588.5,
        -3497.0,
        1503.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -1350.573974609375,
      "bbox_min": [
        -1589.0,
        -3499.0,
        1503.0
      ],
      "bbox_max": [
        -1588.5,
        -3497.0,
        1503.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": 3596.345458984375,
      "bbox_min": [
        -1589.0,
        -3497.5,
        1503.0
      ],
      "bbox_max": [
        -1588.5,
        -3497.0,
        1503.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9400216937065125,
        0.3411146402359009
      ],
      "plane_d": 2738.791748046875,
      "bbox_min": [
        -1612.5,
        -3480.6474609375,
        1459.0
      ],
      "bbox_max": [
        -1545.34130859375,
        -3441.5,
        1562.79541015625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9284767508506775,
        0.0,
        -0.371390700340271
      ],
      "plane_d": 2043.577392578125,
      "bbox_min": [
        -1612.5,
        -3459.271728515625,
        1469.315185546875
      ],
      "bbox_max": [
        -1589.0,
        -3446.725341796875,
        1500.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3450.0,
      "bbox_min": [
        -1612.5,
        -3450.0,
        1476.5452880859375
      ],
      "bbox_max": [
        -1609.6644287109375,
        -3450.0,
        1478.3394775390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1500.0,
      "bbox_min": [
        -1612.5,
        -3459.271728515625,
        1469.315185546875
      ],
      "bbox_max": [
        -1589.0,
        -3446.725341796875,
        1500.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1612.5,
      "bbox_min": [
        -1612.5,
        -3447.601806640625,
        1469.315185546875
      ],
      "bbox_max": [
        -1612.5,
        -3446.725341796875,
        1471.25048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3450.0,
      "bbox_min": [
        -1612.5,
        -3463.709716796875,
        1459.0
      ],
      "bbox_max": [
        -1583.0,
        -3441.5,
        1516.119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1612.5,
      "bbox_min": [
        -1612.5,
        -3450.0,
        1459.0
      ],
      "bbox_max": [
        -1612.5,
        -3441.5,
        1481.7430419921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1485.0,
      "bbox_min": [
        -1607.0,
        -3463.709716796875,
        1485.0
      ],
      "bbox_max": [
        -1583.0,
        -3450.3603515625,
        1516.119384765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9284767508506775,
        0.0,
        -0.371390700340271
      ],
      "plane_d": 2043.577392578125,
      "bbox_min": [
        -1607.0,
        -3457.8603515625,
        1485.0
      ],
      "bbox_max": [
        -1601.0,
        -3451.138427734375,
        1500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284767508506775,
        0.0,
        -0.371390700340271
      ],
      "plane_d": 2043.577392578125,
      "bbox_min": [
        -1605.0526123046875,
        -3457.8603515625,
        1491.5555419921875
      ],
      "bbox_max": [
        -1601.0,
        -3453.70361328125,
        1500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15310870110988617,
        0.9070197343826294,
        0.3922663927078247
      ],
      "plane_d": 2793.074951171875,
      "bbox_min": [
        -1605.0526123046875,
        -3457.8603515625,
        1492.159423828125
      ],
      "bbox_max": [
        -1601.0,
        -3453.93994140625,
        1500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1624.5,
      "bbox_min": [
        -1624.5,
        -3441.5,
        1302.5999755859375
      ],
      "bbox_max": [
        -1549.7508544921875,
        -3426.5,
        1465.0074462890625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1610.0,
      "bbox_min": [
        -1624.5,
        -3441.5,
        1302.5999755859375
      ],
      "bbox_max": [
        -1549.7508544921875,
        -3426.5,
        1465.0074462890625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -1487.699951171875,
      "bbox_min": [
        -1550.0,
        -3439.0,
        1459.0
      ],
      "bbox_max": [
        -1549.7508544921875,
        -3438.771728515625,
        1459.5447998046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1559.0,
      "bbox_min": [
        -1559.0,
        -3441.5,
        1459.0
      ],
      "bbox_max": [
        -1559.0,
        -3439.0712890625,
        1465.0074462890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3426.5,
      "bbox_min": [
        -1624.5,
        -3441.5,
        1302.5999755859375
      ],
      "bbox_max": [
        -1610.0,
        -3426.5,
        1460.718017578125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1449.0,
      "bbox_min": [
        -1624.5,
        -3441.5,
        1449.0
      ],
      "bbox_max": [
        -1610.0,
        -3436.681640625,
        1460.718017578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1612.5,
      "bbox_min": [
        -1612.5,
        -3441.5,
        1459.0
      ],
      "bbox_max": [
        -1612.5,
        -3440.805419921875,
        1460.718017578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1612.5,
      "bbox_min": [
        -1624.5,
        -3451.39208984375,
        1432.5452880859375
      ],
      "bbox_max": [
        -1545.445556640625,
        -3430.029541015625,
        1485.6484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3450.0,
      "bbox_min": [
        -1612.5,
        -3451.39208984375,
        1432.5452880859375
      ],
      "bbox_max": [
        -1545.445556640625,
        -3430.029541015625,
        1485.6484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1559.0,
      "bbox_min": [
        -1612.5,
        -3450.0,
        1432.5452880859375
      ],
      "bbox_max": [
        -1545.445556640625,
        -3430.029541015625,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1449.0,
      "bbox_min": [
        -1612.5,
        -3450.0,
        1449.0
      ],
      "bbox_max": [
        -1610.0,
        -3431.333740234375,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3439.0,
      "bbox_min": [
        -1559.0,
        -3439.0,
        1459.0
      ],
      "bbox_max": [
        -1545.445556640625,
        -3434.824951171875,
        1469.6993408203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -1487.699951171875,
      "bbox_min": [
        -1550.0,
        -3439.0,
        1459.0
      ],
      "bbox_max": [
        -1545.445556640625,
        -3434.824951171875,
        1468.2545166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284767508506775,
        0.0,
        -0.371390700340271
      ],
      "plane_d": 2043.577392578125,
      "bbox_min": [
        -1607.0,
        -3451.39208984375,
        1485.0
      ],
      "bbox_max": [
        -1606.7406005859375,
        -3450.3603515625,
        1485.6484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3439.0,
      "bbox_min": [
        -1624.5,
        -3439.0,
        1447.4259033203125
      ],
      "bbox_max": [
        -1612.5,
        -3432.24853515625,
        1479.4906005859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6757246851921082,
        -0.7371541857719421,
        -0.0
      ],
      "plane_d": -3629.747314453125,
      "bbox_min": [
        -1624.5,
        -3439.0,
        1447.4259033203125
      ],
      "bbox_max": [
        -1612.5,
        -3432.24853515625,
        1479.4906005859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1449.0,
      "bbox_min": [
        -1623.1239013671875,
        -3437.073974609375,
        1449.0
      ],
      "bbox_max": [
        -1612.5,
        -3432.24853515625,
        1449.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1449.0,
      "bbox_min": [
        -1624.5,
        -3437.151611328125,
        1447.4259033203125
      ],
      "bbox_max": [
        -1622.1014404296875,
        -3436.13623046875,
        1449.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1624.5,
      "bbox_min": [
        -1624.5,
        -3437.151611328125,
        1447.4259033203125
      ],
      "bbox_max": [
        -1624.5,
        -3436.51513671875,
        1449.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18093791604042053,
        0.11947211623191833,
        0.9762109518051147
      ],
      "plane_d": -743.3453369140625,
      "bbox_min": [
        -1631.7432861328125,
        -3485.0400390625,
        1464.900146484375
      ],
      "bbox_max": [
        -1523.64404296875,
        -3426.104248046875,
        1574.9000244140625
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -1487.699951171875,
      "bbox_min": [
        -1621.2755126953125,
        -3439.0,
        1464.9405517578125
      ],
      "bbox_max": [
        -1545.71533203125,
        -3435.072265625,
        1482.6754150390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6757246851921082,
        -0.7371541857719421,
        -0.0
      ],
      "plane_d": -3629.747314453125,
      "bbox_min": [
        -1621.2755126953125,
        -3439.0,
        1478.91357421875
      ],
      "bbox_max": [
        -1620.0,
        -3437.830810546875,
        1482.6754150390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15612298250198364,
        0.9095134139060974,
        0.38524121046066284
      ],
      "plane_d": 2817.0615234375,
      "bbox_min": [
        -1631.7432861328125,
        -3485.0400390625,
        1464.900146484375
      ],
      "bbox_max": [
        -1523.64404296875,
        -3426.104248046875,
        1574.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1485.0,
      "bbox_min": [
        -1607.0,
        -3453.93994140625,
        1473.4256591796875
      ],
      "bbox_max": [
        -1559.0,
        -3444.5732421875,
        1492.159423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1559.0,
      "bbox_min": [
        -1559.0,
        -3446.298583984375,
        1473.4256591796875
      ],
      "bbox_max": [
        -1559.0,
        -3444.5732421875,
        1476.8763427734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284767508506775,
        0.0,
        -0.371390700340271
      ],
      "plane_d": 2043.577392578125,
      "bbox_min": [
        -1607.0,
        -3453.93994140625,
        1485.0
      ],
      "bbox_max": [
        -1604.13623046875,
        -3450.3603515625,
        1492.159423828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -3438.999755859375,
      "bbox_min": [
        -1631.7432861328125,
        -3456.615234375,
        1468.396484375
      ],
      "bbox_max": [
        -1545.8721923828125,
        -3426.104248046875,
        1515.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        -0.6726728081703186,
        0.7399401068687439
      ],
      "plane_d": -3426.931640625,
      "bbox_min": [
        -1621.0430908203125,
        -3439.0,
        1468.396484375
      ],
      "bbox_max": [
        -1545.8721923828125,
        -3426.104248046875,
        1515.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -1487.699951171875,
      "bbox_min": [
        -1621.0430908203125,
        -3439.0,
        1468.396484375
      ],
      "bbox_max": [
        -1545.8721923828125,
        -3435.216064453125,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6757246851921082,
        -0.7371541857719421,
        -0.0
      ],
      "plane_d": -3629.747314453125,
      "bbox_min": [
        -1621.0430908203125,
        -3439.0,
        1482.5989990234375
      ],
      "bbox_max": [
        -1620.0,
        -3438.0439453125,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3431.5,
      "bbox_min": [
        -1620.8994140625,
        -3439.0,
        1485.0
      ],
      "bbox_max": [
        -1546.6260986328125,
        -3426.439697265625,
        1507.9754638671875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -1487.7000732421875,
      "bbox_min": [
        -1620.8994140625,
        -3439.0,
        1485.0
      ],
      "bbox_max": [
        -1546.6260986328125,
        -3431.5,
        1497.6932373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -3629.7470703125,
      "bbox_min": [
        -1620.8994140625,
        -3439.0,
        1485.0
      ],
      "bbox_max": [
        -1620.0,
        -3438.175537109375,
        1496.973388671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3434.5,
      "bbox_min": [
        -1605.0,
        -3434.5,
        1485.0
      ],
      "bbox_max": [
        -1585.0,
        -3431.5,
        1495.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1493.5,
      "bbox_min": [
        -1599.5,
        -3434.5,
        1485.0
      ],
      "bbox_max": [
        -1590.0,
        -3431.5,
        1493.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1599.5,
      "bbox_min": [
        -1599.5,
        -3434.5,
        1485.0
      ],
      "bbox_max": [
        -1590.0,
        -3431.5,
        1493.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1590.0,
      "bbox_min": [
        -1590.0,
        -3434.5,
        1485.0
      ],
      "bbox_max": [
        -1590.0,
        -3431.5,
        1493.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1585.0,
      "bbox_min": [
        -1602.5,
        -3431.5,
        1485.0
      ],
      "bbox_max": [
        -1580.2593994140625,
        -3426.439697265625,
        1507.9754638671875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1497.0,
      "bbox_min": [
        -1602.5,
        -3431.5,
        1485.0
      ],
      "bbox_max": [
        -1586.5,
        -3426.439697265625,
        1497.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1586.5,
      "bbox_min": [
        -1602.5,
        -3431.5,
        1485.0
      ],
      "bbox_max": [
        -1586.5,
        -3426.439697265625,
        1497.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1602.5,
      "bbox_min": [
        -1602.5,
        -3431.5,
        1485.0
      ],
      "bbox_max": [
        -1602.5,
        -3431.4423828125,
        1485.7269287109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3428.0,
      "bbox_min": [
        -1585.0,
        -3428.0,
        1486.5
      ],
      "bbox_max": [
        -1580.2593994140625,
        -3426.874267578125,
        1507.9754638671875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1486.5,
      "bbox_min": [
        -1585.0,
        -3428.0,
        1486.5
      ],
      "bbox_max": [
        -1580.2593994140625,
        -3426.874267578125,
        1486.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1485.0,
      "bbox_min": [
        -1631.7432861328125,
        -3456.615234375,
        1471.2928466796875
      ],
      "bbox_max": [
        -1559.0,
        -3439.0,
        1498.7030029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3450.0,
      "bbox_min": [
        -1612.5,
        -3450.0,
        1471.2928466796875
      ],
      "bbox_max": [
        -1559.0,
        -3439.0,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1612.5,
      "bbox_min": [
        -1612.5,
        -3449.0400390625,
        1481.2088623046875
      ],
      "bbox_max": [
        -1612.5,
        -3439.0,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3428.0,
      "bbox_min": [
        -1587.912841796875,
        -3440.310546875,
        1459.0
      ],
      "bbox_max": [
        -1523.64404296875,
        -3419.892333984375,
        1515.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.6726728081703186,
        0.7399401068687439
      ],
      "plane_d": -3426.931640625,
      "bbox_min": [
        -1586.5509033203125,
        -3431.94287109375,
        1511.4156494140625
      ],
      "bbox_max": [
        -1569.154052734375,
        -3428.0,
        1515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1485.0,
      "bbox_min": [
        -1587.912841796875,
        -3426.51806640625,
        1485.0
      ],
      "bbox_max": [
        -1586.5,
        -3425.587158203125,
        1486.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1586.5,
      "bbox_min": [
        -1586.5,
        -3426.51806640625,
        1485.0
      ],
      "bbox_max": [
        -1586.5,
        -3425.587158203125,
        1486.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9899495244026184,
        -0.0,
        -0.1414213627576828
      ],
      "plane_d": -1341.59375,
      "bbox_min": [
        -1587.3790283203125,
        -3428.0,
        1486.5
      ],
      "bbox_max": [
        -1562.8321533203125,
        -3423.059326171875,
        1515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1496.5,
      "bbox_min": [
        -1569.0,
        -3428.0,
        1496.5
      ],
      "bbox_max": [
        -1562.8321533203125,
        -3423.059326171875,
        1496.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1585.0,
      "bbox_min": [
        -1587.3790283203125,
        -3428.0,
        1486.5
      ],
      "bbox_max": [
        -1576.024169921875,
        -3425.15673828125,
        1515.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1586.5,
      "bbox_min": [
        -1587.3790283203125,
        -3428.0,
        1486.5
      ],
      "bbox_max": [
        -1585.0,
        -3425.7060546875,
        1515.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1515.0,
      "bbox_min": [
        -1586.5,
        -3428.0,
        1515.0
      ],
      "bbox_max": [
        -1585.0,
        -3427.415771484375,
        1515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1497.0,
      "bbox_min": [
        -1587.3790283203125,
        -3428.0,
        1497.0
      ],
      "bbox_max": [
        -1586.5,
        -3426.5380859375,
        1515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1515.0,
      "bbox_min": [
        -1586.5784912109375,
        -3428.0,
        1515.0
      ],
      "bbox_max": [
        -1586.5,
        -3427.964599609375,
        1515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1514.0,
      "bbox_min": [
        -1585.0,
        -3428.0,
        1514.0
      ],
      "bbox_max": [
        -1576.024169921875,
        -3425.289794921875,
        1515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1515.0,
      "bbox_min": [
        -1585.0,
        -3428.0,
        1515.0
      ],
      "bbox_max": [
        -1576.7779541015625,
        -3425.53369140625,
        1515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9661343693733215,
        0.24907872080802917,
        0.0674104243516922
      ],
      "plane_d": -827.2496337890625,
      "bbox_min": [
        -1650.8538818359375,
        -3443.77099609375,
        1302.5999755859375
      ],
      "bbox_max": [
        -1570.6143798828125,
        -3382.0,
        1515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1624.5,
      "bbox_min": [
        -1629.142333984375,
        -3440.290771484375,
        1321.0653076171875
      ],
      "bbox_max": [
        -1570.6143798828125,
        -3398.04150390625,
        1515.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.6757246851921082,
        -0.7371541857719421,
        -0.0
      ],
      "plane_d": -3629.747314453125,
      "bbox_min": [
        -1629.142333984375,
        -3440.290771484375,
        1459.0
      ],
      "bbox_max": [
        -1624.5,
        -3430.61962890625,
        1484.0338134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18093794584274292,
        0.11946278810501099,
        0.9762121438980103
      ],
      "plane_d": -743.3792114257812,
      "bbox_min": [
        -1626.8880615234375,
        -3440.290771484375,
        1483.2216796875
      ],
      "bbox_max": [
        -1624.5,
        -3437.27197265625,
        1484.0338134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3426.5,
      "bbox_min": [
        -1624.5,
        -3439.372802734375,
        1321.0653076171875
      ],
      "bbox_max": [
        -1570.6143798828125,
        -3398.04150390625,
        1515.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3410.0,
      "bbox_min": [
        -1624.5,
        -3426.5,
        1439.0
      ],
      "bbox_max": [
        -1570.6143798828125,
        -3398.04150390625,
        1515.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1610.0,
      "bbox_min": [
        -1624.5,
        -3426.5,
        1439.0
      ],
      "bbox_max": [
        -1570.6143798828125,
        -3410.0,
        1515.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1515.0,
      "bbox_min": [
        -1602.5,
        -3426.5,
        1485.0
      ],
      "bbox_max": [
        -1570.6143798828125,
        -3412.0,
        1515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1485.0,
      "bbox_min": [
        -1602.5,
        -3426.5,
        1485.0
      ],
      "bbox_max": [
        -1570.6143798828125,
        -3412.0,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3412.0,
      "bbox_min": [
        -1602.5,
        -3426.5,
        1485.0
      ],
      "bbox_max": [
        -1570.6143798828125,
        -3412.0,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1497.0,
      "bbox_min": [
        -1602.5,
        -3426.5,
        1485.0
      ],
      "bbox_max": [
        -1570.6143798828125,
        -3412.0,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1585.0,
      "bbox_min": [
        -1585.0,
        -3426.5,
        1497.0
      ],
      "bbox_max": [
        -1579.4073486328125,
        -3414.23681640625,
        1514.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1514.0,
      "bbox_min": [
        -1585.0,
        -3426.5,
        1514.0
      ],
      "bbox_max": [
        -1579.4073486328125,
        -3420.809814453125,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1586.5,
      "bbox_min": [
        -1588.4000244140625,
        -3426.5,
        1485.0
      ],
      "bbox_max": [
        -1570.6143798828125,
        -3412.0,
        1497.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1486.5,
      "bbox_min": [
        -1586.5,
        -3425.9892578125,
        1486.5
      ],
      "bbox_max": [
        -1570.6143798828125,
        -3412.62060546875,
        1497.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1585.0,
      "bbox_min": [
        -1586.5,
        -3425.9892578125,
        1486.5
      ],
      "bbox_max": [
        -1585.0,
        -3412.620849609375,
        1497.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1495.0,
      "bbox_min": [
        -1586.5,
        -3419.0,
        1495.0
      ],
      "bbox_max": [
        -1585.0,
        -3413.5,
        1495.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3419.0,
      "bbox_min": [
        -1588.4000244140625,
        -3420.5,
        1485.0
      ],
      "bbox_max": [
        -1586.5,
        -3412.0,
        1497.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3420.5,
      "bbox_min": [
        -1588.4000244140625,
        -3420.5,
        1485.0
      ],
      "bbox_max": [
        -1586.5,
        -3419.0,
        1497.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9032753705978394,
        0.0,
        -0.42906132340431213
      ],
      "plane_d": -795.8902587890625,
      "bbox_min": [
        -1588.4000244140625,
        -3420.5,
        1485.0
      ],
      "bbox_max": [
        -1586.5,
        -3419.0,
        1497.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9032753705978394,
        0.0,
        0.42906132340431213
      ],
      "plane_d": -2075.35107421875,
      "bbox_min": [
        -1588.4000244140625,
        -3420.5,
        1489.0
      ],
      "bbox_max": [
        -1586.5,
        -3419.0,
        1497.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1588.4000244140625,
      "bbox_min": [
        -1588.4000244140625,
        -3420.5,
        1489.0
      ],
      "bbox_max": [
        -1588.4000244140625,
        -3419.0,
        1493.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3413.5,
      "bbox_min": [
        -1588.4000244140625,
        -3413.5,
        1485.0
      ],
      "bbox_max": [
        -1586.5,
        -3412.0,
        1497.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9032753705978394,
        0.0,
        -0.42906132340431213
      ],
      "plane_d": -795.8902587890625,
      "bbox_min": [
        -1588.4000244140625,
        -3413.5,
        1485.0
      ],
      "bbox_max": [
        -1586.5,
        -3412.0,
        1497.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9032753705978394,
        0.0,
        0.42906132340431213
      ],
      "plane_d": -2075.35107421875,
      "bbox_min": [
        -1588.4000244140625,
        -3413.5,
        1489.0
      ],
      "bbox_max": [
        -1586.5,
        -3412.0,
        1497.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1588.4000244140625,
      "bbox_min": [
        -1588.4000244140625,
        -3413.5,
        1489.0
      ],
      "bbox_max": [
        -1588.4000244140625,
        -3412.0,
        1493.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1439.0,
      "bbox_min": [
        -1624.5,
        -3426.5,
        1439.0
      ],
      "bbox_max": [
        -1610.0,
        -3410.0,
        1462.9552001953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3411.5,
      "bbox_min": [
        -1620.5775146484375,
        -3411.5,
        1439.0
      ],
      "bbox_max": [
        -1610.0,
        -3410.0,
        1462.9552001953125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1612.0,
      "bbox_min": [
        -1615.27880859375,
        -3411.5,
        1451.0
      ],
      "bbox_max": [
        -1612.0,
        -3410.0,
        1458.4256591796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1451.0,
      "bbox_min": [
        -1615.27880859375,
        -3411.5,
        1451.0
      ],
      "bbox_max": [
        -1612.0,
        -3410.0,
        1451.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.2800000011920929,
        -0.9599999785423279
      ],
      "plane_d": 465.99993896484375,
      "bbox_min": [
        -1612.0,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1580.0,
        -3405.0,
        1486.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1486.5,
      "bbox_min": [
        -1598.238525390625,
        -3410.0,
        1486.5
      ],
      "bbox_max": [
        -1590.1846923828125,
        -3407.21142578125,
        1486.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.96592116355896,
        0.25883668661117554,
        0.0
      ],
      "plane_d": 2417.48193359375,
      "bbox_min": [
        -1612.0,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1580.0,
        -3405.0,
        1477.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1473.0,
      "bbox_min": [
        -1612.0,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1589.0,
        -3405.0,
        1477.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.96592116355896,
        0.25883668661117554,
        0.0
      ],
      "plane_d": -661.8748168945312,
      "bbox_min": [
        -1612.0,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1589.0,
        -3405.0,
        1473.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.25883668661117554,
        0.96592116355896,
        0.0
      ],
      "plane_d": 2876.3759765625,
      "bbox_min": [
        -1599.0,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1589.0,
        -3405.0,
        1473.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 1279.2763671875,
      "bbox_min": [
        -1599.0,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1589.0,
        -3405.0,
        1473.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 3533.532958984375,
      "bbox_min": [
        -1599.0,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1589.0,
        -3405.0,
        1468.565185546875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.25883668661117554,
        0.96592116355896,
        0.0
      ],
      "plane_d": 3701.54736328125,
      "bbox_min": [
        -1599.0,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1589.0,
        -3405.0,
        1466.5419921875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1454.5,
      "bbox_min": [
        -1599.0,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1589.0,
        -3405.0,
        1454.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3406.5,
      "bbox_min": [
        -1596.0,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1592.0,
        -3406.5,
        1454.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1596.0,
      "bbox_min": [
        -1596.0,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1592.0,
        -3406.5,
        1454.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1592.0,
      "bbox_min": [
        -1592.0,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1592.0,
        -3406.5,
        1454.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        -1612.0,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1610.0,
        -3408.0,
        1459.8638916015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3408.0,
      "bbox_min": [
        -1612.0,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1610.0,
        -3408.0,
        1455.7432861328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1612.0,
      "bbox_min": [
        -1612.0,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1612.0,
        -3408.0,
        1455.3343505859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3408.0,
      "bbox_min": [
        -1601.055419921875,
        -3408.0,
        1476.0
      ],
      "bbox_max": [
        -1590.944580078125,
        -3406.5,
        1477.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1476.0,
      "bbox_min": [
        -1601.055419921875,
        -3408.0,
        1476.0
      ],
      "bbox_max": [
        -1590.944580078125,
        -3406.5,
        1477.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3406.5,
      "bbox_min": [
        -1599.6905517578125,
        -3406.5,
        1476.0
      ],
      "bbox_max": [
        -1593.9117431640625,
        -3406.5,
        1477.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.96592116355896,
        0.25883668661117554,
        0.0
      ],
      "plane_d": -650.2837524414062,
      "bbox_min": [
        -1587.0,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1580.0,
        -3407.18359375,
        1473.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1454.5,
      "bbox_min": [
        -1587.0,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1580.0,
        -3407.18359375,
        1473.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 1287.7615966796875,
      "bbox_min": [
        -1587.0,
        -3410.0,
        1454.5
      ],
      "bbox_max": [
        -1586.013671875,
        -3407.18359375,
        1473.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1473.0,
      "bbox_min": [
        -1587.0,
        -3410.0,
        1473.0
      ],
      "bbox_max": [
        -1586.0740966796875,
        -3409.587890625,
        1473.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1584.0,
      "bbox_min": [
        -1584.0,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1580.0,
        -3407.66259765625,
        1454.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1580.0,
      "bbox_min": [
        -1580.0,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1580.0,
        -3409.684326171875,
        1453.050537109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1610.0,
      "bbox_min": [
        -1624.5,
        -3439.372802734375,
        1388.013671875
      ],
      "bbox_max": [
        -1582.4974365234375,
        -3426.5,
        1515.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.6726728081703186,
        0.7399401068687439
      ],
      "plane_d": -3426.931640625,
      "bbox_min": [
        -1610.0,
        -3435.989013671875,
        1485.0
      ],
      "bbox_max": [
        -1582.4974365234375,
        -3426.5,
        1515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1515.0,
      "bbox_min": [
        -1602.5,
        -3431.5,
        1485.0
      ],
      "bbox_max": [
        -1582.4974365234375,
        -3426.5,
        1515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1497.0,
      "bbox_min": [
        -1602.5,
        -3431.5,
        1485.0
      ],
      "bbox_max": [
        -1582.71435546875,
        -3426.5,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1585.0,
      "bbox_min": [
        -1585.0,
        -3427.33642578125,
        1503.445068359375
      ],
      "bbox_max": [
        -1582.71435546875,
        -3426.5,
        1514.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3431.5,
      "bbox_min": [
        -1602.5,
        -3431.5,
        1485.7269287109375
      ],
      "bbox_max": [
        -1586.5,
        -3426.5,
        1497.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1586.5,
      "bbox_min": [
        -1586.5,
        -3426.5380859375,
        1496.5194091796875
      ],
      "bbox_max": [
        -1586.5,
        -3426.5,
        1497.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1449.0,
      "bbox_min": [
        -1624.5,
        -3437.538818359375,
        1449.0
      ],
      "bbox_max": [
        -1610.0,
        -3426.5,
        1509.4757080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7432345151901245,
        0.5606855154037476,
        0.36501291394233704
      ],
      "plane_d": 169.5526123046875,
      "bbox_min": [
        -1760.0,
        -3542.7783203125,
        1302.5999755859375
      ],
      "bbox_max": [
        -1591.38525390625,
        -3382.0,
        1574.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7289522290229797,
        0.6049720644950867,
        0.3203705847263336
      ],
      "plane_d": 411.9771423339844,
      "bbox_min": [
        -1760.0,
        -3526.5615234375,
        1302.5999755859375
      ],
      "bbox_max": [
        -1591.38525390625,
        -3382.0,
        1574.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34272027015686035,
        0.9365004897117615,
        0.07422665506601334
      ],
      "plane_d": 2554.111572265625,
      "bbox_min": [
        -1739.9085693359375,
        -3485.0400390625,
        1302.5999755859375
      ],
      "bbox_max": [
        -1591.38525390625,
        -3382.0,
        1574.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.15612298250198364,
        0.9095134139060974,
        0.38524121046066284
      ],
      "plane_d": 2817.0615234375,
      "bbox_min": [
        -1640.79345703125,
        -3485.0400390625,
        1484.0338134765625
      ],
      "bbox_max": [
        -1614.5399169921875,
        -3437.538818359375,
        1574.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18093794584274292,
        0.11946278810501099,
        0.9762121438980103
      ],
      "plane_d": -743.3792114257812,
      "bbox_min": [
        -1640.79345703125,
        -3448.461181640625,
        1484.0338134765625
      ],
      "bbox_max": [
        -1614.5399169921875,
        -3437.538818359375,
        1506.3282470703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.15310870110988617,
        0.9070197343826294,
        0.3922663927078247
      ],
      "plane_d": 2793.074951171875,
      "bbox_min": [
        -1640.79345703125,
        -3448.461181640625,
        1485.3487548828125
      ],
      "bbox_max": [
        -1614.5399169921875,
        -3437.538818359375,
        1506.3282470703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1322634071111679,
        0.5509588718414307,
        0.8239847421646118
      ],
      "plane_d": 889.9365234375,
      "bbox_min": [
        -1640.79345703125,
        -3446.90087890625,
        1485.3487548828125
      ],
      "bbox_max": [
        -1614.5399169921875,
        -3437.538818359375,
        1506.3282470703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3439.0,
      "bbox_min": [
        -1620.214599609375,
        -3439.0,
        1496.0819091796875
      ],
      "bbox_max": [
        -1614.5399169921875,
        -3437.538818359375,
        1506.3282470703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.6726728081703186,
        0.7399401068687439
      ],
      "plane_d": -3426.931640625,
      "bbox_min": [
        -1620.214599609375,
        -3439.0,
        1496.0819091796875
      ],
      "bbox_max": [
        -1614.5399169921875,
        -3437.538818359375,
        1506.3282470703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6757246851921082,
        -0.7371541857719421,
        -0.0
      ],
      "plane_d": -3629.747314453125,
      "bbox_min": [
        -1640.79345703125,
        -3445.635498046875,
        1439.0
      ],
      "bbox_max": [
        -1591.38525390625,
        -3392.9853515625,
        1515.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3410.0,
      "bbox_min": [
        -1632.0,
        -3439.0,
        1439.0
      ],
      "bbox_max": [
        -1591.38525390625,
        -3392.9853515625,
        1515.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1515.0,
      "bbox_min": [
        -1632.0,
        -3439.0,
        1439.0
      ],
      "bbox_max": [
        -1591.38525390625,
        -3410.0,
        1515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1624.5,
      "bbox_min": [
        -1632.0,
        -3439.0,
        1439.0
      ],
      "bbox_max": [
        -1595.422119140625,
        -3410.0,
        1515.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1632.0,
      "bbox_min": [
        -1632.0,
        -3428.0,
        1459.0
      ],
      "bbox_max": [
        -1632.0,
        -3420.07177734375,
        1473.971435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3426.5,
      "bbox_min": [
        -1624.5,
        -3439.0,
        1439.0
      ],
      "bbox_max": [
        -1595.422119140625,
        -3410.0,
        1515.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.6726728081703186,
        0.7399401068687439
      ],
      "plane_d": -3426.931640625,
      "bbox_min": [
        -1624.184326171875,
        -3439.0,
        1499.5546875
      ],
      "bbox_max": [
        -1602.03173828125,
        -3428.0,
        1515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3439.0,
      "bbox_min": [
        -1620.0,
        -3439.0,
        1499.5546875
      ],
      "bbox_max": [
        -1618.8203125,
        -3439.0,
        1505.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1610.0,
      "bbox_min": [
        -1624.5,
        -3426.5,
        1439.0
      ],
      "bbox_max": [
        -1595.422119140625,
        -3410.0,
        1500.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1602.5,
      "bbox_min": [
        -1602.5,
        -3419.779052734375,
        1485.0
      ],
      "bbox_max": [
        -1595.422119140625,
        -3412.0,
        1497.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3412.0,
      "bbox_min": [
        -1602.5,
        -3419.779052734375,
        1485.0
      ],
      "bbox_max": [
        -1595.422119140625,
        -3412.0,
        1497.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1497.0,
      "bbox_min": [
        -1602.5,
        -3419.779052734375,
        1485.0
      ],
      "bbox_max": [
        -1595.422119140625,
        -3412.0,
        1497.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1485.0,
      "bbox_min": [
        -1602.5,
        -3413.95556640625,
        1485.0
      ],
      "bbox_max": [
        -1600.7208251953125,
        -3412.0,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3411.5,
      "bbox_min": [
        -1624.5,
        -3426.5,
        1439.0
      ],
      "bbox_max": [
        -1610.0,
        -3410.0,
        1500.5
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1622.5,
      "bbox_min": [
        -1622.5,
        -3411.5,
        1451.0
      ],
      "bbox_max": [
        -1612.0,
        -3410.0,
        1488.320556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1463.0,
      "bbox_min": [
        -1622.5,
        -3411.5,
        1451.0
      ],
      "bbox_max": [
        -1612.0,
        -3410.0,
        1488.320556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1612.0,
      "bbox_min": [
        -1612.8001708984375,
        -3411.5,
        1486.5
      ],
      "bbox_max": [
        -1612.0,
        -3410.535888671875,
        1488.320556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1486.5,
      "bbox_min": [
        -1612.8001708984375,
        -3411.5,
        1486.5
      ],
      "bbox_max": [
        -1612.0,
        -3410.535888671875,
        1486.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1451.0,
      "bbox_min": [
        -1622.5,
        -3411.5,
        1451.0
      ],
      "bbox_max": [
        -1612.0,
        -3410.0,
        1463.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1612.0,
      "bbox_min": [
        -1612.0,
        -3411.5,
        1455.3343505859375
      ],
      "bbox_max": [
        -1612.0,
        -3410.0,
        1463.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1500.5,
      "bbox_min": [
        -1624.5,
        -3426.5,
        1439.0
      ],
      "bbox_max": [
        -1610.0,
        -3411.5,
        1500.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1439.0,
      "bbox_min": [
        -1624.5,
        -3415.81103515625,
        1439.0
      ],
      "bbox_max": [
        -1620.5775146484375,
        -3411.5,
        1439.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1451.0,
      "bbox_min": [
        -1627.1572265625,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1595.701416015625,
        -3392.9853515625,
        1514.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.2800000011920929,
        -0.9599999785423279
      ],
      "plane_d": 465.99993896484375,
      "bbox_min": [
        -1624.5,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1595.701416015625,
        -3399.88671875,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1486.5,
      "bbox_min": [
        -1611.5552978515625,
        -3410.0,
        1486.5
      ],
      "bbox_max": [
        -1595.701416015625,
        -3402.39013671875,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        -1610.0,
        -3410.0,
        1486.5
      ],
      "bbox_max": [
        -1598.5582275390625,
        -3408.1259765625,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1514.0,
      "bbox_min": [
        -1599.4691162109375,
        -3410.0,
        1514.0
      ],
      "bbox_max": [
        -1598.5582275390625,
        -3409.67578125,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3406.5,
      "bbox_min": [
        -1614.5101318359375,
        -3408.0,
        1476.0
      ],
      "bbox_max": [
        -1597.86865234375,
        -3403.0,
        1477.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3408.0,
      "bbox_min": [
        -1614.5101318359375,
        -3408.0,
        1476.0
      ],
      "bbox_max": [
        -1600.39306640625,
        -3408.0,
        1477.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3404.5,
      "bbox_min": [
        -1611.60546875,
        -3404.5,
        1476.0
      ],
      "bbox_max": [
        -1597.86865234375,
        -3403.0,
        1477.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3403.0,
      "bbox_min": [
        -1610.3604736328125,
        -3403.0,
        1476.0
      ],
      "bbox_max": [
        -1600.836181640625,
        -3403.0,
        1477.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1612.0,
      "bbox_min": [
        -1624.5,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1610.0,
        -3408.0,
        1468.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3408.0,
      "bbox_min": [
        -1612.0,
        -3410.0,
        1451.2137451171875
      ],
      "bbox_max": [
        -1610.0,
        -3408.0,
        1468.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        -1612.0,
        -3410.0,
        1455.7432861328125
      ],
      "bbox_max": [
        -1610.0,
        -3408.0,
        1468.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.8682432174682617,
        0.4961389899253845
      ],
      "plane_d": 2232.37744140625,
      "bbox_min": [
        -1612.0,
        -3410.0,
        1464.5
      ],
      "bbox_max": [
        -1610.0,
        -3408.0,
        1468.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1622.5,
      "bbox_min": [
        -1624.5,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1622.5,
        -3408.0,
        1461.59716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3408.0,
      "bbox_min": [
        -1624.5,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1622.5,
        -3408.0,
        1457.8203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1624.5,
      "bbox_min": [
        -1624.5,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1624.5,
        -3408.0,
        1457.0465087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18093794584274292,
        0.11946278810501099,
        0.9762121438980103
      ],
      "plane_d": -743.3792114257812,
      "bbox_min": [
        -1640.79345703125,
        -3445.635498046875,
        1482.847900390625
      ],
      "bbox_max": [
        -1623.4007568359375,
        -3430.135986328125,
        1487.26513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9661343693733215,
        0.24907872080802917,
        0.0674104243516922
      ],
      "plane_d": -827.2496337890625,
      "bbox_min": [
        -1642.5057373046875,
        -3445.635498046875,
        1355.8927001953125
      ],
      "bbox_max": [
        -1634.7877197265625,
        -3386.785888671875,
        1487.26513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9898766279220581,
        0.1408064216375351,
        0.01782338321208954
      ],
      "plane_d": -1165.5235595703125,
      "bbox_min": [
        -1640.79345703125,
        -3445.635498046875,
        1383.44189453125
      ],
      "bbox_max": [
        -1599.1168212890625,
        -3382.0,
        1515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1632.0,
      "bbox_min": [
        -1632.0,
        -3428.0,
        1451.0
      ],
      "bbox_max": [
        -1599.199951171875,
        -3390.844970703125,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3410.0,
      "bbox_min": [
        -1631.0,
        -3426.5,
        1451.0
      ],
      "bbox_max": [
        -1599.199951171875,
        -3390.844970703125,
        1514.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1624.5,
      "bbox_min": [
        -1624.5,
        -3426.5,
        1459.87890625
      ],
      "bbox_max": [
        -1610.0,
        -3410.0,
        1500.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3411.5,
      "bbox_min": [
        -1624.5,
        -3426.5,
        1459.87890625
      ],
      "bbox_max": [
        -1610.0,
        -3410.0,
        1500.5
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1612.0,
      "bbox_min": [
        -1622.5,
        -3411.5,
        1461.59716796875
      ],
      "bbox_max": [
        -1612.0,
        -3410.0,
        1493.459716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1486.5,
      "bbox_min": [
        -1622.5,
        -3411.5,
        1461.59716796875
      ],
      "bbox_max": [
        -1612.0,
        -3410.0,
        1486.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1622.5,
      "bbox_min": [
        -1622.5,
        -3410.742919921875,
        1461.59716796875
      ],
      "bbox_max": [
        -1621.8834228515625,
        -3410.0,
        1463.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1463.0,
      "bbox_min": [
        -1622.5,
        -3410.742919921875,
        1463.0
      ],
      "bbox_max": [
        -1621.8834228515625,
        -3410.0,
        1463.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1500.5,
      "bbox_min": [
        -1624.5,
        -3426.5,
        1488.2039794921875
      ],
      "bbox_max": [
        -1610.0,
        -3411.5,
        1500.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3426.5,
      "bbox_min": [
        -1624.5,
        -3426.5,
        1488.2039794921875
      ],
      "bbox_max": [
        -1610.0,
        -3411.5,
        1500.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1610.0,
      "bbox_min": [
        -1610.0,
        -3415.5400390625,
        1492.8717041015625
      ],
      "bbox_max": [
        -1610.0,
        -3411.5,
        1500.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1451.0,
      "bbox_min": [
        -1631.0,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1599.199951171875,
        -3390.844970703125,
        1514.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.2800000011920929,
        -0.9599999785423279
      ],
      "plane_d": 465.99993896484375,
      "bbox_min": [
        -1631.0,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1599.199951171875,
        -3397.593017578125,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1486.5,
      "bbox_min": [
        -1614.286376953125,
        -3410.0,
        1486.5
      ],
      "bbox_max": [
        -1599.199951171875,
        -3401.180419921875,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        -1612.0,
        -3410.0,
        1486.5
      ],
      "bbox_max": [
        -1599.199951171875,
        -3408.0,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3408.0,
      "bbox_min": [
        -1612.0,
        -3410.0,
        1486.5
      ],
      "bbox_max": [
        -1610.0,
        -3408.0,
        1492.15576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1612.0,
      "bbox_min": [
        -1612.0,
        -3410.0,
        1486.5
      ],
      "bbox_max": [
        -1612.0,
        -3408.0,
        1491.155517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3409.0,
      "bbox_min": [
        -1601.2540283203125,
        -3410.0,
        1511.5
      ],
      "bbox_max": [
        -1599.199951171875,
        -3408.45849609375,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1511.5,
      "bbox_min": [
        -1601.2540283203125,
        -3409.0,
        1511.5
      ],
      "bbox_max": [
        -1599.7744140625,
        -3408.45849609375,
        1511.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1514.0,
      "bbox_min": [
        -1600.78076171875,
        -3410.0,
        1514.0
      ],
      "bbox_max": [
        -1599.199951171875,
        -3409.186767578125,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3408.0,
      "bbox_min": [
        -1631.0,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1609.343994140625,
        -3397.593017578125,
        1477.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1624.5,
      "bbox_min": [
        -1631.0,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1619.0,
        -3408.0,
        1475.3662109375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1622.5,
      "bbox_min": [
        -1623.5821533203125,
        -3410.0,
        1457.8203125
      ],
      "bbox_max": [
        -1619.0,
        -3408.0,
        1475.3662109375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.8682432174682617,
        0.4961389899253845
      ],
      "plane_d": 2232.37744140625,
      "bbox_min": [
        -1623.5821533203125,
        -3410.0,
        1464.5
      ],
      "bbox_max": [
        -1622.5,
        -3408.0,
        1468.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": 1618.9998779296875,
      "bbox_min": [
        -1619.1798095703125,
        -3409.0,
        1475.0
      ],
      "bbox_max": [
        -1619.0,
        -3408.76171875,
        1475.3662109375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1475.0,
      "bbox_min": [
        -1619.1798095703125,
        -3409.0,
        1475.0
      ],
      "bbox_max": [
        -1619.0,
        -3408.76171875,
        1475.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1631.0,
      "bbox_min": [
        -1631.0,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1631.0,
        -3409.04443359375,
        1452.468017578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1476.0,
      "bbox_min": [
        -1617.9344482421875,
        -3408.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1609.343994140625,
        -3397.593017578125,
        1477.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3404.5,
      "bbox_min": [
        -1616.802734375,
        -3406.5,
        1476.0
      ],
      "bbox_max": [
        -1609.701171875,
        -3403.0,
        1477.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3403.0,
      "bbox_min": [
        -1614.162353515625,
        -3403.0,
        1476.0
      ],
      "bbox_max": [
        -1609.701171875,
        -3403.0,
        1477.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3406.5,
      "bbox_min": [
        -1616.802734375,
        -3406.5,
        1476.0
      ],
      "bbox_max": [
        -1612.6060791015625,
        -3406.5,
        1477.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3407208025455475,
        -0.34077969193458557,
        0.8762297630310059
      ],
      "plane_d": -1900.857177734375,
      "bbox_min": [
        -1613.8148193359375,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1609.343994140625,
        -3397.593017578125,
        1474.3365478515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12475047260522842,
        -0.4654877185821533,
        0.876218318939209
      ],
      "plane_d": -2672.83349609375,
      "bbox_min": [
        -1613.8148193359375,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1609.343994140625,
        -3397.593017578125,
        1474.3365478515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.46548134088516235,
        -0.12473297119140625,
        0.8762242197990417
      ],
      "plane_d": -965.699462890625,
      "bbox_min": [
        -1611.225830078125,
        -3399.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1609.343994140625,
        -3397.614990234375,
        1474.3365478515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12474536895751953,
        -0.46546870470046997,
        0.8762291669845581
      ],
      "plane_d": -3075.2216796875,
      "bbox_min": [
        -1613.8148193359375,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1613.0,
        -3400.03515625,
        1473.8125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1157427579164505,
        0.4319656789302826,
        -0.8944323658943176
      ],
      "plane_d": 2600.189208984375,
      "bbox_min": [
        -1613.0,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1611.0,
        -3398.860107421875,
        1474.1944580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18093794584274292,
        0.11946278810501099,
        0.9762121438980103
      ],
      "plane_d": -743.3792114257812,
      "bbox_min": [
        -1640.79345703125,
        -3445.635498046875,
        1483.306640625
      ],
      "bbox_max": [
        -1629.669921875,
        -3429.40625,
        1487.26513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9963745474815369,
        0.0845751017332077,
        0.009205454960465431
      ],
      "plane_d": -1354.2691650390625,
      "bbox_min": [
        -1633.395751953125,
        -3383.444091796875,
        1397.3492431640625
      ],
      "bbox_max": [
        -1633.291748046875,
        -3382.0,
        1406.7977294921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1632.0,
      "bbox_min": [
        -1640.79345703125,
        -3445.635498046875,
        1451.0
      ],
      "bbox_max": [
        -1599.897216796875,
        -3387.3935546875,
        1515.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        0.0,
        0.768221378326416
      ],
      "plane_d": -2200.9541015625,
      "bbox_min": [
        -1632.0,
        -3435.164306640625,
        1451.0
      ],
      "bbox_max": [
        -1599.897216796875,
        -3387.708740234375,
        1515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1515.0,
      "bbox_min": [
        -1632.0,
        -3435.164306640625,
        1451.0
      ],
      "bbox_max": [
        -1599.897216796875,
        -3387.708740234375,
        1515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        0.768221378326416,
        0.0
      ],
      "plane_d": 1562.9464111328125,
      "bbox_min": [
        -1632.0,
        -3435.164306640625,
        1451.0
      ],
      "bbox_max": [
        -1600.167236328125,
        -3387.708740234375,
        1515.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3410.0,
      "bbox_min": [
        -1632.0,
        -3435.164306640625,
        1451.0
      ],
      "bbox_max": [
        -1600.167236328125,
        -3388.471435546875,
        1515.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -3629.7470703125,
      "bbox_min": [
        -1632.0,
        -3435.164306640625,
        1468.0072021484375
      ],
      "bbox_max": [
        -1610.0,
        -3410.0,
        1515.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1500.5,
      "bbox_min": [
        -1632.0,
        -3435.164306640625,
        1468.0072021484375
      ],
      "bbox_max": [
        -1610.0,
        -3410.0,
        1515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5248578786849976,
        -0.5725721716880798,
        0.629829466342926
      ],
      "plane_d": -3767.23876953125,
      "bbox_min": [
        -1632.0,
        -3435.164306640625,
        1505.0
      ],
      "bbox_max": [
        -1613.8685302734375,
        -3428.0,
        1515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6726728081703186,
        0.7399401068687439
      ],
      "plane_d": -3426.931640625,
      "bbox_min": [
        -1620.0,
        -3433.10595703125,
        1510.3582763671875
      ],
      "bbox_max": [
        -1613.8685302734375,
        -3428.0,
        1515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1624.5,
      "bbox_min": [
        -1624.5,
        -3426.5,
        1468.0072021484375
      ],
      "bbox_max": [
        -1610.0,
        -3410.0,
        1500.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3411.5,
      "bbox_min": [
        -1624.5,
        -3426.5,
        1468.0072021484375
      ],
      "bbox_max": [
        -1610.0,
        -3410.0,
        1500.5
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1622.5,
      "bbox_min": [
        -1622.5,
        -3411.5,
        1486.5
      ],
      "bbox_max": [
        -1612.0,
        -3410.0,
        1499.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1499.0,
      "bbox_min": [
        -1622.5,
        -3411.5,
        1486.5
      ],
      "bbox_max": [
        -1612.0,
        -3410.0,
        1499.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1486.5,
      "bbox_min": [
        -1622.5,
        -3411.5,
        1486.5
      ],
      "bbox_max": [
        -1612.0,
        -3410.0,
        1499.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1612.0,
      "bbox_min": [
        -1612.0,
        -3411.5,
        1491.155517578125
      ],
      "bbox_max": [
        -1612.0,
        -3410.0,
        1499.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3426.5,
      "bbox_min": [
        -1624.5,
        -3426.5,
        1491.048095703125
      ],
      "bbox_max": [
        -1610.0,
        -3411.5,
        1500.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1610.0,
      "bbox_min": [
        -1610.0,
        -3413.43212890625,
        1497.531982421875
      ],
      "bbox_max": [
        -1610.0,
        -3411.5,
        1500.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18093794584274292,
        0.11946278810501099,
        0.9762121438980103
      ],
      "plane_d": -743.3792114257812,
      "bbox_min": [
        -1632.0,
        -3431.817138671875,
        1483.3648681640625
      ],
      "bbox_max": [
        -1630.4658203125,
        -3428.0,
        1483.9442138671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1631.0,
      "bbox_min": [
        -1632.0,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1600.167236328125,
        -3388.471435546875,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5076730847358704,
        0.6092077493667603,
        0.6092077493667603
      ],
      "plane_d": 322.57568359375,
      "bbox_min": [
        -1632.0,
        -3394.5,
        1505.0
      ],
      "bbox_max": [
        -1631.0,
        -3393.666748046875,
        1505.8333740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1486.5,
      "bbox_min": [
        -1631.0,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1600.167236328125,
        -3388.471435546875,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1451.0,
      "bbox_min": [
        -1631.0,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1610.324462890625,
        -3388.471435546875,
        1480.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3391.0,
      "bbox_min": [
        -1626.699951171875,
        -3391.0,
        1461.199951171875
      ],
      "bbox_max": [
        -1623.1383056640625,
        -3388.845947265625,
        1472.199951171875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1467.199951171875,
      "bbox_min": [
        -1626.699951171875,
        -3391.0,
        1466.199951171875
      ],
      "bbox_max": [
        -1623.7132568359375,
        -3389.340576171875,
        1472.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1472.199951171875,
      "bbox_min": [
        -1626.699951171875,
        -3391.0,
        1472.199951171875
      ],
      "bbox_max": [
        -1624.40283203125,
        -3389.93408203125,
        1472.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1466.199951171875,
      "bbox_min": [
        -1626.699951171875,
        -3391.0,
        1466.199951171875
      ],
      "bbox_max": [
        -1623.7132568359375,
        -3389.340576171875,
        1466.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3402.0,
      "bbox_min": [
        -1631.0,
        -3409.0,
        1475.0
      ],
      "bbox_max": [
        -1621.5714111328125,
        -3402.0,
        1478.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1475.0,
      "bbox_min": [
        -1631.0,
        -3409.0,
        1475.0
      ],
      "bbox_max": [
        -1627.5714111328125,
        -3402.0,
        1475.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22722961008548737,
        -0.2726755440235138,
        -0.9348875880241394
      ],
      "plane_d": 821.69482421875,
      "bbox_min": [
        -1631.0,
        -3410.0,
        1461.199951171875
      ],
      "bbox_max": [
        -1610.324462890625,
        -3389.44873046875,
        1480.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3402.0,
      "bbox_min": [
        -1625.85693359375,
        -3404.857177734375,
        1476.0001220703125
      ],
      "bbox_max": [
        -1619.0,
        -3402.0,
        1478.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": 1618.9998779296875,
      "bbox_min": [
        -1619.0,
        -3404.857177734375,
        1477.6666259765625
      ],
      "bbox_max": [
        -1619.0,
        -3402.0,
        1478.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.2800000011920929,
        -0.9599999785423279
      ],
      "plane_d": 465.99993896484375,
      "bbox_min": [
        -1627.5714111328125,
        -3410.0,
        1461.199951171875
      ],
      "bbox_max": [
        -1610.324462890625,
        -3389.44873046875,
        1480.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1613.5999755859375,
      "bbox_min": [
        -1613.5999755859375,
        -3397.60009765625,
        1476.080078125
      ],
      "bbox_max": [
        -1612.4000244140625,
        -3396.560302734375,
        1476.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1475.0,
      "bbox_min": [
        -1627.5714111328125,
        -3410.0,
        1462.630859375
      ],
      "bbox_max": [
        -1613.4256591796875,
        -3402.0,
        1478.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1618.9998779296875,
      "bbox_min": [
        -1619.0,
        -3409.0,
        1475.0
      ],
      "bbox_max": [
        -1613.4256591796875,
        -3402.0,
        1478.5
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3403.0,
      "bbox_min": [
        -1619.0,
        -3408.0,
        1476.0
      ],
      "bbox_max": [
        -1613.4256591796875,
        -3403.0,
        1477.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1476.0,
      "bbox_min": [
        -1619.0,
        -3408.0,
        1476.0
      ],
      "bbox_max": [
        -1614.162353515625,
        -3403.0,
        1477.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3404.5,
      "bbox_min": [
        -1619.0,
        -3408.0,
        1476.0
      ],
      "bbox_max": [
        -1614.557373046875,
        -3404.5,
        1477.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3406.5,
      "bbox_min": [
        -1619.0,
        -3408.0,
        1476.0
      ],
      "bbox_max": [
        -1616.0660400390625,
        -3406.5,
        1477.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3408.0,
      "bbox_min": [
        -1619.0,
        -3408.0,
        1476.0
      ],
      "bbox_max": [
        -1617.1976318359375,
        -3408.0,
        1477.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8682432174682617,
        0.4961389899253845
      ],
      "plane_d": 2232.37744140625,
      "bbox_min": [
        -1624.5,
        -3410.0,
        1462.630859375
      ],
      "bbox_max": [
        -1623.3719482421875,
        -3408.0,
        1468.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1624.5,
      "bbox_min": [
        -1624.5,
        -3410.0,
        1462.630859375
      ],
      "bbox_max": [
        -1623.5821533203125,
        -3408.0,
        1468.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3408.0,
      "bbox_min": [
        -1624.5,
        -3408.0,
        1462.630859375
      ],
      "bbox_max": [
        -1623.5821533203125,
        -3408.0,
        1464.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3391.0,
      "bbox_min": [
        -1624.9998779296875,
        -3400.78173828125,
        1461.199951171875
      ],
      "bbox_max": [
        -1610.9580078125,
        -3389.44873046875,
        1476.3834228515625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1467.199951171875,
      "bbox_min": [
        -1624.9998779296875,
        -3391.0,
        1467.199951171875
      ],
      "bbox_max": [
        -1621.896728515625,
        -3390.023681640625,
        1472.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46548134088516235,
        0.12473297119140625,
        0.8762242197990417
      ],
      "plane_d": -1619.906494140625,
      "bbox_min": [
        -1617.0,
        -3400.78173828125,
        1473.2999267578125
      ],
      "bbox_max": [
        -1610.9580078125,
        -3394.790771484375,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4654886722564697,
        -0.12473494559526443,
        0.8762200474739075
      ],
      "plane_d": -2467.354736328125,
      "bbox_min": [
        -1617.0,
        -3400.78173828125,
        1473.2999267578125
      ],
      "bbox_max": [
        -1610.9580078125,
        -3394.790771484375,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34074416756629944,
        -0.3408030867576599,
        0.8762114644050598
      ],
      "plane_d": -3000.11279296875,
      "bbox_min": [
        -1617.0,
        -3400.78173828125,
        1473.2999267578125
      ],
      "bbox_max": [
        -1610.9580078125,
        -3394.790771484375,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43197107315063477,
        0.1157442107796669,
        -0.8944295048713684
      ],
      "plane_d": 2409.443359375,
      "bbox_min": [
        -1617.0,
        -3400.78173828125,
        1473.2999267578125
      ],
      "bbox_max": [
        -1610.9580078125,
        -3394.790771484375,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31623297929763794,
        -0.31623297929763794,
        -0.8944234848022461
      ],
      "plane_d": 755.3223266601562,
      "bbox_min": [
        -1617.0,
        -3400.78173828125,
        1473.2999267578125
      ],
      "bbox_max": [
        -1610.9580078125,
        -3394.790771484375,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3407208025455475,
        0.34077969193458557,
        0.8762297630310059
      ],
      "plane_d": -684.7651977539062,
      "bbox_min": [
        -1616.464111328125,
        -3396.03515625,
        1473.2999267578125
      ],
      "bbox_max": [
        -1614.488525390625,
        -3394.790771484375,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4319745600223541,
        -0.11574513465166092,
        -0.8944277167320251
      ],
      "plane_d": 1623.076904296875,
      "bbox_min": [
        -1617.0,
        -3400.78173828125,
        1473.2999267578125
      ],
      "bbox_max": [
        -1610.9580078125,
        -3395.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12474536895751953,
        -0.46546870470046997,
        0.8762291669845581
      ],
      "plane_d": -3075.2216796875,
      "bbox_min": [
        -1616.464111328125,
        -3400.78173828125,
        1473.2999267578125
      ],
      "bbox_max": [
        -1610.9580078125,
        -3395.842529296875,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31622204184532166,
        0.31622204184532166,
        -0.8944312334060669
      ],
      "plane_d": 2903.765869140625,
      "bbox_min": [
        -1616.464111328125,
        -3400.78173828125,
        1473.2999267578125
      ],
      "bbox_max": [
        -1610.9580078125,
        -3395.842529296875,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12475047260522842,
        -0.4654877185821533,
        0.876218318939209
      ],
      "plane_d": -2672.83349609375,
      "bbox_min": [
        -1615.0,
        -3400.78173828125,
        1473.2999267578125
      ],
      "bbox_max": [
        -1610.9580078125,
        -3395.842529296875,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11574513465166092,
        0.4319745600223541,
        -0.8944277167320251
      ],
      "plane_d": 2973.6025390625,
      "bbox_min": [
        -1615.0,
        -3400.78173828125,
        1473.2999267578125
      ],
      "bbox_max": [
        -1610.9580078125,
        -3395.842529296875,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3407208025455475,
        -0.34077969193458557,
        0.8762297630310059
      ],
      "plane_d": -1900.857177734375,
      "bbox_min": [
        -1614.929443359375,
        -3400.01220703125,
        1473.777099609375
      ],
      "bbox_max": [
        -1610.9580078125,
        -3395.842529296875,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1157427579164505,
        0.4319656789302826,
        -0.8944323658943176
      ],
      "plane_d": 2600.189208984375,
      "bbox_min": [
        -1614.929443359375,
        -3400.01220703125,
        1473.777099609375
      ],
      "bbox_max": [
        -1610.9580078125,
        -3395.842529296875,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.46548134088516235,
        -0.12473297119140625,
        0.8762242197990417
      ],
      "plane_d": -965.699462890625,
      "bbox_min": [
        -1611.3291015625,
        -3398.0244140625,
        1474.2525634765625
      ],
      "bbox_max": [
        -1610.9580078125,
        -3397.511474609375,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1474.2999267578125,
      "bbox_min": [
        -1614.929443359375,
        -3398.929443359375,
        1474.1944580078125
      ],
      "bbox_max": [
        -1611.203857421875,
        -3395.842529296875,
        1474.2999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31623297929763794,
        0.31623297929763794,
        -0.8944234848022461
      ],
      "plane_d": 1883.6416015625,
      "bbox_min": [
        -1612.0352783203125,
        -3398.860107421875,
        1474.1944580078125
      ],
      "bbox_max": [
        -1611.2528076171875,
        -3397.96484375,
        1474.2999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3397.60009765625,
      "bbox_min": [
        -1613.5999755859375,
        -3397.60009765625,
        1474.4000244140625
      ],
      "bbox_max": [
        -1612.4000244140625,
        -3396.39990234375,
        1476.3834228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1612.4000244140625,
      "bbox_min": [
        -1613.5999755859375,
        -3397.60009765625,
        1474.4000244140625
      ],
      "bbox_max": [
        -1612.4000244140625,
        -3396.39990234375,
        1476.3834228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1613.5999755859375,
      "bbox_min": [
        -1613.5999755859375,
        -3397.60009765625,
        1474.4000244140625
      ],
      "bbox_max": [
        -1613.4061279296875,
        -3396.39990234375,
        1476.3834228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3396.39990234375,
      "bbox_min": [
        -1613.5999755859375,
        -3396.39990234375,
        1474.4000244140625
      ],
      "bbox_max": [
        -1613.4061279296875,
        -3396.39990234375,
        1475.0369873046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1514.0,
      "bbox_min": [
        -1631.0,
        -3410.0,
        1486.5
      ],
      "bbox_max": [
        -1600.167236328125,
        -3391.61669921875,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5076730847358704,
        0.6092077493667603,
        0.6092077493667603
      ],
      "plane_d": 322.57568359375,
      "bbox_min": [
        -1631.0,
        -3394.5,
        1505.0
      ],
      "bbox_max": [
        -1627.598388671875,
        -3392.763671875,
        1508.66796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1630.5,
      "bbox_min": [
        -1630.5,
        -3410.0,
        1486.5
      ],
      "bbox_max": [
        -1600.8455810546875,
        -3391.61669921875,
        1512.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1511.5,
      "bbox_min": [
        -1630.5,
        -3410.0,
        1486.5
      ],
      "bbox_max": [
        -1600.8455810546875,
        -3391.61669921875,
        1512.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3406.5,
      "bbox_min": [
        -1619.0,
        -3409.0,
        1511.5
      ],
      "bbox_max": [
        -1604.7205810546875,
        -3406.5,
        1512.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1619.0,
      "bbox_min": [
        -1619.0,
        -3409.0,
        1511.5
      ],
      "bbox_max": [
        -1619.0,
        -3406.5,
        1512.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1622.5,
      "bbox_min": [
        -1630.5,
        -3410.0,
        1486.5
      ],
      "bbox_max": [
        -1610.0,
        -3391.61669921875,
        1508.1119384765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3408.0,
      "bbox_min": [
        -1630.5,
        -3410.0,
        1486.5
      ],
      "bbox_max": [
        -1622.5,
        -3391.61669921875,
        1508.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1624.5,
      "bbox_min": [
        -1624.5,
        -3410.0,
        1486.5
      ],
      "bbox_max": [
        -1622.5,
        -3408.0,
        1503.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.8320503234863281,
        0.5547001957893372
      ],
      "plane_d": 2003.2998046875,
      "bbox_min": [
        -1624.5,
        -3410.0,
        1500.5
      ],
      "bbox_max": [
        -1622.5,
        -3408.0,
        1503.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.650791347026825,
        -0.7592566013336182,
        0.0
      ],
      "plane_d": -1516.56103515625,
      "bbox_min": [
        -1630.5,
        -3395.0,
        1486.5
      ],
      "bbox_max": [
        -1626.4400634765625,
        -3391.61669921875,
        1508.1119384765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5301920771598816,
        -0.6185574531555176,
        -0.5798990726470947
      ],
      "plane_d": -363.12420654296875,
      "bbox_min": [
        -1630.5,
        -3395.0,
        1504.4000244140625
      ],
      "bbox_max": [
        -1626.4400634765625,
        -3393.349609375,
        1508.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1612.0,
      "bbox_min": [
        -1612.0,
        -3410.0,
        1488.08349609375
      ],
      "bbox_max": [
        -1610.0,
        -3408.0,
        1503.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3408.0,
      "bbox_min": [
        -1612.0,
        -3410.0,
        1488.08349609375
      ],
      "bbox_max": [
        -1610.0,
        -3408.0,
        1503.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        -1612.0,
        -3410.0,
        1492.15576171875
      ],
      "bbox_max": [
        -1610.0,
        -3408.0,
        1503.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.8320503234863281,
        0.5547001957893372
      ],
      "plane_d": 2003.2998046875,
      "bbox_min": [
        -1612.0,
        -3410.0,
        1500.5
      ],
      "bbox_max": [
        -1610.0,
        -3408.0,
        1503.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18482716381549835,
        0.05494603142142296,
        0.9812338948249817
      ],
      "plane_d": -963.463623046875,
      "bbox_min": [
        -1632.0,
        -3394.5,
        1478.163330078125
      ],
      "bbox_max": [
        -1626.8314208984375,
        -3387.708740234375,
        1479.3780517578125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.18092861771583557,
        0.11946766078472137,
        0.9762132167816162
      ],
      "plane_d": -743.3794555664062,
      "bbox_min": [
        -1640.79345703125,
        -3445.635498046875,
        1478.997802734375
      ],
      "bbox_max": [
        -1632.0,
        -3387.3935546875,
        1487.26513671875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.18484441936016083,
        0.054944735020399094,
        0.9812306761741638
      ],
      "plane_d": -963.43505859375,
      "bbox_min": [
        -1633.66796875,
        -3394.5849609375,
        1478.997802734375
      ],
      "bbox_max": [
        -1632.0,
        -3387.3935546875,
        1479.697021484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9963745474815369,
        0.0845751017332077,
        0.009205454960465431
      ],
      "plane_d": -1354.2691650390625,
      "bbox_min": [
        -1633.66796875,
        -3394.5849609375,
        1404.79150390625
      ],
      "bbox_max": [
        -1632.6556396484375,
        -3382.0,
        1479.697021484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18484441936016083,
        0.054944735020399094,
        0.9812306761741638
      ],
      "plane_d": -963.43505859375,
      "bbox_min": [
        -1633.66796875,
        -3394.5849609375,
        1479.1036376953125
      ],
      "bbox_max": [
        -1632.6556396484375,
        -3387.205810546875,
        1479.697021484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8500498533248901,
        0.5251100659370422,
        0.04092385247349739
      ],
      "plane_d": 3041.765869140625,
      "bbox_min": [
        -1633.0465087890625,
        -3440.310546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -1523.64404296875,
        -3382.0,
        1515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9963745474815369,
        0.0845751017332077,
        0.009205454960465431
      ],
      "plane_d": -1354.2691650390625,
      "bbox_min": [
        -1632.943115234375,
        -3382.923095703125,
        1444.9290771484375
      ],
      "bbox_max": [
        -1632.8648681640625,
        -3382.0,
        1451.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3386.0,
      "bbox_min": [
        -1633.0465087890625,
        -3440.310546875,
        1451.0
      ],
      "bbox_max": [
        -1523.64404296875,
        -3382.0,
        1486.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3384.5,
      "bbox_min": [
        -1633.0174560546875,
        -3386.0,
        1451.0
      ],
      "bbox_max": [
        -1588.8671875,
        -3382.0,
        1486.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.9963745474815369,
        0.0845751017332077,
        0.009205454960465431
      ],
      "plane_d": -1354.2691650390625,
      "bbox_min": [
        -1633.0174560546875,
        -3386.0,
        1461.37109375
      ],
      "bbox_max": [
        -1620.0,
        -3384.5,
        1479.080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18482716381549835,
        0.05494603142142296,
        0.9812338948249817
      ],
      "plane_d": -963.463623046875,
      "bbox_min": [
        -1632.9449462890625,
        -3386.0,
        1476.5577392578125
      ],
      "bbox_max": [
        -1620.0,
        -3384.5,
        1479.080078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.1848299503326416,
        0.05494631081819534,
        0.9812332391738892
      ],
      "plane_d": -963.4571533203125,
      "bbox_min": [
        -1632.818603515625,
        -3384.5,
        1472.6285400390625
      ],
      "bbox_max": [
        -1599.140380859375,
        -3382.0,
        1478.9722900390625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.18093766272068024,
        0.11946627497673035,
        0.9762117862701416
      ],
      "plane_d": -743.3670654296875,
      "bbox_min": [
        -1542.9244384765625,
        -3440.310546875,
        1459.0
      ],
      "bbox_max": [
        -1523.64404296875,
        -3425.24755859375,
        1477.566162109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -1487.699951171875,
      "bbox_min": [
        -1541.801025390625,
        -3431.484130859375,
        1459.0
      ],
      "bbox_max": [
        -1538.0,
        -3425.24755859375,
        1467.185302734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1538.0,
      "bbox_min": [
        -1538.0,
        -3428.0,
        1459.0
      ],
      "bbox_max": [
        -1538.0,
        -3425.24755859375,
        1463.5579833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -1487.699951171875,
      "bbox_min": [
        -1542.9244384765625,
        -3432.51416015625,
        1466.345947265625
      ],
      "bbox_max": [
        -1538.9801025390625,
        -3428.8984375,
        1477.566162109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        0.768221378326416,
        0.0
      ],
      "plane_d": 1562.9464111328125,
      "bbox_min": [
        -1633.0465087890625,
        -3397.60009765625,
        1473.0
      ],
      "bbox_max": [
        -1598.4000244140625,
        -3386.0,
        1486.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1599.5999755859375,
      "bbox_min": [
        -1613.5999755859375,
        -3397.60009765625,
        1476.0333251953125
      ],
      "bbox_max": [
        -1598.4000244140625,
        -3396.39990234375,
        1476.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3396.39990234375,
      "bbox_min": [
        -1599.5999755859375,
        -3397.60009765625,
        1476.0333251953125
      ],
      "bbox_max": [
        -1598.4000244140625,
        -3396.39990234375,
        1476.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1598.4000244140625,
      "bbox_min": [
        -1599.5999755859375,
        -3397.60009765625,
        1476.0333251953125
      ],
      "bbox_max": [
        -1598.4000244140625,
        -3396.39990234375,
        1476.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3397.60009765625,
      "bbox_min": [
        -1599.5999755859375,
        -3397.60009765625,
        1476.3834228515625
      ],
      "bbox_max": [
        -1598.4000244140625,
        -3397.60009765625,
        1476.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3396.39990234375,
      "bbox_min": [
        -1613.5999755859375,
        -3397.2470703125,
        1476.0333251953125
      ],
      "bbox_max": [
        -1612.4000244140625,
        -3396.39990234375,
        1476.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1612.4000244140625,
      "bbox_min": [
        -1613.5999755859375,
        -3397.2470703125,
        1476.0333251953125
      ],
      "bbox_max": [
        -1612.4000244140625,
        -3396.39990234375,
        1476.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1613.5999755859375,
      "bbox_min": [
        -1613.5999755859375,
        -3396.640380859375,
        1476.0333251953125
      ],
      "bbox_max": [
        -1613.5999755859375,
        -3396.39990234375,
        1476.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18482716381549835,
        0.05494603142142296,
        0.9812338948249817
      ],
      "plane_d": -963.463623046875,
      "bbox_min": [
        -1633.0465087890625,
        -3390.19287109375,
        1473.0
      ],
      "bbox_max": [
        -1621.800048828125,
        -3386.0,
        1479.166748046875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9963745474815369,
        0.0845751017332077,
        0.009205454960465431
      ],
      "plane_d": -1354.2691650390625,
      "bbox_min": [
        -1633.0465087890625,
        -3387.205810546875,
        1473.0
      ],
      "bbox_max": [
        -1632.9449462890625,
        -3386.0,
        1479.166748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3403.0,
      "bbox_min": [
        -1633.024169921875,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1553.6419677734375,
        -3386.0,
        1477.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1476.0,
      "bbox_min": [
        -1600.836181640625,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1553.6419677734375,
        -3403.0,
        1477.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3404.5,
      "bbox_min": [
        -1598.325439453125,
        -3408.0,
        1476.0
      ],
      "bbox_max": [
        -1572.345947265625,
        -3404.5,
        1477.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3406.5,
      "bbox_min": [
        -1594.368896484375,
        -3408.0,
        1476.0
      ],
      "bbox_max": [
        -1572.345947265625,
        -3406.5,
        1477.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3408.0,
      "bbox_min": [
        -1591.4013671875,
        -3408.0,
        1476.0
      ],
      "bbox_max": [
        -1572.345947265625,
        -3408.0,
        1477.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.96592116355896,
        0.25883668661117554,
        0.0
      ],
      "plane_d": 2405.890869140625,
      "bbox_min": [
        -1595.28466796875,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1553.6419677734375,
        -3405.0,
        1473.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 1287.7615966796875,
      "bbox_min": [
        -1595.28466796875,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1577.0,
        -3405.0,
        1473.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.25883668661117554,
        0.96592116355896,
        0.0
      ],
      "plane_d": 3698.441162109375,
      "bbox_min": [
        -1586.8895263671875,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1577.0,
        -3405.0,
        1473.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.25883668661117554,
        0.96592116355896,
        0.0
      ],
      "plane_d": 2879.48193359375,
      "bbox_min": [
        -1586.8895263671875,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1577.0,
        -3405.0,
        1473.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 3525.0478515625,
      "bbox_min": [
        -1586.8895263671875,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1577.0,
        -3405.0,
        1473.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.96592116355896,
        0.25883668661117554,
        0.0
      ],
      "plane_d": -650.2837524414062,
      "bbox_min": [
        -1586.8895263671875,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1577.0,
        -3405.0,
        1473.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1473.0,
      "bbox_min": [
        -1586.8895263671875,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1577.0,
        -3405.0,
        1473.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1454.5,
      "bbox_min": [
        -1586.013671875,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1577.0,
        -3405.0,
        1454.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3406.5,
      "bbox_min": [
        -1584.0,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1580.0,
        -3406.5,
        1454.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1580.0,
      "bbox_min": [
        -1584.0,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1580.0,
        -3406.5,
        1454.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1584.0,
      "bbox_min": [
        -1584.0,
        -3408.201171875,
        1451.0
      ],
      "bbox_max": [
        -1584.0,
        -3406.5,
        1454.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25883668661117554,
        0.96592116355896,
        0.0
      ],
      "plane_d": 3701.54736328125,
      "bbox_min": [
        -1595.28466796875,
        -3408.289306640625,
        1462.6842041015625
      ],
      "bbox_max": [
        -1589.4583740234375,
        -3405.0,
        1473.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 3533.532958984375,
      "bbox_min": [
        -1595.28466796875,
        -3408.289306640625,
        1462.6842041015625
      ],
      "bbox_max": [
        -1589.4583740234375,
        -3405.0,
        1473.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.25883668661117554,
        0.96592116355896,
        0.0
      ],
      "plane_d": 2876.3759765625,
      "bbox_min": [
        -1595.28466796875,
        -3408.289306640625,
        1466.5419921875
      ],
      "bbox_max": [
        -1589.4583740234375,
        -3405.0,
        1473.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1473.0,
      "bbox_min": [
        -1595.28466796875,
        -3408.289306640625,
        1468.5660400390625
      ],
      "bbox_max": [
        -1589.4583740234375,
        -3405.0,
        1473.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.96592116355896,
        0.25883668661117554,
        0.0
      ],
      "plane_d": 2417.48193359375,
      "bbox_min": [
        -1589.669921875,
        -3408.289306640625,
        1468.5660400390625
      ],
      "bbox_max": [
        -1589.4583740234375,
        -3407.5,
        1473.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.96592116355896,
        0.25883668661117554,
        0.0
      ],
      "plane_d": 2394.2998046875,
      "bbox_min": [
        -1575.0,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1553.6419677734375,
        -3405.0,
        1473.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.96592116355896,
        0.25883668661117554,
        0.0
      ],
      "plane_d": -638.6926879882812,
      "bbox_min": [
        -1575.0,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1565.0,
        -3405.0,
        1473.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.25883668661117554,
        0.96592116355896,
        0.0
      ],
      "plane_d": 3695.335205078125,
      "bbox_min": [
        -1575.0,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1565.0,
        -3405.0,
        1473.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.25883668661117554,
        0.96592116355896,
        0.0
      ],
      "plane_d": 2882.588134765625,
      "bbox_min": [
        -1575.0,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1565.0,
        -3405.0,
        1473.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 3516.5625,
      "bbox_min": [
        -1575.0,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1565.0,
        -3405.0,
        1473.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 1296.246826171875,
      "bbox_min": [
        -1575.0,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1565.0,
        -3405.0,
        1473.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1454.5,
      "bbox_min": [
        -1575.0,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1565.0,
        -3405.0,
        1473.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1473.0,
      "bbox_min": [
        -1575.0,
        -3410.0,
        1473.0
      ],
      "bbox_max": [
        -1567.5875244140625,
        -3405.889404296875,
        1473.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3406.5,
      "bbox_min": [
        -1572.0,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1568.0,
        -3406.5,
        1454.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1572.0,
      "bbox_min": [
        -1572.0,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1568.0,
        -3406.5,
        1454.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1568.0,
      "bbox_min": [
        -1568.0,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1568.0,
        -3406.5,
        1454.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1454.5,
      "bbox_min": [
        -1563.0,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1553.6419677734375,
        -3405.37841796875,
        1466.9139404296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.96592116355896,
        0.25883668661117554,
        0.0
      ],
      "plane_d": -627.1016235351562,
      "bbox_min": [
        -1563.0,
        -3410.0,
        1454.5
      ],
      "bbox_max": [
        -1559.4117431640625,
        -3405.37841796875,
        1466.9139404296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 1304.732177734375,
      "bbox_min": [
        -1562.330078125,
        -3407.5,
        1454.5
      ],
      "bbox_max": [
        -1559.4117431640625,
        -3405.37841796875,
        1461.8843994140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25883668661117554,
        0.96592116355896,
        0.0
      ],
      "plane_d": 2885.694091796875,
      "bbox_min": [
        -1560.5,
        -3405.669921875,
        1454.5
      ],
      "bbox_max": [
        -1559.4117431640625,
        -3405.37841796875,
        1456.426513671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1560.0,
      "bbox_min": [
        -1560.0,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1556.0,
        -3406.5,
        1454.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3406.5,
      "bbox_min": [
        -1560.0,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1556.0,
        -3406.5,
        1454.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1556.0,
      "bbox_min": [
        -1556.0,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1556.0,
        -3406.5,
        1454.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1465.199951171875,
      "bbox_min": [
        -1633.024169921875,
        -3401.0,
        1451.0
      ],
      "bbox_max": [
        -1576.0,
        -3386.0,
        1476.3834228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1462.199951171875,
      "bbox_min": [
        -1625.3411865234375,
        -3391.0,
        1451.0
      ],
      "bbox_max": [
        -1576.0,
        -3386.0,
        1465.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3390.0,
      "bbox_min": [
        -1625.3411865234375,
        -3391.0,
        1462.199951171875
      ],
      "bbox_max": [
        -1583.1650390625,
        -3386.0,
        1465.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6401844024658203,
        -0.768221378326416,
        0.0
      ],
      "plane_d": -1564.739013671875,
      "bbox_min": [
        -1625.3411865234375,
        -3389.831787109375,
        1462.199951171875
      ],
      "bbox_max": [
        -1590.0,
        -3386.0,
        1465.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        0.768221378326416,
        0.0
      ],
      "plane_d": 1562.9464111328125,
      "bbox_min": [
        -1625.3411865234375,
        -3388.950927734375,
        1462.199951171875
      ],
      "bbox_max": [
        -1621.800048828125,
        -3386.0,
        1465.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 1618.9998779296875,
      "bbox_min": [
        -1619.0,
        -3387.0,
        1462.199951171875
      ],
      "bbox_max": [
        -1590.0,
        -3386.0,
        1465.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1589.9998779296875,
      "bbox_min": [
        -1590.0,
        -3387.0,
        1462.199951171875
      ],
      "bbox_max": [
        -1590.0,
        -3386.0,
        1464.642822265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1618.9998779296875,
      "bbox_min": [
        -1619.0,
        -3391.0,
        1462.199951171875
      ],
      "bbox_max": [
        -1590.0,
        -3390.0,
        1465.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": -1589.9998779296875,
      "bbox_min": [
        -1590.0,
        -3391.0,
        1462.199951171875
      ],
      "bbox_max": [
        -1590.0,
        -3390.0,
        1465.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6401844024658203,
        -0.768221378326416,
        0.0
      ],
      "plane_d": -1564.739013671875,
      "bbox_min": [
        -1624.996337890625,
        -3391.0,
        1451.0
      ],
      "bbox_max": [
        -1576.0,
        -3386.0,
        1462.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1461.199951171875,
      "bbox_min": [
        -1624.33056640625,
        -3389.44873046875,
        1461.199951171875
      ],
      "bbox_max": [
        -1619.0,
        -3386.0,
        1461.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7117644548416138,
        0.7024182677268982
      ],
      "plane_d": -3433.10546875,
      "bbox_min": [
        -1623.1383056640625,
        -3391.0,
        1451.0
      ],
      "bbox_max": [
        -1576.0,
        -3386.0,
        1462.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3390.39990234375,
      "bbox_min": [
        -1588.5,
        -3390.39990234375,
        1451.0
      ],
      "bbox_max": [
        -1576.0,
        -3386.0,
        1456.49853515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1588.5,
      "bbox_min": [
        -1588.5,
        -3390.39990234375,
        1451.0
      ],
      "bbox_max": [
        -1576.0,
        -3386.0,
        1456.49853515625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1576.0,
      "bbox_min": [
        -1576.0,
        -3390.39990234375,
        1451.0
      ],
      "bbox_max": [
        -1576.0,
        -3389.9765625,
        1451.7010498046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1461.199951171875,
      "bbox_min": [
        -1623.1383056640625,
        -3391.0,
        1455.0799560546875
      ],
      "bbox_max": [
        -1582.2923583984375,
        -3386.0,
        1462.199951171875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3391.0,
      "bbox_min": [
        -1620.3740234375,
        -3391.0,
        1461.199951171875
      ],
      "bbox_max": [
        -1582.4112548828125,
        -3386.0,
        1462.199951171875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3390.39990234375,
      "bbox_min": [
        -1588.5,
        -3390.39990234375,
        1455.0799560546875
      ],
      "bbox_max": [
        -1582.2923583984375,
        -3386.0,
        1461.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1588.5,
      "bbox_min": [
        -1588.5,
        -3390.39990234375,
        1455.0799560546875
      ],
      "bbox_max": [
        -1582.2923583984375,
        -3386.0,
        1461.199951171875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3387.39990234375,
      "bbox_min": [
        -1588.5,
        -3387.39990234375,
        1455.0799560546875
      ],
      "bbox_max": [
        -1582.2923583984375,
        -3387.39990234375,
        1457.1199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1468.199951171875,
      "bbox_min": [
        -1633.024169921875,
        -3401.0,
        1465.199951171875
      ],
      "bbox_max": [
        -1581.2626953125,
        -3386.0,
        1476.3834228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3390.0,
      "bbox_min": [
        -1633.024169921875,
        -3401.0,
        1468.199951171875
      ],
      "bbox_max": [
        -1581.2626953125,
        -3386.0,
        1476.3834228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1471.199951171875,
      "bbox_min": [
        -1633.024169921875,
        -3390.0,
        1468.199951171875
      ],
      "bbox_max": [
        -1591.197998046875,
        -3386.0,
        1474.166748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6401844024658203,
        -0.768221378326416,
        0.0
      ],
      "plane_d": -1564.739013671875,
      "bbox_min": [
        -1626.031005859375,
        -3390.0,
        1468.199951171875
      ],
      "bbox_max": [
        -1619.0,
        -3386.0,
        1471.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        0.768221378326416,
        0.0
      ],
      "plane_d": 1562.9464111328125,
      "bbox_min": [
        -1626.031005859375,
        -3389.525634765625,
        1468.199951171875
      ],
      "bbox_max": [
        -1621.800048828125,
        -3386.0,
        1471.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 1618.9998779296875,
      "bbox_min": [
        -1619.0,
        -3387.0,
        1468.199951171875
      ],
      "bbox_max": [
        -1619.0,
        -3386.0,
        1471.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        0.768221378326416,
        0.0
      ],
      "plane_d": 1562.9464111328125,
      "bbox_min": [
        -1633.024169921875,
        -3390.0,
        1471.199951171875
      ],
      "bbox_max": [
        -1619.0,
        -3386.0,
        1474.166748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22722961008548737,
        -0.2726755440235138,
        -0.9348875880241394
      ],
      "plane_d": 821.69482421875,
      "bbox_min": [
        -1625.52734375,
        -3390.0,
        1471.199951171875
      ],
      "bbox_max": [
        -1619.0,
        -3386.0,
        1474.166748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 1618.9998779296875,
      "bbox_min": [
        -1625.52734375,
        -3390.0,
        1471.199951171875
      ],
      "bbox_max": [
        -1619.0,
        -3386.0,
        1473.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1472.199951171875,
      "bbox_min": [
        -1625.52734375,
        -3390.0,
        1471.199951171875
      ],
      "bbox_max": [
        -1619.0,
        -3386.0,
        1473.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6401844024658203,
        -0.768221378326416,
        0.0
      ],
      "plane_d": -1564.739013671875,
      "bbox_min": [
        -1623.7999267578125,
        -3390.0,
        1471.199951171875
      ],
      "bbox_max": [
        -1619.0,
        -3386.0,
        1472.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22722961008548737,
        -0.2726755440235138,
        -0.9348875880241394
      ],
      "plane_d": 821.69482421875,
      "bbox_min": [
        -1625.39697265625,
        -3401.0,
        1468.199951171875
      ],
      "bbox_max": [
        -1581.2626953125,
        -3390.0,
        1476.3834228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1472.199951171875,
      "bbox_min": [
        -1625.39697265625,
        -3391.0,
        1468.199951171875
      ],
      "bbox_max": [
        -1619.0,
        -3390.0,
        1473.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6401844024658203,
        -0.768221378326416,
        0.0
      ],
      "plane_d": -1564.739013671875,
      "bbox_min": [
        -1624.40283203125,
        -3390.50244140625,
        1468.199951171875
      ],
      "bbox_max": [
        -1623.7998046875,
        -3390.0,
        1472.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6401844024658203,
        -0.768221378326416,
        0.0
      ],
      "plane_d": -1564.739013671875,
      "bbox_min": [
        -1624.4947509765625,
        -3390.5791015625,
        1472.199951171875
      ],
      "bbox_max": [
        -1623.7998046875,
        -3390.0,
        1473.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": -1589.9998779296875,
      "bbox_min": [
        -1590.0,
        -3391.0,
        1468.199951171875
      ],
      "bbox_max": [
        -1590.0,
        -3390.0,
        1471.26708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1474.39990234375,
      "bbox_min": [
        -1616.2547607421875,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1581.2626953125,
        -3393.0,
        1476.3834228515625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.46548134088516235,
        -0.12473297119140625,
        0.8762242197990417
      ],
      "plane_d": -972.2161865234375,
      "bbox_min": [
        -1616.2547607421875,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1581.2626953125,
        -3393.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46548134088516235,
        0.12473297119140625,
        0.8762242197990417
      ],
      "plane_d": -1613.3896484375,
      "bbox_min": [
        -1616.2547607421875,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1595.0,
        -3393.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12474536895751953,
        0.46546870470046997,
        0.8762291669845581
      ],
      "plane_d": 487.854736328125,
      "bbox_min": [
        -1603.0,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1595.0,
        -3393.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12475047260522842,
        0.4654877185821533,
        0.876218318939209
      ],
      "plane_d": 88.991455078125,
      "bbox_min": [
        -1603.0,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1595.0,
        -3393.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31623297929763794,
        -0.31623297929763794,
        -0.8944234848022461
      ],
      "plane_d": 750.8950805664062,
      "bbox_min": [
        -1603.0,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1595.0,
        -3393.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3407208025455475,
        0.34077969193458557,
        0.8762297630310059
      ],
      "plane_d": -679.9951171875,
      "bbox_min": [
        -1602.464111328125,
        -3396.03515625,
        1473.2999267578125
      ],
      "bbox_max": [
        -1599.9647216796875,
        -3393.535888671875,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12474536895751953,
        -0.46546870470046997,
        0.8762291669845581
      ],
      "plane_d": -3073.47509765625,
      "bbox_min": [
        -1603.0,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1595.0,
        -3393.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12475047260522842,
        -0.4654877185821533,
        0.876218318939209
      ],
      "plane_d": -2674.580078125,
      "bbox_min": [
        -1603.0,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1595.0,
        -3393.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31623297929763794,
        0.31623297929763794,
        -0.8944234848022461
      ],
      "plane_d": 1888.06884765625,
      "bbox_min": [
        -1603.0,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1595.0,
        -3393.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3407208025455475,
        -0.34077969193458557,
        0.8762297630310059
      ],
      "plane_d": -1905.627197265625,
      "bbox_min": [
        -1598.0352783203125,
        -3400.464111328125,
        1473.2999267578125
      ],
      "bbox_max": [
        -1595.535888671875,
        -3397.96484375,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4654886722564697,
        0.12473494559526443,
        0.8762200474739075
      ],
      "plane_d": -124.7559814453125,
      "bbox_min": [
        -1603.0,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1595.0,
        -3393.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31622204184532166,
        -0.31622204184532166,
        -0.8944312334060669
      ],
      "plane_d": -260.3519287109375,
      "bbox_min": [
        -1603.0,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1595.0,
        -3393.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34074416756629944,
        0.3408030867576599,
        0.8762114644050598
      ],
      "plane_d": 409.7738037109375,
      "bbox_min": [
        -1598.0352783203125,
        -3396.03515625,
        1473.2999267578125
      ],
      "bbox_max": [
        -1595.535888671875,
        -3393.535888671875,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4654886722564697,
        -0.12473494559526443,
        0.8762200474739075
      ],
      "plane_d": -2460.837890625,
      "bbox_min": [
        -1603.0,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1595.0,
        -3393.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31622204184532166,
        0.31622204184532166,
        -0.8944312334060669
      ],
      "plane_d": 2899.3388671875,
      "bbox_min": [
        -1603.0,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1595.0,
        -3393.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34074416756629944,
        -0.3408030867576599,
        0.8762114644050598
      ],
      "plane_d": -2995.34228515625,
      "bbox_min": [
        -1602.464111328125,
        -3400.464111328125,
        1473.2999267578125
      ],
      "bbox_max": [
        -1599.9647216796875,
        -3397.96484375,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11574513465166092,
        -0.4319745600223541,
        -0.8944277167320251
      ],
      "plane_d": -333.005859375,
      "bbox_min": [
        -1603.0,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1595.0,
        -3393.0,
        1474.2999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11574513465166092,
        0.4319745600223541,
        -0.8944277167320251
      ],
      "plane_d": 2971.982177734375,
      "bbox_min": [
        -1603.0,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1595.0,
        -3393.0,
        1474.2999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1157427579164505,
        -0.4319656789302826,
        -0.8944323658943176
      ],
      "plane_d": 37.18017578125,
      "bbox_min": [
        -1603.0,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1595.0,
        -3393.0,
        1474.2999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1157427579164505,
        0.4319656789302826,
        -0.8944323658943176
      ],
      "plane_d": 2601.8095703125,
      "bbox_min": [
        -1603.0,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1595.0,
        -3395.0,
        1474.2999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4319745600223541,
        0.11574513465166092,
        -0.8944277167320251
      ],
      "plane_d": 1021.9470825195312,
      "bbox_min": [
        -1603.0,
        -3399.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1595.0,
        -3395.0,
        1474.2999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.43197107315063477,
        -0.1157442107796669,
        -0.8944295048713684
      ],
      "plane_d": 235.5860595703125,
      "bbox_min": [
        -1603.0,
        -3399.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1595.0,
        -3395.0,
        1474.2999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4319745600223541,
        -0.11574513465166092,
        -0.8944277167320251
      ],
      "plane_d": 1617.029296875,
      "bbox_min": [
        -1603.0,
        -3399.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1597.070556640625,
        -3395.0,
        1474.2999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43197107315063477,
        0.1157442107796669,
        -0.8944295048713684
      ],
      "plane_d": 2403.3955078125,
      "bbox_min": [
        -1603.0,
        -3399.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1597.070556640625,
        -3395.070556640625,
        1474.2999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1474.2999267578125,
      "bbox_min": [
        -1600.929443359375,
        -3398.929443359375,
        1474.2999267578125
      ],
      "bbox_max": [
        -1597.070556640625,
        -3395.070556640625,
        1474.2999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12474536895751953,
        0.46546870470046997,
        0.8762291669845581
      ],
      "plane_d": 489.6011962890625,
      "bbox_min": [
        -1616.2547607421875,
        -3398.283935546875,
        1473.2999267578125
      ],
      "bbox_max": [
        -1609.0,
        -3393.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12475047260522842,
        0.4654877185821533,
        0.876218318939209
      ],
      "plane_d": 87.244873046875,
      "bbox_min": [
        -1616.2547607421875,
        -3398.283935546875,
        1473.2999267578125
      ],
      "bbox_max": [
        -1609.0,
        -3393.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4654886722564697,
        0.12473494559526443,
        0.8762200474739075
      ],
      "plane_d": -118.2391357421875,
      "bbox_min": [
        -1616.2547607421875,
        -3398.283935546875,
        1473.2999267578125
      ],
      "bbox_max": [
        -1609.0,
        -3393.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31622204184532166,
        -0.31622204184532166,
        -0.8944312334060669
      ],
      "plane_d": -264.779052734375,
      "bbox_min": [
        -1616.2547607421875,
        -3398.283935546875,
        1473.2999267578125
      ],
      "bbox_max": [
        -1609.0,
        -3393.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34074416756629944,
        0.3408030867576599,
        0.8762114644050598
      ],
      "plane_d": 414.544189453125,
      "bbox_min": [
        -1612.0352783203125,
        -3396.03515625,
        1473.2999267578125
      ],
      "bbox_max": [
        -1609.535888671875,
        -3393.535888671875,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31623297929763794,
        -0.31623297929763794,
        -0.8944234848022461
      ],
      "plane_d": 755.3223266601562,
      "bbox_min": [
        -1616.2547607421875,
        -3398.283935546875,
        1473.2999267578125
      ],
      "bbox_max": [
        -1609.0,
        -3393.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3407208025455475,
        0.34077969193458557,
        0.8762297630310059
      ],
      "plane_d": -684.7651977539062,
      "bbox_min": [
        -1616.2547607421875,
        -3395.852783203125,
        1473.2999267578125
      ],
      "bbox_max": [
        -1613.9647216796875,
        -3393.535888671875,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11574513465166092,
        -0.4319745600223541,
        -0.8944277167320251
      ],
      "plane_d": -334.6263427734375,
      "bbox_min": [
        -1615.0,
        -3398.283935546875,
        1473.2999267578125
      ],
      "bbox_max": [
        -1609.0,
        -3393.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1157427579164505,
        -0.4319656789302826,
        -0.8944323658943176
      ],
      "plane_d": 38.8006591796875,
      "bbox_min": [
        -1615.0,
        -3398.283935546875,
        1473.2999267578125
      ],
      "bbox_max": [
        -1609.0,
        -3393.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4319745600223541,
        0.11574513465166092,
        -0.8944277167320251
      ],
      "plane_d": 1015.8994140625,
      "bbox_min": [
        -1614.478271484375,
        -3398.283935546875,
        1473.2999267578125
      ],
      "bbox_max": [
        -1609.0,
        -3395.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.46548134088516235,
        -0.12473297119140625,
        0.8762242197990417
      ],
      "plane_d": -965.699462890625,
      "bbox_min": [
        -1611.2076416015625,
        -3398.283935546875,
        1473.2999267578125
      ],
      "bbox_max": [
        -1609.0,
        -3397.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1474.2999267578125,
      "bbox_min": [
        -1614.478271484375,
        -3397.49755859375,
        1473.2999267578125
      ],
      "bbox_max": [
        -1609.0,
        -3395.0,
        1474.2999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.43197107315063477,
        -0.1157442107796669,
        -0.8944295048713684
      ],
      "plane_d": 229.5384521484375,
      "bbox_min": [
        -1611.3291015625,
        -3397.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1609.0,
        -3395.0,
        1474.2999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12474536895751953,
        -0.46546870470046997,
        0.8762291669845581
      ],
      "plane_d": -3071.66650390625,
      "bbox_min": [
        -1588.5,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1581.2626953125,
        -3394.3662109375,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12475047260522842,
        -0.4654877185821533,
        0.876218318939209
      ],
      "plane_d": -2676.38916015625,
      "bbox_min": [
        -1588.5,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1581.2626953125,
        -3394.3662109375,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46548134088516235,
        0.12473297119140625,
        0.8762242197990417
      ],
      "plane_d": -1606.6402587890625,
      "bbox_min": [
        -1588.5,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1581.2626953125,
        -3394.3662109375,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4654886722564697,
        -0.12473494559526443,
        0.8762200474739075
      ],
      "plane_d": -2454.08837890625,
      "bbox_min": [
        -1588.5,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1581.2626953125,
        -3394.3662109375,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31622204184532166,
        0.31622204184532166,
        -0.8944312334060669
      ],
      "plane_d": 2894.75341796875,
      "bbox_min": [
        -1588.5,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1581.2626953125,
        -3394.3662109375,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34074416756629944,
        -0.3408030867576599,
        0.8762114644050598
      ],
      "plane_d": -2990.4013671875,
      "bbox_min": [
        -1587.964111328125,
        -3400.464111328125,
        1473.2999267578125
      ],
      "bbox_max": [
        -1585.4647216796875,
        -3397.96484375,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31623297929763794,
        0.31623297929763794,
        -0.8944234848022461
      ],
      "plane_d": 1892.6541748046875,
      "bbox_min": [
        -1588.5,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1581.2626953125,
        -3394.3662109375,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3407208025455475,
        -0.34077969193458557,
        0.8762297630310059
      ],
      "plane_d": -1910.567626953125,
      "bbox_min": [
        -1583.5352783203125,
        -3400.464111328125,
        1473.2999267578125
      ],
      "bbox_max": [
        -1581.2626953125,
        -3398.337646484375,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11574513465166092,
        0.4319745600223541,
        -0.8944277167320251
      ],
      "plane_d": 2970.3037109375,
      "bbox_min": [
        -1588.5,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1582.5,
        -3394.3662109375,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1157427579164505,
        0.4319656789302826,
        -0.8944323658943176
      ],
      "plane_d": 2603.48779296875,
      "bbox_min": [
        -1588.5,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1582.5,
        -3394.3662109375,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43197107315063477,
        0.1157442107796669,
        -0.8944295048713684
      ],
      "plane_d": 2397.132080078125,
      "bbox_min": [
        -1588.5,
        -3399.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1583.1683349609375,
        -3394.3662109375,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31623297929763794,
        -0.31623297929763794,
        -0.8944234848022461
      ],
      "plane_d": 746.3096923828125,
      "bbox_min": [
        -1588.5,
        -3398.929443359375,
        1473.2999267578125
      ],
      "bbox_max": [
        -1583.1683349609375,
        -3394.3662109375,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3407208025455475,
        0.34077969193458557,
        0.8762297630310059
      ],
      "plane_d": -675.0546264648438,
      "bbox_min": [
        -1587.964111328125,
        -3396.03515625,
        1473.2999267578125
      ],
      "bbox_max": [
        -1586.1287841796875,
        -3394.3662109375,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1474.2999267578125,
      "bbox_min": [
        -1588.5,
        -3398.929443359375,
        1473.2999267578125
      ],
      "bbox_max": [
        -1583.1683349609375,
        -3395.0,
        1474.2999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4319745600223541,
        -0.11574513465166092,
        -0.8944277167320251
      ],
      "plane_d": 1610.765625,
      "bbox_min": [
        -1588.5,
        -3397.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1586.1708984375,
        -3395.0,
        1474.2999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1599.5999755859375,
      "bbox_min": [
        -1613.5999755859375,
        -3397.60009765625,
        1474.4000244140625
      ],
      "bbox_max": [
        -1584.12255859375,
        -3396.39990234375,
        1476.3834228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1598.4000244140625,
      "bbox_min": [
        -1599.5999755859375,
        -3397.60009765625,
        1474.4000244140625
      ],
      "bbox_max": [
        -1584.12255859375,
        -3396.39990234375,
        1476.3834228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3397.60009765625,
      "bbox_min": [
        -1599.5999755859375,
        -3397.60009765625,
        1474.4000244140625
      ],
      "bbox_max": [
        -1598.4000244140625,
        -3396.39990234375,
        1476.3834228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3396.39990234375,
      "bbox_min": [
        -1599.5999755859375,
        -3396.39990234375,
        1474.4000244140625
      ],
      "bbox_max": [
        -1598.4000244140625,
        -3396.39990234375,
        1476.0333251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3397.60009765625,
      "bbox_min": [
        -1585.199951171875,
        -3397.60009765625,
        1474.4000244140625
      ],
      "bbox_max": [
        -1584.12255859375,
        -3396.737060546875,
        1475.8292236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1585.199951171875,
      "bbox_min": [
        -1585.199951171875,
        -3397.60009765625,
        1474.4000244140625
      ],
      "bbox_max": [
        -1585.199951171875,
        -3396.737060546875,
        1475.8292236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1612.4000244140625,
      "bbox_min": [
        -1613.5999755859375,
        -3397.195556640625,
        1474.4000244140625
      ],
      "bbox_max": [
        -1612.4000244140625,
        -3396.39990234375,
        1476.265380859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1613.5999755859375,
      "bbox_min": [
        -1613.5999755859375,
        -3396.560302734375,
        1475.0369873046875
      ],
      "bbox_max": [
        -1613.5999755859375,
        -3396.39990234375,
        1476.080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 1618.9998779296875,
      "bbox_min": [
        -1624.9835205078125,
        -3391.0,
        1465.199951171875
      ],
      "bbox_max": [
        -1585.4266357421875,
        -3386.0,
        1468.199951171875
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3391.0,
      "bbox_min": [
        -1590.0,
        -3391.0,
        1465.199951171875
      ],
      "bbox_max": [
        -1585.4266357421875,
        -3387.33642578125,
        1466.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1589.9998779296875,
      "bbox_min": [
        -1590.0,
        -3391.0,
        1465.199951171875
      ],
      "bbox_max": [
        -1590.0,
        -3387.33642578125,
        1466.199951171875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3391.0,
      "bbox_min": [
        -1590.0,
        -3391.0,
        1467.199951171875
      ],
      "bbox_max": [
        -1586.93408203125,
        -3388.544189453125,
        1468.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1589.9998779296875,
      "bbox_min": [
        -1590.0,
        -3391.0,
        1467.199951171875
      ],
      "bbox_max": [
        -1590.0,
        -3388.544189453125,
        1468.199951171875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        0.0,
        0.768221378326416
      ],
      "plane_d": -2200.9541015625,
      "bbox_min": [
        -1621.199951171875,
        -3399.3154296875,
        1514.0
      ],
      "bbox_max": [
        -1618.597412109375,
        -3393.5,
        1515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": 1329.00732421875,
      "bbox_min": [
        -1621.199951171875,
        -3394.5,
        1514.0
      ],
      "bbox_max": [
        -1618.597412109375,
        -3393.5,
        1515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5076730847358704,
        0.6092077493667603,
        0.6092077493667603
      ],
      "plane_d": 322.57568359375,
      "bbox_min": [
        -1621.199951171875,
        -3394.5,
        1514.0
      ],
      "bbox_max": [
        -1620.0,
        -3393.5,
        1515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        0.768221378326416,
        0.0
      ],
      "plane_d": 1562.946533203125,
      "bbox_min": [
        -1629.91650390625,
        -3415.499755859375,
        1486.5
      ],
      "bbox_max": [
        -1580.5,
        -3384.5,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3384.5,
      "bbox_min": [
        -1620.0,
        -3415.499755859375,
        1486.5
      ],
      "bbox_max": [
        -1580.5,
        -3384.5,
        1514.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3410.0,
      "bbox_min": [
        -1620.0,
        -3415.499755859375,
        1486.5
      ],
      "bbox_max": [
        -1580.5,
        -3386.0,
        1514.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1585.0,
      "bbox_min": [
        -1589.4248046875,
        -3415.499755859375,
        1486.5
      ],
      "bbox_max": [
        -1580.5,
        -3410.0,
        1505.2064208984375
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1586.4998779296875,
      "bbox_min": [
        -1589.4248046875,
        -3413.92919921875,
        1487.3931884765625
      ],
      "bbox_max": [
        -1585.0,
        -3412.0,
        1497.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3413.5,
      "bbox_min": [
        -1585.848876953125,
        -3413.92919921875,
        1492.212158203125
      ],
      "bbox_max": [
        -1585.0,
        -3413.5,
        1495.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1495.0,
      "bbox_min": [
        -1585.848876953125,
        -3413.92919921875,
        1495.0
      ],
      "bbox_max": [
        -1585.0,
        -3413.5,
        1495.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9032753705978394,
        0.0,
        0.42906132340431213
      ],
      "plane_d": -2075.35107421875,
      "bbox_min": [
        -1589.4248046875,
        -3413.478515625,
        1493.247314453125
      ],
      "bbox_max": [
        -1586.5,
        -3412.0,
        1497.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1497.0,
      "bbox_min": [
        -1589.4248046875,
        -3413.478271484375,
        1497.0
      ],
      "bbox_max": [
        -1586.5,
        -3412.0,
        1497.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3411.0,
      "bbox_min": [
        -1585.0,
        -3411.0,
        1486.5
      ],
      "bbox_max": [
        -1580.5,
        -3410.0,
        1497.754150390625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1582.0,
      "bbox_min": [
        -1582.0,
        -3411.0,
        1486.5
      ],
      "bbox_max": [
        -1580.5,
        -3410.0,
        1493.7645263671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8865849375724792,
        0.0,
        0.4625660479068756
      ],
      "plane_d": 713.64306640625,
      "bbox_min": [
        -1582.0,
        -3411.0,
        1486.5
      ],
      "bbox_max": [
        -1580.5,
        -3410.0,
        1493.7645263671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8865849375724792,
        0.0,
        -0.4625660479068756
      ],
      "plane_d": 2093.535400390625,
      "bbox_min": [
        -1582.0,
        -3411.0,
        1493.75
      ],
      "bbox_max": [
        -1581.992431640625,
        -3410.985107421875,
        1493.7645263671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": -3385.999755859375,
      "bbox_min": [
        -1620.0,
        -3409.0,
        1486.5
      ],
      "bbox_max": [
        -1597.8580322265625,
        -3386.0,
        1514.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.8944272994995117,
        -0.44721364974975586,
        -0.0
      ],
      "plane_d": -2960.33056640625,
      "bbox_min": [
        -1620.0,
        -3409.0,
        1486.5
      ],
      "bbox_max": [
        -1597.8580322265625,
        -3386.0,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1610.5,
      "bbox_min": [
        -1613.0,
        -3409.0,
        1486.5
      ],
      "bbox_max": [
        -1597.8580322265625,
        -3386.0,
        1512.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3394.5,
      "bbox_min": [
        -1613.0,
        -3394.5,
        1486.5
      ],
      "bbox_max": [
        -1610.5,
        -3386.0,
        1501.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272994995117,
        -0.44721364974975586,
        0.0
      ],
      "plane_d": -77.144287109375,
      "bbox_min": [
        -1613.0,
        -3394.5,
        1486.5
      ],
      "bbox_max": [
        -1610.5,
        -3386.0,
        1501.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1613.0,
      "bbox_min": [
        -1613.0,
        -3394.5,
        1486.5
      ],
      "bbox_max": [
        -1610.5,
        -3386.0,
        1501.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944271802902222,
        0.0,
        0.4472135901451111
      ],
      "plane_d": -2113.531494140625,
      "bbox_min": [
        -1613.0,
        -3394.5,
        1500.0
      ],
      "bbox_max": [
        -1610.5,
        -3389.926025390625,
        1501.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1501.0,
      "bbox_min": [
        -1613.0,
        -3394.5,
        1500.0
      ],
      "bbox_max": [
        -1610.5,
        -3390.9306640625,
        1501.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271206855774,
        -0.0,
        0.4472135603427887
      ],
      "plane_d": 769.654541015625,
      "bbox_min": [
        -1613.0,
        -3394.5,
        1500.0
      ],
      "bbox_max": [
        -1610.5,
        -3391.9287109375,
        1501.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -3706.953369140625,
      "bbox_min": [
        -1613.0,
        -3394.5,
        1500.0
      ],
      "bbox_max": [
        -1610.5,
        -3393.3818359375,
        1501.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8000162839889526,
        -0.4000081419944763,
        0.44717705249786377
      ],
      "plane_d": -739.7669067382812,
      "bbox_min": [
        -1613.0,
        -3394.5,
        1500.0
      ],
      "bbox_max": [
        -1610.5,
        -3393.3818359375,
        1501.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.799981415271759,
        -0.3999907076358795,
        0.4472552537918091
      ],
      "plane_d": -3318.621337890625,
      "bbox_min": [
        -1613.0,
        -3394.5,
        1500.0
      ],
      "bbox_max": [
        -1612.1910400390625,
        -3393.3818359375,
        1501.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3393.0,
      "bbox_min": [
        -1610.5,
        -3409.0,
        1486.5
      ],
      "bbox_max": [
        -1597.8580322265625,
        -3386.0,
        1512.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1487.4998779296875,
      "bbox_min": [
        -1610.5,
        -3393.0,
        1486.5
      ],
      "bbox_max": [
        -1599.7401123046875,
        -3386.0,
        1487.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": -3536.5947265625,
      "bbox_min": [
        -1610.5,
        -3393.0,
        1486.5
      ],
      "bbox_max": [
        -1608.5,
        -3391.0,
        1487.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1511.5,
      "bbox_min": [
        -1604.873046875,
        -3409.0,
        1511.5
      ],
      "bbox_max": [
        -1597.8580322265625,
        -3406.5,
        1512.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3406.5,
      "bbox_min": [
        -1604.873046875,
        -3409.0,
        1511.5
      ],
      "bbox_max": [
        -1597.8580322265625,
        -3406.5,
        1512.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3409.0,
      "bbox_min": [
        -1599.9266357421875,
        -3409.0,
        1511.5
      ],
      "bbox_max": [
        -1597.8580322265625,
        -3409.0,
        1512.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3394.5,
      "bbox_min": [
        -1620.0,
        -3398.5,
        1486.5
      ],
      "bbox_max": [
        -1610.965576171875,
        -3386.0,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1617.5,
      "bbox_min": [
        -1620.0,
        -3394.5,
        1486.5
      ],
      "bbox_max": [
        -1617.441650390625,
        -3386.0,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272994995117,
        -0.44721364974975586,
        0.0
      ],
      "plane_d": -70.88330078125,
      "bbox_min": [
        -1620.0,
        -3394.5,
        1486.5
      ],
      "bbox_max": [
        -1617.5,
        -3386.0,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272994995117,
        -0.44721364974975586,
        -0.0
      ],
      "plane_d": -2966.591796875,
      "bbox_min": [
        -1620.0,
        -3394.5,
        1486.5
      ],
      "bbox_max": [
        -1617.5,
        -3386.0,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": 1329.00732421875,
      "bbox_min": [
        -1620.0,
        -3393.5,
        1512.1636962890625
      ],
      "bbox_max": [
        -1619.0919189453125,
        -3391.66357421875,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1501.0,
      "bbox_min": [
        -1620.0,
        -3394.5,
        1500.0
      ],
      "bbox_max": [
        -1617.5,
        -3386.0,
        1501.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": 2357.710205078125,
      "bbox_min": [
        -1620.0,
        -3394.5,
        1500.0
      ],
      "bbox_max": [
        -1617.5,
        -3386.0,
        1501.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -3706.953369140625,
      "bbox_min": [
        -1620.0,
        -3394.5,
        1500.0
      ],
      "bbox_max": [
        -1617.5,
        -3393.3818359375,
        1501.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8000162839889526,
        -0.4000081419944763,
        0.44717705249786377
      ],
      "plane_d": -734.1668090820312,
      "bbox_min": [
        -1620.0,
        -3394.5,
        1500.0
      ],
      "bbox_max": [
        -1617.5,
        -3393.3818359375,
        1501.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.799981415271759,
        -0.3999907076358795,
        0.4472552537918091
      ],
      "plane_d": -3324.22119140625,
      "bbox_min": [
        -1620.0,
        -3394.5,
        1500.0
      ],
      "bbox_max": [
        -1619.1910400390625,
        -3393.3818359375,
        1501.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7295363545417786,
        -0.6839420795440674
      ],
      "plane_d": -1441.2877197265625,
      "bbox_min": [
        -1620.0,
        -3394.5,
        1512.4000244140625
      ],
      "bbox_max": [
        -1619.5,
        -3393.5,
        1513.4666748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7295363545417786,
        -0.6839420795440674
      ],
      "plane_d": -1441.2877197265625,
      "bbox_min": [
        -1618.0001220703125,
        -3394.5,
        1512.8359375
      ],
      "bbox_max": [
        -1617.5,
        -3393.90869140625,
        1513.4666748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7295363545417786,
        -0.6839420795440674
      ],
      "plane_d": -1441.2877197265625,
      "bbox_min": [
        -1617.5,
        -3394.5,
        1513.3265380859375
      ],
      "bbox_max": [
        -1617.441650390625,
        -3394.36865234375,
        1513.4666748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1511.5,
      "bbox_min": [
        -1620.0,
        -3398.5,
        1511.5
      ],
      "bbox_max": [
        -1610.965576171875,
        -3394.5,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3396.0,
      "bbox_min": [
        -1620.0,
        -3398.5,
        1511.5
      ],
      "bbox_max": [
        -1614.0867919921875,
        -3394.5,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1619.0,
      "bbox_min": [
        -1619.0,
        -3398.5,
        1511.5
      ],
      "bbox_max": [
        -1619.0,
        -3396.0,
        1512.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7295363545417786,
        -0.6839420795440674
      ],
      "plane_d": -1441.2877197265625,
      "bbox_min": [
        -1620.0,
        -3395.0,
        1513.4666748046875
      ],
      "bbox_max": [
        -1617.219482421875,
        -3394.5,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5076730847358704,
        0.6092077493667603,
        0.6092077493667603
      ],
      "plane_d": 322.57568359375,
      "bbox_min": [
        -1629.91650390625,
        -3393.573486328125,
        1505.0
      ],
      "bbox_max": [
        -1621.3648681640625,
        -3385.947021484375,
        1506.7105712890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5076730847358704,
        0.6092077493667603,
        0.6092077493667603
      ],
      "plane_d": 322.57568359375,
      "bbox_min": [
        -1628.83544921875,
        -3399.161376953125,
        1504.4000244140625
      ],
      "bbox_max": [
        -1620.0,
        -3386.504150390625,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5301920771598816,
        -0.6185574531555176,
        -0.5798990726470947
      ],
      "plane_d": -363.12420654296875,
      "bbox_min": [
        -1628.57470703125,
        -3399.161376953125,
        1504.4000244140625
      ],
      "bbox_max": [
        -1620.0,
        -3386.504150390625,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        0.0,
        0.768221378326416
      ],
      "plane_d": -2200.9541015625,
      "bbox_min": [
        -1627.598388671875,
        -3396.298828125,
        1508.66796875
      ],
      "bbox_max": [
        -1621.199951171875,
        -3394.5,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6747682690620422,
        0.0,
        -0.7380296587944031
      ],
      "plane_d": 2210.50146484375,
      "bbox_min": [
        -1626.4400634765625,
        -3399.161376953125,
        1508.1119384765625
      ],
      "bbox_max": [
        -1620.0,
        -3395.0,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        0.0,
        0.768221378326416
      ],
      "plane_d": -2200.9541015625,
      "bbox_min": [
        -1624.7601318359375,
        -3398.554931640625,
        1511.033203125
      ],
      "bbox_max": [
        -1621.199951171875,
        -3396.028564453125,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3384.5,
      "bbox_min": [
        -1627.5,
        -3384.5,
        1505.0
      ],
      "bbox_max": [
        -1623.5426025390625,
        -3384.5,
        1510.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9726229310035706,
        0.20830567181110382,
        -0.10302186012268066
      ],
      "plane_d": 2349.484130859375,
      "bbox_min": [
        -1552.311279296875,
        -3440.310546875,
        1312.15576171875
      ],
      "bbox_max": [
        -1523.64404296875,
        -3382.0,
        1464.900146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6396912932395935,
        0.7676994204521179,
        0.037849828600883484
      ],
      "plane_d": 3485.137451171875,
      "bbox_min": [
        -1276.5831298828125,
        -3646.800048828125,
        1302.5999755859375
      ],
      "bbox_max": [
        -1149.1082763671875,
        -3540.2158203125,
        1551.6312255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0643240362405777,
        0.9379590749740601,
        0.34072762727737427
      ],
      "plane_d": 2958.86083984375,
      "bbox_min": [
        -1627.311767578125,
        -3646.800048828125,
        1302.5999755859375
      ],
      "bbox_max": [
        -1163.4052734375,
        -3382.0,
        1574.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6359549164772034,
        0.6976706981658936,
        0.3298740088939667
      ],
      "plane_d": 2885.940185546875,
      "bbox_min": [
        -1627.311767578125,
        -3611.2421875,
        1394.68359375
      ],
      "bbox_max": [
        -1393.18212890625,
        -3382.0,
        1574.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.030036021023988724,
        0.9266842007637024,
        0.3746386170387268
      ],
      "plane_d": 2593.50927734375,
      "bbox_min": [
        -1627.311767578125,
        -3485.0400390625,
        1451.0
      ],
      "bbox_max": [
        -1523.64404296875,
        -3382.0,
        1574.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9400216937065125,
        0.3411146402359009
      ],
      "plane_d": 2738.791748046875,
      "bbox_min": [
        -1547.08447265625,
        -3485.0400390625,
        1557.0006103515625
      ],
      "bbox_max": [
        -1531.6314697265625,
        -3478.544677734375,
        1574.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1515.0,
      "bbox_min": [
        -1627.311767578125,
        -3485.0400390625,
        1451.0
      ],
      "bbox_max": [
        -1523.64404296875,
        -3382.0,
        1574.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1486.5,
      "bbox_min": [
        -1627.311767578125,
        -3440.310546875,
        1451.0
      ],
      "bbox_max": [
        -1523.64404296875,
        -3382.0,
        1515.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1451.0,
      "bbox_min": [
        -1609.5968017578125,
        -3440.310546875,
        1451.0
      ],
      "bbox_max": [
        -1523.64404296875,
        -3382.0,
        1486.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3384.5,
      "bbox_min": [
        -1609.5968017578125,
        -3440.310546875,
        1451.0
      ],
      "bbox_max": [
        -1523.64404296875,
        -3382.0,
        1486.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.2800000011920929,
        -0.9599999785423279
      ],
      "plane_d": 465.99993896484375,
      "bbox_min": [
        -1597.5478515625,
        -3440.310546875,
        1451.0
      ],
      "bbox_max": [
        -1523.64404296875,
        -3386.0,
        1486.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3396.39990234375,
      "bbox_min": [
        -1585.199951171875,
        -3397.60009765625,
        1476.0333251953125
      ],
      "bbox_max": [
        -1584.0,
        -3396.39990234375,
        1476.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1584.0,
      "bbox_min": [
        -1585.199951171875,
        -3397.60009765625,
        1476.0333251953125
      ],
      "bbox_max": [
        -1584.0,
        -3396.39990234375,
        1476.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1585.199951171875,
      "bbox_min": [
        -1585.199951171875,
        -3397.60009765625,
        1476.0333251953125
      ],
      "bbox_max": [
        -1584.0,
        -3396.39990234375,
        1476.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3397.60009765625,
      "bbox_min": [
        -1585.199951171875,
        -3397.60009765625,
        1476.38330078125
      ],
      "bbox_max": [
        -1584.0,
        -3397.60009765625,
        1476.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3410.0,
      "bbox_min": [
        -1597.5478515625,
        -3440.310546875,
        1451.0
      ],
      "bbox_max": [
        -1523.64404296875,
        -3386.0,
        1486.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -1487.699951171875,
      "bbox_min": [
        -1546.0650634765625,
        -3440.310546875,
        1459.0
      ],
      "bbox_max": [
        -1523.64404296875,
        -3424.4345703125,
        1486.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1538.0,
      "bbox_min": [
        -1538.0,
        -3428.0,
        1459.0
      ],
      "bbox_max": [
        -1537.86376953125,
        -3424.4345703125,
        1466.5406494140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18093687295913696,
        0.11946532130241394,
        0.9762120246887207
      ],
      "plane_d": -743.3719482421875,
      "bbox_min": [
        -1538.0,
        -3428.0,
        1466.013916015625
      ],
      "bbox_max": [
        -1537.86376953125,
        -3427.755859375,
        1466.054443359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18093766272068024,
        0.11946627497673035,
        0.9762117862701416
      ],
      "plane_d": -743.3670654296875,
      "bbox_min": [
        -1538.9801025390625,
        -3440.310546875,
        1464.900146484375
      ],
      "bbox_max": [
        -1523.64404296875,
        -3427.875,
        1466.3460693359375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3386.0,
      "bbox_min": [
        -1597.5478515625,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1553.0,
        -3386.0,
        1477.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3391.0,
      "bbox_min": [
        -1594.94287109375,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1553.0,
        -3386.0,
        1477.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1461.199951171875,
      "bbox_min": [
        -1594.94287109375,
        -3391.0,
        1451.0
      ],
      "bbox_max": [
        -1575.82080078125,
        -3386.0,
        1472.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1466.199951171875,
      "bbox_min": [
        -1594.94287109375,
        -3391.0,
        1462.9866943359375
      ],
      "bbox_max": [
        -1578.4139404296875,
        -3386.0,
        1472.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1589.9998779296875,
      "bbox_min": [
        -1590.4200439453125,
        -3387.9404296875,
        1462.9866943359375
      ],
      "bbox_max": [
        -1590.0,
        -3386.0,
        1466.199951171875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1465.199951171875,
      "bbox_min": [
        -1590.4200439453125,
        -3387.33642578125,
        1465.199951171875
      ],
      "bbox_max": [
        -1590.0,
        -3387.0,
        1465.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1467.199951171875,
      "bbox_min": [
        -1594.94287109375,
        -3391.0,
        1467.199951171875
      ],
      "bbox_max": [
        -1578.9329833984375,
        -3386.0,
        1472.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1472.199951171875,
      "bbox_min": [
        -1594.94287109375,
        -3391.0,
        1467.199951171875
      ],
      "bbox_max": [
        -1581.5264892578125,
        -3386.0,
        1472.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1589.9998779296875,
      "bbox_min": [
        -1594.94287109375,
        -3391.0,
        1467.199951171875
      ],
      "bbox_max": [
        -1590.0,
        -3386.0,
        1472.199951171875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1471.199951171875,
      "bbox_min": [
        -1594.94287109375,
        -3390.0,
        1468.199951171875
      ],
      "bbox_max": [
        -1590.0,
        -3387.0,
        1471.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1468.199951171875,
      "bbox_min": [
        -1592.681640625,
        -3390.0,
        1468.199951171875
      ],
      "bbox_max": [
        -1590.0,
        -3387.0,
        1471.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3390.0,
      "bbox_min": [
        -1591.197998046875,
        -3390.0,
        1469.6109619140625
      ],
      "bbox_max": [
        -1590.0,
        -3390.0,
        1471.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.7337597012519836,
        -0.6794091463088989
      ],
      "plane_d": -1495.556884765625,
      "bbox_min": [
        -1588.5,
        -3390.39990234375,
        1451.0
      ],
      "bbox_max": [
        -1576.0,
        -3386.0,
        1461.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3390.39990234375,
      "bbox_min": [
        -1588.5,
        -3390.39990234375,
        1460.3599853515625
      ],
      "bbox_max": [
        -1576.0433349609375,
        -3386.0,
        1461.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1588.5,
      "bbox_min": [
        -1588.5,
        -3386.122314453125,
        1460.9971923828125
      ],
      "bbox_max": [
        -1588.5,
        -3386.0,
        1461.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7117644548416138,
        0.7024182677268982
      ],
      "plane_d": -3433.10546875,
      "bbox_min": [
        -1583.8299560546875,
        -3390.39990234375,
        1451.0
      ],
      "bbox_max": [
        -1576.0,
        -3386.013671875,
        1457.1199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1576.0,
      "bbox_min": [
        -1576.255615234375,
        -3390.39990234375,
        1451.0
      ],
      "bbox_max": [
        -1576.0,
        -3386.013671875,
        1454.7078857421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3390.39990234375,
      "bbox_min": [
        -1576.255615234375,
        -3390.39990234375,
        1451.7010498046875
      ],
      "bbox_max": [
        -1576.0,
        -3390.39990234375,
        1452.0400390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3387.39990234375,
      "bbox_min": [
        -1583.8299560546875,
        -3387.39990234375,
        1455.0799560546875
      ],
      "bbox_max": [
        -1576.5958251953125,
        -3387.39990234375,
        1457.1199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3403.0,
      "bbox_min": [
        -1587.330322265625,
        -3410.0,
        1451.83203125
      ],
      "bbox_max": [
        -1553.0,
        -3393.0,
        1477.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1476.0,
      "bbox_min": [
        -1578.58740234375,
        -3410.0,
        1451.83203125
      ],
      "bbox_max": [
        -1553.0,
        -3403.0,
        1477.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3404.5,
      "bbox_min": [
        -1577.845947265625,
        -3408.0,
        1476.0
      ],
      "bbox_max": [
        -1564.84765625,
        -3404.5,
        1477.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3406.5,
      "bbox_min": [
        -1575.3489990234375,
        -3408.0,
        1476.0
      ],
      "bbox_max": [
        -1564.84765625,
        -3406.5,
        1477.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3408.0,
      "bbox_min": [
        -1573.4765625,
        -3408.0,
        1476.0
      ],
      "bbox_max": [
        -1564.84765625,
        -3408.0,
        1477.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 3516.5625,
      "bbox_min": [
        -1572.719482421875,
        -3410.0,
        1451.83203125
      ],
      "bbox_max": [
        -1553.0,
        -3405.0,
        1473.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25883668661117554,
        0.96592116355896,
        0.0
      ],
      "plane_d": 3695.335205078125,
      "bbox_min": [
        -1572.719482421875,
        -3410.0,
        1465.71240234375
      ],
      "bbox_max": [
        -1565.0,
        -3405.0,
        1473.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.96592116355896,
        0.25883668661117554,
        0.0
      ],
      "plane_d": 2394.2998046875,
      "bbox_min": [
        -1572.719482421875,
        -3410.0,
        1466.3154296875
      ],
      "bbox_max": [
        -1565.0,
        -3405.0,
        1473.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1473.0,
      "bbox_min": [
        -1572.719482421875,
        -3410.0,
        1467.9195556640625
      ],
      "bbox_max": [
        -1565.0,
        -3405.0,
        1473.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25883668661117554,
        0.96592116355896,
        0.0
      ],
      "plane_d": 2882.588134765625,
      "bbox_min": [
        -1572.719482421875,
        -3405.889404296875,
        1467.9195556640625
      ],
      "bbox_max": [
        -1570.0,
        -3405.0,
        1473.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 1296.246826171875,
      "bbox_min": [
        -1572.719482421875,
        -3405.889404296875,
        1472.345458984375
      ],
      "bbox_max": [
        -1572.5,
        -3405.669921875,
        1473.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25883668661117554,
        0.96592116355896,
        0.0
      ],
      "plane_d": 2885.694091796875,
      "bbox_min": [
        -1563.0,
        -3410.0,
        1451.83203125
      ],
      "bbox_max": [
        -1553.0,
        -3405.0,
        1473.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.96592116355896,
        0.25883668661117554,
        0.0
      ],
      "plane_d": -627.1016235351562,
      "bbox_min": [
        -1563.0,
        -3410.0,
        1451.83203125
      ],
      "bbox_max": [
        -1553.0,
        -3405.0,
        1473.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 1304.732177734375,
      "bbox_min": [
        -1563.0,
        -3410.0,
        1451.83203125
      ],
      "bbox_max": [
        -1553.0,
        -3405.0,
        1473.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1454.5,
      "bbox_min": [
        -1563.0,
        -3410.0,
        1451.83203125
      ],
      "bbox_max": [
        -1553.0,
        -3405.0,
        1473.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.96592116355896,
        0.25883668661117554,
        0.0
      ],
      "plane_d": 2382.708740234375,
      "bbox_min": [
        -1563.0,
        -3410.0,
        1454.5
      ],
      "bbox_max": [
        -1553.0,
        -3405.0,
        1473.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25883668661117554,
        0.96592116355896,
        0.0
      ],
      "plane_d": 3692.22900390625,
      "bbox_min": [
        -1563.0,
        -3410.0,
        1454.5
      ],
      "bbox_max": [
        -1556.5643310546875,
        -3405.0,
        1473.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1473.0,
      "bbox_min": [
        -1563.0,
        -3410.0,
        1473.0
      ],
      "bbox_max": [
        -1561.09716796875,
        -3408.60595703125,
        1473.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3406.5,
      "bbox_min": [
        -1558.01123046875,
        -3408.111083984375,
        1451.83203125
      ],
      "bbox_max": [
        -1556.0,
        -3406.5,
        1454.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1556.0,
      "bbox_min": [
        -1556.0,
        -3408.111083984375,
        1451.83203125
      ],
      "bbox_max": [
        -1556.0,
        -3406.5,
        1454.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1474.39990234375,
      "bbox_min": [
        -1587.330322265625,
        -3400.76220703125,
        1473.2999267578125
      ],
      "bbox_max": [
        -1571.3870849609375,
        -3393.0,
        1476.3834228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.46548134088516235,
        -0.12473297119140625,
        0.8762242197990417
      ],
      "plane_d": -978.9656982421875,
      "bbox_min": [
        -1587.330322265625,
        -3400.76220703125,
        1473.2999267578125
      ],
      "bbox_max": [
        -1571.3870849609375,
        -3393.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12474536895751953,
        0.46546870470046997,
        0.8762291669845581
      ],
      "plane_d": 486.0458984375,
      "bbox_min": [
        -1587.330322265625,
        -3399.226806640625,
        1473.2999267578125
      ],
      "bbox_max": [
        -1580.5,
        -3393.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12475047260522842,
        0.4654877185821533,
        0.876218318939209
      ],
      "plane_d": 90.80029296875,
      "bbox_min": [
        -1587.330322265625,
        -3399.226806640625,
        1473.2999267578125
      ],
      "bbox_max": [
        -1580.5,
        -3393.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4654886722564697,
        0.12473494559526443,
        0.8762200474739075
      ],
      "plane_d": -131.5054931640625,
      "bbox_min": [
        -1587.330322265625,
        -3399.226806640625,
        1473.2999267578125
      ],
      "bbox_max": [
        -1580.5,
        -3393.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31622204184532166,
        -0.31622204184532166,
        -0.8944312334060669
      ],
      "plane_d": -255.7667236328125,
      "bbox_min": [
        -1587.330322265625,
        -3399.226806640625,
        1473.2999267578125
      ],
      "bbox_max": [
        -1580.5,
        -3393.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34074416756629944,
        0.3408030867576599,
        0.8762114644050598
      ],
      "plane_d": 404.8330078125,
      "bbox_min": [
        -1583.5352783203125,
        -3396.03515625,
        1473.2999267578125
      ],
      "bbox_max": [
        -1581.035888671875,
        -3393.535888671875,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11574513465166092,
        -0.4319745600223541,
        -0.8944277167320251
      ],
      "plane_d": -331.3275146484375,
      "bbox_min": [
        -1587.330322265625,
        -3399.226806640625,
        1473.2999267578125
      ],
      "bbox_max": [
        -1580.5,
        -3393.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.43197107315063477,
        -0.1157442107796669,
        -0.8944295048713684
      ],
      "plane_d": 241.849609375,
      "bbox_min": [
        -1587.330322265625,
        -3399.226806640625,
        1473.2999267578125
      ],
      "bbox_max": [
        -1580.5,
        -3393.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31623297929763794,
        -0.31623297929763794,
        -0.8944234848022461
      ],
      "plane_d": 746.3096923828125,
      "bbox_min": [
        -1587.330322265625,
        -3399.226806640625,
        1473.2999267578125
      ],
      "bbox_max": [
        -1580.5,
        -3393.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3407208025455475,
        0.34077969193458557,
        0.8762297630310059
      ],
      "plane_d": -675.0546264648438,
      "bbox_min": [
        -1587.330322265625,
        -3395.9931640625,
        1473.2999267578125
      ],
      "bbox_max": [
        -1585.4647216796875,
        -3393.535888671875,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1157427579164505,
        -0.4319656789302826,
        -0.8944323658943176
      ],
      "plane_d": 35.501953125,
      "bbox_min": [
        -1586.5,
        -3399.226806640625,
        1473.2999267578125
      ],
      "bbox_max": [
        -1580.5,
        -3393.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31623297929763794,
        0.31623297929763794,
        -0.8944234848022461
      ],
      "plane_d": 1892.6541748046875,
      "bbox_min": [
        -1586.09521484375,
        -3399.226806640625,
        1473.2999267578125
      ],
      "bbox_max": [
        -1580.5,
        -3395.070556640625,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3407208025455475,
        -0.34077969193458557,
        0.8762297630310059
      ],
      "plane_d": -1910.567626953125,
      "bbox_min": [
        -1583.2020263671875,
        -3399.226806640625,
        1473.2999267578125
      ],
      "bbox_max": [
        -1581.035888671875,
        -3397.96484375,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1474.2999267578125,
      "bbox_min": [
        -1586.09521484375,
        -3399.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1580.5,
        -3395.070556640625,
        1474.2999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4319745600223541,
        0.11574513465166092,
        -0.8944277167320251
      ],
      "plane_d": 1028.210693359375,
      "bbox_min": [
        -1582.8291015625,
        -3399.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1580.5,
        -3397.0,
        1474.2999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34074416756629944,
        -0.3408030867576599,
        0.8762114644050598
      ],
      "plane_d": -2985.630859375,
      "bbox_min": [
        -1574.172119140625,
        -3400.76220703125,
        1473.2999267578125
      ],
      "bbox_max": [
        -1571.3870849609375,
        -3398.2236328125,
        1473.541748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11574513465166092,
        0.4319745600223541,
        -0.8944277167320251
      ],
      "plane_d": 2968.68359375,
      "bbox_min": [
        -1574.172119140625,
        -3400.76220703125,
        1473.2999267578125
      ],
      "bbox_max": [
        -1571.3870849609375,
        -3398.2236328125,
        1473.541748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12474536895751953,
        -0.46546870470046997,
        0.8762291669845581
      ],
      "plane_d": -3069.919921875,
      "bbox_min": [
        -1572.5,
        -3400.76220703125,
        1473.2999267578125
      ],
      "bbox_max": [
        -1571.3870849609375,
        -3400.06982421875,
        1473.541748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43197107315063477,
        0.1157442107796669,
        -0.8944295048713684
      ],
      "plane_d": 2391.08447265625,
      "bbox_min": [
        -1574.172119140625,
        -3400.464111328125,
        1473.2999267578125
      ],
      "bbox_max": [
        -1572.26904296875,
        -3398.2236328125,
        1473.52294921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4654886722564697,
        -0.12473494559526443,
        0.8762200474739075
      ],
      "plane_d": -2447.5712890625,
      "bbox_min": [
        -1574.172119140625,
        -3399.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1573.63427734375,
        -3398.2236328125,
        1473.5023193359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31622204184532166,
        0.31622204184532166,
        -0.8944312334060669
      ],
      "plane_d": 2890.326416015625,
      "bbox_min": [
        -1573.964111328125,
        -3400.464111328125,
        1473.2999267578125
      ],
      "bbox_max": [
        -1572.26904296875,
        -3398.806640625,
        1473.52294921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1584.0,
      "bbox_min": [
        -1585.199951171875,
        -3397.60009765625,
        1474.4000244140625
      ],
      "bbox_max": [
        -1584.0,
        -3396.39990234375,
        1476.3834228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3397.60009765625,
      "bbox_min": [
        -1585.199951171875,
        -3397.60009765625,
        1474.4000244140625
      ],
      "bbox_max": [
        -1584.0,
        -3396.39990234375,
        1476.3834228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3396.39990234375,
      "bbox_min": [
        -1585.199951171875,
        -3397.60009765625,
        1474.4000244140625
      ],
      "bbox_max": [
        -1584.0,
        -3396.39990234375,
        1476.38330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1585.199951171875,
      "bbox_min": [
        -1585.199951171875,
        -3397.60009765625,
        1474.4000244140625
      ],
      "bbox_max": [
        -1585.199951171875,
        -3396.39990234375,
        1476.38330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1848299503326416,
        0.05494631081819534,
        0.9812332391738892
      ],
      "plane_d": -963.4571533203125,
      "bbox_min": [
        -1602.655029296875,
        -3384.5,
        1470.4864501953125
      ],
      "bbox_max": [
        -1587.76806640625,
        -3382.0,
        1473.1505126953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1514.0,
      "bbox_min": [
        -1627.311767578125,
        -3439.0,
        1486.5
      ],
      "bbox_max": [
        -1543.161865234375,
        -3384.5,
        1515.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": 1329.00732421875,
      "bbox_min": [
        -1619.0919189453125,
        -3429.10009765625,
        1514.0
      ],
      "bbox_max": [
        -1561.4105224609375,
        -3393.5,
        1515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6726728081703186,
        0.7399401068687439
      ],
      "plane_d": -3426.931640625,
      "bbox_min": [
        -1576.7779541015625,
        -3429.10009765625,
        1514.0
      ],
      "bbox_max": [
        -1561.4105224609375,
        -3428.0,
        1515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6726728081703186,
        0.7399401068687439
      ],
      "plane_d": -3426.931640625,
      "bbox_min": [
        -1627.311767578125,
        -3439.0,
        1486.5
      ],
      "bbox_max": [
        -1543.161865234375,
        -3384.5,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": 1329.00732421875,
      "bbox_min": [
        -1627.311767578125,
        -3439.0,
        1486.5
      ],
      "bbox_max": [
        -1543.161865234375,
        -3384.5,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3396.0,
      "bbox_min": [
        -1621.736328125,
        -3439.0,
        1486.5
      ],
      "bbox_max": [
        -1543.161865234375,
        -3384.5,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -1487.7000732421875,
      "bbox_min": [
        -1614.0867919921875,
        -3439.0,
        1486.5
      ],
      "bbox_max": [
        -1543.161865234375,
        -3396.0,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3398.5,
      "bbox_min": [
        -1614.0867919921875,
        -3439.0,
        1486.5
      ],
      "bbox_max": [
        -1550.0,
        -3396.0,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1511.5,
      "bbox_min": [
        -1614.0867919921875,
        -3398.5,
        1511.5
      ],
      "bbox_max": [
        -1593.683349609375,
        -3396.0,
        1511.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3410.0,
      "bbox_min": [
        -1601.3555908203125,
        -3439.0,
        1486.5
      ],
      "bbox_max": [
        -1550.0,
        -3406.5,
        1514.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3428.0,
      "bbox_min": [
        -1585.0,
        -3439.0,
        1486.5
      ],
      "bbox_max": [
        -1550.0,
        -3410.0,
        1514.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3439.0,
      "bbox_min": [
        -1555.5079345703125,
        -3439.0,
        1497.6932373046875
      ],
      "bbox_max": [
        -1550.0,
        -3439.0,
        1505.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9899495244026184,
        -0.0,
        -0.1414213627576828
      ],
      "plane_d": -1341.59375,
      "bbox_min": [
        -1585.0,
        -3428.0,
        1486.5
      ],
      "bbox_max": [
        -1555.0,
        -3410.0,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1555.0,
      "bbox_min": [
        -1569.0,
        -3428.0,
        1486.5
      ],
      "bbox_max": [
        -1555.0,
        -3411.0,
        1507.7763671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9899495244026184,
        0.0,
        -0.1414213627576828
      ],
      "plane_d": 1756.9482421875,
      "bbox_min": [
        -1569.0,
        -3428.0,
        1486.5
      ],
      "bbox_max": [
        -1559.3890380859375,
        -3411.0,
        1507.7763671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1496.5,
      "bbox_min": [
        -1569.0,
        -3428.0,
        1486.5
      ],
      "bbox_max": [
        -1561.0,
        -3411.0,
        1496.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3411.0,
      "bbox_min": [
        -1567.78759765625,
        -3411.0,
        1486.5
      ],
      "bbox_max": [
        -1567.0029296875,
        -3411.0,
        1488.0125732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1585.0,
      "bbox_min": [
        -1585.0,
        -3420.809814453125,
        1492.119140625
      ],
      "bbox_max": [
        -1580.5,
        -3410.0,
        1514.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3411.0,
      "bbox_min": [
        -1585.0,
        -3411.0,
        1492.119140625
      ],
      "bbox_max": [
        -1580.5,
        -3410.0,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8865849375724792,
        0.0,
        -0.4625660479068756
      ],
      "plane_d": 2093.535400390625,
      "bbox_min": [
        -1582.0,
        -3411.0,
        1492.119140625
      ],
      "bbox_max": [
        -1580.5,
        -3410.0,
        1496.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1582.0,
      "bbox_min": [
        -1582.0,
        -3410.98486328125,
        1492.119140625
      ],
      "bbox_max": [
        -1582.0,
        -3410.0,
        1493.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3411.0,
      "bbox_min": [
        -1574.5,
        -3411.0,
        1486.5
      ],
      "bbox_max": [
        -1567.571533203125,
        -3410.0,
        1500.9532470703125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1574.5,
      "bbox_min": [
        -1574.5,
        -3411.0,
        1486.5
      ],
      "bbox_max": [
        -1573.0,
        -3410.0,
        1500.9532470703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8865849375724792,
        0.0,
        0.4625660479068756
      ],
      "plane_d": -2083.532470703125,
      "bbox_min": [
        -1574.5,
        -3411.0,
        1486.5
      ],
      "bbox_max": [
        -1573.0,
        -3410.0,
        1496.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8865849375724792,
        0.0,
        -0.4625660479068756
      ],
      "plane_d": -703.6400756835938,
      "bbox_min": [
        -1574.5,
        -3411.0,
        1493.75
      ],
      "bbox_max": [
        -1573.0,
        -3410.0,
        1496.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3406.5,
      "bbox_min": [
        -1601.3555908203125,
        -3409.0,
        1511.5
      ],
      "bbox_max": [
        -1586.0,
        -3406.5,
        1512.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1511.5,
      "bbox_min": [
        -1600.9786376953125,
        -3409.0,
        1511.5
      ],
      "bbox_max": [
        -1586.0,
        -3406.5,
        1512.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3409.0,
      "bbox_min": [
        -1598.23486328125,
        -3409.0,
        1511.5
      ],
      "bbox_max": [
        -1586.0,
        -3406.5,
        1512.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1586.0,
      "bbox_min": [
        -1586.0,
        -3409.0,
        1511.5
      ],
      "bbox_max": [
        -1586.0,
        -3406.5,
        1512.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3384.5,
      "bbox_min": [
        -1621.736328125,
        -3395.0,
        1486.5
      ],
      "bbox_max": [
        -1586.7491455078125,
        -3384.5,
        1514.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -0.7295363545417786,
        -0.6839420795440674
      ],
      "plane_d": -1441.2877197265625,
      "bbox_min": [
        -1621.736328125,
        -3395.0,
        1486.5
      ],
      "bbox_max": [
        -1586.7491455078125,
        -3384.5,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5076730847358704,
        0.6092077493667603,
        0.6092077493667603
      ],
      "plane_d": 322.57568359375,
      "bbox_min": [
        -1621.736328125,
        -3391.66357421875,
        1502.7996826171875
      ],
      "bbox_max": [
        -1620.0,
        -3384.5,
        1512.1636962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        0.768221378326416,
        0.0
      ],
      "plane_d": 1562.946533203125,
      "bbox_min": [
        -1621.736328125,
        -3385.947021484375,
        1502.7996826171875
      ],
      "bbox_max": [
        -1620.0,
        -3384.5,
        1505.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3386.0,
      "bbox_min": [
        -1621.375,
        -3393.0,
        1486.5
      ],
      "bbox_max": [
        -1586.7491455078125,
        -3384.5,
        1507.323974609375
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        0.768221378326416,
        0.0
      ],
      "plane_d": 1562.946533203125,
      "bbox_min": [
        -1621.375,
        -3386.0,
        1491.0
      ],
      "bbox_max": [
        -1597.281982421875,
        -3384.5,
        1504.02197265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3385.0,
      "bbox_min": [
        -1609.5,
        -3385.0,
        1491.0
      ],
      "bbox_max": [
        -1597.8602294921875,
        -3385.0,
        1492.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6000000238418579,
        -0.0,
        0.800000011920929
      ],
      "plane_d": -229.699951171875,
      "bbox_min": [
        -1608.5,
        -3385.0,
        1492.0
      ],
      "bbox_max": [
        -1606.5,
        -3384.5,
        1499.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6000000238418579,
        0.0,
        -0.800000011920929
      ],
      "plane_d": 2163.10009765625,
      "bbox_min": [
        -1608.5,
        -3385.0,
        1497.5
      ],
      "bbox_max": [
        -1606.5,
        -3384.5,
        1499.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1499.0,
      "bbox_min": [
        -1608.5,
        -3386.0,
        1492.0
      ],
      "bbox_max": [
        -1600.912841796875,
        -3385.0,
        1499.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6000000238418579,
        -0.0,
        0.800000011920929
      ],
      "plane_d": -229.699951171875,
      "bbox_min": [
        -1608.5,
        -3386.0,
        1492.0
      ],
      "bbox_max": [
        -1606.5,
        -3385.0,
        1499.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6000000238418579,
        0.0,
        -0.800000011920929
      ],
      "plane_d": 2163.10009765625,
      "bbox_min": [
        -1608.5,
        -3386.0,
        1497.5
      ],
      "bbox_max": [
        -1606.5,
        -3385.0,
        1499.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1487.5,
      "bbox_min": [
        -1620.5882568359375,
        -3393.0,
        1486.5
      ],
      "bbox_max": [
        -1586.7491455078125,
        -3386.0,
        1507.323974609375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3393.0,
      "bbox_min": [
        -1599.7401123046875,
        -3393.0,
        1486.5
      ],
      "bbox_max": [
        -1586.7491455078125,
        -3393.0,
        1487.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1610.5,
      "bbox_min": [
        -1620.5882568359375,
        -3392.132080078125,
        1487.5
      ],
      "bbox_max": [
        -1593.76123046875,
        -3386.0,
        1507.323974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1613.0,
      "bbox_min": [
        -1620.5882568359375,
        -3392.132080078125,
        1493.498291015625
      ],
      "bbox_max": [
        -1610.5,
        -3386.0,
        1507.323974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271206855774,
        -0.0,
        0.4472135603427887
      ],
      "plane_d": 769.654541015625,
      "bbox_min": [
        -1613.0,
        -3392.132080078125,
        1500.0
      ],
      "bbox_max": [
        -1610.5,
        -3386.0,
        1501.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1501.0,
      "bbox_min": [
        -1613.0,
        -3392.132080078125,
        1500.0
      ],
      "bbox_max": [
        -1610.5,
        -3386.0,
        1501.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944271802902222,
        0.0,
        0.4472135901451111
      ],
      "plane_d": -2113.531494140625,
      "bbox_min": [
        -1613.0,
        -3390.9306640625,
        1500.0
      ],
      "bbox_max": [
        -1610.5,
        -3386.0,
        1501.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": 2357.710205078125,
      "bbox_min": [
        -1613.0,
        -3386.5,
        1500.0
      ],
      "bbox_max": [
        -1610.5,
        -3386.0,
        1501.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5301920771598816,
        -0.6185574531555176,
        -0.5798990726470947
      ],
      "plane_d": -363.12420654296875,
      "bbox_min": [
        -1620.5882568359375,
        -3388.7412109375,
        1499.468017578125
      ],
      "bbox_max": [
        -1617.5,
        -3386.0,
        1507.323974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.650791347026825,
        -0.7592566013336182,
        0.0
      ],
      "plane_d": -1516.56103515625,
      "bbox_min": [
        -1620.5882568359375,
        -3386.524658203125,
        1499.468017578125
      ],
      "bbox_max": [
        -1617.5,
        -3386.0,
        1504.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": 2357.710205078125,
      "bbox_min": [
        -1618.0306396484375,
        -3386.524658203125,
        1499.468017578125
      ],
      "bbox_max": [
        -1617.5,
        -3386.0,
        1501.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271206855774,
        -0.0,
        0.4472135603427887
      ],
      "plane_d": 775.91552734375,
      "bbox_min": [
        -1618.0306396484375,
        -3386.524658203125,
        1499.468017578125
      ],
      "bbox_max": [
        -1617.5,
        -3386.0,
        1501.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1617.5,
      "bbox_min": [
        -1618.0306396484375,
        -3386.524658203125,
        1499.468017578125
      ],
      "bbox_max": [
        -1617.5,
        -3386.0,
        1501.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1501.0,
      "bbox_min": [
        -1618.0306396484375,
        -3386.524658203125,
        1501.0
      ],
      "bbox_max": [
        -1618.0,
        -3386.5,
        1501.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3162277936935425,
        0.9486833810806274
      ],
      "plane_d": -2486.02490234375,
      "bbox_min": [
        -1606.5,
        -3392.11865234375,
        1487.5
      ],
      "bbox_max": [
        -1593.76123046875,
        -3386.0,
        1503.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3388.5,
      "bbox_min": [
        -1606.5,
        -3388.5,
        1487.5
      ],
      "bbox_max": [
        -1593.76123046875,
        -3386.0,
        1491.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3387.0,
      "bbox_min": [
        -1606.5,
        -3388.5,
        1487.5
      ],
      "bbox_max": [
        -1593.76123046875,
        -3386.0,
        1491.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1491.5,
      "bbox_min": [
        -1606.5,
        -3387.0,
        1487.5
      ],
      "bbox_max": [
        -1595.92529296875,
        -3386.0,
        1491.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1606.5,
      "bbox_min": [
        -1606.5,
        -3387.0,
        1487.5
      ],
      "bbox_max": [
        -1606.5,
        -3386.0,
        1491.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1490.5,
      "bbox_min": [
        -1606.5,
        -3388.5,
        1490.5
      ],
      "bbox_max": [
        -1593.76123046875,
        -3387.0,
        1491.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1606.5,
      "bbox_min": [
        -1606.5,
        -3388.5,
        1490.5
      ],
      "bbox_max": [
        -1606.5,
        -3387.0,
        1491.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4345989525318146,
        0.9006240963935852
      ],
      "plane_d": -2826.4560546875,
      "bbox_min": [
        -1605.5,
        -3392.11865234375,
        1498.73291015625
      ],
      "bbox_max": [
        -1595.4727783203125,
        -3386.0,
        1503.3504638671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.7771530747413635,
        -0.6293116211891174
      ],
      "plane_d": -1691.3135986328125,
      "bbox_min": [
        -1605.5,
        -3392.11865234375,
        1498.73291015625
      ],
      "bbox_max": [
        -1595.4727783203125,
        -3386.0,
        1503.3504638671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1605.5,
      "bbox_min": [
        -1605.5,
        -3392.11865234375,
        1498.73291015625
      ],
      "bbox_max": [
        -1595.5,
        -3386.0,
        1503.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1601.0,
      "bbox_min": [
        -1605.5,
        -3392.11865234375,
        1498.73291015625
      ],
      "bbox_max": [
        -1595.5,
        -3386.0,
        1503.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1501.4000244140625,
      "bbox_min": [
        -1605.5,
        -3389.916015625,
        1498.73291015625
      ],
      "bbox_max": [
        -1601.0,
        -3386.0,
        1503.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1500.5999755859375,
      "bbox_min": [
        -1605.5,
        -3389.916015625,
        1498.73291015625
      ],
      "bbox_max": [
        -1601.0,
        -3386.0,
        1501.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1602.5999755859375,
      "bbox_min": [
        -1605.5,
        -3388.39990234375,
        1500.5999755859375
      ],
      "bbox_max": [
        -1601.0,
        -3386.0,
        1501.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7158097624778748,
        -0.6982952952384949
      ],
      "plane_d": 3473.09326171875,
      "bbox_min": [
        -1605.5,
        -3388.39990234375,
        1500.5999755859375
      ],
      "bbox_max": [
        -1602.5999755859375,
        -3386.0,
        1501.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1603.4000244140625,
      "bbox_min": [
        -1603.4000244140625,
        -3388.39990234375,
        1500.5999755859375
      ],
      "bbox_max": [
        -1603.4000244140625,
        -3387.314453125,
        1501.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1603.4000244140625,
      "bbox_min": [
        -1603.4000244140625,
        -3388.094970703125,
        1500.5999755859375
      ],
      "bbox_max": [
        -1603.4000244140625,
        -3386.0,
        1501.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7158097624778748,
        -0.6982952952384949
      ],
      "plane_d": 3473.09326171875,
      "bbox_min": [
        -1602.5999755859375,
        -3388.0947265625,
        1500.5999755859375
      ],
      "bbox_max": [
        -1601.0,
        -3387.314208984375,
        1501.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7158097624778748,
        -0.6982952952384949
      ],
      "plane_d": 3473.09326171875,
      "bbox_min": [
        -1605.5,
        -3389.916015625,
        1498.73291015625
      ],
      "bbox_max": [
        -1601.0,
        -3388.0947265625,
        1500.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.777115523815155,
        0.6293579936027527
      ],
      "plane_d": 1686.8668212890625,
      "bbox_min": [
        -1605.5,
        -3388.1865234375,
        1501.4000244140625
      ],
      "bbox_max": [
        -1601.0,
        -3386.927734375,
        1503.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7158097624778748,
        -0.6982952952384949
      ],
      "plane_d": 3473.09326171875,
      "bbox_min": [
        -1605.5,
        -3387.314208984375,
        1501.4000244140625
      ],
      "bbox_max": [
        -1601.0,
        -3386.927734375,
        1501.796142578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1595.5,
      "bbox_min": [
        -1595.5,
        -3392.11865234375,
        1501.3792724609375
      ],
      "bbox_max": [
        -1595.5,
        -3392.058837890625,
        1501.4627685546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3384.5,
      "bbox_min": [
        -1627.311767578125,
        -3384.5,
        1505.0
      ],
      "bbox_max": [
        -1605.6710205078125,
        -3384.5,
        1510.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9400216937065125,
        0.3411146402359009
      ],
      "plane_d": 2738.791748046875,
      "bbox_min": [
        -1550.725830078125,
        -3485.0400390625,
        1562.79541015625
      ],
      "bbox_max": [
        -1531.6314697265625,
        -3480.6474609375,
        1574.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9726229310035706,
        0.20830567181110382,
        -0.10302186012268066
      ],
      "plane_d": 2349.484130859375,
      "bbox_min": [
        -1608.2640380859375,
        -3440.310546875,
        1394.68359375
      ],
      "bbox_max": [
        -1523.64404296875,
        -3382.0,
        1532.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3384.5,
      "bbox_min": [
        -1608.2640380859375,
        -3440.310546875,
        1451.0
      ],
      "bbox_max": [
        -1523.64404296875,
        -3382.0,
        1532.1119384765625
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1515.0,
      "bbox_min": [
        -1605.6710205078125,
        -3440.310546875,
        1451.0
      ],
      "bbox_max": [
        -1523.64404296875,
        -3384.5,
        1532.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071068286895752,
        0.7071068286895752
      ],
      "plane_d": 1329.00732421875,
      "bbox_min": [
        -1605.6710205078125,
        -3440.310546875,
        1451.0
      ],
      "bbox_max": [
        -1523.64404296875,
        -3384.5,
        1515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3386.0,
      "bbox_min": [
        -1585.748046875,
        -3427.755859375,
        1451.0
      ],
      "bbox_max": [
        -1538.0,
        -3384.5,
        1469.764404296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1538.0,
      "bbox_min": [
        -1584.4178466796875,
        -3427.755859375,
        1451.0
      ],
      "bbox_max": [
        -1538.0,
        -3386.0,
        1469.316650390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3410.0,
      "bbox_min": [
        -1584.4178466796875,
        -3410.0,
        1451.0
      ],
      "bbox_max": [
        -1538.0,
        -3386.0,
        1469.316650390625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6401844024658203,
        0.768221378326416,
        0.0
      ],
      "plane_d": 3592.3310546875,
      "bbox_min": [
        -1539.0,
        -3394.5,
        1459.0
      ],
      "bbox_max": [
        -1538.0,
        -3393.666748046875,
        1462.0382080078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3391.0,
      "bbox_min": [
        -1545.000244140625,
        -3391.0,
        1461.199951171875
      ],
      "bbox_max": [
        -1543.5,
        -3391.0,
        1462.823974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3390.0,
      "bbox_min": [
        -1584.4178466796875,
        -3404.5,
        1462.199951171875
      ],
      "bbox_max": [
        -1539.0,
        -3386.0,
        1469.316650390625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1465.199951171875,
      "bbox_min": [
        -1584.4178466796875,
        -3390.0,
        1462.199951171875
      ],
      "bbox_max": [
        -1551.0,
        -3386.0,
        1468.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 1574.9998779296875,
      "bbox_min": [
        -1575.0,
        -3387.0,
        1462.199951171875
      ],
      "bbox_max": [
        -1551.0,
        -3386.0,
        1465.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": -1550.9998779296875,
      "bbox_min": [
        -1551.0,
        -3387.0,
        1462.199951171875
      ],
      "bbox_max": [
        -1551.0,
        -3386.0,
        1463.446533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1468.199951171875,
      "bbox_min": [
        -1575.0,
        -3390.0,
        1468.199951171875
      ],
      "bbox_max": [
        -1574.6654052734375,
        -3389.4931640625,
        1468.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1466.199951171875,
      "bbox_min": [
        -1583.89892578125,
        -3390.0,
        1465.199951171875
      ],
      "bbox_max": [
        -1575.0,
        -3386.0,
        1466.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1547.0,
      "bbox_min": [
        -1547.0,
        -3404.5,
        1462.199951171875
      ],
      "bbox_max": [
        -1547.0,
        -3397.0,
        1464.8466796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3391.0,
      "bbox_min": [
        -1580.0308837890625,
        -3391.0,
        1462.199951171875
      ],
      "bbox_max": [
        -1545.000244140625,
        -3390.0,
        1469.316650390625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1550.9998779296875,
      "bbox_min": [
        -1551.0,
        -3391.0,
        1462.199951171875
      ],
      "bbox_max": [
        -1551.0,
        -3390.0,
        1463.93603515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1547.0,
      "bbox_min": [
        -1547.0,
        -3404.5,
        1455.5
      ],
      "bbox_max": [
        -1547.0,
        -3397.0,
        1462.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1461.199951171875,
      "bbox_min": [
        -1581.3057861328125,
        -3391.0,
        1451.0
      ],
      "bbox_max": [
        -1545.000244140625,
        -3386.0,
        1462.199951171875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3391.0,
      "bbox_min": [
        -1576.3394775390625,
        -3391.0,
        1461.199951171875
      ],
      "bbox_max": [
        -1545.000244140625,
        -3386.0,
        1462.199951171875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1574.9998779296875,
      "bbox_min": [
        -1575.0,
        -3391.0,
        1461.199951171875
      ],
      "bbox_max": [
        -1551.0,
        -3386.0,
        1462.199951171875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        -0.0
      ],
      "plane_d": -1550.9998779296875,
      "bbox_min": [
        -1551.0,
        -3391.0,
        1461.199951171875
      ],
      "bbox_max": [
        -1551.0,
        -3386.0,
        1462.199951171875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.7337597012519836,
        -0.6794091463088989
      ],
      "plane_d": -1495.556884765625,
      "bbox_min": [
        -1577.65380859375,
        -3390.39990234375,
        1454.7078857421875
      ],
      "bbox_max": [
        -1576.0,
        -3387.39990234375,
        1461.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3390.39990234375,
      "bbox_min": [
        -1576.4791259765625,
        -3390.39990234375,
        1460.3599853515625
      ],
      "bbox_max": [
        -1576.0,
        -3390.39990234375,
        1461.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3387.39990234375,
      "bbox_min": [
        -1577.65380859375,
        -3387.76708984375,
        1454.7078857421875
      ],
      "bbox_max": [
        -1576.0,
        -3387.39990234375,
        1457.1199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7117644548416138,
        0.7024182677268982
      ],
      "plane_d": -3433.10546875,
      "bbox_min": [
        -1576.5958251953125,
        -3387.76708984375,
        1454.7078857421875
      ],
      "bbox_max": [
        -1576.0,
        -3387.39990234375,
        1455.0799560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 3508.0771484375,
      "bbox_min": [
        -1561.7855224609375,
        -3410.0,
        1454.5
      ],
      "bbox_max": [
        -1539.0,
        -3404.5,
        1467.8875732421875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.25883668661117554,
        0.96592116355896,
        0.0
      ],
      "plane_d": 3692.22900390625,
      "bbox_min": [
        -1561.7855224609375,
        -3410.0,
        1454.5
      ],
      "bbox_max": [
        -1553.0,
        -3405.0,
        1467.8875732421875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.96592116355896,
        0.25883668661117554,
        0.0
      ],
      "plane_d": 2382.708740234375,
      "bbox_min": [
        -1561.7855224609375,
        -3410.0,
        1454.5
      ],
      "bbox_max": [
        -1553.0,
        -3405.0,
        1467.8875732421875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.25883668661117554,
        0.96592116355896,
        0.0
      ],
      "plane_d": 2885.694091796875,
      "bbox_min": [
        -1561.7855224609375,
        -3408.192138671875,
        1454.5
      ],
      "bbox_max": [
        -1553.484375,
        -3405.0,
        1467.8875732421875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 1304.732177734375,
      "bbox_min": [
        -1561.7855224609375,
        -3408.192138671875,
        1454.5
      ],
      "bbox_max": [
        -1553.484375,
        -3405.384765625,
        1467.8875732421875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1454.5,
      "bbox_min": [
        -1556.5643310546875,
        -3408.192138671875,
        1454.5
      ],
      "bbox_max": [
        -1553.484375,
        -3405.384765625,
        1454.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3162277936935425,
        -0.9486833810806274,
        0.0
      ],
      "plane_d": -3719.78759765625,
      "bbox_min": [
        -1545.0,
        -3408.0,
        1458.0
      ],
      "bbox_max": [
        -1539.0,
        -3404.5,
        1462.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1462.5,
      "bbox_min": [
        -1545.0,
        -3408.0,
        1458.0
      ],
      "bbox_max": [
        -1539.0,
        -3404.5,
        1462.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1458.0,
      "bbox_min": [
        -1545.0,
        -3408.0,
        1458.0
      ],
      "bbox_max": [
        -1539.0,
        -3404.5,
        1462.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1545.0,
      "bbox_min": [
        -1545.0,
        -3406.0,
        1458.0
      ],
      "bbox_max": [
        -1545.0,
        -3404.5,
        1462.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7295363545417786,
        -0.6839420795440674
      ],
      "plane_d": -1441.2877197265625,
      "bbox_min": [
        -1603.7137451171875,
        -3437.117919921875,
        1460.7421875
      ],
      "bbox_max": [
        -1534.83056640625,
        -3384.5,
        1515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5076730251312256,
        0.6092076897621155,
        0.6092076897621155
      ],
      "plane_d": 1931.8992919921875,
      "bbox_min": [
        -1550.0,
        -3395.937744140625,
        1502.7996826171875
      ],
      "bbox_max": [
        -1547.524658203125,
        -3384.5,
        1515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6401844024658203,
        0.768221378326416,
        -0.0
      ],
      "plane_d": 3592.3310546875,
      "bbox_min": [
        -1550.0,
        -3395.937744140625,
        1502.7996826171875
      ],
      "bbox_max": [
        -1547.524658203125,
        -3384.5,
        1515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6401844024658203,
        -0.0,
        0.768221378326416
      ],
      "plane_d": -171.569580078125,
      "bbox_min": [
        -1550.0,
        -3395.937744140625,
        1513.4664306640625
      ],
      "bbox_max": [
        -1548.1597900390625,
        -3394.5,
        1515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1514.0,
      "bbox_min": [
        -1603.7137451171875,
        -3437.117919921875,
        1460.7421875
      ],
      "bbox_max": [
        -1534.83056640625,
        -3384.5,
        1515.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6401844024658203,
        -0.0,
        0.768221378326416
      ],
      "plane_d": -171.569580078125,
      "bbox_min": [
        -1563.135986328125,
        -3429.10009765625,
        1514.0
      ],
      "bbox_max": [
        -1548.800048828125,
        -3395.000244140625,
        1515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 1538.0,
      "bbox_min": [
        -1603.7137451171875,
        -3437.117919921875,
        1472.5625
      ],
      "bbox_max": [
        -1538.0,
        -3384.5,
        1514.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6401844024658203,
        -0.0,
        0.768221378326416
      ],
      "plane_d": -171.569580078125,
      "bbox_min": [
        -1603.7137451171875,
        -3437.117919921875,
        1472.5625
      ],
      "bbox_max": [
        -1538.0,
        -3384.5,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1486.5,
      "bbox_min": [
        -1603.7137451171875,
        -3437.117919921875,
        1472.5625
      ],
      "bbox_max": [
        -1538.0,
        -3384.5,
        1514.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6401844024658203,
        0.768221378326416,
        0.0
      ],
      "plane_d": 3592.3310546875,
      "bbox_min": [
        -1571.0,
        -3432.28564453125,
        1472.5625
      ],
      "bbox_max": [
        -1538.0,
        -3384.5,
        1486.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3402.0,
      "bbox_min": [
        -1571.0,
        -3432.28564453125,
        1476.0333251953125
      ],
      "bbox_max": [
        -1538.0,
        -3396.39990234375,
        1486.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -1487.7000732421875,
      "bbox_min": [
        -1551.0,
        -3432.28564453125,
        1477.6666259765625
      ],
      "bbox_max": [
        -1538.0,
        -3402.0,
        1486.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1550.9998779296875,
      "bbox_min": [
        -1551.0,
        -3404.857177734375,
        1477.6666259765625
      ],
      "bbox_max": [
        -1551.0,
        -3402.0,
        1478.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1569.800048828125,
      "bbox_min": [
        -1571.0,
        -3397.60009765625,
        1476.0333251953125
      ],
      "bbox_max": [
        -1556.0,
        -3396.39990234375,
        1476.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3396.39990234375,
      "bbox_min": [
        -1571.0,
        -3397.60009765625,
        1476.0333251953125
      ],
      "bbox_max": [
        -1569.800048828125,
        -3396.39990234375,
        1476.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1571.0,
      "bbox_min": [
        -1571.0,
        -3397.60009765625,
        1476.0333251953125
      ],
      "bbox_max": [
        -1569.800048828125,
        -3396.39990234375,
        1476.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3397.60009765625,
      "bbox_min": [
        -1571.0,
        -3397.60009765625,
        1476.3834228515625
      ],
      "bbox_max": [
        -1569.800048828125,
        -3397.60009765625,
        1476.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3396.39990234375,
      "bbox_min": [
        -1557.199951171875,
        -3397.60009765625,
        1476.0333251953125
      ],
      "bbox_max": [
        -1556.0,
        -3396.39990234375,
        1476.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1557.199951171875,
      "bbox_min": [
        -1557.199951171875,
        -3397.60009765625,
        1476.0333251953125
      ],
      "bbox_max": [
        -1556.0,
        -3396.39990234375,
        1476.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1556.0,
      "bbox_min": [
        -1557.199951171875,
        -3397.60009765625,
        1476.0333251953125
      ],
      "bbox_max": [
        -1556.0,
        -3396.39990234375,
        1476.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3397.60009765625,
      "bbox_min": [
        -1557.199951171875,
        -3397.60009765625,
        1476.3834228515625
      ],
      "bbox_max": [
        -1556.0,
        -3397.60009765625,
        1476.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3410.0,
      "bbox_min": [
        -1603.7137451171875,
        -3437.117919921875,
        1486.5
      ],
      "bbox_max": [
        -1538.0,
        -3384.5,
        1514.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3411.0,
      "bbox_min": [
        -1581.2674560546875,
        -3437.117919921875,
        1486.5
      ],
      "bbox_max": [
        -1538.0,
        -3410.0,
        1514.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1574.5,
      "bbox_min": [
        -1580.5,
        -3411.0,
        1486.5
      ],
      "bbox_max": [
        -1555.0,
        -3410.0,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1555.0,
      "bbox_min": [
        -1555.0,
        -3411.0,
        1486.5
      ],
      "bbox_max": [
        -1555.0,
        -3410.0,
        1514.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1580.5,
      "bbox_min": [
        -1580.5,
        -3411.0,
        1510.406005859375
      ],
      "bbox_max": [
        -1580.5,
        -3410.0,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -1487.7000732421875,
      "bbox_min": [
        -1571.5,
        -3437.117919921875,
        1486.5
      ],
      "bbox_max": [
        -1538.0,
        -3411.0,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9899495244026184,
        -0.0,
        -0.1414213627576828
      ],
      "plane_d": -1341.59375,
      "bbox_min": [
        -1571.5,
        -3436.374755859375,
        1486.5
      ],
      "bbox_max": [
        -1550.0,
        -3411.0,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9899495244026184,
        0.0,
        -0.1414213627576828
      ],
      "plane_d": 1756.9482421875,
      "bbox_min": [
        -1569.0,
        -3436.374755859375,
        1486.5
      ],
      "bbox_max": [
        -1550.0,
        -3411.0,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1496.5,
      "bbox_min": [
        -1569.0,
        -3430.813720703125,
        1496.5
      ],
      "bbox_max": [
        -1558.4998779296875,
        -3411.0,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3428.0,
      "bbox_min": [
        -1562.6173095703125,
        -3430.813720703125,
        1507.7763671875
      ],
      "bbox_max": [
        -1558.4998779296875,
        -3428.0,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6726728081703186,
        0.7399401068687439
      ],
      "plane_d": -3426.931640625,
      "bbox_min": [
        -1561.4105224609375,
        -3430.813720703125,
        1512.442138671875
      ],
      "bbox_max": [
        -1558.4998779296875,
        -3429.10009765625,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1555.0,
      "bbox_min": [
        -1559.38916015625,
        -3436.374755859375,
        1486.5
      ],
      "bbox_max": [
        -1550.0,
        -3411.0,
        1514.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.6726728081703186,
        0.7399401068687439
      ],
      "plane_d": -3426.931640625,
      "bbox_min": [
        -1555.0,
        -3436.374755859375,
        1507.38671875
      ],
      "bbox_max": [
        -1550.0,
        -3429.10009765625,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3428.0,
      "bbox_min": [
        -1559.38916015625,
        -3433.18701171875,
        1499.3145751953125
      ],
      "bbox_max": [
        -1555.0,
        -3428.0,
        1514.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.6726728081703186,
        0.7399401068687439
      ],
      "plane_d": -3426.931640625,
      "bbox_min": [
        -1558.7225341796875,
        -3433.18701171875,
        1510.28466796875
      ],
      "bbox_max": [
        -1555.0,
        -3429.10009765625,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3386.0,
      "bbox_min": [
        -1603.7137451171875,
        -3410.0,
        1486.5
      ],
      "bbox_max": [
        -1538.0,
        -3384.5,
        1514.0
      ],
      "face_count": 15
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1499.0,
      "bbox_min": [
        -1602.55859375,
        -3386.0,
        1486.5
      ],
      "bbox_max": [
        -1548.199951171875,
        -3384.5,
        1504.3997802734375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6401844024658203,
        0.768221378326416,
        -0.0
      ],
      "plane_d": 3592.3310546875,
      "bbox_min": [
        -1550.0,
        -3385.0,
        1499.0
      ],
      "bbox_max": [
        -1549.4000244140625,
        -3384.5,
        1503.3330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6401844024658203,
        0.768221378326416,
        -0.0
      ],
      "plane_d": 3592.3310546875,
      "bbox_min": [
        -1549.4000244140625,
        -3386.0,
        1499.0
      ],
      "bbox_max": [
        -1548.199951171875,
        -3385.0,
        1504.3997802734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3385.0,
      "bbox_min": [
        -1602.0101318359375,
        -3386.0,
        1486.5
      ],
      "bbox_max": [
        -1548.199951171875,
        -3384.5,
        1499.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1492.0,
      "bbox_min": [
        -1598.927734375,
        -3385.0,
        1486.5
      ],
      "bbox_max": [
        -1549.4000244140625,
        -3384.5,
        1499.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6401844024658203,
        0.768221378326416,
        -0.0
      ],
      "plane_d": 3592.3310546875,
      "bbox_min": [
        -1550.0,
        -3385.0,
        1486.5
      ],
      "bbox_max": [
        -1549.4000244140625,
        -3384.5,
        1488.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9908301830291748,
        -0.0,
        -0.1351132094860077
      ],
      "plane_d": -1344.6466064453125,
      "bbox_min": [
        -1570.0,
        -3385.0,
        1488.0
      ],
      "bbox_max": [
        -1549.4000244140625,
        -3384.5,
        1492.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6401844024658203,
        0.768221378326416,
        -0.0
      ],
      "plane_d": 3592.3310546875,
      "bbox_min": [
        -1550.0,
        -3385.0,
        1488.0
      ],
      "bbox_max": [
        -1549.4000244140625,
        -3384.5,
        1492.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9908301830291748,
        0.0,
        -0.1351132094860077
      ],
      "plane_d": 1756.65185546875,
      "bbox_min": [
        -1570.0,
        -3385.0,
        1488.0
      ],
      "bbox_max": [
        -1569.45458984375,
        -3384.5,
        1492.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1578.5,
      "bbox_min": [
        -1580.5,
        -3385.0,
        1492.0
      ],
      "bbox_max": [
        -1578.5,
        -3384.5,
        1499.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6000000238418579,
        0.0,
        0.800000011920929
      ],
      "plane_d": -2141.89990234375,
      "bbox_min": [
        -1580.5,
        -3385.0,
        1492.0
      ],
      "bbox_max": [
        -1578.5,
        -3384.5,
        1499.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6000000238418579,
        0.0,
        -0.800000011920929
      ],
      "plane_d": 250.9000244140625,
      "bbox_min": [
        -1580.5,
        -3385.0,
        1497.5
      ],
      "bbox_max": [
        -1578.5,
        -3384.5,
        1499.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9908301830291748,
        -0.0,
        -0.1351132094860077
      ],
      "plane_d": -1344.6466064453125,
      "bbox_min": [
        -1561.5,
        -3385.0,
        1492.0
      ],
      "bbox_max": [
        -1549.4000244140625,
        -3384.5,
        1499.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6401844024658203,
        0.768221378326416,
        -0.0
      ],
      "plane_d": 3592.3310546875,
      "bbox_min": [
        -1550.0,
        -3385.0,
        1492.0
      ],
      "bbox_max": [
        -1549.4000244140625,
        -3384.5,
        1499.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6401844024658203,
        0.768221378326416,
        -0.0
      ],
      "plane_d": 3592.3310546875,
      "bbox_min": [
        -1598.379150390625,
        -3386.0,
        1486.5
      ],
      "bbox_max": [
        -1548.199951171875,
        -3385.0,
        1499.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1492.0,
      "bbox_min": [
        -1598.379150390625,
        -3386.0,
        1488.0
      ],
      "bbox_max": [
        -1560.0,
        -3385.0,
        1499.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9908301830291748,
        -0.0,
        -0.1351132094860077
      ],
      "plane_d": -1344.6466064453125,
      "bbox_min": [
        -1570.0,
        -3386.0,
        1488.0
      ],
      "bbox_max": [
        -1560.0,
        -3385.0,
        1492.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1578.5,
      "bbox_min": [
        -1580.5,
        -3386.0,
        1492.0
      ],
      "bbox_max": [
        -1578.5,
        -3385.0,
        1499.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6000000238418579,
        0.0,
        0.800000011920929
      ],
      "plane_d": -2141.89990234375,
      "bbox_min": [
        -1580.5,
        -3386.0,
        1492.0
      ],
      "bbox_max": [
        -1578.5,
        -3385.0,
        1499.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6000000238418579,
        0.0,
        -0.800000011920929
      ],
      "plane_d": 250.9000244140625,
      "bbox_min": [
        -1580.5,
        -3386.0,
        1497.5
      ],
      "bbox_max": [
        -1578.5,
        -3385.0,
        1499.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9908301830291748,
        -0.0,
        -0.1351132094860077
      ],
      "plane_d": -1344.6466064453125,
      "bbox_min": [
        -1561.5,
        -3386.0,
        1492.0
      ],
      "bbox_max": [
        -1560.54541015625,
        -3385.0,
        1499.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1555.0,
      "bbox_min": [
        -1601.345458984375,
        -3410.0,
        1486.5
      ],
      "bbox_max": [
        -1538.0,
        -3386.0,
        1514.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.5076730251312256,
        0.6092076897621155,
        0.6092076897621155
      ],
      "plane_d": 1931.8992919921875,
      "bbox_min": [
        -1548.1597900390625,
        -3394.5,
        1505.0
      ],
      "bbox_max": [
        -1538.0,
        -3386.562744140625,
        1513.4664306640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9983712434768677,
        -0.05704978480935097
      ],
      "plane_d": 3488.822509765625,
      "bbox_min": [
        -1601.345458984375,
        -3410.0,
        1486.5
      ],
      "bbox_max": [
        -1558.5,
        -3386.0,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9899495244026184,
        -0.0,
        -0.1414213627576828
      ],
      "plane_d": -1341.59375,
      "bbox_min": [
        -1571.5,
        -3410.0,
        1496.5
      ],
      "bbox_max": [
        -1558.5,
        -3408.0,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9899495244026184,
        0.0,
        -0.1414213627576828
      ],
      "plane_d": 1756.9482421875,
      "bbox_min": [
        -1569.0,
        -3410.0,
        1496.5
      ],
      "bbox_max": [
        -1558.5,
        -3408.0,
        1514.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1496.5,
      "bbox_min": [
        -1569.0,
        -3410.0,
        1496.5
      ],
      "bbox_max": [
        -1561.0,
        -3409.0,
        1496.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1491.5,
      "bbox_min": [
        -1601.345458984375,
        -3398.5,
        1486.5
      ],
      "bbox_max": [
        -1560.0,
        -3386.0,
        1512.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3162277936935425,
        0.9486833810806274
      ],
      "plane_d": -2486.02490234375,
      "bbox_min": [
        -1595.92529296875,
        -3393.0,
        1486.5
      ],
      "bbox_max": [
        -1560.0,
        -3386.0,
        1491.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1487.5,
      "bbox_min": [
        -1595.92529296875,
        -3393.0,
        1486.5
      ],
      "bbox_max": [
        -1560.0,
        -3386.0,
        1491.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3393.0,
      "bbox_min": [
        -1587.2679443359375,
        -3393.0,
        1486.5
      ],
      "bbox_max": [
        -1560.0,
        -3386.0,
        1487.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3511234521865845,
        0.936329185962677
      ],
      "plane_d": -2582.161865234375,
      "bbox_min": [
        -1578.5,
        -3393.0,
        1486.5
      ],
      "bbox_max": [
        -1560.0,
        -3386.0,
        1487.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1570.0,
      "bbox_min": [
        -1576.5,
        -3390.0,
        1486.5
      ],
      "bbox_max": [
        -1560.0,
        -3386.0,
        1487.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1560.0,
      "bbox_min": [
        -1560.0,
        -3390.0,
        1486.5
      ],
      "bbox_max": [
        -1560.0,
        -3386.0,
        1487.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1576.5,
      "bbox_min": [
        -1576.5,
        -3389.99951171875,
        1486.5
      ],
      "bbox_max": [
        -1576.5,
        -3386.0,
        1487.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1576.5,
      "bbox_min": [
        -1578.5,
        -3393.0,
        1486.5
      ],
      "bbox_max": [
        -1576.5,
        -3387.3330078125,
        1487.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -1283.04541015625,
      "bbox_min": [
        -1578.5,
        -3393.0,
        1486.5
      ],
      "bbox_max": [
        -1576.5,
        -3391.0,
        1487.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3388.5,
      "bbox_min": [
        -1595.92529296875,
        -3388.5,
        1487.5
      ],
      "bbox_max": [
        -1560.0,
        -3386.0,
        1491.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1490.5,
      "bbox_min": [
        -1595.92529296875,
        -3388.5,
        1487.5
      ],
      "bbox_max": [
        -1560.0,
        -3386.0,
        1491.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3387.0,
      "bbox_min": [
        -1595.92529296875,
        -3388.5,
        1490.5
      ],
      "bbox_max": [
        -1580.5,
        -3386.0,
        1491.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1580.5,
      "bbox_min": [
        -1580.5,
        -3387.0,
        1490.5
      ],
      "bbox_max": [
        -1580.5,
        -3386.0,
        1491.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1580.5,
      "bbox_min": [
        -1580.5,
        -3388.5,
        1490.5
      ],
      "bbox_max": [
        -1580.5,
        -3387.0,
        1491.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3387.0,
      "bbox_min": [
        -1595.406494140625,
        -3387.333251953125,
        1487.5
      ],
      "bbox_max": [
        -1560.0,
        -3386.0,
        1490.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1560.0,
      "bbox_min": [
        -1560.0,
        -3387.0,
        1487.5
      ],
      "bbox_max": [
        -1560.0,
        -3386.0,
        1488.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1580.5,
      "bbox_min": [
        -1580.5,
        -3387.0,
        1487.5
      ],
      "bbox_max": [
        -1580.5,
        -3386.0,
        1487.9998779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1580.5,
      "bbox_min": [
        -1580.5,
        -3387.0,
        1487.6248779296875
      ],
      "bbox_max": [
        -1580.5,
        -3386.0,
        1490.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.3511234521865845,
        0.936329185962677
      ],
      "plane_d": -2582.161865234375,
      "bbox_min": [
        -1570.0,
        -3387.333251953125,
        1487.5
      ],
      "bbox_max": [
        -1560.0,
        -3387.0,
        1487.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1570.0,
      "bbox_min": [
        -1570.0,
        -3387.333251953125,
        1487.5
      ],
      "bbox_max": [
        -1560.0,
        -3387.0,
        1487.625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1511.5,
      "bbox_min": [
        -1596.42578125,
        -3398.5,
        1511.5
      ],
      "bbox_max": [
        -1586.0,
        -3396.0,
        1512.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3398.5,
      "bbox_min": [
        -1593.94287109375,
        -3398.5,
        1511.5
      ],
      "bbox_max": [
        -1586.0,
        -3396.0,
        1512.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1586.0,
      "bbox_min": [
        -1586.0,
        -3398.5,
        1511.5
      ],
      "bbox_max": [
        -1586.0,
        -3396.0,
        1512.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.4345989525318146,
        0.9006240963935852
      ],
      "plane_d": -2826.4560546875,
      "bbox_min": [
        -1601.345458984375,
        -3392.11865234375,
        1498.73291015625
      ],
      "bbox_max": [
        -1580.5,
        -3386.0,
        1503.3504638671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1591.0,
      "bbox_min": [
        -1601.345458984375,
        -3392.11865234375,
        1498.73291015625
      ],
      "bbox_max": [
        -1580.5,
        -3386.0,
        1503.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7771530747413635,
        -0.6293116211891174
      ],
      "plane_d": -1691.3135986328125,
      "bbox_min": [
        -1601.345458984375,
        -3392.11865234375,
        1498.73291015625
      ],
      "bbox_max": [
        -1591.0,
        -3386.0,
        1503.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1595.5,
      "bbox_min": [
        -1601.345458984375,
        -3392.098388671875,
        1498.73291015625
      ],
      "bbox_max": [
        -1591.0,
        -3386.0,
        1503.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1501.4000244140625,
      "bbox_min": [
        -1595.5,
        -3389.916015625,
        1498.73291015625
      ],
      "bbox_max": [
        -1591.0,
        -3386.0,
        1503.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1500.5999755859375,
      "bbox_min": [
        -1595.5,
        -3389.916015625,
        1498.73291015625
      ],
      "bbox_max": [
        -1591.0,
        -3386.0,
        1501.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1592.5999755859375,
      "bbox_min": [
        -1595.5,
        -3388.39990234375,
        1500.5999755859375
      ],
      "bbox_max": [
        -1591.0,
        -3386.0,
        1501.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7158097624778748,
        -0.6982952952384949
      ],
      "plane_d": 3473.09326171875,
      "bbox_min": [
        -1595.5,
        -3388.39990234375,
        1500.5999755859375
      ],
      "bbox_max": [
        -1592.5999755859375,
        -3386.0,
        1501.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1593.4000244140625,
      "bbox_min": [
        -1593.4000244140625,
        -3388.39990234375,
        1500.5999755859375
      ],
      "bbox_max": [
        -1593.4000244140625,
        -3387.314453125,
        1501.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1593.4000244140625,
      "bbox_min": [
        -1593.4000244140625,
        -3388.094970703125,
        1500.5999755859375
      ],
      "bbox_max": [
        -1593.4000244140625,
        -3386.0,
        1501.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7158097624778748,
        -0.6982952952384949
      ],
      "plane_d": 3473.09326171875,
      "bbox_min": [
        -1592.5999755859375,
        -3388.0947265625,
        1500.5999755859375
      ],
      "bbox_max": [
        -1591.0,
        -3387.314208984375,
        1501.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7158097624778748,
        -0.6982952952384949
      ],
      "plane_d": 3473.09326171875,
      "bbox_min": [
        -1595.5,
        -3389.916015625,
        1498.73291015625
      ],
      "bbox_max": [
        -1591.0,
        -3388.0947265625,
        1500.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.777115523815155,
        0.6293579936027527
      ],
      "plane_d": 1686.8668212890625,
      "bbox_min": [
        -1595.5,
        -3388.1865234375,
        1501.4000244140625
      ],
      "bbox_max": [
        -1591.0,
        -3386.927734375,
        1503.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7158097624778748,
        -0.6982952952384949
      ],
      "plane_d": 3473.09326171875,
      "bbox_min": [
        -1595.5,
        -3387.314208984375,
        1501.4000244140625
      ],
      "bbox_max": [
        -1591.0,
        -3386.927734375,
        1501.796142578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1601.0,
      "bbox_min": [
        -1601.345458984375,
        -3387.6845703125,
        1501.5787353515625
      ],
      "bbox_max": [
        -1601.0,
        -3386.927734375,
        1502.7305908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.777115523815155,
        0.6293579936027527
      ],
      "plane_d": 1686.8668212890625,
      "bbox_min": [
        -1601.345458984375,
        -3387.6845703125,
        1501.5787353515625
      ],
      "bbox_max": [
        -1601.0,
        -3386.927734375,
        1502.7305908203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7158097624778748,
        -0.6982952952384949
      ],
      "plane_d": 3473.09326171875,
      "bbox_min": [
        -1601.345458984375,
        -3387.139892578125,
        1501.5787353515625
      ],
      "bbox_max": [
        -1601.0,
        -3386.927734375,
        1501.796142578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7771530747413635,
        -0.6293116211891174
      ],
      "plane_d": -1691.3135986328125,
      "bbox_min": [
        -1585.0,
        -3392.11865234375,
        1498.73291015625
      ],
      "bbox_max": [
        -1580.5,
        -3386.0,
        1503.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1580.5,
      "bbox_min": [
        -1585.0,
        -3392.11865234375,
        1498.73291015625
      ],
      "bbox_max": [
        -1580.5,
        -3386.0,
        1503.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1585.0,
      "bbox_min": [
        -1585.0,
        -3392.11865234375,
        1498.73291015625
      ],
      "bbox_max": [
        -1580.5,
        -3386.0,
        1503.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1501.4000244140625,
      "bbox_min": [
        -1585.0,
        -3389.916015625,
        1498.73291015625
      ],
      "bbox_max": [
        -1580.5,
        -3386.0,
        1503.3504638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1582.800048828125,
      "bbox_min": [
        -1585.0,
        -3389.916015625,
        1498.73291015625
      ],
      "bbox_max": [
        -1580.5,
        -3386.0,
        1501.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1500.5999755859375,
      "bbox_min": [
        -1582.800048828125,
        -3389.916015625,
        1498.73291015625
      ],
      "bbox_max": [
        -1580.5,
        -3386.0,
        1501.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7158097624778748,
        -0.6982952952384949
      ],
      "plane_d": 3473.09326171875,
      "bbox_min": [
        -1582.800048828125,
        -3388.39990234375,
        1500.5999755859375
      ],
      "bbox_max": [
        -1580.5,
        -3386.0,
        1501.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1582.0,
      "bbox_min": [
        -1582.0,
        -3388.39990234375,
        1500.5999755859375
      ],
      "bbox_max": [
        -1582.0,
        -3387.314453125,
        1501.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1582.0,
      "bbox_min": [
        -1582.0,
        -3388.094970703125,
        1500.5999755859375
      ],
      "bbox_max": [
        -1582.0,
        -3386.0,
        1501.4000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7158097624778748,
        -0.6982952952384949
      ],
      "plane_d": 3473.09326171875,
      "bbox_min": [
        -1582.800048828125,
        -3389.916015625,
        1498.73291015625
      ],
      "bbox_max": [
        -1580.5,
        -3388.0947265625,
        1500.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7158097624778748,
        -0.6982952952384949
      ],
      "plane_d": 3473.09326171875,
      "bbox_min": [
        -1585.0,
        -3387.314208984375,
        1501.4000244140625
      ],
      "bbox_max": [
        -1580.5,
        -3386.927734375,
        1501.796142578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1538.0,
      "bbox_min": [
        -1587.4263916015625,
        -3432.764892578125,
        1460.7421875
      ],
      "bbox_max": [
        -1534.83056640625,
        -3384.5,
        1486.6397705078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.18481668829917908,
        0.05494606867432594,
        0.9812358021736145
      ],
      "plane_d": -963.4822998046875,
      "bbox_min": [
        -1550.0,
        -3386.0,
        1461.1119384765625
      ],
      "bbox_max": [
        -1538.0,
        -3384.5,
        1463.3721923828125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6401844024658203,
        0.768221378326416,
        0.0
      ],
      "plane_d": 3592.3310546875,
      "bbox_min": [
        -1551.0,
        -3432.764892578125,
        1472.3194580078125
      ],
      "bbox_max": [
        -1538.0,
        -3386.0,
        1486.6397705078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3402.0,
      "bbox_min": [
        -1551.0,
        -3432.764892578125,
        1475.0
      ],
      "bbox_max": [
        -1538.0,
        -3402.0,
        1486.6397705078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -1487.7000732421875,
      "bbox_min": [
        -1543.197998046875,
        -3432.764892578125,
        1475.0
      ],
      "bbox_max": [
        -1538.0,
        -3402.0,
        1486.6397705078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1475.0,
      "bbox_min": [
        -1540.0281982421875,
        -3402.85693359375,
        1475.0
      ],
      "bbox_max": [
        -1539.0,
        -3402.0,
        1475.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6757246851921082,
        -0.7371541857719421,
        0.0
      ],
      "plane_d": -1487.699951171875,
      "bbox_min": [
        -1587.011474609375,
        -3432.2470703125,
        1461.1959228515625
      ],
      "bbox_max": [
        -1538.0,
        -3386.0,
        1484.4552001953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3410.0,
      "bbox_min": [
        -1587.011474609375,
        -3410.0,
        1461.1959228515625
      ],
      "bbox_max": [
        -1538.0,
        -3386.0,
        1480.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1475.0,
      "bbox_min": [
        -1544.14306640625,
        -3409.0,
        1475.0
      ],
      "bbox_max": [
        -1539.0,
        -3402.0,
        1476.0001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3402.0,
      "bbox_min": [
        -1544.14306640625,
        -3402.0,
        1475.0
      ],
      "bbox_max": [
        -1540.0281982421875,
        -3402.0,
        1476.0001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1539.0,
      "bbox_min": [
        -1587.011474609375,
        -3410.0,
        1462.32373046875
      ],
      "bbox_max": [
        -1539.0,
        -3386.0,
        1478.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3404.5,
      "bbox_min": [
        -1587.011474609375,
        -3410.0,
        1462.32373046875
      ],
      "bbox_max": [
        -1539.0,
        -3386.0,
        1478.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1471.199951171875,
      "bbox_min": [
        -1587.011474609375,
        -3404.5,
        1462.32373046875
      ],
      "bbox_max": [
        -1539.0,
        -3386.0,
        1478.395751953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3390.0,
      "bbox_min": [
        -1581.0078125,
        -3404.5,
        1462.32373046875
      ],
      "bbox_max": [
        -1539.0,
        -3386.0,
        1471.199951171875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1468.199951171875,
      "bbox_min": [
        -1575.0,
        -3390.0,
        1462.9239501953125
      ],
      "bbox_max": [
        -1544.699951171875,
        -3386.0,
        1471.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        -0.768221378326416,
        -0.0
      ],
      "plane_d": -3594.12353515625,
      "bbox_min": [
        -1575.0,
        -3390.0,
        1468.199951171875
      ],
      "bbox_max": [
        -1546.199951171875,
        -3386.0,
        1471.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        -0.0,
        0.0
      ],
      "plane_d": 1574.9998779296875,
      "bbox_min": [
        -1575.0,
        -3387.0,
        1468.199951171875
      ],
      "bbox_max": [
        -1551.0,
        -3386.0,
        1471.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": -1550.9998779296875,
      "bbox_min": [
        -1551.0,
        -3387.0,
        1468.199951171875
      ],
      "bbox_max": [
        -1551.0,
        -3386.0,
        1471.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        -0.0
      ],
      "plane_d": -1550.9998779296875,
      "bbox_min": [
        -1575.0,
        -3390.0,
        1462.9239501953125
      ],
      "bbox_max": [
        -1544.699951171875,
        -3386.0,
        1468.199951171875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1467.199951171875,
      "bbox_min": [
        -1551.0,
        -3390.0,
        1462.9239501953125
      ],
      "bbox_max": [
        -1544.699951171875,
        -3386.0,
        1468.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        -0.768221378326416,
        -0.0
      ],
      "plane_d": -3594.12353515625,
      "bbox_min": [
        -1551.0,
        -3390.0,
        1467.199951171875
      ],
      "bbox_max": [
        -1546.199951171875,
        -3386.0,
        1468.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        -0.768221378326416,
        -0.0
      ],
      "plane_d": -3594.12353515625,
      "bbox_min": [
        -1551.0,
        -3390.0,
        1462.9239501953125
      ],
      "bbox_max": [
        -1544.699951171875,
        -3386.0,
        1467.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1466.199951171875,
      "bbox_min": [
        -1551.0,
        -3390.0,
        1466.199951171875
      ],
      "bbox_max": [
        -1544.699951171875,
        -3386.0,
        1466.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1466.199951171875,
      "bbox_min": [
        -1551.0,
        -3390.0,
        1466.199951171875
      ],
      "bbox_max": [
        -1546.1998291015625,
        -3386.0,
        1466.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1465.199951171875,
      "bbox_min": [
        -1575.0,
        -3390.0,
        1465.199951171875
      ],
      "bbox_max": [
        -1551.0,
        -3386.0,
        1468.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1574.9998779296875,
      "bbox_min": [
        -1575.0,
        -3389.49365234375,
        1467.7724609375
      ],
      "bbox_max": [
        -1575.0,
        -3386.0,
        1468.199951171875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1465.0,
      "bbox_min": [
        -1547.0,
        -3404.5,
        1463.9288330078125
      ],
      "bbox_max": [
        -1539.0,
        -3397.0,
        1468.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1547.0,
      "bbox_min": [
        -1547.0,
        -3404.5,
        1463.9288330078125
      ],
      "bbox_max": [
        -1547.0,
        -3397.0,
        1465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38461539149284363,
        0.0,
        0.9230769872665405
      ],
      "plane_d": -1947.461669921875,
      "bbox_min": [
        -1545.0,
        -3403.0,
        1465.0
      ],
      "bbox_max": [
        -1539.0,
        -3398.5,
        1468.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3403.0,
      "bbox_min": [
        -1545.0,
        -3403.0,
        1465.0
      ],
      "bbox_max": [
        -1539.0,
        -3398.5,
        1468.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3398.5,
      "bbox_min": [
        -1545.0,
        -3403.0,
        1465.0
      ],
      "bbox_max": [
        -1539.0,
        -3398.5,
        1468.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1545.0,
      "bbox_min": [
        -1545.0,
        -3403.0,
        1465.0
      ],
      "bbox_max": [
        -1545.0,
        -3398.5,
        1466.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3391.0,
      "bbox_min": [
        -1581.0078125,
        -3396.0,
        1462.32373046875
      ],
      "bbox_max": [
        -1539.0,
        -3390.0,
        1471.199951171875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1550.9998779296875,
      "bbox_min": [
        -1575.0,
        -3391.0,
        1462.823974609375
      ],
      "bbox_max": [
        -1543.5,
        -3390.0,
        1471.199951171875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1466.199951171875,
      "bbox_min": [
        -1551.0,
        -3391.0,
        1462.823974609375
      ],
      "bbox_max": [
        -1543.5,
        -3390.0,
        1471.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        -0.768221378326416,
        -0.0
      ],
      "plane_d": -3594.12353515625,
      "bbox_min": [
        -1546.199951171875,
        -3391.0,
        1462.823974609375
      ],
      "bbox_max": [
        -1545.0,
        -3390.0,
        1466.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1467.199951171875,
      "bbox_min": [
        -1551.0,
        -3391.0,
        1466.199951171875
      ],
      "bbox_max": [
        -1543.5,
        -3390.0,
        1471.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        -0.768221378326416,
        -0.0
      ],
      "plane_d": -3594.12353515625,
      "bbox_min": [
        -1546.199951171875,
        -3391.0,
        1467.199951171875
      ],
      "bbox_max": [
        -1545.0,
        -3390.0,
        1471.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        -0.768221378326416,
        -0.0
      ],
      "plane_d": -3594.12353515625,
      "bbox_min": [
        -1546.199951171875,
        -3391.0,
        1466.199951171875
      ],
      "bbox_max": [
        -1545.0,
        -3390.0,
        1467.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1574.9998779296875,
      "bbox_min": [
        -1575.0,
        -3391.0,
        1468.261962890625
      ],
      "bbox_max": [
        -1575.0,
        -3390.0,
        1471.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        -0.768221378326416,
        -0.0
      ],
      "plane_d": -3594.12353515625,
      "bbox_min": [
        -1545.0,
        -3396.0,
        1462.32373046875
      ],
      "bbox_max": [
        -1539.0,
        -3391.0,
        1471.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3403.0,
      "bbox_min": [
        -1587.011474609375,
        -3404.5,
        1471.199951171875
      ],
      "bbox_max": [
        -1539.0,
        -3386.0,
        1478.395751953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1476.0,
      "bbox_min": [
        -1570.332763671875,
        -3404.5,
        1475.0
      ],
      "bbox_max": [
        -1542.4287109375,
        -3403.0,
        1478.395751953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1475.0,
      "bbox_min": [
        -1551.0,
        -3404.5,
        1475.0
      ],
      "bbox_max": [
        -1542.4287109375,
        -3403.0,
        1476.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        -0.768221378326416,
        -0.0
      ],
      "plane_d": -3594.12353515625,
      "bbox_min": [
        -1587.011474609375,
        -3403.0,
        1471.199951171875
      ],
      "bbox_max": [
        -1539.0,
        -3386.0,
        1477.958251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1472.199951171875,
      "bbox_min": [
        -1551.0,
        -3391.0,
        1471.199951171875
      ],
      "bbox_max": [
        -1543.5,
        -3386.0,
        1472.199951171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3391.0,
      "bbox_min": [
        -1581.5264892578125,
        -3391.0,
        1471.199951171875
      ],
      "bbox_max": [
        -1545.000244140625,
        -3386.0,
        1472.199951171875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": 1574.9998779296875,
      "bbox_min": [
        -1575.0,
        -3391.0,
        1471.199951171875
      ],
      "bbox_max": [
        -1551.0,
        -3386.0,
        1472.199951171875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1475.0,
      "bbox_min": [
        -1551.0,
        -3403.0,
        1475.0
      ],
      "bbox_max": [
        -1542.4287109375,
        -3402.0,
        1477.958251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": -1550.9998779296875,
      "bbox_min": [
        -1551.0,
        -3403.0,
        1475.0
      ],
      "bbox_max": [
        -1551.0,
        -3402.0,
        1477.958251953125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1474.39990234375,
      "bbox_min": [
        -1574.5,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1552.5,
        -3393.0,
        1476.3834228515625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.46548134088516235,
        -0.12473297119140625,
        0.8762242197990417
      ],
      "plane_d": -985.482421875,
      "bbox_min": [
        -1574.5,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1552.5,
        -3393.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12474536895751953,
        0.46546870470046997,
        0.8762291669845581
      ],
      "plane_d": 484.2994384765625,
      "bbox_min": [
        -1574.5,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1566.5,
        -3393.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12475047260522842,
        0.4654877185821533,
        0.876218318939209
      ],
      "plane_d": 92.5467529296875,
      "bbox_min": [
        -1574.5,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1566.5,
        -3393.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12475047260522842,
        -0.4654877185821533,
        0.876218318939209
      ],
      "plane_d": -2678.135498046875,
      "bbox_min": [
        -1574.5,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1566.5,
        -3393.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31623297929763794,
        0.31623297929763794,
        -0.8944234848022461
      ],
      "plane_d": 1897.08154296875,
      "bbox_min": [
        -1574.5,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1566.5,
        -3393.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3407208025455475,
        -0.34077969193458557,
        0.8762297630310059
      ],
      "plane_d": -1915.337646484375,
      "bbox_min": [
        -1569.5352783203125,
        -3400.464111328125,
        1473.2999267578125
      ],
      "bbox_max": [
        -1567.035888671875,
        -3397.96484375,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4654886722564697,
        0.12473494559526443,
        0.8762200474739075
      ],
      "plane_d": -138.0223388671875,
      "bbox_min": [
        -1574.5,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1566.5,
        -3393.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31622204184532166,
        -0.31622204184532166,
        -0.8944312334060669
      ],
      "plane_d": -251.339599609375,
      "bbox_min": [
        -1574.5,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1566.5,
        -3393.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34074416756629944,
        0.3408030867576599,
        0.8762114644050598
      ],
      "plane_d": 400.0626220703125,
      "bbox_min": [
        -1569.5352783203125,
        -3396.03515625,
        1473.2999267578125
      ],
      "bbox_max": [
        -1567.035888671875,
        -3393.535888671875,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46548134088516235,
        0.12473297119140625,
        0.8762242197990417
      ],
      "plane_d": -1600.12353515625,
      "bbox_min": [
        -1574.5,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1566.5,
        -3393.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31623297929763794,
        -0.31623297929763794,
        -0.8944234848022461
      ],
      "plane_d": 741.8824462890625,
      "bbox_min": [
        -1574.5,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1566.5,
        -3393.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3407208025455475,
        0.34077969193458557,
        0.8762297630310059
      ],
      "plane_d": -670.2845458984375,
      "bbox_min": [
        -1573.964111328125,
        -3396.03515625,
        1473.2999267578125
      ],
      "bbox_max": [
        -1571.4647216796875,
        -3393.535888671875,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11574513465166092,
        -0.4319745600223541,
        -0.8944277167320251
      ],
      "plane_d": -329.7071533203125,
      "bbox_min": [
        -1574.5,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1566.5,
        -3393.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1157427579164505,
        -0.4319656789302826,
        -0.8944323658943176
      ],
      "plane_d": 33.881591796875,
      "bbox_min": [
        -1574.5,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1566.5,
        -3393.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4319745600223541,
        0.11574513465166092,
        -0.8944277167320251
      ],
      "plane_d": 1034.25830078125,
      "bbox_min": [
        -1574.5,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1566.5,
        -3395.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.43197107315063477,
        -0.1157442107796669,
        -0.8944295048713684
      ],
      "plane_d": 247.897216796875,
      "bbox_min": [
        -1574.5,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1566.5,
        -3395.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4654886722564697,
        -0.12473494559526443,
        0.8762200474739075
      ],
      "plane_d": -2447.5712890625,
      "bbox_min": [
        -1574.5,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1568.5,
        -3395.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4319745600223541,
        -0.11574513465166092,
        -0.8944277167320251
      ],
      "plane_d": 1604.718017578125,
      "bbox_min": [
        -1574.5,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1568.5,
        -3395.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12474536895751953,
        -0.46546870470046997,
        0.8762291669845581
      ],
      "plane_d": -3069.919921875,
      "bbox_min": [
        -1574.5,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1568.5,
        -3395.070556640625,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1157427579164505,
        0.4319656789302826,
        -0.8944323658943176
      ],
      "plane_d": 2605.1083984375,
      "bbox_min": [
        -1574.5,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1568.5,
        -3395.070556640625,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31622204184532166,
        0.31622204184532166,
        -0.8944312334060669
      ],
      "plane_d": 2890.326416015625,
      "bbox_min": [
        -1574.5,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1568.570556640625,
        -3395.070556640625,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34074416756629944,
        -0.3408030867576599,
        0.8762114644050598
      ],
      "plane_d": -2985.630859375,
      "bbox_min": [
        -1573.63427734375,
        -3400.06982421875,
        1473.5023193359375
      ],
      "bbox_max": [
        -1571.4647216796875,
        -3397.96484375,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43197107315063477,
        0.1157442107796669,
        -0.8944295048713684
      ],
      "plane_d": 2391.08447265625,
      "bbox_min": [
        -1574.5,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1568.570556640625,
        -3395.070556640625,
        1474.2999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1474.2999267578125,
      "bbox_min": [
        -1572.429443359375,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1568.570556640625,
        -3395.070556640625,
        1474.2999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11574513465166092,
        0.4319745600223541,
        -0.8944277167320251
      ],
      "plane_d": 2968.68359375,
      "bbox_min": [
        -1572.26904296875,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1570.5,
        -3398.6708984375,
        1474.2999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12474536895751953,
        0.46546870470046997,
        0.8762291669845581
      ],
      "plane_d": 482.552978515625,
      "bbox_min": [
        -1560.5,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1552.5,
        -3393.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12475047260522842,
        0.4654877185821533,
        0.876218318939209
      ],
      "plane_d": 94.2933349609375,
      "bbox_min": [
        -1560.5,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1552.5,
        -3393.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12474536895751953,
        -0.46546870470046997,
        0.8762291669845581
      ],
      "plane_d": -3068.173583984375,
      "bbox_min": [
        -1560.5,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1552.5,
        -3393.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.12475047260522842,
        -0.4654877185821533,
        0.876218318939209
      ],
      "plane_d": -2679.882080078125,
      "bbox_min": [
        -1560.5,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1552.5,
        -3393.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.46548134088516235,
        -0.12473297119140625,
        0.8762242197990417
      ],
      "plane_d": -991.9991455078125,
      "bbox_min": [
        -1560.5,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1552.5,
        -3393.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31623297929763794,
        0.31623297929763794,
        -0.8944234848022461
      ],
      "plane_d": 1901.5087890625,
      "bbox_min": [
        -1560.5,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1552.5,
        -3393.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3407208025455475,
        -0.34077969193458557,
        0.8762297630310059
      ],
      "plane_d": -1920.1077880859375,
      "bbox_min": [
        -1555.5352783203125,
        -3400.464111328125,
        1473.2999267578125
      ],
      "bbox_max": [
        -1553.035888671875,
        -3397.96484375,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4654886722564697,
        0.12473494559526443,
        0.8762200474739075
      ],
      "plane_d": -144.5391845703125,
      "bbox_min": [
        -1560.5,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1552.5,
        -3393.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31622204184532166,
        -0.31622204184532166,
        -0.8944312334060669
      ],
      "plane_d": -246.9124755859375,
      "bbox_min": [
        -1560.5,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1552.5,
        -3393.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34074416756629944,
        0.3408030867576599,
        0.8762114644050598
      ],
      "plane_d": 395.2921142578125,
      "bbox_min": [
        -1555.5352783203125,
        -3396.03515625,
        1473.2999267578125
      ],
      "bbox_max": [
        -1553.035888671875,
        -3393.535888671875,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46548134088516235,
        0.12473297119140625,
        0.8762242197990417
      ],
      "plane_d": -1593.6068115234375,
      "bbox_min": [
        -1560.5,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1552.5,
        -3393.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31623297929763794,
        -0.31623297929763794,
        -0.8944234848022461
      ],
      "plane_d": 737.4552001953125,
      "bbox_min": [
        -1560.5,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1552.5,
        -3393.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3407208025455475,
        0.34077969193458557,
        0.8762297630310059
      ],
      "plane_d": -665.5144653320312,
      "bbox_min": [
        -1559.964111328125,
        -3396.03515625,
        1473.2999267578125
      ],
      "bbox_max": [
        -1557.4647216796875,
        -3393.535888671875,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4654886722564697,
        -0.12473494559526443,
        0.8762200474739075
      ],
      "plane_d": -2441.0546875,
      "bbox_min": [
        -1560.5,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1552.5,
        -3393.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31622204184532166,
        0.31622204184532166,
        -0.8944312334060669
      ],
      "plane_d": 2885.8994140625,
      "bbox_min": [
        -1560.5,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1552.5,
        -3393.0,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34074416756629944,
        -0.3408030867576599,
        0.8762114644050598
      ],
      "plane_d": -2980.8603515625,
      "bbox_min": [
        -1559.964111328125,
        -3400.464111328125,
        1473.2999267578125
      ],
      "bbox_max": [
        -1557.4647216796875,
        -3397.96484375,
        1474.39990234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11574513465166092,
        -0.4319745600223541,
        -0.8944277167320251
      ],
      "plane_d": -328.086669921875,
      "bbox_min": [
        -1560.5,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1552.5,
        -3393.0,
        1474.2999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11574513465166092,
        0.4319745600223541,
        -0.8944277167320251
      ],
      "plane_d": 2967.06298828125,
      "bbox_min": [
        -1560.5,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1552.5,
        -3393.0,
        1474.2999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1157427579164505,
        -0.4319656789302826,
        -0.8944323658943176
      ],
      "plane_d": 32.2611083984375,
      "bbox_min": [
        -1560.5,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1552.5,
        -3393.0,
        1474.2999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1157427579164505,
        0.4319656789302826,
        -0.8944323658943176
      ],
      "plane_d": 2606.728759765625,
      "bbox_min": [
        -1560.5,
        -3401.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1552.5,
        -3395.0,
        1474.2999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4319745600223541,
        0.11574513465166092,
        -0.8944277167320251
      ],
      "plane_d": 1040.305908203125,
      "bbox_min": [
        -1560.5,
        -3399.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1552.5,
        -3395.0,
        1474.2999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.43197107315063477,
        -0.1157442107796669,
        -0.8944295048713684
      ],
      "plane_d": 253.94482421875,
      "bbox_min": [
        -1560.5,
        -3399.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1552.5,
        -3395.0,
        1474.2999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4319745600223541,
        -0.11574513465166092,
        -0.8944277167320251
      ],
      "plane_d": 1598.6702880859375,
      "bbox_min": [
        -1560.5,
        -3399.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1554.570556640625,
        -3395.0,
        1474.2999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.43197107315063477,
        0.1157442107796669,
        -0.8944295048713684
      ],
      "plane_d": 2385.036865234375,
      "bbox_min": [
        -1560.5,
        -3399.0,
        1473.2999267578125
      ],
      "bbox_max": [
        -1554.570556640625,
        -3395.070556640625,
        1474.2999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1474.2999267578125,
      "bbox_min": [
        -1558.429443359375,
        -3398.929443359375,
        1474.2999267578125
      ],
      "bbox_max": [
        -1554.570556640625,
        -3395.070556640625,
        1474.2999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1569.800048828125,
      "bbox_min": [
        -1571.0,
        -3397.60009765625,
        1474.4000244140625
      ],
      "bbox_max": [
        -1556.0,
        -3396.39990234375,
        1476.3834228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3397.60009765625,
      "bbox_min": [
        -1571.0,
        -3397.60009765625,
        1474.4000244140625
      ],
      "bbox_max": [
        -1569.800048828125,
        -3396.39990234375,
        1476.3834228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1571.0,
      "bbox_min": [
        -1571.0,
        -3397.60009765625,
        1474.4000244140625
      ],
      "bbox_max": [
        -1569.800048828125,
        -3396.39990234375,
        1476.3834228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3396.39990234375,
      "bbox_min": [
        -1571.0,
        -3396.39990234375,
        1474.4000244140625
      ],
      "bbox_max": [
        -1569.800048828125,
        -3396.39990234375,
        1476.0333251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3397.60009765625,
      "bbox_min": [
        -1557.199951171875,
        -3397.60009765625,
        1474.4000244140625
      ],
      "bbox_max": [
        -1556.0,
        -3396.39990234375,
        1476.3834228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1557.199951171875,
      "bbox_min": [
        -1557.199951171875,
        -3397.60009765625,
        1474.4000244140625
      ],
      "bbox_max": [
        -1556.0,
        -3396.39990234375,
        1476.3834228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1556.0,
      "bbox_min": [
        -1557.199951171875,
        -3397.60009765625,
        1474.4000244140625
      ],
      "bbox_max": [
        -1556.0,
        -3396.39990234375,
        1476.3834228515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3396.39990234375,
      "bbox_min": [
        -1557.199951171875,
        -3396.39990234375,
        1474.4000244140625
      ],
      "bbox_max": [
        -1556.0,
        -3396.39990234375,
        1476.0333251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1476.0,
      "bbox_min": [
        -1567.27099609375,
        -3410.0,
        1466.4500732421875
      ],
      "bbox_max": [
        -1542.4287109375,
        -3404.5,
        1478.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3406.5,
      "bbox_min": [
        -1567.27099609375,
        -3409.0,
        1476.0
      ],
      "bbox_max": [
        -1551.0,
        -3404.5,
        1478.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3408.0,
      "bbox_min": [
        -1565.6258544921875,
        -3409.0,
        1476.0
      ],
      "bbox_max": [
        -1551.0,
        -3406.5,
        1478.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1550.9998779296875,
      "bbox_min": [
        -1551.0,
        -3408.0,
        1477.5
      ],
      "bbox_max": [
        -1551.0,
        -3406.5,
        1478.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        -0.0
      ],
      "plane_d": -1550.9998779296875,
      "bbox_min": [
        -1551.0,
        -3409.0,
        1476.0
      ],
      "bbox_max": [
        -1551.0,
        -3408.0,
        1478.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1551.0,
      "bbox_min": [
        -1551.0,
        -3406.5,
        1476.0
      ],
      "bbox_max": [
        -1551.0,
        -3404.5,
        1478.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1475.0,
      "bbox_min": [
        -1562.62646484375,
        -3410.0,
        1466.4500732421875
      ],
      "bbox_max": [
        -1542.4287109375,
        -3404.5,
        1476.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1550.9998779296875,
      "bbox_min": [
        -1551.0,
        -3409.0,
        1475.0
      ],
      "bbox_max": [
        -1551.0,
        -3404.5,
        1476.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.96592116355896,
        0.25883668661117554,
        0.0
      ],
      "plane_d": 2382.708740234375,
      "bbox_min": [
        -1562.62646484375,
        -3410.0,
        1466.4500732421875
      ],
      "bbox_max": [
        -1553.0,
        -3405.0,
        1473.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25883668661117554,
        0.96592116355896,
        0.0
      ],
      "plane_d": 3692.22900390625,
      "bbox_min": [
        -1562.62646484375,
        -3408.60595703125,
        1466.5653076171875
      ],
      "bbox_max": [
        -1555.5,
        -3405.0,
        1473.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25883668661117554,
        0.96592116355896,
        0.0
      ],
      "plane_d": 2885.694091796875,
      "bbox_min": [
        -1562.62646484375,
        -3408.60595703125,
        1466.9466552734375
      ],
      "bbox_max": [
        -1558.0,
        -3405.0,
        1473.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 1304.732177734375,
      "bbox_min": [
        -1562.62646484375,
        -3408.60595703125,
        1467.4920654296875
      ],
      "bbox_max": [
        -1560.5,
        -3405.669921875,
        1473.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.96592116355896,
        0.25883668661117554,
        0.0
      ],
      "plane_d": -627.1016235351562,
      "bbox_min": [
        -1562.62646484375,
        -3408.60595703125,
        1470.0892333984375
      ],
      "bbox_max": [
        -1562.330078125,
        -3407.5,
        1473.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18481668829917908,
        0.05494606867432594,
        0.9812358021736145
      ],
      "plane_d": -963.4822998046875,
      "bbox_min": [
        -1548.2000732421875,
        -3390.45703125,
        1461.1959228515625
      ],
      "bbox_max": [
        -1538.0,
        -3386.0,
        1463.1171875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.18483580648899078,
        0.0549468919634819,
        0.981232225894928
      ],
      "plane_d": -963.44482421875,
      "bbox_min": [
        -1538.0,
        -3390.236328125,
        1460.7421875
      ],
      "bbox_max": [
        -1534.83056640625,
        -3384.5,
        1461.43310546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.847313404083252,
        -0.03997046872973442,
        -0.5295870304107666
      ],
      "plane_d": 1990.376953125,
      "bbox_min": [
        -1563.4188232421875,
        -3384.9921875,
        1526.001220703125
      ],
      "bbox_max": [
        -1554.422119140625,
        -3384.5,
        1532.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.847313404083252,
        0.039971448481082916,
        0.5295870304107666
      ],
      "plane_d": -2000.3814697265625,
      "bbox_min": [
        -1563.4188232421875,
        -3384.592041015625,
        1531.309814453125
      ],
      "bbox_max": [
        -1562.91552734375,
        -3384.5,
        1532.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1848299503326416,
        0.05494631081819534,
        0.9812332391738892
      ],
      "plane_d": -963.4571533203125,
      "bbox_min": [
        -1590.7275390625,
        -3384.5,
        1460.703857421875
      ],
      "bbox_max": [
        -1536.0374755859375,
        -3382.0,
        1532.1099853515625
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1573.5,
      "bbox_min": [
        -1573.5,
        -3384.5,
        1486.5
      ],
      "bbox_max": [
        -1557.0,
        -3382.0,
        1488.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1557.0,
      "bbox_min": [
        -1557.0,
        -3384.5,
        1486.5
      ],
      "bbox_max": [
        -1557.0,
        -3382.0,
        1488.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5300085544586182,
        6.930902600288391e-06,
        -0.8479923009872437
      ],
      "plane_d": 469.93865966796875,
      "bbox_min": [
        -1563.4156494140625,
        -3384.5,
        1525.9482421875
      ],
      "bbox_max": [
        -1554.3372802734375,
        -3382.0,
        1532.1099853515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.847313404083252,
        -0.03997046872973442,
        -0.5295870304107666
      ],
      "plane_d": 1990.376953125,
      "bbox_min": [
        -1563.4156494140625,
        -3384.5,
        1525.9482421875
      ],
      "bbox_max": [
        -1554.3372802734375,
        -3382.0,
        1532.1099853515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.847313404083252,
        0.039971448481082916,
        0.5295870304107666
      ],
      "plane_d": -2000.3814697265625,
      "bbox_min": [
        -1563.4156494140625,
        -3384.5,
        1531.2568359375
      ],
      "bbox_max": [
        -1562.830810546875,
        -3382.0,
        1532.1099853515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.982089102268219,
        0.1529073566198349,
        -0.11009181290864944
      ],
      "plane_d": 2186.53564453125,
      "bbox_min": [
        -1543.5052490234375,
        -3390.09228515625,
        1394.68359375
      ],
      "bbox_max": [
        -1534.83056640625,
        -3382.0,
        1460.8280029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18483580648899078,
        0.0549468919634819,
        0.981232225894928
      ],
      "plane_d": -963.44482421875,
      "bbox_min": [
        -1536.5770263671875,
        -3390.09228515625,
        1460.61669921875
      ],
      "bbox_max": [
        -1534.83056640625,
        -3382.0,
        1460.8280029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1496.0,
      "bbox_min": [
        -1654.0,
        -3382.0,
        1302.5999755859375
      ],
      "bbox_max": [
        -1536.1141357421875,
        -3283.58740234375,
        1546.3753662109375
      ],
      "face_count": 18
    },
    {
      "plane_normal": [
        -0.9455833435058594,
        0.3179033696651459,
        -0.06935158371925354
      ],
      "plane_d": -381.4749755859375,
      "bbox_min": [
        -1637.2723388671875,
        -3382.0,
        1302.5999755859375
      ],
      "bbox_max": [
        -1536.1141357421875,
        -3283.58740234375,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.006793193984776735,
        0.9802196025848389,
        0.19779632985591888
      ],
      "plane_d": 2950.3369140625,
      "bbox_min": [
        -1636.6453857421875,
        -3382.0,
        1302.5999755859375
      ],
      "bbox_max": [
        -1536.1141357421875,
        -3283.58740234375,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9593862891197205,
        0.24561771750450134,
        -0.13874416053295135
      ],
      "plane_d": 2500.552490234375,
      "bbox_min": [
        -1636.6453857421875,
        -3382.0,
        1302.5999755859375
      ],
      "bbox_max": [
        -1536.1141357421875,
        -3287.91259765625,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9963745474815369,
        0.0845751017332077,
        0.009205454960465431
      ],
      "plane_d": -1354.2691650390625,
      "bbox_min": [
        -1636.6453857421875,
        -3382.0,
        1302.5999755859375
      ],
      "bbox_max": [
        -1536.1141357421875,
        -3287.91259765625,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1485.0,
      "bbox_min": [
        -1633.0650634765625,
        -3382.0,
        1302.5999755859375
      ],
      "bbox_max": [
        -1536.1141357421875,
        -3287.91259765625,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1488.0,
      "bbox_min": [
        -1627.0,
        -3382.0,
        1485.0
      ],
      "bbox_max": [
        -1547.0,
        -3328.0,
        1496.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3380.0,
      "bbox_min": [
        -1627.0,
        -3382.0,
        1485.0
      ],
      "bbox_max": [
        -1547.0,
        -3328.0,
        1488.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3328.0,
      "bbox_min": [
        -1627.0,
        -3380.0,
        1485.0
      ],
      "bbox_max": [
        -1547.0,
        -3328.0,
        1488.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1547.0,
      "bbox_min": [
        -1627.0,
        -3380.0,
        1485.0
      ],
      "bbox_max": [
        -1547.0,
        -3328.0,
        1488.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1627.0,
      "bbox_min": [
        -1627.0,
        -3380.0,
        1485.0
      ],
      "bbox_max": [
        -1627.0,
        -3328.0,
        1488.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1486.5,
      "bbox_min": [
        -1573.5,
        -3382.0,
        1486.5
      ],
      "bbox_max": [
        -1557.0,
        -3380.0,
        1488.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1573.5,
      "bbox_min": [
        -1573.5,
        -3382.0,
        1486.5
      ],
      "bbox_max": [
        -1557.0,
        -3380.0,
        1488.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1557.0,
      "bbox_min": [
        -1557.0,
        -3382.0,
        1486.5
      ],
      "bbox_max": [
        -1557.0,
        -3380.0,
        1488.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9958931803703308,
        0.09053574502468109
      ],
      "plane_d": 3181.109130859375,
      "bbox_min": [
        -1625.5,
        -3378.5,
        1488.0
      ],
      "bbox_max": [
        -1549.0,
        -3329.5,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3331.0,
      "bbox_min": [
        -1625.5,
        -3378.5,
        1488.0
      ],
      "bbox_max": [
        -1549.0,
        -3329.5,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -1493.4998779296875,
      "bbox_min": [
        -1625.5,
        -3331.0,
        1488.0
      ],
      "bbox_max": [
        -1549.0,
        -3329.5,
        1493.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9958931803703308,
        -0.0,
        0.09053574502468109
      ],
      "plane_d": 1407.92138671875,
      "bbox_min": [
        -1625.5,
        -3331.0,
        1488.0
      ],
      "bbox_max": [
        -1549.0,
        -3329.5,
        1493.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9958931803703308,
        0.0,
        0.09053574502468109
      ],
      "plane_d": -1753.54150390625,
      "bbox_min": [
        -1625.5,
        -3331.0,
        1488.0
      ],
      "bbox_max": [
        -1625.0,
        -3329.5,
        1493.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9958931803703308,
        0.09053574502468109
      ],
      "plane_d": -3499.34228515625,
      "bbox_min": [
        -1625.5,
        -3378.5,
        1488.0
      ],
      "bbox_max": [
        -1549.0,
        -3331.0,
        1496.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 3377.0,
      "bbox_min": [
        -1625.5,
        -3378.5,
        1488.0
      ],
      "bbox_max": [
        -1549.0,
        -3331.0,
        1496.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1493.4998779296875,
      "bbox_min": [
        -1625.5,
        -3378.5,
        1488.0
      ],
      "bbox_max": [
        -1549.0,
        -3377.0,
        1493.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1557.0,
      "bbox_min": [
        -1625.5,
        -3378.5,
        1488.0
      ],
      "bbox_max": [
        -1549.0,
        -3377.0,
        1493.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9958931803703308,
        -0.0,
        0.09053574502468109
      ],
      "plane_d": 1407.92138671875,
      "bbox_min": [
        -1549.5,
        -3378.5,
        1488.0
      ],
      "bbox_max": [
        -1549.0,
        -3377.0,
        1493.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9958931803703308,
        0.0,
        0.09053574502468109
      ],
      "plane_d": -1753.54150390625,
      "bbox_min": [
        -1625.5,
        -3378.5,
        1488.0
      ],
      "bbox_max": [
        -1573.5,
        -3377.0,
        1493.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1573.5,
      "bbox_min": [
        -1573.5,
        -3378.5,
        1488.0
      ],
      "bbox_max": [
        -1573.5,
        -3377.0,
        1493.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1550.5,
      "bbox_min": [
        -1625.5,
        -3377.0,
        1488.0
      ],
      "bbox_max": [
        -1549.0,
        -3331.0,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9958931803703308,
        -0.0,
        0.09053574502468109
      ],
      "plane_d": 1407.92138671875,
      "bbox_min": [
        -1550.5,
        -3377.0,
        1488.0
      ],
      "bbox_max": [
        -1549.0,
        -3331.0,
        1493.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -1493.4998779296875,
      "bbox_min": [
        -1550.5,
        -3377.0,
        1493.5
      ],
      "bbox_max": [
        -1549.5,
        -3331.0,
        1493.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1624.0,
      "bbox_min": [
        -1625.5,
        -3377.0,
        1488.0
      ],
      "bbox_max": [
        -1552.0,
        -3331.0,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9958931803703308,
        0.0,
        0.09053574502468109
      ],
      "plane_d": -1753.54150390625,
      "bbox_min": [
        -1625.5,
        -3377.0,
        1488.0
      ],
      "bbox_max": [
        -1624.0,
        -3331.0,
        1493.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1493.4998779296875,
      "bbox_min": [
        -1625.0,
        -3377.0,
        1493.5
      ],
      "bbox_max": [
        -1624.0,
        -3331.0,
        1493.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1595.4844970703125,
      "bbox_min": [
        -1620.1156005859375,
        -3375.5,
        1488.0
      ],
      "bbox_max": [
        -1552.0,
        -3332.0,
        1496.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -1620.1156005859375,
      "bbox_min": [
        -1620.1156005859375,
        -3367.11572265625,
        1488.0
      ],
      "bbox_max": [
        -1595.4844970703125,
        -3342.484375,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000378489494324,
        -0.8660035729408264,
        -0.0
      ],
      "plane_d": -3721.545166015625,
      "bbox_min": [
        -1620.1156005859375,
        -3367.11572265625,
        1488.0
      ],
      "bbox_max": [
        -1595.4844970703125,
        -3342.484375,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000101327896118,
        0.866019606590271,
        0.0
      ],
      "plane_d": 3696.92333984375,
      "bbox_min": [
        -1620.1156005859375,
        -3367.11572265625,
        1488.0
      ],
      "bbox_max": [
        -1595.4844970703125,
        -3342.484375,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000181198120117,
        0.8660150170326233,
        0.0
      ],
      "plane_d": 2089.0625,
      "bbox_min": [
        -1620.1156005859375,
        -3367.11572265625,
        1488.0
      ],
      "bbox_max": [
        -1595.4844970703125,
        -3342.484375,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660150170326233,
        0.5000181198120117,
        0.0
      ],
      "plane_d": 272.766357421875,
      "bbox_min": [
        -1620.1156005859375,
        -3367.11572265625,
        1488.0
      ],
      "bbox_max": [
        -1595.4844970703125,
        -3342.484375,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.699182707350701e-05,
        -1.0,
        0.0
      ],
      "plane_d": -3367.05615234375,
      "bbox_min": [
        -1620.1156005859375,
        -3367.11572265625,
        1488.0
      ],
      "bbox_max": [
        -1595.4844970703125,
        -3342.484375,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 3342.484375,
      "bbox_min": [
        -1620.1156005859375,
        -3367.115478515625,
        1488.0
      ],
      "bbox_max": [
        -1595.4844970703125,
        -3342.484375,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999823570251465,
        -0.8660355806350708,
        0.0
      ],
      "plane_d": -2113.820068359375,
      "bbox_min": [
        -1620.1156005859375,
        -3367.115478515625,
        1488.0
      ],
      "bbox_max": [
        -1595.4844970703125,
        -3345.784423828125,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.5000042915344238,
        0.0
      ],
      "plane_d": -297.338134765625,
      "bbox_min": [
        -1620.1156005859375,
        -3363.815673828125,
        1488.0
      ],
      "bbox_max": [
        -1595.4844970703125,
        -3345.784423828125,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660230040550232,
        0.5000042915344238,
        0.0
      ],
      "plane_d": 3057.49072265625,
      "bbox_min": [
        -1620.1156005859375,
        -3363.8154296875,
        1488.0
      ],
      "bbox_max": [
        -1595.4844970703125,
        -3345.784423828125,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.866013765335083,
        -0.5000202655792236,
        -0.0
      ],
      "plane_d": -3082.160400390625,
      "bbox_min": [
        -1620.1156005859375,
        -3363.8154296875,
        1488.0
      ],
      "bbox_max": [
        -1616.815673828125,
        -3358.10009765625,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999086856842041,
        0.013512278907001019
      ],
      "plane_d": -3354.8017578125,
      "bbox_min": [
        -1555.0,
        -3375.5,
        1488.0
      ],
      "bbox_max": [
        -1552.0,
        -3332.0,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999086856842041,
        0.0,
        0.013512278907001019
      ],
      "plane_d": -1574.96435546875,
      "bbox_min": [
        -1555.0,
        -3335.0,
        1488.0
      ],
      "bbox_max": [
        -1552.0,
        -3332.0,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999086856842041,
        0.013512278907001019
      ],
      "plane_d": 3311.589599609375,
      "bbox_min": [
        -1555.0,
        -3335.0,
        1488.0
      ],
      "bbox_max": [
        -1552.0,
        -3332.0,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999086856842041,
        -0.0,
        0.013512278907001019
      ],
      "plane_d": 1531.751953125,
      "bbox_min": [
        -1552.108154296875,
        -3335.0,
        1488.0
      ],
      "bbox_max": [
        -1552.0,
        -3332.0,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999086856842041,
        0.0,
        0.013512278907001019
      ],
      "plane_d": -1574.96435546875,
      "bbox_min": [
        -1555.0,
        -3375.5,
        1488.0
      ],
      "bbox_max": [
        -1552.0,
        -3372.5,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999086856842041,
        0.013512278907001019
      ],
      "plane_d": -3395.2978515625,
      "bbox_min": [
        -1555.0,
        -3375.5,
        1488.0
      ],
      "bbox_max": [
        -1552.0,
        -3372.5,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999086856842041,
        -0.0,
        0.013512278907001019
      ],
      "plane_d": 1531.751953125,
      "bbox_min": [
        -1555.0,
        -3375.5,
        1488.0
      ],
      "bbox_max": [
        -1552.0,
        -3372.5,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999086856842041,
        0.013512278907001019
      ],
      "plane_d": 3352.085693359375,
      "bbox_min": [
        -1555.0,
        -3372.608154296875,
        1488.0
      ],
      "bbox_max": [
        -1552.0,
        -3372.5,
        1496.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18482916057109833,
        0.05494534224271774,
        0.981233537197113
      ],
      "plane_d": -963.462158203125,
      "bbox_min": [
        -1633.0650634765625,
        -3382.0,
        1302.5999755859375
      ],
      "bbox_max": [
        -1536.1141357421875,
        -3287.91259765625,
        1485.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.39672571420669556,
        0.18136583268642426,
        -0.8998417854309082
      ],
      "plane_d": 1149.486572265625,
      "bbox_min": [
        -1633.0650634765625,
        -3378.0,
        1302.5999755859375
      ],
      "bbox_max": [
        -1549.0,
        -3287.91259765625,
        1477.135498046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0412130132317543,
        0.43465206027030945,
        -0.8996549844741821
      ],
      "plane_d": 2685.27783203125,
      "bbox_min": [
        -1625.0,
        -3378.0,
        1302.5999755859375
      ],
      "bbox_max": [
        -1549.0,
        -3287.91259765625,
        1477.135498046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3375.0,
      "bbox_min": [
        -1625.0,
        -3378.0,
        1459.0
      ],
      "bbox_max": [
        -1549.0,
        -3330.0,
        1477.135498046875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1625.0,
      "bbox_min": [
        -1625.0,
        -3378.0,
        1459.0
      ],
      "bbox_max": [
        -1549.0,
        -3375.0,
        1477.135498046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3378.0,
      "bbox_min": [
        -1625.0,
        -3378.0,
        1459.0
      ],
      "bbox_max": [
        -1549.0,
        -3375.0,
        1477.135498046875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1622.0,
      "bbox_min": [
        -1622.0,
        -3378.0,
        1459.0
      ],
      "bbox_max": [
        -1549.0,
        -3375.0,
        1476.5704345703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1602.0,
      "bbox_min": [
        -1602.0,
        -3378.0,
        1459.0
      ],
      "bbox_max": [
        -1549.0,
        -3375.0,
        1472.8031005859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1599.0,
      "bbox_min": [
        -1599.0,
        -3378.0,
        1459.0
      ],
      "bbox_max": [
        -1549.0,
        -3375.0,
        1472.238037109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1576.0,
      "bbox_min": [
        -1576.0,
        -3378.0,
        1459.0
      ],
      "bbox_max": [
        -1549.0,
        -3375.0,
        1467.9056396484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1573.0,
      "bbox_min": [
        -1573.0,
        -3378.0,
        1459.0
      ],
      "bbox_max": [
        -1549.0,
        -3375.0,
        1467.340576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1552.0,
      "bbox_min": [
        -1552.0,
        -3378.0,
        1459.0
      ],
      "bbox_max": [
        -1549.0,
        -3375.0,
        1463.3848876953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1549.0,
      "bbox_min": [
        -1549.0,
        -3378.0,
        1459.0
      ],
      "bbox_max": [
        -1549.0,
        -3375.0,
        1462.81982421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1625.0,
      "bbox_min": [
        -1625.0,
        -3333.0,
        1459.0
      ],
      "bbox_max": [
        -1549.0,
        -3330.0,
        1474.61572265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3333.0,
      "bbox_min": [
        -1625.0,
        -3333.0,
        1459.0
      ],
      "bbox_max": [
        -1549.0,
        -3330.0,
        1474.61572265625
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3330.0,
      "bbox_min": [
        -1625.0,
        -3333.0,
        1459.0
      ],
      "bbox_max": [
        -1549.0,
        -3330.0,
        1474.4476318359375
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1622.0,
      "bbox_min": [
        -1622.0,
        -3333.0,
        1459.0
      ],
      "bbox_max": [
        -1549.0,
        -3330.0,
        1474.050537109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1602.0,
      "bbox_min": [
        -1602.0,
        -3333.0,
        1459.0
      ],
      "bbox_max": [
        -1549.0,
        -3330.0,
        1470.2833251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1599.0,
      "bbox_min": [
        -1599.0,
        -3333.0,
        1459.0
      ],
      "bbox_max": [
        -1549.0,
        -3330.0,
        1469.71826171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1576.0,
      "bbox_min": [
        -1576.0,
        -3333.0,
        1459.0
      ],
      "bbox_max": [
        -1549.0,
        -3330.0,
        1465.3858642578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1573.0,
      "bbox_min": [
        -1573.0,
        -3333.0,
        1459.0
      ],
      "bbox_max": [
        -1549.0,
        -3330.0,
        1464.8206787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1552.0,
      "bbox_min": [
        -1552.0,
        -3333.0,
        1459.0
      ],
      "bbox_max": [
        -1549.0,
        -3330.0,
        1460.8651123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1549.0,
      "bbox_min": [
        -1549.0,
        -3333.0,
        1459.0
      ],
      "bbox_max": [
        -1549.0,
        -3330.0,
        1460.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.056889183819293976,
        0.9831775426864624,
        -0.17356735467910767
      ],
      "plane_d": 3449.109619140625,
      "bbox_min": [
        -1633.0650634765625,
        -3372.64794921875,
        1302.5999755859375
      ],
      "bbox_max": [
        -1597.9923095703125,
        -3369.9052734375,
        1318.2093505859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1549.0,
      "bbox_min": [
        -1625.5,
        -3378.5,
        1460.132080078125
      ],
      "bbox_max": [
        -1548.5,
        -3329.5,
        1485.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1598.5,
      "bbox_min": [
        -1625.5,
        -3378.5,
        1482.0
      ],
      "bbox_max": [
        -1549.0,
        -3329.5,
        1485.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1621.5,
      "bbox_min": [
        -1625.5,
        -3378.5,
        1482.0
      ],
      "bbox_max": [
        -1598.5,
        -3329.5,
        1485.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3333.5,
      "bbox_min": [
        -1625.5,
        -3378.5,
        1482.0
      ],
      "bbox_max": [
        -1621.5,
        -3329.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1625.5,
      "bbox_min": [
        -1625.5,
        -3333.5,
        1482.0
      ],
      "bbox_max": [
        -1621.5,
        -3329.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3329.5,
      "bbox_min": [
        -1625.5,
        -3329.5,
        1482.0
      ],
      "bbox_max": [
        -1621.5,
        -3329.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3378.5,
      "bbox_min": [
        -1625.5,
        -3378.5,
        1482.0
      ],
      "bbox_max": [
        -1621.5,
        -3374.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3374.5,
      "bbox_min": [
        -1625.5,
        -3378.5,
        1482.0
      ],
      "bbox_max": [
        -1621.5,
        -3374.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1625.5,
      "bbox_min": [
        -1625.5,
        -3378.5,
        1482.0
      ],
      "bbox_max": [
        -1625.5,
        -3374.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3333.5,
      "bbox_min": [
        -1602.5,
        -3378.5,
        1482.0
      ],
      "bbox_max": [
        -1598.5,
        -3329.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1602.5,
      "bbox_min": [
        -1602.5,
        -3333.5,
        1482.0
      ],
      "bbox_max": [
        -1598.5,
        -3329.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3329.5,
      "bbox_min": [
        -1602.5,
        -3329.5,
        1482.0
      ],
      "bbox_max": [
        -1598.5,
        -3329.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3378.5,
      "bbox_min": [
        -1602.5,
        -3378.5,
        1482.0
      ],
      "bbox_max": [
        -1598.5,
        -3374.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3374.5,
      "bbox_min": [
        -1602.5,
        -3378.5,
        1482.0
      ],
      "bbox_max": [
        -1598.5,
        -3374.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1602.5,
      "bbox_min": [
        -1602.5,
        -3378.5,
        1482.0
      ],
      "bbox_max": [
        -1602.5,
        -3374.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1572.5,
      "bbox_min": [
        -1576.5,
        -3378.5,
        1482.0
      ],
      "bbox_max": [
        -1549.0,
        -3329.5,
        1485.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3333.5,
      "bbox_min": [
        -1576.5,
        -3378.5,
        1482.0
      ],
      "bbox_max": [
        -1572.5,
        -3329.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1576.5,
      "bbox_min": [
        -1576.5,
        -3333.5,
        1482.0
      ],
      "bbox_max": [
        -1572.5,
        -3329.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3329.5,
      "bbox_min": [
        -1576.5,
        -3329.5,
        1482.0
      ],
      "bbox_max": [
        -1572.5,
        -3329.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3378.5,
      "bbox_min": [
        -1576.5,
        -3378.5,
        1482.0
      ],
      "bbox_max": [
        -1572.5,
        -3374.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1576.5,
      "bbox_min": [
        -1576.5,
        -3378.5,
        1482.0
      ],
      "bbox_max": [
        -1572.5,
        -3374.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3374.5,
      "bbox_min": [
        -1576.5,
        -3374.5,
        1482.0
      ],
      "bbox_max": [
        -1572.5,
        -3374.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1552.5,
      "bbox_min": [
        -1552.5,
        -3378.5,
        1482.0
      ],
      "bbox_max": [
        -1549.0,
        -3329.5,
        1485.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3333.5,
      "bbox_min": [
        -1552.5,
        -3378.5,
        1482.0
      ],
      "bbox_max": [
        -1549.0,
        -3329.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3329.5,
      "bbox_min": [
        -1552.5,
        -3329.5,
        1482.0
      ],
      "bbox_max": [
        -1549.0,
        -3329.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3378.5,
      "bbox_min": [
        -1552.5,
        -3378.5,
        1482.0
      ],
      "bbox_max": [
        -1549.0,
        -3374.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3374.5,
      "bbox_min": [
        -1552.5,
        -3374.5,
        1482.0
      ],
      "bbox_max": [
        -1549.0,
        -3374.5,
        1485.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3333.0,
      "bbox_min": [
        -1625.0,
        -3378.0,
        1460.132080078125
      ],
      "bbox_max": [
        -1549.0,
        -3330.0,
        1482.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3330.0,
      "bbox_min": [
        -1625.0,
        -3333.0,
        1460.132080078125
      ],
      "bbox_max": [
        -1549.0,
        -3330.0,
        1482.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1552.0,
      "bbox_min": [
        -1625.0,
        -3333.0,
        1460.6971435546875
      ],
      "bbox_max": [
        -1552.0,
        -3330.0,
        1482.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1573.0,
      "bbox_min": [
        -1625.0,
        -3333.0,
        1464.6527099609375
      ],
      "bbox_max": [
        -1573.0,
        -3330.0,
        1482.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1576.0,
      "bbox_min": [
        -1625.0,
        -3333.0,
        1465.2178955078125
      ],
      "bbox_max": [
        -1576.0,
        -3330.0,
        1482.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1599.0,
      "bbox_min": [
        -1625.0,
        -3333.0,
        1469.5501708984375
      ],
      "bbox_max": [
        -1599.0,
        -3330.0,
        1482.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1602.0,
      "bbox_min": [
        -1625.0,
        -3333.0,
        1470.1153564453125
      ],
      "bbox_max": [
        -1602.0,
        -3330.0,
        1482.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1622.0,
      "bbox_min": [
        -1625.0,
        -3333.0,
        1473.882568359375
      ],
      "bbox_max": [
        -1622.0,
        -3330.0,
        1482.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1625.0,
      "bbox_min": [
        -1625.0,
        -3333.0,
        1474.4476318359375
      ],
      "bbox_max": [
        -1625.0,
        -3330.0,
        1482.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3375.0,
      "bbox_min": [
        -1625.0,
        -3378.0,
        1462.65185546875
      ],
      "bbox_max": [
        -1549.0,
        -3375.0,
        1482.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3378.0,
      "bbox_min": [
        -1625.0,
        -3378.0,
        1462.81982421875
      ],
      "bbox_max": [
        -1549.0,
        -3375.0,
        1482.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1552.0,
      "bbox_min": [
        -1625.0,
        -3378.0,
        1463.2169189453125
      ],
      "bbox_max": [
        -1552.0,
        -3375.0,
        1482.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1573.0,
      "bbox_min": [
        -1625.0,
        -3378.0,
        1467.172607421875
      ],
      "bbox_max": [
        -1573.0,
        -3375.0,
        1482.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1576.0,
      "bbox_min": [
        -1625.0,
        -3378.0,
        1467.7376708984375
      ],
      "bbox_max": [
        -1576.0,
        -3375.0,
        1482.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1599.0,
      "bbox_min": [
        -1625.0,
        -3378.0,
        1472.070068359375
      ],
      "bbox_max": [
        -1599.0,
        -3375.0,
        1482.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1602.0,
      "bbox_min": [
        -1625.0,
        -3378.0,
        1472.6351318359375
      ],
      "bbox_max": [
        -1602.0,
        -3375.0,
        1482.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1622.0,
      "bbox_min": [
        -1625.0,
        -3378.0,
        1476.4024658203125
      ],
      "bbox_max": [
        -1622.0,
        -3375.0,
        1482.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1625.0,
      "bbox_min": [
        -1625.0,
        -3378.0,
        1476.967529296875
      ],
      "bbox_max": [
        -1625.0,
        -3375.0,
        1482.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1548.5,
      "bbox_min": [
        -1549.0,
        -3378.5,
        1482.0
      ],
      "bbox_max": [
        -1548.5,
        -3329.5,
        1485.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 1481.9998779296875,
      "bbox_min": [
        -1549.0,
        -3378.5,
        1482.0
      ],
      "bbox_max": [
        -1548.5,
        -3329.5,
        1485.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.9661343693733215,
        0.24907872080802917,
        0.0674104243516922
      ],
      "plane_d": -827.2496337890625,
      "bbox_min": [
        -1636.6453857421875,
        -3382.0,
        1311.585205078125
      ],
      "bbox_max": [
        -1633.0650634765625,
        -3369.9052734375,
        1345.208984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9726229310035706,
        0.20830567181110382,
        -0.10302186012268066
      ],
      "plane_d": 2349.484130859375,
      "bbox_min": [
        -1555.170654296875,
        -3382.0,
        1302.5999755859375
      ],
      "bbox_max": [
        -1544.6763916015625,
        -3373.374755859375,
        1384.2362060546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8500498533248901,
        0.5251100659370422,
        0.04092385247349739
      ],
      "plane_d": 3041.765869140625,
      "bbox_min": [
        -1554.104736328125,
        -3382.0,
        1302.5999755859375
      ],
      "bbox_max": [
        -1551.9346923828125,
        -3378.35205078125,
        1312.15576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8500498533248901,
        0.5251100659370422,
        0.04092385247349739
      ],
      "plane_d": 3041.765869140625,
      "bbox_min": [
        -1552.4217529296875,
        -3382.0,
        1302.5999755859375
      ],
      "bbox_max": [
        -1551.8511962890625,
        -3381.076416015625,
        1304.333251953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0412130132317543,
        0.43465206027030945,
        -0.8996549844741821
      ],
      "plane_d": 2685.27783203125,
      "bbox_min": [
        -1605.8306884765625,
        -3287.9814453125,
        1322.72802734375
      ],
      "bbox_max": [
        -1573.1328125,
        -3283.58740234375,
        1326.27783203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9661343693733215,
        0.24907872080802917,
        0.0674104243516922
      ],
      "plane_d": -827.2496337890625,
      "bbox_min": [
        -1637.2723388671875,
        -3382.0,
        1302.5999755859375
      ],
      "bbox_max": [
        -1632.84228515625,
        -3369.9052734375,
        1318.2093505859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.056889183819293976,
        0.9831775426864624,
        -0.17356735467910767
      ],
      "plane_d": 3449.109619140625,
      "bbox_min": [
        -1634.891845703125,
        -3372.7666015625,
        1302.5999755859375
      ],
      "bbox_max": [
        -1632.84228515625,
        -3369.9052734375,
        1318.2093505859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999086856842041,
        -0.0,
        0.013512278907001019
      ],
      "plane_d": 1531.751953125,
      "bbox_min": [
        -1643.3553466796875,
        -3382.0,
        1496.0
      ],
      "bbox_max": [
        -1552.108154296875,
        -3313.192626953125,
        1546.3753662109375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7066444754600525,
        0.6241137981414795,
        -0.33337000012397766
      ],
      "plane_d": 3727.4794921875,
      "bbox_min": [
        -1643.3553466796875,
        -3382.0,
        1496.0
      ],
      "bbox_max": [
        -1552.108154296875,
        -3313.192626953125,
        1546.3753662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7066451907157898,
        -0.5873505473136902,
        0.3945528268814087
      ],
      "plane_d": -1427.25390625,
      "bbox_min": [
        -1643.3553466796875,
        -3373.803466796875,
        1496.0
      ],
      "bbox_max": [
        -1582.3048095703125,
        -3321.434814453125,
        1546.3753662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7066444158554077,
        0.6241137385368347,
        -0.3333699703216553
      ],
      "plane_d": 1454.91064453125,
      "bbox_min": [
        -1643.3553466796875,
        -3365.902099609375,
        1496.0
      ],
      "bbox_max": [
        -1605.121337890625,
        -3321.434814453125,
        1546.3753662109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11041881889104843,
        -0.646426796913147,
        -0.7549437284469604
      ],
      "plane_d": -1208.0379638671875,
      "bbox_min": [
        -1633.6953125,
        -3365.902099609375,
        1496.0
      ],
      "bbox_max": [
        -1605.121337890625,
        -3348.4560546875,
        1530.4117431640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3127978444099426,
        -0.8269219398498535,
        -0.467287540435791
      ],
      "plane_d": -2578.472900390625,
      "bbox_min": [
        -1633.6953125,
        -3365.522705078125,
        1503.5302734375
      ],
      "bbox_max": [
        -1605.5501708984375,
        -3348.4560546875,
        1530.4117431640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4681382179260254,
        -0.6937716007232666,
        -0.5472912192344666
      ],
      "plane_d": -2261.712890625,
      "bbox_min": [
        -1633.6953125,
        -3365.1328125,
        1503.5302734375
      ],
      "bbox_max": [
        -1605.5501708984375,
        -3348.4560546875,
        1530.4117431640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3130333423614502,
        0.8270716071128845,
        0.4668647050857544
      ],
      "plane_d": 2579.510986328125,
      "bbox_min": [
        -1633.490478515625,
        -3365.1328125,
        1503.5302734375
      ],
      "bbox_max": [
        -1605.5501708984375,
        -3348.4560546875,
        1530.4117431640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.46849194169044495,
        0.6938169002532959,
        0.5469309091567993
      ],
      "plane_d": 2262.4970703125,
      "bbox_min": [
        -1633.490478515625,
        -3364.544677734375,
        1503.5302734375
      ],
      "bbox_max": [
        -1605.5501708984375,
        -3348.4560546875,
        1530.058349609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16525734961032867,
        -0.5994217395782471,
        -0.7831881046295166
      ],
      "plane_d": -1096.21240234375,
      "bbox_min": [
        -1622.2056884765625,
        -3360.04541015625,
        1513.2254638671875
      ],
      "bbox_max": [
        -1620.64208984375,
        -3358.8662109375,
        1513.9337158203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1949397623538971,
        -0.5379993319511414,
        -0.8200947046279907
      ],
      "plane_d": -882.5914306640625,
      "bbox_min": [
        -1622.2999267578125,
        -3361.099365234375,
        1503.5302734375
      ],
      "bbox_max": [
        -1605.5501708984375,
        -3348.4560546875,
        1515.3974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03878581523895264,
        -0.6718603372573853,
        -0.7396615743637085
      ],
      "plane_d": -1201.071044921875,
      "bbox_min": [
        -1622.2999267578125,
        -3361.099365234375,
        1503.5302734375
      ],
      "bbox_max": [
        -1605.5501708984375,
        -3348.4560546875,
        1515.3974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.03878581151366234,
        -0.67186039686203,
        -0.7396616339683533
      ],
      "plane_d": -1076.3358154296875,
      "bbox_min": [
        -1622.2999267578125,
        -3361.099365234375,
        1503.5302734375
      ],
      "bbox_max": [
        -1605.5501708984375,
        -3348.4560546875,
        1515.3974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19493964314460754,
        -0.47151148319244385,
        -0.8600439429283142
      ],
      "plane_d": -599.6890869140625,
      "bbox_min": [
        -1622.2999267578125,
        -3361.099365234375,
        1503.5302734375
      ],
      "bbox_max": [
        -1605.5501708984375,
        -3348.4560546875,
        1515.3974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1949397325515747,
        -0.5379992723464966,
        -0.820094645023346
      ],
      "plane_d": -255.6650390625,
      "bbox_min": [
        -1622.2999267578125,
        -3361.099365234375,
        1503.5302734375
      ],
      "bbox_max": [
        -1605.5501708984375,
        -3348.4560546875,
        1515.3974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11043132096529007,
        0.6464233994483948,
        0.7549448013305664
      ],
      "plane_d": 1207.5550537109375,
      "bbox_min": [
        -1622.2999267578125,
        -3361.099365234375,
        1503.5302734375
      ],
      "bbox_max": [
        -1605.5501708984375,
        -3348.4560546875,
        1515.3974609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16525734961032867,
        -0.5994216799736023,
        -0.7831881046295166
      ],
      "plane_d": -564.74462890625,
      "bbox_min": [
        -1609.736572265625,
        -3352.33642578125,
        1503.8843994140625
      ],
      "bbox_max": [
        -1606.263427734375,
        -3349.584716796875,
        1505.589111328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16526995599269867,
        -0.4101145565509796,
        -0.8969346284866333
      ],
      "plane_d": -290.7393798828125,
      "bbox_min": [
        -1609.736572265625,
        -3352.33642578125,
        1503.8843994140625
      ],
      "bbox_max": [
        -1606.395751953125,
        -3349.584716796875,
        1505.589111328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11041884869337082,
        -0.646426796913147,
        -0.7549437880516052
      ],
      "plane_d": -852.930908203125,
      "bbox_min": [
        -1609.2286376953125,
        -3352.33642578125,
        1503.8843994140625
      ],
      "bbox_max": [
        -1606.395751953125,
        -3349.584716796875,
        1505.589111328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11042895913124084,
        -0.36310678720474243,
        -0.9251804947853088
      ],
      "plane_d": -2.5374755859375,
      "bbox_min": [
        -1609.2286376953125,
        -3351.04052734375,
        1503.8843994140625
      ],
      "bbox_max": [
        -1606.395751953125,
        -3349.584716796875,
        1504.6478271484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19493964314460754,
        -0.47151145339012146,
        -0.8600438833236694
      ],
      "plane_d": 27.23681640625,
      "bbox_min": [
        -1608.0,
        -3351.04052734375,
        1503.90576171875
      ],
      "bbox_max": [
        -1606.395751953125,
        -3349.735595703125,
        1504.6478271484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16526997089385986,
        -0.4101146161556244,
        -0.8969346880912781
      ],
      "plane_d": 240.7689208984375,
      "bbox_min": [
        -1608.0,
        -3351.04052734375,
        1503.90576171875
      ],
      "bbox_max": [
        -1606.74365234375,
        -3349.735595703125,
        1504.374267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0387689545750618,
        -0.3376634418964386,
        -0.9404682517051697
      ],
      "plane_d": 345.6328125,
      "bbox_min": [
        -1608.0,
        -3351.04052734375,
        1503.90576171875
      ],
      "bbox_max": [
        -1607.1112060546875,
        -3349.735595703125,
        1504.374267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11042895913124084,
        -0.3631068170070648,
        -0.9251804947853088
      ],
      "plane_d": 352.6019287109375,
      "bbox_min": [
        -1608.0,
        -3351.04052734375,
        1503.990478515625
      ],
      "bbox_max": [
        -1607.1112060546875,
        -3349.91650390625,
        1504.374267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.165274977684021,
        0.5994126200675964,
        0.7831913828849792
      ],
      "plane_d": 1095.71533203125,
      "bbox_min": [
        -1622.2999267578125,
        -3360.323974609375,
        1503.5302734375
      ],
      "bbox_max": [
        -1605.5501708984375,
        -3348.4560546875,
        1514.9315185546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0387689471244812,
        -0.3376634418964386,
        -0.9404681921005249
      ],
      "plane_d": 220.9517822265625,
      "bbox_min": [
        -1608.974365234375,
        -3350.14990234375,
        1503.75634765625
      ],
      "bbox_max": [
        -1607.1112060546875,
        -3349.25,
        1504.1307373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11042895913124084,
        -0.3631068170070648,
        -0.9251804947853088
      ],
      "plane_d": 352.6019287109375,
      "bbox_min": [
        -1608.974365234375,
        -3350.14990234375,
        1503.8004150390625
      ],
      "bbox_max": [
        -1607.1112060546875,
        -3349.359375,
        1504.1307373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0387689545750618,
        -0.3376634418964386,
        -0.9404682517051697
      ],
      "plane_d": 345.6328125,
      "bbox_min": [
        -1608.601806640625,
        -3350.876220703125,
        1503.5302734375
      ],
      "bbox_max": [
        -1605.5501708984375,
        -3348.689697265625,
        1504.7919921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19493964314460754,
        -0.47151145339012146,
        -0.8600438833236694
      ],
      "plane_d": 27.23681640625,
      "bbox_min": [
        -1608.601806640625,
        -3350.876220703125,
        1503.5302734375
      ],
      "bbox_max": [
        -1605.5501708984375,
        -3348.689697265625,
        1504.7919921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0387689471244812,
        -0.3376634418964386,
        -0.9404681921005249
      ],
      "plane_d": 220.9517822265625,
      "bbox_min": [
        -1608.601806640625,
        -3350.455078125,
        1503.5302734375
      ],
      "bbox_max": [
        -1606.263671875,
        -3348.689697265625,
        1504.338134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16526997089385986,
        -0.4101146161556244,
        -0.8969346880912781
      ],
      "plane_d": 240.7689208984375,
      "bbox_min": [
        -1607.1112060546875,
        -3350.455078125,
        1504.0377197265625
      ],
      "bbox_max": [
        -1606.263671875,
        -3349.8095703125,
        1504.338134765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19495174288749695,
        0.5379989743232727,
        0.8200920820236206
      ],
      "plane_d": 882.123291015625,
      "bbox_min": [
        -1612.105712890625,
        -3353.8466796875,
        1503.96728515625
      ],
      "bbox_max": [
        -1605.5748291015625,
        -3348.4560546875,
        1507.674560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.038783423602581024,
        0.6718626618385315,
        0.7396596670150757
      ],
      "plane_d": 1200.587890625,
      "bbox_min": [
        -1610.42529296875,
        -3353.8466796875,
        1503.96728515625
      ],
      "bbox_max": [
        -1605.5748291015625,
        -3348.4560546875,
        1507.674560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1949509233236313,
        0.4715180993080139,
        0.860037624835968
      ],
      "plane_d": 599.2489013671875,
      "bbox_min": [
        -1610.42529296875,
        -3352.61328125,
        1503.96728515625
      ],
      "bbox_max": [
        -1605.5748291015625,
        -3348.4560546875,
        1506.4652099609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.03877443075180054,
        0.33766087889671326,
        0.9404689073562622
      ],
      "plane_d": -221.4427490234375,
      "bbox_min": [
        -1609.718994140625,
        -3352.61328125,
        1503.96728515625
      ],
      "bbox_max": [
        -1605.5748291015625,
        -3348.4560546875,
        1506.4652099609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19495174288749695,
        0.5379989743232727,
        0.8200920820236206
      ],
      "plane_d": 255.1585693359375,
      "bbox_min": [
        -1609.718994140625,
        -3352.61328125,
        1503.96728515625
      ],
      "bbox_max": [
        -1605.5748291015625,
        -3348.4560546875,
        1506.4652099609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.038774434477090836,
        0.33766084909439087,
        0.9404688477516174
      ],
      "plane_d": -346.14111328125,
      "bbox_min": [
        -1609.718994140625,
        -3352.61328125,
        1503.96728515625
      ],
      "bbox_max": [
        -1606.2811279296875,
        -3348.4560546875,
        1506.4652099609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03878342732787132,
        0.6718626618385315,
        0.7396596670150757
      ],
      "plane_d": 1075.8603515625,
      "bbox_min": [
        -1609.718994140625,
        -3352.61328125,
        1504.2347412109375
      ],
      "bbox_max": [
        -1606.2811279296875,
        -3349.119140625,
        1506.4652099609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1652744561433792,
        0.4101085364818573,
        0.8969367146492004
      ],
      "plane_d": 290.2332763671875,
      "bbox_min": [
        -1609.718994140625,
        -3352.06591796875,
        1504.2347412109375
      ],
      "bbox_max": [
        -1606.2811279296875,
        -3349.119140625,
        1506.0052490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11043810844421387,
        0.3631051480770111,
        0.9251800775527954
      ],
      "plane_d": 2.0574951171875,
      "bbox_min": [
        -1609.2161865234375,
        -3352.06591796875,
        1504.2347412109375
      ],
      "bbox_max": [
        -1606.2811279296875,
        -3349.119140625,
        1506.0052490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16527442634105682,
        0.4101085364818573,
        0.8969366550445557
      ],
      "plane_d": -241.289306640625,
      "bbox_min": [
        -1608.0,
        -3352.06591796875,
        1504.2347412109375
      ],
      "bbox_max": [
        -1606.2811279296875,
        -3349.119384765625,
        1506.0052490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11043132096529007,
        0.6464234590530396,
        0.7549448609352112
      ],
      "plane_d": 852.4080810546875,
      "bbox_min": [
        -1608.0,
        -3352.06591796875,
        1504.2347412109375
      ],
      "bbox_max": [
        -1606.28125,
        -3349.119384765625,
        1506.0052490234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1652749925851822,
        0.599412739276886,
        0.7831913232803345
      ],
      "plane_d": 564.19140625,
      "bbox_min": [
        -1608.0,
        -3351.6494140625,
        1504.2347412109375
      ],
      "bbox_max": [
        -1606.28125,
        -3349.119384765625,
        1505.722412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11043811589479446,
        0.3631051182746887,
        0.9251800775527954
      ],
      "plane_d": -353.111572265625,
      "bbox_min": [
        -1608.0,
        -3350.783203125,
        1504.2347412109375
      ],
      "bbox_max": [
        -1606.783935546875,
        -3349.119384765625,
        1504.8028564453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1614.199951171875,
      "bbox_min": [
        -1614.199951171875,
        -3355.456787109375,
        1507.474609375
      ],
      "bbox_max": [
        -1614.199951171875,
        -3353.53857421875,
        1509.0625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5150415301322937,
        -0.8571652173995972
      ],
      "plane_d": -437.427734375,
      "bbox_min": [
        -1616.815673828125,
        -3365.902099609375,
        1496.0
      ],
      "bbox_max": [
        -1605.121337890625,
        -3349.391357421875,
        1509.12841796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1614.199951171875,
      "bbox_min": [
        -1614.199951171875,
        -3356.955810546875,
        1505.4095458984375
      ],
      "bbox_max": [
        -1611.7750244140625,
        -3353.6025390625,
        1509.12841796875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -2.307058275619056e-05,
        -0.8571455478668213,
        0.5150743126869202
      ],
      "plane_d": -3653.53125,
      "bbox_min": [
        -1614.199951171875,
        -3356.955810546875,
        1506.7618408203125
      ],
      "bbox_max": [
        -1611.7750244140625,
        -3355.53369140625,
        1509.12841796875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.8571632504463196,
        0.5150449872016907
      ],
      "plane_d": -3650.208984375,
      "bbox_min": [
        -1616.815673828125,
        -3365.902099609375,
        1496.0
      ],
      "bbox_max": [
        -1605.121337890625,
        -3349.41259765625,
        1505.0621337890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1612.0,
      "bbox_min": [
        -1612.2022705078125,
        -3356.7021484375,
        1497.0018310546875
      ],
      "bbox_max": [
        -1605.121337890625,
        -3349.41259765625,
        1505.0621337890625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.5150126814842224,
        -0.8571826815605164
      ],
      "plane_d": -444.304931640625,
      "bbox_min": [
        -1612.0,
        -3356.7021484375,
        1497.0018310546875
      ],
      "bbox_max": [
        -1605.121337890625,
        -3349.41259765625,
        1502.2294921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8571696281433105,
        -0.5150341987609863
      ],
      "plane_d": 3644.71435546875,
      "bbox_min": [
        -1609.878662109375,
        -3354.3037109375,
        1497.0018310546875
      ],
      "bbox_max": [
        -1606.121337890625,
        -3349.41259765625,
        1502.2294921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.3766965866088867,
        -0.9263367056846619
      ],
      "plane_d": 2650.282470703125,
      "bbox_min": [
        -1609.878662109375,
        -3354.3037109375,
        1497.0018310546875
      ],
      "bbox_max": [
        -1606.121337890625,
        -3351.98779296875,
        1497.943603515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3355.60009765625,
      "bbox_min": [
        -1612.2022705078125,
        -3355.60009765625,
        1499.0712890625
      ],
      "bbox_max": [
        -1612.0,
        -3355.37109375,
        1499.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1499.5,
      "bbox_min": [
        -1612.2021484375,
        -3355.60009765625,
        1499.5
      ],
      "bbox_max": [
        -1612.0,
        -3355.37109375,
        1499.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4851193428039551,
        -0.8401665091514587,
        0.24244487285614014
      ],
      "plane_d": -3973.2109375,
      "bbox_min": [
        -1616.815673828125,
        -3365.902099609375,
        1496.0
      ],
      "bbox_max": [
        -1611.905029296875,
        -3362.3515625,
        1498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4850834310054779,
        0.8401557803153992,
        0.2425534576177597
      ],
      "plane_d": 3245.61962890625,
      "bbox_min": [
        -1616.815673828125,
        -3365.076171875,
        1496.0
      ],
      "bbox_max": [
        -1611.905029296875,
        -3362.3515625,
        1498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1498.0,
      "bbox_min": [
        -1616.815673828125,
        -3365.076171875,
        1496.0
      ],
      "bbox_max": [
        -1612.9840087890625,
        -3362.3515625,
        1498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6859249472618103,
        0.6860393285751343,
        0.24260465800762177
      ],
      "plane_d": 835.759033203125,
      "bbox_min": [
        -1616.815673828125,
        -3363.8154296875,
        1496.0
      ],
      "bbox_max": [
        -1615.269287109375,
        -3362.3515625,
        1498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6955071091651917,
        0.6805833578109741,
        0.23038242757320404
      ],
      "plane_d": 778.6746826171875,
      "bbox_min": [
        -1643.3553466796875,
        -3364.03515625,
        1496.0
      ],
      "bbox_max": [
        -1608.0,
        -3321.434814453125,
        1529.52880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5150415301322937,
        -0.8571652173995972
      ],
      "plane_d": -437.427734375,
      "bbox_min": [
        -1643.3553466796875,
        -3364.03515625,
        1496.0
      ],
      "bbox_max": [
        -1608.0,
        -3321.434814453125,
        1529.52880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5522040724754333,
        -0.33149459958076477,
        -0.7649718523025513
      ],
      "plane_d": -855.4124755859375,
      "bbox_min": [
        -1643.3553466796875,
        -3364.03515625,
        1500.1973876953125
      ],
      "bbox_max": [
        -1608.0,
        -3321.434814453125,
        1529.52880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4681406617164612,
        -0.15752869844436646,
        -0.8694992661476135
      ],
      "plane_d": 19.9765625,
      "bbox_min": [
        -1643.0775146484375,
        -3364.03515625,
        1500.1973876953125
      ],
      "bbox_max": [
        -1608.0,
        -3321.434814453125,
        1529.52880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4681382179260254,
        -0.6937716007232666,
        -0.5472912192344666
      ],
      "plane_d": -2261.712890625,
      "bbox_min": [
        -1643.0775146484375,
        -3364.03515625,
        1500.1973876953125
      ],
      "bbox_max": [
        -1608.0,
        -3321.434814453125,
        1529.52880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31279879808425903,
        -0.024374349042773247,
        -0.9495065808296204
      ],
      "plane_d": 836.332763671875,
      "bbox_min": [
        -1643.0775146484375,
        -3363.66357421875,
        1500.1973876953125
      ],
      "bbox_max": [
        -1608.0,
        -3321.434814453125,
        1529.52880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.46849194169044495,
        0.6938169002532959,
        0.5469309091567993
      ],
      "plane_d": 2262.4970703125,
      "bbox_min": [
        -1643.0775146484375,
        -3363.66357421875,
        1500.1973876953125
      ],
      "bbox_max": [
        -1608.0,
        -3321.434814453125,
        1529.52880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16525734961032867,
        -0.5994217395782471,
        -0.7831881046295166
      ],
      "plane_d": -1096.21240234375,
      "bbox_min": [
        -1626.1187744140625,
        -3359.504638671875,
        1510.2657470703125
      ],
      "bbox_max": [
        -1621.5618896484375,
        -3353.4560546875,
        1513.9002685546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1949397623538971,
        -0.5379993319511414,
        -0.8200947046279907
      ],
      "plane_d": -882.5914306640625,
      "bbox_min": [
        -1626.1187744140625,
        -3355.35693359375,
        1510.2657470703125
      ],
      "bbox_max": [
        -1624.517578125,
        -3353.4560546875,
        1511.407958984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5526136755943298,
        0.5197241902351379,
        0.6515404582023621
      ],
      "plane_d": 1657.0010986328125,
      "bbox_min": [
        -1643.0775146484375,
        -3359.162841796875,
        1500.1973876953125
      ],
      "bbox_max": [
        -1608.0,
        -3321.434814453125,
        1524.1971435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1949397623538971,
        -0.5379993319511414,
        -0.8200947046279907
      ],
      "plane_d": -882.5914306640625,
      "bbox_min": [
        -1627.1341552734375,
        -3355.07373046875,
        1506.495361328125
      ],
      "bbox_max": [
        -1624.517578125,
        -3347.180908203125,
        1510.9464111328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19493964314460754,
        -0.47151148319244385,
        -0.8600439429283142
      ],
      "plane_d": -599.6890869140625,
      "bbox_min": [
        -1627.1341552734375,
        -3349.208984375,
        1506.495361328125
      ],
      "bbox_max": [
        -1625.87939453125,
        -3347.180908203125,
        1507.6365966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5526154041290283,
        0.33127477765083313,
        0.7647700905799866
      ],
      "plane_d": 855.1624755859375,
      "bbox_min": [
        -1643.0775146484375,
        -3359.162841796875,
        1500.1973876953125
      ],
      "bbox_max": [
        -1608.0,
        -3321.434814453125,
        1517.2835693359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19493964314460754,
        -0.47151148319244385,
        -0.8600439429283142
      ],
      "plane_d": -599.6890869140625,
      "bbox_min": [
        -1626.693359375,
        -3349.208984375,
        1502.897216796875
      ],
      "bbox_max": [
        -1624.4217529296875,
        -3341.192626953125,
        1507.422607421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16526995599269867,
        -0.4101145565509796,
        -0.8969346284866333
      ],
      "plane_d": -290.7393798828125,
      "bbox_min": [
        -1625.6776123046875,
        -3343.343994140625,
        1502.897216796875
      ],
      "bbox_max": [
        -1624.4217529296875,
        -3341.192626953125,
        1503.898681640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4684832692146301,
        0.15718330442905426,
        0.8693771958351135
      ],
      "plane_d": -20.8779296875,
      "bbox_min": [
        -1640.407470703125,
        -3359.162841796875,
        1500.1973876953125
      ],
      "bbox_max": [
        -1608.0,
        -3321.434814453125,
        1514.23388671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16526995599269867,
        -0.4101145565509796,
        -0.8969346284866333
      ],
      "plane_d": -290.7393798828125,
      "bbox_min": [
        -1633.0,
        -3343.343994140625,
        1500.1973876953125
      ],
      "bbox_max": [
        -1619.919189453125,
        -3321.45556640625,
        1504.5087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11042895913124084,
        -0.36310678720474243,
        -0.9251804947853088
      ],
      "plane_d": -2.5374755859375,
      "bbox_min": [
        -1633.0,
        -3338.372314453125,
        1500.1973876953125
      ],
      "bbox_max": [
        -1619.919189453125,
        -3321.45556640625,
        1504.5087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46475666761398315,
        0.8784070014953613,
        0.11136633902788162
      ],
      "plane_d": 1991.68017578125,
      "bbox_min": [
        -1633.0,
        -3322.06884765625,
        1503.693359375
      ],
      "bbox_max": [
        -1631.875732421875,
        -3321.45556640625,
        1504.5087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31304019689559937,
        0.02393937297165394,
        0.9494381546974182
      ],
      "plane_d": -837.7777099609375,
      "bbox_min": [
        -1632.8035888671875,
        -3359.162841796875,
        1500.2625732421875
      ],
      "bbox_max": [
        -1608.0,
        -3321.434814453125,
        1514.23388671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11042895913124084,
        -0.36310678720474243,
        -0.9251804947853088
      ],
      "plane_d": -2.5374755859375,
      "bbox_min": [
        -1632.8035888671875,
        -3338.372314453125,
        1500.2625732421875
      ],
      "bbox_max": [
        -1619.2666015625,
        -3321.434814453125,
        1504.5087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46475666761398315,
        0.8784070014953613,
        0.11136633902788162
      ],
      "plane_d": 1991.68017578125,
      "bbox_min": [
        -1632.8035888671875,
        -3322.02294921875,
        1503.90625
      ],
      "bbox_max": [
        -1631.7767333984375,
        -3321.434814453125,
        1504.5087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1949509233236313,
        0.4715180993080139,
        0.860037624835968
      ],
      "plane_d": 599.2489013671875,
      "bbox_min": [
        -1626.943115234375,
        -3359.162841796875,
        1500.43798828125
      ],
      "bbox_max": [
        -1608.0,
        -3336.585205078125,
        1514.23388671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19493964314460754,
        -0.47151148319244385,
        -0.8600439429283142
      ],
      "plane_d": -599.6890869140625,
      "bbox_min": [
        -1625.87939453125,
        -3354.766357421875,
        1500.478271484375
      ],
      "bbox_max": [
        -1608.0,
        -3338.7509765625,
        1510.6781005859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16525734961032867,
        -0.5994217395782471,
        -0.7831881046295166
      ],
      "plane_d": -1096.21240234375,
      "bbox_min": [
        -1623.258544921875,
        -3354.766357421875,
        1503.003662109375
      ],
      "bbox_max": [
        -1608.0,
        -3347.02587890625,
        1510.4454345703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0387689471244812,
        -0.3376634418964386,
        -0.9404681921005249
      ],
      "plane_d": 220.9517822265625,
      "bbox_min": [
        -1609.7177734375,
        -3349.359375,
        1503.003662109375
      ],
      "bbox_max": [
        -1608.0,
        -3347.02587890625,
        1503.8004150390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1614.199951171875,
      "bbox_min": [
        -1614.199951171875,
        -3353.5810546875,
        1506.8411865234375
      ],
      "bbox_max": [
        -1614.199951171875,
        -3352.554443359375,
        1507.5943603515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.0511450202320702e-05,
        0.8571717143058777,
        -0.5150308609008789
      ],
      "plane_d": 3641.349365234375,
      "bbox_min": [
        -1613.900146484375,
        -3345.337890625,
        1502.409423828125
      ],
      "bbox_max": [
        -1611.4886474609375,
        -3345.12841796875,
        1502.7581787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1614.1998291015625,
      "bbox_min": [
        -1614.199951171875,
        -3353.722412109375,
        1505.431396484375
      ],
      "bbox_max": [
        -1614.199951171875,
        -3350.4052734375,
        1507.5146484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1614.199951171875,
      "bbox_min": [
        -1614.199951171875,
        -3348.15185546875,
        1502.127685546875
      ],
      "bbox_max": [
        -1611.4720458984375,
        -3345.102294921875,
        1504.19580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.0511450202320702e-05,
        0.8571717143058777,
        -0.5150308609008789
      ],
      "plane_d": 3641.349365234375,
      "bbox_min": [
        -1614.199951171875,
        -3345.50732421875,
        1502.127685546875
      ],
      "bbox_max": [
        -1611.4720458984375,
        -3345.102294921875,
        1502.801513671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -1614.1998291015625,
      "bbox_min": [
        -1614.199951171875,
        -3354.705322265625,
        1500.478271484375
      ],
      "bbox_max": [
        -1611.375244140625,
        -3345.227783203125,
        1507.2498779296875
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        2.0511450202320702e-05,
        0.8571717143058777,
        -0.5150308609008789
      ],
      "plane_d": 3641.349365234375,
      "bbox_min": [
        -1614.199951171875,
        -3346.498291015625,
        1500.478271484375
      ],
      "bbox_max": [
        -1611.375244140625,
        -3345.227783203125,
        1502.5927734375
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.16526995599269867,
        -0.4101145565509796,
        -0.8969346284866333
      ],
      "plane_d": -290.7393798828125,
      "bbox_min": [
        -1620.9373779296875,
        -3339.337646484375,
        1500.911376953125
      ],
      "bbox_max": [
        -1619.678955078125,
        -3338.372314453125,
        1501.1751708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16525734961032867,
        -0.5994217395782471,
        -0.7831881046295166
      ],
      "plane_d": -1096.21240234375,
      "bbox_min": [
        -1624.6212158203125,
        -3358.865966796875,
        1508.2667236328125
      ],
      "bbox_max": [
        -1615.0791015625,
        -3354.174560546875,
        1513.225341796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1949397623538971,
        -0.5379993319511414,
        -0.8200947046279907
      ],
      "plane_d": -882.5914306640625,
      "bbox_min": [
        -1624.6212158203125,
        -3355.07373046875,
        1510.4454345703125
      ],
      "bbox_max": [
        -1623.258544921875,
        -3354.627197265625,
        1510.9464111328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.165274977684021,
        0.5994126200675964,
        0.7831913828849792
      ],
      "plane_d": 1095.71533203125,
      "bbox_min": [
        -1625.5010986328125,
        -3359.162841796875,
        1503.446044921875
      ],
      "bbox_max": [
        -1608.0,
        -3346.80908203125,
        1514.23388671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.03877443075180054,
        0.33766087889671326,
        0.9404689073562622
      ],
      "plane_d": -221.4427490234375,
      "bbox_min": [
        -1609.700439453125,
        -3349.119140625,
        1503.446044921875
      ],
      "bbox_max": [
        -1608.0,
        -3346.80908203125,
        1504.2347412109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1612.0,
      "bbox_min": [
        -1620.1156005859375,
        -3358.10009765625,
        1496.0
      ],
      "bbox_max": [
        -1608.0250244140625,
        -3344.753173828125,
        1504.276611328125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.8571696281433105,
        -0.5150341987609863
      ],
      "plane_d": 3644.71435546875,
      "bbox_min": [
        -1612.0,
        -3356.1220703125,
        1497.0018310546875
      ],
      "bbox_max": [
        -1608.0250244140625,
        -3349.41259765625,
        1502.2294921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.3766965866088867,
        -0.9263367056846619
      ],
      "plane_d": 2650.282470703125,
      "bbox_min": [
        -1612.0,
        -3356.1220703125,
        1497.0018310546875
      ],
      "bbox_max": [
        -1608.2777099609375,
        -3351.98779296875,
        1498.0943603515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.5150126814842224,
        -0.8571826815605164
      ],
      "plane_d": -444.304931640625,
      "bbox_min": [
        -1612.0,
        -3356.1220703125,
        1497.0018310546875
      ],
      "bbox_max": [
        -1609.878662109375,
        -3354.3037109375,
        1498.0943603515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9701424837112427,
        0.0,
        0.24253562092781067
      ],
      "plane_d": -1934.576171875,
      "bbox_min": [
        -1620.1156005859375,
        -3358.10009765625,
        1496.0
      ],
      "bbox_max": [
        -1612.0,
        -3344.753173828125,
        1500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9701425433158875,
        -0.0,
        0.24253563582897186
      ],
      "plane_d": 1206.969482421875,
      "bbox_min": [
        -1620.1156005859375,
        -3358.10009765625,
        1496.0
      ],
      "bbox_max": [
        -1612.0,
        -3344.753173828125,
        1500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1498.0,
      "bbox_min": [
        -1620.1156005859375,
        -3358.10009765625,
        1496.0
      ],
      "bbox_max": [
        -1618.1156005859375,
        -3351.5,
        1498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2511959671974182,
        0.9370661973953247,
        0.24250248074531555
      ],
      "plane_d": 3184.76025390625,
      "bbox_min": [
        -1620.1156005859375,
        -3358.10009765625,
        1496.0
      ],
      "bbox_max": [
        -1618.1156005859375,
        -3351.5,
        1498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2511899769306183,
        -0.9370437860488892,
        0.24259574711322784
      ],
      "plane_d": -3102.653564453125,
      "bbox_min": [
        -1620.1156005859375,
        -3358.10009765625,
        1496.0
      ],
      "bbox_max": [
        -1618.1156005859375,
        -3357.180419921875,
        1498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.936329185962677,
        0.3511234521865845
      ],
      "plane_d": 2612.826416015625,
      "bbox_min": [
        -1616.8155517578125,
        -3358.0,
        1496.0
      ],
      "bbox_max": [
        -1612.0,
        -3344.753173828125,
        1500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1613.5,
      "bbox_min": [
        -1616.0,
        -3358.0,
        1496.0
      ],
      "bbox_max": [
        -1612.0,
        -3351.5,
        1500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1616.0,
      "bbox_min": [
        -1616.0,
        -3358.0,
        1496.0
      ],
      "bbox_max": [
        -1613.5,
        -3351.5,
        1500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.936329185962677,
        0.3511234521865845
      ],
      "plane_d": -3669.47412109375,
      "bbox_min": [
        -1616.0,
        -3358.0,
        1496.0
      ],
      "bbox_max": [
        -1613.5,
        -3353.0,
        1500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1500.0,
      "bbox_min": [
        -1616.0,
        -3356.5,
        1500.0
      ],
      "bbox_max": [
        -1613.5,
        -3353.0,
        1500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1498.0,
      "bbox_min": [
        -1613.5,
        -3355.60009765625,
        1498.0
      ],
      "bbox_max": [
        -1612.0,
        -3354.0,
        1499.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3354.0,
      "bbox_min": [
        -1613.5,
        -3355.60009765625,
        1498.0
      ],
      "bbox_max": [
        -1612.0,
        -3354.0,
        1499.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1499.5,
      "bbox_min": [
        -1613.5,
        -3355.60009765625,
        1498.0
      ],
      "bbox_max": [
        -1612.0,
        -3354.0,
        1499.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3355.60009765625,
      "bbox_min": [
        -1613.5,
        -3355.60009765625,
        1498.0
      ],
      "bbox_max": [
        -1612.0,
        -3355.60009765625,
        1499.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48509156703948975,
        0.8401626944541931,
        0.24251346290111542
      ],
      "plane_d": 1663.8994140625,
      "bbox_min": [
        -1616.8155517578125,
        -3347.24853515625,
        1496.0
      ],
      "bbox_max": [
        -1613.3914794921875,
        -3344.753173828125,
        1498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48507875204086304,
        -0.8401477336883545,
        0.24259112775325775
      ],
      "plane_d": -2391.52685546875,
      "bbox_min": [
        -1616.8155517578125,
        -3347.24853515625,
        1496.0
      ],
      "bbox_max": [
        -1613.3914794921875,
        -3344.774658203125,
        1498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.686018168926239,
        -0.6859609484672546,
        0.24256305396556854
      ],
      "plane_d": -3767.116455078125,
      "bbox_min": [
        -1616.8155517578125,
        -3347.24853515625,
        1496.0
      ],
      "bbox_max": [
        -1613.3914794921875,
        -3344.774658203125,
        1498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1497.9998779296875,
      "bbox_min": [
        -1616.001220703125,
        -3346.62353515625,
        1498.0
      ],
      "bbox_max": [
        -1613.3914794921875,
        -3344.774658203125,
        1498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10984108597040176,
        -0.8989793658256531,
        -0.423994243144989
      ],
      "plane_d": -2558.715087890625,
      "bbox_min": [
        -1631.96044921875,
        -3373.803466796875,
        1496.0
      ],
      "bbox_max": [
        -1582.3048095703125,
        -3350.53466796875,
        1535.3497314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3127978444099426,
        -0.8269219398498535,
        -0.467287540435791
      ],
      "plane_d": -2578.472900390625,
      "bbox_min": [
        -1631.96044921875,
        -3373.803466796875,
        1497.516845703125
      ],
      "bbox_max": [
        -1582.3048095703125,
        -3350.53466796875,
        1535.3497314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10984160006046295,
        -0.8989806175231934,
        -0.423991322517395
      ],
      "plane_d": -2205.47412109375,
      "bbox_min": [
        -1631.776611328125,
        -3373.803466796875,
        1497.516845703125
      ],
      "bbox_max": [
        -1582.3048095703125,
        -3350.53466796875,
        1535.3497314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3130333423614502,
        0.8270716071128845,
        0.4668647050857544
      ],
      "plane_d": 2579.510986328125,
      "bbox_min": [
        -1631.776611328125,
        -3373.803466796875,
        1497.516845703125
      ],
      "bbox_max": [
        -1582.3048095703125,
        -3350.53466796875,
        1535.3497314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11041881889104843,
        -0.646426796913147,
        -0.7549437284469604
      ],
      "plane_d": -1208.0379638671875,
      "bbox_min": [
        -1621.5299072265625,
        -3371.882080078125,
        1514.4072265625
      ],
      "bbox_max": [
        -1613.1055908203125,
        -3360.8330078125,
        1533.9820556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16314196586608887,
        -0.4206838309764862,
        0.8924179673194885
      ],
      "plane_d": -3051.6201171875,
      "bbox_min": [
        -1621.5299072265625,
        -3371.882080078125,
        1533.7503662109375
      ],
      "bbox_max": [
        -1619.268798828125,
        -3371.0625,
        1533.9820556640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16314196586608887,
        -0.4206838309764862,
        0.8924179673194885
      ],
      "plane_d": -3051.6201171875,
      "bbox_min": [
        -1621.423583984375,
        -3373.803466796875,
        1498.845458984375
      ],
      "bbox_max": [
        -1605.7835693359375,
        -3356.50390625,
        1535.3497314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03878581523895264,
        -0.6718603372573853,
        -0.7396615743637085
      ],
      "plane_d": -1201.071044921875,
      "bbox_min": [
        -1614.8421630859375,
        -3365.4814453125,
        1498.845458984375
      ],
      "bbox_max": [
        -1605.7835693359375,
        -3356.50390625,
        1517.491455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.03878581151366234,
        -0.67186039686203,
        -0.7396616339683533
      ],
      "plane_d": -1076.3358154296875,
      "bbox_min": [
        -1608.0,
        -3365.4814453125,
        1516.631103515625
      ],
      "bbox_max": [
        -1605.7835693359375,
        -3364.534423828125,
        1517.491455078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10993056744337082,
        0.8991839289665222,
        0.42353707551956177
      ],
      "plane_d": 2206.21728515625,
      "bbox_min": [
        -1620.040771484375,
        -3373.35107421875,
        1499.2738037109375
      ],
      "bbox_max": [
        -1582.3048095703125,
        -3350.53466796875,
        1535.3497314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.03878581151366234,
        -0.67186039686203,
        -0.7396616339683533
      ],
      "plane_d": -1076.3358154296875,
      "bbox_min": [
        -1608.0,
        -3365.103515625,
        1499.2738037109375
      ],
      "bbox_max": [
        -1598.79833984375,
        -3356.5478515625,
        1517.264404296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11041884869337082,
        -0.646426796913147,
        -0.7549437880516052
      ],
      "plane_d": -852.930908203125,
      "bbox_min": [
        -1601.1578369140625,
        -3364.23291015625,
        1515.93017578125
      ],
      "bbox_max": [
        -1598.79833984375,
        -3363.156494140625,
        1516.7413330078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8571632504463196,
        0.5150449872016907
      ],
      "plane_d": -3650.208984375,
      "bbox_min": [
        -1605.0206298828125,
        -3356.7021484375,
        1500.7763671875
      ],
      "bbox_max": [
        -1604.400390625,
        -3356.65966796875,
        1500.84716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11041884869337082,
        -0.646426796913147,
        -0.7549437880516052
      ],
      "plane_d": -852.930908203125,
      "bbox_min": [
        -1606.9127197265625,
        -3364.92724609375,
        1500.1485595703125
      ],
      "bbox_max": [
        -1582.3048095703125,
        -3355.471923828125,
        1530.058349609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16525734961032867,
        -0.5994216799736023,
        -0.7831881046295166
      ],
      "plane_d": -564.74462890625,
      "bbox_min": [
        -1595.3572998046875,
        -3364.92724609375,
        1513.717529296875
      ],
      "bbox_max": [
        -1582.3048095703125,
        -3359.331787109375,
        1530.058349609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6954729557037354,
        -0.11604724824428558,
        0.709119439125061
      ],
      "plane_d": -374.3699951171875,
      "bbox_min": [
        -1583.1964111328125,
        -3364.92724609375,
        1529.2672119140625
      ],
      "bbox_max": [
        -1582.3048095703125,
        -3363.8642578125,
        1530.058349609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8571632504463196,
        0.5150449872016907
      ],
      "plane_d": -3650.208984375,
      "bbox_min": [
        -1606.9127197265625,
        -3356.7021484375,
        1500.1485595703125
      ],
      "bbox_max": [
        -1603.5,
        -3355.471923828125,
        1501.63623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.994769275188446,
        -0.10214781016111374
      ],
      "plane_d": -3185.843017578125,
      "bbox_min": [
        -1606.9127197265625,
        -3356.7021484375,
        1500.1485595703125
      ],
      "bbox_max": [
        -1603.5,
        -3355.471923828125,
        1501.63623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1603.5,
      "bbox_min": [
        -1603.5,
        -3356.3388671875,
        1500.318603515625
      ],
      "bbox_max": [
        -1603.5,
        -3355.471923828125,
        1501.63623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4684883952140808,
        0.6938163638114929,
        0.5469347834587097
      ],
      "plane_d": 755.8250732421875,
      "bbox_min": [
        -1620.040771484375,
        -3365.079833984375,
        1499.9010009765625
      ],
      "bbox_max": [
        -1582.3990478515625,
        -3350.53466796875,
        1530.058349609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16525734961032867,
        -0.5994216799736023,
        -0.7831881046295166
      ],
      "plane_d": -564.74462890625,
      "bbox_min": [
        -1604.999755859375,
        -3364.544677734375,
        1500.3721923828125
      ],
      "bbox_max": [
        -1582.3990478515625,
        -3355.221923828125,
        1530.058349609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6954729557037354,
        -0.11604724824428558,
        0.709119439125061
      ],
      "plane_d": -374.3699951171875,
      "bbox_min": [
        -1583.1964111328125,
        -3364.544677734375,
        1529.3875732421875
      ],
      "bbox_max": [
        -1582.3990478515625,
        -3363.66357421875,
        1530.058349609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8571632504463196,
        0.5150449872016907
      ],
      "plane_d": -3650.208984375,
      "bbox_min": [
        -1604.999755859375,
        -3356.478271484375,
        1500.3721923828125
      ],
      "bbox_max": [
        -1603.5,
        -3355.221923828125,
        1501.8780517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1603.5,
      "bbox_min": [
        -1603.5,
        -3356.185546875,
        1500.3721923828125
      ],
      "bbox_max": [
        -1603.5,
        -3355.221923828125,
        1501.8780517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03878342732787132,
        0.6718626618385315,
        0.7396596670150757
      ],
      "plane_d": 1075.8603515625,
      "bbox_min": [
        -1620.040771484375,
        -3365.079833984375,
        1499.9010009765625
      ],
      "bbox_max": [
        -1593.7001953125,
        -3350.53466796875,
        1517.7890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5150415301322937,
        -0.8571652173995972
      ],
      "plane_d": -437.427734375,
      "bbox_min": [
        -1614.316650390625,
        -3364.534423828125,
        1499.9010009765625
      ],
      "bbox_max": [
        -1595.7979736328125,
        -3350.78955078125,
        1516.631103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.307058275619056e-05,
        -0.8571455478668213,
        0.5150743126869202
      ],
      "plane_d": -3653.53125,
      "bbox_min": [
        -1611.9013671875,
        -3355.7421875,
        1508.7816162109375
      ],
      "bbox_max": [
        -1610.609619140625,
        -3355.667236328125,
        1508.9063720703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1601.199951171875,
      "bbox_min": [
        -1601.699951171875,
        -3355.528076171875,
        1507.93408203125
      ],
      "bbox_max": [
        -1601.199951171875,
        -3353.97265625,
        1509.21044921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -6.084522829041816e-05,
        -0.8571798205375671,
        0.5150172710418701
      ],
      "plane_d": -3653.62060546875,
      "bbox_min": [
        -1601.699951171875,
        -3355.528076171875,
        1509.1380615234375
      ],
      "bbox_max": [
        -1601.199951171875,
        -3355.484619140625,
        1509.21044921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.2785068975063041e-05,
        -0.857175350189209,
        0.515024721622467
      ],
      "plane_d": -3653.539794921875,
      "bbox_min": [
        -1605.390380859375,
        -3355.7421875,
        1507.609619140625
      ],
      "bbox_max": [
        -1601.199951171875,
        -3354.036376953125,
        1509.1865234375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1601.199951171875,
      "bbox_min": [
        -1601.199951171875,
        -3355.65673828125,
        1507.609619140625
      ],
      "bbox_max": [
        -1601.199951171875,
        -3354.036376953125,
        1509.1865234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.3955805115983821e-05,
        -0.8571527004241943,
        0.5150623917579651
      ],
      "plane_d": -3653.522705078125,
      "bbox_min": [
        -1611.8966064453125,
        -3355.874267578125,
        1508.561767578125
      ],
      "bbox_max": [
        -1608.0,
        -3355.716064453125,
        1508.8251953125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.8571724891662598,
        0.5150294899940491
      ],
      "plane_d": -3653.51708984375,
      "bbox_min": [
        -1611.881103515625,
        -3356.955810546875,
        1505.71875
      ],
      "bbox_max": [
        -1601.199951171875,
        -3354.209716796875,
        1508.924072265625
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1603.5,
      "bbox_min": [
        -1608.22216796875,
        -3356.7021484375,
        1499.9010009765625
      ],
      "bbox_max": [
        -1603.5,
        -3353.248046875,
        1505.0621337890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.994769275188446,
        -0.10214781016111374
      ],
      "plane_d": -3185.843017578125,
      "bbox_min": [
        -1608.22216796875,
        -3356.7021484375,
        1499.9010009765625
      ],
      "bbox_max": [
        -1606.147216796875,
        -3356.6123046875,
        1500.7763671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11043132096529007,
        0.6464234590530396,
        0.7549448609352112
      ],
      "plane_d": 852.4080810546875,
      "bbox_min": [
        -1620.040771484375,
        -3365.079833984375,
        1505.21630859375
      ],
      "bbox_max": [
        -1593.7001953125,
        -3350.53466796875,
        1517.7890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16525734961032867,
        -0.5994216799736023,
        -0.7831881046295166
      ],
      "plane_d": -564.74462890625,
      "bbox_min": [
        -1601.1378173828125,
        -3360.29833984375,
        1508.1009521484375
      ],
      "bbox_max": [
        -1594.4376220703125,
        -3354.017822265625,
        1514.0858154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11041884869337082,
        -0.646426796913147,
        -0.7549437880516052
      ],
      "plane_d": -852.930908203125,
      "bbox_min": [
        -1596.31787109375,
        -3360.29833984375,
        1513.207763671875
      ],
      "bbox_max": [
        -1595.3572998046875,
        -3359.361572265625,
        1514.0858154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11041881889104843,
        -0.646426796913147,
        -0.7549437284469604
      ],
      "plane_d": -1208.0379638671875,
      "bbox_min": [
        -1619.2664794921875,
        -3363.457275390625,
        1509.4959716796875
      ],
      "bbox_max": [
        -1612.6905517578125,
        -3356.220703125,
        1515.9840087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03878581523895264,
        -0.6718603372573853,
        -0.7396615743637085
      ],
      "plane_d": -1201.071044921875,
      "bbox_min": [
        -1614.8421630859375,
        -3363.457275390625,
        1515.0421142578125
      ],
      "bbox_max": [
        -1614.31640625,
        -3362.42041015625,
        1515.9840087890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11043132096529007,
        0.6464233994483948,
        0.7549448013305664
      ],
      "plane_d": 1207.5550537109375,
      "bbox_min": [
        -1620.040771484375,
        -3363.84375,
        1505.21630859375
      ],
      "bbox_max": [
        -1603.89453125,
        -3350.53466796875,
        1517.04638671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19495174288749695,
        0.5379989743232727,
        0.8200920820236206
      ],
      "plane_d": 255.1585693359375,
      "bbox_min": [
        -1606.28125,
        -3351.78564453125,
        1505.21630859375
      ],
      "bbox_max": [
        -1603.89453125,
        -3350.53466796875,
        1506.4364013671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1603.5,
      "bbox_min": [
        -1604.6611328125,
        -3356.677490234375,
        1499.8455810546875
      ],
      "bbox_max": [
        -1603.5,
        -3355.50048828125,
        1501.3812255859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.8571632504463196,
        0.5150449872016907
      ],
      "plane_d": -3650.208984375,
      "bbox_min": [
        -1604.6611328125,
        -3356.677490234375,
        1500.8173828125
      ],
      "bbox_max": [
        -1603.5,
        -3356.3388671875,
        1501.3812255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.994769275188446,
        -0.10214781016111374
      ],
      "plane_d": -3185.843017578125,
      "bbox_min": [
        -1606.979248046875,
        -3356.7021484375,
        1497.516845703125
      ],
      "bbox_max": [
        -1603.5,
        -3355.160888671875,
        1501.1392822265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.5150126814842224,
        -0.8571826815605164
      ],
      "plane_d": -444.304931640625,
      "bbox_min": [
        -1606.235107421875,
        -3356.7021484375,
        1497.516845703125
      ],
      "bbox_max": [
        -1603.5,
        -3355.160888671875,
        1501.1392822265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1603.4998779296875,
      "bbox_min": [
        -1604.6185302734375,
        -3356.7021484375,
        1498.993896484375
      ],
      "bbox_max": [
        -1603.5,
        -3355.753173828125,
        1501.1392822265625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.8571632504463196,
        0.5150449872016907
      ],
      "plane_d": -3650.208984375,
      "bbox_min": [
        -1604.6185302734375,
        -3356.7021484375,
        1500.7763671875
      ],
      "bbox_max": [
        -1603.5,
        -3356.484130859375,
        1501.1392822265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.994769275188446,
        -0.10214781016111374
      ],
      "plane_d": -3185.843017578125,
      "bbox_min": [
        -1606.894775390625,
        -3356.605712890625,
        1497.900146484375
      ],
      "bbox_max": [
        -1603.5,
        -3355.798828125,
        1499.8380126953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1603.4998779296875,
      "bbox_min": [
        -1603.5,
        -3356.605712890625,
        1498.5045166015625
      ],
      "bbox_max": [
        -1603.5,
        -3356.20751953125,
        1499.8380126953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1498.0,
      "bbox_min": [
        -1605.0360107421875,
        -3367.115478515625,
        1496.0
      ],
      "bbox_max": [
        -1598.784423828125,
        -3362.3515625,
        1498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6859917044639587,
        0.6859917044639587,
        0.24255064129829407
      ],
      "plane_d": 3041.446533203125,
      "bbox_min": [
        -1605.0360107421875,
        -3367.115478515625,
        1496.0
      ],
      "bbox_max": [
        -1598.784423828125,
        -3362.3515625,
        1498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.937079668045044,
        -0.2511158287525177,
        0.24253328144550323
      ],
      "plane_d": -2711.910400390625,
      "bbox_min": [
        -1605.0360107421875,
        -3367.115478515625,
        1496.0
      ],
      "bbox_max": [
        -1604.185791015625,
        -3365.11572265625,
        1498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4851193428039551,
        -0.8401665091514587,
        0.24244487285614014
      ],
      "plane_d": -3973.2109375,
      "bbox_min": [
        -1613.6324462890625,
        -3367.11572265625,
        1496.0
      ],
      "bbox_max": [
        -1610.5640869140625,
        -3364.2958984375,
        1498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4850834310054779,
        0.8401557803153992,
        0.2425534576177597
      ],
      "plane_d": 3245.61962890625,
      "bbox_min": [
        -1613.6324462890625,
        -3367.11572265625,
        1496.0
      ],
      "bbox_max": [
        -1610.5640869140625,
        -3364.2958984375,
        1498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9370861053466797,
        -0.25108692049980164,
        0.24253863096237183
      ],
      "plane_d": 301.4628601074219,
      "bbox_min": [
        -1613.6324462890625,
        -3367.11572265625,
        1496.0
      ],
      "bbox_max": [
        -1610.5640869140625,
        -3364.2958984375,
        1498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1498.0,
      "bbox_min": [
        -1613.6324462890625,
        -3366.35693359375,
        1498.0
      ],
      "bbox_max": [
        -1611.1463623046875,
        -3364.2958984375,
        1498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999086856842041,
        0.013512278907001019
      ],
      "plane_d": 3352.085693359375,
      "bbox_min": [
        -1631.9603271484375,
        -3382.0,
        1496.0
      ],
      "bbox_max": [
        -1552.108154296875,
        -3313.192626953125,
        1532.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999086856842041,
        0.0,
        0.013512278907001019
      ],
      "plane_d": -1574.96435546875,
      "bbox_min": [
        -1563.3309326171875,
        -3382.0,
        1496.0
      ],
      "bbox_max": [
        -1552.108154296875,
        -3372.608154296875,
        1532.0570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999086856842041,
        0.013512278907001019
      ],
      "plane_d": -3395.2978515625,
      "bbox_min": [
        -1554.891845703125,
        -3382.0,
        1496.0
      ],
      "bbox_max": [
        -1552.108154296875,
        -3375.0,
        1526.7484130859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.847313404083252,
        -0.03997046872973442,
        -0.5295870304107666
      ],
      "plane_d": 1990.376953125,
      "bbox_min": [
        -1554.5,
        -3382.0,
        1525.0
      ],
      "bbox_max": [
        -1552.5,
        -3375.0,
        1526.7484130859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3375.0,
      "bbox_min": [
        -1554.5,
        -3375.0,
        1525.0
      ],
      "bbox_max": [
        -1552.5,
        -3375.0,
        1526.60009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5300085544586182,
        6.930902600288391e-06,
        -0.8479923009872437
      ],
      "plane_d": 469.93865966796875,
      "bbox_min": [
        -1563.3309326171875,
        -3382.0,
        1525.0
      ],
      "bbox_max": [
        -1554.4794921875,
        -3373.0,
        1532.0570068359375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.847313404083252,
        0.039971448481082916,
        0.5295870304107666
      ],
      "plane_d": -2000.3814697265625,
      "bbox_min": [
        -1563.3309326171875,
        -3382.0,
        1525.731201171875
      ],
      "bbox_max": [
        -1554.4794921875,
        -3373.08251953125,
        1532.0570068359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.847313404083252,
        -0.03997046872973442,
        -0.5295870304107666
      ],
      "plane_d": 1990.376953125,
      "bbox_min": [
        -1554.83740234375,
        -3382.0,
        1525.731201171875
      ],
      "bbox_max": [
        -1554.4794921875,
        -3375.0,
        1526.5208740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3375.0,
      "bbox_min": [
        -1554.5999755859375,
        -3375.0,
        1525.731201171875
      ],
      "bbox_max": [
        -1554.48681640625,
        -3375.0,
        1525.98095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8479911088943481,
        0.0,
        0.5300105810165405
      ],
      "plane_d": -2136.97705078125,
      "bbox_min": [
        -1563.090576171875,
        -3374.60009765625,
        1531.0999755859375
      ],
      "bbox_max": [
        -1562.5797119140625,
        -3373.08251953125,
        1531.9066162109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.847313404083252,
        -0.039971448481082916,
        0.5295870304107666
      ],
      "plane_d": -2270.10888671875,
      "bbox_min": [
        -1563.090576171875,
        -3373.39990234375,
        1531.0999755859375
      ],
      "bbox_max": [
        -1562.5797119140625,
        -3373.08251953125,
        1531.9066162109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9922802448272705,
        -0.0,
        -0.12401609867811203
      ],
      "plane_d": -1353.3751220703125,
      "bbox_min": [
        -1554.5999755859375,
        -3375.0,
        1525.0
      ],
      "bbox_max": [
        -1554.4901123046875,
        -3373.0,
        1525.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999086856842041,
        0.013512278907001019
      ],
      "plane_d": -3354.8017578125,
      "bbox_min": [
        -1554.891845703125,
        -3373.0,
        1496.0
      ],
      "bbox_max": [
        -1552.108154296875,
        -3322.5078125,
        1526.834716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9999086856842041,
        0.013512278907001019
      ],
      "plane_d": 3311.589599609375,
      "bbox_min": [
        -1554.891845703125,
        -3332.5,
        1496.0
      ],
      "bbox_max": [
        -1552.108154296875,
        -3322.5078125,
        1526.834716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.847313404083252,
        0.03997046872973442,
        -0.5295870304107666
      ],
      "plane_d": 2258.478759765625,
      "bbox_min": [
        -1554.5,
        -3332.5,
        1525.0
      ],
      "bbox_max": [
        -1552.5,
        -3322.5078125,
        1526.834716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.033905185759067535,
        0.9992004632949829,
        0.021191386505961418
      ],
      "plane_d": 3234.79248046875,
      "bbox_min": [
        -1554.4764404296875,
        -3322.509521484375,
        1526.7518310546875
      ],
      "bbox_max": [
        -1554.4388427734375,
        -3322.5078125,
        1526.834716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 3332.499755859375,
      "bbox_min": [
        -1554.5,
        -3332.5,
        1525.0
      ],
      "bbox_max": [
        -1552.5,
        -3332.5,
        1526.60009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.847313404083252,
        0.03997046872973442,
        -0.5295870304107666
      ],
      "plane_d": 2260.09765625,
      "bbox_min": [
        -1554.5,
        -3373.0,
        1525.0
      ],
      "bbox_max": [
        -1552.5,
        -3334.5,
        1526.834716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.033905185759067535,
        0.9992004632949829,
        0.021191386505961418
      ],
      "plane_d": 3275.260009765625,
      "bbox_min": [
        -1554.4764404296875,
        -3363.009521484375,
        1526.7518310546875
      ],
      "bbox_max": [
        -1554.4388427734375,
        -3363.0078125,
        1526.834716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.847313404083252,
        -0.03997046872973442,
        -0.5295870304107666
      ],
      "plane_d": 1991.995849609375,
      "bbox_min": [
        -1554.5,
        -3373.0,
        1525.0
      ],
      "bbox_max": [
        -1552.5,
        -3334.5,
        1526.834716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.033905185759067535,
        -0.9992004632949829,
        0.021191386505961418
      ],
      "plane_d": -3426.876953125,
      "bbox_min": [
        -1554.4764404296875,
        -3344.4921875,
        1526.7518310546875
      ],
      "bbox_max": [
        -1554.4388427734375,
        -3344.490478515625,
        1526.834716796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 3372.999755859375,
      "bbox_min": [
        -1554.5,
        -3373.0,
        1525.0
      ],
      "bbox_max": [
        -1552.5,
        -3373.0,
        1526.60009765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1098410040140152,
        0.04768495261669159,
        -0.9928046464920044
      ],
      "plane_d": 1822.5477294921875,
      "bbox_min": [
        -1631.9603271484375,
        -3373.09326171875,
        1497.7818603515625
      ],
      "bbox_max": [
        -1554.475341796875,
        -3313.192626953125,
        1532.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10984069854021072,
        0.04768303781747818,
        -0.9928048253059387
      ],
      "plane_d": 1469.29345703125,
      "bbox_min": [
        -1631.9603271484375,
        -3373.09326171875,
        1497.7818603515625
      ],
      "bbox_max": [
        -1554.475341796875,
        -3313.192626953125,
        1532.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3127986788749695,
        -0.024374572560191154,
        -0.9495065808296204
      ],
      "plane_d": 1842.292724609375,
      "bbox_min": [
        -1631.9603271484375,
        -3373.09326171875,
        1497.7818603515625
      ],
      "bbox_max": [
        -1554.475341796875,
        -3313.192626953125,
        1532.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4681396782398224,
        -0.15752960741519928,
        -0.8694996237754822
      ],
      "plane_d": 1525.5126953125,
      "bbox_min": [
        -1631.9603271484375,
        -3373.09326171875,
        1497.7818603515625
      ],
      "bbox_max": [
        -1554.475341796875,
        -3313.192626953125,
        1532.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.46813642978668213,
        -0.6937713027000427,
        -0.5472930073738098
      ],
      "plane_d": -756.1793823242188,
      "bbox_min": [
        -1631.9603271484375,
        -3373.09326171875,
        1497.7818603515625
      ],
      "bbox_max": [
        -1554.475341796875,
        -3313.192626953125,
        1532.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31304019689559937,
        0.02393937297165394,
        0.9494381546974182
      ],
      "plane_d": -837.7777099609375,
      "bbox_min": [
        -1631.9603271484375,
        -3364.035400390625,
        1497.7818603515625
      ],
      "bbox_max": [
        -1554.475341796875,
        -3313.192626953125,
        1532.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46475666761398315,
        0.8784070014953613,
        0.11136633902788162
      ],
      "plane_d": 1991.68017578125,
      "bbox_min": [
        -1631.9603271484375,
        -3337.58447265625,
        1498.304931640625
      ],
      "bbox_max": [
        -1613.1063232421875,
        -3315.1142578125,
        1504.1553955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11042895913124084,
        -0.36310678720474243,
        -0.9251804947853088
      ],
      "plane_d": -2.5374755859375,
      "bbox_min": [
        -1621.5299072265625,
        -3337.58447265625,
        1498.304931640625
      ],
      "bbox_max": [
        -1613.1063232421875,
        -3315.1142578125,
        1500.5924072265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1631791740655899,
        0.9854603409767151,
        0.04733411967754364
      ],
      "plane_d": 2931.687255859375,
      "bbox_min": [
        -1621.5299072265625,
        -3315.50537109375,
        1499.872314453125
      ],
      "bbox_max": [
        -1619.269775390625,
        -3315.1142578125,
        1500.5924072265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1631791740655899,
        0.9854603409767151,
        0.04733411967754364
      ],
      "plane_d": 2931.687255859375,
      "bbox_min": [
        -1621.423583984375,
        -3335.050048828125,
        1497.7818603515625
      ],
      "bbox_max": [
        -1605.739501953125,
        -3313.192626953125,
        1500.5924072265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16319337487220764,
        0.985464334487915,
        0.04720210283994675
      ],
      "plane_d": 3456.70556640625,
      "bbox_min": [
        -1608.0,
        -3313.578125,
        1498.7177734375
      ],
      "bbox_max": [
        -1605.739501953125,
        -3313.192626953125,
        1499.21728515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16319337487220764,
        0.985464334487915,
        0.04720210283994675
      ],
      "plane_d": 3456.70556640625,
      "bbox_min": [
        -1608.0,
        -3335.0498046875,
        1498.0087890625
      ],
      "bbox_max": [
        -1592.5533447265625,
        -3313.216552734375,
        1500.7635498046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.46466103196144104,
        0.8784195780754089,
        0.11166514456272125
      ],
      "plane_d": 3485.7783203125,
      "bbox_min": [
        -1594.576416015625,
        -3316.597412109375,
        1500.1038818359375
      ],
      "bbox_max": [
        -1592.5533447265625,
        -3315.49951171875,
        1500.7635498046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.46466103196144104,
        0.8784195780754089,
        0.11166514456272125
      ],
      "plane_d": 3485.7783203125,
      "bbox_min": [
        -1601.15771484375,
        -3339.09375,
        1498.9150390625
      ],
      "bbox_max": [
        -1581.71923828125,
        -3315.50537109375,
        1505.0384521484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6955666542053223,
        0.6805611848831177,
        0.23026825487613678
      ],
      "plane_d": 3015.617919921875,
      "bbox_min": [
        -1583.1964111328125,
        -3323.7119140625,
        1504.0511474609375
      ],
      "bbox_max": [
        -1581.71923828125,
        -3322.02294921875,
        1505.0384521484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5522074103355408,
        -0.33149290084838867,
        -0.7649702429771423
      ],
      "plane_d": 920.4841918945312,
      "bbox_min": [
        -1595.3575439453125,
        -3344.703857421875,
        1500.9112548828125
      ],
      "bbox_max": [
        -1574.88623046875,
        -3322.02294921875,
        1511.123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6955666542053223,
        0.6805611848831177,
        0.23026825487613678
      ],
      "plane_d": 3015.617919921875,
      "bbox_min": [
        -1595.3575439453125,
        -3344.703857421875,
        1500.9112548828125
      ],
      "bbox_max": [
        -1574.88623046875,
        -3322.02294921875,
        1511.123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8204036355018616,
        0.4221179783344269,
        0.3856869637966156
      ],
      "plane_d": 2116.494873046875,
      "bbox_min": [
        -1575.592529296875,
        -3333.83837890625,
        1509.958740234375
      ],
      "bbox_max": [
        -1574.88623046875,
        -3331.777587890625,
        1511.123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6954729557037354,
        -0.11604724824428558,
        0.709119439125061
      ],
      "plane_d": -374.3699951171875,
      "bbox_min": [
        -1594.438232421875,
        -3364.035400390625,
        1510.2664794921875
      ],
      "bbox_max": [
        -1574.88623046875,
        -3353.15771484375,
        1529.52880859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16525734961032867,
        -0.5994216799736023,
        -0.7831881046295166
      ],
      "plane_d": -564.74462890625,
      "bbox_min": [
        -1594.438232421875,
        -3359.504638671875,
        1510.2664794921875
      ],
      "bbox_max": [
        -1574.88623046875,
        -3353.15771484375,
        1524.1971435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8203378319740295,
        0.14242930710315704,
        0.5538588166236877
      ],
      "plane_d": 926.1486206054688,
      "bbox_min": [
        -1575.592529296875,
        -3355.095458984375,
        1522.731201171875
      ],
      "bbox_max": [
        -1574.88623046875,
        -3353.15771484375,
        1524.1971435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.552614688873291,
        0.5197240114212036,
        0.65153968334198
      ],
      "plane_d": -120.20556640625,
      "bbox_min": [
        -1620.0406494140625,
        -3359.1630859375,
        1498.214111328125
      ],
      "bbox_max": [
        -1554.475341796875,
        -3322.5078125,
        1532.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8203378319740295,
        0.14242930710315704,
        0.5538588166236877
      ],
      "plane_d": 926.1486206054688,
      "bbox_min": [
        -1591.4815673828125,
        -3355.073974609375,
        1506.4949951171875
      ],
      "bbox_max": [
        -1555.046875,
        -3335.3037109375,
        1529.75439453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8204036355018616,
        0.4221179783344269,
        0.3856869637966156
      ],
      "plane_d": 2116.494873046875,
      "bbox_min": [
        -1573.0943603515625,
        -3343.498046875,
        1515.7626953125
      ],
      "bbox_max": [
        -1572.6446533203125,
        -3341.56005859375,
        1517.2835693359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5300085544586182,
        6.930902600288391e-06,
        -0.8479923009872437
      ],
      "plane_d": 469.93841552734375,
      "bbox_min": [
        -1559.8956298828125,
        -3344.29443359375,
        1526.0792236328125
      ],
      "bbox_max": [
        -1555.046875,
        -3335.3037109375,
        1529.75439453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.033905185759067535,
        -0.9992004632949829,
        0.021191386505961418
      ],
      "plane_d": -3426.876953125,
      "bbox_min": [
        -1559.8956298828125,
        -3344.29443359375,
        1528.78857421875
      ],
      "bbox_max": [
        -1558.63232421875,
        -3344.25830078125,
        1529.75439453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.552610456943512,
        0.33127740025520325,
        0.7647725343704224
      ],
      "plane_d": -922.0357055664062,
      "bbox_min": [
        -1620.0406494140625,
        -3359.1630859375,
        1498.214111328125
      ],
      "bbox_max": [
        -1554.475341796875,
        -3322.5078125,
        1532.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8204036355018616,
        0.4221179783344269,
        0.3856869637966156
      ],
      "plane_d": 2116.494873046875,
      "bbox_min": [
        -1591.4818115234375,
        -3349.208984375,
        1503.898681640625
      ],
      "bbox_max": [
        -1554.4874267578125,
        -3331.777587890625,
        1526.8370361328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19493964314460754,
        -0.47151145339012146,
        -0.8600438833236694
      ],
      "plane_d": 27.23681640625,
      "bbox_min": [
        -1591.4818115234375,
        -3349.208984375,
        1503.898681640625
      ],
      "bbox_max": [
        -1589.3067626953125,
        -3343.343994140625,
        1507.422607421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9922802448272705,
        -0.0,
        -0.12401609867811203
      ],
      "plane_d": -1353.3751220703125,
      "bbox_min": [
        -1556.2593994140625,
        -3337.54296875,
        1525.2376708984375
      ],
      "bbox_max": [
        -1554.4874267578125,
        -3332.39208984375,
        1526.8370361328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 3332.499755859375,
      "bbox_min": [
        -1554.6036376953125,
        -3332.5,
        1525.2376708984375
      ],
      "bbox_max": [
        -1554.4874267578125,
        -3332.39208984375,
        1525.9329833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.847313404083252,
        0.03997046872973442,
        -0.5295870304107666
      ],
      "plane_d": 2258.478759765625,
      "bbox_min": [
        -1554.6036376953125,
        -3332.5,
        1525.7999267578125
      ],
      "bbox_max": [
        -1554.541015625,
        -3332.39208984375,
        1525.8941650390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5300085544586182,
        6.930902600288391e-06,
        -0.8479923009872437
      ],
      "plane_d": 469.93841552734375,
      "bbox_min": [
        -1556.2593994140625,
        -3337.54296875,
        1525.7999267578125
      ],
      "bbox_max": [
        -1554.5999755859375,
        -3332.39208984375,
        1526.8370361328125
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.5300086140632629,
        -6.929040864633862e-06,
        -0.8479923605918884
      ],
      "plane_d": 469.8922119140625,
      "bbox_min": [
        -1620.0406494140625,
        -3359.1630859375,
        1498.214111328125
      ],
      "bbox_max": [
        -1554.475341796875,
        -3322.5078125,
        1532.1119384765625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.847313404083252,
        0.039971448481082916,
        0.5295870304107666
      ],
      "plane_d": -2002.0003662109375,
      "bbox_min": [
        -1563.4188232421875,
        -3344.270263671875,
        1525.80224609375
      ],
      "bbox_max": [
        -1554.4764404296875,
        -3322.5078125,
        1532.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.847313404083252,
        0.03997046872973442,
        -0.5295870304107666
      ],
      "plane_d": 2258.478759765625,
      "bbox_min": [
        -1563.4188232421875,
        -3344.270263671875,
        1525.80224609375
      ],
      "bbox_max": [
        -1554.4764404296875,
        -3322.5078125,
        1532.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.033905185759067535,
        -0.9992004632949829,
        0.021191386505961418
      ],
      "plane_d": -3426.876953125,
      "bbox_min": [
        -1563.4188232421875,
        -3344.270263671875,
        1529.1097412109375
      ],
      "bbox_max": [
        -1559.146728515625,
        -3344.092041015625,
        1532.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": 3332.499755859375,
      "bbox_min": [
        -1554.541015625,
        -3332.5,
        1525.8941650390625
      ],
      "bbox_max": [
        -1554.48681640625,
        -3332.5,
        1525.98095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8479911088943481,
        0.0,
        0.5300105810165405
      ],
      "plane_d": -2136.97705078125,
      "bbox_min": [
        -1563.079833984375,
        -3334.10009765625,
        1531.0999755859375
      ],
      "bbox_max": [
        -1562.5797119140625,
        -3332.89990234375,
        1531.900146484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0387689545750618,
        -0.3376634418964386,
        -0.9404682517051697
      ],
      "plane_d": 345.6328125,
      "bbox_min": [
        -1620.0406494140625,
        -3359.1630859375,
        1498.214111328125
      ],
      "bbox_max": [
        -1589.056884765625,
        -3332.60498046875,
        1514.23388671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0387689471244812,
        -0.3376634418964386,
        -0.9404681921005249
      ],
      "plane_d": 220.9517822265625,
      "bbox_min": [
        -1620.0406494140625,
        -3359.1630859375,
        1498.214111328125
      ],
      "bbox_max": [
        -1589.056884765625,
        -3332.60498046875,
        1514.23388671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11042895913124084,
        -0.36310678720474243,
        -0.9251804947853088
      ],
      "plane_d": -2.5374755859375,
      "bbox_min": [
        -1620.0406494140625,
        -3359.1630859375,
        1498.2762451171875
      ],
      "bbox_max": [
        -1589.056884765625,
        -3332.60498046875,
        1514.23388671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16525734961032867,
        -0.5994216799736023,
        -0.7831881046295166
      ],
      "plane_d": -564.74462890625,
      "bbox_min": [
        -1620.0406494140625,
        -3359.1630859375,
        1498.2762451171875
      ],
      "bbox_max": [
        -1589.056884765625,
        -3332.60498046875,
        1514.23388671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.16526997089385986,
        -0.4101146161556244,
        -0.8969346880912781
      ],
      "plane_d": 240.7689208984375,
      "bbox_min": [
        -1607.28076171875,
        -3350.78955078125,
        1499.0677490234375
      ],
      "bbox_max": [
        -1590.2244873046875,
        -3335.303955078125,
        1507.1903076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1601.199951171875,
      "bbox_min": [
        -1601.199951171875,
        -3350.343994140625,
        1504.178466796875
      ],
      "bbox_max": [
        -1601.199951171875,
        -3347.8720703125,
        1505.53369140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -2.001436587306671e-05,
        0.8571693301200867,
        -0.5150346159934998
      ],
      "plane_d": 3641.281982421875,
      "bbox_min": [
        -1604.058349609375,
        -3345.298583984375,
        1502.47509765625
      ],
      "bbox_max": [
        -1601.199951171875,
        -3345.05029296875,
        1502.88818359375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.11043811589479446,
        0.3631051182746887,
        0.9251800775527954
      ],
      "plane_d": -353.111572265625,
      "bbox_min": [
        -1620.0406494140625,
        -3359.1630859375,
        1498.2762451171875
      ],
      "bbox_max": [
        -1589.056884765625,
        -3332.60498046875,
        1514.23388671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19495093822479248,
        0.4715180993080139,
        0.8600376844406128
      ],
      "plane_d": -27.7132568359375,
      "bbox_min": [
        -1620.0406494140625,
        -3359.1630859375,
        1498.2762451171875
      ],
      "bbox_max": [
        -1589.056884765625,
        -3332.60498046875,
        1514.23388671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19493964314460754,
        -0.47151145339012146,
        -0.8600438833236694
      ],
      "plane_d": 27.23681640625,
      "bbox_min": [
        -1591.483154296875,
        -3349.3486328125,
        1507.1541748046875
      ],
      "bbox_max": [
        -1590.120849609375,
        -3348.76220703125,
        1507.422607421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19495174288749695,
        0.5379989743232727,
        0.8200920820236206
      ],
      "plane_d": 255.1585693359375,
      "bbox_min": [
        -1620.0406494140625,
        -3359.1630859375,
        1499.0189208984375
      ],
      "bbox_max": [
        -1589.056884765625,
        -3333.841064453125,
        1514.23388671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11043810844421387,
        0.3631051480770111,
        0.9251800775527954
      ],
      "plane_d": 2.0574951171875,
      "bbox_min": [
        -1620.0406494140625,
        -3359.1630859375,
        1499.0189208984375
      ],
      "bbox_max": [
        -1590.4989013671875,
        -3333.841064453125,
        1514.23388671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1652749925851822,
        0.599412739276886,
        0.7831913232803345
      ],
      "plane_d": 564.19140625,
      "bbox_min": [
        -1603.89453125,
        -3359.1630859375,
        1506.4364013671875
      ],
      "bbox_max": [
        -1590.4989013671875,
        -3351.78564453125,
        1514.23388671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1601.199951171875,
      "bbox_min": [
        -1601.199951171875,
        -3354.027587890625,
        1507.0799560546875
      ],
      "bbox_max": [
        -1601.199951171875,
        -3352.700927734375,
        1508.05322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1601.199951171875,
      "bbox_min": [
        -1601.199951171875,
        -3355.0244140625,
        1503.0391845703125
      ],
      "bbox_max": [
        -1601.199951171875,
        -3346.54150390625,
        1507.9503173828125
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        2.0511450202320702e-05,
        0.8571717143058777,
        -0.5150308609008789
      ],
      "plane_d": 3641.349365234375,
      "bbox_min": [
        -1611.4954833984375,
        -3345.3291015625,
        1502.42431640625
      ],
      "bbox_max": [
        -1610.4439697265625,
        -3345.26806640625,
        1502.52587890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        2.2035160327504855e-06,
        0.8571872711181641,
        -0.5150048136711121
      ],
      "plane_d": 3641.3330078125,
      "bbox_min": [
        -1611.4915771484375,
        -3345.44970703125,
        1502.2236328125
      ],
      "bbox_max": [
        -1608.0,
        -3345.3076171875,
        1502.4598388671875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.8571904897689819,
        -0.5149994492530823
      ],
      "plane_d": 3641.33203125,
      "bbox_min": [
        -1611.4776611328125,
        -3355.219970703125,
        1500.478271484375
      ],
      "bbox_max": [
        -1601.199951171875,
        -3345.240234375,
        1506.0848388671875
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.5300085544586182,
        6.930902600288391e-06,
        -0.8479923009872437
      ],
      "plane_d": 469.93841552734375,
      "bbox_min": [
        -1555.820556640625,
        -3337.708251953125,
        1525.0
      ],
      "bbox_max": [
        -1554.485595703125,
        -3332.5,
        1526.562744140625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.847313404083252,
        -0.03997046872973442,
        -0.5295870304107666
      ],
      "plane_d": 1991.995849609375,
      "bbox_min": [
        -1554.634521484375,
        -3335.674072265625,
        1525.731201171875
      ],
      "bbox_max": [
        -1554.485595703125,
        -3334.5,
        1526.071533203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3334.5,
      "bbox_min": [
        -1554.5999755859375,
        -3334.5,
        1525.731201171875
      ],
      "bbox_max": [
        -1554.48681640625,
        -3334.5,
        1525.98095703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9922802448272705,
        -0.0,
        -0.12401609867811203
      ],
      "plane_d": -1353.3751220703125,
      "bbox_min": [
        -1554.5999755859375,
        -3334.5,
        1525.0
      ],
      "bbox_max": [
        -1554.4901123046875,
        -3332.5,
        1525.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3334.5,
      "bbox_min": [
        -1554.5999755859375,
        -3334.5,
        1525.111328125
      ],
      "bbox_max": [
        -1554.4901123046875,
        -3334.5,
        1525.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.847313404083252,
        -0.03997046872973442,
        -0.5295870304107666
      ],
      "plane_d": 1991.995849609375,
      "bbox_min": [
        -1559.3818359375,
        -3344.44580078125,
        1525.821533203125
      ],
      "bbox_max": [
        -1554.477783203125,
        -3335.518798828125,
        1529.432861328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.033905185759067535,
        -0.9992004632949829,
        0.021191386505961418
      ],
      "plane_d": -3426.876953125,
      "bbox_min": [
        -1559.3818359375,
        -3344.44580078125,
        1526.778564453125
      ],
      "bbox_max": [
        -1555.4239501953125,
        -3344.282470703125,
        1529.432861328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9922802448272705,
        -0.0,
        -0.12401609867811203
      ],
      "plane_d": -1353.3751220703125,
      "bbox_min": [
        -1554.513916015625,
        -3334.5,
        1525.0
      ],
      "bbox_max": [
        -1554.498291015625,
        -3334.345703125,
        1525.12451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -3334.5,
      "bbox_min": [
        -1554.513916015625,
        -3334.5,
        1525.0
      ],
      "bbox_max": [
        -1554.498291015625,
        -3334.5,
        1525.12451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5300086140632629,
        -6.929040864633862e-06,
        -0.8479923605918884
      ],
      "plane_d": 469.89190673828125,
      "bbox_min": [
        -1563.4188232421875,
        -3373.09326171875,
        1525.978759765625
      ],
      "bbox_max": [
        -1554.475341796875,
        -3342.93994140625,
        1532.1119384765625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.033905185759067535,
        0.9992004632949829,
        0.021191386505961418
      ],
      "plane_d": 3275.260009765625,
      "bbox_min": [
        -1563.4188232421875,
        -3373.09326171875,
        1525.978759765625
      ],
      "bbox_max": [
        -1554.475341796875,
        -3342.93994140625,
        1532.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.847313404083252,
        -0.039971448481082916,
        0.5295870304107666
      ],
      "plane_d": -2270.10888671875,
      "bbox_min": [
        -1563.4188232421875,
        -3373.09326171875,
        1531.106689453125
      ],
      "bbox_max": [
        -1562.590087890625,
        -3363.407958984375,
        1532.1119384765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.847313404083252,
        -0.03997046872973442,
        -0.5295870304107666
      ],
      "plane_d": 1991.995849609375,
      "bbox_min": [
        -1556.1658935546875,
        -3344.4921875,
        1525.978759765625
      ],
      "bbox_max": [
        -1554.475341796875,
        -3342.93994140625,
        1527.4276123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.033905185759067535,
        -0.9992004632949829,
        0.021191386505961418
      ],
      "plane_d": -3426.876953125,
      "bbox_min": [
        -1556.1658935546875,
        -3344.4921875,
        1526.01171875
      ],
      "bbox_max": [
        -1554.475341796875,
        -3344.434326171875,
        1527.4276123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.847313404083252,
        0.03997046872973442,
        -0.5295870304107666
      ],
      "plane_d": 2260.09765625,
      "bbox_min": [
        -1556.98486328125,
        -3373.031005859375,
        1525.0
      ],
      "bbox_max": [
        -1554.4754638671875,
        -3363.0078125,
        1527.29052734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9922802448272705,
        -0.0,
        -0.12401609867811203
      ],
      "plane_d": -1353.3751220703125,
      "bbox_min": [
        -1554.5999755859375,
        -3373.0107421875,
        1525.0
      ],
      "bbox_max": [
        -1554.5,
        -3373.0,
        1525.7999267578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4850834310054779,
        -0.8401557803153992,
        0.2425534576177597
      ],
      "plane_d": -3951.32421875,
      "bbox_min": [
        -1612.9140625,
        -3358.10009765625,
        1496.0
      ],
      "bbox_max": [
        -1595.4844970703125,
        -3342.484375,
        1504.5340576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1498.0,
      "bbox_min": [
        -1605.0360107421875,
        -3347.24853515625,
        1496.0
      ],
      "bbox_max": [
        -1598.784423828125,
        -3342.484375,
        1498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.68598473072052,
        -0.68598473072052,
        0.2425900548696518
      ],
      "plane_d": -1561.330078125,
      "bbox_min": [
        -1605.0360107421875,
        -3347.24853515625,
        1496.0
      ],
      "bbox_max": [
        -1598.784423828125,
        -3342.484375,
        1498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9370861053466797,
        0.25108692049980164,
        0.24253863096237183
      ],
      "plane_d": -1027.138427734375,
      "bbox_min": [
        -1605.0360107421875,
        -3344.484375,
        1496.0
      ],
      "bbox_max": [
        -1604.185791015625,
        -3342.484375,
        1498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -1602.0,
      "bbox_min": [
        -1612.9140625,
        -3358.10009765625,
        1496.0
      ],
      "bbox_max": [
        -1595.4844970703125,
        -3343.034423828125,
        1504.5340576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 1599.5,
      "bbox_min": [
        -1602.0,
        -3358.10009765625,
        1496.0
      ],
      "bbox_max": [
        -1595.4844970703125,
        -3351.5,
        1500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.936329185962677,
        0.3511234521865845
      ],
      "plane_d": -3669.47412109375,
      "bbox_min": [
        -1602.0,
        -3358.0,
        1496.0
      ],
      "bbox_max": [
        -1599.5,
        -3351.5,
        1500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.936329185962677,
        0.3511234521865845
      ],
      "plane_d": 2612.826416015625,
      "bbox_min": [
        -1602.0,
        -3356.5,
        1496.0
      ],
      "bbox_max": [
        -1599.5,
        -3351.5,
        1500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1500.0,
      "bbox_min": [
        -1602.0,
        -3356.5,
        1500.0
      ],
      "bbox_max": [
        -1599.5,
        -3353.0,
        1500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9701425433158875,
        0.0,
        0.24253563582897186
      ],
      "plane_d": -1912.62109375,
      "bbox_min": [
        -1597.4844970703125,
        -3358.10009765625,
        1496.0
      ],
      "bbox_max": [
        -1595.4844970703125,
        -3351.5,
        1498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1498.0,
      "bbox_min": [
        -1597.4844970703125,
        -3358.10009765625,
        1496.0
      ],
      "bbox_max": [
        -1595.4844970703125,
        -3351.5,
        1498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2511959671974182,
        -0.9370661973953247,
        0.24250248074531555
      ],
      "plane_d": -3910.3251953125,
      "bbox_min": [
        -1597.4844970703125,
        -3358.10009765625,
        1496.0
      ],
      "bbox_max": [
        -1595.4844970703125,
        -3351.5,
        1498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2511889934539795,
        0.9370402097702026,
        0.2426101565361023
      ],
      "plane_d": 2376.77734375,
      "bbox_min": [
        -1597.4844970703125,
        -3352.419677734375,
        1496.0
      ],
      "bbox_max": [
        -1595.4844970703125,
        -3351.5,
        1498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1603.5,
      "bbox_min": [
        -1612.9140625,
        -3356.46875,
        1497.0018310546875
      ],
      "bbox_max": [
        -1602.0,
        -3343.034423828125,
        1504.5340576171875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.8571696281433105,
        -0.5150341987609863
      ],
      "plane_d": 3644.71435546875,
      "bbox_min": [
        -1612.9140625,
        -3356.46875,
        1497.0018310546875
      ],
      "bbox_max": [
        -1603.5,
        -3343.034423828125,
        1502.2294921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.3766965866088867,
        -0.9263367056846619
      ],
      "plane_d": 2650.282470703125,
      "bbox_min": [
        -1607.722900390625,
        -3356.46875,
        1497.0018310546875
      ],
      "bbox_max": [
        -1603.5,
        -3351.98779296875,
        1498.5045166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.5150126814842224,
        -0.8571826815605164
      ],
      "plane_d": -444.304931640625,
      "bbox_min": [
        -1606.121337890625,
        -3356.46875,
        1497.0018310546875
      ],
      "bbox_max": [
        -1603.5,
        -3354.3037109375,
        1498.5045166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.994769275188446,
        -0.10214781016111374
      ],
      "plane_d": -3185.843017578125,
      "bbox_min": [
        -1603.6209716796875,
        -3356.46875,
        1498.2894287109375
      ],
      "bbox_max": [
        -1603.5,
        -3356.44677734375,
        1498.5045166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1497.9998779296875,
      "bbox_min": [
        -1612.9140625,
        -3345.214111328125,
        1497.3619384765625
      ],
      "bbox_max": [
        -1610.9605712890625,
        -3343.034423828125,
        1498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48507875204086304,
        -0.8401477336883545,
        0.24259112775325775
      ],
      "plane_d": -2391.52685546875,
      "bbox_min": [
        -1612.9140625,
        -3345.214111328125,
        1497.3619384765625
      ],
      "bbox_max": [
        -1610.9605712890625,
        -3343.034423828125,
        1498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48509156703948975,
        0.8401626944541931,
        0.24251346290111542
      ],
      "plane_d": 1663.8994140625,
      "bbox_min": [
        -1612.9140625,
        -3344.320068359375,
        1497.3619384765625
      ],
      "bbox_max": [
        -1610.9605712890625,
        -3343.034423828125,
        1498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9370861053466797,
        0.25108692049980164,
        0.24253863096237183
      ],
      "plane_d": 1986.1556396484375,
      "bbox_min": [
        -1611.414306640625,
        -3344.320068359375,
        1497.3619384765625
      ],
      "bbox_max": [
        -1610.9605712890625,
        -3343.034423828125,
        1498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1498.0,
      "bbox_min": [
        -1603.5,
        -3355.60009765625,
        1498.0
      ],
      "bbox_max": [
        -1602.0,
        -3354.0,
        1499.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1499.5,
      "bbox_min": [
        -1603.5,
        -3355.60009765625,
        1498.0
      ],
      "bbox_max": [
        -1602.0,
        -3354.0,
        1499.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -3355.60009765625,
      "bbox_min": [
        -1603.5,
        -3355.60009765625,
        1498.0
      ],
      "bbox_max": [
        -1602.0,
        -3354.0,
        1499.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 3354.0,
      "bbox_min": [
        -1603.5,
        -3354.0,
        1498.0
      ],
      "bbox_max": [
        -1602.0,
        -3354.0,
        1499.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.48509156703948975,
        0.8401626944541931,
        0.24251346290111542
      ],
      "plane_d": 1663.8994140625,
      "bbox_min": [
        -1615.029296875,
        -3346.282470703125,
        1496.0
      ],
      "bbox_max": [
        -1610.5640869140625,
        -3342.484375,
        1498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48507875204086304,
        -0.8401477336883545,
        0.24259112775325775
      ],
      "plane_d": -2391.52685546875,
      "bbox_min": [
        -1614.0667724609375,
        -3346.282470703125,
        1496.0
      ],
      "bbox_max": [
        -1610.5640869140625,
        -3342.484375,
        1498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9370861053466797,
        0.25108692049980164,
        0.24253863096237183
      ],
      "plane_d": 1986.1556396484375,
      "bbox_min": [
        -1614.0667724609375,
        -3345.539306640625,
        1496.0
      ],
      "bbox_max": [
        -1610.5640869140625,
        -3342.484375,
        1498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1497.9998779296875,
      "bbox_min": [
        -1614.0667724609375,
        -3345.539306640625,
        1498.0
      ],
      "bbox_max": [
        -1612.828125,
        -3344.109130859375,
        1498.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1302.5999755859375,
      "bbox_min": [
        -4035.11669921875,
        -5265.7685546875,
        540.0
      ],
      "bbox_max": [
        -1760.0,
        -2700.0,
        1760.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1052.5999755859375,
      "bbox_min": [
        -3280.0,
        -5065.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2460.0,
        -3283.287109375,
        1302.5999755859375
      ],
      "face_count": 17
    },
    {
      "plane_normal": [
        0.0,
        0.9805806875228882,
        0.1961161345243454
      ],
      "plane_d": 4617.79833984375,
      "bbox_min": [
        -3280.0,
        -5065.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2460.0,
        -3283.287109375,
        1302.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9805806875228882,
        0.1961161345243454
      ],
      "plane_d": 4711.93408203125,
      "bbox_min": [
        -3280.0,
        -5065.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2908.47216796875,
        -4919.7685546875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6102267503738403,
        0.7675688862800598,
        0.19611582159996033
      ],
      "plane_d": 5575.14697265625,
      "bbox_min": [
        -3280.0,
        -5065.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2908.47216796875,
        -4919.7685546875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6102268099784851,
        0.7675688862800598,
        0.1961151361465454
      ],
      "plane_d": 1791.7420654296875,
      "bbox_min": [
        -3280.0,
        -5065.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2908.47216796875,
        -4919.7685546875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7123335599899292,
        0.6738840341567993,
        0.19611519575119019
      ],
      "plane_d": 1021.7857055664062,
      "bbox_min": [
        -3280.0,
        -5008.603515625,
        1052.5999755859375
      ],
      "bbox_max": [
        -2908.47216796875,
        -4919.7685546875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.712333619594574,
        0.6738840937614441,
        0.19611524045467377
      ],
      "plane_d": 5438.25390625,
      "bbox_min": [
        -3280.0,
        -5008.603515625,
        1052.5999755859375
      ],
      "bbox_max": [
        -3054.07763671875,
        -4919.7685546875,
        1302.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4965.7685546875,
      "bbox_min": [
        -3175.552978515625,
        -4965.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3054.07763671875,
        -4919.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8406816720962524,
        0.5415297150611877,
        0.0
      ],
      "plane_d": 5333.830078125,
      "bbox_min": [
        -3175.552978515625,
        -4965.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3145.921875,
        -4919.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.00018243707017973065,
        1.0,
        0.0
      ],
      "plane_d": 4247.14404296875,
      "bbox_min": [
        -3280.0,
        -4952.2685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2460.0,
        -3283.287109375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1101.623779296875,
      "bbox_min": [
        -3280.0,
        -4952.2685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2460.0,
        -4247.6279296875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.007462478708475828,
        0.9999721646308899,
        0.0
      ],
      "plane_d": 4588.44677734375,
      "bbox_min": [
        -3219.999755859375,
        -4929.5732421875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2460.0,
        -4247.6279296875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9230950474739075,
        0.0,
        0.3845720887184143
      ],
      "plane_d": 2041.401123046875,
      "bbox_min": [
        -3219.999755859375,
        -4929.5732421875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2649.999755859375,
        -4609.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2799.999755859375,
      "bbox_min": [
        -3219.999755859375,
        -4929.5732421875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2649.999755859375,
        -4609.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6298324465751648,
        0.776731014251709,
        0.0
      ],
      "plane_d": 5581.65966796875,
      "bbox_min": [
        -3219.999755859375,
        -4929.5732421875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2799.999755859375,
        -4609.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314704895019531,
        -0.5555691123008728,
        0.0
      ],
      "plane_d": -17.6025390625,
      "bbox_min": [
        -3219.999755859375,
        -4929.5732421875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3119.999755859375,
        -4679.7998046875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3119.999755859375,
      "bbox_min": [
        -3119.999755859375,
        -4701.10791015625,
        1052.5999755859375
      ],
      "bbox_max": [
        -3119.999755859375,
        -4679.7998046875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3119.999755859375,
      "bbox_min": [
        -3119.999755859375,
        -4730.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3119.999755859375,
        -4701.10791015625,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8064050674438477,
        0.5913636684417725
      ],
      "plane_d": 3077.1162109375,
      "bbox_min": [
        -2839.999755859375,
        -4623.70166015625,
        1082.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4609.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4609.7685546875,
      "bbox_min": [
        -2749.999755859375,
        -4609.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2649.999755859375,
        -4609.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0003918238799087703,
        -0.0
      ],
      "plane_d": 3071.875244140625,
      "bbox_min": [
        -3070.18798828125,
        -4611.48583984375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2596.999755859375,
        -4247.6279296875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.700103759765625,
        0.0,
        0.7140412330627441
      ],
      "plane_d": 1362.783935546875,
      "bbox_min": [
        -3070.10009765625,
        -4611.48583984375,
        1101.5926513671875
      ],
      "bbox_max": [
        -3070.068359375,
        -4529.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4319.7685546875,
      "bbox_min": [
        -3070.100341796875,
        -4611.48583984375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2596.999755859375,
        -4247.6279296875,
        1101.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1092.623779296875,
      "bbox_min": [
        -3070.100341796875,
        -4611.48583984375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2596.999755859375,
        -4319.7685546875,
        1101.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 2739.999755859375,
      "bbox_min": [
        -3070.100341796875,
        -4611.41748046875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2596.999755859375,
        -4319.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.700103759765625,
        0.0,
        0.7140412330627441
      ],
      "plane_d": 1362.783935546875,
      "bbox_min": [
        -3070.100341796875,
        -4611.41748046875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2749.999755859375,
        -4441.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4529.7685546875,
      "bbox_min": [
        -3070.100341796875,
        -4529.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3020.100341796875,
        -4529.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4559.7685546875,
      "bbox_min": [
        -2909.999755859375,
        -4559.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2749.999755859375,
        -4441.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2909.999755859375,
      "bbox_min": [
        -2909.999755859375,
        -4529.7685546875,
        1081.623779296875
      ],
      "bbox_max": [
        -2884.999755859375,
        -4441.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2884.999755859375,
      "bbox_min": [
        -2909.999755859375,
        -4529.7685546875,
        1081.623779296875
      ],
      "bbox_max": [
        -2884.999755859375,
        -4499.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4499.7685546875,
      "bbox_min": [
        -2909.999755859375,
        -4499.7685546875,
        1081.623779296875
      ],
      "bbox_max": [
        -2884.999755859375,
        -4499.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 2596.999755859375,
      "bbox_min": [
        -2655.0,
        -4529.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2596.999755859375,
        -4319.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        4.606426955433562e-06,
        6.0998854678473435e-06
      ],
      "plane_d": 2655.013427734375,
      "bbox_min": [
        -2655.0,
        -4404.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2596.999755859375,
        -4319.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4404.7685546875,
      "bbox_min": [
        -2639.999755859375,
        -4404.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2596.999755859375,
        -4404.7685546875,
        1092.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4559.7685546875,
      "bbox_min": [
        -3070.10009765625,
        -4611.48583984375,
        1092.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4319.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.700103759765625,
        0.0,
        0.7140412330627441
      ],
      "plane_d": 1362.783935546875,
      "bbox_min": [
        -3070.08837890625,
        -4611.48583984375,
        1092.623779296875
      ],
      "bbox_max": [
        -3060.9208984375,
        -4559.7685546875,
        1101.6123046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2909.999755859375,
      "bbox_min": [
        -3070.10009765625,
        -4559.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4319.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.700103759765625,
        0.0,
        0.7140412330627441
      ],
      "plane_d": 1362.783935546875,
      "bbox_min": [
        -3070.10009765625,
        -4559.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -3060.9208984375,
        -4529.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4529.7685546875,
      "bbox_min": [
        -3070.10009765625,
        -4529.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -3060.9208984375,
        -4529.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        3.2572361305938102e-06,
        0.7071068286895752
      ],
      "plane_d": 1104.781005859375,
      "bbox_min": [
        -2909.999755859375,
        -4529.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2654.999755859375,
        -4319.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4529.7685546875,
      "bbox_min": [
        -2909.999755859375,
        -4529.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2759.999755859375,
        -4469.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2759.999755859375,
      "bbox_min": [
        -2909.999755859375,
        -4529.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2759.999755859375,
        -4469.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2884.999755859375,
      "bbox_min": [
        -2909.999755859375,
        -4529.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2759.999755859375,
        -4469.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4499.7685546875,
      "bbox_min": [
        -2909.999755859375,
        -4499.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2884.999755859375,
        -4499.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4469.7685546875,
      "bbox_min": [
        -2769.999755859375,
        -4469.7685546875,
        1092.623779296875
      ],
      "bbox_max": [
        -2759.999755859375,
        -4469.7685546875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8651316165924072,
        -0.5015451312065125,
        0.0
      ],
      "plane_d": 165.22314453125,
      "bbox_min": [
        -2687.4853515625,
        -4306.30322265625,
        1052.5999755859375
      ],
      "bbox_max": [
        -2653.469482421875,
        -4247.6279296875,
        1101.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9230950474739075,
        0.0,
        0.3845720887184143
      ],
      "plane_d": 2041.401123046875,
      "bbox_min": [
        -3280.0,
        -4952.2685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -2663.999755859375,
        -4293.56640625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1232.623779296875,
      "bbox_min": [
        -3280.0,
        -4952.2685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -2670.423583984375,
        -4293.56640625,
        1302.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 2799.999755859375,
      "bbox_min": [
        -3280.0,
        -4939.7734375,
        1101.623779296875
      ],
      "bbox_max": [
        -2670.423583984375,
        -4293.56640625,
        1232.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9734168648719788,
        0.0016828934894874692,
        0.22903460264205933
      ],
      "plane_d": 2789.064697265625,
      "bbox_min": [
        -3280.0,
        -4939.7734375,
        1101.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4293.56640625,
        1232.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9734182953834534,
        0.0,
        0.22903494536876678
      ],
      "plane_d": 2781.445556640625,
      "bbox_min": [
        -3280.0,
        -4939.7734375,
        1101.623779296875
      ],
      "bbox_max": [
        -3116.6005859375,
        -4529.7685546875,
        1232.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314704895019531,
        -0.5555691123008728,
        0.0
      ],
      "plane_d": -17.6025390625,
      "bbox_min": [
        -3280.0,
        -4939.7734375,
        1101.623779296875
      ],
      "bbox_max": [
        -3119.999755859375,
        -4679.7998046875,
        1232.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9395509958267212,
        0.0,
        -0.3424091041088104
      ],
      "plane_d": 3458.78271484375,
      "bbox_min": [
        -3280.0,
        -4919.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -3119.999755859375,
        -4679.7998046875,
        1232.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01227299403399229,
        0.9982650876045227,
        0.05758681520819664
      ],
      "plane_d": 4736.61279296875,
      "bbox_min": [
        -3280.0,
        -4856.21337890625,
        1188.0367431640625
      ],
      "bbox_max": [
        -3249.981689453125,
        -4853.7041015625,
        1232.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3119.999755859375,
      "bbox_min": [
        -3119.999755859375,
        -4701.10791015625,
        1101.623779296875
      ],
      "bbox_max": [
        -3119.999755859375,
        -4679.7998046875,
        1116.07177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3119.999755859375,
      "bbox_min": [
        -3119.999755859375,
        -4730.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -3119.999755859375,
        -4701.10791015625,
        1116.07177734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3119.999755859375,
      "bbox_min": [
        -3119.999755859375,
        -4730.7685546875,
        1116.07177734375
      ],
      "bbox_max": [
        -3119.999755859375,
        -4679.7998046875,
        1117.547119140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9755594730377197,
        -0.00016128552670124918,
        0.21973522007465363
      ],
      "plane_d": 2798.13330078125,
      "bbox_min": [
        -3128.600341796875,
        -4919.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4295.22607421875,
        1232.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0003918238799087703,
        -0.0
      ],
      "plane_d": 3071.875244140625,
      "bbox_min": [
        -3119.999755859375,
        -4919.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4306.080078125,
        1232.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        4.787071247847052e-06
      ],
      "plane_d": 3070.0947265625,
      "bbox_min": [
        -3119.999755859375,
        -4730.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -3070.03759765625,
        -4529.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.980980634689331,
        -0.19410614669322968,
        0.0
      ],
      "plane_d": 2113.042236328125,
      "bbox_min": [
        -3119.999755859375,
        -4730.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -3070.10009765625,
        -4629.7685546875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 3119.999755859375,
      "bbox_min": [
        -3119.999755859375,
        -4730.7685546875,
        1117.171875
      ],
      "bbox_max": [
        -3119.999755859375,
        -4679.7998046875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7012491822242737,
        0.7129162549972534,
        0.0
      ],
      "plane_d": 5496.15234375,
      "bbox_min": [
        -3079.999755859375,
        -4689.537109375,
        1101.623779296875
      ],
      "bbox_max": [
        -3070.10009765625,
        -4679.7998046875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7012491822242737,
        0.7129162549972534,
        0.0
      ],
      "plane_d": 5496.15234375,
      "bbox_min": [
        -3070.100341796875,
        -4689.5986328125,
        1101.623779296875
      ],
      "bbox_max": [
        -3070.03759765625,
        -4689.537109375,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6298324465751648,
        0.776731014251709,
        0.0
      ],
      "plane_d": 5581.65966796875,
      "bbox_min": [
        -3070.03759765625,
        -4919.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4319.7685546875,
        1232.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8958584070205688,
        0.0,
        0.44433945417404175
      ],
      "plane_d": 2067.916015625,
      "bbox_min": [
        -2964.228515625,
        -4919.7685546875,
        1152.623779296875
      ],
      "bbox_max": [
        -2879.999755859375,
        -4850.7685546875,
        1232.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.9983217716217041,
        0.05791091546416283
      ],
      "plane_d": 4775.87841796875,
      "bbox_min": [
        -2964.228515625,
        -4855.55908203125,
        1152.623779296875
      ],
      "bbox_max": [
        -2879.999755859375,
        -4850.7685546875,
        1232.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.006341905798763037,
        0.997999370098114,
        0.06290493160486221
      ],
      "plane_d": 4786.82275390625,
      "bbox_min": [
        -2943.232666015625,
        -4855.55908203125,
        1152.623779296875
      ],
      "bbox_max": [
        -2879.999755859375,
        -4850.7685546875,
        1232.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8064050674438477,
        0.5913636684417725
      ],
      "plane_d": 3077.1162109375,
      "bbox_min": [
        -3070.03759765625,
        -4729.86767578125,
        1101.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4319.7685546875,
        1232.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7012491822242737,
        0.7129162549972534,
        0.0
      ],
      "plane_d": 5496.15234375,
      "bbox_min": [
        -3070.03759765625,
        -4729.86767578125,
        1101.623779296875
      ],
      "bbox_max": [
        -3029.098876953125,
        -4689.5986328125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1122.623779296875,
      "bbox_min": [
        -2909.999755859375,
        -4559.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4319.7685546875,
        1122.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4319.7685546875,
      "bbox_min": [
        -2909.999755859375,
        -4559.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4319.7685546875,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4529.7685546875,
      "bbox_min": [
        -2909.999755859375,
        -4559.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4499.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4559.7685546875,
      "bbox_min": [
        -2839.999755859375,
        -4559.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4559.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2884.999755859375,
      "bbox_min": [
        -2909.999755859375,
        -4529.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -2884.999755859375,
        -4499.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 4499.7685546875,
      "bbox_min": [
        -2909.999755859375,
        -4499.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -2884.999755859375,
        -4499.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1122.623779296875,
      "bbox_min": [
        -2799.999755859375,
        -4609.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -2670.423583984375,
        -4293.92236328125,
        1232.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8944272398948669,
        0.0,
        0.44721361994743347
      ],
      "plane_d": 1971.0384521484375,
      "bbox_min": [
        -2799.999755859375,
        -4609.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -2670.423583984375,
        -4293.92236328125,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4319.7685546875,
      "bbox_min": [
        -2799.999755859375,
        -4559.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -2754.49951171875,
        -4319.7685546875,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4559.7685546875,
      "bbox_min": [
        -2799.999755859375,
        -4559.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -2754.49951171875,
        -4469.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 2759.999755859375,
      "bbox_min": [
        -2769.999755859375,
        -4509.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -2759.999755859375,
        -4469.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 4469.7685546875,
      "bbox_min": [
        -2769.999755859375,
        -4469.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -2759.999755859375,
        -4469.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4609.7685546875,
      "bbox_min": [
        -2764.999755859375,
        -4609.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -2670.423583984375,
        -4293.92236328125,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4319.7685546875,
      "bbox_min": [
        -2764.999755859375,
        -4559.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -2670.423583984375,
        -4293.92236328125,
        1122.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        3.2572361305938102e-06,
        0.7071068286895752
      ],
      "plane_d": 1104.781005859375,
      "bbox_min": [
        -2759.999755859375,
        -4559.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -2675.010986328125,
        -4319.7685546875,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4559.7685546875,
      "bbox_min": [
        -2759.999755859375,
        -4559.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -2749.999755859375,
        -4559.7685546875,
        1112.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8651316165924072,
        -0.5015451312065125,
        0.0
      ],
      "plane_d": 165.22314453125,
      "bbox_min": [
        -2687.4853515625,
        -4306.30322265625,
        1101.623779296875
      ],
      "bbox_max": [
        -2680.307861328125,
        -4293.92236328125,
        1122.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4609.7685546875,
      "bbox_min": [
        -2749.999755859375,
        -4609.7685546875,
        1122.623779296875
      ],
      "bbox_max": [
        -2679.17236328125,
        -4299.05712890625,
        1232.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8651316165924072,
        -0.5015451312065125,
        0.0
      ],
      "plane_d": 165.22314453125,
      "bbox_min": [
        -2687.4853515625,
        -4306.30322265625,
        1122.623779296875
      ],
      "bbox_max": [
        -2683.28466796875,
        -4299.05712890625,
        1142.5771484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8958584666252136,
        -0.0,
        0.44433948397636414
      ],
      "plane_d": 2067.916015625,
      "bbox_min": [
        -3274.898193359375,
        -4913.2685546875,
        1232.623779296875
      ],
      "bbox_max": [
        -2919.67919921875,
        -4855.4091796875,
        1302.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9395509958267212,
        0.0,
        -0.3424091041088104
      ],
      "plane_d": 3458.78271484375,
      "bbox_min": [
        -3274.898193359375,
        -4911.6953125,
        1232.623779296875
      ],
      "bbox_max": [
        -2919.67919921875,
        -4855.4091796875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01227299403399229,
        0.9982650876045227,
        0.05758681520819664
      ],
      "plane_d": 4736.61279296875,
      "bbox_min": [
        -3274.898193359375,
        -4859.876953125,
        1232.623779296875
      ],
      "bbox_max": [
        -3206.59619140625,
        -4855.9072265625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9987815618515015,
        0.04934954270720482
      ],
      "plane_d": 4789.1611328125,
      "bbox_min": [
        -3249.981689453125,
        -4859.59814453125,
        1232.623779296875
      ],
      "bbox_max": [
        -3206.59619140625,
        -4855.9072265625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.003976684529334307,
        0.9978758096694946,
        0.06502450257539749
      ],
      "plane_d": 4751.76220703125,
      "bbox_min": [
        -3221.847900390625,
        -4859.59814453125,
        1290.53515625
      ],
      "bbox_max": [
        -3206.59619140625,
        -4858.7685546875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.006341905798763037,
        0.997999370098114,
        0.06290493160486221
      ],
      "plane_d": 4786.82275390625,
      "bbox_min": [
        -3210.992919921875,
        -4907.19970703125,
        1232.623779296875
      ],
      "bbox_max": [
        -2919.67919921875,
        -4855.4091796875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9983217716217041,
        0.05791091546416283
      ],
      "plane_d": 4775.87841796875,
      "bbox_min": [
        -3210.992919921875,
        -4907.19970703125,
        1232.623779296875
      ],
      "bbox_max": [
        -2943.232666015625,
        -4855.4091796875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4297522008419037,
        0.0,
        -0.902946949005127
      ],
      "plane_d": 2545.216064453125,
      "bbox_min": [
        -3210.992919921875,
        -4907.19970703125,
        1290.53515625
      ],
      "bbox_max": [
        -2978.151611328125,
        -4858.7685546875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.003976684529334307,
        0.9978758096694946,
        0.06502450257539749
      ],
      "plane_d": 4751.76220703125,
      "bbox_min": [
        -3210.992919921875,
        -4859.537109375,
        1290.53515625
      ],
      "bbox_max": [
        -3189.3193359375,
        -4858.7685546875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.003976674750447273,
        0.9978757500648499,
        0.06502451002597809
      ],
      "plane_d": 4776.4169921875,
      "bbox_min": [
        -3010.6865234375,
        -4859.59814453125,
        1290.53515625
      ],
      "bbox_max": [
        -2978.151611328125,
        -4858.7685546875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4297522008419037,
        0.0,
        -0.902946949005127
      ],
      "plane_d": 2545.216064453125,
      "bbox_min": [
        -3210.992919921875,
        -4859.46826171875,
        1290.53515625
      ],
      "bbox_max": [
        -2989.006591796875,
        -4858.7685546875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.003976684529334307,
        0.9978758096694946,
        0.06502450257539749
      ],
      "plane_d": 4751.76220703125,
      "bbox_min": [
        -3210.992919921875,
        -4859.46826171875,
        1290.53515625
      ],
      "bbox_max": [
        -3185.6435546875,
        -4858.7685546875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.003976674750447273,
        0.9978757500648499,
        0.06502451002597809
      ],
      "plane_d": 4776.4169921875,
      "bbox_min": [
        -3014.35595703125,
        -4859.46826171875,
        1290.53515625
      ],
      "bbox_max": [
        -2989.006591796875,
        -4858.7685546875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        3.2572361305938102e-06,
        0.7071068286895752
      ],
      "plane_d": 1104.781005859375,
      "bbox_min": [
        -2687.4853515625,
        -4372.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -2663.999755859375,
        -4302.71484375,
        1152.259033203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4319.7685546875,
      "bbox_min": [
        -2675.010986328125,
        -4319.7685546875,
        1101.623779296875
      ],
      "bbox_max": [
        -2664.0,
        -4319.7685546875,
        1112.6348876953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8651316165924072,
        -0.5015451312065125,
        0.0
      ],
      "plane_d": 165.22314453125,
      "bbox_min": [
        -2687.4853515625,
        -4306.30322265625,
        1137.5841064453125
      ],
      "bbox_max": [
        -2685.4052734375,
        -4302.71484375,
        1152.259033203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.000566598610021174,
        0.9717413783073425,
        0.23604734241962433
      ],
      "plane_d": 3914.062255859375,
      "bbox_min": [
        -3128.563232421875,
        -4306.30322265625,
        1101.623779296875
      ],
      "bbox_max": [
        -2653.469482421875,
        -4247.6279296875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8651316165924072,
        -0.5015451312065125,
        0.0
      ],
      "plane_d": 165.22314453125,
      "bbox_min": [
        -2687.4853515625,
        -4306.30322265625,
        1101.623779296875
      ],
      "bbox_max": [
        -2680.307861328125,
        -4293.92236328125,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8651316165924072,
        -0.5015451312065125,
        0.0
      ],
      "plane_d": 165.22314453125,
      "bbox_min": [
        -3128.563232421875,
        -4306.30322265625,
        1101.623779296875
      ],
      "bbox_max": [
        -2653.469482421875,
        -4247.6279296875,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8411246538162231,
        -0.4916875958442688,
        0.22528356313705444
      ],
      "plane_d": -58.8607177734375,
      "bbox_min": [
        -3118.603759765625,
        -4295.22607421875,
        1101.623779296875
      ],
      "bbox_max": [
        -2708.07421875,
        -4247.63818359375,
        1152.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9734168648719788,
        0.0016828934894874692,
        0.22903460264205933
      ],
      "plane_d": 2789.064697265625,
      "bbox_min": [
        -3118.603759765625,
        -4295.22607421875,
        1101.623779296875
      ],
      "bbox_max": [
        -3117.009033203125,
        -4259.19970703125,
        1108.4144287109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9875902533531189,
        -0.10195229202508926,
        0.11946217715740204
      ],
      "plane_d": 2521.177490234375,
      "bbox_min": [
        -3280.0,
        -4247.66796875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2460.0,
        -3283.287109375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9767470955848694,
        0.034353528171777725,
        0.2116248458623886
      ],
      "plane_d": 2855.7041015625,
      "bbox_min": [
        -3280.0,
        -4239.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3031.9140625,
        -3344.980712890625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39677491784095764,
        -0.917915940284729,
        0.0
      ],
      "plane_d": -2385.22314453125,
      "bbox_min": [
        -3280.0,
        -4239.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3083.144287109375,
        -3903.39501953125,
        1247.45458984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10799951106309891,
        0.9941509366035461,
        0.0
      ],
      "plane_d": 3547.585693359375,
      "bbox_min": [
        -3086.49267578125,
        -3903.7587890625,
        1052.5999755859375
      ],
      "bbox_max": [
        -3083.144287109375,
        -3903.39501953125,
        1079.9710693359375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4239.7685546875,
      "bbox_min": [
        -3280.0,
        -4239.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3117.869384765625,
        -4239.7685546875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20940233767032623,
        -0.9440802931785583,
        0.25468209385871887
      ],
      "plane_d": -2849.800537109375,
      "bbox_min": [
        -3088.01416015625,
        -3407.13818359375,
        1052.5999755859375
      ],
      "bbox_max": [
        -3031.9140625,
        -3344.980712890625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09112545102834702,
        -0.9304839968681335,
        0.35481786727905273
      ],
      "plane_d": -3767.822265625,
      "bbox_min": [
        -2921.3994140625,
        -3397.99365234375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2552.111572265625,
        -3283.287109375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.18425501883029938,
        -0.9331962466239929,
        0.3085367977619171
      ],
      "plane_d": -2959.1591796875,
      "bbox_min": [
        -2921.3994140625,
        -3392.010498046875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2749.9501953125,
        -3283.287109375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1306823045015335,
        -0.9546955227851868,
        0.2673548758029938
      ],
      "plane_d": -3137.979736328125,
      "bbox_min": [
        -2921.3994140625,
        -3392.010498046875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2792.86328125,
        -3363.318115234375,
        1119.5692138671875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9959433078765869,
        -0.08998323231935501,
        8.233218250097707e-05
      ],
      "plane_d": 2717.095458984375,
      "bbox_min": [
        -3126.218994140625,
        -4247.66796875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2460.0,
        -3283.287109375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9951902031898499,
        -0.04628791660070419,
        0.08633600920438766
      ],
      "plane_d": 2787.013916015625,
      "bbox_min": [
        -3126.218994140625,
        -4239.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3029.97216796875,
        -3339.265625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39677491784095764,
        -0.917915940284729,
        0.0
      ],
      "plane_d": -2385.22314453125,
      "bbox_min": [
        -3126.218994140625,
        -4239.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3077.04150390625,
        -3860.439453125,
        1280.1251220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1079995185136795,
        0.9941509962081909,
        0.0
      ],
      "plane_d": 3547.5859375,
      "bbox_min": [
        -3086.49267578125,
        -3903.7587890625,
        1052.5999755859375
      ],
      "bbox_max": [
        -3077.04150390625,
        -3860.439453125,
        1187.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1072.5999755859375,
      "bbox_min": [
        -3079.06787109375,
        -3880.383056640625,
        1072.5999755859375
      ],
      "bbox_max": [
        -3077.043212890625,
        -3860.439453125,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4239.7685546875,
      "bbox_min": [
        -3126.218994140625,
        -4239.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3111.311767578125,
        -4239.7685546875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9927711486816406,
        0.04754962772130966,
        0.11020220816135406
      ],
      "plane_d": 3104.564453125,
      "bbox_min": [
        -3094.6171875,
        -3936.187744140625,
        1052.5999755859375
      ],
      "bbox_max": [
        -3029.97216796875,
        -3339.265625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39677491784095764,
        -0.917915940284729,
        0.0
      ],
      "plane_d": -2385.22314453125,
      "bbox_min": [
        -3094.6171875,
        -3936.187744140625,
        1139.7886962890625
      ],
      "bbox_max": [
        -3080.906005859375,
        -3903.15185546875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1079995185136795,
        0.9941509962081909,
        0.0
      ],
      "plane_d": 3547.5859375,
      "bbox_min": [
        -3085.076904296875,
        -3903.60498046875,
        1139.7886962890625
      ],
      "bbox_max": [
        -3080.906005859375,
        -3903.15185546875,
        1187.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1306823045015335,
        -0.9546955227851868,
        0.2673548758029938
      ],
      "plane_d": -3137.979736328125,
      "bbox_min": [
        -3035.290771484375,
        -3407.13818359375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2848.796875,
        -3332.9873046875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20940233767032623,
        -0.9440802931785583,
        0.25468209385871887
      ],
      "plane_d": -2849.800537109375,
      "bbox_min": [
        -3035.290771484375,
        -3407.13818359375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2936.673095703125,
        -3332.9873046875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1080.0,
      "bbox_min": [
        -2958.145751953125,
        -3397.729736328125,
        1061.6800537109375
      ],
      "bbox_max": [
        -2936.673095703125,
        -3386.654296875,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.987689197063446,
        0.15642857551574707,
        -6.9202828854031395e-06
      ],
      "plane_d": 3431.929931640625,
      "bbox_min": [
        -2938.325927734375,
        -3397.090087890625,
        1061.6800537109375
      ],
      "bbox_max": [
        -2936.673095703125,
        -3386.654296875,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 3041.499755859375,
      "bbox_min": [
        -3111.3173828125,
        -4247.66796875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2460.0,
        -3332.9873046875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1079995185136795,
        0.9941509962081909,
        0.0
      ],
      "plane_d": 3547.5859375,
      "bbox_min": [
        -3111.3173828125,
        -4239.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3041.499755859375,
        -3860.464111328125,
        1187.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4239.7685546875,
      "bbox_min": [
        -3111.3173828125,
        -4239.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3046.499755859375,
        -4239.7685546875,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1072.5999755859375,
      "bbox_min": [
        -3078.84326171875,
        -3882.977783203125,
        1052.5999755859375
      ],
      "bbox_max": [
        -3047.438720703125,
        -3860.464111328125,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.08714968711137772,
        0.9961952567100525,
        0.0
      ],
      "plane_d": 4113.939453125,
      "bbox_min": [
        -3077.043212890625,
        -3882.977783203125,
        1052.5999755859375
      ],
      "bbox_max": [
        -3047.438720703125,
        -3860.464111328125,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9961944818496704,
        -0.08715847134590149,
        0.0
      ],
      "plane_d": 2699.143798828125,
      "bbox_min": [
        -3049.181884765625,
        -3882.977783203125,
        1052.5999755859375
      ],
      "bbox_max": [
        -3047.438720703125,
        -3863.053955078125,
        1072.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1079995185136795,
        0.9941509962081909,
        0.0
      ],
      "plane_d": 3547.5859375,
      "bbox_min": [
        -3041.499755859375,
        -4247.640625,
        1052.5999755859375
      ],
      "bbox_max": [
        -2460.0,
        -3332.9873046875,
        1302.5999755859375
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.8408512473106384,
        -0.4904192090034485,
        0.22903768718242645
      ],
      "plane_d": -58.544342041015625,
      "bbox_min": [
        -2745.6064453125,
        -4247.640625,
        1052.5999755859375
      ],
      "bbox_max": [
        -2460.0,
        -3835.699462890625,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8411246538162231,
        -0.4916875958442688,
        0.22528356313705444
      ],
      "plane_d": -58.8607177734375,
      "bbox_min": [
        -2745.6064453125,
        -4247.640625,
        1052.5999755859375
      ],
      "bbox_max": [
        -2460.0,
        -3835.699462890625,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10253556817770004,
        0.17759636044502258,
        0.9787472486495972
      ],
      "plane_d": -99.72515869140625,
      "bbox_min": [
        -2745.6064453125,
        -4022.947509765625,
        1052.5999755859375
      ],
      "bbox_max": [
        -2460.0,
        -3835.699462890625,
        1226.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4999997913837433,
        0.8660256266593933,
        0.0
      ],
      "plane_d": 4752.2900390625,
      "bbox_min": [
        -2745.6064453125,
        -4022.947509765625,
        1052.5999755859375
      ],
      "bbox_max": [
        -2556.375,
        -3866.19091796875,
        1101.7984619140625
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8660260438919067,
        -0.49999895691871643,
        0.0
      ],
      "plane_d": 222.9329833984375,
      "bbox_min": [
        -2579.205322265625,
        -4022.947509765625,
        1082.623779296875
      ],
      "bbox_max": [
        -2569.205322265625,
        -4004.139892578125,
        1101.7984619140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.499998539686203,
        0.8660262227058411,
        -0.0
      ],
      "plane_d": 4772.2890625,
      "bbox_min": [
        -2579.205322265625,
        -4022.947509765625,
        1101.0238037109375
      ],
      "bbox_max": [
        -2576.629638671875,
        -4021.46044921875,
        1101.79833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547210574150085,
        0.8320364356040955,
        -0.0
      ],
      "plane_d": 4762.3193359375,
      "bbox_min": [
        -2745.6064453125,
        -4004.0419921875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2556.375,
        -3866.19091796875,
        1097.6080322265625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.49999991059303284,
        0.8660255670547485,
        0.0
      ],
      "plane_d": 4748.2900390625,
      "bbox_min": [
        -2745.6064453125,
        -3926.67578125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2695.376953125,
        -3893.881591796875,
        1096.7698974609375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9643577337265015,
        -0.2646018862724304,
        0.0
      ],
      "plane_d": 1616.414306640625,
      "bbox_min": [
        -2745.6064453125,
        -3897.67578125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2744.5654296875,
        -3893.881591796875,
        1096.7698974609375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.49999895691871643,
        0.8660260438919067,
        -0.0
      ],
      "plane_d": 4732.2890625,
      "bbox_min": [
        -2744.5654296875,
        -4004.0419921875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2556.375,
        -3866.19091796875,
        1097.60791015625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.25882238149642944,
        0.9659250378608704,
        0.0
      ],
      "plane_d": 3174.44677734375,
      "bbox_min": [
        -2744.5654296875,
        -4004.0419921875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2556.375,
        -3881.726806640625,
        1097.60791015625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660281896591187,
        -0.4999951720237732,
        0.0
      ],
      "plane_d": 217.953369140625,
      "bbox_min": [
        -2563.375,
        -4004.0419921875,
        1082.623779296875
      ],
      "bbox_max": [
        -2556.375,
        -3986.8193359375,
        1094.01904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8743014335632324,
        0.48538342118263245,
        -0.0
      ],
      "plane_d": 4172.65283203125,
      "bbox_min": [
        -2559.205322265625,
        -3991.91748046875,
        1082.623779296875
      ],
      "bbox_max": [
        -2556.375,
        -3986.8193359375,
        1094.01904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9643577337265015,
        -0.2646018862724304,
        0.0
      ],
      "plane_d": 1616.414306640625,
      "bbox_min": [
        -2744.5654296875,
        -3893.881591796875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2741.23046875,
        -3881.726806640625,
        1095.972412109375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9643577337265015,
        -0.2646018862724304,
        0.0
      ],
      "plane_d": 1616.414306640625,
      "bbox_min": [
        -2741.23046875,
        -3881.726806640625,
        1052.5999755859375
      ],
      "bbox_max": [
        -2737.60302734375,
        -3866.19091796875,
        1093.41748046875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9643577337265015,
        -0.2646018862724304,
        0.0
      ],
      "plane_d": 1616.414306640625,
      "bbox_min": [
        -2745.6064453125,
        -4022.8564453125,
        1090.540283203125
      ],
      "bbox_max": [
        -2556.496337890625,
        -3866.19091796875,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6020522713661194,
        0.7984567284584045,
        0.0
      ],
      "plane_d": 4737.015625,
      "bbox_min": [
        -2740.67431640625,
        -3868.5068359375,
        1090.540283203125
      ],
      "bbox_max": [
        -2737.60302734375,
        -3866.19091796875,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660260438919067,
        -0.49999895691871643,
        0.0
      ],
      "plane_d": 222.9329833984375,
      "bbox_min": [
        -2579.205322265625,
        -4022.8564453125,
        1097.6080322265625
      ],
      "bbox_max": [
        -2569.205322265625,
        -4004.139892578125,
        1114.0384521484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.499998539686203,
        0.8660262227058411,
        -0.0
      ],
      "plane_d": 4772.2890625,
      "bbox_min": [
        -2579.205322265625,
        -4022.8564453125,
        1101.79833984375
      ],
      "bbox_max": [
        -2576.78759765625,
        -4021.46044921875,
        1113.6636962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547210574150085,
        0.8320363759994507,
        -0.0
      ],
      "plane_d": 4762.3193359375,
      "bbox_min": [
        -2695.376953125,
        -3984.139892578125,
        1096.769775390625
      ],
      "bbox_max": [
        -2598.382080078125,
        -3926.67578125,
        1172.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25882238149642944,
        0.9659249782562256,
        0.0
      ],
      "plane_d": 3174.446533203125,
      "bbox_min": [
        -2603.84619140625,
        -3984.139892578125,
        1096.769775390625
      ],
      "bbox_max": [
        -2598.382080078125,
        -3982.67578125,
        1166.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25882238149642944,
        0.9659249782562256,
        0.0
      ],
      "plane_d": 3174.446533203125,
      "bbox_min": [
        -2598.382080078125,
        -3991.698974609375,
        1093.4173583984375
      ],
      "bbox_max": [
        -2556.496337890625,
        -3976.8193359375,
        1166.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49999895691871643,
        0.8660260438919067,
        -0.0
      ],
      "plane_d": 4732.2890625,
      "bbox_min": [
        -2576.52587890625,
        -3991.698974609375,
        1093.4173583984375
      ],
      "bbox_max": [
        -2556.496337890625,
        -3976.8193359375,
        1166.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8743014335632324,
        0.48538342118263245,
        -0.0
      ],
      "plane_d": 4172.65283203125,
      "bbox_min": [
        -2559.205322265625,
        -3991.698974609375,
        1093.4176025390625
      ],
      "bbox_max": [
        -2556.496337890625,
        -3986.8193359375,
        1114.4124755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10253556817770004,
        0.17759636044502258,
        0.9787472486495972
      ],
      "plane_d": -99.72515869140625,
      "bbox_min": [
        -2584.199951171875,
        -4042.3720703125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2460.0,
        -3843.5283203125,
        1194.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.01678992621600628,
        0.9998590350151062,
        0.0
      ],
      "plane_d": 3963.764404296875,
      "bbox_min": [
        -2563.375,
        -4006.8173828125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2530.334228515625,
        -3991.698974609375,
        1096.9793701171875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8743014335632324,
        0.48538342118263245,
        -0.0
      ],
      "plane_d": 4172.65283203125,
      "bbox_min": [
        -2556.496337890625,
        -3991.91748046875,
        1093.10546875
      ],
      "bbox_max": [
        -2556.375,
        -3991.698974609375,
        1094.0458984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49999895691871643,
        0.8660260438919067,
        -0.0
      ],
      "plane_d": 4752.28955078125,
      "bbox_min": [
        -2548.89697265625,
        -4041.3603515625,
        1082.623779296875
      ],
      "bbox_max": [
        -2526.578857421875,
        -4024.0400390625,
        1101.79833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.499998539686203,
        0.8660262227058411,
        -0.0
      ],
      "plane_d": 4772.2890625,
      "bbox_min": [
        -2548.89697265625,
        -4041.3603515625,
        1101.0238037109375
      ],
      "bbox_max": [
        -2544.737548828125,
        -4038.958984375,
        1101.79833984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49999895691871643,
        0.8660260438919067,
        -0.0
      ],
      "plane_d": 4752.28955078125,
      "bbox_min": [
        -2584.199951171875,
        -4041.3603515625,
        1093.41748046875
      ],
      "bbox_max": [
        -2516.548095703125,
        -3980.677978515625,
        1194.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660230040550232,
        -0.500004231929779,
        0.0
      ],
      "plane_d": 183.10400390625,
      "bbox_min": [
        -2579.205322265625,
        -4041.3603515625,
        1101.79833984375
      ],
      "bbox_max": [
        -2534.737548828125,
        -4021.46044921875,
        1194.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.499998539686203,
        0.8660262227058411,
        -0.0
      ],
      "plane_d": 4772.2890625,
      "bbox_min": [
        -2579.205322265625,
        -4041.3603515625,
        1101.79833984375
      ],
      "bbox_max": [
        -2544.737548828125,
        -4021.46044921875,
        1142.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.49999895691871643,
        0.8660260438919067,
        0.0
      ],
      "plane_d": 4732.28955078125,
      "bbox_min": [
        -2569.842529296875,
        -4024.0400390625,
        1093.41748046875
      ],
      "bbox_max": [
        -2516.548095703125,
        -3980.677978515625,
        1194.623779296875
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.8660281896591187,
        -0.4999951720237732,
        0.0
      ],
      "plane_d": 217.953369140625,
      "bbox_min": [
        -2569.205322265625,
        -4024.0400390625,
        1093.4176025390625
      ],
      "bbox_max": [
        -2524.737548828125,
        -3986.8193359375,
        1194.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8743014335632324,
        0.48538342118263245,
        -0.0
      ],
      "plane_d": 4172.65283203125,
      "bbox_min": [
        -2569.205322265625,
        -4004.139892578125,
        1094.01904296875
      ],
      "bbox_max": [
        -2556.375,
        -3986.8193359375,
        1194.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.016789225861430168,
        0.999859094619751,
        0.0
      ],
      "plane_d": 3960.440673828125,
      "bbox_min": [
        -2569.205322265625,
        -4004.139892578125,
        1142.623779296875
      ],
      "bbox_max": [
        -2563.375,
        -4004.0419921875,
        1194.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.016789928078651428,
        0.999859094619751,
        0.0
      ],
      "plane_d": 3963.764892578125,
      "bbox_min": [
        -2563.375,
        -4024.0400390625,
        1093.4176025390625
      ],
      "bbox_max": [
        -2524.737548828125,
        -3993.736083984375,
        1194.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48740285634994507,
        0.8442001342773438,
        0.2230798602104187
      ],
      "plane_d": 4363.11279296875,
      "bbox_min": [
        -2557.7763671875,
        -4024.0400390625,
        1142.623779296875
      ],
      "bbox_max": [
        -2531.61767578125,
        -4006.885986328125,
        1194.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000002384185791,
        0.8660253882408142,
        -0.0
      ],
      "plane_d": 4749.2900390625,
      "bbox_min": [
        -2557.7763671875,
        -4024.0400390625,
        1142.623779296875
      ],
      "bbox_max": [
        -2534.737548828125,
        -4007.2744140625,
        1194.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8743192553520203,
        0.48535144329071045,
        -0.0
      ],
      "plane_d": 4169.24365234375,
      "bbox_min": [
        -2537.567626953125,
        -4024.0400390625,
        1142.623779296875
      ],
      "bbox_max": [
        -2534.737548828125,
        -4018.94189453125,
        1194.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48740285634994507,
        0.8442001342773438,
        0.2230798602104187
      ],
      "plane_d": 4363.11279296875,
      "bbox_min": [
        -2563.375,
        -4007.2744140625,
        1142.623779296875
      ],
      "bbox_max": [
        -2534.64892578125,
        -3993.736083984375,
        1194.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000002384185791,
        0.8660253882408142,
        -0.0
      ],
      "plane_d": 4749.2900390625,
      "bbox_min": [
        -2563.375,
        -4007.2744140625,
        1142.623779296875
      ],
      "bbox_max": [
        -2557.7763671875,
        -4004.0419921875,
        1194.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999997615814209,
        0.8660255670547485,
        -0.0
      ],
      "plane_d": 4752.28955078125,
      "bbox_min": [
        -2526.578857421875,
        -4067.168212890625,
        1052.5999755859375
      ],
      "bbox_max": [
        -2460.0,
        -4011.44775390625,
        1187.623779296875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.49999895691871643,
        0.8660260438919067,
        0.0
      ],
      "plane_d": 4732.28955078125,
      "bbox_min": [
        -2516.548095703125,
        -4067.168212890625,
        1052.5999755859375
      ],
      "bbox_max": [
        -2460.0,
        -4011.44775390625,
        1172.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.44320565462112427,
        0.8964199423789978,
        0.0
      ],
      "plane_d": 4736.1767578125,
      "bbox_min": [
        -2507.4169921875,
        -4067.168212890625,
        1052.5999755859375
      ],
      "bbox_max": [
        -2460.0,
        -4016.719482421875,
        1172.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9659255743026733,
        0.25882023572921753,
        0.0
      ],
      "plane_d": 3461.58642578125,
      "bbox_min": [
        -2507.4169921875,
        -4044.0400390625,
        1052.5999755859375
      ],
      "bbox_max": [
        -2500.096435546875,
        -4016.719482421875,
        1166.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.22523219883441925,
        0.9743051528930664,
        0.0
      ],
      "plane_d": 3108.530029296875,
      "bbox_min": [
        -3030.255859375,
        -3866.19091796875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2460.0,
        -3332.9873046875,
        1302.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6020522713661194,
        0.7984567284584045,
        0.0
      ],
      "plane_d": 4737.015625,
      "bbox_min": [
        -2807.0751953125,
        -3866.19091796875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2460.0,
        -3824.790771484375,
        1226.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.20790888369083405,
        0.9781482815742493,
        0.0
      ],
      "plane_d": 4339.14501953125,
      "bbox_min": [
        -2807.0751953125,
        -3848.5751953125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2764.036865234375,
        -3839.42724609375,
        1203.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.10253556817770004,
        0.17759636044502258,
        0.9787472486495972
      ],
      "plane_d": -99.72515869140625,
      "bbox_min": [
        -2466.7197265625,
        -3836.429443359375,
        1053.6239013671875
      ],
      "bbox_max": [
        -2460.0,
        -3824.790771484375,
        1056.4398193359375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.987689197063446,
        0.15642857551574707,
        -6.9202828854031395e-06
      ],
      "plane_d": 3431.929931640625,
      "bbox_min": [
        -2937.185791015625,
        -3403.73876953125,
        1069.902587890625
      ],
      "bbox_max": [
        -2935.6201171875,
        -3393.852783203125,
        1080.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24250808358192444,
        -0.909406840801239,
        0.3378889858722687
      ],
      "plane_d": -2927.0478515625,
      "bbox_min": [
        -2010.0,
        -3793.99462890625,
        948.6456909179688
      ],
      "bbox_max": [
        -1760.0,
        -3203.987060546875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3485427498817444,
        -0.8757609128952026,
        0.3340070843696594
      ],
      "plane_d": -2608.564453125,
      "bbox_min": [
        -2010.0,
        -3793.99462890625,
        948.6456909179688
      ],
      "bbox_max": [
        -1760.0,
        -3244.978515625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23947833478450775,
        -0.8831087350845337,
        0.4034464955329895
      ],
      "plane_d": -2932.8583984375,
      "bbox_min": [
        -2010.0,
        -3336.106689453125,
        1160.166015625
      ],
      "bbox_max": [
        -1925.2470703125,
        -3248.052978515625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21603241562843323,
        -0.9093504548072815,
        0.35554423928260803
      ],
      "plane_d": -2994.511962890625,
      "bbox_min": [
        -2010.0,
        -3793.99462890625,
        948.6456909179688
      ],
      "bbox_max": [
        -1760.0,
        -3244.978515625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1646440476179123,
        0.8786206841468811,
        0.44823890924453735
      ],
      "plane_d": 2238.702880859375,
      "bbox_min": [
        -2010.0,
        -3793.99462890625,
        948.6456909179688
      ],
      "bbox_max": [
        -1760.0,
        -3340.234130859375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45244094729423523,
        0.7295348644256592,
        0.5129094123840332
      ],
      "plane_d": 2833.32421875,
      "bbox_min": [
        -2010.0,
        -3793.99462890625,
        950.2199096679688
      ],
      "bbox_max": [
        -1760.0,
        -3362.54541015625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4463079273700714,
        0.49091777205467224,
        0.7482037544250488
      ],
      "plane_d": -36.39849853515625,
      "bbox_min": [
        -2010.0,
        -3793.99462890625,
        1052.5999755859375
      ],
      "bbox_max": [
        -1888.70703125,
        -3506.4814453125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5098023414611816,
        0.8602915406227112,
        0.0
      ],
      "plane_d": 4041.298828125,
      "bbox_min": [
        -2010.0,
        -3793.99462890625,
        1052.5999755859375
      ],
      "bbox_max": [
        -1926.837890625,
        -3506.4814453125,
        1234.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -1052.599853515625,
      "bbox_min": [
        -2010.0,
        -3793.99462890625,
        1052.5999755859375
      ],
      "bbox_max": [
        -1926.837890625,
        -3545.0,
        1234.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6757248044013977,
        0.7371538877487183,
        -0.0
      ],
      "plane_d": 3927.4951171875,
      "bbox_min": [
        -1945.0,
        -3575.815185546875,
        1192.4141845703125
      ],
      "bbox_max": [
        -1926.837890625,
        -3545.0,
        1234.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1234.0,
      "bbox_min": [
        -1936.4140625,
        -3575.815185546875,
        1234.0
      ],
      "bbox_max": [
        -1926.837890625,
        -3559.98291015625,
        1234.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5098023414611816,
        0.8602915406227112,
        0.0
      ],
      "plane_d": 4041.298828125,
      "bbox_min": [
        -1991.890380859375,
        -3567.037109375,
        1168.2171630859375
      ],
      "bbox_max": [
        -1928.6549072265625,
        -3517.213134765625,
        1234.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6757248044013977,
        0.7371538877487183,
        -0.0
      ],
      "plane_d": 3927.4951171875,
      "bbox_min": [
        -1955.0,
        -3567.037109375,
        1214.4193115234375
      ],
      "bbox_max": [
        -1928.6549072265625,
        -3545.0,
        1234.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1234.0,
      "bbox_min": [
        -1955.0,
        -3567.037109375,
        1234.0
      ],
      "bbox_max": [
        -1928.6549072265625,
        -3545.033935546875,
        1234.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0967860147356987,
        0.9410552978515625,
        0.324110209941864
      ],
      "plane_d": 3115.90478515625,
      "bbox_min": [
        -1945.0955810546875,
        -3628.2177734375,
        950.2199096679688
      ],
      "bbox_max": [
        -1760.0,
        -3362.54541015625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4463079273700714,
        0.49091777205467224,
        0.7482037544250488
      ],
      "plane_d": -36.39849853515625,
      "bbox_min": [
        -1945.0955810546875,
        -3628.2177734375,
        1203.9764404296875
      ],
      "bbox_max": [
        -1826.687255859375,
        -3526.04248046875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5098023414611816,
        0.8602915406227112,
        0.0
      ],
      "plane_d": 4041.298828125,
      "bbox_min": [
        -1945.0955810546875,
        -3545.23583984375,
        1233.8914794921875
      ],
      "bbox_max": [
        -1944.74267578125,
        -3544.943359375,
        1234.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1234.0,
      "bbox_min": [
        -1945.0955810546875,
        -3545.23583984375,
        1233.8914794921875
      ],
      "bbox_max": [
        -1944.74267578125,
        -3544.943359375,
        1234.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6757248044013977,
        0.7371538877487183,
        -0.0
      ],
      "plane_d": 3927.4951171875,
      "bbox_min": [
        -1945.0955810546875,
        -3545.23583984375,
        1233.8914794921875
      ],
      "bbox_max": [
        -1944.74267578125,
        -3544.943359375,
        1234.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33383411169052124,
        0.6676682233810425,
        0.6654126048088074
      ],
      "plane_d": 896.4573974609375,
      "bbox_min": [
        -1945.0955810546875,
        -3545.033935546875,
        1233.895263671875
      ],
      "bbox_max": [
        -1945.0,
        -3544.943359375,
        1234.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7289522290229797,
        0.6049720644950867,
        0.3203705847263336
      ],
      "plane_d": 411.9771423339844,
      "bbox_min": [
        -1888.5152587890625,
        -3571.833740234375,
        950.2199096679688
      ],
      "bbox_max": [
        -1760.0,
        -3362.54541015625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.14676129817962646,
        0.7160802483558655,
        0.6824150681495667
      ],
      "plane_d": 1489.5687255859375,
      "bbox_min": [
        -1857.778564453125,
        -3493.00048828125,
        950.2199096679688
      ],
      "bbox_max": [
        -1760.0,
        -3362.54541015625,
        1167.278076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2235765904188156,
        0.04341130331158638,
        0.9737191796302795
      ],
      "plane_d": -385.780029296875,
      "bbox_min": [
        -1826.2652587890625,
        -3393.506103515625,
        950.2199096679688
      ],
      "bbox_max": [
        -1760.0,
        -3362.54541015625,
        966.8153686523438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34272027015686035,
        0.9365004897117615,
        0.07422665506601334
      ],
      "plane_d": 2554.111572265625,
      "bbox_min": [
        -1857.778564453125,
        -3493.00048828125,
        1064.9735107421875
      ],
      "bbox_max": [
        -1760.0,
        -3455.78955078125,
        1167.278076171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.043616753071546555,
        0.9218221306800842,
        0.38515132665634155
      ],
      "plane_d": 2676.18310546875,
      "bbox_min": [
        -1888.5152587890625,
        -3407.556884765625,
        966.8153686523438
      ],
      "bbox_max": [
        -1822.9830322265625,
        -3393.506103515625,
        1000.8163452148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7289522290229797,
        0.6049720644950867,
        0.3203705847263336
      ],
      "plane_d": 411.9771423339844,
      "bbox_min": [
        -2010.0,
        -3551.677978515625,
        948.6456909179688
      ],
      "bbox_max": [
        -1760.0,
        -3340.234130859375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34272027015686035,
        0.9365004897117615,
        0.07422665506601334
      ],
      "plane_d": 2554.111572265625,
      "bbox_min": [
        -1816.41650390625,
        -3483.12548828125,
        948.6456909179688
      ],
      "bbox_max": [
        -1760.0,
        -3340.234130859375,
        1265.1668701171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21186989545822144,
        0.07687602192163467,
        0.9742696285247803
      ],
      "plane_d": -294.561767578125,
      "bbox_min": [
        -1813.3851318359375,
        -3376.00732421875,
        948.6456909179688
      ],
      "bbox_max": [
        -1760.0,
        -3340.234130859375,
        963.0778198242188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21823850274085999,
        0.07879546284675598,
        0.9727092981338501
      ],
      "plane_d": -274.47198486328125,
      "bbox_min": [
        -2010.0,
        -3536.908203125,
        955.6844482421875
      ],
      "bbox_max": [
        -1790.718017578125,
        -3344.77978515625,
        1219.030029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20575138926506042,
        0.1004783883690834,
        0.9734323620796204
      ],
      "plane_d": -226.04217529296875,
      "bbox_min": [
        -2010.0,
        -3424.79638671875,
        980.9876098632812
      ],
      "bbox_max": [
        -1901.143798828125,
        -3361.1201171875,
        1010.5689086914062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21186989545822144,
        0.07687602192163467,
        0.9742696285247803
      ],
      "plane_d": -294.561767578125,
      "bbox_min": [
        -2010.0,
        -3536.908203125,
        955.6844482421875
      ],
      "bbox_max": [
        -1790.718017578125,
        -3344.77978515625,
        1219.030029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2235765904188156,
        0.04341130331158638,
        0.9737191796302795
      ],
      "plane_d": -385.780029296875,
      "bbox_min": [
        -1888.5152587890625,
        -3402.5927734375,
        963.0778198242188
      ],
      "bbox_max": [
        -1813.3851318359375,
        -3376.00732421875,
        981.5137939453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5098023414611816,
        0.8602915406227112,
        0.0
      ],
      "plane_d": 4041.298828125,
      "bbox_min": [
        -2010.0,
        -3536.908203125,
        1140.5296630859375
      ],
      "bbox_max": [
        -1958.655029296875,
        -3506.4814453125,
        1219.030029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.33383411169052124,
        0.6676682233810425,
        0.6654126048088074
      ],
      "plane_d": 896.4573974609375,
      "bbox_min": [
        -2010.0,
        -3536.908203125,
        1162.74072265625
      ],
      "bbox_max": [
        -1958.655029296875,
        -3506.4814453125,
        1219.030029296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1052.5999755859375,
      "bbox_min": [
        -2460.0,
        -4970.0,
        1007.42724609375
      ],
      "bbox_max": [
        -2010.0,
        -3271.035888671875,
        1302.5999755859375
      ],
      "face_count": 14
    },
    {
      "plane_normal": [
        0.32936930656433105,
        -0.8532378077507019,
        0.40435269474983215
      ],
      "plane_d": -2643.852783203125,
      "bbox_min": [
        -2349.54345703125,
        -3600.0,
        1007.42724609375
      ],
      "bbox_max": [
        -2010.0,
        -3377.13134765625,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20575138926506042,
        0.1004783883690834,
        0.9734323620796204
      ],
      "plane_d": -226.04217529296875,
      "bbox_min": [
        -2089.408203125,
        -3418.607421875,
        1007.42724609375
      ],
      "bbox_max": [
        -2010.0,
        -3394.35986328125,
        1026.71435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06612364202737808,
        0.09650266915559769,
        0.9931338429450989
      ],
      "plane_d": -551.6007690429688,
      "bbox_min": [
        -2349.54345703125,
        -3600.0,
        1007.6962890625
      ],
      "bbox_max": [
        -2010.0,
        -3377.13134765625,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.06977259367704391,
        0.09120963513851166,
        0.9933844208717346
      ],
      "plane_d": -562.3287353515625,
      "bbox_min": [
        -2284.10009765625,
        -3584.956787109375,
        1007.6962890625
      ],
      "bbox_max": [
        -2010.0,
        -3396.96630859375,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1103413850069046,
        0.05388505384325981,
        0.9924319386482239
      ],
      "plane_d": -604.18408203125,
      "bbox_min": [
        -2241.28857421875,
        -3584.349609375,
        1007.6962890625
      ],
      "bbox_max": [
        -2010.0,
        -3396.96630859375,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20575138926506042,
        0.1004783883690834,
        0.9734323620796204
      ],
      "plane_d": -226.04217529296875,
      "bbox_min": [
        -2105.0,
        -3459.55078125,
        1007.6962890625
      ],
      "bbox_max": [
        -2010.0,
        -3396.96630859375,
        1028.85546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.21823850274085999,
        0.07879546284675598,
        0.9727092981338501
      ],
      "plane_d": -274.47198486328125,
      "bbox_min": [
        -2105.0,
        -3459.55078125,
        1010.5689086914062
      ],
      "bbox_max": [
        -2010.0,
        -3421.18310546875,
        1028.85546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4472135901451111,
        -0.8944271802902222,
        0.0
      ],
      "plane_d": -2126.50048828125,
      "bbox_min": [
        -2105.0,
        -3430.0,
        1027.470703125
      ],
      "bbox_max": [
        -2095.0,
        -3421.18310546875,
        1028.85546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8849280476570129,
        0.4657277762889862,
        -0.0
      ],
      "plane_d": 3449.0419921875,
      "bbox_min": [
        -2097.0087890625,
        -3425.0,
        1027.470703125
      ],
      "bbox_max": [
        -2095.0,
        -3421.18310546875,
        1027.6839599609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1646440476179123,
        0.8786206841468811,
        0.44823890924453735
      ],
      "plane_d": 2238.702880859375,
      "bbox_min": [
        -2069.41357421875,
        -3459.55078125,
        1011.8688354492188
      ],
      "bbox_max": [
        -2010.0,
        -3440.84375,
        1026.71435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1646440476179123,
        0.8786206841468811,
        0.44823890924453735
      ],
      "plane_d": 2238.702880859375,
      "bbox_min": [
        -2069.41357421875,
        -3459.55078125,
        1012.2451782226562
      ],
      "bbox_max": [
        -2010.0,
        -3441.03564453125,
        1026.71435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.01847594976425171,
        0.1786024272441864,
        0.9837478995323181
      ],
      "plane_d": -353.90960693359375,
      "bbox_min": [
        -2241.28857421875,
        -3584.349609375,
        1019.2986450195312
      ],
      "bbox_max": [
        -2010.0,
        -3424.814697265625,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1646440476179123,
        0.8786206841468811,
        0.44823890924453735
      ],
      "plane_d": 2238.702880859375,
      "bbox_min": [
        -2069.41357421875,
        -3459.55078125,
        1019.2986450195312
      ],
      "bbox_max": [
        -2010.0,
        -3444.63427734375,
        1026.71435546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1646440476179123,
        0.8786206841468811,
        0.44823890924453735
      ],
      "plane_d": 2238.702880859375,
      "bbox_min": [
        -2095.4931640625,
        -3470.9453125,
        1023.2570190429688
      ],
      "bbox_max": [
        -2010.0,
        -3424.814697265625,
        1030.313232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5098023414611816,
        0.8602915406227112,
        0.0
      ],
      "plane_d": 4041.298828125,
      "bbox_min": [
        -2080.0,
        -3470.9453125,
        1028.05322265625
      ],
      "bbox_max": [
        -2069.96728515625,
        -3465.0,
        1030.313232421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4472135901451111,
        -0.8944271802902222,
        0.0
      ],
      "plane_d": -2126.50048828125,
      "bbox_min": [
        -2095.4931640625,
        -3425.24658203125,
        1027.6832275390625
      ],
      "bbox_max": [
        -2095.0,
        -3424.814697265625,
        1027.7513427734375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8849280476570129,
        0.4657277762889862,
        -0.0
      ],
      "plane_d": 3449.0419921875,
      "bbox_min": [
        -2095.09765625,
        -3425.0,
        1027.6832275390625
      ],
      "bbox_max": [
        -2095.0,
        -3424.814697265625,
        1027.694091796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.01847594976425171,
        0.1786024272441864,
        0.9837478995323181
      ],
      "plane_d": -353.90960693359375,
      "bbox_min": [
        -2241.28857421875,
        -3584.956787109375,
        1023.7344970703125
      ],
      "bbox_max": [
        -2010.0,
        -3423.116943359375,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5098023414611816,
        0.8602915406227112,
        0.0
      ],
      "plane_d": 4041.298828125,
      "bbox_min": [
        -2080.0,
        -3471.091552734375,
        1030.1544189453125
      ],
      "bbox_max": [
        -2069.720458984375,
        -3465.0,
        1030.595947265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4472135901451111,
        -0.8944271802902222,
        0.0
      ],
      "plane_d": -2126.50048828125,
      "bbox_min": [
        -2105.0,
        -3430.0,
        1027.5908203125
      ],
      "bbox_max": [
        -2095.0,
        -3423.116943359375,
        1028.85546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.01847594976425171,
        0.1786024272441864,
        0.9837478995323181
      ],
      "plane_d": -353.90960693359375,
      "bbox_min": [
        -2235.4189453125,
        -3600.0,
        1024.19921875
      ],
      "bbox_max": [
        -2010.0,
        -3377.13134765625,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3485427498817444,
        -0.8757609128952026,
        0.3340070843696594
      ],
      "plane_d": -2608.564453125,
      "bbox_min": [
        -2105.0,
        -3480.35546875,
        1024.19921875
      ],
      "bbox_max": [
        -2010.0,
        -3377.13134765625,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8618017435073853,
        0.5072331428527832,
        0.003500441089272499
      ],
      "plane_d": 3538.946533203125,
      "bbox_min": [
        -2102.800048828125,
        -3421.313232421875,
        1027.470703125
      ],
      "bbox_max": [
        -2096.940185546875,
        -3411.51708984375,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8849280476570129,
        0.4657277762889862,
        -0.0
      ],
      "plane_d": 3449.0419921875,
      "bbox_min": [
        -2097.0087890625,
        -3421.313232421875,
        1027.470703125
      ],
      "bbox_max": [
        -2096.940185546875,
        -3421.18310546875,
        1027.819580078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1646440476179123,
        0.8786206841468811,
        0.44823890924453735
      ],
      "plane_d": 2238.702880859375,
      "bbox_min": [
        -2105.0,
        -3480.35546875,
        1024.19921875
      ],
      "bbox_max": [
        -2010.0,
        -3413.5810546875,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5098023414611816,
        0.8602915406227112,
        0.0
      ],
      "plane_d": 4041.298828125,
      "bbox_min": [
        -2080.0,
        -3480.35546875,
        1030.50341796875
      ],
      "bbox_max": [
        -2054.08740234375,
        -3465.0,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8849280476570129,
        0.4657277762889862,
        -0.0
      ],
      "plane_d": 3449.0419921875,
      "bbox_min": [
        -2096.996826171875,
        -3425.0,
        1027.478759765625
      ],
      "bbox_max": [
        -2095.0,
        -3421.205810546875,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2802785038948059,
        -0.8504679203033447,
        0.4451383650302887
      ],
      "plane_d": -2792.41162109375,
      "bbox_min": [
        -2349.54345703125,
        -3506.75830078125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2130.3798828125,
        -3303.68017578125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9805806875228882,
        0.1961161345243454
      ],
      "plane_d": 4617.79833984375,
      "bbox_min": [
        -2460.0,
        -4969.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2010.0,
        -3271.035888671875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23947833478450775,
        -0.8831087350845337,
        0.4034464955329895
      ],
      "plane_d": -2932.8583984375,
      "bbox_min": [
        -2460.0,
        -4606.9326171875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2010.0,
        -3271.035888671875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3485427498817444,
        -0.8757609128952026,
        0.3340070843696594
      ],
      "plane_d": -2608.564453125,
      "bbox_min": [
        -2074.00537109375,
        -3402.604736328125,
        1052.5999755859375
      ],
      "bbox_max": [
        -2010.0,
        -3336.106689453125,
        1160.166015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.007462478708475828,
        0.9999721646308899,
        0.0
      ],
      "plane_d": 4588.44677734375,
      "bbox_min": [
        -2460.0,
        -4606.9326171875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2010.0,
        -3398.669677734375,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.39045250415802,
        0.9206230640411377,
        0.0
      ],
      "plane_d": 4687.40673828125,
      "bbox_min": [
        -2460.0,
        -4179.34716796875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2010.0,
        -3398.669677734375,
        1226.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9563905596733093,
        0.29209116101264954,
        -0.0
      ],
      "plane_d": 3385.528076171875,
      "bbox_min": [
        -2460.0,
        -4179.34716796875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2263.487060546875,
        -4067.168212890625,
        1226.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7113276124000549,
        0.7028605937957764,
        0.0
      ],
      "plane_d": 1223.594482421875,
      "bbox_min": [
        -2460.0,
        -4147.68505859375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2273.156982421875,
        -4067.168212890625,
        1226.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7431495785713196,
        0.6691253781318665,
        0.0
      ],
      "plane_d": 4464.6171875,
      "bbox_min": [
        -2302.5986328125,
        -4147.68505859375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2273.156982421875,
        -4114.986328125,
        1203.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.49999672174453735,
        0.866027295589447,
        -0.0
      ],
      "plane_d": 4748.2890625,
      "bbox_min": [
        -2460.0,
        -4123.57568359375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2354.336181640625,
        -4067.168212890625,
        1187.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.44320565462112427,
        0.8964199423789978,
        0.0
      ],
      "plane_d": 4736.1767578125,
      "bbox_min": [
        -2460.0,
        -4094.575927734375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2404.565673828125,
        -4067.168212890625,
        1172.623779296875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.33383411169052124,
        0.6676682233810425,
        0.6654126048088074
      ],
      "plane_d": 896.4573974609375,
      "bbox_min": [
        -2460.0,
        -3884.990966796875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2010.0,
        -3398.669677734375,
        1173.7037353515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5098023414611816,
        0.8602915406227112,
        0.0
      ],
      "plane_d": 4041.298828125,
      "bbox_min": [
        -2460.0,
        -3884.990966796875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2010.0,
        -3461.623291015625,
        1162.74072265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.10253556817770004,
        0.17759636044502258,
        0.9787472486495972
      ],
      "plane_d": -99.72515869140625,
      "bbox_min": [
        -2460.0,
        -3884.990966796875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2431.489013671875,
        -3820.558349609375,
        1064.5474853515625
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8655995726585388,
        -0.5007209777832031,
        -0.003997364081442356
      ],
      "plane_d": 188.33384704589844,
      "bbox_min": [
        -2460.0,
        -3884.990966796875,
        1052.5999755859375
      ],
      "bbox_max": [
        -2431.489013671875,
        -3835.6083984375,
        1064.5474853515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1646440476179123,
        0.8786206841468811,
        0.44823890924453735
      ],
      "plane_d": 2238.702880859375,
      "bbox_min": [
        -2050.7568359375,
        -3490.472412109375,
        1052.5999755859375
      ],
      "bbox_max": [
        -2010.0,
        -3461.623291015625,
        1109.14892578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4472135901451111,
        -0.8944271802902222,
        0.0
      ],
      "plane_d": -2126.50048828125,
      "bbox_min": [
        -2121.00537109375,
        -3430.0,
        1052.5999755859375
      ],
      "bbox_max": [
        -2095.0,
        -3398.669677734375,
        1086.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8849280476570129,
        0.4657277762889862,
        -0.0
      ],
      "plane_d": 3449.0419921875,
      "bbox_min": [
        -2121.00537109375,
        -3430.0,
        1052.5999755859375
      ],
      "bbox_max": [
        -2095.0,
        -3398.669677734375,
        1086.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1085.9998779296875,
      "bbox_min": [
        -2121.00537109375,
        -3430.0,
        1086.0
      ],
      "bbox_max": [
        -2095.0,
        -3398.669677734375,
        1086.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1052.5999755859375,
      "bbox_min": [
        -3720.0,
        -4981.95361328125,
        1052.5999755859375
      ],
      "bbox_max": [
        -3280.0,
        -3820.448974609375,
        1302.5999755859375
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.6948639154434204,
        -0.6925082802772522,
        0.19389794766902924
      ],
      "plane_d": -604.1531372070312,
      "bbox_min": [
        -3720.0,
        -4981.95361328125,
        1052.5999755859375
      ],
      "bbox_max": [
        -3280.0,
        -3820.448974609375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9805806279182434,
        -0.0,
        0.1961161345243454
      ],
      "plane_d": 3421.71630859375,
      "bbox_min": [
        -3720.0,
        -4289.7998046875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3699.999755859375,
        -4099.7685546875,
        1152.6011962890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9805806279182434,
        0.1961161345243454
      ],
      "plane_d": 4421.68212890625,
      "bbox_min": [
        -3720.0,
        -4981.95361328125,
        1052.5999755859375
      ],
      "bbox_max": [
        -3280.0,
        -4032.349609375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9805806279182434,
        -0.0,
        0.1961161345243454
      ],
      "plane_d": 3049.095458984375,
      "bbox_min": [
        -3720.0,
        -4981.95361328125,
        1052.5999755859375
      ],
      "bbox_max": [
        -3280.0,
        -4719.7685546875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9805806279182434,
        0.1961161196231842
      ],
      "plane_d": 4529.54541015625,
      "bbox_min": [
        -3720.0,
        -4879.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3549.999755859375,
        -4719.7685546875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.982647716999054,
        0.0,
        0.1854814738035202
      ],
      "plane_d": 3440.55859375,
      "bbox_min": [
        -3720.0,
        -4856.95947265625,
        1052.5999755859375
      ],
      "bbox_max": [
        -3699.999755859375,
        -4719.7685546875,
        1188.553955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9852399826049805,
        0.06568368524312973,
        0.158075749874115
      ],
      "plane_d": 3796.234375,
      "bbox_min": [
        -3720.0,
        -4856.95947265625,
        1052.5999755859375
      ],
      "bbox_max": [
        -3699.999755859375,
        -4784.76953125,
        1188.553955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9805806279182434,
        0.1961161196231842
      ],
      "plane_d": 4617.79833984375,
      "bbox_min": [
        -3369.999755859375,
        -4981.95361328125,
        1052.5999755859375
      ],
      "bbox_max": [
        -3280.0,
        -4850.7685546875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7123355865478516,
        0.6738817095756531,
        0.19611580669879913
      ],
      "plane_d": 5438.24755859375,
      "bbox_min": [
        -3291.52734375,
        -4981.95361328125,
        1168.73291015625
      ],
      "bbox_max": [
        -3280.0,
        -4942.9951171875,
        1302.5999755859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.01227299403399229,
        0.9982650876045227,
        0.05758681520819664
      ],
      "plane_d": 4736.61279296875,
      "bbox_min": [
        -3319.999755859375,
        -4855.59765625,
        1128.623779296875
      ],
      "bbox_max": [
        -3280.0,
        -4850.7685546875,
        1220.8592529296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9987815618515015,
        0.04934954270720482
      ],
      "plane_d": 4789.1611328125,
      "bbox_min": [
        -3319.999755859375,
        -4853.7041015625,
        1128.623779296875
      ],
      "bbox_max": [
        -3280.0,
        -4850.7685546875,
        1188.0367431640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6399935483932495,
        -0.7400472164154053,
        0.20673252642154694
      ],
      "plane_d": -1128.05810546875,
      "bbox_min": [
        -3720.0,
        -4740.96044921875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3280.0,
        -4032.349609375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.202193021774292,
        0.9521721005439758,
        0.22909876704216003
      ],
      "plane_d": 4294.4814453125,
      "bbox_min": [
        -3549.999755859375,
        -4192.001953125,
        1052.5999755859375
      ],
      "bbox_max": [
        -3348.9013671875,
        -4032.349609375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7012690901756287,
        0.7012708783149719,
        0.12822175025939941
      ],
      "plane_d": 5107.23486328125,
      "bbox_min": [
        -3442.946533203125,
        -4192.001953125,
        1052.5999755859375
      ],
      "bbox_max": [
        -3348.9013671875,
        -4032.349609375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9412570595741272,
        -0.14917725324630737,
        0.30295413732528687
      ],
      "plane_d": 2217.72314453125,
      "bbox_min": [
        -3430.738037109375,
        -4192.001953125,
        1052.5999755859375
      ],
      "bbox_max": [
        -3348.9013671875,
        -4096.39453125,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 5385.869140625,
      "bbox_min": [
        -3430.738037109375,
        -4192.001953125,
        1052.5999755859375
      ],
      "bbox_max": [
        -3424.76611328125,
        -4186.0302734375,
        1092.4654541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6449734568595886,
        -0.7364493012428284,
        0.20408721268177032
      ],
      "plane_d": -1092.6890869140625,
      "bbox_min": [
        -3720.0,
        -4740.96044921875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3280.0,
        -4126.103515625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.28423649072647095,
        -0.0,
        0.9587541818618774
      ],
      "plane_d": -85.68463134765625,
      "bbox_min": [
        -3720.0,
        -4740.96044921875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3280.0,
        -4186.0302734375,
        1158.5577392578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.982647716999054,
        0.0,
        0.1854814738035202
      ],
      "plane_d": 3440.55859375,
      "bbox_min": [
        -3720.0,
        -4740.96044921875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3280.0,
        -4186.0302734375,
        1158.5577392578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1373203992843628,
        0.9674778580665588,
        0.21243742108345032
      ],
      "plane_d": 4807.8193359375,
      "bbox_min": [
        -3720.0,
        -4695.8271484375,
        1052.5999755859375
      ],
      "bbox_max": [
        -3699.999755859375,
        -4672.56103515625,
        1158.5577392578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4239.7685546875,
      "bbox_min": [
        -3483.0,
        -4580.0,
        1052.5999755859375
      ],
      "bbox_max": [
        -3280.0,
        -4186.0302734375,
        1113.36572265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7175806760787964,
        -0.6964753270149231,
        0.0
      ],
      "plane_d": -714.20361328125,
      "bbox_min": [
        -3483.0,
        -4580.0,
        1052.5999755859375
      ],
      "bbox_max": [
        -3417.0,
        -4404.92822265625,
        1113.36572265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7175806760787964,
        0.6964753270149231,
        0.0
      ],
      "plane_d": 5525.79736328125,
      "bbox_min": [
        -3474.777587890625,
        -4413.39990234375,
        1052.5999755859375
      ],
      "bbox_max": [
        -3417.0,
        -4379.39990234375,
        1112.5543212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3349817395210266,
        0.32512935996055603,
        0.8843518495559692
      ],
      "plane_d": 1604.658203125,
      "bbox_min": [
        -3474.777587890625,
        -4413.39990234375,
        1102.3896484375
      ],
      "bbox_max": [
        -3417.0,
        -4379.39990234375,
        1112.5543212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3349817395210266,
        0.32512935996055603,
        0.8843518495559692
      ],
      "plane_d": -706.7158813476562,
      "bbox_min": [
        -3474.777587890625,
        -4408.373046875,
        1102.3896484375
      ],
      "bbox_max": [
        -3450.0,
        -4379.39990234375,
        1112.5543212890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 5385.869140625,
      "bbox_min": [
        -3430.738037109375,
        -4239.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3376.999755859375,
        -4186.0302734375,
        1106.4625244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.35422706604003906,
        -0.0,
        0.93515944480896
      ],
      "plane_d": 179.48388671875,
      "bbox_min": [
        -3454.023193359375,
        -4553.38916015625,
        1061.7740478515625
      ],
      "bbox_max": [
        -3280.0,
        -4186.0302734375,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3349817395210266,
        0.32512935996055603,
        0.8843518495559692
      ],
      "plane_d": 1604.658203125,
      "bbox_min": [
        -3454.023193359375,
        -4553.38916015625,
        1102.3896484375
      ],
      "bbox_max": [
        -3417.0,
        -4186.0302734375,
        1114.8896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3349817395210266,
        -0.32512933015823364,
        0.8843517899513245
      ],
      "plane_d": -1308.3056640625,
      "bbox_min": [
        -3454.023193359375,
        -4553.38916015625,
        1102.3896484375
      ],
      "bbox_max": [
        -3417.0,
        -4406.0107421875,
        1114.8896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3349817395210266,
        0.32512935996055603,
        0.8843518495559692
      ],
      "plane_d": -706.7158813476562,
      "bbox_min": [
        -3454.023193359375,
        -4413.39990234375,
        1112.1729736328125
      ],
      "bbox_max": [
        -3450.0,
        -4406.0107421875,
        1114.8896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 4239.7685546875,
      "bbox_min": [
        -3430.738037109375,
        -4239.7685546875,
        1061.7740478515625
      ],
      "bbox_max": [
        -3280.0,
        -4186.0302734375,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 5385.869140625,
      "bbox_min": [
        -3430.738037109375,
        -4239.7685546875,
        1090.5311279296875
      ],
      "bbox_max": [
        -3376.999755859375,
        -4186.0302734375,
        1121.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1052.5999755859375,
      "bbox_min": [
        -3835.11669921875,
        -4970.0,
        1052.5999755859375
      ],
      "bbox_max": [
        -3720.0,
        -3960.0,
        1302.5999755859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.980492353439331,
        -0.0,
        0.19655711948871613
      ],
      "plane_d": 3504.267333984375,
      "bbox_min": [
        -3835.11669921875,
        -4879.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3720.0,
        -4069.7685546875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9428800940513611,
        0.2659531235694885,
        0.20061436295509338
      ],
      "plane_d": 4566.60009765625,
      "bbox_min": [
        -3835.11669921875,
        -4879.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3720.0,
        -4069.7685546875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9413501620292664,
        0.2744533121585846,
        0.19630339741706848
      ],
      "plane_d": 4605.08056640625,
      "bbox_min": [
        -3835.11669921875,
        -4668.23779296875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3750.459716796875,
        -4549.7685546875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.770168125629425,
        -0.6076056361198425,
        0.19405239820480347
      ],
      "plane_d": 56.47296142578125,
      "bbox_min": [
        -3835.11669921875,
        -4879.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3720.0,
        -4069.7685546875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9805806279182434,
        -0.0,
        0.1961161345243454
      ],
      "plane_d": 3421.71630859375,
      "bbox_min": [
        -3749.999755859375,
        -4254.21875,
        1152.6011962890625
      ],
      "bbox_max": [
        -3720.0,
        -4069.7685546875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7741605639457703,
        -0.6014260649681091,
        0.19738803803920746
      ],
      "plane_d": 94.33433532714844,
      "bbox_min": [
        -3835.11669921875,
        -4879.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3720.0,
        -4244.33984375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.13673339784145355,
        0.9675556421279907,
        0.21246233582496643
      ],
      "plane_d": 4805.955078125,
      "bbox_min": [
        -3789.732666015625,
        -4879.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3720.0,
        -4244.33984375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1373203992843628,
        0.9674778580665588,
        0.21243742108345032
      ],
      "plane_d": 4807.8193359375,
      "bbox_min": [
        -3750.459716796875,
        -4879.7685546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -3720.0,
        -4668.23779296875,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9852399826049805,
        0.06568368524312973,
        0.158075749874115
      ],
      "plane_d": 3796.234375,
      "bbox_min": [
        -3747.18896484375,
        -4879.7685546875,
        1158.5577392578125
      ],
      "bbox_max": [
        -3720.0,
        -4695.8271484375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.982647716999054,
        0.0,
        0.1854814738035202
      ],
      "plane_d": 3440.55859375,
      "bbox_min": [
        -3747.18896484375,
        -4879.7685546875,
        1158.5577392578125
      ],
      "bbox_max": [
        -3720.0,
        -4695.8271484375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9805806279182434,
        0.1961161196231842
      ],
      "plane_d": 4529.54541015625,
      "bbox_min": [
        -3736.77734375,
        -4879.7685546875,
        1188.553955078125
      ],
      "bbox_max": [
        -3720.0,
        -4856.95947265625,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9805806279182434,
        -0.0,
        0.1961161345243454
      ],
      "plane_d": 3421.71630859375,
      "bbox_min": [
        -3749.999755859375,
        -4271.61572265625,
        1152.6011962890625
      ],
      "bbox_max": [
        -3720.0,
        -4244.33984375,
        1302.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7578271627426147,
        0.6524553894996643
      ],
      "plane_d": 2916.337158203125,
      "bbox_min": [
        -3280.0,
        -5265.7685546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -2460.0,
        -2979.77587890625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7578271627426147,
        0.6524554491043091
      ],
      "plane_d": 2989.088623046875,
      "bbox_min": [
        -3280.0,
        -5265.7685546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -2824.65869140625,
        -4969.7685546875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46659424901008606,
        0.5960854887962341,
        0.6534307599067688
      ],
      "plane_d": 760.7036743164062,
      "bbox_min": [
        -3280.0,
        -5265.7685546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -2824.65869140625,
        -4969.7685546875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.47042611241340637,
        0.5917193293571472,
        0.6546507477760315
      ],
      "plane_d": 725.4353637695312,
      "bbox_min": [
        -3280.0,
        -5265.7685546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -2824.65869140625,
        -4969.7685546875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5524737238883972,
        0.5226529240608215,
        0.6493124961853027
      ],
      "plane_d": 144.815185546875,
      "bbox_min": [
        -3280.0,
        -5265.7685546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -2824.65869140625,
        -4969.7685546875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4606236219406128,
        0.5994809865951538,
        0.6545597910881042
      ],
      "plane_d": 3650.314208984375,
      "bbox_min": [
        -3280.0,
        -5265.7685546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -3182.88427734375,
        -4981.95361328125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.46899479627609253,
        0.5899190306663513,
        0.6572970747947693
      ],
      "plane_d": 3624.95458984375,
      "bbox_min": [
        -3280.0,
        -5117.62890625,
        1302.5999755859375
      ],
      "bbox_max": [
        -3182.88427734375,
        -4981.95361328125,
        1418.4383544921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5505159497261047,
        0.5208008289337158,
        0.6524559259414673
      ],
      "plane_d": 3550.40869140625,
      "bbox_min": [
        -3280.0,
        -5041.67822265625,
        1302.5999755859375
      ],
      "bbox_max": [
        -3254.78857421875,
        -4981.95361328125,
        1350.2730712890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.009789052419364452,
        -0.60419100522995,
        0.7967793345451355
      ],
      "plane_d": -3048.53662109375,
      "bbox_min": [
        -3260.67529296875,
        -4907.5830078125,
        1302.5999755859375
      ],
      "bbox_max": [
        -2460.0,
        -2979.77587890625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3154846429824829,
        -0.6847353577613831,
        0.6569679379463196
      ],
      "plane_d": -2236.382080078125,
      "bbox_min": [
        -3260.67529296875,
        -4907.5830078125,
        1302.5999755859375
      ],
      "bbox_max": [
        -2460.0,
        -2979.77587890625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.14996828138828278,
        -0.7595442533493042,
        0.6329313516616821
      ],
      "plane_d": -2905.852783203125,
      "bbox_min": [
        -3161.864501953125,
        -3437.66064453125,
        1302.5999755859375
      ],
      "bbox_max": [
        -2749.9501953125,
        -3111.68505859375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45930567383766174,
        -0.7651201486587524,
        0.45125314593315125
      ],
      "plane_d": -1759.25537109375,
      "bbox_min": [
        -3161.864501953125,
        -3437.66064453125,
        1302.5999755859375
      ],
      "bbox_max": [
        -2861.24462890625,
        -3111.68505859375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19022035598754883,
        -0.8575993776321411,
        0.4778488874435425
      ],
      "plane_d": -2909.8359375,
      "bbox_min": [
        -3161.864501953125,
        -3384.146240234375,
        1302.5999755859375
      ],
      "bbox_max": [
        -3001.666748046875,
        -3237.51708984375,
        1487.3131103515625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8624072670936584,
        -0.13326707482337952,
        0.48835813999176025
      ],
      "plane_d": 1580.2606201171875,
      "bbox_min": [
        -3161.864501953125,
        -3384.146240234375,
        1302.5999755859375
      ],
      "bbox_max": [
        -3086.888427734375,
        -3346.458740234375,
        1434.564697265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7868428826332092,
        0.027674341574311256,
        0.616532564163208
      ],
      "plane_d": 1719.455078125,
      "bbox_min": [
        -3106.85986328125,
        -3384.146240234375,
        1302.5999755859375
      ],
      "bbox_max": [
        -3086.888427734375,
        -3352.1396484375,
        1327.955322265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8624072670936584,
        -0.13326707482337952,
        0.48835813999176025
      ],
      "plane_d": 1580.2606201171875,
      "bbox_min": [
        -3156.801025390625,
        -3437.66064453125,
        1302.5999755859375
      ],
      "bbox_max": [
        -3085.00634765625,
        -3354.920166015625,
        1423.3140869140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7868428826332092,
        0.027674341574311256,
        0.616532564163208
      ],
      "plane_d": 1719.455078125,
      "bbox_min": [
        -3124.666259765625,
        -3437.66064453125,
        1302.5999755859375
      ],
      "bbox_max": [
        -3085.00634765625,
        -3381.18115234375,
        1351.9122314453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7917473912239075,
        -0.03682546317577362,
        0.6097375154495239
      ],
      "plane_d": 1512.502685546875,
      "bbox_min": [
        -3260.67529296875,
        -4907.5830078125,
        1302.5999755859375
      ],
      "bbox_max": [
        -2460.0,
        -3111.68505859375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7868428826332092,
        0.027674341574311256,
        0.616532564163208
      ],
      "plane_d": 1719.455078125,
      "bbox_min": [
        -3260.67529296875,
        -4906.7431640625,
        1302.5999755859375
      ],
      "bbox_max": [
        -3080.0,
        -3369.941650390625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.004279972054064274,
        0.9998396635055542,
        0.01739072985947132
      ],
      "plane_d": 4850.89501953125,
      "bbox_min": [
        -3244.551513671875,
        -4906.7431640625,
        1302.5999755859375
      ],
      "bbox_max": [
        -3151.91455078125,
        -4859.45361328125,
        1344.58447265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4297522008419037,
        0.0,
        -0.902946949005127
      ],
      "plane_d": 2545.216064453125,
      "bbox_min": [
        -3185.643798828125,
        -4906.7431640625,
        1302.5999755859375
      ],
      "bbox_max": [
        -3151.940185546875,
        -4860.693359375,
        1318.640869140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.003976684529334307,
        0.9978758096694946,
        0.06502450257539749
      ],
      "plane_d": 4751.76220703125,
      "bbox_min": [
        -3244.551513671875,
        -4861.31201171875,
        1302.5999755859375
      ],
      "bbox_max": [
        -3151.91455078125,
        -4859.45361328125,
        1332.522705078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4297522008419037,
        0.0,
        -0.902946949005127
      ],
      "plane_d": 2545.216064453125,
      "bbox_min": [
        -3244.551513671875,
        -4861.1162109375,
        1302.5999755859375
      ],
      "bbox_max": [
        -3151.91455078125,
        -4859.45361328125,
        1319.626708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01227299403399229,
        0.9982650876045227,
        0.05758681520819664
      ],
      "plane_d": 4736.61279296875,
      "bbox_min": [
        -3244.551513671875,
        -4860.7685546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -3221.847900390625,
        -4859.59814453125,
        1319.626708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8624072670936584,
        -0.13326707482337952,
        0.48835813999176025
      ],
      "plane_d": 1580.2606201171875,
      "bbox_min": [
        -3260.67529296875,
        -3618.21142578125,
        1351.9122314453125
      ],
      "bbox_max": [
        -3124.666259765625,
        -3369.941650390625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8624072670936584,
        -0.13326707482337952,
        0.48835813999176025
      ],
      "plane_d": 1580.2606201171875,
      "bbox_min": [
        -3260.67529296875,
        -4907.5830078125,
        1302.5999755859375
      ],
      "bbox_max": [
        -2460.0,
        -3111.68505859375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5322588086128235,
        -0.7790220975875854,
        0.3313983976840973
      ],
      "plane_d": -1399.44775390625,
      "bbox_min": [
        -3218.01416015625,
        -4907.5830078125,
        1302.5999755859375
      ],
      "bbox_max": [
        -2460.0,
        -3111.68505859375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.45930567383766174,
        -0.7651201486587524,
        0.45125314593315125
      ],
      "plane_d": -1759.25537109375,
      "bbox_min": [
        -3171.936767578125,
        -4907.5830078125,
        1302.5999755859375
      ],
      "bbox_max": [
        -2460.0,
        -3111.68505859375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.19022035598754883,
        -0.8575993776321411,
        0.4778488874435425
      ],
      "plane_d": -2909.8359375,
      "bbox_min": [
        -3035.258056640625,
        -3239.552001953125,
        1476.240234375
      ],
      "bbox_max": [
        -3016.616455078125,
        -3207.9873046875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3573431670665741,
        -0.0,
        0.9339731931686401
      ],
      "plane_d": -173.7481689453125,
      "bbox_min": [
        -3171.936767578125,
        -4907.5830078125,
        1302.5999755859375
      ],
      "bbox_max": [
        -2460.0,
        -3271.27490234375,
        1372.10791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.004279956221580505,
        0.9998396635055542,
        0.01739072985947132
      ],
      "plane_d": 4824.359375,
      "bbox_min": [
        -3171.936767578125,
        -4907.5830078125,
        1302.5999755859375
      ],
      "bbox_max": [
        -2954.386962890625,
        -4859.45361328125,
        1372.10791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4297522008419037,
        0.0,
        -0.902946949005127
      ],
      "plane_d": 2545.216064453125,
      "bbox_min": [
        -3153.473388671875,
        -4907.5830078125,
        1302.5999755859375
      ],
      "bbox_max": [
        -2954.386962890625,
        -4860.4365234375,
        1343.361572265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8958584666252136,
        -0.0,
        0.44433948397636414
      ],
      "plane_d": 2067.916015625,
      "bbox_min": [
        -2962.83203125,
        -4907.5830078125,
        1302.5999755859375
      ],
      "bbox_max": [
        -2954.386962890625,
        -4860.4365234375,
        1319.626708984375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.003976674750447273,
        0.9978757500648499,
        0.06502451002597809
      ],
      "plane_d": 4776.4169921875,
      "bbox_min": [
        -3171.936767578125,
        -4862.2685546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -2954.386962890625,
        -4859.45361328125,
        1372.10791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.004279972054064274,
        0.9998396635055542,
        0.01739072985947132
      ],
      "plane_d": 4850.89501953125,
      "bbox_min": [
        -3170.65673828125,
        -4861.7685546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -2954.386962890625,
        -4859.59814453125,
        1343.361572265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4297522008419037,
        0.0,
        -0.902946949005127
      ],
      "plane_d": 2545.216064453125,
      "bbox_min": [
        -3151.955322265625,
        -4861.7685546875,
        1318.6336669921875
      ],
      "bbox_max": [
        -3100.0,
        -4861.1162109375,
        1343.361572265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.003976684529334307,
        0.9978758096694946,
        0.06502450257539749
      ],
      "plane_d": 4751.76220703125,
      "bbox_min": [
        -3162.6396484375,
        -4861.7685546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -2954.386962890625,
        -4859.59814453125,
        1343.361572265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4297522008419037,
        0.0,
        -0.902946949005127
      ],
      "plane_d": 2545.216064453125,
      "bbox_min": [
        -3151.940185546875,
        -4861.7685546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -2954.386962890625,
        -4859.59814453125,
        1343.361572265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.006341905798763037,
        0.997999370098114,
        0.06290493160486221
      ],
      "plane_d": 4786.82275390625,
      "bbox_min": [
        -2978.151611328125,
        -4860.7685546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -2954.386962890625,
        -4859.59814453125,
        1319.626708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8958584070205688,
        0.0,
        0.44433945417404175
      ],
      "plane_d": 2067.916015625,
      "bbox_min": [
        -2962.83203125,
        -4860.7685546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -2954.386962890625,
        -4859.7490234375,
        1319.626708984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.004279972054064274,
        0.9998396635055542,
        0.01739072985947132
      ],
      "plane_d": 4850.89501953125,
      "bbox_min": [
        -3171.936767578125,
        -4862.2685546875,
        1342.9239501953125
      ],
      "bbox_max": [
        -3100.0,
        -4861.45849609375,
        1372.10791015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26112592220306396,
        -0.6418163180351257,
        0.721030592918396
      ],
      "plane_d": -3705.04443359375,
      "bbox_min": [
        -2512.55908203125,
        -3308.51708984375,
        1302.5999755859375
      ],
      "bbox_max": [
        -2460.0,
        -3271.27490234375,
        1335.750732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7578271627426147,
        0.6524553894996643
      ],
      "plane_d": 2916.337158203125,
      "bbox_min": [
        -2460.0,
        -5169.7685546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -1760.0,
        -3059.423095703125,
        1574.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26112592220306396,
        -0.6418163180351257,
        0.721030592918396
      ],
      "plane_d": -3705.04443359375,
      "bbox_min": [
        -2460.0,
        -3663.7890625,
        1302.5999755859375
      ],
      "bbox_max": [
        -1760.0,
        -3059.423095703125,
        1574.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2753306031227112,
        -0.8354538679122925,
        0.4756152629852295
      ],
      "plane_d": -2793.050048828125,
      "bbox_min": [
        -2319.057373046875,
        -3567.609619140625,
        1302.5999755859375
      ],
      "bbox_max": [
        -1760.0,
        -3059.423095703125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22970595955848694,
        -0.8470718264579773,
        0.4792749881744385
      ],
      "plane_d": -2933.39697265625,
      "bbox_min": [
        -2144.25732421875,
        -3567.609619140625,
        1302.5999755859375
      ],
      "bbox_max": [
        -1760.0,
        -3059.423095703125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.26883310079574585,
        -0.8187206983566284,
        0.5073708295822144
      ],
      "plane_d": -2802.57958984375,
      "bbox_min": [
        -2144.25732421875,
        -3248.052978515625,
        1302.5999755859375
      ],
      "bbox_max": [
        -1760.0,
        -3059.423095703125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.23221024870872498,
        -0.8293224573135376,
        0.5082348585128784
      ],
      "plane_d": -2908.64794921875,
      "bbox_min": [
        -1958.299072265625,
        -3248.052978515625,
        1302.5999755859375
      ],
      "bbox_max": [
        -1760.0,
        -3059.423095703125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22038745880126953,
        -0.8264544606208801,
        0.5180755853652954
      ],
      "plane_d": -2934.9130859375,
      "bbox_min": [
        -1925.2470703125,
        -3248.052978515625,
        1302.5999755859375
      ],
      "bbox_max": [
        -1760.0,
        -3105.5673828125,
        1459.6031494140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.22038745880126953,
        -0.8264544606208801,
        0.5180755853652954
      ],
      "plane_d": -2934.9130859375,
      "bbox_min": [
        -1925.2470703125,
        -3567.609619140625,
        1302.5999755859375
      ],
      "bbox_max": [
        -1760.0,
        -3196.33544921875,
        1364.2069091796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7289522290229797,
        0.6049720644950867,
        0.3203705847263336
      ],
      "plane_d": 411.9771423339844,
      "bbox_min": [
        -1823.181640625,
        -3567.609619140625,
        1302.5999755859375
      ],
      "bbox_max": [
        -1760.0,
        -3491.47998046875,
        1364.2069091796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7031068801879883,
        0.6397297978401184,
        0.31046193838119507
      ],
      "plane_d": 596.2442626953125,
      "bbox_min": [
        -1826.687255859375,
        -3663.7890625,
        1302.5999755859375
      ],
      "bbox_max": [
        -1760.0,
        -3524.104736328125,
        1574.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7432345151901245,
        0.5606855154037476,
        0.36501291394233704
      ],
      "plane_d": 169.5526123046875,
      "bbox_min": [
        -1826.687255859375,
        -3571.833740234375,
        1302.5999755859375
      ],
      "bbox_max": [
        -1760.0,
        -3524.104736328125,
        1393.7564697265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5327659845352173,
        -0.5439295768737793,
        0.6483063697814941
      ],
      "plane_d": -1163.5986328125,
      "bbox_min": [
        -3720.0,
        -5244.791015625,
        1302.5999755859375
      ],
      "bbox_max": [
        -3280.0,
        -3619.7685546875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5355481505393982,
        -0.5337325930595398,
        0.6544598937034607
      ],
      "plane_d": -1123.4718017578125,
      "bbox_min": [
        -3720.0,
        -5244.791015625,
        1302.5999755859375
      ],
      "bbox_max": [
        -3280.0,
        -3820.448974609375,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3389105796813965,
        0.677821159362793,
        0.6524554491043091
      ],
      "plane_d": 3660.854248046875,
      "bbox_min": [
        -3720.0,
        -5244.791015625,
        1302.5999755859375
      ],
      "bbox_max": [
        -3280.0,
        -4879.7685546875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.75782710313797,
        0.6524553894996643
      ],
      "plane_d": 2848.13232421875,
      "bbox_min": [
        -3720.0,
        -5244.791015625,
        1302.5999755859375
      ],
      "bbox_max": [
        -3280.0,
        -4879.7685546875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4606236219406128,
        0.5994809865951538,
        0.6545597910881042
      ],
      "plane_d": 3650.314208984375,
      "bbox_min": [
        -3303.90771484375,
        -5244.791015625,
        1485.2779541015625
      ],
      "bbox_max": [
        -3280.0,
        -5190.60986328125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5505159497261047,
        0.5208008289337158,
        0.6524559259414673
      ],
      "plane_d": 3550.40869140625,
      "bbox_min": [
        -3377.63818359375,
        -5226.4208984375,
        1302.5999755859375
      ],
      "bbox_max": [
        -3280.0,
        -4969.7685546875,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.46899479627609253,
        0.5899190306663513,
        0.6572970747947693
      ],
      "plane_d": 3624.95458984375,
      "bbox_min": [
        -3377.63818359375,
        -5226.4208984375,
        1350.2730712890625
      ],
      "bbox_max": [
        -3280.0,
        -5041.67822265625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4606236219406128,
        0.5994809865951538,
        0.6545597910881042
      ],
      "plane_d": 3650.314208984375,
      "bbox_min": [
        -3377.63818359375,
        -5226.4208984375,
        1418.4383544921875
      ],
      "bbox_max": [
        -3280.0,
        -5117.62890625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7293676733970642,
        0.20572879910469055,
        0.6524556875228882
      ],
      "plane_d": 2884.762939453125,
      "bbox_min": [
        -4035.11669921875,
        -4839.2734375,
        1302.5999755859375
      ],
      "bbox_max": [
        -3749.99951171875,
        -4183.41845703125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5877209901809692,
        -0.4636683166027069,
        0.6630200743675232
      ],
      "plane_d": -627.662353515625,
      "bbox_min": [
        -4035.11669921875,
        -4839.2734375,
        1302.5999755859375
      ],
      "bbox_max": [
        -3749.99951171875,
        -4183.41845703125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7203983068466187,
        0.23521989583969116,
        0.6524553298950195
      ],
      "plane_d": 2989.8984375,
      "bbox_min": [
        -4035.11669921875,
        -4839.2734375,
        1302.5999755859375
      ],
      "bbox_max": [
        -3749.99951171875,
        -4183.41845703125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6123817563056946,
        -0.43806323409080505,
        0.6580951809883118
      ],
      "plane_d": -415.2310791015625,
      "bbox_min": [
        -4035.11669921875,
        -4352.2294921875,
        1302.5999755859375
      ],
      "bbox_max": [
        -3835.11669921875,
        -4183.41845703125,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7203983068466187,
        0.23521989583969116,
        0.6524553298950195
      ],
      "plane_d": 2989.8984375,
      "bbox_min": [
        -3963.99951171875,
        -5079.7685546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -3720.0,
        -4828.22119140625,
        1534.9000244140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.75782710313797,
        0.6524553894996643
      ],
      "plane_d": 2848.13232421875,
      "bbox_min": [
        -3881.86572265625,
        -5079.7685546875,
        1302.5999755859375
      ],
      "bbox_max": [
        -3720.0,
        -4879.7685546875,
        1534.9000244140625
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CGameArea piece: mt02f",
      "entity_class": "CGameArea",
      "piece_name": "mt02f",
      "offset": 54,
      "centroid": [
        -1624.9752197265625,
        -3404.5833333333335,
        1018.0792154947917
      ],
      "bbox_min": [
        -2218.0556640625,
        -3730.0,
        892.0
      ],
      "bbox_max": [
        -1107.0670166015625,
        -2885.0,
        1495.0
      ],
      "dimensions_source": {
        "span_x": 1110.9886474609375,
        "span_y": 845.0,
        "height_z": 603.0,
        "door_width": 1110.9886474609375,
        "door_depth": 845.0,
        "leaf_depth": 845.0,
        "clearance_margin": 0.0,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          1.0,
          -0.0
        ]
      },
      "vertices": [
        [
          -1590.0999755859375,
          -3532.0,
          1490.0
        ],
        [
          -1585.5999755859375,
          -3532.0,
          1490.0
        ],
        [
          -1585.5999755859375,
          -3532.0,
          1495.0
        ],
        [
          -1590.0999755859375,
          -3532.0,
          1495.0
        ],
        [
          -1606.0,
          -3426.5,
          892.0
        ],
        [
          -1606.0,
          -3411.5,
          892.0
        ],
        [
          -1606.0,
          -3411.5,
          915.0
        ],
        [
          -1606.0,
          -3426.5,
          915.0
        ],
        [
          -1475.0,
          -3730.0,
          904.5354614257812
        ],
        [
          -2218.0556640625,
          -3730.0,
          1089.800048828125
        ],
        [
          -1624.5,
          -3441.5,
          941.8099975585938
        ],
        [
          -1624.5,
          -3441.5,
          941.8099975585938
        ],
        [
          -1610.0,
          -3441.5,
          938.1947631835938
        ],
        [
          -1475.0,
          -3730.0,
          904.5354614257812
        ],
        [
          -2218.0556640625,
          -3730.0,
          1089.800048828125
        ],
        [
          -2218.0556640625,
          -2885.0,
          1089.800048828125
        ],
        [
          -1624.5,
          -3426.5,
          941.8099975585938
        ],
        [
          -1624.5,
          -3441.5,
          941.8099975585938
        ],
        [
          -2218.0556640625,
          -2885.0,
          1089.800048828125
        ],
        [
          -1475.0,
          -2885.0,
          904.5354614257812
        ],
        [
          -1610.0,
          -3426.5,
          938.1947631835938
        ],
        [
          -1624.5,
          -3426.5,
          941.8099975585938
        ],
        [
          -1475.0,
          -2885.0,
          904.5354614257812
        ],
        [
          -1475.0,
          -3730.0,
          904.5354614257812
        ],
        [
          -1610.0,
          -3441.5,
          938.1947631835938
        ],
        [
          -1610.0,
          -3426.5,
          938.1947631835938
        ],
        [
          -1107.0670166015625,
          -2885.0,
          902.7994995117188
        ],
        [
          -1107.0670166015625,
          -3730.0,
          902.7994995117188
        ],
        [
          -1475.0,
          -3730.0,
          904.5354614257812
        ],
        [
          -1475.0,
          -2885.0,
          904.5354614257812
        ]
      ],
      "plane_distance": 3532.0
    },
    {
      "tag": "CBreakableObject piece: ",
      "entity_class": "CBreakableObject",
      "piece_name": "",
      "offset": 7803,
      "centroid": [
        -1588.0,
        -3521.9005485983457,
        1486.3389389935662
      ],
      "bbox_min": [
        -1590.5,
        -3522.3623046875,
        1483.0
      ],
      "bbox_max": [
        -1585.699951171875,
        -3521.5,
        1489.199951171875
      ],
      "dimensions_source": {
        "span_x": 4.800048828125,
        "span_y": 0.8623046875,
        "height_z": 6.199951171875,
        "door_width": 4.800048828125,
        "door_depth": 0.8623046875,
        "leaf_depth": 0.8623046875,
        "clearance_margin": 0.0,
        "slide_axis": "x"
      },
      "vertices": [
        [
          -1586.2779541015625,
          -3521.842529296875,
          1488.2188720703125
        ],
        [
          -1585.9000244140625,
          -3522.094970703125,
          1487.4000244140625
        ],
        [
          -1585.699951171875,
          -3522.228759765625,
          1486.199951171875
        ],
        [
          -1585.9000244140625,
          -3522.094970703125,
          1484.5
        ],
        [
          -1586.2779541015625,
          -3521.842529296875,
          1483.9803466796875
        ],
        [
          -1588.0,
          -3521.5,
          1489.1285400390625
        ],
        [
          -1587.5999755859375,
          -3521.57958984375,
          1489.0999755859375
        ],
        [
          -1586.5,
          -3521.79833984375,
          1488.699951171875
        ],
        [
          -1586.699951171875,
          -3521.758544921875,
          1483.4000244140625
        ],
        [
          -1588.0,
          -3521.5,
          1483.0
        ],
        [
          -1589.0,
          -3521.698974609375,
          1489.199951171875
        ],
        [
          -1589.5,
          -3521.79833984375,
          1483.300048828125
        ],
        [
          -1589.7220458984375,
          -3521.842529296875,
          1483.6453857421875
        ],
        [
          -1589.7220458984375,
          -3521.842529296875,
          1488.5889892578125
        ],
        [
          -1590.4000244140625,
          -3522.295654296875,
          1484.699951171875
        ],
        [
          -1590.5,
          -3522.3623046875,
          1486.5999755859375
        ],
        [
          -1590.300048828125,
          -3522.228759765625,
          1488.0999755859375
        ]
      ],
      "authentic_texture": "chkcopperpipe1grn"
    },
    {
      "tag": "CBreakableObject piece: ",
      "entity_class": "CBreakableObject",
      "piece_name": "",
      "offset": 9069,
      "centroid": [
        -1606.25,
        -3509.25,
        1485.25
      ],
      "bbox_min": [
        -1609.0,
        -3512.0,
        1482.5
      ],
      "bbox_max": [
        -1603.5,
        -3506.5,
        1488.0
      ],
      "dimensions_source": {
        "span_x": 5.5,
        "span_y": 5.5,
        "height_z": 5.5,
        "door_width": 5.5,
        "door_depth": 5.5,
        "leaf_depth": 5.5,
        "clearance_margin": 0.0,
        "slide_axis": "x",
        "slide_vector": [
          -1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -1609.0,
          -3512.0,
          1482.5
        ],
        [
          -1609.0,
          -3506.5,
          1488.0
        ],
        [
          -1609.0,
          -3512.0,
          1488.0
        ],
        [
          -1609.0,
          -3506.5,
          1482.5
        ],
        [
          -1603.5,
          -3512.0,
          1482.5
        ],
        [
          -1603.5,
          -3506.5,
          1488.0
        ],
        [
          -1603.5,
          -3512.0,
          1488.0
        ],
        [
          -1603.5,
          -3506.5,
          1482.5
        ]
      ],
      "plane_distance": -1609.0
    },
    {
      "tag": "CBreakableObject piece: ",
      "entity_class": "CBreakableObject",
      "piece_name": "",
      "offset": 10136,
      "centroid": [
        -1606.25,
        -3502.25,
        1485.25
      ],
      "bbox_min": [
        -1609.0,
        -3505.0,
        1482.5
      ],
      "bbox_max": [
        -1603.5,
        -3499.5,
        1488.0
      ],
      "dimensions_source": {
        "span_x": 5.5,
        "span_y": 5.5,
        "height_z": 5.5,
        "door_width": 5.5,
        "door_depth": 5.5,
        "leaf_depth": 5.5,
        "clearance_margin": 0.0,
        "slide_axis": "x",
        "slide_vector": [
          -1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -1609.0,
          -3505.0,
          1482.5
        ],
        [
          -1609.0,
          -3499.5,
          1488.0
        ],
        [
          -1609.0,
          -3505.0,
          1488.0
        ],
        [
          -1609.0,
          -3499.5,
          1482.5
        ],
        [
          -1603.5,
          -3505.0,
          1482.5
        ],
        [
          -1603.5,
          -3499.5,
          1488.0
        ],
        [
          -1603.5,
          -3505.0,
          1488.0
        ],
        [
          -1603.5,
          -3499.5,
          1482.5
        ]
      ],
      "plane_distance": -1609.0
    }
  ],
  "tutorial_messages": []
}